/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A Coursera language code used for translation.
   * Examples: "en", "es", "fr", "pt-BR", "zh-CN", "zh-TW".
   *
   * Must be a valid code from CourseraLanguageCode:
   * https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  ContentfulTranslation_CourseraLanguageCode: any;
  /** An RFC-3339 compliant Full Date Scalar */
  Date: string;
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: string;
  /**
   * A string representing a duration conforming to the
   * [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601#Durations) PnDTnHnMn.nS, with days
   * considered to be exactly 24 hours. eg: P1DT13H23M34.5S
   * P is the duration designator (for period) placed at the start of the duration representation.
   * D is the day designator that follows the value for the number of days.
   * T is the time designator that precedes the time components of the representation.
   * H is the hour designator that follows the value for the number of hours.
   * M is the minute designator that follows the value for the number of minutes.
   * S is the second designator that follows the value for the number of seconds.
   * Milliseconds may be represented using decimals, eg. PT0.5S for 500ms.
   *
   * Note: year, month, and week designators are not supported.
   */
  Duration: string;
  /** A JSON scalar */
  JSON: any;
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: string;
  /** A IETF BCP 47 language tag */
  Locale: string;
  ObjMap: any;
  /** An RFC-3339 compliant Full Time Scalar */
  Time: string;
  /** A url scalar that accepts string values like https://www.w3.org/Addressing/URL/url-spec.txt */
  URL: string;
};

/** TODO: Complete this description */
export type AcademicDiscipline_QueryCustomizedSkillSetsInput = {
  /** TODO: Complete this description */
  orgId: Scalars['String'];
  /** TODO: Complete this description */
  templateSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_SetupAcademicDisciplineBasedProgramInput = {
  /** TODO: Complete this description */
  orgId: Scalars['String'];
  /** TODO: Complete this description */
  programId: Scalars['String'];
  /** TODO: Complete this description */
  selectedAcademicDisciplineId: Scalars['String'];
  /** TODO: Complete this description */
  selectedSubjectIds?: InputMaybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  selectedTargetSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  selectedTemplateSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum defining the possible actions for contract tag product operations */
export const AdHocProducts_ContractTagProductAction = {
  /** Product IDs are allowed for the contract tag (allowlist operation) */
  Allowed: 'ALLOWED',
  /** Product IDs are denied for the contract tag (denylist operation) */
  Denied: 'DENIED'
} as const;

export type AdHocProducts_ContractTagProductAction = typeof AdHocProducts_ContractTagProductAction[keyof typeof AdHocProducts_ContractTagProductAction];
/** Input for hard removing product IDs from a contract tag */
export type AdHocProducts_HardRemoveContractTagProductIdInput = {
  /** The contract tag name */
  contractTagName: Scalars['String'];
  /** List of product IDs to hard remove */
  productIds: Array<Scalars['ID']>;
};

/** Input for allowing or denying product IDs from a contract tag */
export type AdHocProducts_UpdateContractTagProductIdInput = {
  /** Action to perform: ALLOWED or DENIED */
  action: AdHocProducts_ContractTagProductAction;
  /** The contract tag name */
  contractTagName: Scalars['String'];
  /** List of product IDs to allow or deny */
  productIds: Array<Scalars['ID']>;
};

/** Input for adding back an original course item to a learning block */
export type AdaptiveLearning_AddCourseItemToLearningBlockInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Original course item ID to add back to the learning block */
  itemId: Scalars['ID'];
  /** Learning block ID */
  learningBlockId: Scalars['ID'];
};

/** Input for deleting a learner's adaptive learning plan for a course branch. */
export type AdaptiveLearning_DeleteLearningPlanInput = {
  /** Course Branch ID whose plan should be deleted. */
  courseBranchId: Scalars['ID'];
  /** Coursera userId of the learner whose plan should be deleted. */
  userId: Scalars['ID'];
};

/**
 * The calling user's completion state for a single item, mirroring the source
 * CourseBranchItemCompletionStatus. AI-generated practice and summary items only
 * ever report NOT_STARTED or COMPLETED (they have no STARTED signal). One-pagers
 * are not returned by getMyLearningPlanItemProgress at all — they are overview
 * content with no completion concept. UNKNOWN is the default when no completion
 * record exists for the item.
 */
export const AdaptiveLearning_ItemCompletionStatus = {
  /** The user has completed the item. */
  Completed: 'COMPLETED',
  /** The user has a record for the item but has not completed it. */
  NotStarted: 'NOT_STARTED',
  /** The user has begun but not yet completed the item. */
  Started: 'STARTED',
  /** No completion record exists for this (user, item). */
  Unknown: 'UNKNOWN'
} as const;

export type AdaptiveLearning_ItemCompletionStatus = typeof AdaptiveLearning_ItemCompletionStatus[keyof typeof AdaptiveLearning_ItemCompletionStatus];
/** Onboard input */
export type AdaptiveLearning_OnboardInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Learning goal */
  goal: Scalars['String'];
  /** Learning pace */
  learningPace?: InputMaybe<Scalars['String']>;
  /** Session duration in minutes */
  sessionDurationMinutes?: InputMaybe<Scalars['Int']>;
};

/** A single answer to a pre-assessment question */
export type AdaptiveLearning_PreAssessmentAnswer = {
  /** Question ID */
  questionId: Scalars['ID'];
  /** Learner's selected skill level */
  selectedOption: AdaptiveLearning_SkillLevel;
};

/** A single pre-assessment answer at either skill or subSkill granularity. */
export type AdaptiveLearning_PreAssessmentAnswerV2 = {
  /** Whether `name` refers to a skill or a subSkill in the course's hierarchy. */
  level: AdaptiveLearning_SkillHierarchyLevel;
  /** Skill or subSkill name (interpreted per the level field). */
  name: Scalars['String'];
  /** Selected skill level. */
  selectedOption: AdaptiveLearning_SkillLevel;
};

/**
 * Proficiency level returned in pre-assessment responses. Mirrors
 * AdaptiveLearning_SkillLevel (NEW/SEEN/KNOWN) plus the MIXED marker that the
 * server uses for SKILL-level entries when the constituent assessed sub-skills
 * disagree. Distinct from AdaptiveLearning_SkillLevel because MIXED is not a
 * valid user-selectable answer (it is server-computed only).
 */
export const AdaptiveLearning_ProficiencyLevel = {
  /** Learner can do this independently */
  Known: 'KNOWN',
  /** Server-only: returned for SKILL entries when assessed sub-skills disagree. Never returned for SUBSKILL entries. */
  Mixed: 'MIXED',
  /** Learner hasn't done this before */
  New: 'NEW',
  /** Learner knows the basics but needs a refresh */
  Seen: 'SEEN'
} as const;

export type AdaptiveLearning_ProficiencyLevel = typeof AdaptiveLearning_ProficiencyLevel[keyof typeof AdaptiveLearning_ProficiencyLevel];
/** Input for reporting progress on a session plan item */
export type AdaptiveLearning_ReportItemProgressInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID that was completed */
  itemId: Scalars['ID'];
  /** Learning block ID */
  learningBlockId: Scalars['ID'];
};

/** Input for reporting a learner's attempt on a single AI-generated practice question */
export type AdaptiveLearning_ReportPracticeAttemptInput = {
  /** Stable UUID of the AI-generated practice (from AiGeneratedPractice.aiGeneratedPracticeId) */
  aiGeneratedPracticeId: Scalars['ID'];
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /**
   * Whether the learner answered correctly. Client-reported: for MCQ-style practices
   * the client compares the selected option to the known correct answer; for
   * flashcards the client passes the learner's self-grade.
   */
  isCorrect: Scalars['Boolean'];
  /** Type of the practice (disambiguates the practice alongside aiGeneratedPracticeId) */
  practiceType: LowStakesLearningTools_AiGeneratedPracticeType;
  /**
   * Optional free-form record of what the learner entered or selected. Not
   * interpreted by the server; kept for future analytics and debuggability.
   */
  userAnswer?: InputMaybe<Scalars['String']>;
};

/** Granularity at which a pre-assessment answer applies. */
export const AdaptiveLearning_SkillHierarchyLevel = {
  /** Answer fans out to all subSkills under the named skill. */
  Skill: 'SKILL',
  /** Answer applies to the named subSkill only. */
  Subskill: 'SUBSKILL'
} as const;

export type AdaptiveLearning_SkillHierarchyLevel = typeof AdaptiveLearning_SkillHierarchyLevel[keyof typeof AdaptiveLearning_SkillHierarchyLevel];
/** Learner's self-assessed skill level */
export const AdaptiveLearning_SkillLevel = {
  /** Learner can do this independently */
  Known: 'KNOWN',
  /** Learner hasn't done this before */
  New: 'NEW',
  /** Learner knows the basics but needs a refresh */
  Seen: 'SEEN'
} as const;

export type AdaptiveLearning_SkillLevel = typeof AdaptiveLearning_SkillLevel[keyof typeof AdaptiveLearning_SkillLevel];
/** Input for submitting pre-assessment answers */
export type AdaptiveLearning_SubmitPreAssessmentAnswersInput = {
  /** List of responses to pre-assessment questions */
  responses: Array<AdaptiveLearning_PreAssessmentAnswer>;
};

/** Input for submitting pre-assessment answers at either granularity. */
export type AdaptiveLearning_SubmitPreAssessmentAnswersV2Input = {
  /**
   * Skill- and subSkill-level answers, in any order. May be null or empty —
   * in which case no writes are performed and the mutation simply returns the
   * current proficiency snapshot.
   */
  answers?: InputMaybe<Array<AdaptiveLearning_PreAssessmentAnswerV2>>;
  /** Course Branch ID. */
  courseBranchId: Scalars['ID'];
};

/** The optimization status for the course */
export const AdminCourse_OptimizationStatus = {
  /** Completed optimization */
  CompletedOptimization: 'COMPLETED_OPTIMIZATION',
  /** Pending optimization */
  PendingOptimization: 'PENDING_OPTIMIZATION'
} as const;

export type AdminCourse_OptimizationStatus = typeof AdminCourse_OptimizationStatus[keyof typeof AdminCourse_OptimizationStatus];
/** The page type */
export const AdminCourse_PageType = {
  /** The Courses page */
  Course: 'COURSE',
  /** The Projects page */
  Project: 'PROJECT'
} as const;

export type AdminCourse_PageType = typeof AdminCourse_PageType[keyof typeof AdminCourse_PageType];
/** Input for querying courses by search query and filters. */
export type AdminCourse_QueryBySearchQueryAndFiltersInput = {
  /** The optional list of course ids */
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The optional instructor ids */
  instructorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The optional list of optimization status to filter by */
  optimizationStatuses?: InputMaybe<Array<AdminCourse_OptimizationStatus>>;
  /** The page type */
  pageType: AdminCourse_PageType;
  /** The partner id */
  partnerId: Scalars['ID'];
  /** The optional list of program slugs to filter courses by */
  programSlugs?: InputMaybe<Array<Scalars['String']>>;
  /** The optional search query string */
  searchQuery?: InputMaybe<Scalars['String']>;
  /** The optional list of session statuses to filter course contexts by */
  sessionStatuses?: InputMaybe<Array<AdminCourse_SessionStatus>>;
  /** The optional user id, the course filter permissions are applied for the user if present */
  userId?: InputMaybe<Scalars['ID']>;
};

/** The session status of the course contexts */
export const AdminCourse_SessionStatus = {
  /** All course sessions for the course context are over */
  Archived: 'ARCHIVED',
  /** There are currently active course sessions for the course context */
  Live: 'LIVE',
  /** No course sessions for the course context */
  New: 'NEW',
  /** There are upcoming course sessions for the course context */
  Upcoming: 'UPCOMING'
} as const;

export type AdminCourse_SessionStatus = typeof AdminCourse_SessionStatus[keyof typeof AdminCourse_SessionStatus];
/** Role enum. */
export const AdminPartnerMemberships_AdminPartnerMembershipRole = {
  /** Course assistant role */
  CourseAssistant: 'COURSE_ASSISTANT',
  /** Data coordinator role */
  DataCoordinator: 'DATA_COORDINATOR',
  /** Instructor role */
  Instructor: 'INSTRUCTOR',
  /** Partner admin role */
  PartnerAdmin: 'PARTNER_ADMIN',
  /** Teaching staff role */
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type AdminPartnerMemberships_AdminPartnerMembershipRole = typeof AdminPartnerMemberships_AdminPartnerMembershipRole[keyof typeof AdminPartnerMemberships_AdminPartnerMembershipRole];
/** Input type for AdminPartnerMemberships_QueryByUserInput */
export type AdminPartnerMemberships_QueryByUserInput = {
  /** Optional fetch instructors */
  fetchInstructors?: Scalars['Boolean'];
  /** Optional filter by partner ID */
  partnerId?: InputMaybe<Scalars['ID']>;
  /** Optional filter by role */
  role?: InputMaybe<Scalars['String']>;
  /** User id */
  userId: Scalars['ID'];
};

/** Input for deleting impersonation selections. */
export type AdminProgramImpersonations_DeleteInput = {
  /** The organization ID. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Input for setting impersonation selections. */
export type AdminProgramImpersonations_SetInput = {
  /** Program IDs to impersonate. All must belong to the specified organization. */
  programIds: Array<Scalars['ID']>;
  /** The organization ID. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Input type for AddSessionAssistantsByEmails */
export type AdminStaffMemberships_AddSessionAssistantsByEmailsInput = {
  /** list of emails to be added/invited to a session */
  emails: Array<Scalars['String']>;
  /** session id */
  sessionId: Scalars['ID'];
};

/** User IDs and session ID for role deletion. */
export type AdminStaffMemberships_DeleteSessionAssistantsInput = {
  /** Session ID */
  sessionId: Scalars['ID'];
  /** List of user IDs that should have their roles removed from the given session */
  userIds: Array<Scalars['ID']>;
};

/** ScopeType enum. */
export const AdminStaffMemberships_ScopeType = {
  /** Type name for course scope */
  Course: 'COURSE',
  /** Type name for degree scope */
  Degree: 'DEGREE',
  /** Type name for group scope */
  Group: 'GROUP',
  /** Type name for partner scope */
  Partner: 'PARTNER'
} as const;

export type AdminStaffMemberships_ScopeType = typeof AdminStaffMemberships_ScopeType[keyof typeof AdminStaffMemberships_ScopeType];
/** Session ID to look up the session assistants associated with. */
export type AdminStaffMemberships_SessionAssistantsBySessionIdInput = {
  /** Session Id to look up. */
  sessionId: Scalars['ID'];
};

/** Partner ID to look up associated staff. */
export type AdminStaffMemberships_StaffByPartnerInput = {
  /** Partner id to look up. */
  partnerId: Scalars['ID'];
};

/** Input for queryByUser */
export type AdminUserProfiles_QueryByUserInput = {
  /** User ID for profile */
  userId: Scalars['ID'];
};

/** Input for rolesByUser */
export type AdminUserRoles_RolesByUserInput = {
  /** Return only roles applying to content belonging to this partner */
  partnerId: Scalars['ID'];
  /** Text query searches role names and institution/program/course/group names */
  query?: InputMaybe<Scalars['String']>;
  /** Return only roles of this user */
  userId: Scalars['ID'];
};

/** Scope level for role */
export const AdminUserRoles_ScopeLevel = {
  /** Course scope level */
  Course: 'COURSE',
  /** Program (degree) scope level */
  Degree: 'DEGREE',
  /** Group (session) scope level */
  Group: 'GROUP',
  /** Institution (partner) scope level */
  Partner: 'PARTNER'
} as const;

export type AdminUserRoles_ScopeLevel = typeof AdminUserRoles_ScopeLevel[keyof typeof AdminUserRoles_ScopeLevel];
/** Ai assignments dispute status */
export const AiAssignmments_DisputeStatus = {
  /** Status indicating dispute was processed and there are grade updtes */
  Accepted: 'ACCEPTED',
  /** Status indicating failure to process the dispute */
  Failed: 'FAILED',
  /** Status once dispute is requested but no decision has been made */
  InProgress: 'IN_PROGRESS',
  /** Status indicating dispute was processed but there won't be grade changes */
  Rejected: 'REJECTED'
} as const;

export type AiAssignmments_DisputeStatus = typeof AiAssignmments_DisputeStatus[keyof typeof AiAssignmments_DisputeStatus];
/** Ai assignments dispute issue categories */
export const AiAssignmments_IssueCategory = {
  /** Category indicates that The AI's evaluation of the answer doesn’t seem to align with the content of the course. */
  Accuracy: 'ACCURACY',
  /** Category indicates that AI has misunderstood the assignment requirements or objectives. */
  AssignmentUnderstanding: 'ASSIGNMENT_UNDERSTANDING',
  /** Category indicates the submission had extra materials that were not properly considered by AI. */
  ExtraMaterial: 'EXTRA_MATERIAL',
  /** Category indicates that the feedback provided by the AI does not align with the given grade. */
  GradeFeedbackMisalignment: 'GRADE_FEEDBACK_MISALIGNMENT',
  /** Category indicates any other issues not covered by the other categories. */
  Other: 'OTHER',
  /** Category indicates that AI has misinterpreted the grading rubric or criteria. */
  RubricMisinterpretation: 'RUBRIC_MISINTERPRETATION'
} as const;

export type AiAssignmments_IssueCategory = typeof AiAssignmments_IssueCategory[keyof typeof AiAssignmments_IssueCategory];
/** Input representing user feedback about a particular LLM response */
export type AiAuthoring_SubmitWritingAssistantFeedbackInput = {
  /** Optional user comment about the response */
  comment?: InputMaybe<Scalars['String']>;
  /** The ID of the response */
  id: Scalars['ID'];
  /** User's sentiment about the response */
  sentiment: AiAuthoring_WritingAssistantUserSentiment;
};

/** Input to the AI Writing Assistant, containing various fields that can be set or unset depending on the use case */
export type AiAuthoring_WritingAssistantInput = {
  /** Optional input JSON that can be used for use cases requiring more complex, structured inputs */
  additionalInputs?: InputMaybe<Scalars['JSON']>;
  /** Optional input representing a selection of text that will be operated on for use cases like rewriting or critiquing */
  selectedText?: InputMaybe<AiAuthoring_WritingAssistantSelectedTextInput>;
  /** Input determining the system prompt that will be passed to the LLM */
  systemPrompt: AiAuthoring_WritingAssistantSystemPromptInput;
  /**
   * What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while
   * lower values like 0.2 will make it more focused and deterministic.
   */
  temperature?: Scalars['Float'];
  /** Optional user prompt which will be passed to the LLM for use cases requiring user input to guide generation */
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** Represents a text selection */
export type AiAuthoring_WritingAssistantSelectedTextInput = {
  /** The complete text that the selection is a part of */
  completeText: Scalars['String'];
  /**
   * The index after the last character of the substring (exclusive). The length of the substring is expected to equal
   * selectionEndIndex - selectionStartIndex.
   */
  selectionEndIndex: Scalars['Int'];
  /** The index of the first character of the selection (inclusive) */
  selectionStartIndex: Scalars['Int'];
};

/**
 * Input determining the system prompt that will be passed to the LLM, expected to contain either a prompt template ID or
 * a prompt override string
 */
export type AiAuthoring_WritingAssistantSystemPromptInput = {
  /**
   * If set, the prompt override will be passed to the LLM, allowing different prompts to be tested without requiring code
   * changes or long-term persistence
   */
  promptOverride?: InputMaybe<Scalars['String']>;
  /**
   * If set, a system prompt corresponding to the template ID will be retrieved from a parameter store and passed to the
   * LLM
   */
  promptTemplateId?: InputMaybe<Scalars['ID']>;
};

/** Enum representing the user's sentiment about a particular LLM response */
export const AiAuthoring_WritingAssistantUserSentiment = {
  /** The user disliked the LLM response */
  Negative: 'NEGATIVE',
  /** The user liked the LLM response */
  Positive: 'POSITIVE'
} as const;

export type AiAuthoring_WritingAssistantUserSentiment = typeof AiAuthoring_WritingAssistantUserSentiment[keyof typeof AiAuthoring_WritingAssistantUserSentiment];
/** This is used to track whether the learner's message was a direct action request or free-form. */
export const AiCoach_Action = {
  /** Direct action for the button 'Tell me what you can do' */
  AboutCoach: 'ABOUT_COACH',
  /** Direct action for the button 'Check my understanding' */
  CheckUnderstanding: 'CHECK_UNDERSTANDING',
  /** Action used in Coach Items (Roleplay) to initiate debrief session. */
  CoachItemGenerateFeedback: 'COACH_ITEM_GENERATE_FEEDBACK',
  /** Action used in Coach Items (Roleplay) to generate json representation of the scenario. Response is not shown to the learner. */
  CoachItemGenerateJson: 'COACH_ITEM_GENERATE_JSON',
  /** Action used in Coach Items (Roleplay) to initate scenario generation. Response of this is shown to the learner. */
  CoachItemGenerateScenario: 'COACH_ITEM_GENERATE_SCENARIO',
  /** Action used in Coach Items for learners to indicate that they are ready to start */
  CoachItemLetsGetStarted: 'COACH_ITEM_LETS_GET_STARTED',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_1: 'COACH_ITEM_PERSONALIZATION_OPTION_1',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_2: 'COACH_ITEM_PERSONALIZATION_OPTION_2',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_3: 'COACH_ITEM_PERSONALIZATION_OPTION_3',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_4: 'COACH_ITEM_PERSONALIZATION_OPTION_4',
  /** Action used in the Coach Items to encourage learner to continue chat even when they feel stuck */
  CoachItemStuckContinue: 'COACH_ITEM_STUCK_CONTINUE',
  /** Action used in the Coach Items to indicate that chat should be ended as learner is stuck */
  CoachItemStuckEnd: 'COACH_ITEM_STUCK_END',
  /** Action used in the Coach Items completion flow to indicate to the FE and BE that the chat should be ended */
  CoachItemSummary: 'COACH_ITEM_SUMMARY',
  /** Action used in the Coach Items to indicate that chat should be ended as learner completed the tasks. */
  CoachItemTaskCompleted: 'COACH_ITEM_TASK_COMPLETED',
  /** Generic action buttons that does not require special handling in the BE */
  GenericAction: 'GENERIC_ACTION',
  /** Direct action for the button 'Help me get started' */
  HelpGetStartedWithCourse: 'HELP_GET_STARTED_WITH_COURSE',
  /** Action used in the Practice Moment to indicate that chat should be ended as user ended the activity. */
  PracticeMomentEndedActivity: 'PRACTICE_MOMENT_ENDED_ACTIVITY',
  /** Action used in the Practice Moment to indicate that it's a single turn activity. */
  PracticeMomentSingleTurn: 'PRACTICE_MOMENT_SINGLE_TURN',
  /** Direct action for the button 'Can you generate practice questions based on this video?' */
  PracticeQuestions: 'PRACTICE_QUESTIONS',
  /** Direct action for the button 'Give me a practice scenario' */
  PracticeScenario: 'PRACTICE_SCENARIO',
  /** Direct action for the button that asks coach to generate real-life examples */
  RealLifeExamples: 'REAL_LIFE_EXAMPLES',
  /** Direct action for the button 'Can you explain this topic in simple terms?' */
  SimpleExplanation: 'SIMPLE_EXPLANATION',
  /** Direct action for the button 'Put it in simple terms' */
  SimpleTerms: 'SIMPLE_TERMS',
  /** Direct action for the button 'Can you summarize this video for me?' */
  Summarize: 'SUMMARIZE',
  /** Direct action for the button 'Summarize this reading' */
  SummarizeReading: 'SUMMARIZE_READING',
  /** Free form message entered by the learner */
  TypedMessage: 'TYPED_MESSAGE',
  /** Direct action for generating a welcome message, prior to any user interaction */
  WelcomeMessage: 'WELCOME_MESSAGE',
  /** Direct action for the button 'Why should I take this course?' */
  WhyTakeCourse: 'WHY_TAKE_COURSE'
} as const;

export type AiCoach_Action = typeof AiCoach_Action[keyof typeof AiCoach_Action];
/** The additional context of a Coach chat as an input. */
export type AiCoach_AdditionalContextInput = {
  /** Context key for the additional context with a prefix of "additionalContext.". For example, "additionalContext.roleData" */
  contextKey: Scalars['String'];
  /** The value of the additional context. */
  contextValue: Scalars['String'];
};

/** The status of a Coach Async Task */
export const AiCoach_AsyncTaskStatus = {
  /** The async task has completed successfully */
  Completed: 'COMPLETED',
  /** The async task has failed */
  Failed: 'FAILED',
  /** The async task is picked up by a consumer and is in progress */
  InProgress: 'IN_PROGRESS',
  /** The async task is sent to the queue and waiting to be processed */
  Pending: 'PENDING'
} as const;

export type AiCoach_AsyncTaskStatus = typeof AiCoach_AsyncTaskStatus[keyof typeof AiCoach_AsyncTaskStatus];
/** Metadata describing a file attachment uploaded by the user and sent with a chat message. */
export type AiCoach_AttachmentInput = {
  /** The size of the file in bytes. */
  byteSize: Scalars['Int'];
  /** The MIME type of the file (e.g. "image/png", "application/pdf"). */
  mimeType: Scalars['String'];
  /** The original filename as provided by the user. */
  originalName: Scalars['String'];
  /** The S3 URL where the uploaded file is stored. */
  s3Url: Scalars['URL'];
};

/** The state of the conversation as it pertains to whether messages can be sent */
export const AiCoach_ChatSessionStatus = {
  /** The conversation is open to new messages from the user */
  Active: 'ACTIVE',
  /** The conversation has concluded in error due to too many messages being sent */
  ChatLimitReached: 'CHAT_LIMIT_REACHED',
  /** The chat session data has been deleted */
  Deleted: 'DELETED',
  /** The chat session data is in the process of being deleted */
  Deleting: 'DELETING',
  /** The conversation has concluded intentionally either by the user or system */
  Ended: 'ENDED'
} as const;

export type AiCoach_ChatSessionStatus = typeof AiCoach_ChatSessionStatus[keyof typeof AiCoach_ChatSessionStatus];
/** The configuration of Coach as an input. Contains a subset of fields from proto model coursera.proto.aicoach.v1beta1.CoachConfiguration. */
export type AiCoach_CoachConfigInput = {
  /** The max number of chat history messages included in prompt. */
  chatHistoryLimit?: InputMaybe<Scalars['Int']>;
  /** The max token of chat history messages included in prompt. */
  chatHistoryTokenLimit?: InputMaybe<Scalars['Int']>;
  /** The model used for config override, such as "gpt-5" */
  model?: InputMaybe<Scalars['String']>;
  /** System prompt template */
  systemPromptTemplate?: InputMaybe<Scalars['String']>;
  /** The max token of prompt, including system prompt template, context and chat history. */
  totalTokenLimit?: InputMaybe<Scalars['Int']>;
  /** The max user message length in characters. */
  userMessageLengthLimit?: InputMaybe<Scalars['Int']>;
};

/** The status of the edit user response */
export const AiCoach_CoachEditResponseStatus = {
  /** Approve */
  Approve: 'APPROVE',
  /** Reject */
  Reject: 'REJECT'
} as const;

export type AiCoach_CoachEditResponseStatus = typeof AiCoach_CoachEditResponseStatus[keyof typeof AiCoach_CoachEditResponseStatus];
/** The type of edit being suggested by coach */
export const AiCoach_CoachEditVerb = {
  /** Denotes that coach would like to add an object */
  Add: 'ADD',
  /** Denotes that there are multiple suggested edits grouped together */
  Group: 'GROUP',
  /** Denotes that coach would like to remove an object */
  Remove: 'REMOVE',
  /** Denotes that coach would like to reorder the elements of a list field */
  Reorder: 'REORDER',
  /** Denotes that coach would like to update an field or object */
  Update: 'UPDATE'
} as const;

export type AiCoach_CoachEditVerb = typeof AiCoach_CoachEditVerb[keyof typeof AiCoach_CoachEditVerb];
/** Input for setting the coach settings memory preference */
export type AiCoach_CoachSettingsMemoryPreferenceInput = {
  /** Enable collection of memory and usage in interactions */
  enableMemory: Scalars['Boolean'];
};

/** Input for setting the coach settings profile preference */
export type AiCoach_CoachSettingsProfilePreferenceInput = {
  /** Enable additional info */
  enableAdditionalInfo: Scalars['Boolean'];
  /** Enable education history */
  enableEducationHistory: Scalars['Boolean'];
  /** Enable location */
  enableLocation: Scalars['Boolean'];
  /** Enable the usage of user profile or completely disable the usage of all user profile fields */
  enableProfile: Scalars['Boolean'];
  /** Enable work history */
  enableWorkHistory: Scalars['Boolean'];
};

/** The configuration of a Coach chat message as an input. */
export type AiCoach_ConfigurationInput = {
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Optional parameter containing the coach config version. If not provided, the latest published config is used. */
  coachConfigVersion?: InputMaybe<Scalars['Int']>;
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Include structured output in chat history */
  includeStructuredOutputInChatHistory?: Scalars['Boolean'];
};

/** Context of where the dynamic prompts are to be shown to the learner */
export const AiCoach_ContextType = {
  /** Shows dynamic prompts in Coach Tutor Disclosure UI */
  Disclosure: 'DISCLOSURE'
} as const;

export type AiCoach_ContextType = typeof AiCoach_ContextType[keyof typeof AiCoach_ContextType];
/** Contextual information used to help the AI coach understand the context of the message in coursera. */
export type AiCoach_CourseraContextInput = {
  /** List of additional products the user need as supporting context */
  additionalProducts?: InputMaybe<Array<AiCoach_ProductInput>>;
  /** Provides the AuthoringCourseBranch ID context of the message if the context is available. */
  authoringCourseBranchId?: InputMaybe<Scalars['ID']>;
  /** Provides the CourseBranch ID context of the message if the context is available. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Degree ID the user is currently on */
  degreeId?: InputMaybe<Scalars['ID']>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Module ID the user is currently on */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Specialization ID the user is currently on */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** The enum indicating the type of the product for the AI coach to understand the additional context of the message in coursera. */
export const AiCoach_CourseraProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type AiCoach_CourseraProductType = typeof AiCoach_CourseraProductType[keyof typeof AiCoach_CourseraProductType];
/** Input for creating a new chat session */
export type AiCoach_CreateChatSessionInput = {
  /** Chat Session Title */
  title: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** The input to create a LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenDevInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * Agent type name to specify which agent should be dispatched to the room when
   * a user joins. Should match the one you are using in local testing.
   */
  agentTypeName: Scalars['String'];
  /** Existing Coach chat session id. */
  chatSessionId: Scalars['ID'];
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
};

/** The input to create a LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /** Existing Coach chat session id. */
  chatSessionId: Scalars['ID'];
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
};

/**
 * Input for creating and returning the message from the user and the subsequent response returned by the AI coach.
 * The input includes the optional fields of courseId and itemId, or s12nId to help link the chat
 * message to those fields, if the context allows.
 */
export type AiCoach_CreateUserMessageAndReturnResponseInput = {
  /** This signifies a direct action or a message typed out by the learner in the FE. */
  action?: AiCoach_Action;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** Optional parameter containing the coach config version. If not provided, the latest published config is used. */
  coachConfigVersion?: InputMaybe<Scalars['Int']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
  /** Coach mode. */
  mode?: AiCoach_Mode;
  /** Specialization ID the user is currently on */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** User ID */
  userId: Scalars['ID'];
};

/** Preset date range selection used to scope an analytics query. */
export const AiCoach_DateRangeType = {
  /** All available historical data with no date restriction. */
  AllTime: 'ALL_TIME',
  /** A custom date range specified by the user. */
  Custom: 'CUSTOM',
  /** Last 30 days from the current date. */
  Last_30Days: 'LAST_30_DAYS',
  /** Last 60 days from the current date. */
  Last_60Days: 'LAST_60_DAYS',
  /** Last 90 days from the current date. */
  Last_90Days: 'LAST_90_DAYS'
} as const;

export type AiCoach_DateRangeType = typeof AiCoach_DateRangeType[keyof typeof AiCoach_DateRangeType];
/** Input for deleting chat sessions for the current learner */
export type AiCoach_DeleteChatSessionsForCurrentUserInput = {
  /** Chat Session IDs */
  chatSessionIds: Array<Scalars['ID']>;
};

/** Input for deleting memories for the current learner */
export type AiCoach_DeleteMemoriesForCurrentUserInput = {
  /** Memory IDs */
  memoryIds: Array<Scalars['ID']>;
};

/** Difficulty level of a Coursera product. */
export const AiCoach_DifficultyLevel = {
  /** Suitable for learners with substantial experience and deep knowledge of the subject. */
  Advanced: 'ADVANCED',
  /** Suitable for learners with little to no prior knowledge of the subject. */
  Beginner: 'BEGINNER',
  /** Suitable for learners with some foundational knowledge of the subject. */
  Intermediate: 'INTERMEDIATE',
  /** Contains content spanning multiple difficulty levels. */
  Mixed: 'MIXED'
} as const;

export type AiCoach_DifficultyLevel = typeof AiCoach_DifficultyLevel[keyof typeof AiCoach_DifficultyLevel];
/**
 * The type of embedded content returned by the AI coach.
 * Each value identifies a concrete implementation of AiCoach_EmbeddedContent.
 */
export const AiCoach_EmbeddedContentType = {
  /** Embedded content containing analytics data from the Analytics Control Plane. */
  Analytics: 'ANALYTICS',
  /**
   * Embedded content representing a tool call returned by an MCP server, optionally
   * carrying an interactive MCP App.
   */
  McpToolCall: 'MCP_TOOL_CALL',
  /**
   * Embedded content representing a filter override, surfaced when the NLQ-derived filters
   * conflict with or diverge from the overall applied filters.
   */
  OverrideFilters: 'OVERRIDE_FILTERS'
} as const;

export type AiCoach_EmbeddedContentType = typeof AiCoach_EmbeddedContentType[keyof typeof AiCoach_EmbeddedContentType];
/** Learner enrollment status used in analytics filters. */
export const AiCoach_LearnerStatus = {
  /** Learner has been invited but has not yet joined. */
  Invited: 'INVITED',
  /** Learner has accepted the invitation and joined. */
  Joined: 'JOINED',
  /** Learner has been removed from the program or contract. */
  Removed: 'REMOVED'
} as const;

export type AiCoach_LearnerStatus = typeof AiCoach_LearnerStatus[keyof typeof AiCoach_LearnerStatus];
/**
 * Input for re-pointing a logged-out learner's chat history to the calling authenticated user at
 * first-time registration.
 */
export type AiCoach_LinkLoggedOutHistoryToCurrentUserInput = {
  /**
   * Optional single chat session to migrate. When omitted, all sessions owned by the logged-out
   * identity are migrated (the recommended client behavior).
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /**
   * The __204u cookie value identifying the logged-out session whose chat history should be linked.
   * Cross-checked server-side against the __204u request cookie; a mismatch is rejected.
   */
  cookieId: Scalars['ID'];
};

/** This is used to define the mode of the AI coach. */
export const AiCoach_Mode = {
  /** This mode is used on pre- and post-assignment pages to help learners prepare assignments and review the results afterwards */
  Assignment: 'ASSIGNMENT',
  /** Basic mode where Coach only has some common context and is not aware of any additional page-specific stuff */
  Basic: 'BASIC',
  /** This mode is used in coach items. see https://coursera.atlassian.net/wiki/spaces/CP/pages/3655335963/Coach+Item+MVP for more details. eg) socratic dicussion */
  CoachItem: 'COACH_ITEM',
  /** This operates identically to the COACH_ITEM type, except that this lets authors access the draft version of the item rather than the live version */
  CoachItemAuthoringDraft: 'COACH_ITEM_AUTHORING_DRAFT',
  /** This operates identically to the COACH_ITEM_AUTHORING_DRAFT type, except that this lets authors access the published version of the item */
  CoachItemAuthoringPublished: 'COACH_ITEM_AUTHORING_PUBLISHED',
  /** This mode is used on course home page */
  CourseGuide: 'COURSE_GUIDE',
  /** This mode is used on lecture and reading pages */
  ItemLearning: 'ITEM_LEARNING',
  /** Experimental "injectable" "Proactive AI" item type */
  PracticeMoment: 'PRACTICE_MOMENT',
  /** This mode is used on pre- and post-quiz pages to help learners prepare quizzes and review the results afterwards */
  Quiz: 'QUIZ'
} as const;

export type AiCoach_Mode = typeof AiCoach_Mode[keyof typeof AiCoach_Mode];
/** This is used to define the type of the navigation leading message. */
export const AiCoach_NavigationLeadingMessage = {
  /** Leading message for the navigation button appending the response of Help me get started action */
  HelpGetStartedWithCourseNavigation: 'HELP_GET_STARTED_WITH_COURSE_NAVIGATION',
  /** Leading message for the navigation button appending the response of Why should I take this course action */
  WhyTakeCourseNavigation: 'WHY_TAKE_COURSE_NAVIGATION'
} as const;

export type AiCoach_NavigationLeadingMessage = typeof AiCoach_NavigationLeadingMessage[keyof typeof AiCoach_NavigationLeadingMessage];
/** Item types supported for new course optimizations */
export const AiCoach_OptimizationItemType = {
  /** Dialogue */
  Dialogue: 'DIALOGUE',
  /** Tool based practice */
  ToolBasedPractice: 'TOOL_BASED_PRACTICE'
} as const;

export type AiCoach_OptimizationItemType = typeof AiCoach_OptimizationItemType[keyof typeof AiCoach_OptimizationItemType];
/** Product input for the AI coach to understand the additional context of the message in coursera. */
export type AiCoach_ProductInput = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: AiCoach_CourseraProductType;
};

/** Use for PLATFORM: Input for creating and returning the message from the user and the subsequent response returned by the AI coach async. */
export type AiCoach_RespondToUserMessageAsyncInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
};

/** Use for PLATFORM: Input for creating and returning the message from the user and the subsequent response returned by the AI coach. */
export type AiCoach_RespondToUserMessageInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * File attachments to send with this message. Defaults to an empty list so existing
   * callers are unaffected. At most one attachment is supported for MVP.
   */
  attachments?: Array<AiCoach_AttachmentInput>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** A field that can be only used by Courserians to preview config changes on the flight. */
  configOverride?: InputMaybe<AiCoach_CoachConfigInput>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
  /**
   * How the message should be processed by Coach.
   * @deprecated Please use the new async endpoint AiCoach_RespondToUserMessageAsync as task based processing will be deprecated.
   */
  responseProcessingType?: AiCoach_ResponseProcessingType;
};

/** Use for PLATFORM: How Coach should process the message */
export const AiCoach_ResponseProcessingType = {
  /** Default: Process the message synchronously and return the response */
  SynchronousResponse: 'SYNCHRONOUS_RESPONSE',
  /** Process the message with a task-based workflow based on the Coach action's task configuration */
  TaskBasedProcessing: 'TASK_BASED_PROCESSING'
} as const;

export type AiCoach_ResponseProcessingType = typeof AiCoach_ResponseProcessingType[keyof typeof AiCoach_ResponseProcessingType];
/** Input for saving coach settings for the user */
export type AiCoach_SaveCoachUserSettingsInput = {
  /**
   * The coach settings memory preference input, which includes the enable/disable settings for collection and retrieval
   * of memory in user interactions
   */
  memoryPreferenceInput?: InputMaybe<AiCoach_CoachSettingsMemoryPreferenceInput>;
  /** The coach settings profile preference input, which includes the enable/disable settings for user profile fields */
  profilePreferenceInput?: InputMaybe<AiCoach_CoachSettingsProfilePreferenceInput>;
};

/** This helps depict if the message is by the user or the AI coach. */
export const AiCoach_SenderType = {
  /** Message is by the AI coach */
  System: 'SYSTEM',
  /** Message is by the user */
  User: 'USER'
} as const;

export type AiCoach_SenderType = typeof AiCoach_SenderType[keyof typeof AiCoach_SenderType];
/** Platform text streaming: Input for creating and returning the message from the user and the subsequent STREAMED response returned by the AI coach. */
export type AiCoach_TextStreamingChatInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * File attachments to send with this message. Defaults to an empty list so existing
   * callers are unaffected. At most one attachment is supported for MVP.
   */
  attachments?: Array<AiCoach_AttachmentInput>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** A field that can be only used by Courserians to preview config changes on the flight. */
  configOverride?: InputMaybe<AiCoach_CoachConfigInput>;
  /**
   * The cookie ID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  cookieId?: InputMaybe<Scalars['ID']>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /**
   * The UUID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
};

/** Input for updating a  chat session */
export type AiCoach_UpdateChatSessionInput = {
  /** Chat Session ID */
  id: Scalars['ID'];
  /** Chat Session Title */
  title: Scalars['String'];
};

/** Input to update the status of a dynamic prompt to completed status for a learner */
export type AiCoach_UpdateDynamicPromptStatusAsCompleteInput = {
  /** The ID of the dynamic prompt that needs to get updated with the completed status */
  id: Scalars['ID'];
};

/** Inputs for updating the feedback of the user on a AI coach response. */
export type AiCoach_UpdateWithUserFeedbackInput = {
  /**
   * The cookie ID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  cookieId?: InputMaybe<Scalars['ID']>;
  /**
   * The UUID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Message ID */
  messageId: Scalars['ID'];
  /** Feedback via comments from the user on the response received by the AI coach */
  userComments?: InputMaybe<Scalars['String']>;
  /** Feedback via a like/dislike from the user on the response received by the AI coach */
  userFeedback: AiCoach_UserFeedback;
};

/** User feedback via a like/dislike on the response received by the AI coach. */
export const AiCoach_UserFeedback = {
  /** AI coach response is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI coach response is liked by the user */
  Like: 'LIKE',
  /** User feedback i.e the like or dislike status is unset by the user */
  Unset: 'UNSET'
} as const;

export type AiCoach_UserFeedback = typeof AiCoach_UserFeedback[keyof typeof AiCoach_UserFeedback];
/**
 * Input for creating / updating the index of the given asset.
 * The course item context indicates the item to which this asset was attached.
 */
export type AiEmbeddings_IndexDocumentAssetInput = {
  /** Asset ID to be indexed */
  assetId: Scalars['ID'];
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Module ID */
  moduleId: Scalars['ID'];
};

/** This is used to define the status of the request. */
export const AiEmbeddings_IndexDocumentAssetStatus = {
  /** Processing denied, due to some validation error */
  Denied: 'DENIED',
  /** Processing failed */
  Failure: 'FAILURE',
  /** Request successfully processed */
  Success: 'SUCCESS'
} as const;

export type AiEmbeddings_IndexDocumentAssetStatus = typeof AiEmbeddings_IndexDocumentAssetStatus[keyof typeof AiEmbeddings_IndexDocumentAssetStatus];
/** This is used to define the error code of the request. */
export const AiEmbeddings_IndexDocumentErrorCode = {
  /** No error */
  None: 'NONE',
  /** Indicates asset cannot be found */
  NotFoundError: 'NOT_FOUND_ERROR',
  /** Indicates general processing error */
  ProcessingError: 'PROCESSING_ERROR',
  /** Indicates asset file size exceeds maximum */
  SizeLimitExceededError: 'SIZE_LIMIT_EXCEEDED_ERROR',
  /** Indicates asset is of unsupported file type */
  UnsupportedFileTypeError: 'UNSUPPORTED_FILE_TYPE_ERROR'
} as const;

export type AiEmbeddings_IndexDocumentErrorCode = typeof AiEmbeddings_IndexDocumentErrorCode[keyof typeof AiEmbeddings_IndexDocumentErrorCode];
/** The type of assessment for which a challenge is created. */
export const AiGradedChallenge_AssessmentType = {
  /** Lab assignment. */
  Lab: 'LAB',
  /** Roleplay assessment. */
  Roleplay: 'ROLEPLAY'
} as const;

export type AiGradedChallenge_AssessmentType = typeof AiGradedChallenge_AssessmentType[keyof typeof AiGradedChallenge_AssessmentType];
/** AttemptStatus */
export const AiGradedChallenge_AttemptStatus = {
  /**
   * The attempt is completed or closed because either they ran out of submissions or time, and
   * at this time learner cannot make submissions.
   */
  Completed: 'COMPLETED',
  /** The attempt is in progress and learner is allowed to make submissions */
  InProgress: 'IN_PROGRESS',
  /** Learner has not started the attempt */
  NotStarted: 'NOT_STARTED'
} as const;

export type AiGradedChallenge_AttemptStatus = typeof AiGradedChallenge_AttemptStatus[keyof typeof AiGradedChallenge_AttemptStatus];
/** The draft/published status of a challenge. */
export const AiGradedChallenge_ChallengeStatus = {
  /** Challenge is a draft being edited by the author. */
  Draft: 'DRAFT',
  /** Challenge has been published and is visible to learners. */
  Published: 'PUBLISHED'
} as const;

export type AiGradedChallenge_ChallengeStatus = typeof AiGradedChallenge_ChallengeStatus[keyof typeof AiGradedChallenge_ChallengeStatus];
/** The status of the challenge submission. */
export const AiGradedChallenge_ChallengeSubmissionStatus = {
  /** The challenge submission grading failed. */
  GradingFailed: 'GRADING_FAILED',
  /** The challenge submission grading has started. */
  GradingStarted: 'GRADING_STARTED',
  /** The challenge submission grading succeeded. */
  GradingSucceeded: 'GRADING_SUCCEEDED'
} as const;

export type AiGradedChallenge_ChallengeSubmissionStatus = typeof AiGradedChallenge_ChallengeSubmissionStatus[keyof typeof AiGradedChallenge_ChallengeSubmissionStatus];
/** The criteria for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricCriteriaInput = {
  /** Options for the checklist rubric. */
  options: Array<AiGradedChallenge_ChecklistRubricOptionInput>;
  /** Prompt for the checklist rubric. */
  prompt: Scalars['String'];
};

/** An option for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricOptionInput = {
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: InputMaybe<Scalars['Float']>;
};

/** Input for AiGradedChallenge_CreateChallenge mutation */
export type AiGradedChallenge_CreateChallengeInput = {
  /** ID of the assessment for which a challenge is created. */
  assessmentId: Scalars['ID'];
  /** Type of assessment for which a challenge is created. */
  assessmentType: AiGradedChallenge_AssessmentType;
  /** Version of the assessment for which a challenge is created. */
  assessmentVersion: Scalars['Int'];
  /** Draft or published status of the challenge. */
  challengeStatus: AiGradedChallenge_ChallengeStatus;
  /** Enablement status of the challenge. */
  enablementStatus: AiGradedChallenge_EnablementStatus;
  /** Grader-facing instructions for the challenge. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** Instructions for the challenge. */
  instructions: AiGradedChallenge_InstructionsInput;
  /** Rubrics for the challenge. */
  rubrics: Array<AiGradedChallenge_RubricInput>;
};

/** Input for AiGradedChallenge_DeleteDraftChallengeById mutation */
export type AiGradedChallenge_DeleteDraftChallengeByIdInput = {
  /** The composite challenge ID of the draft challenge to delete. */
  challengeId: Scalars['ID'];
};

/** Input for AiGradedChallenge_DeleteDraftChallenge mutation */
export type AiGradedChallenge_DeleteDraftChallengeInput = {
  /** ID of the assessment for the draft challenge to delete. */
  assessmentId: Scalars['ID'];
  /** Type of assessment for the draft challenge to delete. */
  assessmentType: AiGradedChallenge_AssessmentType;
  /** Version of the assessment for the draft challenge to delete. */
  assessmentVersion: Scalars['Int'];
};

/** The enablement status of a challenge. */
export const AiGradedChallenge_EnablementStatus = {
  /** Challenge is disabled. */
  Disabled: 'DISABLED',
  /** Challenge is enabled. */
  Enabled: 'ENABLED'
} as const;

export type AiGradedChallenge_EnablementStatus = typeof AiGradedChallenge_EnablementStatus[keyof typeof AiGradedChallenge_EnablementStatus];
/** The instructions part. */
export type AiGradedChallenge_InstructionPartInput = {
  /** The CML content of the part. */
  content: Cml_CmlInput;
  /** The title of the part. */
  title: Scalars['String'];
};

/** The instructions for a challenge. */
export type AiGradedChallenge_InstructionsInput = {
  /** The instructions parts. */
  parts: Array<AiGradedChallenge_InstructionPartInput>;
};

/** Lab capture content input. */
export type AiGradedChallenge_LabCaptureContentInput = {
  /** Attempt ID */
  attemptId: Scalars['ID'];
};

/** The criteria for a options rubric. */
export type AiGradedChallenge_OptionsRubricCriteriaInput = {
  /** Options for the options rubric. */
  options: Array<AiGradedChallenge_OptionsRubricOptionInput>;
  /** Prompt for the options rubric. */
  prompt: Scalars['String'];
};

/** The option for a options rubric. */
export type AiGradedChallenge_OptionsRubricOptionInput = {
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: InputMaybe<Scalars['Float']>;
};

/** The recording submission for the challenge. */
export type AiGradedChallenge_RecordingContentInput = {
  /** ID of the recording */
  recordingId: Scalars['ID'];
};

/** The criteria for a rubric. */
export type AiGradedChallenge_RubricCriteriaInput = {
  /** Rubric criteria for a checklist rubric. */
  checklistRubricCriteria?: InputMaybe<AiGradedChallenge_ChecklistRubricCriteriaInput>;
  /** Rubric criteria for an options rubric. */
  optionsRubricCriteria?: InputMaybe<AiGradedChallenge_OptionsRubricCriteriaInput>;
  /** Rubric criteria for a text rubric. */
  textRubricCriteria?: InputMaybe<AiGradedChallenge_TextRubricCriteriaInput>;
};

/** The rubric for a challenge. */
export type AiGradedChallenge_RubricInput = {
  /** Criteria for the rubric. */
  criteria: AiGradedChallenge_RubricCriteriaInput;
  /** Grader-facing instructions for this rubric. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** ID of the rubric. */
  rubricId: Scalars['ID'];
  /** IDs of the skill expressions associated with this rubric. */
  skillExpressionIds: Array<Scalars['ID']>;
  /**
   * Sources indicating who created/contributed to this rubric.
   * Defaults to an empty list if not provided.
   */
  sources?: Array<AiGradedChallenge_RubricSource>;
};

/** The source of a rubric (who created or contributed to it). */
export const AiGradedChallenge_RubricSource = {
  /** Rubric was generated by AI. */
  Ai: 'AI',
  /** Rubric was created or edited by a human. */
  Human: 'HUMAN'
} as const;

export type AiGradedChallenge_RubricSource = typeof AiGradedChallenge_RubricSource[keyof typeof AiGradedChallenge_RubricSource];
/** Input for AiGradedChallenge_SaveUserFeedback mutation */
export type AiGradedChallenge_SaveUserFeedbackInput = {
  /** ID of the challenge submission that should be saved. */
  challengeSubmissionId: Scalars['ID'];
  /** Optional user feedback comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Type of user feedback for a challenge submission. */
  feedbackType: AiGradedChallenge_UserFeedbackType;
};

/** The status of the skill verification process for a challenge submission. */
export const AiGradedChallenge_SkillVerificationStatus = {
  /** Skill verification has completed. */
  Complete: 'COMPLETE',
  /** Skill verification is in progress. */
  InProgress: 'IN_PROGRESS',
  /** Skill verification is not required for this submission. */
  NotRequired: 'NOT_REQUIRED'
} as const;

export type AiGradedChallenge_SkillVerificationStatus = typeof AiGradedChallenge_SkillVerificationStatus[keyof typeof AiGradedChallenge_SkillVerificationStatus];
/** The content of the challenge submission. */
export type AiGradedChallenge_SubmissionContentInput = {
  /** CML submission. */
  cmlContent?: InputMaybe<Cml_CmlInput>;
  /** Lab capture. */
  labCaptureContent?: InputMaybe<AiGradedChallenge_LabCaptureContentInput>;
  /** Recording submission. */
  recordingContent?: InputMaybe<AiGradedChallenge_RecordingContentInput>;
};

/** Input for AiGradedChallenge_SubmitChallenge mutation */
export type AiGradedChallenge_SubmitChallengeInput = {
  /** ID of the branch in which this submission is made. */
  branchId: Scalars['ID'];
  /** ID of the challenge that the submission is for. */
  challengeId: Scalars['ID'];
  /** ID of the course in which the submission is made. */
  courseId: Scalars['ID'];
  /** ID of the item for which this challenge submission is associated with. */
  itemId: Scalars['ID'];
  /** Content of the challenge submission. */
  submissionContent: AiGradedChallenge_SubmissionContentInput;
};

/** The criteria for a text rubric. */
export type AiGradedChallenge_TextRubricCriteriaInput = {
  /** Points for the text rubric. */
  points?: InputMaybe<Scalars['Float']>;
  /** Prompt for the text rubric. */
  prompt: Scalars['String'];
};

/** Input for AiGradedChallenge_UpdateChallenge mutation */
export type AiGradedChallenge_UpdateChallengeInput = {
  /** ID of the challenge to update. */
  challengeId: Scalars['ID'];
  /** Enablement status of the challenge. */
  enablementStatus: AiGradedChallenge_EnablementStatus;
  /** Grader-facing instructions for the challenge. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** Instructions for the challenge. */
  instructions: AiGradedChallenge_InstructionsInput;
  /** Rubrics for the challenge. */
  rubrics: Array<AiGradedChallenge_RubricInput>;
};

/** The type of user feedback for a challenge submission. */
export const AiGradedChallenge_UserFeedbackType = {
  /** Downvote the challenge submission. */
  Downvote: 'DOWNVOTE',
  /** Upvote the challenge submission feedback. */
  Upvote: 'UPVOTE'
} as const;

export type AiGradedChallenge_UserFeedbackType = typeof AiGradedChallenge_UserFeedbackType[keyof typeof AiGradedChallenge_UserFeedbackType];
/** Enum type for AI Models */
export const AiGrading_AiModelEnum = {
  /** To use Gpt4 Client */
  Gpt_4: 'GPT_4',
  /** To use Gpt35Turbo16k Client */
  Gpt_35Turbo_16K: 'GPT_35_TURBO_16K'
} as const;

export type AiGrading_AiModelEnum = typeof AiGrading_AiModelEnum[keyof typeof AiGrading_AiModelEnum];
/** The type of assessment for rubric generation. */
export const AiGrading_AssessmentType = {
  /** Graded assignment. */
  Assignment: 'ASSIGNMENT',
  /** Lab. */
  Lab: 'LAB',
  /** ROLEPLAY */
  Roleplay: 'ROLEPLAY'
} as const;

export type AiGrading_AssessmentType = typeof AiGrading_AssessmentType[keyof typeof AiGrading_AssessmentType];
/** The status of the rubrics generation job. */
export const AiGrading_AssignmentRubricGenerationJobStatus = {
  /** The job completed successfully */
  Completed: 'COMPLETED',
  /** The job failed */
  Failed: 'FAILED',
  /** The job is in progress */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiGrading_AssignmentRubricGenerationJobStatus = typeof AiGrading_AssignmentRubricGenerationJobStatus[keyof typeof AiGrading_AssignmentRubricGenerationJobStatus];
/** Input for CreateAssignmentLevelRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentLevelRubricGenerationJobInput = {
  /** The assessment type. */
  assessmentType?: AiGrading_AssessmentType;
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /**
   * A list of skill expression ids for which we should generate rubrics. If empty, the systems will
   * attempt to query for skill expressions that need rubrics.
   */
  skillExpressionIds?: Array<Scalars['ID']>;
};

/** Input for CreateAssignmentRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentRubricGenerationJobInput = {
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Question ID */
  questionId: Scalars['ID'];
};

/** User Input for createDispute mutation */
export type AiGrading_CreateDisputeInput = {
  /** Id of the AI Suggestion this dispute is about */
  aiSuggestionId: Scalars['ID'];
  /** Id of the assignment this dispute is about */
  assignmentId: Scalars['ID'];
  /** version of the assignment this dispute is about */
  assignmentVersion: Scalars['Int'];
  /** Id of the course branch */
  courseBranchId: Scalars['ID'];
  /** Id of the course this dispute is about */
  courseId: Scalars['ID'];
  /** Id of the item this dispute is about */
  itemId: Scalars['ID'];
  /** Id of the submission this dispute is about */
  submissionId: Scalars['ID'];
  /** Dispute details entered by user */
  userInput: AiGrading_UserInputInput;
};

/** Ai Grading dispute status */
export const AiGrading_DisputeStatus = {
  /** Status indicating dispute was processed and there are grade updtes */
  Accepted: 'ACCEPTED',
  /** Status indicating failure to process the dispute */
  Failed: 'FAILED',
  /** Status once dispute is requested but no decision has been made */
  InProgress: 'IN_PROGRESS',
  /** Status indicating dispute was processed but there won't be grade changes */
  Rejected: 'REJECTED'
} as const;

export type AiGrading_DisputeStatus = typeof AiGrading_DisputeStatus[keyof typeof AiGrading_DisputeStatus];
/** Ai grading dispute issue categories */
export const AiGrading_IssueCategory = {
  /** Category indicates that The AI's evaluation of the answer doesn’t seem to align with the content of the course. */
  Accuracy: 'ACCURACY',
  /** Category indicates that AI has misunderstood the assignment requirements or objectives. */
  AssignmentUnderstanding: 'ASSIGNMENT_UNDERSTANDING',
  /** Category indicates the submission had extra materials that were not properly considered by AI. */
  ExtraMaterial: 'EXTRA_MATERIAL',
  /** Category indicates that the feedback provided by the AI does not align with the given grade. */
  GradeFeedbackMisalignment: 'GRADE_FEEDBACK_MISALIGNMENT',
  /** Category indicates any other issues not covered by the other categories. */
  Other: 'OTHER',
  /** Category indicates that AI has misinterpreted the grading rubric or criteria. */
  RubricMisinterpretation: 'RUBRIC_MISINTERPRETATION'
} as const;

export type AiGrading_IssueCategory = typeof AiGrading_IssueCategory[keyof typeof AiGrading_IssueCategory];
/** Enum type for ItemType */
export const AiGrading_ItemType = {
  /** assignment item */
  Assignment: 'ASSIGNMENT',
  /** peer review item */
  PeerReview: 'PEER_REVIEW'
} as const;

export type AiGrading_ItemType = typeof AiGrading_ItemType[keyof typeof AiGrading_ItemType];
/** The status of the preview ai grades job. */
export const AiGrading_PreviewAiGradesJobStatus = {
  /** The job completed successfully */
  Completed: 'COMPLETED',
  /** The job failed */
  Failed: 'FAILED',
  /** The job is in progress */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiGrading_PreviewAiGradesJobStatus = typeof AiGrading_PreviewAiGradesJobStatus[keyof typeof AiGrading_PreviewAiGradesJobStatus];
/** Sample Content for AI grading when the question requires a file upload response input */
export type AiGrading_PreviewGradeForQuestionFileInput = {
  /** Caption to describe the file */
  caption: Scalars['String'];
  /** Generated file URL after upload */
  fileUrl: Scalars['String'];
  /** Title to describe the file */
  title: Scalars['String'];
};

/** Input for AiGrading_PreviewGradeForQuestion mutation */
export type AiGrading_PreviewGradeForQuestionInput = {
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The ItemType */
  itemType: AiGrading_ItemType;
  /** The Question ID */
  questionId: Scalars['ID'];
  /** sample answer to preview AI grading */
  sampleInput: AiGrading_PreviewGradeForQuestionSampleInputUnion;
};

/** The sample answer used for the AiGrading_PreviewGradeForQuestion mutation */
export type AiGrading_PreviewGradeForQuestionSampleInputUnion = {
  /** Cml content input. */
  cmlContentInput?: InputMaybe<CmlContentInput>;
  /** File Upload content. */
  fileUploadInput?: InputMaybe<AiGrading_PreviewGradeForQuestionFileInput>;
};

/** Input for AiGrading_SaveUserFeedbackInput mutation */
export type AiGrading_SaveUserFeedbackInput = {
  /**
   * [Optional] The logged in user's feedback choice for the specified AI grading review part of a specific review
   * This field is optional, which is useful when the learner deselects feedback.
   */
  feedbackChoice?: InputMaybe<AiGrading_UserFeedbackChoice>;
  /** The Review Part ID of the AI review */
  reviewPartId: Scalars['ID'];
  /** AI Suggestion ID */
  suggestionId: Scalars['ID'];
};

/** Ai grading suggestion status */
export const AiGrading_SuggestionStatus = {
  /** The suggestion is marked as CANCELED when the submission is not found or has been deleted. */
  Canceled: 'CANCELED',
  /** The suggestion is marked as FAILED after the maximum number of retries. */
  Failed: 'FAILED',
  /** Initial status during suggestion generation process */
  Pending: 'PENDING',
  /**
   * The suggestion is marked as SUCCEEDED when all open-ended questions have been correctly graded.
   * If an assignment includes both manually graded questions and open-ended questions,
   * the suggestion may or may not contain grades for the manually graded questions.
   */
  Succeeded: 'SUCCEEDED'
} as const;

export type AiGrading_SuggestionStatus = typeof AiGrading_SuggestionStatus[keyof typeof AiGrading_SuggestionStatus];
/** Enum representing user feedback of AI grading */
export const AiGrading_UserFeedbackChoice = {
  /** AI review part is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI review part is liked by the user */
  Like: 'LIKE'
} as const;

export type AiGrading_UserFeedbackChoice = typeof AiGrading_UserFeedbackChoice[keyof typeof AiGrading_UserFeedbackChoice];
/** User Input for mutation */
export type AiGrading_UserInputInput = {
  /** Text justifying dispute entered by user */
  inputText: Scalars['String'];
  /** List of issue categories selected by user */
  issueCategory: Array<AiGrading_IssueCategory>;
};

/**
 * A free-form virtual browser website, identified by a display name and
 * an optional URL to open when the lab launches.
 */
export type AiItemGeneration_CustomWebsiteInput = {
  /**
   * The URL to open in the virtual browser when the lab launches.
   * Optional; when omitted the launch URL is resolved downstream.
   */
  launchUrl?: InputMaybe<Scalars['URL']>;
  /** Human-readable name of the website or tool (e.g. \"Canva\"). */
  name: Scalars['String'];
};

/**
 * Defer materialization: generate content now and create the item later via
 * the AiItemGeneration_FinalizeGeneratedItem mutation.
 */
export type AiItemGeneration_DeferredMaterializationInput = {
  /**
   * The item after which the generated item should be inserted when it is
   * materialized. Captured at generate time and replayed at finalize to
   * position the item. If not provided, the item is appended as the last
   * item in the module.
   */
  previousItemId?: InputMaybe<Scalars['ID']>;
};

/**
 * Input for finalizing (materializing) a previously generated item. The
 * placement and configuration are taken from what was captured at generate
 * time, so only the job id is required.
 */
export type AiItemGeneration_FinalizeGeneratedItemInput = {
  /** The ID of the generation job to finalize. */
  jobId: Scalars['ID'];
};

/** Input for generating a new AI-powered item in a course module. */
export type AiItemGeneration_GenerateItemInput = {
  /** The authoring course branch. */
  branchId: Scalars['ID'];
  /** The course to create the item in. */
  courseId: Scalars['ID'];
  /**
   * The type-specific configuration for the item to generate. Exactly one
   * field must be set.
   */
  itemInput: AiItemGeneration_ItemInput;
  /**
   * How the generated item should be materialized. Exactly one field must
   * be set.
   */
  materialization: AiItemGeneration_MaterializationInput;
  /** The module to create the item in. */
  moduleId: Scalars['ID'];
  /**
   * Skill expressions that scope the generated content. The LLM generates
   * a coherent item targeting these skills.
   */
  skillExpressions?: InputMaybe<Array<Scalars['String']>>;
};

/** Whether an item is a graded assessment or ungraded practice. */
export const AiItemGeneration_GradingType = {
  /** Graded assessment with no time limit and unlimited attempts. */
  Graded: 'GRADED',
  /** Ungraded practice mode. */
  Practice: 'PRACTICE'
} as const;

export type AiItemGeneration_GradingType = typeof AiItemGeneration_GradingType[keyof typeof AiItemGeneration_GradingType];
/** Status of an item generation job. */
export const AiItemGeneration_ItemGenerationJobStatus = {
  /**
   * Content generation and materialization succeeded.
   * The item is fully populated and ready for human review.
   */
  Completed: 'COMPLETED',
  /** The job failed. The item shell exists but content is incomplete. */
  Failed: 'FAILED',
  /** The job is queued or the LLM is generating content. */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiItemGeneration_ItemGenerationJobStatus = typeof AiItemGeneration_ItemGenerationJobStatus[keyof typeof AiItemGeneration_ItemGenerationJobStatus];
/**
 * Discriminated union of item-type-specific generation inputs. Exactly
 * one field must be provided.
 */
export type AiItemGeneration_ItemInput = {
  /** Configuration for generating a virtual browser lab. */
  lab?: InputMaybe<AiItemGeneration_LabInput>;
};

/** The publication status of a generated item. */
export const AiItemGeneration_ItemStatus = {
  /** Leave the item as a draft for human review before publishing. */
  Draft: 'DRAFT',
  /** Publish the item immediately. */
  Published: 'PUBLISHED'
} as const;

export type AiItemGeneration_ItemStatus = typeof AiItemGeneration_ItemStatus[keyof typeof AiItemGeneration_ItemStatus];
/** Configuration specific to generating a lab item. */
export type AiItemGeneration_LabInput = {
  /**
   * Whether this is a graded assessment or ungraded practice.
   * Defaults to PRACTICE if not provided.
   */
  gradingType?: AiItemGeneration_GradingType;
  /**
   * A one-sentence direction from the pedagogy model describing what the
   * generated lab should focus on. When provided, the LLM uses this to
   * tailor the exercise scenario and requirements.
   */
  recommendedFocus?: InputMaybe<Scalars['String']>;
  /**
   * An optional recommended tool/website for the generated lab. When
   * provided, the LLM is encouraged to build the exercise around it.
   * Omitting it leaves the tool choice to the generator.
   */
  recommendedTool?: InputMaybe<AiItemGeneration_RecommendedToolInput>;
  /**
   * Estimated time for the learner to complete the lab, in minutes.
   * Defaults to 15 if not provided.
   */
  timeEstimateMinutes?: Scalars['Int'];
};

/**
 * Discriminated union of materialization strategies. Exactly one field
 * must be provided.
 */
export type AiItemGeneration_MaterializationInput = {
  /**
   * Generate content without materializing an item now. The item is created
   * later via the AiItemGeneration_FinalizeGeneratedItem mutation.
   */
  deferred?: InputMaybe<AiItemGeneration_DeferredMaterializationInput>;
  /** Insert the generated item into a module at a specific position. */
  moduleItemMaterialization?: InputMaybe<AiItemGeneration_ModuleItemMaterializationInput>;
};

/** Materialize the generated item as an item inserted into a module. */
export type AiItemGeneration_ModuleItemMaterializationInput = {
  /**
   * Whether the item should be left as a draft or published immediately.
   * Defaults to DRAFT if not provided.
   */
  itemStatus?: AiItemGeneration_ItemStatus;
  /**
   * The item ID after which the new item should be inserted. If not
   * provided, the item is appended as the last item in the module.
   */
  previousItemId?: InputMaybe<Scalars['ID']>;
};

/**
 * Discriminated union of recommended tools. Exactly one field must be
 * provided. Modeled as a union so additional tool types can be added
 * later without a breaking change.
 */
export type AiItemGeneration_RecommendedToolInput = {
  /** A virtual browser tool, scoped to a specific website. */
  virtualBrowser?: InputMaybe<AiItemGeneration_VirtualBrowserToolInput>;
};

/**
 * Discriminated union of virtual browser website kinds. Exactly one field
 * must be provided. Today only a free-form custom website is supported; a
 * typed \"known website\" arm may be added later without a breaking change.
 */
export type AiItemGeneration_VirtualBrowserToolInput = {
  /** A free-form website specified by name and launch URL. */
  custom?: InputMaybe<AiItemGeneration_CustomWebsiteInput>;
};

/** ENUM for feedback types */
export const AiSuggestions_FeedbackChoice = {
  /** Grader gave dislike/thumbs down */
  Dislike: 'DISLIKE',
  /** Grader gave like/thumbs up */
  Like: 'LIKE'
} as const;

export type AiSuggestions_FeedbackChoice = typeof AiSuggestions_FeedbackChoice[keyof typeof AiSuggestions_FeedbackChoice];
/** Suggestion feedback input */
export type AiSuggestions_SaveSuggestionFeedbackInput = {
  /**
   * Feedback given to AI suggestion
   * This can be null as graders can unset their previously given feedback
   */
  feedbackChoice?: InputMaybe<AiSuggestions_FeedbackChoice>;
  /** Rubric Id */
  reviewPartId: Scalars['ID'];
  /** Suggestion Id */
  suggestionId: Scalars['ID'];
};

/** Context of where the dynamic prompts are to be shown to the learner */
export const AiTutor_ContextType = {
  /** Shows dynamic prompts in Coach Tutor Disclosure UI */
  Disclosure: 'DISCLOSURE'
} as const;

export type AiTutor_ContextType = typeof AiTutor_ContextType[keyof typeof AiTutor_ContextType];
/** Input to update the status of a dynamic prompt to completed status for a learner */
export type AiTutor_UpdateDynamicPromptStatusAsCompleteInput = {
  /** The ID of the dynamic prompt that needs to get updated with the completed status */
  id: Scalars['ID'];
};

/** Status of the AI grading of the submission */
export const Ai_Grading_Status = {
  /** Grading finished */
  Graded: 'GRADED',
  /** Grading started */
  Grading: 'GRADING',
  /** Grading is not required */
  NotRequired: 'NOT_REQUIRED',
  /** Grading didn't start yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Ai_Grading_Status = typeof Ai_Grading_Status[keyof typeof Ai_Grading_Status];
/** TODO: Complete this description */
export const ApiStatusType = {
  /** ApiStatusType shows Turnitin webhook status is configured or not. */
  Configured: 'CONFIGURED',
  /** TODO: Complete this description */
  NotConfigured: 'NOT_CONFIGURED'
} as const;

export type ApiStatusType = typeof ApiStatusType[keyof typeof ApiStatusType];
/** Status of assessment generation process */
export const AssessmentGeneration_AssessmentGenerationStatus = {
  /** Generation has been cancelled */
  Cancelled: 'CANCELLED',
  /** Generation has completed successfully */
  Completed: 'COMPLETED',
  /** Generation has failed */
  Failed: 'FAILED',
  /** Generation is currently in progress */
  InProgress: 'IN_PROGRESS',
  /** Generation has not started yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type AssessmentGeneration_AssessmentGenerationStatus = typeof AssessmentGeneration_AssessmentGenerationStatus[keyof typeof AssessmentGeneration_AssessmentGenerationStatus];
/** Assessment generation input to trigger assessment generation */
export type AssessmentGeneration_GenerateAssessmentInput = {
  /** The branch ID for the assessment generation */
  branchId: Scalars['ID'];
  /** The course ID for the assessment generation */
  courseId: Scalars['ID'];
  /** Generation parameters as structured json data */
  generationParameters: Scalars['JSON'];
};

/** Input for getting assessment generation status */
export type AssessmentGeneration_GetAssessmentGenerationStatusInput = {
  /** The generation ID to check status for */
  generationId: Scalars['ID'];
};

/** Assessment generation input to cancel assessment generation */
export type AssessmentGeneration_StopAssessmentGenerationInput = {
  /** The unique generation ID to track the assessment generation process */
  generationId: Scalars['ID'];
};

/** Assignment Generator Status */
export const AssessmentGenerator_RequestStatus = {
  /**
   * The assignment generation was cancelled by the user.
   * This can only happen during the GENERATING state.
   */
  Cancelled: 'CANCELLED',
  /** The assignment generation ended */
  Completed: 'COMPLETED',
  /** The assignment generation failed */
  Failed: 'FAILED',
  /** The question generation started */
  Generating: 'GENERATING',
  /** The question generation ended and the process started publishing the question bank */
  PublishingQuestionBank: 'PUBLISHING_QUESTION_BANK',
  /** The assignment generation request was created, but the question generation hasn't started yet */
  Started: 'STARTED',
  /** Finished publishing question bank and started updating assignment */
  UpdatingAssignment: 'UPDATING_ASSIGNMENT'
} as const;

export type AssessmentGenerator_RequestStatus = typeof AssessmentGenerator_RequestStatus[keyof typeof AssessmentGenerator_RequestStatus];
/** Input to start an assignment generation process */
export type AssessmentGenerator_StartGenerationInput = {
  /** Assignment to fill in the generation */
  assessmentId: Scalars['ID'];
  /** Parameters for the question generation request */
  questionGenerationInput: QuestionGenerator_StartGenerationInput;
  /** Number of questions learner will see in the in the assignment; default is 1 */
  questionsPerQuestionBlock?: Scalars['Int'];
};

/** Add asset video input. */
export type AssetVideo_AddAssetVideoInput = {
  /** Index (starts at 0) of image which is used as the poster image. Optional, uses first image if not present. */
  preferredPosterIndex?: InputMaybe<Scalars['Int']>;
  /**
   * Trimming ranges for this video asset across all branches it's used in. If a branch id
   * matches an existing one, the range will be replaced in the underlying map.
   */
  trimmingRangesForBranches?: InputMaybe<Array<AssetVideo_TrimmingRangesForBranchesInput>>;
  /** Video asset id. */
  videoAssetId: Scalars['ID'];
  /** Video id. */
  videoId: Scalars['ID'];
};

/** Inputs for converting an existing video into an audioDescription video asset */
export type AssetVideo_ConvertExistingVideoToAudioDescriptionVideoInput = {
  /** course that the video asset is associated with, used for permission check */
  courseId: Scalars['ID'];
  /** Language code for the audioDescription video */
  languageCode: Scalars['String'];
  /**
   * assetId of the original video asset that we would want to attach
   * the audio description video asset to
   */
  originalAssetId: Scalars['ID'];
  /** assetId of the video asset that we want to turn use as the audio description video */
  videoAssetId: Scalars['ID'];
};

/** Inputs for deleting an audioDescription video asset */
export type AssetVideo_DeleteAudioDescriptionVideoInput = {
  /** course that the video asset is associated with, used for permission check */
  courseId: Scalars['ID'];
  /** Language code for the audioDescription video we want to delete from the original video asset */
  languageCode: Scalars['String'];
  /**
   * assetId of the original video asset that we would want to delete
   * the audio description video asset from
   */
  videoAssetId: Scalars['ID'];
};

/** Set trimming range input. */
export type AssetVideo_SetTrimmingRangeForBranchInput = {
  /** The authoring course branch this trimming range applies to. */
  authoringCourseBranchId: Scalars['ID'];
  /** The ending point in ms for the trimmed video. */
  endMs: Scalars['Int'];
  /** The starting point in ms for the trimmed video. */
  startMs: Scalars['Int'];
  /** Video id. */
  videoId: Scalars['ID'];
};

/** Video trimming ranges for branches. */
export type AssetVideo_TrimmingRangesForBranchesInput = {
  /** The authoring course branch this trimming range applies to. */
  authoringCourseBranchId: Scalars['ID'];
  /** The ending point in ms for the trimmed video. */
  endMs: Scalars['Int'];
  /** The starting point in ms for the trimmed video. */
  startMs: Scalars['Int'];
};

/** Type of part */
export const AssignmentAdminTools_VerifiedSkillsAssignmentPartType = {
  /** Autograded Question type */
  Question: 'Question',
  /** Rubric type */
  Rubric: 'Rubric'
} as const;

export type AssignmentAdminTools_VerifiedSkillsAssignmentPartType = typeof AssignmentAdminTools_VerifiedSkillsAssignmentPartType[keyof typeof AssignmentAdminTools_VerifiedSkillsAssignmentPartType];
/** Apply AI grading input */
export type AssignmentAiGrading_ApplyAiGradingInput = {
  /** UserId of the AI grader */
  aiGraderId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Submission ID */
  submissionId: Scalars['ID'];
  /** Submitter ID */
  submitterId: Scalars['ID'];
  /**
   * User ID in submitter, we are using the first user in either the team or user submitter to fetch
   * the assignment presentation, so for internal use we can just pass in any UserId from the submitter
   */
  userIdInSubmitter: Scalars['ID'];
};

/** OpenAI Message Input */
export type AssignmentAi_OpenAiMessage_Input = {
  /** Content */
  content?: InputMaybe<Scalars['String']>;
  /** Role */
  role?: InputMaybe<AssignmentAi_OpenAiRole>;
};

/** OpenAI Chat Roles */
export const AssignmentAi_OpenAiRole = {
  /** ASSISTANT */
  Assistant: 'ASSISTANT',
  /** SYSTEM */
  System: 'SYSTEM',
  /** USER */
  User: 'USER'
} as const;

export type AssignmentAi_OpenAiRole = typeof AssignmentAi_OpenAiRole[keyof typeof AssignmentAi_OpenAiRole];
/** Assignment AI Utility Queries */
export type AssignmentAi_Utilities_ChatV1Input = {
  /** MaxTokensForResponse */
  maxTokensForResponse?: InputMaybe<Scalars['Int']>;
  /** Messages */
  messages: Array<AssignmentAi_OpenAiMessage_Input>;
  /** The number of chat completion responses to generate */
  n?: InputMaybe<Scalars['Int']>;
  /** Temperature */
  temperature?: InputMaybe<Scalars['Float']>;
  /** TopP */
  topP?: InputMaybe<Scalars['Float']>;
};

/** Type of feedback */
export const AssignmentCoach_FeedbackRating = {
  /** Not Useful */
  ThumbsDown: 'THUMBS_DOWN',
  /** Useful */
  ThumbsUp: 'THUMBS_UP'
} as const;

export type AssignmentCoach_FeedbackRating = typeof AssignmentCoach_FeedbackRating[keyof typeof AssignmentCoach_FeedbackRating];
/** Request for the submission of feedback */
export type AssignmentCoach_SubmitFeedbackOnSuggestionInput = {
  /** branch id */
  branchId: Scalars['ID'];
  /** Student's comment */
  comment?: InputMaybe<Scalars['String']>;
  /** feedback */
  feedbackRating: AssignmentCoach_FeedbackRating;
  /** Item id */
  itemId: Scalars['ID'];
};

/** Types of errors */
export const AssignmentMetadata_ErrorDetailsWithErrorCode = {
  /** Thrown when querying by the downstream record ID returns error */
  AssignmentMetadataIdNotFoundError: 'AssignmentMetadata_IdNotFoundError'
} as const;

export type AssignmentMetadata_ErrorDetailsWithErrorCode = typeof AssignmentMetadata_ErrorDetailsWithErrorCode[keyof typeof AssignmentMetadata_ErrorDetailsWithErrorCode];
/** TODO: Complete this description */
export const AssignmentPresentations_AllowedUrlType = {
  /** TODO: Complete this description */
  All: 'All',
  /** TODO: Complete this description */
  StandardAudio: 'StandardAudio',
  /** TODO: Complete this description */
  StandardVideo: 'StandardVideo'
} as const;

export type AssignmentPresentations_AllowedUrlType = typeof AssignmentPresentations_AllowedUrlType[keyof typeof AssignmentPresentations_AllowedUrlType];
/** TODO: Complete this description */
export const AssignmentPresentations_BaseTaskId = {
  /** TODO: Complete this description */
  AutoGradedEvaluation: 'AUTO_GRADED_EVALUATION',
  /** TODO: Complete this description */
  GitInitialization: 'GIT_INITIALIZATION',
  /** TODO: Complete this description */
  GitSubmission: 'GIT_SUBMISSION',
  /** TODO: Complete this description */
  GradeRelease: 'GRADE_RELEASE',
  /** TODO: Complete this description */
  MachineEvaluableVariantSelection: 'MACHINE_EVALUABLE_VARIANT_SELECTION',
  /** TODO: Complete this description */
  MachineEvaluationOverride: 'MACHINE_EVALUATION_OVERRIDE',
  /** TODO: Complete this description */
  PeerReview: 'PEER_REVIEW',
  /** TODO: Complete this description */
  PeerReviewAllocation: 'PEER_REVIEW_ALLOCATION',
  /** TODO: Complete this description */
  StaffEvaluation: 'STAFF_EVALUATION',
  /** TODO: Complete this description */
  SubmitterSubmission: 'SUBMITTER_SUBMISSION',
  /** TODO: Complete this description */
  SubmitterViewEvaluation: 'SUBMITTER_VIEW_EVALUATION'
} as const;

export type AssignmentPresentations_BaseTaskId = typeof AssignmentPresentations_BaseTaskId[keyof typeof AssignmentPresentations_BaseTaskId];
/** TODO: Complete this description */
export const AssignmentPresentations_ContentTypeName = {
  /** TODO: Complete this description */
  CmlContent: 'cmlContent',
  /** TODO: Complete this description */
  HtmlContent: 'htmlContent'
} as const;

export type AssignmentPresentations_ContentTypeName = typeof AssignmentPresentations_ContentTypeName[keyof typeof AssignmentPresentations_ContentTypeName];
/** Modeled after DetailLevel.courier */
export const AssignmentPresentations_DetailLevel = {
  /** All information about the question necessary for responding to it. */
  Full: 'Full',
  /** No information about the question. */
  NoDetails: 'NoDetails',
  /**
   * Enough information about the question to let the learner know what it is, but not enough
   * to respond to it. For example, `Partial` for multiple choice questions includes the prompt
   * but none of the options.
   */
  Partial: 'Partial'
} as const;

export type AssignmentPresentations_DetailLevel = typeof AssignmentPresentations_DetailLevel[keyof typeof AssignmentPresentations_DetailLevel];
/** Modeled after FeedbackLevel.courier model. */
export const AssignmentPresentations_FeedbackLevel = {
  /** All relevant instructor-specified explanations. */
  Explained: 'Explained',
  /** Feedback about correctness but nothing else. */
  Graded: 'Graded',
  /** No feedback. */
  NoFeedback: 'NoFeedback'
} as const;

export type AssignmentPresentations_FeedbackLevel = typeof AssignmentPresentations_FeedbackLevel[keyof typeof AssignmentPresentations_FeedbackLevel];
/** Modeled after the typedDefinition aliases in FormElement.courier */
export const AssignmentPresentations_FormElementCourierTypeName = {
  /** TODO: Complete this description */
  AutoGradedResponseElement: 'autoGradedResponseElement',
  /** TODO: Complete this description */
  GitRepositoryPromptElement: 'gitRepositoryPromptElement',
  /** TODO: Complete this description */
  InstructionsElement: 'instructionsElement',
  /** TODO: Complete this description */
  InstructionsWithReviewCriteriaElement: 'instructionsWithReviewCriteriaElement',
  /** TODO: Complete this description */
  PromptRequiringResponseElement: 'promptRequiringResponseElement',
  /** TODO: Complete this description */
  PromptWithMultipleResponsesElement: 'promptWithMultipleResponsesElement',
  /** TODO: Complete this description */
  PromptWithResponseElement: 'promptWithResponseElement',
  /** TODO: Complete this description */
  PromptWithoutResponseElement: 'promptWithoutResponseElement'
} as const;

export type AssignmentPresentations_FormElementCourierTypeName = typeof AssignmentPresentations_FormElementCourierTypeName[keyof typeof AssignmentPresentations_FormElementCourierTypeName];
/**
 * Used to describe the question or review to indicate the type of grader.
 * When used in the prompt, signifies the default grader type that should be used to grade said prompt.
 */
export const AssignmentPresentations_GraderType = {
  /** AI Graded */
  Ai: 'AI',
  /** Auto graded questions */
  Auto: 'AUTO',
  /** Human Graded */
  Human: 'HUMAN'
} as const;

export type AssignmentPresentations_GraderType = typeof AssignmentPresentations_GraderType[keyof typeof AssignmentPresentations_GraderType];
/** Modeled after typedDefinition alias in MachineEvaluationOverride.courier */
export const AssignmentPresentations_MachineEvaluationOverrideCourierTypeName = {
  /** Award full credit regardless the response. */
  AwardFullCredit: 'AwardFullCredit',
  /**
   * Regrade response with a provided questionId. If questions are compatible, we will evaluate with
   * new question. We accept previously correct answer if `acceptPreviouslyCorrectAnswer` is set to
   * true. If questions are incompatible, we will always use original question of evaluate.
   */
  Regrade: 'Regrade'
} as const;

export type AssignmentPresentations_MachineEvaluationOverrideCourierTypeName = typeof AssignmentPresentations_MachineEvaluationOverrideCourierTypeName[keyof typeof AssignmentPresentations_MachineEvaluationOverrideCourierTypeName];
/**
 * Modeled after @typedDefinition aliases Prompt.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_PromptTypeName = {
  /** TODO: Complete this description */
  AutoGradablePrompt: 'autoGradablePrompt',
  /** TODO: Complete this description */
  MachineEvaluablePrompt: 'machineEvaluablePrompt',
  /** TODO: Complete this description */
  ReviewPrompt: 'reviewPrompt',
  /** TODO: Complete this description */
  SubmissionPrompt: 'submissionPrompt',
  /** TODO: Complete this description */
  TitlePrompt: 'titlePrompt'
} as const;

export type AssignmentPresentations_PromptTypeName = typeof AssignmentPresentations_PromptTypeName[keyof typeof AssignmentPresentations_PromptTypeName];
/**
 * Modeled after @typedDefinition aliases Response.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_ResponseTypeName = {
  /** TODO: Complete this description */
  AutoGradableResponse: 'autoGradableResponse',
  /** TODO: Complete this description */
  MachineEvaluableResponse: 'machineEvaluableResponse',
  /** TODO: Complete this description */
  ReviewResponse: 'reviewResponse',
  /** TODO: Complete this description */
  SubmissionResponse: 'submissionResponse',
  /** TODO: Complete this description */
  TitleResponse: 'titleResponse'
} as const;

export type AssignmentPresentations_ResponseTypeName = typeof AssignmentPresentations_ResponseTypeName[keyof typeof AssignmentPresentations_ResponseTypeName];
/** Modeled after @typeDefinition aliases ReviewPartSchemaDetails.courier */
export const AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName = {
  /** Box view document annotation review schema */
  BoxViewDocumentAnnotationReviewSchema: 'boxViewDocumentAnnotationReviewSchema',
  /** Multiline input review schema */
  MultiLineInputReviewSchema: 'multiLineInputReviewSchema',
  /** Options review schema */
  OptionsReviewSchema: 'optionsReviewSchema',
  /** Single line input review schema */
  SingleLineInputReviewSchema: 'singleLineInputReviewSchema',
  /** YesNo review schema */
  YesNoReviewSchema: 'yesNoReviewSchema'
} as const;

export type AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName = typeof AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName[keyof typeof AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName];
/** Modeled after @typedDefinition aliases ReviewPart.courier */
export const AssignmentPresentations_ReviewPartTypeName = {
  /** BoxViewDocumentAnnotation review part. */
  BoxViewDocumentAnnotation: 'boxViewDocumentAnnotation',
  /** Multiline input review part. */
  MultiLineInput: 'multiLineInput',
  /** Options review part. */
  Options: 'options',
  /** SingleLine input review part. */
  SingleLineInput: 'singleLineInput',
  /** YesNo review part. */
  YesNo: 'yesNo'
} as const;

export type AssignmentPresentations_ReviewPartTypeName = typeof AssignmentPresentations_ReviewPartTypeName[keyof typeof AssignmentPresentations_ReviewPartTypeName];
/**
 * Modeled after @typedDefinition aliases SubmissionPartResponse.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_SubmissionPartResponseTypeName = {
  /** TODO: Complete this description */
  FileUploadResponse: 'fileUploadResponse',
  /** TODO: Complete this description */
  OffPlatformResponse: 'offPlatformResponse',
  /** TODO: Complete this description */
  PlainTextResponse: 'plainTextResponse',
  /** TODO: Complete this description */
  RichTextResponse: 'richTextResponse',
  /** TODO: Complete this description */
  UrlResponse: 'urlResponse'
} as const;

export type AssignmentPresentations_SubmissionPartResponseTypeName = typeof AssignmentPresentations_SubmissionPartResponseTypeName[keyof typeof AssignmentPresentations_SubmissionPartResponseTypeName];
/**
 * Modeled after @typedDefinition aliases SubmissionPartSchemaDetails.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName = {
  /** TODO: Complete this description */
  FileUploadSchema: 'fileUploadSchema',
  /** TODO: Complete this description */
  OffPlatformSchema: 'offPlatformSchema',
  /** TODO: Complete this description */
  PlainTextSchema: 'plainTextSchema',
  /** TODO: Complete this description */
  RichTextSchema: 'richTextSchema',
  /** TODO: Complete this description */
  UrlSchema: 'urlSchema'
} as const;

export type AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName = typeof AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName[keyof typeof AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName];
/** TODO: Complete this description */
export const AssignmentPresentations_SubmissionStatus = {
  /** TODO: Complete this description */
  AwaitingPeerReview: 'AWAITING_PEER_REVIEW',
  /** TODO: Complete this description */
  Deleted: 'DELETED',
  /** TODO: Complete this description */
  GradeReleased: 'GRADE_RELEASED',
  /** TODO: Complete this description */
  GradingFinished: 'GRADING_FINISHED',
  /** TODO: Complete this description */
  GradingStarted: 'GRADING_STARTED',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED',
  /** TODO: Complete this description */
  NotYetSubmitted: 'NOT_YET_SUBMITTED',
  /** TODO: Complete this description */
  ReadyForGrading: 'READY_FOR_GRADING'
} as const;

export type AssignmentPresentations_SubmissionStatus = typeof AssignmentPresentations_SubmissionStatus[keyof typeof AssignmentPresentations_SubmissionStatus];
/** Yes or No choice */
export const AssignmentPresentations_YesNoChoice = {
  /** No choice */
  No: 'No',
  /** Yes choice */
  Yes: 'Yes'
} as const;

export type AssignmentPresentations_YesNoChoice = typeof AssignmentPresentations_YesNoChoice[keyof typeof AssignmentPresentations_YesNoChoice];
/** Types of errors */
export const AssignmentPreview_ErrorDetailsWithErrorCode = {
  /** Thrown when querying by the downstream record ID returns error */
  AssignmentPreviewIdNotFoundError: 'AssignmentPreview_IdNotFoundError'
} as const;

export type AssignmentPreview_ErrorDetailsWithErrorCode = typeof AssignmentPreview_ErrorDetailsWithErrorCode[keyof typeof AssignmentPreview_ErrorDetailsWithErrorCode];
/** Assignment regrade input to register regrade configurations per item */
export type Assignment_AssignmentRegradeInput = {
  /** The course branch Id to which the item belongs */
  courseBranchId: Scalars['ID'];
  /**
   * The assignment item id to be regraded, depending on the regrade item scope, this is might not
   * be the only item to be regraded
   */
  itemId: Scalars['ID'];
  /** The regrade configuration for the assignment item applied when doing machine evaluation */
  regradeConfig: Assignment_RegradeConfigInput;
};

/**
 * Item instances of the assignment to regrade, either only the specified item instance, or all
 * linked items
 */
export const Assignment_ItemRegradeScope = {
  /** Regrade all linked items */
  ItemScopeAllLinkedItems: 'ITEM_SCOPE_ALL_LINKED_ITEMS',
  /** Regrade only the specified item instance */
  ItemScopeSingleItem: 'ITEM_SCOPE_SINGLE_ITEM'
} as const;

export type Assignment_ItemRegradeScope = typeof Assignment_ItemRegradeScope[keyof typeof Assignment_ItemRegradeScope];
/** The assignment regrade configurations */
export type Assignment_RegradeConfigInput = {
  /**
   * Assignment version scope to regrade, either only the latest version when registering the
   * regrade configuration, or specified versions
   */
  assignmentVersionScope?: InputMaybe<Array<Scalars['Int']>>;
  /** Specified group of learners to regrade, otherwise all groups/non-groups are regraded */
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Item instances of the assignment to regrade, either only the specified item instance, or all
   * linked items
   */
  itemRegradeScope: Assignment_ItemRegradeScope;
  /** Specified learnerIds to regrade, otherwise all learners are regraded */
  learnerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Specified questionIds to regrade, otherwise all questions in the assignment are regraded */
  questionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Formula for question regrade: Either full credit to questions, or true credit based on the latest
   * question definition
   */
  regradeFormula: Assignment_RegradeFormula;
  /**
   * Submissions to regrade: either only in existing/past submissions, or for all submissions
   * including future submissions
   */
  submissionRegradeScope: Assignment_SubmissionRegradeScope;
};

/**
 * Formula for question regrade: Either full credit to questions, or true credit based on the latest
 * question definition
 */
export const Assignment_RegradeFormula = {
  /** Full credit to questions */
  FullCredit: 'FULL_CREDIT',
  /** True credit based on the latest question definition */
  RegradeByLatestAssignment: 'REGRADE_BY_LATEST_ASSIGNMENT'
} as const;

export type Assignment_RegradeFormula = typeof Assignment_RegradeFormula[keyof typeof Assignment_RegradeFormula];
/**
 * Submissions to regrade: either only in existing/past submissions, or for all submissions
 * including future submissions
 */
export const Assignment_SubmissionRegradeScope = {
  /** Regrade in all submissions including future submissions */
  RegradeSubmissionScopePastAndOngoingSubmissions: 'REGRADE_SUBMISSION_SCOPE_PAST_AND_ONGOING_SUBMISSIONS',
  /** Regrade only in existing/past submissions */
  RegradeSubmissionScopePastSubmissions: 'REGRADE_SUBMISSION_SCOPE_PAST_SUBMISSIONS'
} as const;

export type Assignment_SubmissionRegradeScope = typeof Assignment_SubmissionRegradeScope[keyof typeof Assignment_SubmissionRegradeScope];
/** Atom summative content */
export type AtomSummativeContent_AtomSummativeContentInput = {
  /** atom type */
  atomType: AtomSummativeContent_AtomType;
  /** Are learning objectives manually overridden by the original author. */
  isLearningObjectiveManuallyOverridden: Scalars['Boolean'];
  /** Is summary manually overridden by the original author. */
  isSummaryManuallyOverridden: Scalars['Boolean'];
  /** Is title manually overridden by the original author. */
  isTitleManuallyOverridden: Scalars['Boolean'];
  /** Learning objectives. */
  learningObjectives: Array<Scalars['String']>;
  /** Summary */
  summary: Scalars['String'];
  /** Title. */
  title: Scalars['String'];
  /** Only set if the atom summative content is changed by the original author */
  userId?: InputMaybe<Scalars['ID']>;
  /** versioned atom id */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Atom type. */
export const AtomSummativeContent_AtomType = {
  /** A discussion prompt is a custom experience built on top of discussion forums. */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** External tool */
  LtiTool: 'LTI_TOOL',
  /** Peer review */
  PeerReview: 'PEER_REVIEW',
  /** Programming assignment allows instructors to set up autograders to grade learner submissions. Learners complete programming assignments either on their local environment or inside Coursera Labs(aka Workspaces) and then make submissions to get grades on Coursera. */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /** Staff Graded Assignments (SGA) is one assessment type that was specifically designed for degrees to allow manual grading. */
  StaffGraded: 'STAFF_GRADED',
  /** Teammate Review (TMR) is an assessment type that allows for team members to review each other. The typical use case for this item type is to allow individuals to give feedback to each other for a project that was performed in a different item type (e.g., Staff Graded Assignments) or off of the platform. */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Coursera Labs enables you to build interactive in-browser learning experiences powered by Coursera-hosted cloud environments. */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget which can be plugged in to the course items */
  Widget: 'WIDGET',
  /** WISEflow is a third-party tool we use to enhance your learning experience. */
  WiseFlow: 'WISE_FLOW'
} as const;

export type AtomSummativeContent_AtomType = typeof AtomSummativeContent_AtomType[keyof typeof AtomSummativeContent_AtomType];
/** Create atom summative content input. */
export type AtomSummativeContent_CreateAtomSummativeContentInput = {
  /** Atom summative content. */
  atomSummativeContent?: InputMaybe<AtomSummativeContent_AtomSummativeContentInput>;
};

/** Delete atom summative content input. */
export type AtomSummativeContent_DeleteAtomSummativeContentInput = {
  /** Versioned atom id. */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Find atom summative contents by branch item id. */
export type AtomSummativeContent_FindAtomSummativeContentByBranchAndItemIdInput = {
  /** Course branch id. */
  branchId: Scalars['ID'];
  /** Item id */
  itemId: Scalars['ID'];
};

/** Find atom summative contents by atom id. */
export type AtomSummativeContent_FindAtomSummativeContentsByAtomIdInput = {
  /** Atom id. */
  atomId: Scalars['ID'];
};

/** Find atom summative contents by course branch id and atom type. */
export type AtomSummativeContent_FindAtomSummativeContentsByCourseBranchIdAndAtomTypeInput = {
  /** Atom type. */
  atomType: AtomSummativeContent_AtomType;
  /** The learner side course branch id */
  courseBranchId: Scalars['ID'];
};

/** Get atom summative content input. */
export type AtomSummativeContent_GetAtomSummativeContentInput = {
  /** Versioned atom id. */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Get course outline summary as an export file, using course id and course branch id */
export type AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdInput = {
  /** Course branch Id */
  courseBranchId: Scalars['ID'];
  /** Course Id */
  courseId: Scalars['ID'];
};

/** Multi-get atom summative contents input. */
export type AtomSummativeContent_MultiGetAtomSummativeContentsInput = {
  /** Versioned atom ids. */
  versionedAtomIds: Array<AtomSummativeContent_VersionedAtomIdInput>;
};

/** Update atom summative content input. */
export type AtomSummativeContent_UpdateAtomSummativeContentInput = {
  /** Atom summative content. */
  atomSummativeContent?: InputMaybe<AtomSummativeContent_AtomSummativeContentInput>;
};

/** Versioned atom id input */
export type AtomSummativeContent_VersionedAtomIdInput = {
  /** Atom id */
  atomId: Scalars['ID'];
  /** Atom version. The atom version can only be empty in the get/ multi-get atom summative contents input */
  version?: InputMaybe<Scalars['Int']>;
};

/**
 * AttemptStatus NOT_STARTED - indicates the learner has not started the attempt, IN_PROGRESS - the attempt is in progress and learner
 * is allowed to make submissions, COMPLETED - the attempt is completed or closed because either they ran out of submissions or time, and
 * at this time learner cannot make submissions.
 */
export const AttemptStatus = {
  /** TODO: Complete this description */
  Completed: 'COMPLETED',
  /** TODO: Complete this description */
  InProgress: 'IN_PROGRESS',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED'
} as const;

export type AttemptStatus = typeof AttemptStatus[keyof typeof AttemptStatus];
/** Asset Creation Atom Context Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationAtomContextInput = {
  /** The authoringAtomId of the attempt */
  authoringAtomId: Scalars['ID'];
};

/** Asset Creation Context Union Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationContextUnionInput = {
  /** Asset Creation Atom Context */
  assetCreationAtomContext?: InputMaybe<AuthoringAssetCreationAttempts_AssetCreationAtomContextInput>;
  /** Asset Creation Course Context */
  assetCreationCourseContext?: InputMaybe<AuthoringAssetCreationAttempts_AssetCreationCourseContextInput>;
};

/** Asset Creation Course Context Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationCourseContextInput = {
  /** The courseId of the attempt */
  courseId: Scalars['ID'];
};

/** Asset Tag input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetTagInput = {
  /** Name of the asset tag */
  name: Scalars['String'];
  /** Value of the asset tag */
  value: Scalars['String'];
};

/** Asset Type enum GraphQL schema */
export const AuthoringAssetCreationAttempts_AssetType = {
  /** Asset of type: Audio */
  AssetTypeAudio: 'ASSET_TYPE_AUDIO',
  /** Asset of type: Generic */
  AssetTypeGeneric: 'ASSET_TYPE_GENERIC',
  /** Asset of type: Image */
  AssetTypeImage: 'ASSET_TYPE_IMAGE',
  /** Invalid asset type */
  AssetTypeInvalid: 'ASSET_TYPE_INVALID',
  /** Asset of type: Pdf */
  AssetTypePdf: 'ASSET_TYPE_PDF',
  /** Asset of type: Subtitle */
  AssetTypeSubtitle: 'ASSET_TYPE_SUBTITLE',
  /** Asset of type: Video */
  AssetTypeVideo: 'ASSET_TYPE_VIDEO'
} as const;

export type AuthoringAssetCreationAttempts_AssetType = typeof AuthoringAssetCreationAttempts_AssetType[keyof typeof AuthoringAssetCreationAttempts_AssetType];
/** Asset Type Audio With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeAudioWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_AUDIO
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Generic With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeGenericWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_GENERIC
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Image With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeImageWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_IMAGE
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Invalid With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeInvalidWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_INVALID
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Pdf With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypePdfWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_PDF
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** Pdf template of the asset to be created */
  pdfTemplate: AuthoringAssetCreationAttempts_PdfTemplate;
};

/** Asset Type Subtitle With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeSubtitleWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_SUBTITLE
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** language of the asset to be created */
  language: Scalars['String'];
};

/** Asset Type Video With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeVideoWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_VIDEO
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** videoId of the asset to be created */
  videoId: Scalars['ID'];
  /** Video template of the asset to be created */
  videoTemplate: AuthoringAssetCreationAttempts_VideoTemplate;
};

/** Asset Type With Related Data Union Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetTypeWithRelatedDataUnionInput = {
  /** Asset Type Audio With Related Data */
  assetTypeAudioWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeAudioWithRelatedDataInput>;
  /** Asset Type Generic With Related Data */
  assetTypeGenericWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeGenericWithRelatedDataInput>;
  /** Asset Type Image With Related Data */
  assetTypeImageWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeImageWithRelatedDataInput>;
  /** Asset Type Invalid With Related Data */
  assetTypeInvalidWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeInvalidWithRelatedDataInput>;
  /** Asset Type Pdf With Related Data */
  assetTypePdfWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypePdfWithRelatedDataInput>;
  /** Asset Type Subtitle With Related Data */
  assetTypeSubtitleWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeSubtitleWithRelatedDataInput>;
  /** Asset Type Video With Related Data */
  assetTypeVideoWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeVideoWithRelatedDataInput>;
};

/** Create Input GraphQL schema */
export type AuthoringAssetCreationAttempts_CreateInput = {
  /** Creation context of the asset */
  assetCreationContext: AuthoringAssetCreationAttempts_AssetCreationContextUnionInput;
  /** Tags of the asset to be created */
  assetTags: Array<AuthoringAssetCreationAttempts_AssetTagInput>;
  /** Type of the asset to be created */
  assetTypeWithRelatedData: AuthoringAssetCreationAttempts_AssetTypeWithRelatedDataUnionInput;
  /** creatorId (userId) of the asset to be created */
  creatorId?: InputMaybe<Scalars['Int']>;
  /** Name of the asset to be created */
  name?: InputMaybe<Scalars['String']>;
};

/** Pdf Template enum GraphQL schema */
export const AuthoringAssetCreationAttempts_PdfTemplate = {
  /** Invalid pdf template */
  PdfTemplateInvalid: 'PDF_TEMPLATE_INVALID',
  /** Pdf template of type: Slides */
  PdfTemplateSlides: 'PDF_TEMPLATE_SLIDES'
} as const;

export type AuthoringAssetCreationAttempts_PdfTemplate = typeof AuthoringAssetCreationAttempts_PdfTemplate[keyof typeof AuthoringAssetCreationAttempts_PdfTemplate];
/** Video template GraphQL schema */
export const AuthoringAssetCreationAttempts_VideoTemplate = {
  /** Video template of type: Full Video */
  VideoTemplateFullVideo: 'VIDEO_TEMPLATE_FULL_VIDEO',
  /** Video template of type: Full Video Two */
  VideoTemplateFullVideoTwo: 'VIDEO_TEMPLATE_FULL_VIDEO_TWO',
  /** Invalid video template */
  VideoTemplateInvalid: 'VIDEO_TEMPLATE_INVALID',
  /** Video template of type: Lite Video */
  VideoTemplateLiteVideo: 'VIDEO_TEMPLATE_LITE_VIDEO'
} as const;

export type AuthoringAssetCreationAttempts_VideoTemplate = typeof AuthoringAssetCreationAttempts_VideoTemplate[keyof typeof AuthoringAssetCreationAttempts_VideoTemplate];
export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = {
  Ai: 'AI',
  Auto: 'AUTO',
  Human: 'HUMAN'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType];
export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState = {
  AccessGranted: 'ACCESS_GRANTED',
  AtomVersionNotAtLatest: 'ATOM_VERSION_NOT_AT_LATEST',
  InsufficientPermissions: 'INSUFFICIENT_PERMISSIONS'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState];
export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus = {
  BadReference: 'BAD_REFERENCE',
  Dtd: 'DTD',
  Duplicate: 'DUPLICATE',
  Empty: 'EMPTY',
  Enum: 'ENUM',
  Format: 'FORMAT',
  Locked: 'LOCKED',
  NonEmpty: 'NON_EMPTY',
  Other: 'OTHER',
  Overlap: 'OVERLAP',
  TooLarge: 'TOO_LARGE',
  TooLong: 'TOO_LONG',
  TooShort: 'TOO_SHORT',
  TooSmall: 'TOO_SMALL',
  Valid: 'VALID'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus];
/**
 * Input type @authorization directive.
 * Any @authorization directive usage must specify at least one AuthorizationKey.
 */
export type AuthorizationKey = {
  /**
   * The list of additional inputs required by the authorization implementation for the
   * corresponding authorization key.
   *
   * The elements of this list are JSON path styled strings that point to the input field(s)
   * of the decorated GraphQL field, or their nested field(s).
   *
   * The length of this list must match the expected number of additional inputs defined in the
   * graphql-configurations.yaml file for the corresponding authorization key.
   *
   * The order of the elements are important, please make sure they are provided in the exact
   * order that the authorizer implementation would expect.
   *
   * Examples:
   * - ["courseId"]
   * - ["courseId", "userId"]
   * - ["queryInput.userId"]
   */
  inputPaths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The key of the authorization in string format.
   * All authorization keys must be defined properly in the graphql-configurations.yaml file,
   * with a brief description and the expected number of additional inputs.
   *
   * The key follows a hierarchical structure, separated by dots.
   * Examples:
   * - 'core.loggedIn'
   * - 'core.courserian'
   */
  key: Scalars['String'];
};

/** Metric type. */
export const Autograder_MetricType = {
  /** Number of Attempts */
  Attempts: 'ATTEMPTS',
  /** Memory usage in MB. */
  MemoryUsage: 'MEMORY_USAGE',
  /** Performance/runtime in milliseconds. */
  Performance: 'PERFORMANCE',
  /** The score (aka grade) of the submission in percent (rounded to 2 decimal places). */
  Score: 'SCORE'
} as const;

export type Autograder_MetricType = typeof Autograder_MetricType[keyof typeof Autograder_MetricType];
/** Status of a test case evaluation will always either be PASS, FAIL, or SKIP */
export const Autograder_TestCaseEvaluationStatus = {
  /** Test case errored out */
  Error: 'ERROR',
  /** Test case failed */
  Fail: 'FAIL',
  /** Test case passed */
  Pass: 'PASS',
  /** Test case skipped */
  Skip: 'SKIP'
} as const;

export type Autograder_TestCaseEvaluationStatus = typeof Autograder_TestCaseEvaluationStatus[keyof typeof Autograder_TestCaseEvaluationStatus];
/** Input for badge name style customization */
export type Badge_BadgeNameStyle = {
  /** Badge Name Font Color */
  fontColor?: InputMaybe<Scalars['String']>;
  /** Badge Name Font Size */
  fontSize?: Scalars['Int'];
  /** Badge Name Font Style */
  fontStyle?: InputMaybe<Badge_StringFontStyle>;
};

/** Enum that defines where the badge was initially created. */
export const Badge_BadgeSource = {
  /** COURSERA */
  Coursera: 'COURSERA',
  /** CREDLY */
  Credly: 'CREDLY'
} as const;

export type Badge_BadgeSource = typeof Badge_BadgeSource[keyof typeof Badge_BadgeSource];
/** Input for creating or updating one or more Credly badge template mappings. */
export type Badge_CreateOrUpdateCredlyBadgeTemplateMappingInput = {
  /** One or more mappings to create or update. */
  mappings: Array<Badge_CredlyBadgeTemplateMappingInput>;
};

/** A single product-to-badge-template mapping entry. */
export type Badge_CredlyBadgeTemplateMappingInput = {
  /** The Credly badge template ID to associate with this product. */
  badgeTemplateId: Scalars['ID'];
  /** The product ID (e.g., course ID or specialization ID). */
  productId: Scalars['ID'];
};

/** Input for deleting a Credly badge template mapping. */
export type Badge_DeleteCredlyBadgeTemplateMappingInput = {
  /** The product ID of the mapping to delete. */
  productId: Scalars['ID'];
};

/** Enum that defines all supported badge issuer type. */
export const Badge_IssuerType = {
  /** ENTERPRISE_ORG */
  EnterpriseOrg: 'ENTERPRISE_ORG'
} as const;

export type Badge_IssuerType = typeof Badge_IssuerType[keyof typeof Badge_IssuerType];
/** Input for Open Badge image creation */
export type Badge_OpenBadgeImageGenerationInput = {
  /** Issued Badge ID */
  issuedBadgeId: Scalars['ID'];
  /** Open Badge Version */
  openBadgeVersion: Badge_OpenBadgeVersion;
};

/** Enum that defines all supported Open Badges version. */
export const Badge_OpenBadgeVersion = {
  /** Open badge version 2.0 */
  V2_0: 'V2_0',
  /** Open badge version 3.0 */
  V3_0: 'V3_0'
} as const;

export type Badge_OpenBadgeVersion = typeof Badge_OpenBadgeVersion[keyof typeof Badge_OpenBadgeVersion];
/** Input for badge creation */
export type Badge_PreviewGeneratorInput = {
  /** Badge logo image URL */
  badgeImage?: InputMaybe<Scalars['URL']>;
  /** Badge logo height */
  badgeLogoHeight?: Scalars['Int'];
  /** Badge name */
  badgeName: Scalars['String'];
  /** Badge Name Style */
  badgeNameStyle?: InputMaybe<Badge_BadgeNameStyle>;
  /** Program ID */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Enum for badge sources */
export const Badge_Source = {
  /** A badge created internally on Coursera */
  Coursera: 'COURSERA',
  /** A badge created externally on Credly */
  Credly: 'CREDLY'
} as const;

export type Badge_Source = typeof Badge_Source[keyof typeof Badge_Source];
/** Badge font Enum */
export const Badge_StringFontStyle = {
  /** Italic */
  Italic: 'ITALIC',
  /** Normal */
  Normal: 'NORMAL'
} as const;

export type Badge_StringFontStyle = typeof Badge_StringFontStyle[keyof typeof Badge_StringFontStyle];
/** Enum that defines all possible user states for a badge */
export const Badge_UserState = {
  /** ENROLLED */
  Enrolled: 'ENROLLED',
  /** ISSUED */
  Issued: 'ISSUED',
  /** NEVER ENROLLED */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** UNENROLLED */
  Unenrolled: 'UNENROLLED'
} as const;

export type Badge_UserState = typeof Badge_UserState[keyof typeof Badge_UserState];
/** The places where a banner ad can be displayed are called placements. */
export const BannerAdCampaign_Placement = {
  /** Articles */
  Article: 'ARTICLE',
  /** Browse domain pages */
  BrowseDomain: 'BROWSE_DOMAIN',
  /** TODO: Complete this description */
  BrowseHome: 'BROWSE_HOME',
  /** Browse subdomain pages */
  BrowseSubdomain: 'BROWSE_SUBDOMAIN',
  /** TODO: Complete this description */
  LoggedInDashboard: 'LOGGED_IN_DASHBOARD',
  /** Menu expandable from page header */
  Megamenu: 'MEGAMENU',
  /** Weekly recommendations email */
  WeeklyRecsEmail: 'WEEKLY_RECS_EMAIL'
} as const;

export type BannerAdCampaign_Placement = typeof BannerAdCampaign_Placement[keyof typeof BannerAdCampaign_Placement];
/** Input for BetaTestingSchedule_Delete mutation. */
export type BetaTestingSchedule_DeleteInput = {
  /** Id of the course for which to delete its beta testing schedule. */
  courseId: Scalars['ID'];
};

/** Input for BetaTestingSchedule_Update Mutation. */
export type BetaTestingSchedule_UpdateInput = {
  /** Id of the course to be updated \ added. */
  courseId: Scalars['ID'];
  /** Group Id of the beta testing. */
  groupId?: InputMaybe<Scalars['ID']>;
  /** The time of when the beta testing started. */
  startedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Enum of the supported Box widget RPC action types */
export const Box_WidgetRpcActionType = {
  /** Get scoped activity summary data for the user */
  GetActivitySummaries: 'GET_ACTIVITY_SUMMARIES',
  /** Get authorization data for specific APIs that the widget needs to communicate with */
  GetExternalApiAuthorizations: 'GET_EXTERNAL_API_AUTHORIZATIONS',
  /** Load current session's configuration data */
  GetSessionConfiguration: 'GET_SESSION_CONFIGURATION',
  /** Retrieve storedValues from our BE */
  GetStoredValues: 'GET_STORED_VALUES',
  /** Read specific, session-configured data keys from Nostos */
  ReadCustomQueryResults: 'READ_CUSTOM_QUERY_RESULTS',
  /** Set the answer for a graded widget */
  SetAnswer: 'SET_ANSWER',
  /** Set the containing item as complete */
  SetComplete: 'SET_COMPLETE',
  /** Set the height of the widget */
  SetHeight: 'SET_HEIGHT',
  /** Save storedValues to our BE for persistence */
  SetStoredValues: 'SET_STORED_VALUES'
} as const;

export type Box_WidgetRpcActionType = typeof Box_WidgetRpcActionType[keyof typeof Box_WidgetRpcActionType];
/** Conflict metadata for a given branch used to determine if conflicting edits have been made */
export type BranchItem_AuthoringCourseBranchConflictMetadataInput = {
  /** Learner course branch version */
  courseBranchVersion: Scalars['Int'];
  /** Authoring course branch version */
  version: Scalars['Int'];
};

/** Represents the location of an item in a given branch's course material */
export type BranchItem_AuthoringCourseMaterialItemScopeInput = {
  /** Authoring branch id */
  authoringCourseBranchId: Scalars['ID'];
  /**
   * Optional item id. If provided, indicates the specific item to be operated on within the lesson, but can be left null
   * when creating a brand new item.
   */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson id */
  lessonId: Scalars['ID'];
  /** Module id */
  moduleId: Scalars['ID'];
};

/** Input for the BranchItem_CreateBranchItem mutation */
export type BranchItem_CreateBranchItemInput = {
  /** The location of the item to be created */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: InputMaybe<Scalars['String']>;
  /** Indicates whether the created atom was manually created by a user, or generated with AI assistance */
  generationSource?: ItemPlatform_AtomGenerationSource;
  /** Optional flag to determine if the created atom is graded */
  isGraded?: InputMaybe<Scalars['Boolean']>;
  /**
   * The item type for the atom to be created.
   *
   * We use a String instead of the ItemPlatform_ItemType enum to allow new item types to be added to the enum without
   * requiring coordinated deploys across all services that import graphql-shared-itemplatform.
   * By ensuring the enum is only used in return types and not in inputs, Federation will use the Union composition
   * strategy instead of requiring the enum definition to be exactly the same across all subgraphs where it is used:
   * https://www.apollographql.com/docs/federation/federated-types/composition/#enums.
   */
  itemType: Scalars['String'];
};

/** Input for BranchItem_DuplicateBranchItem mutation */
export type BranchItem_DuplicateBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
};

/** Input for BranchItem_ForkBranchItem mutation */
export type BranchItem_ForkBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
  /** The source authoring course branch id for change log reporting */
  sourceAuthoringCourseBranchId: Scalars['ID'];
};

/** Input for the BranchItem_PublishBranchItem mutation */
export type BranchItem_PublishBranchItemInput = {
  /** Id of the atom to publish */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /**
   * Optional limit on which branches to publish to. If specified, only branches mapping to the
   * supplied branch ids will be published to and all other instances of the atom will be frozen.
   */
  publishLimit?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for BranchItem_ShareBranchItem mutation */
export type BranchItem_ShareBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
  /** The source authoring course branch id for change log reporting */
  sourceAuthoringCourseBranchId: Scalars['ID'];
};

/** The destination for an item to be unfrozen */
export type BranchItem_UnfreezeBranchItemDestination = {
  /** The authoring course branch id for the item to be unfrozen */
  authoringCourseBranchId: Scalars['ID'];
  /** The item id for item to be unfrozen */
  itemId: Scalars['ID'];
};

/** Input for BranchItem_UnfreezeBranchItem mutation */
export type BranchItem_UnfreezeBranchItemInput = {
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Destination of the item to be unfrozen */
  destination: BranchItem_UnfreezeBranchItemDestination;
};

/** Input for the BranchItem_UnlinkBranchItem mutation */
export type BranchItem_UnlinkBranchItemInput = {
  /** Id of the atom to unlink */
  atomId: Scalars['ID'];
  /** Conflict metadata for the target branch used to determine if conflicting edits have been made */
  authoringCourseBranchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** The location of the item to unlink in the target branch's course material */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
};

/** Whether the optional Group column had values in the import CSV. */
export const BulkProgramInvitations_GroupColumnState = {
  /** Column missing, or no row specified a group */
  Absent: 'ABSENT',
  /** Every row specified a group */
  AllRows: 'ALL_ROWS',
  /** Some rows have a group, others don't */
  Partial: 'PARTIAL'
} as const;

export type BulkProgramInvitations_GroupColumnState = typeof BulkProgramInvitations_GroupColumnState[keyof typeof BulkProgramInvitations_GroupColumnState];
/** Billing cycle options. */
export const BusinessCaseProposal_BillingCycle = {
  /** Single annual installment. */
  Annual: 'ANNUAL',
  /** Four quarterly installments. */
  Quarterly: 'QUARTERLY'
} as const;

export type BusinessCaseProposal_BillingCycle = typeof BusinessCaseProposal_BillingCycle[keyof typeof BusinessCaseProposal_BillingCycle];
/** Why an async download request reached the FAILED state. */
export const BusinessCaseProposal_DownloadErrorReason = {
  /** An unclassified failure occurred; service logs hold the cause. */
  InternalError: 'INTERNAL_ERROR',
  /** The render pipeline (Lambda invoke / S3 upload / presign) threw an exception. */
  RenderFailed: 'RENDER_FAILED'
} as const;

export type BusinessCaseProposal_DownloadErrorReason = typeof BusinessCaseProposal_DownloadErrorReason[keyof typeof BusinessCaseProposal_DownloadErrorReason];
/** Lifecycle states of an async download request. */
export const BusinessCaseProposal_DownloadStatusEnum = {
  /**
   * Render or upload failed; `errorReason` is populated and the client must resubmit the
   * original `BusinessCaseProposal_RequestDownload` mutation.
   */
  Failed: 'FAILED',
  /** Render+upload is queued or executing; poll again shortly. */
  InProgress: 'IN_PROGRESS',
  /** The supplied `requestId` is unknown */
  NotFound: 'NOT_FOUND',
  /** Render succeeded; `downloadUrl` is populated and valid until `expiresAt`. */
  Ready: 'READY'
} as const;

export type BusinessCaseProposal_DownloadStatusEnum = typeof BusinessCaseProposal_DownloadStatusEnum[keyof typeof BusinessCaseProposal_DownloadStatusEnum];
/** The form state captured by the business-case builder on the business homepage. */
export type BusinessCaseProposal_Input = {
  /** Billing cycle for the contract. */
  billingCycle: BusinessCaseProposal_BillingCycle;
  /** Optional enterprise promotion ID to apply to the price. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional industry of the prospect's organization. When omitted, the "Organizations similar
   * to yours" section is hidden from the rendered PDF.
   */
  industry?: InputMaybe<Scalars['String']>;
  /** Number of learner licenses requested. */
  learnerCount: Scalars['Int'];
  /** Up to 3 learning priorities, used to seed catalog recommendations in the PDF. */
  learningPriorities: Array<Scalars['String']>;
  /** Optional BCP-47 locale tag for the rendered PDF and email body. Defaults to "en-US". */
  locale?: InputMaybe<Scalars['String']>;
  /**
   * Pricing model to apply for the contract. Defaults to STANDARD pricing where annual and
   * quarterly have the same effective annual rate.
   */
  pricingModel?: InputMaybe<EnterpriseContractPrice_PricingModel>;
  /**
   * Optional primary business goal driving the request. When omitted, the "Goal supported"
   * section is hidden from the rendered PDF.
   */
  primaryGoal?: InputMaybe<Scalars['String']>;
};

/** Input for `BusinessCaseProposal_RequestDownload`. */
export type BusinessCaseProposal_RequestDownloadInput = {
  /** Proposal configuration mirroring the business-case builder inputs */
  proposal: BusinessCaseProposal_Input;
};

/** Input for sending the business-case proposal PDF via email. */
export type BusinessCaseProposal_SendEmailInput = {
  /** Recipient business email address. */
  email: Scalars['String'];
  /** Proposal configuration mirroring the business-homepage builder inputs. */
  proposal: BusinessCaseProposal_Input;
};

/** Input type for archiving a campaign */
export type CampaignManagement_ArchiveCampaignInput = {
  /** The ID of the campaign to be deleted */
  id: Scalars['ID'];
};

/** The baseline template variable configuration */
export type CampaignManagement_BasicTemplatingConfigurationInput = {
  /** THe key value pairs of the variable input. */
  keyValuePairs: Array<CampaignManagement_BasicTemplatingKeyValuePairInput>;
};

/** Key value pair input for baseling templating data. */
export type CampaignManagement_BasicTemplatingKeyValuePairInput = {
  /** The value of the variable key value pair */
  value: Scalars['String'];
  /** THe key of the key value pair */
  variableName: Scalars['String'];
};

/** Supported Campaign Status Types */
export const CampaignManagement_CampaignStatus = {
  /** Archived */
  Archived: 'ARCHIVED',
  /** Completed */
  Completed: 'COMPLETED',
  /** Draft */
  Draft: 'DRAFT',
  /** Running */
  Running: 'RUNNING',
  /** Upcoming */
  Upcoming: 'UPCOMING'
} as const;

export type CampaignManagement_CampaignStatus = typeof CampaignManagement_CampaignStatus[keyof typeof CampaignManagement_CampaignStatus];
/** Countdown configuration input for templating. */
export type CampaignManagement_CountdownTemplatingConfigurationInput = {
  /** Days before campaign end date to start countdown */
  countdownStart: Scalars['Int'];
};

/** Input type for creating a new campaign */
export type CampaignManagement_CreateCampaignInput = {
  /** New Campaign's Contentful Entry ID */
  contentfulEntryId: Scalars['ID'];
  /** New Campaign's ending time */
  endTime: Scalars['DateTime'];
  /**
   * New Campaign's epic experiment type
   * @deprecated Use new experimentType field.
   */
  epicExperimentType?: InputMaybe<CampaignManagement_EpicExperimentType>;
  /** New Campaign's experiment type (nullable while migrating off epicExperimentType) */
  experimentType?: InputMaybe<CampaignManagement_ExperimentType>;
  /** New Campaign's name */
  name: Scalars['String'];
  /** New Campaign's starting time */
  startTime: Scalars['DateTime'];
  /** New Campaign's targeting strategy configuration */
  targetingStrategy?: InputMaybe<CampaignManagement_TargetingStrategyInput>;
  /** New Campaign's templating details */
  templatingConfigurations?: Array<CampaignManagement_TemplatingConfigurationInput>;
};

/** Input type for deleting a campaign */
export type CampaignManagement_DeleteCampaignInput = {
  /** The ID of the campaign to be deleted */
  id: Scalars['ID'];
};

/** Input for end campaign operation */
export type CampaignManagement_EndCampaignInput = {
  /** The ID of the campaign to be ended */
  id: Scalars['ID'];
};

/** Supported epic experiment types */
export const CampaignManagement_EpicExperimentType = {
  /** A/B Epic Experiment Type */
  Ab: 'AB',
  /** Rollout Epic Experiment Type */
  Rollout: 'ROLLOUT'
} as const;

export type CampaignManagement_EpicExperimentType = typeof CampaignManagement_EpicExperimentType[keyof typeof CampaignManagement_EpicExperimentType];
/** Supported experiment types */
export const CampaignManagement_ExperimentType = {
  /** A/B Epic Experiment Type */
  Ab: 'AB',
  /** Rollout Experiment Type */
  Rollout: 'ROLLOUT'
} as const;

export type CampaignManagement_ExperimentType = typeof CampaignManagement_ExperimentType[keyof typeof CampaignManagement_ExperimentType];
/** The JustWords template variable configuration */
export type CampaignManagement_JustWordsTemplatingConfigurationInput = {
  /** THe string representing the justwords template id. */
  templateId: Scalars['ID'];
};

/** Input for marking campaign ready for launch */
export type CampaignManagement_MarkCampaignReadyForLaunchInput = {
  /** The ID of the campaign to be marked ready for launch */
  id: Scalars['ID'];
};

/** Input type for patching a campaign. Use null as the field value when no update required for it. */
export type CampaignManagement_PatchCampaignInput = {
  /**
   * Enable or disable the campaign to toggle it from being eligible to be served via the Campaign Modules API
   * @deprecated This flag will be enabled/disabled via new queries that will be added soon.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Campaign's new ending time. Use null for no update. Use null as the value when no update required. */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the campaign to be patched */
  id: Scalars['ID'];
  /** Campaign's new starting time. Use null as the value when no update required. */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** New Campaign's targeting strategy configuration */
  targetingStrategy?: InputMaybe<CampaignManagement_TargetingStrategyInput>;
  /** Campaign's new templating variables */
  templatingConfigurations?: InputMaybe<Array<CampaignManagement_TemplatingConfigurationInput>>;
};

/** Targeting strategy input type */
export type CampaignManagement_TargetingStrategyInput = {
  /** Key/value pairs used to configure the targeting strategy */
  parameters?: InputMaybe<Scalars['JSON']>;
  /** Targeting Strategy Type */
  type: CampaignManagement_TargetingStrategyType;
};

/** Supported Targeting Strategy Types */
export const CampaignManagement_TargetingStrategyType = {
  /** All Learners */
  AllLearners: 'ALL_LEARNERS',
  /** Amplitude Cohort */
  AmplitudeCohort: 'AMPLITUDE_COHORT',
  /** Course Plus Eligible */
  CourseraPlusEligible: 'COURSERA_PLUS_ELIGIBLE',
  /** Logged In */
  LoggedIn: 'LOGGED_IN',
  /** Logged Out */
  LoggedOut: 'LOGGED_OUT'
} as const;

export type CampaignManagement_TargetingStrategyType = typeof CampaignManagement_TargetingStrategyType[keyof typeof CampaignManagement_TargetingStrategyType];
/** Input for template variables */
export type CampaignManagement_TemplatingConfigurationInput = {
  /** Basic templating input. */
  basicTemplatingConfigurationInput?: InputMaybe<CampaignManagement_BasicTemplatingConfigurationInput>;
  /** Countdown templating input */
  countdownTemplatingInput?: InputMaybe<CampaignManagement_CountdownTemplatingConfigurationInput>;
  /** JustWords templating input. */
  justWordsTemplatingConfigurationInput?: InputMaybe<CampaignManagement_JustWordsTemplatingConfigurationInput>;
};

/** An input type for variables related to Campaign Modules. */
export type Campaign_CampaignModulesInputVariables = {
  /** A specific campaign ID that should be used no matter what the default behavior would be. */
  forceUseCampaignId?: InputMaybe<Scalars['ID']>;
  /** A boolean flag to indicate whether Contentful is on preview mode. */
  useContentfulPreview?: InputMaybe<Scalars['Boolean']>;
};

/** The variants of a campaign experiment. */
export const Campaign_ExperimentVariant = {
  /** The B variant. */
  B: 'B',
  /** The C variant. */
  C: 'C',
  /** The control variant. */
  Control: 'CONTROL'
} as const;

export type Campaign_ExperimentVariant = typeof Campaign_ExperimentVariant[keyof typeof Campaign_ExperimentVariant];
/** An enum of all just words events that are supported. */
export const Campaign_JustWordsEventType = {
  /** A click event */
  Click: 'CLICK',
  /** An impression event */
  Impression: 'IMPRESSION'
} as const;

export type Campaign_JustWordsEventType = typeof Campaign_JustWordsEventType[keyof typeof Campaign_JustWordsEventType];
/** Input for a justwords templating event */
export type Campaign_JustWordsTemplatingEventInput = {
  /** The type of event to send */
  eventType?: InputMaybe<Campaign_JustWordsEventType>;
  /** The tracking id for the justwords template */
  trackingId: Scalars['ID'];
};

/** Parameters to override the default campaign matching and rendering behavior. */
export type Campaign_Overrides = {
  /** A specific campaign ID that should be used no matter what the default behavior would be. */
  campaignId?: InputMaybe<Scalars['ID']>;
  /** A boolean flag to indicate whether Contentful is on preview mode. */
  contentfulPreview?: InputMaybe<Scalars['Boolean']>;
  /** Country code to use when matching the campaign. Follows ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The time to use as the present when matching the campaign. */
  currentTime?: InputMaybe<Scalars['DateTime']>;
  /** Locale to use for fetching the contentful content. */
  locale?: InputMaybe<Scalars['String']>;
  /** The user ID to use when matching the campaign. */
  userId?: InputMaybe<Scalars['Int']>;
  /** The experiment variant to force for the campaign. */
  variant?: InputMaybe<Campaign_ExperimentVariant>;
};

/** Product type of the slug passed in. */
export const Campaign_ProductType = {
  /** Course */
  Course: 'COURSE',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type Campaign_ProductType = typeof Campaign_ProductType[keyof typeof Campaign_ProductType];
/** Generic input type for events */
export type Campaign_RecordEventInput = {
  /** JustWords eventing input. */
  justWordsTemplatingEvent?: InputMaybe<Campaign_JustWordsTemplatingEventInput>;
};

/** Input for adding contents to an existing role. */
export type CareerAcademy_AddContentsToRoleInput = {
  /** IDs of the product to be added to the role. */
  id: Array<CareerAcademy_ProductId>;
  /** ID of the role */
  roleId: Scalars['ID'];
  /**
   * Variants of the role to which content is being added
   * Content can be added:
   * * To GROW_WITH_GOOGLE only, it's not allowed to add content to other variants in this case
   * * To all variants except GROW_WITH_GOOGLE
   */
  variants: Array<CareerAcademy_Variant>;
};

/** Input for adding a role */
export type CareerAcademy_AddRoleInput = {
  /** Category ID of the role */
  categoryId: Scalars['ID'];
  /** Display name of role */
  name: Scalars['String'];
  /** Slug of role */
  slug: Scalars['String'];
};

/** Entity representing types of Content. */
export const CareerAcademy_ContentType = {
  /** Content is a Guided Project. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Content is a Portfolio Project */
  PortfolioProject: 'PORTFOLIO_PROJECT',
  /** Content is a Professional Certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE'
} as const;

export type CareerAcademy_ContentType = typeof CareerAcademy_ContentType[keyof typeof CareerAcademy_ContentType];
/** Input for deleting a role */
export type CareerAcademy_DeleteRoleInput = {
  /** Slug of the role */
  slug: Scalars['String'];
};

/** Input representing id of the product */
export type CareerAcademy_ProductId = {
  /** ID of the product */
  id: Scalars['ID'];
  /** Type of the product */
  type: CareerAcademy_ProductType;
};

/** Entity representing types of Product. */
export const CareerAcademy_ProductType = {
  /** Course product. It can either be a normal course, guided project, or portfolio project. */
  Course: 'COURSE',
  /** Specialization product. It can be either a specialization or a professional certificate. */
  Specialization: 'SPECIALIZATION'
} as const;

export type CareerAcademy_ProductType = typeof CareerAcademy_ProductType[keyof typeof CareerAcademy_ProductType];
/** input object of mutation CareerAcademy_RefreshCurriculums */
export type CareerAcademy_RefreshCurriculumsInput = {
  /**
   * Variants that needs to be updated by RefreshCurriculum job
   * Will update all variants when empty
   */
  variants: Array<CareerAcademy_Variant>;
};

/** Enum representing status of the refresh job */
export const CareerAcademy_RefreshJobStatus = {
  /** Refresh job is idle */
  Idle: 'IDLE',
  /** Refresh job is currently running */
  Running: 'RUNNING',
  /** Refresh job has started */
  Started: 'STARTED'
} as const;

export type CareerAcademy_RefreshJobStatus = typeof CareerAcademy_RefreshJobStatus[keyof typeof CareerAcademy_RefreshJobStatus];
/** Input for removing content from a role. */
export type CareerAcademy_RemoveContentFromRoleInput = {
  /** IDs of the content. */
  id: Scalars['ID'];
  /** ID of the role */
  roleId: Scalars['ID'];
  /** Variants of the role to which content will be removed from */
  variant: CareerAcademy_Variant;
};

/** Input for update program curriculum */
export type CareerAcademy_UpdateProgramCurriculumInput = {
  /** Denotes program ID that will be updated */
  programId: Scalars['ID'];
  /**
   * Denotes to a list of role identifiers representing a subset CA reference curriculum roles.
   * Program admins may select only roles they want to be included in programs
   * instead of importing all roles from CA reference curriculum.
   * If empty the desired program will have all CA reference curriculum's role added to it's curriculum
   */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Variant of the program that will be updated */
  variant: CareerAcademy_Variant;
};

/** The variant of Career Academy we're using (typically region/language based). */
export const CareerAcademy_Variant = {
  /** Variant containing arabic content in addition to default content. */
  Arabic: 'ARABIC',
  /** Default variant containing english content. */
  Default: 'DEFAULT',
  /** Grow with Google is an offering that contains just Google entry-level certs, and limited corresponding roles for it. */
  GrowWithGoogle: 'GROW_WITH_GOOGLE',
  /** Enum representing when no variant is present. */
  None: 'NONE',
  /** Variant containing spanish content in addition to default content. */
  Spanish: 'SPANISH'
} as const;

export type CareerAcademy_Variant = typeof CareerAcademy_Variant[keyof typeof CareerAcademy_Variant];
/** Career role completion status filter. */
export const CareerRole_CompletionStatusFilter = {
  /** All roles in the Role Taxonomy 2.0. */
  All: 'ALL',
  /** Completed roles, have completed merchandising data and pathways, can be ready for launching RDP. */
  Completed: 'COMPLETED',
  /** Roles with at least one pathway linked to it, merchandising data is not guaranteed. */
  PathwayLinked: 'PATHWAY_LINKED'
} as const;

export type CareerRole_CompletionStatusFilter = typeof CareerRole_CompletionStatusFilter[keyof typeof CareerRole_CompletionStatusFilter];
/** The merchandising job categories that used for merchandising and filtering. */
export const CareerRole_MerchandisingJobCategory = {
  /** Business */
  Business: 'BUSINESS',
  /** Data & Analytics */
  DataAndAnalytics: 'DATA_AND_ANALYTICS',
  /** Healthcare */
  Healthcare: 'HEALTHCARE',
  /** Sales & Marketing */
  SalesAndMarketing: 'SALES_AND_MARKETING',
  /** Software & IT */
  SoftwareAndIt: 'SOFTWARE_AND_IT'
} as const;

export type CareerRole_MerchandisingJobCategory = typeof CareerRole_MerchandisingJobCategory[keyof typeof CareerRole_MerchandisingJobCategory];
/** The levels of the pathway specializations. */
export const CareerRole_PathwayLevel = {
  /** Advanced */
  Advanced: 'ADVANCED',
  /** Beginner */
  Beginner: 'BEGINNER',
  /** Intermediate */
  Intermediate: 'INTERMEDIATE'
} as const;

export type CareerRole_PathwayLevel = typeof CareerRole_PathwayLevel[keyof typeof CareerRole_PathwayLevel];
/** Career role product type. */
export const CareerRole_ProductType = {
  /** Course. */
  Course: 'COURSE',
  /** Degree. */
  Degree: 'DEGREE',
  /** Specialization (professional certificates included). */
  Specialization: 'SPECIALIZATION'
} as const;

export type CareerRole_ProductType = typeof CareerRole_ProductType[keyof typeof CareerRole_ProductType];
/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
/** Distinction achieved by a learner getting a grade for a course */
export const CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** It is necessary to differentiate Spark and OnDemand courses because not all features can not treat these as the same thing. For example, we may have an upsell feature that prompts you to take a specialization if you took a course that is part of it. We wouldn't want this feature to treat all certs the same because Spark Courses/Specializations are no longer available. A SparkCourse Cert vs OnDemandCourse Cert shouldn't be considered as a different "type" of certificate though as they store the exact same fields. However a Course and a Specialization should be considered as different types as they are a completely different product */
export const CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin = {
  OnDemand: 'ON_DEMAND',
  Spark: 'SPARK'
} as const;

export type CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin = typeof CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin[keyof typeof CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin];
/** Courier version of org.coursera.certificate.CertificateTypeV1 in org/coursera/certificate/package.scala. Number of certificate types have been reduced from CertificateTypeV1. Spark vs OnDemand is now represented in CertificatePlatformOrigin With/WithoutGrade is now represented using the CertificateSharingConfiguration. Honors course certs are defined through the Distinction level in CourseCertificate */
export const CertificateV1_Org_Coursera_Certificate_CertificateType = {
  Course: 'Course',
  Specialization: 'Specialization'
} as const;

export type CertificateV1_Org_Coursera_Certificate_CertificateType = typeof CertificateV1_Org_Coursera_Certificate_CertificateType[keyof typeof CertificateV1_Org_Coursera_Certificate_CertificateType];
/** Represents the print settings for a certificate with disclaimer */
export type Certificates_CertificateWithDisclaimerPrintSettingsInput = {
  /** Disclaimer text for the certificate */
  disclaimer: Scalars['String'];
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText?: InputMaybe<Certificates_SignatureImageWithTextInput>;
};

/** Represents the input for a course certificate print settings identifier */
export type Certificates_CourseCertificatePrintSettingsIdInput = {
  /** Type of the course certificate */
  certificateType: Certificates_CourseCertificateType;
  /** ID of the course */
  courseId: Scalars['ID'];
};

/** Represents the print settings for a course certificate */
export type Certificates_CourseCertificatePrintSettingsInput = {
  /** Print settings for a certificate with disclaimer */
  certificateWithDisclaimer?: InputMaybe<Certificates_CertificateWithDisclaimerPrintSettingsInput>;
  /** Print settings for a verified certificate on-demand */
  verifiedCertificateOnDemand?: InputMaybe<Certificates_VerifiedCertificateOnDemandPrintSettingsInput>;
};

/** Represents the certificate types for a course */
export const Certificates_CourseCertificateType = {
  /** Invalid certificate type */
  Invalid: 'INVALID',
  /** On-demand certificate type */
  OnDemand: 'ON_DEMAND',
  /** On-demand honors certificate type without grade */
  OnDemandHonorsWithoutGrade: 'ON_DEMAND_HONORS_WITHOUT_GRADE',
  /** On-demand certificate type without grade */
  OnDemandWithoutGrade: 'ON_DEMAND_WITHOUT_GRADE'
} as const;

export type Certificates_CourseCertificateType = typeof Certificates_CourseCertificateType[keyof typeof Certificates_CourseCertificateType];
/** Represents the input for deleting certificate print settings */
export type Certificates_DeleteCourseCertificatePrintSettingsInput = {
  /** Unique identifier for a course certificate print settings request */
  settingsId: Certificates_CourseCertificatePrintSettingsIdInput;
};

/** Represents the input for deleting certificate print settings */
export type Certificates_DeleteS12nCertificatePrintSettingsInput = {
  /** Unique identifier for a s12n certificate print settings request */
  settingsId: Certificates_S12nCertificatePrintSettingsIdInput;
};

/** Type of certificate */
export const Certificates_ProductType = {
  /** Certificate for completing a course */
  Course: 'COURSE',
  /** Certificate for completing a specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type Certificates_ProductType = typeof Certificates_ProductType[keyof typeof Certificates_ProductType];
/** Represents the print settings for a specialization certificate on-demand */
export type Certificates_S12nCertificateOnDemandPrintSettingsInput = {
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText?: InputMaybe<Certificates_SignatureImageWithTextInput>;
};

/** Represents the input for an s12n certificate print settings identifier */
export type Certificates_S12nCertificatePrintSettingsIdInput = {
  /** Type of the s12n certificate */
  certificateType: Certificates_S12nCertificateType;
  /** ID of the s12n */
  s12nId: Scalars['ID'];
};

/** Represents the certificate types for a specialization */
export const Certificates_S12nCertificateType = {
  /** Invalid certificate type */
  Invalid: 'INVALID',
  /** Specialization certificate type */
  Specialization: 'SPECIALIZATION',
  /** Specialization on-demand certificate type */
  SpecializationOnDemand: 'SPECIALIZATION_ON_DEMAND'
} as const;

export type Certificates_S12nCertificateType = typeof Certificates_S12nCertificateType[keyof typeof Certificates_S12nCertificateType];
/** Represents input for the signature in a certificate */
export type Certificates_SignatureImageWithTextInput = {
  /** Text to display alongside the signature */
  signatureText: Scalars['String'];
  /** URL of the signature image. Null if not exists. */
  signatureUrl?: InputMaybe<Scalars['URL']>;
};

/** Represents the input for updating course certificate print settings */
export type Certificates_UpdateCourseCertificatePrintSettingsInput = {
  /** The updated course certificate print settings */
  printSettings: Certificates_CourseCertificatePrintSettingsInput;
  /** Unique identifier for the course certificate print settings */
  settingsId: Certificates_CourseCertificatePrintSettingsIdInput;
};

/** Represents the input for updating s12n certificate print settings */
export type Certificates_UpdateS12nCertificatePrintSettingsInput = {
  /** The updated s12n certificate print settings */
  printSettings: Certificates_S12nCertificateOnDemandPrintSettingsInput;
  /** Unique identifier for the s12n certificate print settings */
  settingsId: Certificates_S12nCertificatePrintSettingsIdInput;
};

/** Represents the print settings for a verified certificate on-demand */
export type Certificates_VerifiedCertificateOnDemandPrintSettingsInput = {
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText: Certificates_SignatureImageWithTextInput;
};

/** TODO: Complete this description */
export const CheatingCaseStatus = {
  /** the learner has requested an appeal for the case and was denied */
  AppealDenied: 'APPEAL_DENIED',
  /** the case has been granted an appeal with the false positive reason */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE',
  /** the case has been granted an appeal with an "other" reason */
  AppealOther: 'APPEAL_OTHER',
  /** the learner has requested an appeal for the case */
  AppealRequested: 'APPEAL_REQUESTED',
  /** cheating confirmed */
  CheatingConfirmed: 'CHEATING_CONFIRMED',
  /** cheating not confirmed */
  CheatingNotConfirmed: 'CHEATING_NOT_CONFIRMED',
  /** the case is still being resolved */
  InProgress: 'IN_PROGRESS',
  /** resolved no ruling */
  ResolvedNoRuling: 'RESOLVED_NO_RULING'
} as const;

export type CheatingCaseStatus = typeof CheatingCaseStatus[keyof typeof CheatingCaseStatus];
/** Salesforce environment status */
export const CheatingCaseTask_SalesforceEnvironment = {
  SalesForceEnvironmentInvalid: 'SALES_FORCE_ENVIRONMENT_INVALID',
  SalesForceEnvironmentSfExpDev: 'SALES_FORCE_ENVIRONMENT_SF_EXP_DEV',
  SalesForceEnvironmentSfProd: 'SALES_FORCE_ENVIRONMENT_SF_PROD',
  SalesForceEnvironmentSfQaBuild: 'SALES_FORCE_ENVIRONMENT_SF_QA_BUILD',
  SalesForceEnvironmentSfUat: 'SALES_FORCE_ENVIRONMENT_SF_UAT'
} as const;

export type CheatingCaseTask_SalesforceEnvironment = typeof CheatingCaseTask_SalesforceEnvironment[keyof typeof CheatingCaseTask_SalesforceEnvironment];
/** enums representing supported reasons in an appeal request */
export const CheatingIncident_AppealRequestReason = {
  /** one time exception for a given course */
  AppealException: 'APPEAL_EXCEPTION',
  /** learner does not agree with the ruling */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE'
} as const;

export type CheatingIncident_AppealRequestReason = typeof CheatingIncident_AppealRequestReason[keyof typeof CheatingIncident_AppealRequestReason];
/** enum representing all possible cheating incident statuses */
export const CheatingIncident_CheatingIncidentRuling = {
  /** the learner has requested an appeal for the incident and was denied */
  AppealDenied: 'APPEAL_DENIED',
  /** the incident has been granted an appeal with the false positive reason */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE',
  /** the incident has been granted an appeal with an "other" reason */
  AppealOther: 'APPEAL_OTHER',
  /** the learner has requested an appeal for the incident */
  AppealRequested: 'APPEAL_REQUESTED',
  /** cheating confirmed */
  CheatingConfirmed: 'CHEATING_CONFIRMED',
  /** cheating not confirmed */
  CheatingNotConfirmed: 'CHEATING_NOT_CONFIRMED',
  /** the incident is still being resolved */
  InProgress: 'IN_PROGRESS',
  /** resolved no ruling */
  ResolvedNoRuling: 'RESOLVED_NO_RULING'
} as const;

export type CheatingIncident_CheatingIncidentRuling = typeof CheatingIncident_CheatingIncidentRuling[keyof typeof CheatingIncident_CheatingIncidentRuling];
/** enums representing possible significant events related to the lifecycle of a given cheating incident */
export const CheatingIncident_EventType = {
  /** the learner submitted the assignment that was linked to the cheating incident */
  AssignmentSubmission: 'ASSIGNMENT_SUBMISSION',
  /** the requested appeal from the learner has been ruled by someone with incident ruling authority */
  CaseAppealRuled: 'CASE_APPEAL_RULED',
  /** the learner has requested an appeal for a given incident */
  CaseAppealSubmitted: 'CASE_APPEAL_SUBMITTED',
  /** the incident has been ruled by someone with incident ruling authority, for example, outsourcing agents */
  CaseRuled: 'CASE_RULED',
  /** the submission was flagged by our system either through peer flags or automated flags */
  SubmissionFlag: 'SUBMISSION_FLAG'
} as const;

export type CheatingIncident_EventType = typeof CheatingIncident_EventType[keyof typeof CheatingIncident_EventType];
/** all currently supported item types within the cheating incidents system */
export const CheatingIncident_ItemType = {
  /** peer review */
  Peer: 'PEER',
  /** programming assignments */
  Programming: 'PROGRAMMING',
  /** quizzes */
  Quiz: 'QUIZ',
  /** staff graded assignments */
  StaffGraded: 'STAFF_GRADED'
} as const;

export type CheatingIncident_ItemType = typeof CheatingIncident_ItemType[keyof typeof CheatingIncident_ItemType];
/** enums representing possible contact log sources in LearnerServiceContactLog */
export const CheatingIncident_LearnerServiceContactLogSource = {
  /** from the learner */
  Learner: 'LEARNER',
  /** from learner services */
  LearnerServices: 'LEARNER_SERVICES'
} as const;

export type CheatingIncident_LearnerServiceContactLogSource = typeof CheatingIncident_LearnerServiceContactLogSource[keyof typeof CheatingIncident_LearnerServiceContactLogSource];
/** input type for RequestAppealForCheatingIncident */
export type CheatingIncident_RequestAppealForCheatingIncidentInput = {
  /** when the appeal reason is FALSE_POSITIVE, it is a required field to allow learners to provide explanation on why they disagree with the ruling */
  explanation?: InputMaybe<Scalars['String']>;
  /** incident id */
  incidentId: Scalars['ID'];
  /** reason for appeal */
  reason: CheatingIncident_AppealRequestReason;
};

/** Content id could refer to a verified certificate or to a specialization */
export type CheckoutGateway_ContentId = {
  /** A course (verified certificate) id */
  courseId?: InputMaybe<Scalars['ID']>;
  /** A specialization id */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** Side effects metadata for fulfillment of Coursera Lite ownable product */
export type CheckoutGateway_CourseraLitePostFulfillmentSideEffects = {
  /**
   * The course/s12n to grant membership for once checkout is complete
   * (e.g. the CDP/SDP they were exposed to Coursera Lite from)
   */
  contentIdToGrantMembershipTo?: InputMaybe<CheckoutGateway_ContentId>;
  /**
   * The course/s12n to grant membership to once checkout is complete
   * (e.g. the CDP they were exposed to s12n from)
   *
   * This is only relevant if the learner enrolled in Coursera Lite through a CDP in an s12n that
   * isn't the first course in the s12n. In this case, the learner should get the membership for that
   * course instead of going through normal s12n enrollment flow (which will grant the membership
   * of the first course in the s12n)
   */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
};

/** Side effects metadata for fulfillment of Coursera Plus ownable product */
export type CheckoutGateway_CourseraPlusPostFulfillmentSideEffects = {
  /**
   * The course/s12n to grant ownership for once checkout is complete
   * (e.g. the CDP/SDP they were exposed to Coursera Plus from)
   */
  contentIdToGrantOwnershipTo?: InputMaybe<CheckoutGateway_ContentId>;
  /**
   * The course/s12n to grant membership to once checkout is complete
   * (e.g. the CDP they were exposed to s12n from)
   *
   * This is only relevant if the learner enrolled in Coursera Plus through a CDP in an s12n that
   * isn't the first course in the s12n. In this case, the learner should get the membership for that
   * course instead of going through normal s12n enrollment flow (which will grant the membership
   * of the first course in the s12n)
   */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
};

/** Input for cart creation */
export type CheckoutGateway_CreateCart = {
  /** An identifier for an ownable product + fulfillment method pair */
  ownableProductFulfillmentConfigurationId: Scalars['ID'];
  /** Context to identify the fulfillment config, and side-effects of cart creation */
  productFulfillmentContext: CheckoutGateway_ProductFulfillmentContext;
  /** User id for the user that the cart should be created for */
  userId: Scalars['ID'];
};

/** Input options for cart create */
export type CheckoutGateway_CreateCartInput = {
  /** Input for production cart creation */
  prod?: InputMaybe<CheckoutGateway_CreateCart>;
  /** Input for test cart creation */
  test?: InputMaybe<CheckoutGateway_CreateCartTest>;
};

/** Input for cart creation */
export type CheckoutGateway_CreateCartTest = {
  /** Country code */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Currency code */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** An identifier for an ownable product + fulfillment method pair */
  ownableProductFulfillmentConfigurationId: Scalars['ID'];
  /** Context to identify the fulfillment config, and side-effects of cart creation */
  productFulfillmentContext: CheckoutGateway_ProductFulfillmentContext;
  /** User id for the user that the cart should be created for */
  userId: Scalars['ID'];
};

/**
 * Side effects metadata for fulfillment of Credential Track ownable products (Mastertrack w/ 1 or 4
 * installments, Mastertrack one-time payment hack).
 */
export type CheckoutGateway_CredentialTrackPostFulfillmentSideEffects = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Side effects context for different products post fulfillment (scheme-agnostic)
 * Examples of side effects includes sending emails, product enrollment etc.
 * The long term vision of this model is to function as a well-defined side-effect container
 * for each product type that is obvious for engineers to extend/add to. Currently, the side-effects
 * container for VerifiedCertificate product type is empty because during phase 4 of
 * next gen product config, we learned that there wasn't a B2C use case for VerifiedCertificate
 * post fulfillment side effects, so we opted to remove the fields from this side effects container.
 * The credential track side-effects container is also empty because the FE does not use
 * CredentialTrackSubscriptionCartItemMetadata or auxiliaryCartInfo to encapsulate any side effects
 * for the "Mastertrack w/ 1 or 4 installments", or "Mastertrack one-time payment hack" case.
 */
export type CheckoutGateway_PostFulfillmentContext = {
  /** Metadata required for owning a Coursera Lite product */
  courseraLite?: InputMaybe<CheckoutGateway_CourseraLitePostFulfillmentSideEffects>;
  /** Metadata required for owning a Coursera Plus product */
  courseraPlus?: InputMaybe<CheckoutGateway_CourseraPlusPostFulfillmentSideEffects>;
  /** Metadata required for owning a credential track product */
  credentialTrack?: InputMaybe<CheckoutGateway_CredentialTrackPostFulfillmentSideEffects>;
  /** Metadata required for owning a specialization product */
  specialization?: InputMaybe<CheckoutGateway_SpecializationPostFulfillmentSideEffects>;
  /** Metadata required for owning a verified certificate product */
  verifiedCertificate?: InputMaybe<CheckoutGateway_VerifiedCertificatePostFulfillmentSideEffects>;
};

/**
 * Metadata context to capture any fulfillment-specific concerns
 * i.e. what you get access to and any side-effects around the context that you get access to it
 *
 * Distinct from scheme-specific concerns e.g. free trial length, prepaid vs subscription etc.
 *
 * This container is sparse to start but intended to be flexible for the future,
 * within the scope of product fulfillment
 */
export type CheckoutGateway_ProductFulfillmentContext = {
  /** Side effects context for different products post fulfillment (scheme-agnostic) */
  postFulfillmentContext?: InputMaybe<CheckoutGateway_PostFulfillmentContext>;
};

/** Side effects metadata for fulfillment of s12n ownable product */
export type CheckoutGateway_SpecializationPostFulfillmentSideEffects = {
  /** The course to enroll the learner in (e.g. the CDP they were exposed to s12n from) */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
  /** Flag to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/**
 * Side effects metadata for fulfillment of verified certificate ownable products
 * (courses, guided projects etc)
 */
export type CheckoutGateway_VerifiedCertificatePostFulfillmentSideEffects = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** CourseItem id Type */
export type Clip_CourseItemId = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** Item Id */
  itemId: Scalars['ID'];
};

/** TODO: Complete this description */
export type CmlContentInput = {
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['String'];
};

/** Federated Cml input type */
export type Cml_CmlInput = {
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['ID'];
};

/** Input for attempt rate submission configuration */
export type CoachItemAuthoring_AttemptRateSubmissionInput = {
  /** Number of attempts allowed per time interval */
  maxAttemptsPerInterval: Scalars['Int'];
  /** Time interval value (unit specified by timeIntervalUnit) */
  timeInterval: Scalars['Int'];
  /** Unit for the time interval (hours or days) */
  timeIntervalUnit: CoachItemAuthoring_TimeIntervalUnit;
  /** Time limit for each attempt in minutes */
  timeLimitPerAttemptInMinutes: Scalars['Int'];
};

/** Input type for coach activity draft containing activity-specific details */
export type CoachItemAuthoring_CoachActivityDraftInput = {
  /** Allowed communication modes for the coach item. Empty or null means all modes are supported. */
  allowedCommunicationModes?: InputMaybe<Array<CoachItemAuthoring_CommunicationMode>>;
  /** Asset files to use as embeddings */
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * CoachActivityTemplate that this particular coach activity is tied with.
   * This field was renamed from versionedCoachItemType eg) rolePlay@1, socraticDialogue@8
   */
  coachActivitySchemaId?: InputMaybe<Scalars['ID']>;
  /** Type specific fields for different coach activities */
  coachActivityTypeSpecificFields?: InputMaybe<CoachItemAuthoring_CoachActivityTypeSpecificFieldsInput>;
  /** Cover page instruction shown in the item cover page */
  coverPageInstruction?: InputMaybe<Scalars['String']>;
  /**
   * Prompt parameters that eventually gets injected into different prompts.
   *
   * Socratic Dialogue: authoringRubricAdvanced, authoringRubricIntermediate,
   * authoringRubricBeginner, purposeOfActivity.
   *
   * Role Play: authoringRubricAdvanced, authoringRubricIntermediate, authoringRubricBeginner,
   * scenarioDefinition.
   */
  promptParameters?: InputMaybe<Array<CoachItemAuthoring_PromptParameterInput>>;
};

/** Input type for different coach activity type specific fields */
export type CoachItemAuthoring_CoachActivityTypeSpecificFieldsInput = {
  /** Role play specific fields */
  rolePlay?: InputMaybe<CoachItemAuthoring_RolePlayFieldsInput>;
  /** Socratic dialogue specific fields */
  socraticDialogue?: InputMaybe<CoachItemAuthoring_SocraticDialogueFieldsInput>;
};

/** Communication mode for coach items */
export const CoachItemAuthoring_CommunicationMode = {
  /** Text-only communication */
  Text: 'TEXT',
  /** Voice-only communication */
  Voice: 'VOICE'
} as const;

export type CoachItemAuthoring_CommunicationMode = typeof CoachItemAuthoring_CommunicationMode[keyof typeof CoachItemAuthoring_CommunicationMode];
/** CoachItem draft content, represented as an input type */
export type CoachItemAuthoring_DraftContentInput = {
  /** Updated coach item content */
  coachActivity?: InputMaybe<CoachItemAuthoring_CoachActivityDraftInput>;
  /** Whether the coach item is graded */
  isGraded?: InputMaybe<Scalars['Boolean']>;
  /** Updated item name */
  name: Scalars['String'];
  /** Passing fraction threshold (0.0 to 1.0). Only applicable when isGraded is true. */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Submission limit configuration. Only applicable when isGraded is true. */
  submissionLimitConfig?: InputMaybe<CoachItemAuthoring_SubmissionLimitConfigInput>;
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
  /** versioned Id of the underlying coach activity */
  versionedCoachActivityId?: InputMaybe<Scalars['ID']>;
};

/** Input type for prompt parameter key-value pair */
export type CoachItemAuthoring_PromptParameterInput = {
  /** Key of the prompt parameter */
  key: Scalars['String'];
  /** Value of the prompt parameter */
  value: Scalars['String'];
};

/** Input type for role play specific fields */
export type CoachItemAuthoring_RolePlayFieldsInput = {
  /** AI persona behavior */
  aiPersonaBehavior: Scalars['String'];
  /** AI persona first message */
  aiPersonaFirstMessage?: InputMaybe<Scalars['String']>;
  /** AI persona role */
  aiPersonaRole: Scalars['String'];
  /** List of tasks */
  tasks: Array<Scalars['String']>;
};

/** Input type for socratic dialogue specific fields */
export type CoachItemAuthoring_SocraticDialogueFieldsInput = {
  /** Empty type for socratic dialogue fields */
  _placeholder?: Scalars['Boolean'];
};

/**
 * Submission limit configuration for graded coach items.
 * Exactly one field must be set.
 */
export type CoachItemAuthoring_SubmissionLimitConfigInput = {
  /** Rate-limited: X attempts per Y hours */
  attemptRate?: InputMaybe<CoachItemAuthoring_AttemptRateSubmissionInput>;
  /** Unlimited submissions allowed */
  unlimited?: InputMaybe<CoachItemAuthoring_UnlimitedSubmissionInput>;
};

/** Unit for the submission rate limit time interval */
export const CoachItemAuthoring_TimeIntervalUnit = {
  /** Time interval measured in days */
  Days: 'DAYS',
  /** Time interval measured in hours */
  Hours: 'HOURS'
} as const;

export type CoachItemAuthoring_TimeIntervalUnit = typeof CoachItemAuthoring_TimeIntervalUnit[keyof typeof CoachItemAuthoring_TimeIntervalUnit];
/** Input for unlimited submission configuration */
export type CoachItemAuthoring_UnlimitedSubmissionInput = {
  /** Placeholder field */
  _placeholder?: Scalars['Boolean'];
};

/** Input for the CoachItemAuthoring_UpdateCoachItemDraft mutation */
export type CoachItemAuthoring_UpdateCoachItemDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: CoachItemAuthoring_DraftContentInput;
};

/** Input for starting a grading attempt on a coach item. */
export type CoachItemGrading_StartGradingAttemptInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /**
   * The chat session ID for the role-play. Required so that the server can record
   * the session in the proctor attempt metadata and auto-submit it when the
   * deadline elapses.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
};

/** Input for submitting a coach item chat session for grading. */
export type CoachItemGrading_SubmitForGradingInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /** The chat session ID to submit for grading */
  chatSessionId: Scalars['ID'];
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
};

/** Input for updating coach item progress */
export type CoachItemProgress_UpdateCoachItemProgressInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
  /** The new progress state to set */
  progressState: CoachItem_ProgressState;
};

/** The additional context of a Coach chat as an input. */
export type CoachItem_AdditionalContextInput = {
  /** Context key for the additional context with a prefix of "additionalContext.". For example, "additionalContext.roleData" */
  contextKey: Scalars['String'];
  /** The value of the additional context. */
  contextValue: Scalars['String'];
};

/**
 * Allowed coach action IDs for CoachItem_ResolveContent. Only actions listed here are
 * accepted; attempts to use any other value will be rejected at the schema level.
 */
export const CoachItem_CoachActionId = {
  /** Generate a JSON actor context for the role-play session */
  CoachItemGenerateJson: 'COACH_ITEM_GENERATE_JSON',
  /** Generate a scenario description for the role-play session */
  CoachItemGenerateScenarioV2: 'COACH_ITEM_GENERATE_SCENARIO_V2',
  /** Welcome message for dialogue */
  CoachItemWelcomeMessage: 'COACH_ITEM_WELCOME_MESSAGE',
  /** List all required dasks for the role-play session */
  TaskListing: 'TASK_LISTING'
} as const;

export type CoachItem_CoachActionId = typeof CoachItem_CoachActionId[keyof typeof CoachItem_CoachActionId];
/**
 * Allowed coach mode IDs for CoachItem_ResolveContent. Only modes listed here are
 * accepted; attempts to use any other value will be rejected at the schema level.
 */
export const CoachItem_CoachModeId = {
  /** Dialogue */
  CoachItemDialogue: 'COACH_ITEM_DIALOGUE',
  /** Role-play simulation mode */
  CoachItemRolePlay: 'COACH_ITEM_ROLE_PLAY'
} as const;

export type CoachItem_CoachModeId = typeof CoachItem_CoachModeId[keyof typeof CoachItem_CoachModeId];
/** Communication mode for coach items */
export const CoachItem_CommunicationMode = {
  /** Text-only communication */
  Text: 'TEXT',
  /** Voice-only communication */
  Voice: 'VOICE'
} as const;

export type CoachItem_CommunicationMode = typeof CoachItem_CommunicationMode[keyof typeof CoachItem_CommunicationMode];
/** The configuration of a Coach chat message as an input. */
export type CoachItem_ConfigurationInput = {
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Include structured output in chat history */
  includeStructuredOutputInChatHistory?: Scalars['Boolean'];
};

/** Coursera context input for the AI coach to understand the context of the message. */
export type CoachItem_CourseraContextInput = {
  /** List of additional products the user need as supporting context */
  additionalProducts?: InputMaybe<Array<CoachItem_ProductInput>>;
  /** Provides the AuthoringCourseBranch ID context of the message if the context is available. */
  authoringCourseBranchId?: InputMaybe<Scalars['ID']>;
  /** Provides the CourseBranch ID context of the message if the context is available. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Degree ID the user is currently on */
  degreeId?: InputMaybe<Scalars['ID']>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Module ID the user is currently on */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Specialization ID the user is currently on */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** The enum indicating the type of the product for the AI coach to understand the additional context of the message in coursera. */
export const CoachItem_CourseraProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type CoachItem_CourseraProductType = typeof CoachItem_CourseraProductType[keyof typeof CoachItem_CourseraProductType];
/** Product input for the AI coach to understand the additional context of the message in coursera. */
export type CoachItem_ProductInput = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: CoachItem_CourseraProductType;
};

/** Enum representing the progress state of a coach item */
export const CoachItem_ProgressState = {
  /** The coach item has been completed */
  Completed: 'COMPLETED',
  /** The coach item has not been started */
  NotStarted: 'NOT_STARTED',
  /** The coach item has been started but not completed */
  Started: 'STARTED',
  /** Unknown progress state (default) */
  Unknown: 'UNKNOWN'
} as const;

export type CoachItem_ProgressState = typeof CoachItem_ProgressState[keyof typeof CoachItem_ProgressState];
/**
 * Input for resolving coach item content. Mirrors the core fields of
 * AiCoach_RespondToUserMessageInput so that the frontend can swap mutation names with
 * minimal changes.
 */
export type CoachItem_ResolveContentInput = {
  /**
   * Additional context to append to the prompt when a cache miss triggers live LLM
   * generation.
   */
  additionalContext?: InputMaybe<Array<CoachItem_AdditionalContextInput>>;
  /**
   * The ID of the current chat session. If empty, the backend will create a new session
   * and return the generated ID in the result.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /**
   * Configuration identifying the coach action (e.g. COACH_ITEM_GENERATE_SCENARIO or
   * COACH_ITEM_GENERATE_JSON) and mode. The coachActionId is used as the sort key in
   * the DynamoDB cache.
   */
  config: CoachItem_ConfigurationInput;
  /**
   * Coursera context used to derive the cache key (courseId, itemId, branchId) and to
   * help the AI coach understand the context of the message.
   */
  courseraContext?: InputMaybe<CoachItem_CourseraContextInput>;
  /** Message input by the user (or action trigger) to the AI coach */
  message: Scalars['String'];
};

/** Input for subscribing to role play task status updates. */
export type CoachItem_RolePlayTaskStatusInput = {
  /** Additional context to append to the prompt if not available in existing context fetchers. */
  additionalContext?: InputMaybe<Array<CoachItem_AdditionalContextInput>>;
  /** The ID of the current chat session. If empty, the backend will generate a new session ID. */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** The configuration input of the chat message including action and mode. */
  config: CoachItem_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message. */
  courseraContext?: InputMaybe<CoachItem_CourseraContextInput>;
};

/** This helps depict if the message is by the user or the AI coach. */
export const CoachItem_SenderType = {
  /** Message is by the AI coach */
  System: 'SYSTEM',
  /** Message is by the user */
  User: 'USER'
} as const;

export type CoachItem_SenderType = typeof CoachItem_SenderType[keyof typeof CoachItem_SenderType];
/** Allowable options for collection Attribute Type */
export const CollectionAttributes_CollectionAttributeType = {
  /** Attribute Type that represents an academic discipline */
  AcademicDiscipline: 'ACADEMIC_DISCIPLINE',
  /** Attribute Type that represents the contract tag name (currently only support academy contract tag name) */
  ContractTagName: 'CONTRACT_TAG_NAME',
  /** Attribute Type that represents a domain */
  Domain: 'DOMAIN',
  /** Attribute Type that represents an educational goal */
  EducationalGoal: 'EDUCATIONAL_GOAL',
  /** Attribute Type that represents a learning objective */
  LearningObjective: 'LEARNING_OBJECTIVE',
  /** Attribute Type that represents the status of optimization */
  OptimizationStatus: 'OPTIMIZATION_STATUS',
  /** Attribute Type that represents a organization goal */
  OrganizationGoal: 'ORGANIZATION_GOAL',
  /** Attribute Type that represents the organisation ID (one per collection; owning org). */
  OrganizationId: 'ORGANIZATION_ID',
  /** Attribute Type that represents a program ID (multiple per collection; programs where the collection is added). */
  ProgramId: 'PROGRAM_ID',
  /** Attribute Type that represents the purpose of this collection */
  Purpose: 'PURPOSE',
  /** Attribute Type that represents a skill */
  Skill: 'SKILL'
} as const;

export type CollectionAttributes_CollectionAttributeType = typeof CollectionAttributes_CollectionAttributeType[keyof typeof CollectionAttributes_CollectionAttributeType];
/** Paginated input for collection attributes */
export type CollectionAttributes_GroupPaginationInput = {
  /** Collection attribute type */
  attributeType: CollectionAttributes_CollectionAttributeType;
  /** pagination cursor */
  cursor?: InputMaybe<Scalars['String']>;
  /** Max number of attributes to return */
  limit?: Scalars['Int'];
};

/** Academic Discipline Attribute input type */
export type Collection_AcademicDisciplineInput = {
  /** Academic Discipline Attribute input value */
  value: Scalars['String'];
};

/**
 * Input for AddCollection mutation. Currently only adds a reference of an existing collection into the collections table.
 * In the future, this API can be repurposed to add a new collection.
 */
export type Collection_AddCollectionInput = {
  /** Collection type */
  collectionType: Collection_CollectionType;
  /** ID of the collection */
  id: Scalars['ID'];
  /**
   * Visibility scope
   * @deprecated No longer used, use visibilityScopes instead
   */
  visibilityScope?: InputMaybe<Collection_VisibilityScope>;
  /** Visibility scopes */
  visibilityScopes?: InputMaybe<Array<Collection_VisibilityScope>>;
};

/** Collection attribute input */
export type Collection_CollectionAttributeInput = {
  /** Academic discipline input */
  academicDiscipline?: InputMaybe<Collection_AcademicDisciplineInput>;
  /** Contract tag name input */
  contractTagName?: InputMaybe<Collection_ContractTagNameInput>;
  /** Domain ID input */
  domain?: InputMaybe<Collection_DomainAttributeInput>;
  /** Educational goal input */
  educationalGoal?: InputMaybe<Collection_EducationalGoalInput>;
  /** Learning objectives input */
  learningObjective?: InputMaybe<Collection_LearningObjectivesInput>;
  /** Optimization status */
  optimizationStatus?: InputMaybe<Collection_OptimizationStatusInput>;
  /** Organization goal input */
  organizationGoal?: InputMaybe<Collection_OrganizationGoalInput>;
  /** Organisation ID input (one per collection; owning organisation). */
  organizationId?: InputMaybe<Collection_OrganizationIdInput>;
  /** Program ID input (programs where the collection is added). */
  programId?: InputMaybe<Collection_ProgramIdInput>;
  /** Collection purpose input */
  purpose?: InputMaybe<Collection_CollectionPurposeInput>;
  /** Skill ID input */
  skill?: InputMaybe<Collection_SkillAttributeInput>;
};

/** Collection Purpose Attribute input type */
export type Collection_CollectionPurposeInput = {
  /** Collection Purpose Attribute input value (i.e. CURATED_LIBRARY or LEARNING_PATH) */
  value: Scalars['String'];
};

/**
 * Collection types supposed by collection-mgmt-application.
 * Currently the only use case is enterprise curation library project.
 */
export const Collection_CollectionType = {
  /** Admin-curated (e.g. organisation-level) collection. */
  AdminCurated: 'ADMIN_CURATED',
  /** Preset */
  Preset: 'PRESET'
} as const;

export type Collection_CollectionType = typeof Collection_CollectionType[keyof typeof Collection_CollectionType];
/** Contract Tag Name Attribute input type (currently used for Academy) */
export type Collection_ContractTagNameInput = {
  /** Contract Tag Name Attribute input value */
  value: Scalars['String'];
};

/** Domain Attribute input type */
export type Collection_DomainAttributeInput = {
  /** Domain ID input value */
  domainId: Scalars['ID'];
};

/** Educational Goal Attribute input type */
export type Collection_EducationalGoalInput = {
  /** Educational Goal Attribute input value */
  value: Scalars['String'];
};

/** Learning Objectives Attribute input type */
export type Collection_LearningObjectivesInput = {
  /** Learning Objectives Attribute input value */
  value: Scalars['String'];
};

/** Collection Purpose Attribute input type */
export type Collection_OptimizationStatusInput = {
  /** Indicate if the collection needs optimized, the value of the enum is either "NEED_REVIEW" or "OPTIMIZED" */
  value: Scalars['String'];
};

/** Organization Goal Attribute input type */
export type Collection_OrganizationGoalInput = {
  /** Organization Goal Attribute input value */
  value: Scalars['String'];
};

/** Organisation ID attribute input type (one per collection; owning organisation). */
export type Collection_OrganizationIdInput = {
  /** Organisation ID value */
  organizationId: Scalars['ID'];
};

/** Program ID attribute input type (programs where the collection is added). */
export type Collection_ProgramIdInput = {
  /** Program ID value */
  programId: Scalars['ID'];
};

/** Skill Attribute input type */
export type Collection_SkillAttributeInput = {
  /** Skill ID input value */
  skillId: Scalars['ID'];
};

/** Input for UpdateCollectionAttributes mutation */
export type Collection_UpdateCollectionAttributesInput = {
  /** Attributes to add */
  attributesToAdd: Array<Collection_CollectionAttributeInput>;
  /** Attributes to delete */
  attributesToDelete: Array<Collection_CollectionAttributeInput>;
  /** Collection ID */
  collectionId: Scalars['ID'];
  /** Collection type */
  collectionType: Collection_CollectionType;
};

/** Input for UpdateCollectionAttributes mutation */
export type Collection_UpdateCollectionVisibilitiesInput = {
  /** Collection ID */
  collectionId: Scalars['ID'];
  /** Collection type */
  collectionType: Collection_CollectionType;
  /** Visibility to add */
  visibilitiesToAdd: Array<Collection_VisibilityScope>;
  /** Visibility to delete */
  visibilitiesToDelete: Array<Collection_VisibilityScope>;
};

/** Collection visibility scope for Enterprise Curated Collection */
export const Collection_VisibilityScope = {
  /** Visible to Coursera for Business Audience */
  C4B: 'C4B',
  /** Visible to Coursera for Campus Audience */
  C4C: 'C4C',
  /** Visible to Coursera for Government Audience */
  C4G: 'C4G',
  /** Draft state, no visibility outside of internal tool */
  Draft: 'DRAFT',
  /** Visible to Enterprise Admins */
  EnterpriseAdmin: 'ENTERPRISE_ADMIN',
  /**
   * Visible to consumers
   * https://docs.google.com/document/d/1xpd3oMU7E3IX5FC046v4XQ0fpttSHTPZWMl4hinApNI/edit?tab=t.0
   */
  Marketing: 'MARKETING'
} as const;

export type Collection_VisibilityScope = typeof Collection_VisibilityScope[keyof typeof Collection_VisibilityScope];
/** Inferred roles confidence level */
export const Confidence_Level = {
  /** High confidence level */
  High: 'HIGH',
  /** Low confidence level */
  Low: 'LOW',
  /** Medium confidence level */
  Medium: 'MEDIUM'
} as const;

export type Confidence_Level = typeof Confidence_Level[keyof typeof Confidence_Level];
/** Input identifying a coach configuration by its mode and action */
export type ContentExperiment_CoachConfigurationKeyInput = {
  /** Coach action identifier */
  action: Scalars['String'];
  /** Coach mode identifier */
  mode: Scalars['String'];
};

/** Input to complete a content experiment group */
export type ContentExperiment_CompleteGroupInput = {
  /** Time at which to complete assignment for the experiment */
  completeTime: Scalars['DateTime'];
  /** ID of the content experiment group to complete */
  groupId: Scalars['ID'];
};

/** Input "union" of the possible configuration keys (`@oneOf`: exactly one variant must be set). */
export type ContentExperiment_ConfigurationKeyInput = {
  /** Identifies a coach configuration by its mode and action */
  coachConfigurationKey?: InputMaybe<ContentExperiment_CoachConfigurationKeyInput>;
};

/**
 * Input for the content optimization configuration on a content experiment group. The record itself
 * may be empty; new top-level configuration fields can be added here over time.
 */
export type ContentExperiment_ContentOptimizationConfigurationInput = {
  /**
   * Optional configuration key selecting which downstream resource (e.g. a coach configuration)
   * drives the pedagogy refresh event for this group
   */
  configurationKey?: InputMaybe<ContentExperiment_ConfigurationKeyInput>;
};

/** Input to create a content experiment group */
export type ContentExperiment_CreateContentExperimentGroupInput = {
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this group
   * @deprecated Use contentOptimizationConfiguration on ExperimentVariantInput instead
   */
  contentOptimizationConfiguration?: InputMaybe<ContentExperiment_ContentOptimizationConfigurationInput>;
  /** Description of the group */
  description: Scalars['String'];
  /** Optional unique identifier for the group */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the group */
  name: Scalars['String'];
  /** Variants to include in this group */
  variants: Array<ContentExperiment_ExperimentVariantInput>;
};

/** Input for createSubjectsForGroup mutation */
export type ContentExperiment_CreateSubjectsForGroupInput = {
  /** ID of the content experiment group */
  groupId: Scalars['ID'];
  /** List of subject keys to create for this group */
  subjectKeys: Array<ContentExperiment_SubjectKeyInput>;
};

/** Lifecycle state of a content experiment group */
export const ContentExperiment_ExperimentGroupState = {
  /** The group has been created but group-level resource setup has not started */
  New: 'NEW',
  /** All close calls have been issued; all subjects will be assigned back to default once the scheduled complete time is reached */
  ScheduledComplete: 'SCHEDULED_COMPLETE',
  /** All open calls have been issued; assignment will become active once the scheduled start time is reached */
  ScheduledStart: 'SCHEDULED_START',
  /** All stop calls have been issued; assignment will become inactive once the scheduled stop time is reached */
  ScheduledStop: 'SCHEDULED_STOP',
  /** Close calls are being issued to subjects */
  SchedulingComplete: 'SCHEDULING_COMPLETE',
  /** Open (start assignment) calls are being issued to subjects */
  SchedulingStart: 'SCHEDULING_START',
  /** Stop calls are being issued to subjects */
  SchedulingStop: 'SCHEDULING_STOP',
  /** Group-level resources are being configured */
  SettingUp: 'SETTING_UP',
  /** Group-level resources have been configured; the group is ready to accept subjects */
  SetupComplete: 'SETUP_COMPLETE',
  /** At least one subject is being set up in the downstream experiment pipeline */
  SubjectsSettingUp: 'SUBJECTS_SETTING_UP',
  /** All subjects have completed setup in the downstream experiment pipeline */
  SubjectsSetupComplete: 'SUBJECTS_SETUP_COMPLETE'
} as const;

export type ContentExperiment_ExperimentGroupState = typeof ContentExperiment_ExperimentGroupState[keyof typeof ContentExperiment_ExperimentGroupState];
/** Lifecycle state of a subject within a content experiment group */
export const ContentExperiment_ExperimentSubjectState = {
  /** The subject has been added but setup has not yet begun */
  New: 'NEW',
  /** The close call has been issued; this subject will be assigned back to default once the scheduled complete time is reached */
  ScheduledComplete: 'SCHEDULED_COMPLETE',
  /** The open call has been issued; this subject's assignment will become active once the scheduled start time is reached */
  ScheduledStart: 'SCHEDULED_START',
  /** The stop call has been issued; this subject's assignment will become inactive once the scheduled stop time is reached */
  ScheduledStop: 'SCHEDULED_STOP',
  /** The close call is being issued to this subject */
  SchedulingComplete: 'SCHEDULING_COMPLETE',
  /** The open (start assignment) call is being issued to this subject */
  SchedulingStart: 'SCHEDULING_START',
  /** The stop call is being issued to this subject */
  SchedulingStop: 'SCHEDULING_STOP',
  /** Setup is in progress for this subject */
  SettingUp: 'SETTING_UP',
  /** Setup is complete and the subject is ready for experimentation */
  SetupComplete: 'SETUP_COMPLETE',
  /** Setup permanently failed (e.g. the branch copy job failed). The subject must be deleted and re-added to retry. */
  SetupFailed: 'SETUP_FAILED'
} as const;

export type ContentExperiment_ExperimentSubjectState = typeof ContentExperiment_ExperimentSubjectState[keyof typeof ContentExperiment_ExperimentSubjectState];
/** Input for an experiment variant */
export type ContentExperiment_ExperimentVariantInput = {
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this variant
   */
  contentOptimizationConfiguration?: InputMaybe<ContentExperiment_ContentOptimizationConfigurationInput>;
  /** Unique identifier for the variant */
  id: Scalars['ID'];
  /**
   * Whether this variant is the control (baseline) variant for the experiment. Optional; treated as
   * false when omitted.
   */
  isControl?: InputMaybe<Scalars['Boolean']>;
  /** Name of the variant */
  name: Scalars['String'];
};

/** Input for removeSubjectsFromGroup mutation */
export type ContentExperiment_RemoveSubjectsFromGroupInput = {
  /** ID of the content experiment group */
  groupId: Scalars['ID'];
  /** List of subject keys to remove from this group */
  subjectKeys: Array<ContentExperiment_SubjectKeyInput>;
};

/** Input to start a content experiment group */
export type ContentExperiment_StartGroupInput = {
  /** ID of the content experiment group to start */
  groupId: Scalars['ID'];
  /** Time at which to start assignment for the experiment */
  startTime: Scalars['DateTime'];
};

/** Input to stop a content experiment group */
export type ContentExperiment_StopGroupInput = {
  /** ID of the content experiment group to stop */
  groupId: Scalars['ID'];
  /** Time at which to stop assignment for the experiment */
  stopTime: Scalars['DateTime'];
};

/** Identifies a subject by its ID and type */
export type ContentExperiment_SubjectKeyInput = {
  /** ID of the subject */
  subjectId: Scalars['ID'];
  /** Type of the subject */
  subjectType: Scalars['String'];
};

/** Contentful request query and variables from the client. */
export type ContentfulRequestInput = {
  /** Contentful space to use for query. */
  contentfulSpace?: InputMaybe<Scalars['String']>;
  /** This is the contentful query coming from the client in order to support partial field selection. */
  query: Scalars['String'];
  /** Contentful request variables used in the query. */
  variables: ContentfulRequestInputVariables;
};

/** Contentful request variables used in the query. */
export type ContentfulRequestInputVariables = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** 2-letter ISO country code from the client, optional since it defaults to global. */
  countryCode: CountryCode;
  /** This flags enables querying Contentful entries that are not yet published. */
  isPreview: Scalars['Boolean'];
  /** 2-letter ISO Language code from the client, optional since it defaults to the country default language. */
  languageCode: LanguageCode;
  /**
   * This is the query parameter used in the query from the client, it is needed in order to be overridden by the localized parameter.
   * @deprecated The variant is determined by the localization-application through EPIC.
   */
  variant?: InputMaybe<Scalars['String']>;
};

/** Error codes for Contentful translation failures. */
export const ContentfulTranslation_ErrorCode = {
  /** Other Contentful API error. */
  ContentfulError: 'CONTENTFUL_ERROR',
  /** Contentful entry not found (HTTP 404). */
  EntryNotFound: 'ENTRY_NOT_FOUND',
  /** Invalid or unsupported language code. */
  InvalidLanguage: 'INVALID_LANGUAGE',
  /** No permission to access Contentful space (HTTP 401/403). */
  PermissionDenied: 'PERMISSION_DENIED',
  /** Contentful API rate limit exceeded (HTTP 429). */
  RateLimited: 'RATE_LIMITED',
  /** Unexpected translation failure. */
  TranslationFailed: 'TRANSLATION_FAILED'
} as const;

export type ContentfulTranslation_ErrorCode = typeof ContentfulTranslation_ErrorCode[keyof typeof ContentfulTranslation_ErrorCode];
/** Input for triggering translation of one or more Contentful entries. */
export type ContentfulTranslation_TranslateEntriesInput = {
  /**
   * Controls whether existing translations are overwritten.
   *
   * - false (default): Only translates fields that don't have existing translations
   *   in the target language. This preserves any human translations or previous
   *   machine translations. Recommended for most use cases.
   *
   * - true: Overwrites ALL existing translations with new machine translations.
   *   Use with caution: this will replace any human-edited translations and
   *   incurs additional translation costs for content that may already be translated.
   *
   * CAUTION: Setting allowOverwrite=true triggers retranslation of all fields,
   * which increases translation costs. Only use when source content has been
   * updated and you explicitly want to refresh all translations.
   */
  allowOverwrite?: InputMaybe<Scalars['Boolean']>;
  /** The Contentful entry IDs to translate. All entries must be in the same space/environment. */
  contentfulEntryIds: Array<Scalars['ID']>;
  /** The Contentful environment ID (e.g., "master"). */
  contentfulEnvironmentId: Scalars['ID'];
  /** The Contentful space ID where the entries reside. */
  contentfulSpaceId: Scalars['ID'];
  /** Source language code for translation (e.g., "en", "pt-BR"). */
  sourceLanguageCode: Scalars['ContentfulTranslation_CourseraLanguageCode'];
  /** Target language codes to translate into (e.g., ["es", "fr", "pt-BR"]). */
  targetLanguageCodes: Array<Scalars['ContentfulTranslation_CourseraLanguageCode']>;
};

export const ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Running: 'RUNNING',
  Successful: 'SUCCESSFUL'
} as const;

export type ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus = typeof ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus[keyof typeof ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration = {
  Active: 'ACTIVE',
  AfterCutoffDate: 'AFTER_CUTOFF_DATE',
  All: 'ALL',
  None: 'NONE',
  OnlyFreeEnrollments: 'ONLY_FREE_ENROLLMENTS',
  Overage: 'OVERAGE',
  Selected: 'SELECTED'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration = {
  All: 'ALL',
  None: 'NONE'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration = {
  Active: 'ACTIVE',
  All: 'ALL',
  None: 'NONE',
  Selected: 'SELECTED'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration];
/** Input argument for create new branch. */
export type CoreSkillTaxonomyBranch_CreateNewBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for deactivate branch. */
export type CoreSkillTaxonomyBranch_DeactivateBranchInput = {
  /** Flag to force deactivate freeze branch */
  includeFreezeBranch?: Scalars['Boolean'];
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for freeze branch. */
export type CoreSkillTaxonomyBranch_FreezeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for merge branch. */
export type CoreSkillTaxonomyBranch_MergeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Sorting direction for the SkillTag based on the TaxonomyBranchContent */
export const CoreSkillTaxonomyBranch_Status = {
  /** branch active for editing */
  Active: 'ACTIVE',
  /** branch deactivated for all operation other than deletion */
  Deactivate: 'DEACTIVATE',
  /** branch freezed for labelling and A/B testing */
  Freeze: 'FREEZE',
  /** branch has been merged into main */
  Merged: 'MERGED'
} as const;

export type CoreSkillTaxonomyBranch_Status = typeof CoreSkillTaxonomyBranch_Status[keyof typeof CoreSkillTaxonomyBranch_Status];
/** Input argument for delete nodes by branch. */
export type CoreSkillTaxonomyNode_DeleteNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** Skill node ids to be deleted. */
  nodeIds: Array<Scalars['ID']>;
};

/** Skill node for upsert */
export type CoreSkillTaxonomyNode_NodeInput = {
  /** Skill children nodes id. */
  childrenNodes: Array<Scalars['ID']>;
  /** mapped Coursera content domains that */
  courseraContentDomains: Array<Scalars['String']>;
  /** Skill description. */
  desc: Scalars['String'];
  /** Skill id. */
  id: Scalars['ID'];
  /**
   * Flag indicating whether a skill is part of our clean taxonomy, which has been
   * vetted for quality. Currently BTD only. Currently eligible for "precise" skill-content tags.
   */
  isHumanSkill: Scalars['Boolean'];
  /** if the skill is programming language */
  isProgrammingLanguage: Scalars['Boolean'];
  /** if the skill is tool or software */
  isToolSoftware: Scalars['Boolean'];
  /** Skill name. */
  name: Scalars['String'];
  /** Data source for the skill. */
  source: CoreSkillTaxonomyNode_Source;
};

/** Enum for skill source */
export const CoreSkillTaxonomyNode_Source = {
  /** From burning glass */
  BurningGlass: 'BURNING_GLASS',
  /** From Coursera */
  Coursera: 'COURSERA',
  /** From CSM */
  Csm: 'CSM',
  /** From Skill trans */
  SkillTrans: 'SKILL_TRANS',
  /** From Wikipedia */
  Wikipedia: 'WIKIPEDIA'
} as const;

export type CoreSkillTaxonomyNode_Source = typeof CoreSkillTaxonomyNode_Source[keyof typeof CoreSkillTaxonomyNode_Source];
/** Input argument for upsert nodes by branch. */
export type CoreSkillTaxonomyNode_UpsertNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** Skill node to be upserted. */
  nodes: Array<CoreSkillTaxonomyNode_NodeInput>;
};

/** 2-letter ISO country codes. */
export const CountryCode = {
  /** Andorra */
  Ad: 'AD',
  /** United Arab Emirates */
  Ae: 'AE',
  /** Afghanistan */
  Af: 'AF',
  /** Antigua and Barbuda */
  Ag: 'AG',
  /** Anguilla */
  Ai: 'AI',
  /** Albania */
  Al: 'AL',
  /** Armenia */
  Am: 'AM',
  /** Netherland Antilles */
  An: 'AN',
  /** Angola */
  Ao: 'AO',
  /** Antarctica */
  Aq: 'AQ',
  /** Argentina */
  Ar: 'AR',
  /** American Samoa */
  As: 'AS',
  /** Austria */
  At: 'AT',
  /** Australia */
  Au: 'AU',
  /** Aruba */
  Aw: 'AW',
  /** Azerbaijan */
  Az: 'AZ',
  /** Bosnia- Herzegovina */
  Ba: 'BA',
  /** Barbados */
  Bb: 'BB',
  /** Bangladesh */
  Bd: 'BD',
  /** Belgium */
  Be: 'BE',
  /** Burkina Faso */
  Bf: 'BF',
  /** Bulgaria */
  Bg: 'BG',
  /** Bahrain */
  Bh: 'BH',
  /** Burundi */
  Bi: 'BI',
  /** Benin */
  Bj: 'BJ',
  /** Bermuda */
  Bm: 'BM',
  /** Brunei Darussalam */
  Bn: 'BN',
  /** Bolivia */
  Bo: 'BO',
  /** Brazil */
  Br: 'BR',
  /** Bahamas */
  Bs: 'BS',
  /** Bhutan */
  Bt: 'BT',
  /** Bouvet Island */
  Bv: 'BV',
  /** Botswana */
  Bw: 'BW',
  /** Belarus */
  By: 'BY',
  /** Belize */
  Bz: 'BZ',
  /** Canada */
  Ca: 'CA',
  /** Cocos (Keeling) Islands */
  Cc: 'CC',
  /** Central African Republic */
  Cf: 'CF',
  /** Congo */
  Cg: 'CG',
  /** Switzerland */
  Ch: 'CH',
  /** Ivory Coast */
  Ci: 'CI',
  /** Cook Islands */
  Ck: 'CK',
  /** Chile */
  Cl: 'CL',
  /** Cameroon */
  Cm: 'CM',
  /** China */
  Cn: 'CN',
  /** Colombia */
  Co: 'CO',
  /** Costa Rica */
  Cr: 'CR',
  /** Czechoslovakia (obsolete) */
  Cs: 'CS',
  /** Cuba */
  Cu: 'CU',
  /** Cape Verde */
  Cv: 'CV',
  /** Christmas Island */
  Cx: 'CX',
  /** Cyprus */
  Cy: 'CY',
  /** Czech Republic */
  Cz: 'CZ',
  /** Germany */
  De: 'DE',
  /** Djibouti */
  Dj: 'DJ',
  /** Denmark */
  Dk: 'DK',
  /** Dominica */
  Dm: 'DM',
  /** Dominican Republic */
  Do: 'DO',
  /** Algeria */
  Dz: 'DZ',
  /** Ecuador */
  Ec: 'EC',
  /** Estonia */
  Ee: 'EE',
  /** Egypt */
  Eg: 'EG',
  /** Western Sahara */
  Eh: 'EH',
  /** Eritrea */
  Er: 'ER',
  /** Spain */
  Es: 'ES',
  /** Ethiopia */
  Et: 'ET',
  /** Finland */
  Fi: 'FI',
  /** Fiji */
  Fj: 'FJ',
  /** Falkland Isl.( Malvinas) */
  Fk: 'FK',
  /** Micronesia */
  Fm: 'FM',
  /** Faroe Islands */
  Fo: 'FO',
  /** France */
  Fr: 'FR',
  /** France (Europe only) */
  Fx: 'FX',
  /** Gabon */
  Ga: 'GA',
  /** Great Britain (UK) */
  Gb: 'GB',
  /** Grenada */
  Gd: 'GD',
  /** Georgia */
  Ge: 'GE',
  /** Guyana (Fr.) */
  Gf: 'GF',
  /** Ghana */
  Gh: 'GH',
  /** Gibraltar */
  Gi: 'GI',
  /** Greenland */
  Gl: 'GL',
  /** Gambia */
  Gm: 'GM',
  /** Guinea */
  Gn: 'GN',
  /** Guadeloupe (Fr.) */
  Gp: 'GP',
  /** Equatorial Guinea */
  Gq: 'GQ',
  /** Greece */
  Gr: 'GR',
  /** South Georgia & South Sandwich Islands */
  Gs: 'GS',
  /** Guatemala */
  Gt: 'GT',
  /** Guam (US) */
  Gu: 'GU',
  /** Guinea Bissau */
  Gw: 'GW',
  /** Guyana */
  Gy: 'GY',
  /** Hong Kong */
  Hk: 'HK',
  /** Heard & McDonald Islands */
  Hm: 'HM',
  /** Honduras */
  Hn: 'HN',
  /** Croatia */
  Hr: 'HR',
  /** Haiti */
  Ht: 'HT',
  /** Hungary */
  Hu: 'HU',
  /** Indonesia */
  Id: 'ID',
  /** Ireland */
  Ie: 'IE',
  /** Israel */
  Il: 'IL',
  /** India */
  In: 'IN',
  /** British Indian Ocean Terr. */
  Io: 'IO',
  /** Iraq */
  Iq: 'IQ',
  /** Iran */
  Ir: 'IR',
  /** Iceland */
  Is: 'IS',
  /** Italy */
  It: 'IT',
  /** Jamaica */
  Jm: 'JM',
  /** Jordan */
  Jo: 'JO',
  /** Japan */
  Jp: 'JP',
  /** Kenya */
  Ke: 'KE',
  /** Kyrgyz Republic */
  Kg: 'KG',
  /** Cambodia */
  Kh: 'KH',
  /** Kiribati */
  Ki: 'KI',
  /** Comoros */
  Km: 'KM',
  /** St. Kitts Nevis Anguilla */
  Kn: 'KN',
  /** Korea (North) */
  Kp: 'KP',
  /** Korea (South) */
  Kr: 'KR',
  /** Kuwait */
  Kw: 'KW',
  /** Cayman Islands */
  Ky: 'KY',
  /** Kazachstan */
  Kz: 'KZ',
  /** Laos */
  La: 'LA',
  /** Lebanon */
  Lb: 'LB',
  /** Saint Lucia */
  Lc: 'LC',
  /** Liechtenstein */
  Li: 'LI',
  /** Sri Lanka */
  Lk: 'LK',
  /** Liberia */
  Lr: 'LR',
  /** Lesotho */
  Ls: 'LS',
  /** Lithuania */
  Lt: 'LT',
  /** Luxembourg */
  Lu: 'LU',
  /** Latvia */
  Lv: 'LV',
  /** Libya */
  Ly: 'LY',
  /** Morocco */
  Ma: 'MA',
  /** Monaco */
  Mc: 'MC',
  /** Moldova */
  Md: 'MD',
  /** Madagascar */
  Mg: 'MG',
  /** Marshall Islands */
  Mh: 'MH',
  /** Macedonia (prev. Yug.) */
  Mk: 'MK',
  /** Mali */
  Ml: 'ML',
  /** Myanmar */
  Mm: 'MM',
  /** Mongolia */
  Mn: 'MN',
  /** Macau */
  Mo: 'MO',
  /** Northern Mariana Islands */
  Mp: 'MP',
  /** Martinique (Fr.) */
  Mq: 'MQ',
  /** Mauritania */
  Mr: 'MR',
  /** Montserrat */
  Ms: 'MS',
  /** Malta */
  Mt: 'MT',
  /** Mauritius */
  Mu: 'MU',
  /** Maldives */
  Mv: 'MV',
  /** Malawi */
  Mw: 'MW',
  /** Mexico */
  Mx: 'MX',
  /** Malaysia */
  My: 'MY',
  /** Mozambique */
  Mz: 'MZ',
  /** Namibia */
  Na: 'NA',
  /** New Caledonia Fr. */
  Nc: 'NC',
  /** Niger */
  Ne: 'NE',
  /** Norfolk Island */
  Nf: 'NF',
  /** Nigeria */
  Ng: 'NG',
  /** Nicaragua */
  Ni: 'NI',
  /** Netherlands */
  Nl: 'NL',
  /** Norway */
  No: 'NO',
  /** Nepal */
  Np: 'NP',
  /** Nauru */
  Nr: 'NR',
  /** Niue */
  Nu: 'NU',
  /** New Zealand */
  Nz: 'NZ',
  /** Oman */
  Om: 'OM',
  /** Panama */
  Pa: 'PA',
  /** Peru */
  Pe: 'PE',
  /** Polynesia (Fr.) */
  Pf: 'PF',
  /** Papua New Guinea */
  Pg: 'PG',
  /** Philippines */
  Ph: 'PH',
  /** Pakistan */
  Pk: 'PK',
  /** Poland */
  Pl: 'PL',
  /** St. Pierre & Miquelon */
  Pm: 'PM',
  /** Pitcairn */
  Pn: 'PN',
  /** Puerto Rico (US) */
  Pr: 'PR',
  /** Portugal */
  Pt: 'PT',
  /** Palau */
  Pw: 'PW',
  /** Paraguay */
  Py: 'PY',
  /** Qatar */
  Qa: 'QA',
  /** Reunion (Fr.) */
  Re: 'RE',
  /** Romania */
  Ro: 'RO',
  /** Russian Federation */
  Ru: 'RU',
  /** Rwanda */
  Rw: 'RW',
  /** Saudi Arabia */
  Sa: 'SA',
  /** Solomon Islands */
  Sb: 'SB',
  /** Seychelles */
  Sc: 'SC',
  /** Sudan */
  Sd: 'SD',
  /** Sweden */
  Se: 'SE',
  /** Singapore */
  Sg: 'SG',
  /** St. Helena */
  Sh: 'SH',
  /** Slovenia */
  Si: 'SI',
  /** Svalbard& Jan Mayen Islands */
  Sj: 'SJ',
  /** Slovakia (Slovak Republic) */
  Sk: 'SK',
  /** Sierra Leone */
  Sl: 'SL',
  /** San Marino */
  Sm: 'SM',
  /** Senegal */
  Sn: 'SN',
  /** Somalia */
  So: 'SO',
  /** Suriname */
  Sr: 'SR',
  /** St. Tome and Principe */
  St: 'ST',
  /** Soviet Union (obsolete) */
  Su: 'SU',
  /** El Salvador */
  Sv: 'SV',
  /** Syria */
  Sy: 'SY',
  /** Swaziland */
  Sz: 'SZ',
  /** Turks& Caicos Islands */
  Tc: 'TC',
  /** Chad */
  Td: 'TD',
  /** French Southern Territory */
  Tf: 'TF',
  /** Togo */
  Tg: 'TG',
  /** Thailand */
  Th: 'TH',
  /** Tadjikistan */
  Tj: 'TJ',
  /** Tokelau */
  Tk: 'TK',
  /** Turkmenistan */
  Tm: 'TM',
  /** Tunisia */
  Tn: 'TN',
  /** Tonga */
  To: 'TO',
  /** East Timor */
  Tp: 'TP',
  /** Turkey */
  Tr: 'TR',
  /** Trinidad Tobago */
  Tt: 'TT',
  /** Tuvalu */
  Tv: 'TV',
  /** Taiwan */
  Tw: 'TW',
  /** Tanzania */
  Tz: 'TZ',
  /** Ukraine */
  Ua: 'UA',
  /** Uganda */
  Ug: 'UG',
  /** United Kingdom */
  Uk: 'UK',
  /** US Minor outlying Islands */
  Um: 'UM',
  /** United States */
  Us: 'US',
  /** Uruguay */
  Uy: 'UY',
  /** Uzbekistan */
  Uz: 'UZ',
  /** Vatican City State */
  Va: 'VA',
  /** St. Vincent& Grenadines */
  Vc: 'VC',
  /** Venezuela */
  Ve: 'VE',
  /** VirginIslands (GB) */
  Vg: 'VG',
  /** Virgin Islands (US) */
  Vi: 'VI',
  /** Vietnam */
  Vn: 'VN',
  /** Vanuatu */
  Vu: 'VU',
  /** Wallis & Futuna Islands */
  Wf: 'WF',
  /** Samoa */
  Ws: 'WS',
  /** Yemen */
  Ye: 'YE',
  /** Mayotte */
  Yt: 'YT',
  /** Yugoslavia (obsolete) */
  Yu: 'YU',
  /** South Africa */
  Za: 'ZA',
  /** Zambia */
  Zm: 'ZM',
  /** Zaire */
  Zr: 'ZR',
  /** Zimbabwe */
  Zw: 'ZW',
  /** Global country code is to be used as a default fallback */
  Global: 'global'
} as const;

export type CountryCode = typeof CountryCode[keyof typeof CountryCode];
/** Distinction achieved by a learner getting a grade for a course */
export const CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** It is necessary to differentiate Spark and OnDemand courses because not all features can not treat these as the same thing. For example, we may have an upsell feature that prompts you to take a specialization if you took a course that is part of it. We wouldn't want this feature to treat all certs the same because Spark Courses/Specializations are no longer available. A SparkCourse Cert vs OnDemandCourse Cert shouldn't be considered as a different "type" of certificate though as they store the exact same fields. However a Course and a Specialization should be considered as different types as they are a completely different product */
export const CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin = {
  OnDemand: 'ON_DEMAND',
  Spark: 'SPARK'
} as const;

export type CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin = typeof CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin[keyof typeof CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin];
/** Input for an answer option with correctness */
export type CourseBuilderV2_AnswerOptionWithCorrectnessInput = {
  /** Answer option text */
  answer: Scalars['String'];
  /** Feedback for the answer option */
  feedback: Scalars['String'];
  /** Indicates if the answer option is correct */
  isCorrect: Scalars['Boolean'];
};

/** Input for an answer option with ID */
export type CourseBuilderV2_AnswerOptionWithIdInput = {
  /** Answer option text */
  answer: Scalars['String'];
  /** Feedback for the answer option */
  feedback: Scalars['String'];
  /** ID of the answer option */
  id: Scalars['ID'];
};

/** Assessment attempt configuration input */
export type CourseBuilderV2_AssessmentAttemptConfigurationInput = {
  /**
   * Number of attempts allowed
   * Can be null if unlimited attempts are allowed
   */
  attemptLimit?: InputMaybe<Scalars['Int']>;
  /**
   * Rate Limit Configuration
   * Can be null if no rate limit is set
   */
  rateLimitConfiguration?: InputMaybe<CourseBuilderV2_AssessmentRateLimitConfigurationInput>;
  /**
   * Submission limit for each attempt
   * Can be null if no submission limit is set
   */
  submissionLimitForEachAttempt?: InputMaybe<Scalars['Int']>;
  /**
   * Time limit for each attempt in milliseconds
   * Can be null if no time limit is set
   */
  timeLimitForEachAttempt?: InputMaybe<Scalars['Int']>;
};

/** Assessment generation configuration input */
export type CourseBuilderV2_AssessmentGenerationConfigurationInput = {
  /** Question generation input */
  generationInput: CourseBuilderV2_StartAssessmentGenerationInput;
  /** Number of questions learners will see per module */
  questionsForLearnersPerModule: Scalars['Int'];
};

/**
 * Enum representing the types of feedback level
 * QuestionGenerator_FeedbackType
 */
export const CourseBuilderV2_AssessmentGeneratorFeedbackType = {
  /** All relevant feedback provided */
  Full: 'FULL',
  /** Correct answer is not disclosed */
  Graded: 'GRADED',
  /** No feedback provided */
  None: 'NONE'
} as const;

export type CourseBuilderV2_AssessmentGeneratorFeedbackType = typeof CourseBuilderV2_AssessmentGeneratorFeedbackType[keyof typeof CourseBuilderV2_AssessmentGeneratorFeedbackType];
/**
 * Enum representing the types of questions the AI can generate
 * QuestionGenerator_QuestionType
 */
export const CourseBuilderV2_AssessmentGeneratorQuestionType = {
  /** Code expression question */
  AiGraded: 'AI_GRADED',
  /** Checkboxes question */
  Checkbox: 'CHECKBOX',
  /** Code expression question */
  CodeExpression: 'CODE_EXPRESSION',
  /** Multi-choice questions, or checkboxes */
  MultipleChoice: 'MULTIPLE_CHOICE',
  /** Number match questions */
  Number: 'NUMBER',
  /** Text match questions */
  TextExactMatch: 'TEXT_EXACT_MATCH'
} as const;

export type CourseBuilderV2_AssessmentGeneratorQuestionType = typeof CourseBuilderV2_AssessmentGeneratorQuestionType[keyof typeof CourseBuilderV2_AssessmentGeneratorQuestionType];
/** Specify type of Assessment Outline */
export const CourseBuilderV2_AssessmentOutlineType = {
  /** Final exam */
  FinalExam: 'FINAL_EXAM',
  /** Module quiz */
  ModuleQuiz: 'MODULE_QUIZ'
} as const;

export type CourseBuilderV2_AssessmentOutlineType = typeof CourseBuilderV2_AssessmentOutlineType[keyof typeof CourseBuilderV2_AssessmentOutlineType];
/** Assessment Rate Limit Configuration */
export type CourseBuilderV2_AssessmentRateLimitConfigurationInput = {
  /** Number of attempts allowed */
  numberOfAttempts: Scalars['Int'];
  /** Time interval for each attempt in milliseconds */
  timeInterval: Scalars['Int'];
};

/** Input for an assignment segment */
export type CourseBuilderV2_AssignmentSegmentInput = {
  /** Check box question */
  checkBoxQuestion?: InputMaybe<CourseBuilderV2_CheckBoxQuestionInput>;
  /** Check box reflect question */
  checkBoxReflectQuestion?: InputMaybe<CourseBuilderV2_CheckBoxReflectQuestionInput>;
  /** Manual graded question */
  manualGradedQuestion?: InputMaybe<CourseBuilderV2_ManualGradedQuestionInput>;
  /** Math expression question */
  mathExpressionQuestion?: InputMaybe<CourseBuilderV2_MathExpressionQuestionInput>;
  /** Multiple choice question */
  multipleChoiceQuestion?: InputMaybe<CourseBuilderV2_MultipleChoiceQuestionInput>;
  /** Multiple choice reflect question */
  multipleChoiceReflectQuestion?: InputMaybe<CourseBuilderV2_MultipleChoiceReflectQuestionInput>;
  /** Multiple dropdown question */
  multipleDropdownQuestion?: InputMaybe<CourseBuilderV2_MultipleDropdownQuestionInput>;
  /** Numeric question */
  numericQuestion?: InputMaybe<CourseBuilderV2_NumericQuestionInput>;
  /** Regex question */
  regexQuestion?: InputMaybe<CourseBuilderV2_RegexQuestionInput>;
  /** Text block with learner instructions */
  textBlockQuestion?: InputMaybe<CourseBuilderV2_TextBlockQuestionInput>;
  /** Text exact match question */
  textExactMatchQuestion?: InputMaybe<CourseBuilderV2_TextExactMatchQuestionInput>;
  /** Text reflect question */
  textReflectQuestion?: InputMaybe<CourseBuilderV2_TextReflectQuestionInput>;
};

/** Generation source for generated atom underlying the course item */
export const CourseBuilderV2_AtomGenerationSource = {
  /** Atom was generated by AI */
  Ai: 'AI',
  /** Atom was generated by a user */
  User: 'USER'
} as const;

export type CourseBuilderV2_AtomGenerationSource = typeof CourseBuilderV2_AtomGenerationSource[keyof typeof CourseBuilderV2_AtomGenerationSource];
/** Input for a checkbox question */
export type CourseBuilderV2_CheckBoxQuestionInput = {
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** A list of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflect question */
export type CourseBuilderV2_CheckBoxReflectQuestionInput = {
  /** A list of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Range specifying a portion of split text and docx files converted to cml */
export type CourseBuilderV2_CmlRangeInput = {
  /** CML content */
  cml: Cml_CmlInput;
  /**
   * CML content
   * @deprecated Use properly typed `cml` field instead
   */
  cmlContent?: InputMaybe<Scalars['String']>;
};

/** Course item input */
export type CourseBuilderV2_CourseItemInput = {
  /** Assessment outline item */
  assessmentOutlineItem?: InputMaybe<CourseBuilderV2_GeneratedAssessmentOutlineItemInput>;
  /** Curated item */
  curatedItem?: InputMaybe<CourseBuilderV2_CuratedItemInput>;
  /** Generated asset item */
  generatedAssetItem?: InputMaybe<CourseBuilderV2_GeneratedAssetItemInput>;
  /** Placeholder item */
  placeholderItem?: InputMaybe<CourseBuilderV2_PlaceholderItemInput>;
  /** Unmatched search term */
  unmatchedSearchTerm?: InputMaybe<Scalars['String']>;
};

/** Course item type */
export const CourseBuilderV2_CourseItemType = {
  /** Assignment */
  Assignment: 'ASSIGNMENT',
  /** Dialogue */
  Dialogue: 'DIALOGUE',
  /** Discussion Prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** LTI or App Item */
  Lti: 'LTI',
  /** Peer Review Assignment */
  PeerReview: 'PEER_REVIEW',
  /** Programming Assignment */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /** Role Play */
  RolePlay: 'ROLE_PLAY',
  /** Teammate Review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** UNGRADED_LAB */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget (aka Plugin) */
  Widget: 'WIDGET'
} as const;

export type CourseBuilderV2_CourseItemType = typeof CourseBuilderV2_CourseItemType[keyof typeof CourseBuilderV2_CourseItemType];
/** Course length */
export type CourseBuilderV2_CourseLengthInput = {
  /** Desired length of the course in hours */
  numHours: Scalars['Int'];
  /** Desired number of modules to generate, inferred on the server if not provided */
  numModules?: InputMaybe<Scalars['Int']>;
};

/** Course length specified using number of modules or a range of modules */
export type CourseBuilderV2_CourseLengthModuleBasedInput = {
  /** Specify a range of number of modules to generate */
  moduleRange?: InputMaybe<CourseBuilderV2_CourseLengthModuleRangeInput>;
  /** Specify a fixed number of modules to generate */
  numModules?: InputMaybe<Scalars['Int']>;
};

/** Course length specified using number of modules */
export type CourseBuilderV2_CourseLengthModuleRangeInput = {
  /** Maximum number of modules to generate */
  maxModules: Scalars['Int'];
  /** Minimum number of modules to generate */
  minModules: Scalars['Int'];
};

/** Fields required when creating a new workflow for the first time */
export type CourseBuilderV2_CreateWorkflowInput = {
  /** The authoring branch the workflow is associated with */
  authoringBranchId: Scalars['ID'];
  /** The course the workflow is associated with */
  courseId: Scalars['ID'];
  /**
   * Primary language code associated with the parent course.
   * This is its own field because the workflow stores a denormalized copy of the language code for use
   * in curation, generation, etc. The source of truth for inputting the language code is moving to the
   * StartGeneratingCourseOutlineWithModulesAndLearningObjectivesInput directly so that the code can be updated after
   * creation
   */
  languageCode: Scalars['String'];
};

/** Curated item input */
export type CourseBuilderV2_CuratedItemInput = {
  /** ID of the underlying atom */
  atomId: Scalars['ID'];
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: InputMaybe<Scalars['String']>;
  /** Range specifing the start and end for of the trim, if the user chose to edit the trim manually */
  itemRange?: InputMaybe<CourseBuilderV2_ItemRangeInput>;
  /** Item type of the curated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** Generated learning objectives from atom-summative-application */
  learningObjectives?: InputMaybe<Array<Scalars['String']>>;
  /** Item name */
  name: Scalars['String'];
  /** If multiple items are curated from the same course, this will point at the next item */
  nextAtomId?: InputMaybe<Scalars['ID']>;
  /** If multiple items are curated from the same course, this will point at the previous item */
  previousAtomId?: InputMaybe<Scalars['ID']>;
  /**
   * Generated rationale explaining why a curated item was placed in a particular location within a
   * course outline.
   */
  rationale?: InputMaybe<Scalars['String']>;
  /**
   * Search terms from which this item was curated, either during the initial
   * CURATING_ITEMS_FOR_LEARNING_OBJECTIVES step or as a result of manual user refinement
   */
  searchTerms?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the source branch the atom was curated from */
  sourceAuthoringBranchId: Scalars['ID'];
  /** ID of the course from which the item originated */
  sourceCourseId: Scalars['ID'];
  /** ID of the item in its source authoring branch. Added on 3/5/24, earlier curated items will not have this field */
  sourceItemId?: InputMaybe<Scalars['ID']>;
  /** Item summary */
  summary: Scalars['String'];
  /**
   * AI-assigned search terms associated with this item. As we pull in surrounding items when items
   * are curated, it's possible for tagged search terms to differ from the original input search
   * terms, so we track these separately for forensic purposes.
   */
  taggedSearchTerms?: InputMaybe<Array<Scalars['String']>>;
  /** Item time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Enum representing the difficulty level of the course for learners */
export const CourseBuilderV2_DifficultyLevel = {
  /** Advanced */
  Advanced: 'ADVANCED',
  /** Beginner */
  Beginner: 'BEGINNER',
  /** Intermediate */
  Intermediate: 'INTERMEDIATE'
} as const;

export type CourseBuilderV2_DifficultyLevel = typeof CourseBuilderV2_DifficultyLevel[keyof typeof CourseBuilderV2_DifficultyLevel];
/** Input for a fillable blank */
export type CourseBuilderV2_FillableBlankInput = {
  /** Fillable blank populated by multiple choice options */
  multipleChoiceFillableBlank?: InputMaybe<CourseBuilderV2_MultipleChoiceFillableBlankInput>;
};

/** Any data for Assignment items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalAssignmentDataInput = {
  /** Configuration for assessment attempts */
  assessmentAttemptConfiguration?: InputMaybe<CourseBuilderV2_AssessmentAttemptConfigurationInput>;
  /** Assignment level rubrics */
  assignmentLevelRubrics?: InputMaybe<Array<CourseBuilderV2_RubricPartInput>>;
  /** Assignment segments */
  assignmentSegments: Array<CourseBuilderV2_AssignmentSegmentInput>;
  /** Instructions for graders */
  graderInstructions?: InputMaybe<Scalars['String']>;
  /** Indicates if it is a team assignment */
  isTeamAssignment?: InputMaybe<Scalars['Boolean']>;
  /** Visibility of learner feedback post grade release */
  learnerFeedbackVisibility?: InputMaybe<CourseBuilderV2_LearnerPostreleaseVisibility>;
  /** Visibility of learner submission post submission */
  learnerSubmissionVisibility?: InputMaybe<CourseBuilderV2_LearnerPostsubmitVisibility>;
  /** Passing fraction */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Review criteria */
  reviewCriteria?: InputMaybe<Scalars['String']>;
  /** Indicates if the grade should be shown on grade release */
  showGradeOnGradeRelease?: InputMaybe<Scalars['Boolean']>;
};

/**
 * A container for all data that is specific to a particular item type; some item types such as Reading don't require any additional data, so there will be no
 * field for such item types in this message.
 */
export type CourseBuilderV2_FullItemAdditionalDataInput = {
  /** Container for any data for a fully fleshed Assignment item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalAssignmentData?: InputMaybe<CourseBuilderV2_FullItemAdditionalAssignmentDataInput>;
  /** Container for any data for a fully fleshed Discussion Prompt item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalDiscussionPromptData?: InputMaybe<CourseBuilderV2_FullItemAdditionalDiscussionPromptDataInput>;
  /** Container for any data for a fully fleshed Lecture item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalLectureData?: InputMaybe<CourseBuilderV2_FullItemAdditionalLectureDataInput>;
  /** Container for any data for a fully fleshed Widget item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalWidgetData?: InputMaybe<CourseBuilderV2_FullItemAdditionalWidgetDataInput>;
};

/** Any data for Discussion Prompt items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalDiscussionPromptDataInput = {
  /** The prompt for the discussion */
  prompt: Scalars['String'];
  /** The title for the discussion prompt */
  title: Scalars['String'];
};

/** Any data for Lecture items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalLectureDataInput = {
  /** List of language codes and subtitle asset IDs for those languages */
  languageSubtitleAssetIds: Array<CourseBuilderV2_LanguageSubtitleAssetIdInput>;
};

/** Any data for Widget items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalWidgetDataInput = {
  /** Configuration of the widget with fields which are tied to the used widget ID */
  configuration: Scalars['JSON'];
  /** Title of the iframe hosting the plugin in the UI */
  iframeTitle: Scalars['String'];
  /**
   * Captures the broad categories of widgets that can be extracted from source content
   * @deprecated widget categories are internal to the backend distillation step and should not be relied upon by clients. Use the widgetId instead where needed.
   */
  widgetCategory?: InputMaybe<CourseBuilderV2_WidgetCategory>;
  /** Coursera widget ID identifying the widget that is used for this item */
  widgetId: Scalars['ID'];
};

/** Generate assessment outline item input */
export type CourseBuilderV2_GenerateAssessmentOutlineItemInput = {
  /** attempt configuration of the assessment */
  attemptConfiguration: CourseBuilderV2_AssessmentAttemptConfigurationInput;
};

/** CourseBuilderV2_GenerateAssessmentsOutline mutation input */
export type CourseBuilderV2_GenerateAssessmentsOutlineItemsInput = {
  /**
   * Generate final exam assessments
   * Can be null if no final exam is needed
   */
  finalExam?: InputMaybe<CourseBuilderV2_GenerateAssessmentOutlineItemInput>;
  /**
   * Generate module quiz assessments
   * Can be null if no module quizzes are needed
   */
  moduleQuiz?: InputMaybe<CourseBuilderV2_GenerateAssessmentOutlineItemInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** Generated assessment outline item input */
export type CourseBuilderV2_GeneratedAssessmentOutlineItemInput = {
  /** Type of this assessment; either module quiz or final exam */
  assessmentOutlineType: CourseBuilderV2_AssessmentOutlineType;
  /** attempt configuration of the assessment */
  attemptConfiguration: CourseBuilderV2_AssessmentAttemptConfigurationInput;
  /** when true: it is a graded assignment; when false: it is a practice assignment */
  isGraded: Scalars['Boolean'];
  /** Item type of the curated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** name of the assessment */
  name: Scalars['String'];
  /** question generation configuration of the assessment */
  questionGenerationConfiguration: CourseBuilderV2_AssessmentGenerationConfigurationInput;
  /** specifies whether the assessment outline has been reviewed by the author */
  reviewed: Scalars['Boolean'];
};

/** Generated asset item input */
export type CourseBuilderV2_GeneratedAssetItemInput = {
  /**
   * ID for a generated asset item, if the item is unchanged this refers to the original uploaded
   * asset. For asset items that have been split corresponds to {originalAssetId}~{hashOfSplitRange}
   */
  assetId: Scalars['ID'];
  /**
   * With the introduction of Smart Ingestion, it is possible that some items will actually not be
   * generated by AI but ingested almost verbatim from user provided content; this field will help
   * track that on item level, allowing further manipulation by AI on ingested items to be tracked.
   */
  atomGenerationSource?: InputMaybe<CourseBuilderV2_AtomGenerationSource>;
  /** S3 path of extracted file content in textual form */
  contentPath: Scalars['String'];
  /**
   * If full item data is required by the current workflow type, this field will be populated with
   * it for the appropriate item type.
   */
  fullItemAdditionalData?: InputMaybe<CourseBuilderV2_FullItemAdditionalDataInput>;
  /** Atom id that corresponds to the item that was created as a part of this generated asset. */
  generatedAtomId?: InputMaybe<Scalars['ID']>;
  /** Range specifying the start and end for the split, if the user chose to edit the split manually */
  itemRange?: InputMaybe<CourseBuilderV2_ItemRangeInput>;
  /** Assigned item type, based on the input file format. */
  itemType: CourseBuilderV2_CourseItemType;
  /** A key to uniquely identify this item; optional since not all flows use this field */
  key?: InputMaybe<Scalars['String']>;
  /** Generated item name */
  name: Scalars['String'];
  /** ID of the original input asset used to generate this item, present when an item has been split */
  originalAssetId?: InputMaybe<Scalars['ID']>;
  /** Time commitment of the original asset */
  originalTimeCommitment?: InputMaybe<Scalars['Duration']>;
  /**
   * Generated rationale explaining why a generated asset item was placed in a particular location
   * within a course outline.
   */
  rationale?: InputMaybe<Scalars['String']>;
  /** Generated item summary */
  summary: Scalars['String'];
  /** Time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Input for a graded text box rubric part */
export type CourseBuilderV2_GradedTextBoxRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
  /** Points value for the rubric */
  points: Scalars['Float'];
};

/** Input for an inline feedback rubric part */
export type CourseBuilderV2_InlineFeedbackRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** Union of all the different types of item ranges for auto-split items */
export type CourseBuilderV2_ItemRangeInput = {
  /** Range specifing the start and end pages for split text and docx files */
  cmlRange?: InputMaybe<CourseBuilderV2_CmlRangeInput>;
  /** Range specifing the start and end pages for split PDFs */
  pageRange?: InputMaybe<CourseBuilderV2_PageRangeInput>;
  /** Range specifing the start and end timestamps for split/trimmed videos */
  timestampRange?: InputMaybe<CourseBuilderV2_TimestampRangeInput>;
};

/** Mapping fields */
export type CourseBuilderV2_ItemSkillMappingFieldsInput = {
  /** The programming language ids */
  programmingLanguageIds: Array<Scalars['ID']>;
  /** The skill expressions IDs */
  skillExpressionIds: Array<Scalars['ID']>;
  /** The tool ids */
  toolIds: Array<Scalars['ID']>;
  /** The skill content type */
  verifiedSkillsContentType: CourseBuilderV2_VerifiedSkillsContentType;
};

/** The mapping between item and skills input */
export type CourseBuilderV2_ItemSkillMappingInput = {
  /** Item id */
  itemId: Scalars['ID'];
  /** Mapping value */
  value: CourseBuilderV2_ItemSkillMappingFieldsInput;
};

/** Language code and the subtitle asset ID for that language input fields */
export type CourseBuilderV2_LanguageSubtitleAssetIdInput = {
  /** Asset ID for the subtitle asset in the designated language */
  assetId: Scalars['ID'];
  /** Language code (e.g., en, fr, es) */
  languageCode: Scalars['String'];
};

/** Visibility of learner feedback post grade release */
export const CourseBuilderV2_LearnerPostreleaseVisibility = {
  /** Grade is fully visible post grade release */
  LearnerPostreleaseVisibilityFull: 'LEARNER_POSTRELEASE_VISIBILITY_FULL',
  /** Grade is not visible post grade release */
  LearnerPostreleaseVisibilityLimited: 'LEARNER_POSTRELEASE_VISIBILITY_LIMITED',
  /** Grade is partially visible post grade release */
  LearnerPostreleaseVisibilityPartial: 'LEARNER_POSTRELEASE_VISIBILITY_PARTIAL'
} as const;

export type CourseBuilderV2_LearnerPostreleaseVisibility = typeof CourseBuilderV2_LearnerPostreleaseVisibility[keyof typeof CourseBuilderV2_LearnerPostreleaseVisibility];
/** Visibility of learner submission post submission */
export const CourseBuilderV2_LearnerPostsubmitVisibility = {
  /** Submission is hidden post submission */
  LearnerPostsubmitVisibilityHidden: 'LEARNER_POSTSUBMIT_VISIBILITY_HIDDEN',
  /** Submission is visible post submission */
  LearnerPostsubmitVisibilityVisible: 'LEARNER_POSTSUBMIT_VISIBILITY_VISIBLE'
} as const;

export type CourseBuilderV2_LearnerPostsubmitVisibility = typeof CourseBuilderV2_LearnerPostsubmitVisibility[keyof typeof CourseBuilderV2_LearnerPostsubmitVisibility];
/** Indicates how this question should be graded */
export const CourseBuilderV2_ManualGradedQuestionGraderType = {
  /** graded by AI */
  Ai: 'AI',
  /** Graded by teaching staff (manually graded) */
  Human: 'HUMAN'
} as const;

export type CourseBuilderV2_ManualGradedQuestionGraderType = typeof CourseBuilderV2_ManualGradedQuestionGraderType[keyof typeof CourseBuilderV2_ManualGradedQuestionGraderType];
/** Input for a manually graded question */
export type CourseBuilderV2_ManualGradedQuestionInput = {
  /** Whether the question is an ai-graded question or graded by a human. If none is present, it is human graded. */
  graderType?: InputMaybe<CourseBuilderV2_ManualGradedQuestionGraderType>;
  /** Whether plagiarism detection is enabled for the question */
  plagiarismDetection: Scalars['Boolean'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Response type for the question */
  responseType: CourseBuilderV2_ManualGradedQuestionResponseType;
  /** List of grading rubrics for the question */
  rubrics: Array<CourseBuilderV2_RubricPartInput>;
};

/** Manual graded question response type */
export const CourseBuilderV2_ManualGradedQuestionResponseType = {
  /** File upload response type */
  FileUpload: 'FILE_UPLOAD',
  /** No submission response type */
  NoSubmission: 'NO_SUBMISSION',
  /** Rich text response type */
  RichText: 'RICH_TEXT',
  /** URL response type */
  Url: 'URL'
} as const;

export type CourseBuilderV2_ManualGradedQuestionResponseType = typeof CourseBuilderV2_ManualGradedQuestionResponseType[keyof typeof CourseBuilderV2_ManualGradedQuestionResponseType];
/** Input for a math expression question */
export type CourseBuilderV2_MathExpressionQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Module learning objective input */
export type CourseBuilderV2_ModuleLearningObjectiveInput = {
  /** Flag denoting that a learning objective was AI-generated. */
  aiGenerated?: Scalars['Boolean'];
  /** Unique key for this learning objective, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** The learning objective */
  learningObjective: Scalars['String'];
  /**
   * Optional list of curated items matching one of this learning objective's search terms, or one of
   * the items surrounding a search result.
   */
  matchingCuratedItems?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Optional list of generated asset items matching this learning objective */
  matchingGeneratedItems?: InputMaybe<Array<CourseBuilderV2_GeneratedAssetItemInput>>;
  /** Optional list of curated items retained from a previous iteration matching this learning objective */
  matchingRetainedCuratedItems?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Optional list of search terms that will be used to curate items for this learning objective */
  searchTerms?: InputMaybe<Array<Scalars['String']>>;
};

/** Module skill metadata input */
export type CourseBuilderV2_ModuleSkillMetadataInput = {
  /** The mapping between item and skills, this field will always be null for now since the item level module mapping is not supported yet. */
  itemMappings?: InputMaybe<Array<CourseBuilderV2_ItemSkillMappingInput>>;
  /** The programming language used in this skill. */
  programmingLanguages?: InputMaybe<Array<Scalars['String']>>;
  /** A discrete, observable, and measurable capability that enables a person to perform a specific task or function. */
  skillExpressionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The tools envolved in the skill */
  tools?: InputMaybe<Array<Scalars['String']>>;
};

/** Input for a fillable blank populated by multiple choice options */
export type CourseBuilderV2_MultipleChoiceFillableBlankInput = {
  /** List of answer options with IDs */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** The id of the correct answer option in the list of answers */
  correctAnswerOptionId: Scalars['ID'];
  /** ID of the fillable blank */
  id: Scalars['ID'];
};

/** Input for a multiple choice question */
export type CourseBuilderV2_MultipleChoiceQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflect question */
export type CourseBuilderV2_MultipleChoiceReflectQuestionInput = {
  /** List of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  noChosenFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple dropdown question */
export type CourseBuilderV2_MultipleDropdownQuestionInput = {
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** Placeholders for dropdown questions */
  fillableBlanks: Array<CourseBuilderV2_FillableBlankInput>;
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: InputMaybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML, and contains fillable blanks */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a numeric answer */
export type CourseBuilderV2_NumericAnswerInput = {
  /** Range numeric answer */
  rangeAnswer?: InputMaybe<CourseBuilderV2_RangeNumericAnswerInput>;
  /** Value numeric answer */
  valueAnswer?: InputMaybe<CourseBuilderV2_ValueNumericAnswerInput>;
};

/** Input for a numeric question */
export type CourseBuilderV2_NumericQuestionInput = {
  /** List of numeric answer options */
  answers: Array<CourseBuilderV2_NumericAnswerInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for an options rubric part */
export type CourseBuilderV2_OptionsRubricPartInput = {
  /** Rubric options */
  options: Array<CourseBuilderV2_RubricOptionInput>;
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** Lesson input */
export type CourseBuilderV2_OutlineLessonInput = {
  /** List of items in the lesson. */
  items: Array<CourseBuilderV2_CourseItemInput>;
  /**
   * Unique key for this lesson, used by the FE to optimize list rendering.
   * Optional for backwards compatibility as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  key?: InputMaybe<Scalars['ID']>;
  /**
   * Lesson name.
   * Optional for backwards compatiblity as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  name?: InputMaybe<Scalars['String']>;
};

/** Outline module input */
export type CourseBuilderV2_OutlineModuleInput = {
  /** Approximate length in minutes */
  approximateLengthInMinutes: Scalars['Int'];
  /** Module description */
  description: Scalars['String'];
  /**
   * Optional list of course items that will be placed in this module
   * @deprecated Use `lessons` instead
   */
  items?: InputMaybe<Array<CourseBuilderV2_CourseItemInput>>;
  /** Unique key for this module, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** Module learning objectives */
  learningObjectives: Array<CourseBuilderV2_ModuleLearningObjectiveInput>;
  /** Optional list of lessons that will be placed in this module */
  lessons?: InputMaybe<Array<CourseBuilderV2_OutlineLessonInput>>;
  /** Module name */
  name: Scalars['String'];
  /** The skillmetadata tagged to the module */
  skillMetadata?: InputMaybe<CourseBuilderV2_ModuleSkillMetadataInput>;
};

/** Range specifing the start and end pages for split PDFs */
export type CourseBuilderV2_PageRangeInput = {
  /** End page number */
  endPage: Scalars['Int'];
  /** Start page number */
  startPage: Scalars['Int'];
};

/** Placeholder item input */
export type CourseBuilderV2_PlaceholderItemInput = {
  /**
   * Content generated for the placeholder item based on the generationParameters. As of December 2025, required inputs for
   * various item types' generation APIs are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generatedContent?: InputMaybe<Scalars['JSON']>;
  /**
   * User-editable parameters that will be used as inputs to generate the item content, if present. As of December 2025,
   * the exact parameters for each item type are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generationParameters?: InputMaybe<Scalars['JSON']>;
  /** Item level learning objective for which this item is meant to fulfill */
  itemLevelLearningObjective?: InputMaybe<Scalars['String']>;
  /** Item type to generate */
  itemType: CourseBuilderV2_CourseItemType;
  /** Unique key for this placeholder item, used by FE to distinguish between placeholder items sharing the same name. */
  key?: InputMaybe<Scalars['ID']>;
  /** Name of item */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Search term for which a curated item could not be found, resulting in this placeholder item
   * @deprecated Use `itemLevelLearningObjective` instead
   */
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** Corresponds to the productDifficultyLevel facet in search_hit.proto */
export const CourseBuilderV2_ProductDifficultyLevel = {
  /** Corresponds to facet value "productDifficultyLevel:Advanced" */
  Advanced: 'ADVANCED',
  /** Corresponds to facet value "productDifficultyLevel:Beginner" */
  Beginner: 'BEGINNER',
  /** Corresponds to facet value "productDifficultyLevel:Intermediate" */
  Intermediate: 'INTERMEDIATE',
  /** Corresponds to facet value "productDifficultyLevel:Mixed" */
  Mixed: 'MIXED'
} as const;

export type CourseBuilderV2_ProductDifficultyLevel = typeof CourseBuilderV2_ProductDifficultyLevel[keyof typeof CourseBuilderV2_ProductDifficultyLevel];
/** Corresponds to the productDuration facet in search_hit.proto */
export const CourseBuilderV2_ProductDuration = {
  /** Corresponds to facet value "productDuration:Less Than 2 Hours" */
  LessThanTwoHours: 'LESS_THAN_TWO_HOURS',
  /** Corresponds to facet value "productDuration:1-4 Weeks" */
  OneToFourWeeks: 'ONE_TO_FOUR_WEEKS',
  /** Corresponds to facet value "productDuration:1-4 Years" */
  OneToFourYears: 'ONE_TO_FOUR_YEARS',
  /** Corresponds to facet value "productDuration:1-3 Months" */
  OneToThreeMonths: 'ONE_TO_THREE_MONTHS',
  /** Corresponds to facet value "productDuration:6-12 Months" */
  SixToTwelveMonths: 'SIX_TO_TWELVE_MONTHS',
  /** Corresponds to facet value "productDuration:3-6 Months" */
  ThreeToSixMonths: 'THREE_TO_SIX_MONTHS',
  /** Corresponds to facet value "productDuration:Under 60 Minutes" */
  UnderSixtyMinutes: 'UNDER_SIXTY_MINUTES'
} as const;

export type CourseBuilderV2_ProductDuration = typeof CourseBuilderV2_ProductDuration[keyof typeof CourseBuilderV2_ProductDuration];
/** Corresponds to the productTypeDescription facet in search_hit.proto */
export const CourseBuilderV2_ProductType = {
  /** Corresponds to facet value "productTypeDescription:Courses" */
  Course: 'COURSE',
  /** Corresponds to facet value "productTypeDescription:Professional Certificates" */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Corresponds to facet value "productTypeDescription:Specializations" */
  Specialization: 'SPECIALIZATION'
} as const;

export type CourseBuilderV2_ProductType = typeof CourseBuilderV2_ProductType[keyof typeof CourseBuilderV2_ProductType];
/** Input for a range numeric answer */
export type CourseBuilderV2_RangeNumericAnswerInput = {
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Lower bound of the range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound is inclusive */
  lowerBoundInclusive: Scalars['Boolean'];
  /** Upper bound of the range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound is inclusive */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Input for a regex answer */
export type CourseBuilderV2_RegexAnswerInput = {
  /** Whether the regex pattern is case insensitive */
  caseInsensitive: Scalars['Boolean'];
  /** Whether the dot symbol in the regex pattern matches all characters, including newlines */
  dotAll: Scalars['Boolean'];
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Whether the regex pattern is multi-line */
  multiLine: Scalars['Boolean'];
  /** Regex pattern for the answer */
  regex: Scalars['String'];
};

/** Input for a regex question */
export type CourseBuilderV2_RegexQuestionInput = {
  /** List of regex answer options */
  answers: Array<CourseBuilderV2_RegexAnswerInput>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** CourseBuilderV2_RewindToCheckpoint mutation input */
export type CourseBuilderV2_RewindToCheckpointInput = {
  /** Checkpoint to rewind to */
  checkpoint: CourseBuilderV2_WorkflowStatus;
  /** List of curated items to use in the next workflow iteration */
  curatedItemsToRetain?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_RewindToStep mutation input */
export type CourseBuilderV2_RewindToStepInput = {
  /** Step to rewind to */
  step: CourseBuilderV2_WorkflowStatus;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** Input for a rubric option */
export type CourseBuilderV2_RubricOptionInput = {
  /** Rubric option prompt */
  optionPrompt: Scalars['String'];
  /** Points value for the rubric option */
  points: Scalars['Float'];
};

/** Input for a rubric part for an assignment */
export type CourseBuilderV2_RubricPartInput = {
  /** Graded text box rubric part */
  gradedTextBoxRubricPart?: InputMaybe<CourseBuilderV2_GradedTextBoxRubricPartInput>;
  /** Inline feedback rubric part */
  inlineFeedbackRubricPart?: InputMaybe<CourseBuilderV2_InlineFeedbackRubricPartInput>;
  /** Options rubric part */
  optionsRubricPart?: InputMaybe<CourseBuilderV2_OptionsRubricPartInput>;
  /** Ungraded text box rubric part */
  ungradedTextBoxRubricPart?: InputMaybe<CourseBuilderV2_UngradedTextBoxRubricPartInput>;
  /** Yes no rubric part */
  yesNoRubricPart?: InputMaybe<CourseBuilderV2_YesNoRubricPartInput>;
};

/** CourseBuilderV2_SaveCoachChatSession input */
export type CourseBuilderV2_SaveCoachChatSessionInput = {
  /** Coach chat session ID to save */
  coachChatSessionId: Scalars['ID'];
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** Input for analyzing a Smart Ingestion workflow for content gaps */
export type CourseBuilderV2_StartAnalyzingContentForGapsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** The ID of the Smart Ingestion workflow to analyze */
  workflowId: Scalars['ID'];
};

/** Input to start a question generation request */
export type CourseBuilderV2_StartAssessmentGenerationInput = {
  /** The type of feedback the AI should generate. Feedback is displayed to learners alongside their answer. */
  feedbackType: CourseBuilderV2_AssessmentGeneratorFeedbackType;
  /** Number of questions to generate per module */
  numberOfQuestions: Scalars['Int'];
  /** The name of the question bank to be created */
  questionBankName: Scalars['String'];
  /** Question types to generate */
  questionTypes?: InputMaybe<Array<CourseBuilderV2_AssessmentGeneratorQuestionType>>;
};

/** CourseBuilderV2_StartGeneratingCourseMaterials mutation input */
export type CourseBuilderV2_StartGeneratingCourseMaterialsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromScratch mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromScratchInput = {
  /** Description of the learners expected to take the course */
  audience?: InputMaybe<Scalars['String']>;
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds?: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Desired course length, specified in number of modules */
  courseLength?: InputMaybe<CourseBuilderV2_CourseLengthModuleBasedInput>;
  /** language code to use for the primary language of the course */
  languageCode?: Scalars['String'];
  /** Text describing outcomes or skills learners should get from taking the course */
  learningObjectives?: InputMaybe<Scalars['String']>;
  /** Optional syllabus input asset ID */
  syllabusInputAssetId?: InputMaybe<Scalars['ID']>;
  /** Text describing topic to generate a course about */
  topic?: InputMaybe<Scalars['String']>;
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCourses mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesInput = {
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Enterprise program ID */
  enterpriseProgramId: Scalars['ID'];
  /** A list of source courses selected by the user as a starting point to generate the course */
  selectedSourceCourses: Array<Scalars['ID']>;
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileInput mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileInput = {
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Asset ID for user file inputs of the syllabus */
  syllabusInputAssetId: Scalars['ID'];
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItems mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsInput = {
  /** Optional list of course IDs whose items will be prioritized when generating curation results */
  prioritizedCourseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectives mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesInput = {
  /** Description of the learners expected to take the course */
  audience: Scalars['String'];
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssets: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssets?: Array<Scalars['ID']>;
  /** Desired course length */
  courseLength: CourseBuilderV2_CourseLengthInput;
  /** language code to use for the primary language of the course */
  languageCode?: Scalars['String'];
  /** Text describing outcomes or skills learners should get from taking the course */
  learningObjectives: Scalars['String'];
  /** Text describing topics to generate a course about */
  topics: Scalars['String'];
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the
   * GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTerms mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsInput = {
  /** Optional list of language codes to filter curated items */
  curationLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Enterprise program ID */
  enterpriseProgramId: Scalars['ID'];
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSkills mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSkillsInput = {
  /** Authoring branch ID */
  authoringBranchId: Scalars['ID'];
  /** Developmental progress within an occupational group. */
  careerBand: Scalars['String'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Educators' partner ids */
  educators: Array<Scalars['ID']>;
  /** The program id the content is recommended from. */
  enterpriseProgramId: Scalars['ID'];
  /** Course language code ISO 639-1 language codes (e.g., 'en', 'es', 'fr', 'de'). We allow author to select multiple languages if non English is selected in Step 1. */
  languages: Array<Scalars['String']>;
  /** A cluster of occupations with a high degree of overlap in skills and competencies. */
  occupationalGroup: Scalars['String'];
  /** Skill area ID. A Skill Area is learner-facing grouping of related skills that support a common phase of work or functional objective. The skills in a Skill Area are commonly taught, practiced, or applied together. */
  skillArea: Scalars['ID'];
  /** Skill expressions' IDs */
  skillExpressions: Array<Scalars['String']>;
  /**
   * SkillTrack is the Enterprise program's contract tag.There is currently no
   * contract tag type, so we're using a string instead
   */
  skillTrack: Scalars['String'];
};

/** CourseBuilderV2_StartGeneratingItemOutlineFromScratch mutation input */
export type CourseBuilderV2_StartGeneratingItemOutlineFromScratchInput = {
  /** List of item types that we can use to generate items */
  itemTypesToGenerate: Array<CourseBuilderV2_CourseItemType>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** Input for generating placeholder items in a workflow from placeholder recommendations */
export type CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** The ID of the Smart Ingestion workflow to update. */
  workflowId: Scalars['ID'];
};

/** Input for a text block question */
export type CourseBuilderV2_TextBlockQuestionInput = {
  /** Body of the text block which supports CML */
  body: Scalars['String'];
  /** Title of the text block */
  title: Scalars['String'];
};

/** Input for a text exact match question */
export type CourseBuilderV2_TextExactMatchQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a text reflect question */
export type CourseBuilderV2_TextReflectQuestionInput = {
  /** Feedback for when an answer is provided */
  feedback: Scalars['String'];
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: InputMaybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Range specifing the start and end timestamps for split/trimmed videos */
export type CourseBuilderV2_TimestampRangeInput = {
  /** End timestamp in milliseconds */
  endMs: Scalars['Int'];
  /** Start timestamp in milliseconds */
  startMs: Scalars['Int'];
};

/** Input for an ungraded text box rubric part */
export type CourseBuilderV2_UngradedTextBoxRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** CourseBuilderV2_UpdateCourseOutline mutation input */
export type CourseBuilderV2_UpdateCourseOutlineInput = {
  /** Updated course outline */
  courseOutline: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithCuratedItems mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithCuratedItemsInput = {
  /** Updated course outline */
  courseOutlineWithCuratedItems: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectives mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesInput = {
  /** Updated course outline */
  courseOutlineWithModulesAndLearningObjectives: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithSearchTerms mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithSearchTermsInput = {
  /** Updated course outline */
  courseOutlineWithSearchTerms: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateItemOutlineFromScratchInput mutation input */
export type CourseBuilderV2_UpdateItemOutlineFromScratchInput = {
  /** List of modules with updated items */
  courseOutlineWithItems: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** Input for a value numeric answer */
export type CourseBuilderV2_ValueNumericAnswerInput = {
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Value of the answer */
  value: Scalars['Float'];
};

/** The skill content type */
export const CourseBuilderV2_VerifiedSkillsContentType = {
  /** Practive quizzes, peer reviews etc. Items that are graded but do not contribute to skill expression attainment */
  Assessment: 'ASSESSMENT',
  /** Final Skill Assessment that counts toward skill expression attainment */
  Attainment: 'ATTAINMENT',
  /** Lectures, readings etc. Items that are not graded */
  Instructional: 'INSTRUCTIONAL'
} as const;

export type CourseBuilderV2_VerifiedSkillsContentType = typeof CourseBuilderV2_VerifiedSkillsContentType[keyof typeof CourseBuilderV2_VerifiedSkillsContentType];
/**
 * Widgets are a flexible item type and their configuration can take many shapes. To enable this
 * flexibility during Smart Ingestion Distillation and Augmentation steps, different models will be
 * used to extract information about different kinds of widgets. This enum captures the broad
 * categories of widgets that can be extracted from source content.
 */
export const CourseBuilderV2_WidgetCategory = {
  /** Widget with a single link such as IFrame or YouTube video */
  WidgetWithLink: 'WIDGET_WITH_LINK',
  /** Widget with a YouTube video ID */
  WidgetWithYoutubeVideoId: 'WIDGET_WITH_YOUTUBE_VIDEO_ID'
} as const;

export type CourseBuilderV2_WidgetCategory = typeof CourseBuilderV2_WidgetCategory[keyof typeof CourseBuilderV2_WidgetCategory];
/** Course Builder workflow ID and version number */
export type CourseBuilderV2_WorkflowIdAndVersion = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** oneOf field containing either a WorkflowIdAndVersion or a CreateInput */
export type CourseBuilderV2_WorkflowIdAndVersionOrCreateInput = {
  /** Set when creating a new workflow */
  createInput?: InputMaybe<CourseBuilderV2_CreateWorkflowInput>;
  /**
   * Set when rerunning the GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES step for an
   * existing workflow
   */
  workflowIdAndVersion?: InputMaybe<CourseBuilderV2_WorkflowIdAndVersion>;
};

/** The current status of the workflow */
export const CourseBuilderV2_WorkflowStatus = {
  /** The workflow polls Assessment Generator for status on generation requests triggered in GENERATING_COURSE_MATERIALS step */
  AwaitingAssessmentsGenerationCompletion: 'AWAITING_ASSESSMENTS_GENERATION_COMPLETION',
  /** The workflow is analyzing the course outline to identify gaps where placeholder items should be inserted */
  CbsiAnalyzingContentForGaps: 'CBSI_ANALYZING_CONTENT_FOR_GAPS',
  /** The workflow has completed assessment generation for Smart Ingestion and is waiting for the user to proceed to materials generation. */
  CbsiAssessmentsReviewCheckpoint: 'CBSI_ASSESSMENTS_REVIEW_CHECKPOINT',
  /** The workflow is augmenting the course content from the structure content field and based on the distilled course structure */
  CbsiAugmentCourseContentFromStructureContent: 'CBSI_AUGMENT_COURSE_CONTENT_FROM_STRUCTURE_CONTENT',
  /** The workflow is waiting for user to confirm or edit the placeholder recommendations before generating placeholder items */
  CbsiAwaitingPlaceholderConfirmation: 'CBSI_AWAITING_PLACEHOLDER_CONFIRMATION',
  /** The workflow is having coach generate suggestions for user to review */
  CbsiCoachReviewCheckpoint: 'CBSI_COACH_REVIEW_CHECKPOINT',
  /** The workflow is distilling the course structure from the structure content field */
  CbsiDistillCourseStructureFromStructureContent: 'CBSI_DISTILL_COURSE_STRUCTURE_FROM_STRUCTURE_CONTENT',
  /** The workflow is generating placeholder items based on the confirmed recommendations */
  CbsiGeneratingPlaceholderItems: 'CBSI_GENERATING_PLACEHOLDER_ITEMS',
  /** The workflow has completed placeholder generation and is waiting for the user to review the generated placeholder items before proceeding to the optional assessment step or materials generation. */
  CbsiPlaceholderReviewCheckpoint: 'CBSI_PLACEHOLDER_REVIEW_CHECKPOINT',
  /** The workflow starts asset loading based on asset bundles from structure content */
  CbsiStartAssetCreationFromStructureContent: 'CBSI_START_ASSET_CREATION_FROM_STRUCTURE_CONTENT',
  /** The workflow completed successfully */
  Completed: 'COMPLETED',
  /** The workflow is converting syllabus to course outline with modules and learning objectives */
  ConvertingSyllabusToCourseOutline: 'CONVERTING_SYLLABUS_TO_COURSE_OUTLINE',
  /** The workflow is searching for items matching each module learning objective's search terms */
  CuratingItemsForLearningObjectives: 'CURATING_ITEMS_FOR_LEARNING_OBJECTIVES',
  /** The workflow is fetching the modules by skills */
  CuratingModulesForSkills: 'CURATING_MODULES_FOR_SKILLS',
  /** The workflow is waiting for TextExtractJob invocations to extract text from input files */
  ExtractingTextFromInputFiles: 'EXTRACTING_TEXT_FROM_INPUT_FILES',
  /** The workflow ran into an error while executing */
  Failed: 'FAILED',
  /** The workflow is generating a course outline from scratch */
  FsGeneratingCourseOutline: 'FS_GENERATING_COURSE_OUTLINE',
  /** The workflow is generating course outline items from scratch */
  FsGeneratingCourseOutlineWithItems: 'FS_GENERATING_COURSE_OUTLINE_WITH_ITEMS',
  /** The workflow is generating Assessments items and adding them to course outline */
  GeneratingAssessmentsOutlineItems: 'GENERATING_ASSESSMENTS_OUTLINE_ITEMS',
  /** The workflow is populating the branch with course materials based on the outline */
  GeneratingCourseMaterials: 'GENERATING_COURSE_MATERIALS',
  /** The workflow is generating course metadata */
  GeneratingCourseMetadata: 'GENERATING_COURSE_METADATA',
  /**
   * The workflow is generating a course outline from selected source courses.
   * - course materials will be concatenated together
   * - learning objectives will be generated for modules that did not have learning objectives of their own
   * - items generated from uploaded files will be inserted into the course outline where the AI deems appropriate
   */
  GeneratingCourseOutlineFromSelectedCourses: 'GENERATING_COURSE_OUTLINE_FROM_SELECTED_COURSES',
  /** The workflow is selecting and reordering items from the previous step to form a complete course outline with curated items */
  GeneratingCourseOutlineWithCuratedItems: 'GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS',
  /** The workflow is generating a course outline containing modules and their respective learning objectives */
  GeneratingCourseOutlineWithModulesAndLearningObjectives: 'GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES',
  /** The workflow is generating items based from input files and text extracted from them */
  GeneratingItemsFromInputFiles: 'GENERATING_ITEMS_FROM_INPUT_FILES',
  /**
   * The workflow is generating item contents, which will be converted into real course materials in the
   * GENERATING_COURSE_MATERIALS step
   */
  GeneratingItemContents: 'GENERATING_ITEM_CONTENTS',
  /**
   * The workflow is generating item-type specific parameters that will be reviewed by users and used as inputs for item
   * content generation
   */
  GeneratingItemParameters: 'GENERATING_ITEM_PARAMETERS',
  /** Coach is generating suggested edits for the course outline with items */
  GeneratingProactiveSuggestionsForOutlineWithItems: 'GENERATING_PROACTIVE_SUGGESTIONS_FOR_OUTLINE_WITH_ITEMS',
  /** Coach is generating suggested edits for the course outline with modules and learning objectives */
  GeneratingProactiveSuggestionsForOutlineWithModules: 'GENERATING_PROACTIVE_SUGGESTIONS_FOR_OUTLINE_WITH_MODULES',
  /** The workflow is generating search terms for each learning objective to be used for item curation */
  GeneratingSearchTerms: 'GENERATING_SEARCH_TERMS',
  /** The workflow is searching the catalog for relevant courses for more focused curation results */
  GeneratingSuggestedCurationFilters: 'GENERATING_SUGGESTED_CURATION_FILTERS',
  /** The workflow is converting syllabus uploads to usable format for later inputs to LLMs */
  HandlingSyllabusAssetUpload: 'HANDLING_SYLLABUS_ASSET_UPLOAD',
  /** The workflow was created, but the associated Airflow jobs have not yet run */
  NotStarted: 'NOT_STARTED',
  /** The workflow is refining course learning objectives from the original user-provided inputs */
  RefiningCourseLearningObjectives: 'REFINING_COURSE_LEARNING_OBJECTIVES',
  /** The workflow is started over */
  StartOver: 'START_OVER',
  /** The workflow is tagging generated items with learning objectives */
  TaggingGeneratedItemsWithLearningObjectives: 'TAGGING_GENERATED_ITEMS_WITH_LEARNING_OBJECTIVES',
  /** The workflow is tagging curated items retained from a previous iteration with learning objectives */
  TaggingRetainedCuratedItemsWithLearningObjectives: 'TAGGING_RETAINED_CURATED_ITEMS_WITH_LEARNING_OBJECTIVES',
  /** The workflow is updating the course with the metadata generated by the previous step */
  UpdatingCourseMetadata: 'UPDATING_COURSE_METADATA',
  /** The workflow is waiting for users to review and edit the generated assessment outline items */
  UserAssessmentsOutlineCheckpoint: 'USER_ASSESSMENTS_OUTLINE_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the outline generated by the previous step */
  UserCurationCheckpoint: 'USER_CURATION_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the item outline generated by the previous step */
  UserItemReviewCheckpoint: 'USER_ITEM_REVIEW_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the outline generated by the previous step */
  UserOutlineCheckpoint: 'USER_OUTLINE_CHECKPOINT',
  /** The workflow is waiting for users to review and edit previously generated search terms and curation filters */
  UserSearchTermsCheckpoint: 'USER_SEARCH_TERMS_CHECKPOINT'
} as const;

export type CourseBuilderV2_WorkflowStatus = typeof CourseBuilderV2_WorkflowStatus[keyof typeof CourseBuilderV2_WorkflowStatus];
/** The type of the Course Builder workflow */
export const CourseBuilderV2_WorkflowType = {
  /** The workflow in which the generated course is built from existing content through AI-assisted curation */
  AiCuration: 'AI_CURATION',
  /**
   * Updated version of the workflow in which the generated course is built from existing content
   * through AI-assisted curation, now incorporating agentic outline and item content generation
   */
  AiCurationV2: 'AI_CURATION_V2',
  /** The workflow in which the generated course is built from scratch */
  FromScratch: 'FROM_SCRATCH',
  /**
   * Updated version of the workflow in which the generated course is built from scratch, now incorporating agentic outline
   * and item content generation
   */
  FromScratchV2: 'FROM_SCRATCH_V2',
  /** The workflow in which the generated course is built from a number of existing courses through reuse */
  FullCourseReuse: 'FULL_COURSE_REUSE',
  /** The workflow in which the generated course is built based on skills author required */
  SkillBased: 'SKILL_BASED',
  /** The workflow in which the generated course is built based on ingested content from some external source */
  SmartIngestion: 'SMART_INGESTION'
} as const;

export type CourseBuilderV2_WorkflowType = typeof CourseBuilderV2_WorkflowType[keyof typeof CourseBuilderV2_WorkflowType];
/** Input for Yes/No points */
export type CourseBuilderV2_YesNoPointsInput = {
  /** Points value for when the rubric part is not satisfied */
  noPoints: Scalars['Float'];
  /** Points value for when the rubric part is satisfied */
  yesPoints: Scalars['Float'];
};

/** Input for a Yes/No rubric part */
export type CourseBuilderV2_YesNoRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
  /** Points for when the rubric part is and isn't satisfied */
  yesNoPoints: CourseBuilderV2_YesNoPointsInput;
};

/** Course builder restriction creation input. */
export type CourseBuilder_CreateRestrictionInput = {
  /** The type of the access restriction: INCLUDE / EXCLUDE. */
  accessType: CourseBuilder_RestrictionAccessType;
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
  /**
   * The identifiers of entities being restricted. Actual values depend on the restrictionLevel.
   * For a Global restriction, this will be empty.
   */
  restrictions?: InputMaybe<Array<Scalars['String']>>;
};

/** Course builder restriction delete input. */
export type CourseBuilder_DeleteRestrictionInput = {
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
};

/** The access type of the restriction. */
export const CourseBuilder_RestrictionAccessType = {
  /** EXCLUDE. */
  Exclude: 'EXCLUDE',
  /** INCLUDE. */
  Include: 'INCLUDE'
} as const;

export type CourseBuilder_RestrictionAccessType = typeof CourseBuilder_RestrictionAccessType[keyof typeof CourseBuilder_RestrictionAccessType];
/** The level of the restriction. */
export const CourseBuilder_RestrictionLevel = {
  /** COURSE. */
  Course: 'COURSE',
  /** GLOBAL. */
  Global: 'GLOBAL',
  /** ITEM_TYPE. */
  ItemType: 'ITEM_TYPE',
  /** PARTNER. */
  Partner: 'PARTNER',
  /** SPECIALIZATION. */
  Specialization: 'SPECIALIZATION'
} as const;

export type CourseBuilder_RestrictionLevel = typeof CourseBuilder_RestrictionLevel[keyof typeof CourseBuilder_RestrictionLevel];
/** Course builder restriction update input. */
export type CourseBuilder_UpdateRestrictionInput = {
  /** The type of the access restriction: INCLUDE / EXCLUDE. */
  accessType: CourseBuilder_RestrictionAccessType;
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
  /**
   * The identifiers of entities being restricted. Actual values depend on the restrictionLevel.
   * For a Global restriction, this will be empty.
   */
  restrictions?: InputMaybe<Array<Scalars['String']>>;
};

/** Course change input types */
export type CourseChange_BranchChangeTypeInput = {
  /** Item change type */
  itemChangeType?: InputMaybe<CourseItemChange_ChangeType>;
  /** Learning objective change type */
  learningObjectiveChangeType?: InputMaybe<CourseChange_LearningObjectiveChangeType>;
};

/** Type of user change was made by: Coursera or partner */
export const CourseChange_CourseraOrPartner = {
  /** Coursera */
  Coursera: 'COURSERA',
  /** Partner */
  Partner: 'PARTNER'
} as const;

export type CourseChange_CourseraOrPartner = typeof CourseChange_CourseraOrPartner[keyof typeof CourseChange_CourseraOrPartner];
/** Learning objective change types */
export const CourseChange_LearningObjectiveChangeType = {
  /** The learning objective was associated */
  AssociateLo: 'ASSOCIATE_LO',
  /** The learning objective was created */
  CreateLo: 'CREATE_LO',
  /** The learning objective was deleted */
  DeleteLo: 'DELETE_LO',
  /** The learning objective was disassociated */
  DisassociateLo: 'DISASSOCIATE_LO',
  /** The learning objective change represents a group of changes */
  GroupedChanges: 'GROUPED_CHANGES',
  /** The learning objective was moved */
  MoveLo: 'MOVE_LO',
  /** The learning objective was reordered */
  ReorderLo: 'REORDER_LO',
  /** The learning objective was updated */
  UpdateLo: 'UPDATE_LO'
} as const;

export type CourseChange_LearningObjectiveChangeType = typeof CourseChange_LearningObjectiveChangeType[keyof typeof CourseChange_LearningObjectiveChangeType];
/** Input parameters for CourseCompletionRecommendationsQueries */
export type CourseCompletionRecommendations_QueryByUserAndCourseInput = {
  /** The ID of the course for which a recommendation is being retrieved. */
  courseId?: InputMaybe<Scalars['ID']>;
};

/** Input for single course translation. */
export type CourseContentTranslation_SingleCourseTranslationInput = {
  /** The authoring branch id in the course for translation. */
  authoringBranchId: Scalars['ID'];
  /** The course id for translation. */
  courseId: Scalars['ID'];
  /** If this course is a previously translated course, we might need to retranslate the content by setting this to true. */
  retranslation: Scalars['Boolean'];
  /**
   * The target language codes to translate to. The language codes should follow the Coursera Language Code defined here
   * https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  targetLanguages: Array<Scalars['String']>;
};

/** Input for triggering proactive course translation. */
export type CourseContentTranslation_TriggerProactiveCourseTranslationInput = {
  /** A list of course translation config. */
  courses: Array<CourseContentTranslation_SingleCourseTranslationInput>;
};

/** CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram mutation input */
export type CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramInput = {
  /** Course id to update the default enterprise program selection of */
  courseId: Scalars['ID'];
  /**
   * Default enterprise program id selection for a particular course id
   * This is used as a part of the Course Builder authoring flow, when embedding items author's select
   * from a list of enterprise program's to embed from.
   */
  defaultEnterpriseProgramId: Scalars['ID'];
};

/** TODO: Complete this description */
export const CourseItemChange_ChangeType = {
  /** The atom was forked. */
  CopyItem: 'COPY_ITEM',
  /** The atom was created. */
  CreateItem: 'CREATE_ITEM',
  /** The atom was deleted from this branch. */
  DeleteItem: 'DELETE_ITEM',
  /** The atom was duplicated in this branch. */
  DuplicateItem: 'DUPLICATE_ITEM',
  /** The atom draft was edited. */
  EditDraft: 'EDIT_DRAFT',
  /** The atom was frozen in this branch. */
  FreezeItem: 'FREEZE_ITEM',
  /** This course item change represents a group of changes. */
  GroupedChanges: 'GROUPED_CHANGES',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** The atom was linked to this branch. */
  LinkItem: 'LINK_ITEM',
  /** The atom was moved */
  MoveItem: 'MOVE_ITEM',
  /** The atom draft was published. */
  PublishItem: 'PUBLISH_ITEM',
  /** The atom was reordered */
  ReorderItem: 'REORDER_ITEM',
  /** The atom draft was reverted. */
  RevertDraft: 'REVERT_DRAFT',
  /** The atom was unfrozen in this branch. */
  UnfreezeItem: 'UNFREEZE_ITEM',
  /** The atom was unlinked and copied to this branch. */
  UnlinkItem: 'UNLINK_ITEM'
} as const;

export type CourseItemChange_ChangeType = typeof CourseItemChange_ChangeType[keyof typeof CourseItemChange_ChangeType];
export const CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType = {
  IdVerification: 'ID_VERIFICATION',
  NameAttestation: 'NAME_ATTESTATION'
} as const;

export type CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType = typeof CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType[keyof typeof CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType];
export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
/** This is a enum that represents the weekly progress deadline status. */
export const CourseNavigation_DeadlineStatus = {
  /** TODO: Complete this description */
  Completed: 'COMPLETED',
  /** TODO: Complete this description */
  Failed: 'FAILED',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** TODO: Complete this description */
  Ontrack: 'ONTRACK',
  /** TODO: Complete this description */
  Overdue: 'OVERDUE'
} as const;

export type CourseNavigation_DeadlineStatus = typeof CourseNavigation_DeadlineStatus[keyof typeof CourseNavigation_DeadlineStatus];
/**
 * Item type
 * Should match UpcomingItems_ItemType
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 * Deprecate some item types based on https://docs.google.com/document/d/1xj9ffO56LgpH-QXUzLFWjUi966r7M_rteIW0e_d97GQ/edit#heading=h.hgy0mtjf8o5u
 */
export const CourseNavigation_ItemType = {
  /** Assessment open single page */
  AssesOpenSinglePage: 'ASSES_OPEN_SINGLE_PAGE',
  /** Closed peer */
  ClosedPeer: 'CLOSED_PEER',
  /** Coach */
  Coach: 'COACH',
  /** Discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Exam */
  Exam: 'EXAM',
  /** Graded coach */
  GradedCoach: 'GRADED_COACH',
  /** Graded discussion prompt */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** Graded lab */
  GradedLab: 'GRADED_LAB',
  /** Graded LTI */
  GradedLti: 'GRADED_LTI',
  /** Graded peer */
  GradedPeer: 'GRADED_PEER',
  /** Graded programming */
  GradedProgramming: 'GRADED_PROGRAMMING',
  /** Graded widget */
  GradedWidget: 'GRADED_WIDGET',
  /** Lecture */
  Lecture: 'LECTURE',
  /** Notebook */
  Notebook: 'NOTEBOOK',
  /** Peer */
  Peer: 'PEER',
  /** Phased peer */
  PhasedPeer: 'PHASED_PEER',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming */
  Programming: 'PROGRAMMING',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Single question submit */
  SingleQuestionSubmit: 'SINGLE_QUESTION_SUBMIT',
  /** Slideshow */
  Slideshow: 'SLIDESHOW',
  /** Staff graded */
  StaffGraded: 'STAFF_GRADED',
  /** Supplement */
  Supplement: 'SUPPLEMENT',
  /** Teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded assignment */
  UngradedAssignment: 'UNGRADED_ASSIGNMENT',
  /** Ungraded lab */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded LTI */
  UngradedLti: 'UNGRADED_LTI',
  /** Ungraded programming */
  UngradedProgramming: 'UNGRADED_PROGRAMMING',
  /** Ungraded widget */
  UngradedWidget: 'UNGRADED_WIDGET',
  /** Wise flow */
  WiseFlow: 'WISE_FLOW',
  /** Workspace launcher */
  WorkspaceLauncher: 'WORKSPACE_LAUNCHER'
} as const;

export type CourseNavigation_ItemType = typeof CourseNavigation_ItemType[keyof typeof CourseNavigation_ItemType];
/** This is a enum that represents the module types. */
export const CourseNavigation_ModuleType = {
  /** TODO: Complete this description */
  FirstWeek: 'FIRST_WEEK',
  /** TODO: Complete this description */
  Full: 'FULL',
  /** TODO: Complete this description */
  Preview: 'PREVIEW'
} as const;

export type CourseNavigation_ModuleType = typeof CourseNavigation_ModuleType[keyof typeof CourseNavigation_ModuleType];
/** Input for multiGet learner next item */
export type CourseNavigation_MultiGetLearnerNextItemInput = {
  /** Course id */
  courseId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

/** navigation items types */
export const CourseNavigation_NavigationItemType = {
  /** TODO: Complete this description */
  Admin: 'ADMIN',
  /** TODO: Complete this description */
  Classmates: 'CLASSMATES',
  /** TODO: Complete this description */
  CourseInfo: 'COURSE_INFO',
  /** TODO: Complete this description */
  CourseManager: 'COURSE_MANAGER',
  /** TODO: Complete this description */
  DiscussionForums: 'DISCUSSION_FORUMS',
  /** TODO: Complete this description */
  Grades: 'GRADES',
  /** TODO: Complete this description */
  Inbox: 'INBOX',
  /** TODO: Complete this description */
  Modules: 'MODULES',
  /** TODO: Complete this description */
  Notes: 'NOTES',
  /** TODO: Complete this description */
  OfficeHours: 'OFFICE_HOURS',
  /** TODO: Complete this description */
  PreviewCourse: 'PREVIEW_COURSE',
  /** TODO: Complete this description */
  PreviewFirstWeek: 'PREVIEW_FIRST_WEEK',
  /** TODO: Complete this description */
  Resources: 'RESOURCES',
  /** TODO: Complete this description */
  Teamwork: 'TEAMWORK'
} as const;

export type CourseNavigation_NavigationItemType = typeof CourseNavigation_NavigationItemType[keyof typeof CourseNavigation_NavigationItemType];
/**
 * Course offering input class is needed as GraphQL must differentiate between input and types even
 * though similar structures are followed.
 *
 * Description of each field follows those in [courseoffering.graphqls].
 */
export type CourseOfferingInput = {
  /** The catalog availability setting of the offering. See [[CatalogAvailability]] for more details. */
  catalogAvailability: CourseOffering_CatalogAvailabilityUnionInput;
  /**
   * The courseId of the course the offering is part of. The relationship between an offering and a course
   * is 1:1.
   */
  courseId: Scalars['ID'];
  /** The default feature set of the offering. See [[DefaultFeatureSet]] for more details. */
  defaultFeatureSet: CourseOffering_DefaultFeatureSet;
  /**
   * Externally managed offerings are offerings created and managed outside of the educator
   * experience that should not be visible to admins in authoring flows.
   *
   * These offerings are currently used to support custom academic terms for MOOCs in C4C
   * enterprise programs. However, this flag is only intended to allow excluding these
   * offerings in authoring flows as a workaround for the lack of enterprise-admin / session-level
   * permissions. For additional details, see: http:go.dkandu.me/externallymanagedsession
   */
  isExternallyManaged: Scalars['Boolean'];
  /** The schedule availability of the offering. See [[ScheduleAvailability]] for more details. */
  scheduleAvailability: CourseOffering_ScheduleAvailabilityUnionInput;
  /** The schedule experience of the offering. See [[ScheduleExperience]] for more details. */
  scheduleExperience: CourseOffering_ScheduleExperienceUnionInput;
};

/** The course offering generates sessions on a recurring basis indefinitely. */
export type CourseOffering_AlwaysAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  branchId: Scalars['ID'];
  /**  eslint-disable @graphql-eslint/require-description */
  repeatFrequency: CourseOffering_RepeatFrequencyUnionInput;
};

/**
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type CourseOffering_CatalogAvailabilityUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  enterpriseAdminCatalogs?: InputMaybe<CourseOffering_EnterpriseAdminCatalogsInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  noCatalogs?: InputMaybe<CourseOffering_NoCatalogsInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  publicCatalog?: InputMaybe<CourseOffering_PublicCatalogInput>;
};

/**
 * A CohortBased learning experience means that learners enrolled in the offering will be bound by the session
 * start time, end time, item deadlines, etc. All learners in a same session will have the same experience with no
 * personalized treatment. The field selfSwitchOfferingSchedule controls whether learners should be able to self-serve
 * switch between sessions in the CohortBased offering.
 *
 * A CohortBased offering experience may use any type of availability format.
 */
export type CourseOffering_CohortBasedInput = {
  /** If true, allows user to switch between sessions */
  selfSwitchOfferingSchedule: Scalars['Boolean'];
};

/**
 * The default feature set describes a default set of features that corresponds with the old MOOC/HE split,
 * which we have renamed to Basic/HighEngagement here.
 *
 * In the later phases, we will transition towards granular feature toggles powered by ProductFeatures,
 * and the default feature set will not be materialized anymore (but will stil be author facing). In the interim it is
 * still convenient to have something that corresponds to the MOOC/HE split before we have time to split out all of the
 * existing behavior into granular features.
 *
 * Please see the section titled "OfferingType and FeatureSet" in the proposal for more details:
 * https://docs.google.com/document/d/1N4cu3R-rjLwiZs9WAky53qirc7IlYsR2z9byWOCyAo8/edit?usp=sharing
 */
export const CourseOffering_DefaultFeatureSet = {
  /** Basic feature set akin to old MOOC features */
  DefaultFeatureSetBasic: 'DEFAULT_FEATURE_SET_BASIC',
  /** High engagement feature set such as timed quizzes */
  DefaultFeatureSetHighEngagement: 'DEFAULT_FEATURE_SET_HIGH_ENGAGEMENT'
} as const;

export type CourseOffering_DefaultFeatureSet = typeof CourseOffering_DefaultFeatureSet[keyof typeof CourseOffering_DefaultFeatureSet];
/**
 * An offering with an EnterpriseAdminCatalogs catalog setting appears in the admin catalog of
 * enterprise organizations, and potentially curated into an enterprise program.
 */
export type CourseOffering_EnterpriseAdminCatalogsInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/**
 * Generic error codes for failed GraphQL mutation requests.
 * TODO: Make more meaningful/specific errors as the Offerings app gets further developed.
 */
export const CourseOffering_Error = {
  /** A create offering mutation error. */
  CreateOfferingError: 'CREATE_OFFERING_ERROR',
  /** A delete offering mutation error. */
  DeleteOfferingError: 'DELETE_OFFERING_ERROR',
  /** An update offering mutation error. */
  UpdateOfferingError: 'UPDATE_OFFERING_ERROR'
} as const;

export type CourseOffering_Error = typeof CourseOffering_Error[keyof typeof CourseOffering_Error];
/** The generation window for creating limited available recurring sessions. */
export type CourseOffering_GenerationWindowInput = {
  /** The end time of the generation window */
  endsAtTime: TimestampInput;
  /** The start time of the generation window */
  startsAtTime: TimestampInput;
};

/** The course offering generates sessions on a recurring basis based on certain generation windows. */
export type CourseOffering_LimitedAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  branchId: Scalars['ID'];
  /**  eslint-disable @graphql-eslint/require-description */
  generationWindow: Array<CourseOffering_GenerationWindowInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  postStartEnrollmentDuration: Scalars['Duration'];
  /**  eslint-disable @graphql-eslint/require-description */
  repeatFrequency: CourseOffering_RepeatFrequencyUnionInput;
};

/** The course offering does not generate sessions automatically. */
export type CourseOffering_ManualAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** A schedule availability that generates recurring sessions on a monthly timeline */
export type CourseOffering_MonthlyInput = {
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of the month this event should repeat on. Must be <= 28 to allow all months.
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfMonth <= 28, "Day of month should be <= 28")
   */
  dayOfMonth: Scalars['Int'];
};

/** An offering with a NoCatalogs catalog availability setting should not appear in any catalog. */
export type CourseOffering_NoCatalogsInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** An offering with an PublicCatalog catalog setting can appear in any catalog. */
export type CourseOffering_PublicCatalogInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

export type CourseOffering_RepeatFrequencyUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  monthly?: InputMaybe<CourseOffering_MonthlyInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  weekly?: InputMaybe<CourseOffering_WeeklyInput>;
};

/** The schedule availability options for an offering. */
export type CourseOffering_ScheduleAvailabilityUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  alwaysAvailability?: InputMaybe<CourseOffering_AlwaysAvailabilityInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  limitedAvailability?: InputMaybe<CourseOffering_LimitedAvailabilityInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  manualAvailability?: InputMaybe<CourseOffering_ManualAvailabilityInput>;
};

/** The schedule experience of an offering */
export type CourseOffering_ScheduleExperienceUnionInput = {
  cohortBased?: InputMaybe<CourseOffering_CohortBasedInput>;
  selfPaced?: InputMaybe<CourseOffering_SelfPacedInput>;
};

/**
 * A SelfPaced learning experience means that learners enrolled in the offering will be able to learn
 * at a self-paced rate with personalized deadlines that are tailored for each learner. It is also implicit that
 * learners will be able to self-serve switch into a next session should the session end before they complete the
 * course.
 */
export type CourseOffering_SelfPacedInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** A schedule availability that generates recurring sessions on a weekly timeline */
export type CourseOffering_WeeklyInput = {
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of week that this event should repeat on. Follows [[org.joda.time.DateTimeConstants]]
   * conventions for converting day of week to number. (Monday = 1, Tuesday = 2.. Sunday = 7)
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfWeek >= 1 && dayOfWeek <= 7, "Day of week should be between 1 and 7 (inclusive)")
   */
  dayOfWeek: Scalars['Int'];
};

/** Feature configuration as input */
export type CourseProfiles_AcademicIntegrityFeatureConfigurationInput = {
  /** Enabled status for Coursera Proctoring */
  isCourseraProctoringEnabled?: Scalars['Boolean'];
  /** Enabled status for graded item locking */
  isGradedItemLockingEnabled: Scalars['Boolean'];
  /** Enabled status for Locking Browser */
  isLockingBrowserEnabled?: Scalars['Boolean'];
  /** Peer Review AI Grading disabled */
  isPeerReviewAiGradingDisabled?: Scalars['Boolean'];
};

/** Types of course profiles */
export const CourseProfiles_ProfileType = {
  /** Credential courses, such as those offered for-credit */
  Credential: 'CREDENTIAL',
  /** Non-credential courses, such as those offered not for-credit */
  NonCredential: 'NON_CREDENTIAL'
} as const;

export type CourseProfiles_ProfileType = typeof CourseProfiles_ProfileType[keyof typeof CourseProfiles_ProfileType];
/** Possible scopes for course profiles */
export const CourseProfiles_Scope = {
  /** Institution scope */
  Institution: 'INSTITUTION',
  /** Program scope */
  Program: 'PROGRAM'
} as const;

export type CourseProfiles_Scope = typeof CourseProfiles_Scope[keyof typeof CourseProfiles_Scope];
/** Input schema for updating a course profile for institution */
export type CourseProfiles_UpdateCourseProfileForInstitutionInput = {
  /** Feature configurations to be set for the course profile */
  featureConfiguration: CourseProfiles_AcademicIntegrityFeatureConfigurationInput;
  /** The institution ID for which the course profile is to be updated */
  institutionId: Scalars['ID'];
  /** The course profile type to be updated */
  profileType: CourseProfiles_ProfileType;
};

/** Input schema for updating a course profile for program */
export type CourseProfiles_UpdateCourseProfileForProgramInput = {
  /** Feature configurations to be set for the course profile */
  featureConfiguration: CourseProfiles_AcademicIntegrityFeatureConfigurationInput;
  /** The course profile type to be updated */
  profileType: CourseProfiles_ProfileType;
  /** The program ID for which the course profile is to be updated */
  programId: Scalars['ID'];
};

/** Input schema for ApplyCourseProgressOverride mutation */
export type CourseProgress_ApplyCourseProgressOverrideInput = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The explanation for the override. */
  explanation: Scalars['String'];
  /** The overridden grade. */
  grade: Scalars['Float'];
  /**
   * [Optional] The overridden passing state for the honors track.
   * If the course does not have an honors track, exclude this field.
   * If the course does have an honors track but this field is omitted,
   * it will not override the honors passing state and will use whatever
   * the learner earned.
   */
  honorsPassingState?: InputMaybe<CourseProgress_PassingState>;
  /** The overridden passing state for the core track. */
  passingState: CourseProgress_PassingState;
  /** The user id. */
  userId: Scalars['ID'];
};

/** The completion status of the atom */
export const CourseProgress_AtomCompletionStatus = {
  /** The atom is completed */
  Completed: 'COMPLETED',
  /** The atom has an invalid state. */
  Invalid: 'INVALID',
  /** The atom is not yet started */
  NotStarted: 'NOT_STARTED',
  /** The atom is in progress */
  Started: 'STARTED'
} as const;

export type CourseProgress_AtomCompletionStatus = typeof CourseProgress_AtomCompletionStatus[keyof typeof CourseProgress_AtomCompletionStatus];
/** The completion status of an item within a course branch. */
export const CourseProgress_CourseBranchItemCompletionStatus = {
  /** The learner has completed the item. */
  Completed: 'COMPLETED',
  /** The learner has not started the item. */
  NotStarted: 'NOT_STARTED',
  /** The learner has started but not completed the item. */
  Started: 'STARTED'
} as const;

export type CourseProgress_CourseBranchItemCompletionStatus = typeof CourseProgress_CourseBranchItemCompletionStatus[keyof typeof CourseProgress_CourseBranchItemCompletionStatus];
/** The completion status of a course branch module */
export const CourseProgress_CourseBranchModuleCompletionStatus = {
  /** The module is completed */
  Completed: 'COMPLETED',
  /** No progress has been made on the module */
  NotStarted: 'NOT_STARTED',
  /** The module is not yet complete, but progress has been made */
  Started: 'STARTED',
  /** The completion status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_CourseBranchModuleCompletionStatus = typeof CourseProgress_CourseBranchModuleCompletionStatus[keyof typeof CourseProgress_CourseBranchModuleCompletionStatus];
/** Whether a late penalty is a fraction of the awarded score or a decrease in points of the awarded score. */
export const CourseProgress_LatePenaltyApplicationMode = {
  /** Apply the penalty as a fraction of the awarded score. */
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  /** Apply the penalty as a decrease in points of the awarded score. */
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE',
  /** An invalid late penalty application mode. */
  Invalid: 'INVALID'
} as const;

export type CourseProgress_LatePenaltyApplicationMode = typeof CourseProgress_LatePenaltyApplicationMode[keyof typeof CourseProgress_LatePenaltyApplicationMode];
/** The period of time over which a late penalty is applied. */
export const CourseProgress_LatePenaltyPeriodType = {
  /** The period occurs every day. */
  Day: 'DAY',
  /** The period occurs every hour. */
  Hour: 'HOUR',
  /** The period is infinite. */
  Infinity: 'INFINITY',
  /** An invalid late penalty period type. */
  Invalid: 'INVALID',
  /** The period occurs every minute. */
  Minute: 'MINUTE',
  /** The period occurs every month. */
  Month: 'MONTH',
  /** The period occurs every week. */
  Week: 'WEEK',
  /** The period is zero (applies immediately). */
  Zero: 'ZERO'
} as const;

export type CourseProgress_LatePenaltyPeriodType = typeof CourseProgress_LatePenaltyPeriodType[keyof typeof CourseProgress_LatePenaltyPeriodType];
/** Progress information for a specific item type. */
export const CourseProgress_LtiActivityProgressStatus = {
  /** The activity has been completed. */
  Completed: 'COMPLETED',
  /** The activity has been initialized. */
  Initialized: 'INITIALIZED',
  /** The activity is in progress. */
  InProgress: 'IN_PROGRESS',
  /** The activity has been started. */
  Started: 'STARTED',
  /** The activity has been submitted. */
  Submitted: 'SUBMITTED',
  /** The activity progress status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_LtiActivityProgressStatus = typeof CourseProgress_LtiActivityProgressStatus[keyof typeof CourseProgress_LtiActivityProgressStatus];
/** Progress information for a specific item type. */
export const CourseProgress_LtiGradingProgressStatus = {
  /** The grading could not complete. */
  Failed: 'FAILED',
  /** The grading process is completed; the score value, if any represents the current Final Grade */
  FullyGraded: 'FULLY_GRADED',
  /** There is no grading process occurring(for example, the student has not yet made any submission) */
  NotReady: 'NOT_READY',
  /**
   * Final Grade is pending but does not require manual intervention; if a Score value is present,
   * it indicates the current value is partial and may be updated.
   */
  Pending: 'PENDING',
  /**
   * Final Grade is pending, and it does require human intervention; if a Score value is present, it
   * indicates the current value is partial and maybe updated during the manual grading.
   */
  PendingManual: 'PENDING_MANUAL',
  /** The grading progress status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_LtiGradingProgressStatus = typeof CourseProgress_LtiGradingProgressStatus[keyof typeof CourseProgress_LtiGradingProgressStatus];
/** Passing state for courses and course branches. */
export const CourseProgress_PassingState = {
  /** No graded items. Can't be passed. */
  NotPassable: 'NOT_PASSABLE',
  /** Course is passable but learner has not passed. */
  NotPassed: 'NOT_PASSED',
  /** Course is passable and learner has passed. */
  Passed: 'PASSED',
  /** Not recognizable. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_PassingState = typeof CourseProgress_PassingState[keyof typeof CourseProgress_PassingState];
/** Input schema for RemoveCourseProgressOverride mutation */
export type CourseProgress_RemoveCourseProgressOverrideInput = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** Input schema for resyncCourseBranchProgress mutation */
export type CourseProgress_ResyncCourseBranchProgressInput = {
  /** The courseBranchId. */
  courseBranchId: Scalars['ID'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** Input schema for toggleAtomGradeHide mutation */
export type CourseProgress_ToggleAtomGradeHideInput = {
  /** The atom id. */
  atomId: Scalars['ID'];
  /** If true, the grade should be hidden. If false, the grade should be shown. */
  hide: Scalars['Boolean'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** The difficulty level of the course */
export const Course_DifficultyLevel = {
  /** The advanced level */
  Advanced: 'ADVANCED',
  /** The beginner level */
  Beginner: 'BEGINNER',
  /** The intermediate level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type Course_DifficultyLevel = typeof Course_DifficultyLevel[keyof typeof Course_DifficultyLevel];
/** Different product variants that are currently supported */
export const Course_PremiumExperienceVariant = {
  /** Base variant where everything is free */
  BaseVariant: 'BASE_VARIANT',
  /** For closed course, all course materials are behind paywall */
  PremiumCourse: 'PREMIUM_COURSE',
  /** Gradable assessments are behind paywall */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type Course_PremiumExperienceVariant = typeof Course_PremiumExperienceVariant[keyof typeof Course_PremiumExperienceVariant];
/** Wrapper for checkout cart ID (Coursera Plus cart checked out as part of Collection-save). */
export type CourseraPlusCollections_CartId = {
  /** Cart ID. */
  id: Scalars['ID'];
};

/** Input for CourseraPlusCollections_Save mutation. userId comes from request context. */
export type CourseraPlusCollections_SaveInput = {
  /** Additional input for that Collection: same shape as `Recommendations.queryCollection`'s `additionalInput` JSON (e.g. `preset_collection_id`, `ai_collection_id`, `query`, `facets`). */
  collectionAdditionalInput: Scalars['JSON'];
  /**
   * This ID is the same as `Recommendations.queryCollection`'s `id`. In coursera-plus-application, this is
   * the equivalent of the `collection_config_name` column, stored in the `collection_transactions` table.
   */
  collectionId: Scalars['ID'];
  /** Correlates this Collection-save with the learner's Plus subscription (`@oneOf`). See `CourseraPlusCollections_SubscriptionReference`. */
  subscriptionReference: CourseraPlusCollections_SubscriptionReference;
};

/** Wrapper for Coursera Plus subscription ID. */
export type CourseraPlusCollections_SubscriptionId = {
  /** Subscription ID. */
  id: Scalars['ID'];
};

/** Allows us to link a learner's Plus subscription to a specific Collection-save. */
export type CourseraPlusCollections_SubscriptionReference = {
  /** Plus checkout cart for the Collection-save when the subscription ID is not available yet (checkout path). */
  checkoutCartId?: InputMaybe<CourseraPlusCollections_CartId>;
  /** Plus subscription ID when the learner is already subscribed (post-checkout path). */
  subscriptionId?: InputMaybe<CourseraPlusCollections_SubscriptionId>;
};

/** The action that triggered a Coursera Plus Collection transaction. Later, `UNSAVE` might be possible. */
export const CourseraPlusCollections_TransactionAction = {
  /** Indicates the Collection save drove the user into Coursera Plus checkout. */
  CheckoutSave: 'CHECKOUT_SAVE',
  /** Indicates the Collection was saved without driving a Coursera Plus checkout. */
  Save: 'SAVE'
} as const;

export type CourseraPlusCollections_TransactionAction = typeof CourseraPlusCollections_TransactionAction[keyof typeof CourseraPlusCollections_TransactionAction];
export const CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction = {
  Enroll: 'ENROLL',
  Revoke: 'REVOKE',
  Unenroll: 'UNENROLL',
  Upgrade: 'UPGRADE'
} as const;

export type CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction = typeof CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction[keyof typeof CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction];
/** Types of assets that can be uploaded for a proctoring session. */
export const CourseraProctoring_AssetType = {
  /** An image from the user's camera. */
  CameraImage: 'CAMERA_IMAGE',
  /** An image from the user's primary camera. */
  PrimaryCameraImage: 'PRIMARY_CAMERA_IMAGE',
  /** An image of the user's screen. */
  ScreenImage: 'SCREEN_IMAGE',
  /** An image from the user's secondary camera. */
  SecondaryCameraImage: 'SECONDARY_CAMERA_IMAGE'
} as const;

export type CourseraProctoring_AssetType = typeof CourseraProctoring_AssetType[keyof typeof CourseraProctoring_AssetType];
/** Configuration for a camera in mutation input. */
export type CourseraProctoring_CameraConfigInput = {
  /** Whether camera is enabled or disabled. */
  cameraStatus: CourseraProctoring_EnablementStatus;
  /** Whether monitoring is enabled or disabled for this camera. */
  monitoringStatus: CourseraProctoring_EnablementStatus;
  /** Whether recording is enabled or disabled for this camera. */
  recordingStatus: CourseraProctoring_EnablementStatus;
};

/** Configuration for Coursera Proctoring features. */
export type CourseraProctoring_ConfigurationInput = {
  /** Configuration for the primary camera. */
  primaryCameraConfig: CourseraProctoring_CameraConfigInput;
  /** Configuration for the secondary camera. */
  secondaryCameraConfig: CourseraProctoring_CameraConfigInput;
};

/** Content type of the asset. */
export const CourseraProctoring_ContentType = {
  /** Content type of the asset is image/jpeg. */
  ImageJpeg: 'IMAGE_JPEG'
} as const;

export type CourseraProctoring_ContentType = typeof CourseraProctoring_ContentType[keyof typeof CourseraProctoring_ContentType];
/** Enum representing the enablement status. */
export const CourseraProctoring_EnablementStatus = {
  /** The feature is disabled. */
  Disabled: 'DISABLED',
  /** The feature is enabled and required. */
  Enabled: 'ENABLED'
} as const;

export type CourseraProctoring_EnablementStatus = typeof CourseraProctoring_EnablementStatus[keyof typeof CourseraProctoring_EnablementStatus];
/** Input to finish the proctoring session. */
export type CourseraProctoring_EndProctoringInput = {
  /** The identifier of the proctoring session to end. */
  proctoringSessionId: Scalars['ID'];
};

/** Feedback type for proctoring events. */
export const CourseraProctoring_FeedbackType = {
  /** Negative feedback */
  Downvote: 'DOWNVOTE',
  /** Positive feedback */
  Upvote: 'UPVOTE'
} as const;

export type CourseraProctoring_FeedbackType = typeof CourseraProctoring_FeedbackType[keyof typeof CourseraProctoring_FeedbackType];
/** The input to initialize a proctoring asset. */
export type CourseraProctoring_InitializeAssetInput = {
  /** The type of the asset being initialized. */
  assetType: CourseraProctoring_AssetType;
  /** The content type of the asset. */
  contentType: CourseraProctoring_ContentType;
  /** The identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/** Key-value pair representing a metadata entry. */
export type CourseraProctoring_MetadataEntry = {
  /** Metadata key */
  key: Scalars['String'];
  /** Metadata value */
  value: Scalars['String'];
};

/** The input to process an asset. */
export type CourseraProctoring_ProcessAssetInput = {
  /** The identifier of the asset. */
  assetId: Scalars['ID'];
  /** The identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/**
 * Input to reanalyze recordings that previously failed analysis.
 * INTERNAL USE ONLY: For manual intervention by engineers when recording analysis failures need to be fixed.
 */
export type CourseraProctoring_ReanalyzeRecordingsInput = {
  /** The identifiers of the recordings to reanalyze. */
  recordingIds: Array<Scalars['ID']>;
};

/** Input to set Coursera Proctoring enablement for an assessment. */
export type CourseraProctoring_SetEnablementInput = {
  /** The assessment ID. */
  assessmentId: Scalars['ID'];
  /** The type of the assessment. */
  assessmentType: ExamMonitor_AssessmentType;
  /** Configuration for proctoring. */
  configuration: CourseraProctoring_ConfigurationInput;
  /** The course ID. Required for public or YourOrg course sessions. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The course session ID. Required for private course sessions. */
  courseSessionId?: InputMaybe<Scalars['ID']>;
  /** Whether proctoring is enabled for the assessment. */
  enabled: Scalars['Boolean'];
};

/** Describes how severe misconduct is in a proctoring event. */
export const CourseraProctoring_Severity = {
  /** High severity event. */
  High: 'HIGH',
  /** Low severity event. */
  Low: 'LOW',
  /** Medium severity event. */
  Medium: 'MEDIUM',
  /** Normal event, no severity. */
  None: 'NONE'
} as const;

export type CourseraProctoring_Severity = typeof CourseraProctoring_Severity[keyof typeof CourseraProctoring_Severity];
/** Input to initialize a proctoring session. */
export type CourseraProctoring_StartProctoringInput = {
  /** The assessment being proctored. */
  assessmentId: Scalars['ID'];
  /** The type of the assessment being proctored. */
  assessmentType: ExamMonitor_AssessmentType;
  /** The assessment attempt being proctored. */
  attemptId: Scalars['ID'];
  /** The course session in which assessment is started. */
  courseSessionId: Scalars['ID'];
  /** Optional metadata about the proctoring session. Can store arbitrary key-value pairs. */
  metadata?: InputMaybe<Array<CourseraProctoring_MetadataEntry>>;
};

/** Event that is generated by the proctoring system. */
export type CourseraProctoring_SubmitProctoringEventFeedbackInput = {
  /** Asset ID. */
  assetId: Scalars['ID'];
  /** Feedback for the event. */
  feedback?: InputMaybe<Scalars['String']>;
  /** Feedback type. */
  feedbackType: CourseraProctoring_FeedbackType;
  /** Identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/** Denotes the different ways the learner can purchase a tier product (either through standard purchase or upgrade). */
export const CourseraTierSubscriptions_AcquisitionType = {
  /** Learner can purchase tier product through standard checkout */
  Standard: 'STANDARD',
  /** Learner can purchase tier product through upgrading/upsell */
  Upgrade: 'UPGRADE'
} as const;

export type CourseraTierSubscriptions_AcquisitionType = typeof CourseraTierSubscriptions_AcquisitionType[keyof typeof CourseraTierSubscriptions_AcquisitionType];
/** BillingCycles supported by existing subscriptions. */
export const CourseraTierSubscriptions_BillingCycle = {
  /** Billed annually */
  Annual: 'ANNUAL',
  /** Billed Monthly */
  Monthly: 'MONTHLY'
} as const;

export type CourseraTierSubscriptions_BillingCycle = typeof CourseraTierSubscriptions_BillingCycle[keyof typeof CourseraTierSubscriptions_BillingCycle];
/** Use to create a cart for checkout */
export type CourseraTierSubscriptions_CartCreateInput = {
  /** Country of the learner, to be used at checkout. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** Optional coupon id */
  couponId?: InputMaybe<Scalars['Int']>;
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /** List of products to be checked out by this cart. */
  productItems: Array<CourseraTierSubscriptions_CartItemCreateInput>;
  /** ID of the learner who owns this cart */
  userId: Scalars['ID'];
};

/** Used to create a cart item. Stores the product to be purchased and the action to take with it */
export type CourseraTierSubscriptions_CartItemCreateInput = {
  /** Mirrors the CartItemMetadata courier enum in infra-services. */
  metadata: CourseraTierSubscriptions_CartItemMetadataInputUnion;
  /** The action to take with this product */
  productAction: CourseraTierSubscriptions_ProductAction;
  /** ID of the product being purchased */
  productItemId: Scalars['ID'];
  /** The type of product being purchased */
  productType: CourseraTierSubscriptions_ProductType;
};

/**
 * CartItemMetadata input used for request params. Mirrors CartItemMetadata courier enum in
 * infra-services.
 */
export type CourseraTierSubscriptions_CartItemMetadataInputUnion = {
  /** Metadata for a CourseraTierLite subscription. */
  courseraTierLiteCartItemMetadataInput?: InputMaybe<CourseraTierSubscriptions_CourseraTierLiteCartItemMetadataInput>;
};

/**
 * CourseraTierLiteCartItemMetadata input used for request params. Includes Metadata for
 * a CourseraTierLite subscription.
 */
export type CourseraTierSubscriptions_CourseraTierLiteCartItemMetadataInput = {
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: InputMaybe<CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout coursera lite */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
};

/** CreateMidCycleUpgradeCart request object */
export type CourseraTierSubscriptions_CreateMidCycleUpgradeCartInput = {
  /** Country of the learner, to be used at checkout. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /** The Coursera Tier that the learner owns at time of upgrade */
  fromTier: CourseraTierSubscriptions_ProductType;
  /**
   * productEnrollmentInformation contains the course ID and/or Specialization ID to enroll the user into
   * after the upgrade. if this input is provided, then the productIdToEnroll must be provided therein.
   * If there is no s12nId, the courseId will be used as the productIdToEnroll.
   */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
  /** The Coursera Tier to which the learner is trying to upgrade */
  toTier: CourseraTierSubscriptions_ProductType;
  /** The billing cycle to which the learner is trying to upgrade */
  toTierBillingCycle?: InputMaybe<CourseraTierSubscriptions_BillingCycle>;
  /** ID of the learner who owns this cart */
  userId: Scalars['ID'];
};

/** Razorpay subscription id whose subscription needs to be ended. */
export type CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductInput = {
  /** Subscription Id */
  subscriptionId: Scalars['ID'];
};

/** The checkout information to be used for the toTier subscription */
export type CourseraTierSubscriptions_MidCycleUpgradeCheckoutInformation = {
  /** Subscription id for the fromTier in a midCycleUpgrade */
  fromTierSubscriptionId: Scalars['ID'];
  /** Payment information for the type of subscription that the learner is checking out */
  paymentInformation: CourseraTierSubscriptions_SubscriptionPaymentInformationInputUnion;
  /** Cart id for which to process coursera tier subscription checkout */
  toTierCartId: Scalars['ID'];
};

/** MidCycleUpgrade request object. */
export type CourseraTierSubscriptions_MidCycleUpgradeInput = {
  /**
   * [optional] The checkout information to be used for the toTier subscription instead of building
   * the toTier cart here and using the payment information linked to the "fromTier" subscription.
   */
  checkoutInformation?: InputMaybe<CourseraTierSubscriptions_MidCycleUpgradeCheckoutInformation>;
  /** Country of the learner, to be used at checkout. */
  countryIsoCode: Scalars['String'];
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /**
   * Deprecated. Use fromTierSubscriptionId instead.
   * @deprecated Use fromTierSubscriptionId instead.
   */
  fromTier?: InputMaybe<CourseraTierSubscriptions_ProductType>;
  /** ID of the Subscription which is to be migrated to the new tier. */
  fromTierSubscriptionId: Scalars['ID'];
  /**
   * [optional] productEnrollmentInformation contains the course ID and/or Specialization ID to enroll the user into
   * after the upgrade. If this input is provided, then the productIdToEnroll must be provided therein.
   * If there is no s12nId, the courseId will be used as the productIdToEnroll.
   */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
  /**
   * [optional] Promo code (eg: "SUBS_DISCOUNT_50") to include in the upgrade on the next billing.
   * Will be plugged into the UpgradeVariants.EmailParameters.additionalDiscountPromoCode.
   */
  promoCode?: InputMaybe<Scalars['String']>;
  /** The Coursera Tier to which the learner is trying to upgrade */
  toTier: CourseraTierSubscriptions_ProductType;
  /** [optional] The billing cycle to which the learner is trying to upgrade. Defaults to MONTHLY. */
  toTierBillingCycle?: InputMaybe<CourseraTierSubscriptions_BillingCycle>;
  /** User ID for which to process coursera tier subscription mid cycle upgrade. */
  userId: Scalars['ID'];
};

/**
 * Specifies the different payment cadence associated with the tier product configuration payment scheme
 * (Not to be confused with the actual PaymentSchemes of OneTimePaymentScheme and SubscriptionPaymentScheme
 * which contain actual paymentScheme details such as ownership, freeTrial and refund days)
 */
export const CourseraTierSubscriptions_PaymentCadence = {
  /** This is used to get tier product configuration details with annual subscription payment scheme */
  AnnualSubscription: 'ANNUAL_SUBSCRIPTION',
  /** This is used to get tier product configuration details with monthly subscription payment scheme */
  MonthlySubscription: 'MONTHLY_SUBSCRIPTION',
  /** This is used to get tier product configuration details with one-time payment scheme */
  OneTime: 'ONE_TIME'
} as const;

export type CourseraTierSubscriptions_PaymentCadence = typeof CourseraTierSubscriptions_PaymentCadence[keyof typeof CourseraTierSubscriptions_PaymentCadence];
/** Payment processor id in which this subscription billing is managed by. */
export const CourseraTierSubscriptions_PaymentProcessorId = {
  /** Payment processor id used for Braintree subscriptions. */
  Braintree: 'BRAINTREE',
  /** Payment processor id used for Braintree sandbox subscriptions. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Payment processor id used for Paypal subscriptions. */
  Paypal: 'PAYPAL',
  /** Payment processor id used Razorpay subscriptions. */
  Razorpay: 'RAZORPAY',
  /** Payment processor id used Razorpay subscriptions in sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Payment processor id used Stripe Europe subscriptions. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Payment processor id used Stripe Europe subscriptions in sandbox. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Payment processor id used Stripe subscriptions. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Payment processor id used Stripe subscriptions in sandbox. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX'
} as const;

export type CourseraTierSubscriptions_PaymentProcessorId = typeof CourseraTierSubscriptions_PaymentProcessorId[keyof typeof CourseraTierSubscriptions_PaymentProcessorId];
/** Product action of a transaction */
export const CourseraTierSubscriptions_ProductAction = {
  /**
   * Buy product action is the primary product action used by the FE.
   * Additional product actions are used to support our internal tool for Learner Services.
   * For the CourseraTierLite rollout, we are skipping internal tool support for the MVP.
   * We will rely on direct API calls if we need to do admin-level refunds.
   */
  Buy: 'BUY'
} as const;

export type CourseraTierSubscriptions_ProductAction = typeof CourseraTierSubscriptions_ProductAction[keyof typeof CourseraTierSubscriptions_ProductAction];
/**
 * ProductEnrollmentInformation input used for request params. Used when users
 * purchase CourseraTierSubscription through an CDP or SDP. After users purchase
 * CourserTierSubscription, we also need to enroll them into the corresponding course or s12n.
 */
export type CourseraTierSubscriptions_ProductEnrollmentInformationInput = {
  /**
   * Users can enroll in courseraTierSubscription through any CDP in an s12n. In this case, the user
   * should get the membership for that course instead of just going through normal s12n
   * enrollment flow which will
   * grant the membership of the first course in the s12n
   */
  courseIdToGrantMembership?: InputMaybe<Scalars['ID']>;
  /** The product to enroll with purchasing CourseraTierSubscription */
  productIdToEnroll: Scalars['ID'];
};

/** Product type of the coursera tier subscription */
export const CourseraTierSubscriptions_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /** Use for Invalid or deprecated product types */
  Invalid: 'INVALID'
} as const;

export type CourseraTierSubscriptions_ProductType = typeof CourseraTierSubscriptions_ProductType[keyof typeof CourseraTierSubscriptions_ProductType];
/** Payment information used for a razorpay subscription checkout used for request params. */
export type CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformationInput = {
  /** Signifies if the payment is being made in the sandbox environment. Defaults to false when absent. */
  isSandbox?: InputMaybe<Scalars['Boolean']>;
  /** Payment Id returned by Razorpay */
  razorpayPaymentId?: InputMaybe<Scalars['ID']>;
  /** Signature returned by Razorpay */
  razorpaySignature?: InputMaybe<Scalars['ID']>;
  /** Subscription Id return by Razorpay */
  razorpaySubscriptionId: Scalars['ID'];
};

/** SendEmailWorkaroundForRazorpayLiteToPlusUpgradeInput request object */
export type CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeInput = {
  /** Subscription ID for the Lite subscription that was just cancelled/invalidated/refunded so the learner could "upgrade to Plus. Primarily used to fetch the enrollments the learner previously engaged with so we could send them an email and they can reenroll as needed. */
  liteSubscriptionId: Scalars['ID'];
  /** Subscription ID for the Plus subscription that the learner checked out (e.g. "upgraded" to). Primarily used for receipt/fulfillment context */
  plusSubscriptionId: Scalars['ID'];
};

/** Status of the coursera tier subscription */
export const CourseraTierSubscriptions_Status = {
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  Active: 'ACTIVE',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE */
  Cancelled: 'CANCELLED',
  /**
   * Subscription has reached the specified number of billing cycles and has lapsed out of
   * the paid through period
   */
  Expired: 'EXPIRED',
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  FreeTrial: 'FREE_TRIAL',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE. */
  Inactive: 'INACTIVE',
  /** Learner maintains product ownership until the end of grace period after which status is INACTIVE */
  PastDue: 'PAST_DUE'
} as const;

export type CourseraTierSubscriptions_Status = typeof CourseraTierSubscriptions_Status[keyof typeof CourseraTierSubscriptions_Status];
/** Payment information used for a Stripe subscription upgrade. */
export type CourseraTierSubscriptions_StripeSubscriptionPaymentInformationInput = {
  /**
   * Optional new stripe payment method id which the learner wants the next transaction of the
   * subscription to be charged to.
   */
  updateSubscriptionToNewPaymentMethodId?: InputMaybe<Scalars['ID']>;
};

/** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
export const CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType = {
  /**
   * Used to trigger different side effects based off what type of payment a subscription checkout
   * Represents. Right now we only have the need to distinguish between INITIAL_CHECKOUT and
   * SUBSEQUENT_PAYMENT, but we may find a need for other actions like REFUND.
   */
  SubscriptionCartItemMetadataPaymentTypeInitialCheckout: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_INITIAL_CHECKOUT',
  /**
   * Any payment after the initial checkout payment. Deliberately chose not to call it
   * RECURRING_PAYMENT since that means both initial and subsequent payments in the context of our
   * store. Also didn't call it installment because generally we only use that to mean subsequent
   * payment for a terminal subscription.
   */
  SubscriptionCartItemMetadataPaymentTypeSubsequentPayment: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_SUBSEQUENT_PAYMENT'
} as const;

export type CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType = typeof CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType[keyof typeof CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType];
/**
 * Input subscription payment information that acts as a created subscription payment
 * information container. Used for request params.
 */
export type CourseraTierSubscriptions_SubscriptionPaymentInformationInputUnion = {
  /** Used for razorpay checkout. */
  razorpayPaymentInformation?: InputMaybe<CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformationInput>;
  /** Used for stripe checkout. */
  stripePaymentInformation?: InputMaybe<CourseraTierSubscriptions_StripeSubscriptionPaymentInformationInput>;
  /** Used for wallet based subscriptions such as Braintree */
  walletPaymentInformation?: InputMaybe<CourseraTierSubscriptions_WalletSubscriptionPaymentInformationInput>;
};

/** Input payment wallet subscription information used for request params. */
export type CourseraTierSubscriptions_WalletSubscriptionPaymentInformationInput = {
  /** Payment wallet id for the payment wallet used at checkout. */
  paymentWalletId: Scalars['ID'];
  /**
   * PaymentWalletThreeDsNonce is passed when 3D Secure is enabled during the subscription creation.
   * This nonce is validated for a specific transaction amount and is valid for 45 days.
   */
  paymentWalletThreeDsNonce?: InputMaybe<Scalars['String']>;
  /**
   * For subscriptions, this is the id of the subscription. (e.g. braintree's SubscriptionId). For
   * transactions, this is the id of the transaction. (i.e. id used in ExternalTransaction)
   */
  transactionId: Scalars['ID'];
};

/**
 * These are verification statuses that are useful from Coursera's perspective, and are
 * defined by Coursera. They are NOT the original callback parameter verificationStatus states
 * defined by Jumio
 *
 * For original verificationStatus states defined by Jumio, see JumioCallbackVerificationStatus.courier
 */
export const CourseraVerificationStatus = {
  /** Approved */
  Approved: 'APPROVED',
  /** Denied age */
  DeniedAge: 'DENIED_AGE',
  /** Denied by Jumio */
  DeniedByJumio: 'DENIED_BY_JUMIO',
  /** Denied by Persona */
  DeniedByPersona: 'DENIED_BY_PERSONA',
  /** Denied by expired id */
  DeniedExpiredId: 'DENIED_EXPIRED_ID',
  /** Denied restricted country */
  DeniedRestrictedCountry: 'DENIED_RESTRICTED_COUNTRY',
  /** Error not Jumio supported country */
  ErrorNotJumioSupportedCountry: 'ERROR_NOT_JUMIO_SUPPORTED_COUNTRY',
  /** Error not readable id */
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  /** No id uploaded */
  NoIdUploaded: 'NO_ID_UPLOADED',
  /** Pending */
  Pending: 'PENDING'
} as const;

export type CourseraVerificationStatus = typeof CourseraVerificationStatus[keyof typeof CourseraVerificationStatus];
/** Delete input */
export type CourserianRoles_DeleteRolesOfCourserianInput = {
  /** This id is the alias of a courserian. */
  courserianId: Scalars['ID'];
};

/** Update input */
export type CourserianRoles_UpdateRolesOfCourserianInput = {
  /** This id is the alias of a courserian. Each courserian's work email is [alias]@coursera.org. */
  courserianId: Scalars['ID'];
  /**
   * You can refer to
   * https://github.com/webedx-spark/user-roles-application/blob/cd0ceb60b56d29015993d98ca6b2957a502c1e96/src/main/java/org/coursera/userroles/models/CourserianRole.java#L5
   * for the list of permissible roles. They are mostly lower-case strings, like "dataAdmin", "engineer", etc.
   */
  roles: Array<Scalars['String']>;
};

export const CoursesV1_Org_Coursera_Course_CertificateType = {
  Ace: 'ACE',
  SoA: 'SoA',
  Specialization: 'Specialization',
  VerifiedCert: 'VerifiedCert'
} as const;

export type CoursesV1_Org_Coursera_Course_CertificateType = typeof CoursesV1_Org_Coursera_Course_CertificateType[keyof typeof CoursesV1_Org_Coursera_Course_CertificateType];
export const CoursesV1_Org_Coursera_Course_CourseMode = {
  Ondemand: 'ONDEMAND',
  Session: 'SESSION'
} as const;

export type CoursesV1_Org_Coursera_Course_CourseMode = typeof CoursesV1_Org_Coursera_Course_CourseMode[keyof typeof CoursesV1_Org_Coursera_Course_CourseMode];
export const CoursesV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type CoursesV1_Org_Coursera_Course_CourseStatus = typeof CoursesV1_Org_Coursera_Course_CourseStatus[keyof typeof CoursesV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const CoursesV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type CoursesV1_Org_Coursera_Course_PremiumExperienceVariant = typeof CoursesV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof CoursesV1_Org_Coursera_Course_PremiumExperienceVariant];
export const CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
/** Create course offering request */
export type CreateCourseOfferingRequest = {
  /** The course offering to be created */
  courseOffering: CourseOfferingInput;
};

/** Parameter for creating an upsell */
export type CreateUpsellRequest = {
  /** Additional parameters in JSON format */
  paramsJson?: InputMaybe<Scalars['String']>;
  /** The id of the product that upsells */
  sourceId: Scalars['ID'];
  /** The type of the product that upsells */
  sourceType: Scalars['String'];
  /** The id of the product to upsell to */
  targetId: Scalars['ID'];
  /** The type of the product to upsell to */
  targetType: Scalars['String'];
  /** Upsell type */
  upsellType: Scalars['String'];
};

/** Possible credential status values */
export const CredentialConfiguration_CredentialStatus = {
  /** Disabled credential status */
  Disabled: 'DISABLED',
  /** Enabled credential status */
  Enabled: 'ENABLED'
} as const;

export type CredentialConfiguration_CredentialStatus = typeof CredentialConfiguration_CredentialStatus[keyof typeof CredentialConfiguration_CredentialStatus];
/**
 * Defines the hierarchical levels at which a credential configuration can be applied.
 * Follows a top-down structure from institution to individual course/specialization level.
 */
export const CredentialConfiguration_Level = {
  /** Collection-level configuration */
  Collection: 'COLLECTION',
  /** Individual course-level configuration */
  Course: 'COURSE',
  /** Institution-wide configuration level */
  Institution: 'INSTITUTION',
  /** Learning path-specific configuration */
  LearningPath: 'LEARNING_PATH',
  /** Program-level configuration */
  Program: 'PROGRAM',
  /** Specialization-level configuration */
  Specialization: 'SPECIALIZATION'
} as const;

export type CredentialConfiguration_Level = typeof CredentialConfiguration_Level[keyof typeof CredentialConfiguration_Level];
/** Input for setting credential configuration for a collection or learning path */
export type CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathInput = {
  /** Credential status to set */
  credentialStatus: CredentialConfiguration_CredentialStatus;
  /** Program ID */
  programId: Scalars['ID'];
  /** Track ID (collection or learning path ID) */
  trackId: Scalars['ID'];
};

/** Input for setting credential configuration for a program */
export type CredentialConfiguration_SetCredentialConfigurationForProgramInput = {
  /** Credential status to set */
  credentialStatus: CredentialConfiguration_CredentialStatus;
  /** Program ID */
  programId: Scalars['ID'];
};

/**
 * Represents the possible states of a credential configuration.
 * MIXED state is particularly important for parent configurations that may have children
 * with different states.
 */
export const CredentialConfiguration_Status = {
  /** Configuration is active and fully enabled */
  Credential: 'CREDENTIAL',
  /** Indicates mixed states among child configurations */
  Mixed: 'MIXED',
  /** Configuration is inactive or disabled */
  NonCredential: 'NON_CREDENTIAL'
} as const;

export type CredentialConfiguration_Status = typeof CredentialConfiguration_Status[keyof typeof CredentialConfiguration_Status];
/** Generic input for updating credential configurations */
export type CredentialConfiguration_UpdateCredentialConfigurationInput = {
  /** Level of the credential configuration */
  configurationLevel: CredentialConfiguration_Level;
  /** New status for the credential configuration */
  configurationStatus: CredentialConfiguration_Status;
  /** Credential configuration ID */
  id: Scalars['ID'];
};

/** Mutation input for updating credential configurations inside institution */
export type CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionInput = {
  /**
   * Credential configurations to be updated.
   * For an institution, we expect a list of configs corresponding to the programs and collections under this program
   */
  credentialConfigurations: Array<CredentialConfiguration_UpdateCredentialConfigurationInput>;
  /** Institution for which credential configurations are to be updated in */
  institutionId: Scalars['ID'];
};

/** Mutation input for updating credential configurations inside program */
export type CredentialConfiguration_UpdateCredentialConfigurationsForProgramInput = {
  /**
   * Credential configurations to be updated.
   * For a program, we expect a list of configs corresponding to the collections and products under this program
   */
  credentialConfigurations: Array<CredentialConfiguration_UpdateCredentialConfigurationInput>;
  /** Program for which credential configurations are to be updated in */
  programId: Scalars['ID'];
};

/** Input for updating an enterprise program from a curation outline */
export type CurationBuilder_AddGroupCurationsToProgramsInput = {
  /** Suggested Curations with Matching Groups */
  SuggestedCurationsWithMatchingGroups: Array<CurationBuilder_SuggestedCurationWithMatchingGroups>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Input for creating an enterprise program from a program outline */
export type CurationBuilder_CreateProgramFromProgramOutlineInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program outline request */
  programOutlineRequest: CurationBuilder_ProgramOutlineUpdateRequest;
  /** Suggested curation requests */
  suggestedCurationRequests: Array<CurationBuilder_SuggestedCurationRequest>;
};

/** Input for Curation Outline Request */
export type CurationBuilder_CurationOutlineCreateOrUpdateRequest = {
  /** UUID for the curation outline (if no value is provided, will be auto-generated on the backend) */
  curationOutlineId?: InputMaybe<Scalars['ID']>;
  /** Parameters for curation outline request */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
};

/** Parameters of a Curation Outline */
export type CurationBuilder_CurationOutlineParams = {
  /** Type of curation (COLLECTIONS or LEARNING_PATHS) */
  curationType: CurationBuilder_CurationType;
  /** Description of the curation outline */
  description: Scalars['String'];
  /** Expected learning completion hours (default 10) - applicable only for LearningPaths */
  expectedLearningCompletionHours?: InputMaybe<Scalars['Float']>;
  /** Learning objectives */
  learningObjectives: Array<CurationBuilder_LearningObjectiveInput>;
  /** Title of the curation outline */
  title: Scalars['String'];
};

/** Curation type enum */
export const CurationBuilder_CurationType = {
  /** Collections curation type */
  Collections: 'COLLECTIONS',
  /** Learning paths curation type */
  LearningPaths: 'LEARNING_PATHS'
} as const;

export type CurationBuilder_CurationType = typeof CurationBuilder_CurationType[keyof typeof CurationBuilder_CurationType];
/** Input for generating group curation outlines */
export type CurationBuilder_GenerateBulkCurationOutlinesInput = {
  /**
   * Session UUID (optional)
   * if value not passed - BE will create a new session
   * if value is passed - BE will update an existing session
   */
  bulkSessionId?: InputMaybe<Scalars['ID']>;
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Types of curation to generate */
  curationTypes: Array<CurationBuilder_CurationType>;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the curation outline e.g. "en" */
  language: Scalars['String'];
  /** Program ID list, it can be empty. */
  learnerAudiences?: InputMaybe<Array<Scalars['ID']>>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Shared Prompt for group curation outlines creation */
  sharedPrompt: Scalars['String'];
};

/** Input for generating curation outline content suggestions */
export type CurationBuilder_GenerateCurationOutlineContentSuggestionsInput = {
  /** Contents to retain from previous suggestions */
  contentsToRetain?: Array<CurationBuilder_SuggestedCurationRequest>;
  /** Curation content types to include */
  curationContentTypes: Array<CurationBuilder_ProductType>;
  /** Array of curation outline requests */
  curationOutlineRequests: Array<CurationBuilder_CurationOutlineCreateOrUpdateRequest>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Partner IDs to filter suggestions */
  partnerIds: Array<Scalars['ID']>;
};

/** Input for generating a curation outline */
export type CurationBuilder_GenerateCurationOutlineInput = {
  /**
   * curation outline UUID (optional)
   * if value not passed - BE will create a new curationOutline
   * if value is passed - BE will update an existing curationOutline
   */
  curationOutlineId?: InputMaybe<Scalars['ID']>;
  /** Type of curation to generate */
  curationType: CurationBuilder_CurationType;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the curation outline e.g. "en" */
  language: Scalars['String'];
  /** Learner audience description */
  learnerAudience: Scalars['String'];
  /** Learning goals description */
  learningGoals: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program ID */
  programId: Scalars['ID'];
};

/** Input for requesting an s3 File upload location */
export type CurationBuilder_GenerateFileUploadLocationInput = {
  /** File name */
  fileName: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Input for generating a program outline */
export type CurationBuilder_GenerateProgramOutlineInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Types of curations to generate */
  curationTypes: Array<CurationBuilder_CurationType>;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the program outline e.g. "en" */
  language: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /**
   * program outline UUID (optional)
   * if value not passed - BE will create a new programOutline
   * if value is passed - BE will update an existing programOutline
   */
  programOutlineId?: InputMaybe<Scalars['ID']>;
  /** Text representing learner audience and learning goals */
  prompt: Scalars['String'];
};

/**
 * Input for generating AI prompt from a file
 * Will initialize an outline of supplied outlineType
 */
export type CurationBuilder_GeneratePromptAttributesFromFileInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Location of prompt file that was uploaded to s3 */
  fileLocation: CurationBuilder_PromptFileLocationInput;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /**
   * Optional Unique ID identifier for the outlineType
   * if not provided, a new outline of outlineType will be created/initialized
   * if provided, the existing outline of outlineType will be updated/reinitialized
   */
  outlineId?: InputMaybe<Scalars['ID']>;
  /** Type of outline to generate prompt attributes for */
  outlineType: CurationBuilder_OutlineType;
  /** program ID required for curation builder flow */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Input for Learning Objectives */
export type CurationBuilder_LearningObjectiveInput = {
  /** Text summarizing the learning objective */
  narration: Scalars['String'];
  /** Skills associated with this learning objective */
  skillIds: Array<Scalars['ID']>;
};

/** Input for learning path badge configuration */
export type CurationBuilder_LearningPathBadgeConfigurationInput = {
  /** Logo image height for the badge (px) */
  logoImageHeight?: Scalars['Int'];
  /** Logo image URL for the badge */
  logoImageUrl: Scalars['URL'];
};

/** Outline generation status enum */
export const CurationBuilder_OutlineGenerationStatus = {
  /** Outline will go into this state when generation is completed */
  Generated: 'GENERATED',
  /**
   * Outline will toggle through this state when generation is in progress
   * i.e. when CurationBuilder_GenerateProgramOutline is called
   * Outline will also return to this state when Regeneration is triggered
   */
  Generating: 'GENERATING',
  /**
   * This is a terminal state, when the generation failure is permanent and shouldn't be retried.
   * Outline may also go into this state when generation fails after all retries have been exhausted.
   * Users will need to be notified whenever generation hits this state.
   */
  GenerationFailedNonRetryable: 'GENERATION_FAILED_NON_RETRYABLE',
  /**
   * Outline may go into this state when generation fails but is eligible to be auto-retried.
   * The async generation logic would retry 3x after which if it still fails then the state would go permanently into GENERATION_FAILED_NON_RETRYABLE.
   */
  GenerationFailedRetryable: 'GENERATION_FAILED_RETRYABLE',
  /**
   * Initial status when outline is first saved during
   * the CurationBuilder_GeneratePromptAttributesFromFile stage
   * Outline will also return to this state when file is re-uploaded
   * i.e. CurationBuilder_GeneratePromptAttributesFromFile is called
   */
  GenerationInitialized: 'GENERATION_INITIALIZED'
} as const;

export type CurationBuilder_OutlineGenerationStatus = typeof CurationBuilder_OutlineGenerationStatus[keyof typeof CurationBuilder_OutlineGenerationStatus];
/** Outline type enum */
export const CurationBuilder_OutlineType = {
  /** Curation outline type */
  CurationOutline: 'CURATION_OUTLINE',
  /** Group curation outline type */
  GroupCurationOutline: 'GROUP_CURATION_OUTLINE',
  /** Program outline type */
  ProgramOutline: 'PROGRAM_OUTLINE'
} as const;

export type CurationBuilder_OutlineType = typeof CurationBuilder_OutlineType[keyof typeof CurationBuilder_OutlineType];
/** Product type enum */
export const CurationBuilder_ProductType = {
  /** Course product type */
  Course: 'COURSE',
  /** Guided project product type */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional certificate product type */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type */
  Project: 'PROJECT',
  /** Specialization product type */
  Specialization: 'SPECIALIZATION',
  /** Video product type */
  Video: 'VIDEO'
} as const;

export type CurationBuilder_ProductType = typeof CurationBuilder_ProductType[keyof typeof CurationBuilder_ProductType];
/** Parameters of a Program Outline */
export type CurationBuilder_ProgramOutlineParams = {
  /** Array of CurationOutline objects associated with this programOutline */
  curationOutlineRequests: Array<CurationBuilder_CurationOutlineCreateOrUpdateRequest>;
  /** Description about a program being built */
  programDescription: Scalars['String'];
  /** Name to be applied to a program being built */
  programName: Scalars['String'];
};

/** Input for Program Outline Request */
export type CurationBuilder_ProgramOutlineUpdateRequest = {
  /** Unique UUID identifier for a programOutline */
  programOutlineId: Scalars['ID'];
  /** Parameters for program outline request */
  programOutlineParams: CurationBuilder_ProgramOutlineParams;
};

/** S3 file location */
export type CurationBuilder_PromptFileLocationInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
  /** signed s3 Upload File Url */
  signedUploadUrl: Scalars['URL'];
};

/** Input for suggested curation */
export type CurationBuilder_SuggestedCurationRequest = {
  /** Curation outline ID */
  curationOutlineId: Scalars['ID'];
  /** Products suggested for this curation */
  productIds: Array<Scalars['ID']>;
};

/** Input for suggested curation with matched groups */
export type CurationBuilder_SuggestedCurationWithMatchingGroups = {
  /** Group IDs */
  groupIds: Array<Scalars['ID']>;
  /** Suggested curation requests */
  suggestedCurationRequests: Array<CurationBuilder_SuggestedCurationRequest>;
};

/** Input for updating badge configurations */
export type CurationBuilder_UpdateBadgeConfigurationsForProgramsInput = {
  /** Learning path badge configuration */
  learningPathBadgeConfiguration: CurationBuilder_LearningPathBadgeConfigurationInput;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs */
  programIds: Array<Scalars['ID']>;
};

/** Input for updating badge configurations */
export type CurationBuilder_UpdateBadgeConfigurationsInput = {
  /** Learning path badge configuration */
  learningPathBadgeConfiguration: CurationBuilder_LearningPathBadgeConfigurationInput;
  /**
   * DEPRECATED- Learning path badge configurations
   * @deprecated List not required - Use learningPathBadgeConfiguration instead
   */
  learningPathBadgeConfigurations?: InputMaybe<Array<CurationBuilder_LearningPathBadgeConfigurationInput>>;
  /** Program ID */
  programId: Scalars['ID'];
};

/** Input for updating a curation outline */
export type CurationBuilder_UpdateCurationOutlineInput = {
  /** UUID for the curation outline */
  curationOutlineId: Scalars['ID'];
  /** Curation outline parameters containing updated information */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Input for updating a curation outline */
export type CurationBuilder_UpdateCurationOutlineWithGroupsInput = {
  /** UUID for the curation outline */
  curationOutlineId: Scalars['ID'];
  /** Curation outline parameters containing updated information */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
  /** Updated matching group id */
  newMatchingGroupIds: Array<Scalars['ID']>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Input for updating an enterprise program from a curation outline */
export type CurationBuilder_UpdateProgramFromCurationOutlineInput = {
  /** Program ID */
  programId: Scalars['ID'];
  /** Suggested curation request */
  suggestedCurationRequest: CurationBuilder_SuggestedCurationRequest;
};

/** Input for updating a program outline */
export type CurationBuilder_UpdateProgramOutlineInput = {
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Unique UUID identifier for a programOutline */
  programOutlineId: Scalars['ID'];
  /** Program outline parameters containing updated information */
  programOutlineParams: CurationBuilder_ProgramOutlineParams;
};

/** Types of content that can be included in curation recommendations */
export const CurationRecommendation_CurationItemType = {
  /** Course content */
  Course: 'COURSE',
  /** Guided project content */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional certificate content */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project content */
  Project: 'PROJECT',
  /** Specialization content */
  Specialization: 'SPECIALIZATION',
  /** Video content */
  Video: 'VIDEO'
} as const;

export type CurationRecommendation_CurationItemType = typeof CurationRecommendation_CurationItemType[keyof typeof CurationRecommendation_CurationItemType];
/** Input for generating curation recommendations */
export type CurationRecommendation_GenerateRecommendationInput = {
  /** The ID of the collection to generate recommendations for */
  collectionId: Scalars['ID'];
  /** Language code for the recommendations (e.g., "en", "es", "fr") */
  language?: InputMaybe<Scalars['String']>;
};

/** Actions that can be taken on a content item in a curation suggestion */
export const CurationRecommendation_SuggestionActionType = {
  /** Add this content item to the collection */
  Add: 'ADD',
  /** Remove this content item from the collection */
  Delete: 'DELETE',
  /** Replace this content item from the collection */
  Replace: 'REPLACE'
} as const;

export type CurationRecommendation_SuggestionActionType = typeof CurationRecommendation_SuggestionActionType[keyof typeof CurationRecommendation_SuggestionActionType];
/** The reason for generating this curation recommendation. */
export const CurationRecommendation_SuggestionReason = {
  /** Replace content that is restricted or no longer available. */
  DeprecatedRestrictedContent: 'DEPRECATED_RESTRICTED_CONTENT',
  /** Add new content to collections that currently have fewer than 5 items. */
  ExpandCollection: 'EXPAND_COLLECTION',
  /** Replace content with a lower rating to enhance overall quality. */
  HigherRatingContent: 'HIGHER_RATING_CONTENT',
  /** Replace content that is older than one year with more current material. */
  NewerContent: 'NEWER_CONTENT',
  /** Remove content from collections that have more than 10 items. */
  ReduceCollection: 'REDUCE_COLLECTION',
  /** Remove content from collections that launched over 1 year. */
  StaleContent: 'STALE_CONTENT'
} as const;

export type CurationRecommendation_SuggestionReason = typeof CurationRecommendation_SuggestionReason[keyof typeof CurationRecommendation_SuggestionReason];
/** Status of a curation suggestion */
export const CurationRecommendation_SuggestionStatusType = {
  /** Suggestion has been accepted */
  Accepted: 'ACCEPTED',
  /** Suggestion is pending review */
  Pending: 'PENDING',
  /** Suggestion has been rejected */
  Rejected: 'REJECTED'
} as const;

export type CurationRecommendation_SuggestionStatusType = typeof CurationRecommendation_SuggestionStatusType[keyof typeof CurationRecommendation_SuggestionStatusType];
/** Input for updating suggestion status */
export type CurationRecommendation_UpdateSuggestionStatusInput = {
  /** Status to update to */
  action: CurationRecommendation_SuggestionStatusType;
  /** Suggestion ID to update status */
  suggestionId: Scalars['ID'];
};

/** current List of ISO4217 codes. */
export const CurrencyCode = {
  /** TODO: Complete this description */
  Aed: 'AED',
  /** TODO: Complete this description */
  Afn: 'AFN',
  /** TODO: Complete this description */
  All: 'ALL',
  /** TODO: Complete this description */
  Amd: 'AMD',
  /** TODO: Complete this description */
  And: 'AND',
  /** TODO: Complete this description */
  Ang: 'ANG',
  /** TODO: Complete this description */
  Aoa: 'AOA',
  /** TODO: Complete this description */
  Ars: 'ARS',
  /** TODO: Complete this description */
  Aud: 'AUD',
  /** TODO: Complete this description */
  Awg: 'AWG',
  /** TODO: Complete this description */
  Azn: 'AZN',
  /** TODO: Complete this description */
  Bam: 'BAM',
  /** TODO: Complete this description */
  Bbd: 'BBD',
  /** TODO: Complete this description */
  Bdt: 'BDT',
  /** TODO: Complete this description */
  Bgn: 'BGN',
  /** TODO: Complete this description */
  Bhd: 'BHD',
  /** TODO: Complete this description */
  Bif: 'BIF',
  /** TODO: Complete this description */
  Bmd: 'BMD',
  /** TODO: Complete this description */
  Bnd: 'BND',
  /** TODO: Complete this description */
  Bob: 'BOB',
  /** TODO: Complete this description */
  Bov: 'BOV',
  /** TODO: Complete this description */
  Brl: 'BRL',
  /** TODO: Complete this description */
  Bsd: 'BSD',
  /** TODO: Complete this description */
  Btn: 'BTN',
  /** TODO: Complete this description */
  Bwp: 'BWP',
  /** TODO: Complete this description */
  Byn: 'BYN',
  /** TODO: Complete this description */
  Bzd: 'BZD',
  /** TODO: Complete this description */
  Cad: 'CAD',
  /** TODO: Complete this description */
  Cdf: 'CDF',
  /** TODO: Complete this description */
  Che: 'CHE',
  /** TODO: Complete this description */
  Chf: 'CHF',
  /** TODO: Complete this description */
  Chw: 'CHW',
  /** TODO: Complete this description */
  Clf: 'CLF',
  /** TODO: Complete this description */
  Clp: 'CLP',
  /** TODO: Complete this description */
  Cny: 'CNY',
  /** TODO: Complete this description */
  Cop: 'COP',
  /** TODO: Complete this description */
  Cou: 'COU',
  /** TODO: Complete this description */
  Crc: 'CRC',
  /** TODO: Complete this description */
  Cuc: 'CUC',
  /** TODO: Complete this description */
  Cup: 'CUP',
  /** TODO: Complete this description */
  Cve: 'CVE',
  /** TODO: Complete this description */
  Czk: 'CZK',
  /** TODO: Complete this description */
  Djf: 'DJF',
  /** TODO: Complete this description */
  Dkk: 'DKK',
  /** TODO: Complete this description */
  Dop: 'DOP',
  /** TODO: Complete this description */
  Dzd: 'DZD',
  /** TODO: Complete this description */
  Egp: 'EGP',
  /** TODO: Complete this description */
  Ern: 'ERN',
  /** TODO: Complete this description */
  Etb: 'ETB',
  /** TODO: Complete this description */
  Eur: 'EUR',
  /** TODO: Complete this description */
  Fjd: 'FJD',
  /** TODO: Complete this description */
  Fkp: 'FKP',
  /** TODO: Complete this description */
  Gbp: 'GBP',
  /** TODO: Complete this description */
  Gel: 'GEL',
  /** TODO: Complete this description */
  Ghs: 'GHS',
  /** TODO: Complete this description */
  Gip: 'GIP',
  /** TODO: Complete this description */
  Gmd: 'GMD',
  /** TODO: Complete this description */
  Gnf: 'GNF',
  /** TODO: Complete this description */
  Gtq: 'GTQ',
  /** TODO: Complete this description */
  Gyd: 'GYD',
  /** TODO: Complete this description */
  Hkd: 'HKD',
  /** TODO: Complete this description */
  Hnl: 'HNL',
  /** TODO: Complete this description */
  Hrk: 'HRK',
  /** TODO: Complete this description */
  Htg: 'HTG',
  /** TODO: Complete this description */
  Huf: 'HUF',
  /** TODO: Complete this description */
  Idr: 'IDR',
  /** TODO: Complete this description */
  Ils: 'ILS',
  /** TODO: Complete this description */
  Inr: 'INR',
  /** TODO: Complete this description */
  Iqd: 'IQD',
  /** TODO: Complete this description */
  Irr: 'IRR',
  /** TODO: Complete this description */
  Isk: 'ISK',
  /** TODO: Complete this description */
  Jmd: 'JMD',
  /** TODO: Complete this description */
  Jod: 'JOD',
  /** TODO: Complete this description */
  Jpy: 'JPY',
  /** TODO: Complete this description */
  Kes: 'KES',
  /** TODO: Complete this description */
  Kgs: 'KGS',
  /** TODO: Complete this description */
  Khr: 'KHR',
  /** TODO: Complete this description */
  Kmf: 'KMF',
  /** TODO: Complete this description */
  Kpw: 'KPW',
  /** TODO: Complete this description */
  Krw: 'KRW',
  /** TODO: Complete this description */
  Kwd: 'KWD',
  /** TODO: Complete this description */
  Kyd: 'KYD',
  /** TODO: Complete this description */
  Kzt: 'KZT',
  /** TODO: Complete this description */
  Lak: 'LAK',
  /** TODO: Complete this description */
  Lbp: 'LBP',
  /** TODO: Complete this description */
  Lkr: 'LKR',
  /** TODO: Complete this description */
  Lrd: 'LRD',
  /** TODO: Complete this description */
  Lsl: 'LSL',
  /** TODO: Complete this description */
  Lyd: 'LYD',
  /** TODO: Complete this description */
  Mad: 'MAD',
  /** TODO: Complete this description */
  Mdl: 'MDL',
  /** TODO: Complete this description */
  Mga: 'MGA',
  /** TODO: Complete this description */
  Mkd: 'MKD',
  /** TODO: Complete this description */
  Mmk: 'MMK',
  /** TODO: Complete this description */
  Mnt: 'MNT',
  /** TODO: Complete this description */
  Mop: 'MOP',
  /** TODO: Complete this description */
  Mru: 'MRU',
  /** TODO: Complete this description */
  Mur: 'MUR',
  /** TODO: Complete this description */
  Mvr: 'MVR',
  /** TODO: Complete this description */
  Mwk: 'MWK',
  /** TODO: Complete this description */
  Mxn: 'MXN',
  /** TODO: Complete this description */
  Mxv: 'MXV',
  /** TODO: Complete this description */
  Myr: 'MYR',
  /** TODO: Complete this description */
  Mzn: 'MZN',
  /** TODO: Complete this description */
  Nad: 'NAD',
  /** TODO: Complete this description */
  Ngn: 'NGN',
  /** TODO: Complete this description */
  Nio: 'NIO',
  /** TODO: Complete this description */
  Nok: 'NOK',
  /** TODO: Complete this description */
  Npr: 'NPR',
  /** TODO: Complete this description */
  Nzd: 'NZD',
  /** TODO: Complete this description */
  Omr: 'OMR',
  /** TODO: Complete this description */
  Pab: 'PAB',
  /** TODO: Complete this description */
  Pen: 'PEN',
  /** TODO: Complete this description */
  Pgk: 'PGK',
  /** TODO: Complete this description */
  Php: 'PHP',
  /** TODO: Complete this description */
  Pkr: 'PKR',
  /** TODO: Complete this description */
  Pln: 'PLN',
  /** TODO: Complete this description */
  Pyg: 'PYG',
  /** TODO: Complete this description */
  Qar: 'QAR',
  /** TODO: Complete this description */
  Ron: 'RON',
  /** TODO: Complete this description */
  Rsd: 'RSD',
  /** TODO: Complete this description */
  Rub: 'RUB',
  /** TODO: Complete this description */
  Rwf: 'RWF',
  /** TODO: Complete this description */
  Sar: 'SAR',
  /** TODO: Complete this description */
  Sbd: 'SBD',
  /** TODO: Complete this description */
  Scr: 'SCR',
  /** TODO: Complete this description */
  Sdg: 'SDG',
  /** TODO: Complete this description */
  Sek: 'SEK',
  /** TODO: Complete this description */
  Sgd: 'SGD',
  /** TODO: Complete this description */
  Shp: 'SHP',
  /** TODO: Complete this description */
  Sll: 'SLL',
  /** TODO: Complete this description */
  Sos: 'SOS',
  /** TODO: Complete this description */
  Srd: 'SRD',
  /** TODO: Complete this description */
  Ssp: 'SSP',
  /** TODO: Complete this description */
  Stn: 'STN',
  /** TODO: Complete this description */
  Svc: 'SVC',
  /** TODO: Complete this description */
  Syp: 'SYP',
  /** TODO: Complete this description */
  Szl: 'SZL',
  /** TODO: Complete this description */
  Thb: 'THB',
  /** TODO: Complete this description */
  Tjs: 'TJS',
  /** TODO: Complete this description */
  Tmt: 'TMT',
  /** TODO: Complete this description */
  Tnd: 'TND',
  /** TODO: Complete this description */
  Top: 'TOP',
  /** TODO: Complete this description */
  Try: 'TRY',
  /** TODO: Complete this description */
  Ttd: 'TTD',
  /** TODO: Complete this description */
  Twd: 'TWD',
  /** TODO: Complete this description */
  Tzs: 'TZS',
  /** TODO: Complete this description */
  Uah: 'UAH',
  /** TODO: Complete this description */
  Ugx: 'UGX',
  /** TODO: Complete this description */
  Usd: 'USD',
  /** TODO: Complete this description */
  Usn: 'USN',
  /** TODO: Complete this description */
  Uyi: 'UYI',
  /** TODO: Complete this description */
  Uyu: 'UYU',
  /** TODO: Complete this description */
  Uyw: 'UYW',
  /** TODO: Complete this description */
  Uzs: 'UZS',
  /** TODO: Complete this description */
  Ved: 'VED',
  /** TODO: Complete this description */
  Ves: 'VES',
  /** TODO: Complete this description */
  Vnd: 'VND',
  /** TODO: Complete this description */
  Vuv: 'VUV',
  /** TODO: Complete this description */
  Wst: 'WST',
  /** TODO: Complete this description */
  Xaf: 'XAF',
  /** TODO: Complete this description */
  Xag: 'XAG',
  /** TODO: Complete this description */
  Xau: 'XAU',
  /** TODO: Complete this description */
  Xba: 'XBA',
  /** TODO: Complete this description */
  Xbb: 'XBB',
  /** TODO: Complete this description */
  Xbc: 'XBC',
  /** TODO: Complete this description */
  Xbd: 'XBD',
  /** TODO: Complete this description */
  Xcd: 'XCD',
  /** TODO: Complete this description */
  Xdr: 'XDR',
  /** TODO: Complete this description */
  Xof: 'XOF',
  /** TODO: Complete this description */
  Xpd: 'XPD',
  /** TODO: Complete this description */
  Xpf: 'XPF',
  /** TODO: Complete this description */
  Xpt: 'XPT',
  /** TODO: Complete this description */
  Xsu: 'XSU',
  /** TODO: Complete this description */
  Xts: 'XTS',
  /** TODO: Complete this description */
  Xua: 'XUA',
  /** TODO: Complete this description */
  Xxx: 'XXX',
  /** TODO: Complete this description */
  Yer: 'YER',
  /** TODO: Complete this description */
  Zar: 'ZAR',
  /** TODO: Complete this description */
  Zmw: 'ZMW',
  /** TODO: Complete this description */
  Zwl: 'ZWL'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];
/** Input schema for triggerCurriculumDownload job */
export type CurriculumBuilder_TriggerCurriculumDownloadInput = {
  /** Include FullCatalog export or not */
  includeFullCatalog?: InputMaybe<Scalars['Boolean']>;
  /** Include SkillSet export or not */
  includeSkillSet?: InputMaybe<Scalars['Boolean']>;
  /** ProgramId to be exported */
  programId: Scalars['ID'];
  /** UserId of the requester */
  userId: Scalars['ID'];
};

/** Types of file processing */
export const CurriculumManagement_FileProcessingType = {
  /** Curriculum data */
  Curriculum: 'CURRICULUM',
  /** Event data on the academic calendar */
  Event: 'EVENT',
  /** Term data */
  Term: 'TERM'
} as const;

export type CurriculumManagement_FileProcessingType = typeof CurriculumManagement_FileProcessingType[keyof typeof CurriculumManagement_FileProcessingType];
/** Types for invocation errors */
export const CurriculumManagement_InvocationErrorType = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** There is already an in-progress invocation for the same type */
  InProgressInvocationAlreadyExists: 'IN_PROGRESS_INVOCATION_ALREADY_EXISTS'
} as const;

export type CurriculumManagement_InvocationErrorType = typeof CurriculumManagement_InvocationErrorType[keyof typeof CurriculumManagement_InvocationErrorType];
/** Input for launching the DPM experience */
export type CurriculumManagement_LaunchDegreeProgressMapExperienceInput = {
  /** The degree slug */
  degreeSlug: Scalars['String'];
};

/** Input for starting file processing */
export type CurriculumManagement_StartFileProcessingInput = {
  /** The degree slug */
  degreeSlug: Scalars['String'];
  /** The partner slug */
  partnerSlug: Scalars['String'];
  /** The type of the data being processed */
  processingType: CurriculumManagement_FileProcessingType;
  /** The list of names of the uploaded files */
  uploadedFileNames: Array<Scalars['String']>;
};

/** The workflow status types */
export const CurriculumManagement_WorkflowStatus = {
  /** The workflow failed */
  Failed: 'FAILED',
  /** The workflow is still in-progress */
  InProgress: 'IN_PROGRESS',
  /** The workflow ended successfully */
  Successful: 'SUCCESSFUL'
} as const;

export type CurriculumManagement_WorkflowStatus = typeof CurriculumManagement_WorkflowStatus[keyof typeof CurriculumManagement_WorkflowStatus];
/** Day in a week */
export const DailyItemCompletions_DayInAWeek = {
  /** Friday */
  Friday: 'FRIDAY',
  /** Monday */
  Monday: 'MONDAY',
  /** Saturday */
  Saturday: 'SATURDAY',
  /** Sunday */
  Sunday: 'SUNDAY',
  /** Thursday */
  Thursday: 'THURSDAY',
  /** Tuesday */
  Tuesday: 'TUESDAY',
  /** Wednesday */
  Wednesday: 'WEDNESDAY'
} as const;

export type DailyItemCompletions_DayInAWeek = typeof DailyItemCompletions_DayInAWeek[keyof typeof DailyItemCompletions_DayInAWeek];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType = {
  Installment: 'INSTALLMENT',
  Upgrade: 'UPGRADE'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Expired: 'EXPIRED',
  Paused: 'PAUSED',
  Terminated: 'TERMINATED'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = {
  ContractEndDate: 'CONTRACT_END_DATE',
  Downgraded: 'DOWNGRADED',
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  Migrated: 'MIGRATED',
  MissingPayment: 'MISSING_PAYMENT',
  Refunded: 'REFUNDED',
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = {
  SelfServe: 'SELF_SERVE',
  Standard: 'STANDARD'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType];
/** EnterpriseContract's can be paid for in a variety of different ways. The EnterpriseContractBillingSystemType is a finite list of the billing methods available for both direct sales and WES contracts. */
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = {
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  NonBillable: 'NON_BILLABLE',
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType = {
  InstallmentPayment: 'INSTALLMENT_PAYMENT',
  RenewalPayment: 'RENEWAL_PAYMENT'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
/** Names that identify price mappings for self-serve contracts, where a price mapping defines the per-user cost of a contract based on the contract's courses per user limit. */
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = {
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = {
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag];
/** Degree duration */
export type DegreeAttributes_DurationInput = {
  /** Total time for the degree */
  duration: Scalars['Int'];
  /** Unit of degree duration */
  totalTimeUnit: DegreeAttributes_TimeUnit;
};

/** Time unit for degree duration */
export const DegreeAttributes_TimeUnit = {
  /** Day */
  Day: 'DAY',
  /** Month */
  Month: 'MONTH',
  /** Week */
  Week: 'WEEK',
  /** Year */
  Year: 'YEAR'
} as const;

export type DegreeAttributes_TimeUnit = typeof DegreeAttributes_TimeUnit[keyof typeof DegreeAttributes_TimeUnit];
/** Tuition */
export type DegreeAttributes_TuitionInput = {
  /** Amount */
  amount: Scalars['Float'];
  /** Currency */
  currency: Scalars['String'];
};

/** Degree Attributes upsert request object */
export type DegreeAttributes_UpdateDegreeAttributesInput = {
  /** Degree ID */
  degreeId: Scalars['ID'];
  /** Whether the degree requires a bachelor's degree */
  degreeRequiresBachelorDegree?: InputMaybe<Scalars['Boolean']>;
  /** Total time for the degree */
  duration?: InputMaybe<DegreeAttributes_DurationInput>;
  /** Whether the degree has an application fee */
  hasApplicationFee?: InputMaybe<Scalars['Boolean']>;
  /** Whether the degree has a scholarship */
  hasScholarship?: InputMaybe<Scalars['Boolean']>;
  /** The tuition in the advertised currency for the degree */
  marketedTuition?: InputMaybe<DegreeAttributes_TuitionInput>;
  /** The number of courses in the degree */
  numCourses?: InputMaybe<Scalars['Int']>;
  /** The number of credits in the degree */
  numCredits?: InputMaybe<Scalars['Int']>;
  /** The number of modules in the degree */
  numModules?: InputMaybe<Scalars['Int']>;
  /** The number of cohorts for the degree */
  numberOfCohorts?: InputMaybe<Scalars['Int']>;
  /** The on campus tuition for the degree */
  onCampusTuition?: InputMaybe<Scalars['Float']>;
  /** Whether the online tuition is the same as the on campus tuition */
  onlineSameAsOnCampus?: InputMaybe<Scalars['Boolean']>;
  /** Whether the degree is pay as you go */
  payAsYouGo?: InputMaybe<Scalars['Boolean']>;
  /** The primary aligned job for the degree */
  primaryAlignedJob?: InputMaybe<Scalars['String']>;
  /** The QS ranking for the degree */
  qsRanking?: InputMaybe<Scalars['Int']>;
  /** The tuition in USD for the degree */
  tuitionInUsd?: InputMaybe<Scalars['Float']>;
  /** The webinar host for the degree */
  webinarHost?: InputMaybe<Scalars['String']>;
};

/** Catalog availability status of the degree */
export const DegreeAuthoring_CatalogAvailabilityStatus = {
  /** Degree is archived */
  Archived: 'ARCHIVED',
  /** Degree is still in draft */
  Draft: 'DRAFT',
  /** Degree is live */
  Live: 'LIVE',
  /** Degree is in prelaunch */
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type DegreeAuthoring_CatalogAvailabilityStatus = typeof DegreeAuthoring_CatalogAvailabilityStatus[keyof typeof DegreeAuthoring_CatalogAvailabilityStatus];
/** Query for Degrees */
export type DegreeAuthoring_DegreeQueryInput = {
  /** Query for Catalog availability statuses */
  catalogAvailabilityStatuses?: InputMaybe<Array<DegreeAuthoring_CatalogAvailabilityStatus>>;
  /** Query by Degree Category Ids */
  degreeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Query for domain Ids */
  domainIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Query by EOI types */
  eoiTypes?: InputMaybe<Array<DegreeAuthoring_EoiType>>;
  /** Query for Degree IDs, including draft degrees */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Query for language codes */
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Query by mailspin template ID */
  mailspinTemplateId?: InputMaybe<Scalars['ID']>;
  /** Query for partial name match */
  name?: InputMaybe<Scalars['String']>;
  /** Query for product variants */
  productVariants?: InputMaybe<Array<DegreeAuthoring_ProductVariant>>;
  /** Query for partial short name match */
  shortName?: InputMaybe<Scalars['String']>;
  /** Query for partial slug match */
  slug?: InputMaybe<Scalars['String']>;
  /** Query for partial tagline match */
  tagline?: InputMaybe<Scalars['String']>;
};

/** Expression of Interest types */
export const DegreeAuthoring_EoiType = {
  /** EOI Extra Questions */
  EoiExtraQuestions: 'EOI_EXTRA_QUESTIONS',
  /** One click email */
  EoiOneClickEmail: 'EOI_ONE_CLICK_EMAIL',
  /** Only phone */
  EoiOnlyPhone: 'EOI_ONLY_PHONE'
} as const;

export type DegreeAuthoring_EoiType = typeof DegreeAuthoring_EoiType[keyof typeof DegreeAuthoring_EoiType];
/** Input for generating a pre-signed URL for a file upload */
export type DegreeAuthoring_FileUploadSignUrlRequest = {
  /** MD5 checksum of the file to be uploaded */
  contentMd5?: InputMaybe<Scalars['String']>;
  /** MIME type of the file to be uploaded */
  contentType: Scalars['String'];
  /** Name of the file to be uploaded */
  fileName: Scalars['String'];
};

/** Prooduct variant of the degree */
export const DegreeAuthoring_ProductVariant = {
  /** Bachelors degree */
  BachelorsDegree: 'BachelorsDegree',
  /** Graduate certificate */
  GraduateCertificate: 'GraduateCertificate',
  /** MasterTrack */
  MasterTrack: 'MasterTrack',
  /** Masters degree */
  MastersDegree: 'MastersDegree',
  /** Postgraduate diploma */
  PostgraduateDiploma: 'PostgraduateDiploma',
  /** Professional certificate */
  ProfessionalCertificate: 'ProfessionalCertificate',
  /** University certificate */
  UniversityCertificate: 'UniversityCertificate'
} as const;

export type DegreeAuthoring_ProductVariant = typeof DegreeAuthoring_ProductVariant[keyof typeof DegreeAuthoring_ProductVariant];
export const DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier = {
  Tier_1: 'TIER_1',
  Tier_2: 'TIER_2'
} as const;

export type DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier = typeof DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier[keyof typeof DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier];
/** Search filter for querying degree categories. */
export type DegreeCategoryGetAllQueryFilter = {
  /** Optional parameter that determines whether degree counts should be included in degreeCategory response. */
  degreeCountSpecs?: InputMaybe<DegreeCountSpecs>;
  /** Optional parameter that determines whether premium products collections should be included in degreeCategory response. */
  learningProductSpecs?: InputMaybe<PremiumLearningProductSpecs>;
  /** Optional parameter for ordering degree categories. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Optional parameter specifying the Tier that degree category results should belong to. */
  tiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Parameters for creating or updating a degree category. */
export type DegreeCategoryRequest = {
  /** Unique ID of the degree category. */
  id: Scalars['String'];
  /** Name of the degree category. */
  name: Scalars['String'];
  /** Unique slug of the degree category. */
  slug: Scalars['String'];
  /** Tag line of the degree category. */
  tagline: Scalars['String'];
  /** Tier that a degree category belongs to. */
  tier: Scalars['String'];
};

/** Input for creating student success attributes (same as above without version). */
export type DegreeConfig_CreateStudentSuccessAttributesInput = {
  /** The degree to update the attributes for. */
  degreeId: Scalars['ID'];
  /** Whether the degree supports disclaimers or not */
  disclaimersConfig: DegreeConfig_DisclaimerConfigInput;
  /** The enrollment URL provided by the partner where students can enroll for classes. */
  enrollmentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the degree supports FCND (for-credit non-degree) students or not. */
  fcndConfig: DegreeConfig_FcndConfigInput;
  /** Indicates whether the degree supports a performance pathway admissions process. */
  hasPbaAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports an open content performance pathway admissions process. */
  hasPbaWithOpenContentAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports a traditional admissions process. */
  hasTraditionalAdmissionProcess: Scalars['Boolean'];
  /**
   * The maximum number of terms (if there is one) that a student can be enrolled as a degree student
   * in the program.
   */
  maxTerms: Scalars['Int'];
};

/** Configurations for disclaimer support. */
export type DegreeConfig_DisclaimerConfigInput = {
  /** Optional call to action label. */
  disclaimerCallToAction?: InputMaybe<Scalars['String']>;
  /** Disclaimer message. */
  disclaimerMessage: Scalars['String'];
  /** Optional URL to redirect learners to partner portal. */
  disclaimerUrl?: InputMaybe<Scalars['URL']>;
  /** Whether disclaimer support is enabled or not. */
  enabled: Scalars['Boolean'];
};

/** Different degree config errors */
export const DegreeConfig_Error = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** Any other BE validation errors (data invalid) - this is so that any other validation errors on the BE are not thrown as internal errors */
  InvalidArgument: 'INVALID_ARGUMENT',
  /** The maxCreditsForFcnd field is null but FCND is enabled */
  MaxCreditsForFcndMissing: 'MAX_CREDITS_FOR_FCND_MISSING',
  /** The version does not match the stored version */
  VersionConflict: 'VERSION_CONFLICT'
} as const;

export type DegreeConfig_Error = typeof DegreeConfig_Error[keyof typeof DegreeConfig_Error];
/** Configurations for FCND support. */
export type DegreeConfig_FcndConfigInput = {
  /** Whether FCND support is enabled or not. */
  enabled: Scalars['Boolean'];
  /**
   * The maximum number of credits (if there is one) that learners can apply towards degree
   * completion as an FCND student (before being admitted to the degree)
   */
  maxNumberOfCredits?: InputMaybe<Scalars['Int']>;
};

/** Input for updating student success attributes. */
export type DegreeConfig_UpdateStudentSuccessAttributesInput = {
  /** The degree to update the attributes for. */
  degreeId: Scalars['ID'];
  /** Whether the degree supports disclaimers or not */
  disclaimersConfig: DegreeConfig_DisclaimerConfigInput;
  /** The enrollment URL provided by the partner where students can enroll for classes. */
  enrollmentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the degree supports FCND (for-credit non-degree) students or not. */
  fcndConfig: DegreeConfig_FcndConfigInput;
  /** Indicates whether the degree supports a performance pathway admissions process. */
  hasPbaAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports an open content performance pathway admissions process. */
  hasPbaWithOpenContentAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports a traditional admissions process. */
  hasTraditionalAdmissionProcess: Scalars['Boolean'];
  /**
   * The maximum number of terms (if there is one) that a student can be enrolled as a degree student
   * in the program.
   */
  maxTerms: Scalars['Int'];
  /** The version of the student success attributes to trigger the update on. */
  version: Scalars['Int'];
};

/** Parameter for querying degree categories when degree count is required in the results. */
export type DegreeCountSpecs = {
  /** Availability status by which to retrieve degree counts. */
  catalogAvailabilityStatuses?: InputMaybe<Array<Scalars['String']>>;
};

/** List item */
export const DegreeEnrollmentCheckListItem = {
  /** APPLICATION_ACCEPTED */
  ApplicationAccepted: 'APPLICATION_ACCEPTED',
  /** ENROLL_IN_COURSES */
  EnrollInCourses: 'ENROLL_IN_COURSES',
  /** PAY_APPLICATION_FEE */
  PayApplicationFee: 'PAY_APPLICATION_FEE',
  /** SUBMIT_APPLICATION */
  SubmitApplication: 'SUBMIT_APPLICATION'
} as const;

export type DegreeEnrollmentCheckListItem = typeof DegreeEnrollmentCheckListItem[keyof typeof DegreeEnrollmentCheckListItem];
/** Composite key for checklists */
export type DegreeEnrollmentChecklistKey = {
  /** Product slug */
  productSlug: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** User */
  userId: Scalars['String'];
};

/** Includes all high-credentials and not just strict degrees, but for lack of a better term that's also widely accepted, still naming as degree here. Why are we using this type instead of [[DegreeProductVariant]] from the core [[Degree]] model? There are some types in [[DegreeProductVariant]] that don't concern us at all (we don't market every variant of degrees). We also don't want to couple the types we need for marketing purposes with the types that are created for learning experience purposes; for now, the systems for marketing specific data are largely isolated from learning experience systems. */
export const DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType = {
  Degree: 'DEGREE',
  Mastertrack: 'MASTERTRACK'
} as const;

export type DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType = typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType[keyof typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType];
/** The things that a learner may have to do on their path to becoming a Mastertrack/Degree student. */
export const DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem = {
  ApplicationAccepted: 'APPLICATION_ACCEPTED',
  EnrollInCourses: 'ENROLL_IN_COURSES',
  PayApplicationFee: 'PAY_APPLICATION_FEE',
  SubmitApplication: 'SUBMIT_APPLICATION'
} as const;

export type DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem = typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem[keyof typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem];
/** Assignment progress state */
export const DegreeEvent_AssignmentProgressState = {
  /** If the assignment is graded and not passed */
  Failed: 'FAILED',
  /** If the assignment is not submitted by the student */
  NotSubmitted: 'NOT_SUBMITTED',
  /** If the assignment is not submitted and overdue */
  Overdue: 'OVERDUE',
  /** If the assignment is graded and passed */
  Passed: 'PASSED',
  /** If the assignment is not submitted by the student, but not graded */
  Submitted: 'SUBMITTED'
} as const;

export type DegreeEvent_AssignmentProgressState = typeof DegreeEvent_AssignmentProgressState[keyof typeof DegreeEvent_AssignmentProgressState];
/** Submission type configured for the assignment */
export const DegreeEvent_AssignmentSubmissionType = {
  /** The assignment is configured to be submitted by individual learners */
  Individual: 'INDIVIDUAL',
  /** The assignment has a submission type that doesn't belong to any of the common categories */
  Other: 'OTHER',
  /** The assignment is configured to be submitted by teams */
  Team: 'TEAM'
} as const;

export type DegreeEvent_AssignmentSubmissionType = typeof DegreeEvent_AssignmentSubmissionType[keyof typeof DegreeEvent_AssignmentSubmissionType];
/** The type of the academic event */
export const DegreeEvent_EventType = {
  /** The type for submitting grading */
  GradingSubmission: 'GRADING_SUBMISSION',
  /** A generic type for events that do not belong to all the above types */
  Other: 'OTHER',
  /** The type for the end of the registration */
  RegistrationEnd: 'REGISTRATION_END',
  /** The type for the start of the registration */
  RegistrationStart: 'REGISTRATION_START'
} as const;

export type DegreeEvent_EventType = typeof DegreeEvent_EventType[keyof typeof DegreeEvent_EventType];
/** Degree roles that are assignable to learners. */
export const DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole = {
  DeletedLearner: 'DELETED_LEARNER',
  Learner: 'LEARNER'
} as const;

export type DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole = typeof DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole[keyof typeof DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole];
export const DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature = typeof DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature];
export const DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState = {
  Completed: 'Completed',
  Failed: 'Failed',
  InReview: 'InReview',
  NotStarted: 'NotStarted',
  Optional: 'Optional',
  Started: 'Started'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState = typeof DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState];
/** Enum to indicate to the platform the status of the user towards the activity's completion. It is up to the tool to determine the appropriate value for this enum. See spec for more details: https://www.imsglobal.org/spec/lti-ags/v2p0/#activityprogress */
export const DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus = {
  Completed: 'Completed',
  InProgress: 'InProgress',
  Initialized: 'Initialized',
  Started: 'Started',
  Submitted: 'Submitted'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus = typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus];
/** Enum to indicate to the platform the status of the grading process, including allowing to inform when human intervention is needed. It is up to the tool to determine the appropriate value for this enum. See spec for more details: https://www.imsglobal.org/spec/lti-ags/v2p0/#gradingprogress */
export const DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress = {
  Failed: 'Failed',
  FullyGraded: 'FullyGraded',
  NotReady: 'NotReady',
  Pending: 'Pending',
  PendingManual: 'PendingManual'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress = typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress];
export const DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
/**
 * Degree marketing types.
 * The first use case is to support value first landing pages.
 */
export const DegreeMarketing_MarketingType = {
  /** Pathway degrees. */
  Pathway: 'PATHWAY'
} as const;

export type DegreeMarketing_MarketingType = typeof DegreeMarketing_MarketingType[keyof typeof DegreeMarketing_MarketingType];
/** Update input */
export type DegreeMarketing_UpdateCourseInput = {
  /** Id of the catalog degree course */
  id: Scalars['ID'];
  /** For Credit Non Degree flag */
  isForCreditNonDegree: Scalars['Boolean'];
};

/** Filter accepted by the generic query */
export type DegreeMarketing_UpsellFilterRequest = {
  /** Return only upsells that were active at the given time */
  activeAtUtc?: InputMaybe<Scalars['String']>;
  /** Indicates weather to show deleted upsells too, it cancels the activeAtUtc flag */
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  /** The id of the product that upsells. If sourceId is present, source type must be present too */
  sourceId?: InputMaybe<Scalars['ID']>;
  /** The type of the product that upsells */
  sourceType?: InputMaybe<Scalars['String']>;
  /** The id of the product to upsell to. If targetId is present, source type must be present too */
  targetId?: InputMaybe<Scalars['ID']>;
  /** The type of the product to upsell to */
  targetType?: InputMaybe<Scalars['String']>;
  /** Upsell type */
  upsellType?: InputMaybe<Scalars['String']>;
};

/** Slot Input for IN_COURSE_EXPERIENCE_COMPLETION_STATE Slot */
export type DegreePathwaysMerchandising_InCourseExperienceCompletionStateInput = {
  /** The ID of the course being taken. */
  courseId: Scalars['ID'];
  /** The ID of the specialization that the course being taken is part of. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** Slot Input for IN_COURSE_EXPERIENCE_UPSELL_NOTIFICATION Slot */
export type DegreePathwaysMerchandising_InCourseExperienceUpsellNotificationInput = {
  /** The ID of the course being taken. */
  courseId: Scalars['ID'];
  /** The ID of the specialization that the course being taken is part of. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** Slot Input for LIHP_MY_LEARNING_TAB Slot */
export type DegreePathwaysMerchandising_LoggedInHomePageMyLearningTabInput = {
  /** The IDs of the courses in the My Learning Tab */
  courseIds: Array<Scalars['ID']>;
  /** The IDs of the specializations in the My Learning Tab. */
  s12nIds: Array<Scalars['ID']>;
};

/** Slot Input for LIHP_PATHWAY_DEGREES_COLLECTION Slot */
export type DegreePathwaysMerchandising_LoggedInHomePagePathwayDegreesCollectionInput = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Slot Input for LIHP_STACKABLE_PATHWAY_CONTENT_COLLECTION Slot */
export type DegreePathwaysMerchandising_LoggedInHomePageStackablePathwayContentCollectionInput = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Presentational Tags that let the FE know of any special styling that should
 * be done for the Degree Pathways merchandising module
 */
export const DegreePathwaysMerchandising_PresentationalTags = {
  /** Featured Visual Treatment */
  Featured: 'FEATURED',
  /** With Expression of Interest */
  WithEoi: 'WITH_EOI'
} as const;

export type DegreePathwaysMerchandising_PresentationalTags = typeof DegreePathwaysMerchandising_PresentationalTags[keyof typeof DegreePathwaysMerchandising_PresentationalTags];
/** Slots on Coursera of which we merchandise Degree Pathways */
export const DegreePathwaysMerchandising_Slot = {
  /** The completion state upsell on the LEX / in course experience */
  InCourseExperienceCompletionState: 'IN_COURSE_EXPERIENCE_COMPLETION_STATE',
  /** The upsell banner/notification on the LEX / in course experience */
  InCourseExperienceUpsellNotification: 'IN_COURSE_EXPERIENCE_UPSELL_NOTIFICATION',
  /**
   * The stackability module that is underneath course cards in the LIHP My Learning Tab
   * 'In Progress' and 'Completed'
   */
  LihpMyLearningTab: 'LIHP_MY_LEARNING_TAB',
  /** A collection of Pathway Degrees on the LIHP */
  LihpPathwayDegreesCollection: 'LIHP_PATHWAY_DEGREES_COLLECTION',
  /** A collection of stackable pathway content on the LIHP */
  LihpStackablePathwayContentCollection: 'LIHP_STACKABLE_PATHWAY_CONTENT_COLLECTION'
} as const;

export type DegreePathwaysMerchandising_Slot = typeof DegreePathwaysMerchandising_Slot[keyof typeof DegreePathwaysMerchandising_Slot];
/** Slot Inputs. One for each slot on Coursera of which we merchandise Degree Pathways using PUMA */
export type DegreePathwaysMerchandising_SlotInput = {
  /** Get Degree Pathways Merchandising Modules for the Learner Experience Complete State Module. */
  inCourseExperienceCompletionState?: InputMaybe<DegreePathwaysMerchandising_InCourseExperienceCompletionStateInput>;
  /** Get Degree Pathways Merchandising Modules for the Learner Experience Upsell Banner. */
  inCourseExperienceUpsellNotification?: InputMaybe<DegreePathwaysMerchandising_InCourseExperienceUpsellNotificationInput>;
  /** Get Degree Pathways Merchandising Modules for LIHP My Learning Tab */
  loggedInHomePageMyLearningTab?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePageMyLearningTabInput>;
  /** Get Degree Pathways Merchandising Modules for the LIHP Pathway Degrees Collection Slot. */
  loggedInHomePagePathwayDegreesCollection?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePagePathwayDegreesCollectionInput>;
  /** Get Degree Pathways Merchandising Modules for the LIHP Stackable Content Collection Slot. */
  loggedInHomePageStackablePathwayContentCollection?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePageStackablePathwayContentCollectionInput>;
};

/** Upsell relation types */
export const DegreePathwaysMerchandising_UpsellType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type DegreePathwaysMerchandising_UpsellType = typeof DegreePathwaysMerchandising_UpsellType[keyof typeof DegreePathwaysMerchandising_UpsellType];
/** The rule the learner must complete to pass the grouping type */
export const DegreePlan_CompletionRuleType = {
  /** The learner must complete x of y credits in this segment */
  Credit: 'CREDIT',
  /** The enum value for the invalid completion rule types */
  Invalid: 'INVALID',
  /** The learner must complete x of y segments in this category */
  Segment: 'SEGMENT'
} as const;

export type DegreePlan_CompletionRuleType = typeof DegreePlan_CompletionRuleType[keyof typeof DegreePlan_CompletionRuleType];
/** The learner's admission type */
export const DegreePlan_LearnerAdmissionStatus = {
  /** The learner is enrolled in the degree directly */
  Degree: 'DEGREE',
  /**
   * FCND stands for "for credit non degree". The learner is not enrolled in the degree, and not in a
   * PBA course, but is taking "for credit non degree" courses
   */
  FcndNone: 'FCND_NONE',
  /** The learner is not enrolled in the degree, but is in a performance-based admission course */
  FcndPba: 'FCND_PBA',
  /** The learner is not enrolled in the degree, not in a PBA course, and is not taking FCND courses */
  NotEnrolled: 'NOT_ENROLLED',
  /** The learner is enrolled in the degree via performance-based admission */
  Pba: 'PBA'
} as const;

export type DegreePlan_LearnerAdmissionStatus = typeof DegreePlan_LearnerAdmissionStatus[keyof typeof DegreePlan_LearnerAdmissionStatus];
/** The learner state for a given segment course */
export const DegreePlan_LearnerProgressState = {
  /** The course is completed with a passing grade by the learner */
  Completed: 'COMPLETED',
  /** The course is in progress by the learner */
  InProgress: 'IN_PROGRESS',
  /** The course has not been started by the learner. Default option */
  NotStarted: 'NOT_STARTED',
  /** The course has been planned by the learner */
  Planned: 'PLANNED'
} as const;

export type DegreePlan_LearnerProgressState = typeof DegreePlan_LearnerProgressState[keyof typeof DegreePlan_LearnerProgressState];
/** The completion type of the prerequisite */
export const DegreePlan_PrerequisiteCompletionType = {
  /** All courses or descendant prerequisites must be satisfied */
  All: 'ALL',
  /** At least one course or descendant prerequisite must be satisfied */
  Any: 'ANY'
} as const;

export type DegreePlan_PrerequisiteCompletionType = typeof DegreePlan_PrerequisiteCompletionType[keyof typeof DegreePlan_PrerequisiteCompletionType];
/** Input values for degree webinar query */
export type DegreeWebinar_QueryDegreeWebinars = {
  /** A list of degree category ids. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of degree variants */
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Webinar status is one of PAST or UPCOMING */
  webinarStatus?: InputMaybe<Scalars['String']>;
};

/** Type of launch this degree was intended to launch as e.g. TEST or REAL */
export const Degree_InternalLaunchType = {
  /** A real launch intended to be publicly accessible by everyone */
  Real: 'REAL',
  /** Test launch only accessible to Courserians */
  Test: 'TEST'
} as const;

export type Degree_InternalLaunchType = typeof Degree_InternalLaunchType[keyof typeof Degree_InternalLaunchType];
/** Product variants of the degree program */
export const Degree_ProductVariant = {
  /** Variant for a Bachelor's degree */
  BachelorsDegree: 'BACHELORS_DEGREE',
  /** Variant for a Graduate Certificate */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Variant for a Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** Variant for a MasterTrack certificate */
  MasterTrack: 'MASTER_TRACK',
  /** Variant for an On-Campus Program */
  OnCampusProgram: 'ON_CAMPUS_PROGRAM',
  /** Variant for Postgraduate Diploma */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Variant for Professional Certificate Degree */
  ProfessionalCertificateDegree: 'PROFESSIONAL_CERTIFICATE_DEGREE',
  /** Variant for University Certificate */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Unknown or unimplemented variant */
  Unknown: 'UNKNOWN'
} as const;

export type Degree_ProductVariant = typeof Degree_ProductVariant[keyof typeof Degree_ProductVariant];
/** Type of launch this degree was intended to launch as e.g. TEST or REAL. */
export const DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType = typeof DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType[keyof typeof DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType];
export const DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType = {
  Free: 'FREE',
  Plus: 'PLUS',
  Standard: 'STANDARD'
} as const;

export type DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType = typeof DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType[keyof typeof DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType];
/** Delete course offering request */
export type DeleteCourseOfferingRequest = {
  /** The course offering ID that is to be deleted. */
  courseOfferingId: Scalars['ID'];
};

/** inputs required to generate a descript url */
export type Descript_CreateEditUrlInput = {
  /** name that will be used to populate project in Descript */
  name: Scalars['String'];
  /**
   * an ID that Descript uses to uniquely identify the video, populated with atom id + video asset id for now (this has been intentionally left for the FE to handle to make it easier to swap if needed)
   * This is also used to handle export requests from Descript to Coursera.
   */
  sourceId: Scalars['ID'];
  /** URI to file that will be used by Descript */
  uri: Scalars['URL'];
};

/** Certificate types */
export const DescriptionPage_CertificateType = {
  /** TODO: Complete this description */
  Specialization: 'SPECIALIZATION',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type DescriptionPage_CertificateType = typeof DescriptionPage_CertificateType[keyof typeof DescriptionPage_CertificateType];
/** Course status */
export const DescriptionPage_CourseStatus = {
  /** TODO: Complete this description */
  Draft: 'DRAFT',
  /** TODO: Complete this description */
  Inactive: 'INACTIVE',
  /** TODO: Complete this description */
  Launched: 'LAUNCHED',
  /** TODO: Complete this description */
  PreEnroll: 'PRE_ENROLL'
} as const;

export type DescriptionPage_CourseStatus = typeof DescriptionPage_CourseStatus[keyof typeof DescriptionPage_CourseStatus];
/** Course types */
export const DescriptionPage_CourseType = {
  /** TODO: Complete this description */
  Project: 'PROJECT',
  /** TODO: Complete this description */
  RhymeProject: 'RHYME_PROJECT',
  /** TODO: Complete this description */
  StandardCourse: 'STANDARD_COURSE'
} as const;

export type DescriptionPage_CourseType = typeof DescriptionPage_CourseType[keyof typeof DescriptionPage_CourseType];
/** Learning product difficulty levels */
export const DescriptionPage_DifficultyLevel = {
  /** TODO: Complete this description */
  Advanced: 'ADVANCED',
  /** TODO: Complete this description */
  Beginner: 'BEGINNER',
  /** TODO: Complete this description */
  Intermediate: 'INTERMEDIATE'
} as const;

export type DescriptionPage_DifficultyLevel = typeof DescriptionPage_DifficultyLevel[keyof typeof DescriptionPage_DifficultyLevel];
/** Qualification types for the industry certification/exam specified in the industryCertificationName field */
export const DescriptionPage_IndustryCertificationQualificationType = {
  /** Product is not qualified, but learners can earn hours towards the industry certification/exam specified in the industryCertificationName field */
  HoursTowards: 'HOURS_TOWARDS',
  /** Product is qualified for the industry certification/exam specified in the industryCertificationName field */
  Qualified: 'QUALIFIED'
} as const;

export type DescriptionPage_IndustryCertificationQualificationType = typeof DescriptionPage_IndustryCertificationQualificationType[keyof typeof DescriptionPage_IndustryCertificationQualificationType];
/** Learning product types including courses and s12ns */
export const DescriptionPage_LearningProductType = {
  /** Regular course */
  Course: 'COURSE',
  /** ProfessionalCertificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project */
  Project: 'PROJECT',
  /** Guided project */
  RhymeProject: 'RHYME_PROJECT',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type DescriptionPage_LearningProductType = typeof DescriptionPage_LearningProductType[keyof typeof DescriptionPage_LearningProductType];
/** Marketing Source */
export const DescriptionPage_MarketingSource = {
  /** Google */
  Google: 'GOOGLE',
  /** Paid Media, a.k.a Paid Ads */
  PaidMedia: 'PAID_MEDIA'
} as const;

export type DescriptionPage_MarketingSource = typeof DescriptionPage_MarketingSource[keyof typeof DescriptionPage_MarketingSource];
/** Premium Experience Variants */
export const DescriptionPage_PremiumExperienceVariant = {
  /** TODO: Complete this description */
  BaseVariant: 'BASE_VARIANT',
  /** TODO: Complete this description */
  PremiumCourse: 'PREMIUM_COURSE',
  /** TODO: Complete this description */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type DescriptionPage_PremiumExperienceVariant = typeof DescriptionPage_PremiumExperienceVariant[keyof typeof DescriptionPage_PremiumExperienceVariant];
/** Product variants */
export const DescriptionPage_ProductVariant = {
  /** TODO: Complete this description */
  BachelorsDegree: 'BACHELORS_DEGREE',
  /**
   * A specialization product that will be treated as a professional certificate, but will not add
   * "professional certificate" name to the title. Explanation:
   * https://coursera.slack.com/archives/C04PHNQAL/p1648067641940959?thread_ts=1648058204.861219&cid=C04PHNQAL
   */
  ExternalCertificate: 'EXTERNAL_CERTIFICATE',
  /** Professional certificate for Google */
  GoogleCertificate: 'GOOGLE_CERTIFICATE',
  /** TODO: Complete this description */
  MastersDegree: 'MASTERS_DEGREE',
  /** TODO: Complete this description */
  MasterTrack: 'MASTER_TRACK',
  /** TODO: Complete this description */
  OnCampusProgram: 'ON_CAMPUS_PROGRAM',
  /** TODO: Complete this description */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** TODO: Complete this description */
  StandardSpecialization: 'STANDARD_SPECIALIZATION'
} as const;

export type DescriptionPage_ProductVariant = typeof DescriptionPage_ProductVariant[keyof typeof DescriptionPage_ProductVariant];
/** Sub categories for professional certificates */
export const DescriptionPage_ProfessionalCertificateType = {
  /** Advanced (a.k.a non-gateway) certificate, e.g. google-it-automation */
  Advanced: 'ADVANCED',
  /** Gateway certificate, e.g. google-data-analytics */
  Gateway: 'GATEWAY'
} as const;

export type DescriptionPage_ProfessionalCertificateType = typeof DescriptionPage_ProfessionalCertificateType[keyof typeof DescriptionPage_ProfessionalCertificateType];
/** Input to get course page data. */
export type DescriptionPage_QueryCourseMarketingPageInput = {
  /** The marketing source of the request */
  marketingSource: DescriptionPage_MarketingSource;
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
};

/** Input to get course page data. */
export type DescriptionPage_QueryCoursePageInput = {
  /** Filter out non Coursera Plus recommendations. */
  filterNonCourseraPlusRecommendations?: Scalars['Boolean'];
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course. */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get org-scoped enterprise course page data. */
export type DescriptionPage_QueryEnterpriseCoursePageByOrgInput = {
  /** The slug for the organization the course belongs to. */
  organizationSlug: Scalars['String'];
  /** optionally we can pass a program slug to provide context */
  programSlug?: InputMaybe<Scalars['String']>;
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get enterprise course page data. */
export type DescriptionPage_QueryEnterpriseCoursePageInput = {
  /** The slug for the program the course belongs to. */
  programSlug: Scalars['String'];
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course. */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get org-scoped enterprise specialization page data. */
export type DescriptionPage_QueryEnterpriseSpecializationPageByOrgInput = {
  /** The slug for the organization the specialization belongs to. */
  organizationSlug: Scalars['String'];
  /** optionally we can pass a program slug to provide context */
  programSlug?: InputMaybe<Scalars['String']>;
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get enterprise specialization page data. */
export type DescriptionPage_QueryEnterpriseSpecializationPageInput = {
  /** The slug for the program the specialization belongs to. */
  programSlug: Scalars['String'];
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get specialization page data. */
export type DescriptionPage_QuerySpecializationMarketingPageInput = {
  /** The marketing source of the request */
  marketingSource: DescriptionPage_MarketingSource;
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get specialization page data. */
export type DescriptionPage_QuerySpecializationPageInput = {
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input for querying the Verified Skill Paths page */
export type DescriptionPage_QueryVerifiedSkillPathsPageInput = {
  /** List of course IDs to fetch Verified Skill Paths page data from */
  courseIds: Array<Scalars['ID']>;
};

/** Upsell types */
export const DescriptionPage_UpsellType = {
  /** TODO: Complete this description */
  OffersCredit: 'OFFERS_CREDIT',
  /** TODO: Complete this description */
  PartOf: 'PART_OF',
  /** TODO: Complete this description */
  RelatedTo: 'RELATED_TO'
} as const;

export type DescriptionPage_UpsellType = typeof DescriptionPage_UpsellType[keyof typeof DescriptionPage_UpsellType];
/** Course material types */
export const DescriptionPage_WeeklyMaterialItemType = {
  /** Previously called LTI items */
  AppItem: 'APP_ITEM',
  /** Staff graded or ungraded assignment items */
  Assignment: 'ASSIGNMENT',
  /** Graded and ungraded discussion prompt items */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Deprecated. Use QUIZ instead. */
  Exam: 'EXAM',
  /** Lecture items */
  Lecture: 'LECTURE',
  /** Phased, closed, graded, or ungraded peer review items */
  PeerReview: 'PEER_REVIEW',
  /** Graded or ungraded widget items */
  Plugin: 'PLUGIN',
  /** Graded or ungraded programming items */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quizzes and exams (graded quizzes) */
  Quiz: 'QUIZ',
  /** Supplement items, mostly reading materials */
  Supplement: 'SUPPLEMENT',
  /** Teammate review items */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab items */
  UngradedLab: 'UNGRADED_LAB',
  /** WiseFlow items */
  WiseFlow: 'WISE_FLOW'
} as const;

export type DescriptionPage_WeeklyMaterialItemType = typeof DescriptionPage_WeeklyMaterialItemType[keyof typeof DescriptionPage_WeeklyMaterialItemType];
/** Learning product difficulty levels */
export const DiscoveryCollections_DifficultyLevel = {
  /** Advanced level */
  Advanced: 'ADVANCED',
  /** Beginner level */
  Beginner: 'BEGINNER',
  /** Intermediate level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type DiscoveryCollections_DifficultyLevel = typeof DiscoveryCollections_DifficultyLevel[keyof typeof DiscoveryCollections_DifficultyLevel];
/**
 * A parameter that is directly passed through to a collection.
 * See this for more information on how to use pass through parameters: https://coursera.atlassian.net/wiki/spaces/UD/pages/175374364/Collections#Pass-Through-Parameters
 */
export type DiscoveryCollections_PassThroughParameter = {
  /** The name of a parameter used in a collection. */
  name: Scalars['String'];
  /** The value that will be injected/replaced */
  value: Scalars['String'];
};

/**
 * Compare this input to `DiscoveryCollections_queryCollectionsInput`:
 * * DiscoveryCollections_queryCollectionsInput: more like querying by ID, where contextType + contextId forms a composite
 * ID and the exact collection set keyed by the ID is returned.
 * * DiscoveryCollections_QueryByDisplayContextInput: the client provides where they want to display the collections and
 * the server will compute the optimal collection list to return.
 */
export type DiscoveryCollections_QueryByDisplayContextInput = {
  /**
   * Container on the page where the FE wants to display this collection list, e.g. "rc-CuratedCollections" or
   * "rc-BrowseCollections".
   * The default value is "page", which means that there is only one container on this page that displays collection sets,
   * and there is therefore no need to distinguish between different containers within the page.
   */
  container?: Scalars['String'];
  /** Page where the FE wants to display this collection list, e.g. "LIHP" (logged-in home page). */
  page: Scalars['String'];
};

/** Input to get a single skill-based collection within enterprise program context */
export type DiscoveryCollections_QueryEnterpriseCollectionBySkillIdInput = {
  /** The desired maximum number of entities per collection */
  maxNumberOfEntityIds?: InputMaybe<Scalars['Int']>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['ID'];
  /** SkillId specifies the id used to fetch skill-based recommendations */
  skillId: Scalars['ID'];
};

/**
 * Standard input for discovery collection query.
 * contextType and contextId are defined in the collections tool here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollections_QueryCollectionsInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
};

/** Input to get collections within enterprise context. ProgramId and organizationId can't be both null at the same time */
export type DiscoveryCollections_QueryEnterpriseCollectionsByOrganizationInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Pagination cursor. */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** Contains organizationId, representing the context of collections being fetched */
  organizationId: Scalars['String'];
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
};

/** Input to get collections within enterprise context. ProgramId and organizationId can't be both null at the same time */
export type DiscoveryCollections_QueryEnterpriseCollectionsByProgramInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Pagination cursor. */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['String'];
};

/** Input to get collections within enterprise+targetSkillProfile (TSP) context */
export type DiscoveryCollections_QueryEnterpriseCollectionsByTspInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Information to navigate response collections */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** The desired maximum number of entities per collection */
  maxNumberOfEntityIds?: InputMaybe<Scalars['Int']>;
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['String'];
  /** Contains tspId, representing the id for a targetSkillProfile we will be fetching products within collection for */
  targetSkillProfileId: Scalars['String'];
};

/** Information to navigate response collections */
export type DiscoveryCollections_RequestDataCursor = {
  /** Maximum number of returned collections */
  limit: Scalars['Int'];
  /** First 0-based collection index to return */
  start: Scalars['Int'];
};

/** Input parameters for adding email to whitelist. */
export type EmailWhitelist_AddToWhitelistInput = {
  /** The email address to add to the whitelist. */
  email: Scalars['String'];
};

/** Input parameters for removing email from whitelist. */
export type EmailWhitelist_RemoveFromWhitelistInput = {
  /** The email address to remove from the whitelist. */
  email: Scalars['String'];
};

/** Choice reason code to give meta informaton to the clients on the enrollment choices returned. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode = {
  BlockedOnIos: 'BLOCKED_ON_IOS',
  CapstoneAccessLocked: 'CAPSTONE_ACCESS_LOCKED',
  CatalogSubscribed: 'CATALOG_SUBSCRIBED',
  EarnedS12NCertificate: 'EARNED_S12N_CERTIFICATE',
  Enrolled: 'ENROLLED',
  EnrolledRestrictedAudit: 'ENROLLED_RESTRICTED_AUDIT',
  NoAvailableSession: 'NO_AVAILABLE_SESSION',
  PurchasedSingleCourse: 'PURCHASED_SINGLE_COURSE',
  ReachedMaxAllowance: 'REACHED_MAX_ALLOWANCE',
  RegionBlocked: 'REGION_BLOCKED',
  SpecializationBulkPaid: 'SPECIALIZATION_BULK_PAID',
  SpecializationEnrolledThroughCourseraPlus: 'SPECIALIZATION_ENROLLED_THROUGH_COURSERA_PLUS',
  SpecializationSubscribed: 'SPECIALIZATION_SUBSCRIBED',
  SpecializationUpgradeRequired: 'SPECIALIZATION_UPGRADE_REQUIRED'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode];
/** List of enrollment choices that are available to clients to show on the different enroll modals. TODO(CatalogSubscriptions Deprecation): There were 3 CatalogSubscription EnrollmentChoiceTypes that used to exist in this enum but have been deleted:  - SUBSCRIBE_TO_CATALOG  - SUBSCRIBE_TO_CATALOG_TRIAL  - UPGRADE_TO_CATALOG_SUBSCRIPTION  Leaving this comment here for context until we can finish deprecating the related client code.  See https://docs.google.com/document/d/1CDH0zUCI7BSpZwEfXMTd-MgqzB66F_IBSABuNSawOWI/edit# for additional context. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType = {
  AuditCourse: 'AUDIT_COURSE',
  BulkpayFullSpecialization: 'BULKPAY_FULL_SPECIALIZATION',
  BulkpayRemainingSpecializationCourses: 'BULKPAY_REMAINING_SPECIALIZATION_COURSES',
  EnrollCourse: 'ENROLL_COURSE',
  EnrollCourseWithFullDiscount: 'ENROLL_COURSE_WITH_FULL_DISCOUNT',
  EnrollThroughCourseraPlus: 'ENROLL_THROUGH_COURSERA_PLUS',
  EnrollThroughGroup: 'ENROLL_THROUGH_GROUP',
  EnrollThroughProgram: 'ENROLL_THROUGH_PROGRAM',
  EnrollThroughProgramInvitation: 'ENROLL_THROUGH_PROGRAM_INVITATION',
  EnrollThroughS12NPrepaid: 'ENROLL_THROUGH_S12N_PREPAID',
  EnrollThroughS12NSubscription: 'ENROLL_THROUGH_S12N_SUBSCRIPTION',
  EnrollThroughS12NSubscriptionTrial: 'ENROLL_THROUGH_S12N_SUBSCRIPTION_TRIAL',
  PurchaseCourseraTierLite: 'PURCHASE_COURSERA_TIER_LITE',
  PurchaseSingleCourse: 'PURCHASE_SINGLE_COURSE',
  SubscribeToCourseraPlus: 'SUBSCRIBE_TO_COURSERA_PLUS'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType];
/** The product type that enrollment choices api supports. Historically we used org.coursera.product.ProductType file. As that file being diverged to be used in payment related product such as subscription, facilatedLearning, it is time for enrollment choices api to has its own product type that it supports. for backward compatibility, we use camel case just as org.coursera.product.ProductType. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType = {
  Specialization: 'Specialization',
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType];
/** List of Coursera Subscription Tiers. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier = {
  CourseraPlus: 'COURSERA_PLUS',
  Lite: 'LITE'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier];
export const EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle = {
  Annual: 'ANNUAL',
  Biannual: 'BIANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle];
export const EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus];
/** Reasons to block enrollment */
export const EnrollmentChoiceReasonCode = {
  /** Blocked on iOS (i.e. if price is too high for in-app purchases). */
  BlockedOnIos: 'BLOCKED_ON_IOS',
  /** User is not eligible to enroll in the underlying product. */
  CapstoneAccessLocked: 'CAPSTONE_ACCESS_LOCKED',
  /** User has a catalog subscription. */
  CatalogSubscribed: 'CATALOG_SUBSCRIBED',
  /**
   * Use has s12n certificate when they finish a superset of a s12n.
   * FE will see this EnrollmentChoiceReasonCode and create an S12nMembership.
   */
  EarnedS12NCertificate: 'EARNED_S12N_CERTIFICATE',
  /** User is already enrolled in the underlying product. */
  Enrolled: 'ENROLLED',
  /** User is not eligible to pre-enroll in an s12n which is currently pre-enrolling */
  NotEligibleToPreEnroll: 'NOT_ELIGIBLE_TO_PRE_ENROLL',
  /** Currently no session avaialbe for a course, meaning a leaner can not enroll. */
  NoAvailableSession: 'NO_AVAILABLE_SESSION',
  /** User is already pre-enrolled in the given specialization */
  PreEnrolled: 'PRE_ENROLLED',
  /** User has purchased this course. */
  PurchasedSingleCourse: 'PURCHASED_SINGLE_COURSE',
  /** Currently no session avaialbe for a course, meaning a leaner can not enroll. */
  ReachedMaxAllowance: 'REACHED_MAX_ALLOWANCE',
  /** Blocked by Sanction. */
  RegionBlocked: 'REGION_BLOCKED',
  /** User already bulk paid for the underlying specialization. */
  SpecializationBulkPaid: 'SPECIALIZATION_BULK_PAID',
  /**
   * User enrolled in the underlying specialization through Coursera Plus
   * Used for computing choices for courses in a specialization
   */
  SpecializationEnrolledThroughCourseraPlus: 'SPECIALIZATION_ENROLLED_THROUGH_COURSERA_PLUS',
  /** User already subscribed the underlying specialization. */
  SpecializationSubscribed: 'SPECIALIZATION_SUBSCRIBED',
  /** User cannot enroll into an old version of this s12n. */
  SpecializationUpgradeRequired: 'SPECIALIZATION_UPGRADE_REQUIRED'
} as const;

export type EnrollmentChoiceReasonCode = typeof EnrollmentChoiceReasonCode[keyof typeof EnrollmentChoiceReasonCode];
/** BillingCycles supported by existing subscriptions. */
export const EnrollmentChoice_BillingCycle = {
  /** Billed annually */
  Annual: 'ANNUAL',
  /** Billed Bi-anually */
  Biannual: 'BIANNUAL',
  /** Billed Monthly */
  Monthly: 'MONTHLY'
} as const;

export type EnrollmentChoice_BillingCycle = typeof EnrollmentChoice_BillingCycle[keyof typeof EnrollmentChoice_BillingCycle];
/** List of enrollment choices that are available to clients to show on the different enroll modals. */
export const EnrollmentChoice_EnrollmentChoiceType = {
  /** Enrollment choice when the user is just going to audit the course */
  AuditCourse: 'AUDIT_COURSE',
  /** Enrollment choice when a user can purchase the full specialization */
  BulkpayFullSpecialization: 'BULKPAY_FULL_SPECIALIZATION',
  /** Enrollment choice when a user can purchase the remaining part of the specialization */
  BulkpayRemainingSpecializationCourses: 'BULKPAY_REMAINING_SPECIALIZATION_COURSES',
  /** Enrollment choice to be enrolled in the course for free */
  EnrollCourse: 'ENROLL_COURSE',
  /** Enrollment choice to be enrolled with a full (100%) discount */
  EnrollCourseWithFullDiscount: 'ENROLL_COURSE_WITH_FULL_DISCOUNT',
  /** The user is allowed to enroll in this content through CourseraPlus. */
  EnrollThroughCourseraPlus: 'ENROLL_THROUGH_COURSERA_PLUS',
  /** The user is part of a group that gives them access to the course/s12n */
  EnrollThroughGroup: 'ENROLL_THROUGH_GROUP',
  /** The user is part of a program that gives them access to the course/s12n */
  EnrollThroughProgram: 'ENROLL_THROUGH_PROGRAM',
  /** The user has a program invitation that gives them access to the course/s12n */
  EnrollThroughProgramInvitation: 'ENROLL_THROUGH_PROGRAM_INVITATION',
  /** The user is allowed to enroll to the s12n through prepaid payment options */
  EnrollThroughS12NPrepaid: 'ENROLL_THROUGH_S12N_PREPAID',
  /** The user is allowed to enroll to the s12n through subscription */
  EnrollThroughS12NSubscription: 'ENROLL_THROUGH_S12N_SUBSCRIPTION',
  /** The user is allowed to enroll to the s12n through subscription for a trial duration */
  EnrollThroughS12NSubscriptionTrial: 'ENROLL_THROUGH_S12N_SUBSCRIPTION_TRIAL',
  /** The user is eligible to pre-enroll into the course/s12n */
  PreEnrollmentEligible: 'PRE_ENROLLMENT_ELIGIBLE',
  /** The user is allowed to enroll in this content through Coursera Tier Lite */
  PurchaseCourseraTierLite: 'PURCHASE_COURSERA_TIER_LITE',
  /** Enrollment choice for a user to purchase just that one course */
  PurchaseSingleCourse: 'PURCHASE_SINGLE_COURSE',
  /** The user is able to subscribe to CourseraPlus. */
  SubscribeToCourseraPlus: 'SUBSCRIBE_TO_COURSERA_PLUS'
} as const;

export type EnrollmentChoice_EnrollmentChoiceType = typeof EnrollmentChoice_EnrollmentChoiceType[keyof typeof EnrollmentChoice_EnrollmentChoiceType];
/** Product types supported by payment system. */
export const EnrollmentChoice_ProductType = {
  /** Site wide subscription */
  CatalogSubscription: 'CatalogSubscription',
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'CourseraPlus',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'CourseraPlusSubscription',
  /** TODO: Complete this description */
  CredentialTrackCourse: 'CredentialTrackCourse',
  /**
   * A new version of CredentialTrackCourse that has different revenue recognition and ownership
   * granting logic from the original version. Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  CredentialTrackCourseV2: 'CredentialTrackCourseV2',
  /** TODO: Complete this description */
  CredentialTrackSubscription: 'CredentialTrackSubscription',
  /**
   * A new version of CredentialTrackSubscription that has different revenue recognition and
   * ownership granting logic from the original version. Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  CredentialTrackSubscriptionV2: 'CredentialTrackSubscriptionV2',
  /** TODO: Complete this description */
  EnterpriseContract: 'EnterpriseContract',
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type EnrollmentChoice_ProductType = typeof EnrollmentChoice_ProductType[keyof typeof EnrollmentChoice_ProductType];
/** List of Coursera Subscription Tiers. */
export const EnrollmentChoice_Tier = {
  /** Tier for Coursera Plus. */
  CourseraPlus: 'COURSERA_PLUS',
  /** Tier for Coursera Tier Lite. */
  Lite: 'LITE'
} as const;

export type EnrollmentChoice_Tier = typeof EnrollmentChoice_Tier[keyof typeof EnrollmentChoice_Tier];
/** Type of curriculum item. */
export const EntCurriculum_CurriculumItemType = {
  /** A standard Coursera course. */
  Course: 'COURSE',
  /** A private/custom course. */
  PrivateCourse: 'PRIVATE_COURSE',
  /** A specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type EntCurriculum_CurriculumItemType = typeof EntCurriculum_CurriculumItemType[keyof typeof EntCurriculum_CurriculumItemType];
/** Derived enrollment state for a user/product within an organization. */
export const EntCurriculum_OrgProductEnrollmentState = {
  /**
   * The user was previously enrolled via a program in the organization but has since lost
   * program-level access (e.g. program membership ended). The user retains audit-only
   * access to the product.
   */
  Auditing: 'AUDITING',
  /** The user is actively enrolled in the product via a program in the organization. */
  Enrolled: 'ENROLLED',
  /** The user has been selected for (but not yet enrolled in) the product via a program. */
  Selected: 'SELECTED'
} as const;

export type EntCurriculum_OrgProductEnrollmentState = typeof EntCurriculum_OrgProductEnrollmentState[keyof typeof EntCurriculum_OrgProductEnrollmentState];
/**
 * Input for EntCurriculum_UpdateProgramCurriculum. Mirrors the Naptime
 * update endpoint parameters; the curriculum body matches the Pegasus
 * typedDefinition shape of org.coursera.program.curriculum.Curriculum.
 */
export type EntCurriculum_UpdateProgramCurriculumInput = {
  /**
   * If true, allow the update to remove badge templates from existing
   * tracks. Default false — prevents accidental badge loss.
   */
  allowBadgeDeletion?: InputMaybe<Scalars['Boolean']>;
  /**
   * If true, allow the update to clear clip references from existing
   * course items. Default false.
   */
  allowClearingClips?: InputMaybe<Scalars['Boolean']>;
  /**
   * Curriculum payload in Pegasus typedDefinition format — exactly one of
   * { "tracksCurriculum": {...} } or { "wildcardCurriculum": {...} }.
   * Schema matches org.coursera.program.curriculum.Curriculum.courier
   * in infra-services.
   */
  curriculum: Scalars['JSON'];
  /** Curriculum ID being updated (StringKey form). */
  curriculumId: Scalars['ID'];
  /**
   * Program ID that owns this curriculum. Required for authorization
   * (per-program edit permission) and verified server-side against the
   * curriculum's actual owner.
   */
  programId: Scalars['ID'];
  /**
   * If true, items the requester is not authorized to use are silently
   * dropped during validation instead of failing the update. Default false.
   */
  skipUnauthorizedProducts?: InputMaybe<Scalars['Boolean']>;
  /**
   * Free-form tag for audit logs identifying what surface drove this
   * update.
   */
  updateSource?: InputMaybe<Scalars['String']>;
};

/** Input for adding or updating a payment method as backup for an enterprise contract. */
export type EntTransaction_AddOrUpdateNewPaymentMethodInput = {
  /** The enterprise contract ID to add or update the backup payment method for. */
  contractId: Scalars['ID'];
  /** The existing payment method ID to be removed from backup payment methods. */
  existingPaymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The payment method request to add as a backup payment method. */
  updatePaymentMethodRequest: EntTransaction_AddPaymentMethodRequestInput;
};

/** Input for adding a payment method. */
export type EntTransaction_AddPaymentMethodRequestInput = {
  /** The billing country of the payment method, ISO 3166-1 alpha-2 code. */
  billingCountry?: InputMaybe<Scalars['String']>;
  /** The billing zip code of the payment method. */
  billingZipCode?: InputMaybe<Scalars['String']>;
  /** The nonce of the payment method. */
  nonce: Scalars['String'];
  /** The payment processor ID of the payment method. */
  paymentProcessorId: EntTransaction_PaymentProcessorType;
};

/** Input for automated invoice order properties. */
export type EntTransaction_AutomatedInvoiceOrderPropertiesInput = {
  /** Admin title. */
  adminTitle: Scalars['String'];
  /** Creator user ID. */
  creatorUserId: Scalars['ID'];
  /** Existing organization ID. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** Purchase order number. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Sales owner information. */
  salesOwner?: InputMaybe<EntTransaction_SalesOwnerInput>;
  /** Tax ID data. */
  taxIdData?: InputMaybe<EntTransaction_TaxIdDataInput>;
};

/** Enumeration for billing system types. */
export const EntTransaction_BillingSystemType = {
  /** Automated invoice handled by Enterprise Invoicing service. */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Automated transaction payment. */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Non-billable contract (usually for testing). */
  NonBillable: 'NON_BILLABLE',
  /** Off-platform invoice handled by internal finance team. */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EntTransaction_BillingSystemType = typeof EntTransaction_BillingSystemType[keyof typeof EntTransaction_BillingSystemType];
/** Enumeration for billing types. */
export const EntTransaction_BillingType = {
  /** Invoice-based billing. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time payment. */
  OneTime: 'ONE_TIME',
  /** Quarterly payments. */
  Quarterly: 'QUARTERLY'
} as const;

export type EntTransaction_BillingType = typeof EntTransaction_BillingType[keyof typeof EntTransaction_BillingType];
/** Input for creating an enterprise contract purchase order */
export type EntTransaction_CreateEnterpriseContractPurchaseOrderInput = {
  /** Information required to submit an automated invoice order. */
  automatedInvoiceOrderProperties?: InputMaybe<EntTransaction_AutomatedInvoiceOrderPropertiesInput>;
  /** Currency to bill in. */
  billingCurrency: Scalars['String'];
  /** Specify ONE_TIME for annual payments and QUARTERLY for quarterly-paid installments. */
  billingScheduleType: EntTransaction_BillingType;
  /** Specify AUTOMATED_TRANSACTION_PAYMENT or AUTOMATED_INVOICE. */
  billingSystemType: EntTransaction_BillingSystemType;
  /** Billing contact email address. */
  contactEmail: Scalars['String'];
  /** Billing contact name. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Country ISO code for billing. */
  countryIsoCode: Scalars['String'];
  /** Information required to create a PaymentWallet with Coursera's payment service. Required if billingSystemType = AUTOMATED_TRANSACTION_PAYMENT. */
  createPaymentWalletRequest?: InputMaybe<EntTransaction_CreatePaymentWalletRequestInput>;
  /** If provided, will create new contract on existing organization. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** Number of licenses being ordered. */
  numberOfLicenses: Scalars['Int'];
  /** Any offers to create the contract order with. Supports free-trial and discretionaryDiscount~<id>. */
  offerCode?: InputMaybe<Scalars['String']>;
  /** Enterprise organization address. */
  organizationAddress?: InputMaybe<EntTransaction_ThirdPartyOrganizationAddressInput>;
  /** Enterprise organization size range. */
  organizationEmployeeRange?: InputMaybe<Scalars['String']>;
  /** Enterprise organization name. */
  organizationName: Scalars['String'];
  /** Enterprise organization type. */
  organizationType?: InputMaybe<Scalars['String']>;
  /** Coursera account user ID of the purchaser. */
  purchaserUserId: Scalars['ID'];
  /** Specify for testing purposes, else None. */
  testingOptions?: InputMaybe<EntTransaction_TestingOptionsInput>;
};

/** Input for creating a non-billable free trial. */
export type EntTransaction_CreateNonBillableFreeTrialInput = {
  /** Company/Organization name. */
  companyName: Scalars['String'];
  /** ISO 3166-1 alpha-2 country code (e.g., "US", "IN"). */
  countryIsoCode: Scalars['String'];
  /** Organization size. */
  orgSize?: InputMaybe<EntTransaction_OrgSize>;
  /** Organization type. */
  organizationType?: InputMaybe<EntTransaction_OrgType>;
  /** Whether user is interested in research interviews. */
  researchOptIn?: Scalars['Boolean'];
  /** Full name of the user. */
  userName: Scalars['String'];
  /** Work email address. */
  workEmail: Scalars['String'];
};

/** Input for creating a payment wallet request. */
export type EntTransaction_CreatePaymentWalletRequestInput = {
  /** Billing country ISO code. */
  billingCountry: Scalars['String'];
  /** Billing zip code (optional). */
  billingZipcode?: InputMaybe<Scalars['String']>;
  /** Cart ID (optional). */
  cartId?: InputMaybe<Scalars['ID']>;
  /** Payment method nonce/token from payment processor. */
  nonce: Scalars['String'];
  /** Payment processor ID (optional). */
  paymentProcessorId?: InputMaybe<Scalars['ID']>;
  /** Recaptcha token for verification (optional). */
  recaptchaToken?: InputMaybe<Scalars['String']>;
  /** User ID for the payment wallet. */
  userId: Scalars['ID'];
};

/** Credit card brand/types. */
export const EntTransaction_CreditCardType = {
  /** American Express. */
  Amex: 'AMEX',
  /** Cartes Bancaires (French). */
  CartesBancaires: 'CARTES_BANCAIRES',
  /** Diners Club. */
  Diners: 'DINERS',
  /** Discover. */
  Discover: 'DISCOVER',
  /** EFTPOS Australia. */
  EftposAu: 'EFTPOS_AU',
  /** Interac (Canadian debit). */
  Interac: 'INTERAC',
  /** JCB (Japan Credit Bureau). */
  Jcb: 'JCB',
  /** Link */
  Link: 'LINK',
  /** Mastercard. */
  Mastercard: 'MASTERCARD',
  /** UnionPay. */
  Unionpay: 'UNIONPAY',
  /** Other card brand. */
  Unknown: 'UNKNOWN',
  /** Visa. */
  Visa: 'VISA'
} as const;

export type EntTransaction_CreditCardType = typeof EntTransaction_CreditCardType[keyof typeof EntTransaction_CreditCardType];
/** Input for deleting a backup payment method from an enterprise contract. */
export type EntTransaction_DeleteBackupPaymentMethodInput = {
  /** The enterprise contract ID to delete the backup payment method from. */
  contractId: Scalars['ID'];
  /** The payment method ID to delete from backup payment methods. */
  paymentMethodId: Scalars['ID'];
};

/** Enumeration for enterprise contract billing system types. */
export const EntTransaction_EnterpriseContractBillingSystemType = {
  /** Automated invoice. */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Automated transaction payment. */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Non-billable contract. */
  NonBillable: 'NON_BILLABLE',
  /** Off-platform invoice. */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EntTransaction_EnterpriseContractBillingSystemType = typeof EntTransaction_EnterpriseContractBillingSystemType[keyof typeof EntTransaction_EnterpriseContractBillingSystemType];
/** Enumeration for enterprise contract billing types. */
export const EntTransaction_EnterpriseContractBillingType = {
  /** Invoice-based billing. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time billing. */
  OneTime: 'ONE_TIME',
  /** Quarterly billing. */
  Quarterly: 'QUARTERLY'
} as const;

export type EntTransaction_EnterpriseContractBillingType = typeof EntTransaction_EnterpriseContractBillingType[keyof typeof EntTransaction_EnterpriseContractBillingType];
/** Enumeration for enterprise contract limit types. */
export const EntTransaction_EnterpriseContractLimitType = {
  /** Enrollment cap limit. */
  EnrollmentCap: 'ENROLLMENT_CAP',
  /** No limit specified. */
  NoLimit: 'NO_LIMIT',
  /** User license limit. */
  UserLicense: 'USER_LICENSE',
  /** User license with enrollment cap. */
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EntTransaction_EnterpriseContractLimitType = typeof EntTransaction_EnterpriseContractLimitType[keyof typeof EntTransaction_EnterpriseContractLimitType];
/** Enumeration for enterprise contract payment types. */
export const EntTransaction_EnterpriseContractPaymentType = {
  /** Installment payment. */
  Installment: 'INSTALLMENT',
  /** Upgrade payment. */
  Upgrade: 'UPGRADE'
} as const;

export type EntTransaction_EnterpriseContractPaymentType = typeof EntTransaction_EnterpriseContractPaymentType[keyof typeof EntTransaction_EnterpriseContractPaymentType];
/** Enumeration for enterprise contract price mapping names. */
export const EntTransaction_EnterpriseContractPriceMappingName = {
  /** One course value increase mappings. */
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  /** Original release mappings. */
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EntTransaction_EnterpriseContractPriceMappingName = typeof EntTransaction_EnterpriseContractPriceMappingName[keyof typeof EntTransaction_EnterpriseContractPriceMappingName];
/** Enumeration for enterprise contract states. */
export const EntTransaction_EnterpriseContractState = {
  /** Contract is active. */
  Active: 'ACTIVE',
  /** Contract is created. */
  Created: 'CREATED',
  /** Contract is expired. */
  Expired: 'EXPIRED',
  /** Contract is paused. */
  Paused: 'PAUSED',
  /** Contract is terminated. */
  Terminated: 'TERMINATED'
} as const;

export type EntTransaction_EnterpriseContractState = typeof EntTransaction_EnterpriseContractState[keyof typeof EntTransaction_EnterpriseContractState];
/** Enumeration for enterprise contract term tags. */
export const EntTransaction_EnterpriseContractTermTag = {
  /** Free trial allowing access to Coursera for Teams. */
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EntTransaction_EnterpriseContractTermTag = typeof EntTransaction_EnterpriseContractTermTag[keyof typeof EntTransaction_EnterpriseContractTermTag];
/** Enumeration for enterprise contract terminated reasons. */
export const EntTransaction_EnterpriseContractTerminatedReason = {
  /** Contract ended due to end date. */
  ContractEndDate: 'CONTRACT_END_DATE',
  /** Contract was downgraded. */
  Downgraded: 'DOWNGRADED',
  /** Free trial conversion failed. */
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  /** Free trial expired. */
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  /** Initial invoice was voided. */
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  /** Initial payment failed. */
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  /** Contract was migrated. */
  Migrated: 'MIGRATED',
  /** Missing payment. */
  MissingPayment: 'MISSING_PAYMENT',
  /** Contract was refunded. */
  Refunded: 'REFUNDED',
  /** Renewal grace period exceeded. */
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EntTransaction_EnterpriseContractTerminatedReason = typeof EntTransaction_EnterpriseContractTerminatedReason[keyof typeof EntTransaction_EnterpriseContractTerminatedReason];
/** Enumeration for enterprise contract types. */
export const EntTransaction_EnterpriseContractType = {
  /** Self-serve enterprise contract. */
  SelfServe: 'SELF_SERVE',
  /** Standard enterprise contract. */
  Standard: 'STANDARD'
} as const;

export type EntTransaction_EnterpriseContractType = typeof EntTransaction_EnterpriseContractType[keyof typeof EntTransaction_EnterpriseContractType];
/** Input for finalizing an order. */
export type EntTransaction_FinalizeOrderInput = {
  /** The contract ID to associate with the order. */
  contractId: Scalars['ID'];
  /** The order ID to finalize. */
  orderId: Scalars['ID'];
};

/** Reasons why a user might not be eligible for a free trial. */
export const EntTransaction_FreeTrialEligibilityFailureReason = {
  /** Email domain has reached the limit of free trials (3 per domain). */
  DomainTrialLimitExceeded: 'DOMAIN_TRIAL_LIMIT_EXCEEDED',
  /** User is already associated with an existing organization. */
  ExistingOrgAssociation: 'EXISTING_ORG_ASSOCIATION',
  /** Email address is not a valid business email. */
  InvalidBusinessEmail: 'INVALID_BUSINESS_EMAIL',
  /** User has already used a free trial previously. */
  PreviousFreeTrialUsed: 'PREVIOUS_FREE_TRIAL_USED',
  /** User's country is sanctioned and not allowed for free trials. */
  SanctionedCountry: 'SANCTIONED_COUNTRY',
  /** User already has a free trial request in progress. */
  TrialInProgress: 'TRIAL_IN_PROGRESS'
} as const;

export type EntTransaction_FreeTrialEligibilityFailureReason = typeof EntTransaction_FreeTrialEligibilityFailureReason[keyof typeof EntTransaction_FreeTrialEligibilityFailureReason];
/** Input for making a payment method the primary payment method for an enterprise contract. */
export type EntTransaction_MakeMethodPrimaryInput = {
  /** The enterprise contract ID to update the primary payment method for. */
  contractId: Scalars['ID'];
  /** The payment method ID to set as the primary payment method. */
  paymentMethodId: Scalars['ID'];
};

/** Enumeration for next scheduled payment types. */
export const EntTransaction_NextScheduledPaymentType = {
  /** Installment payment. */
  InstallmentPayment: 'INSTALLMENT_PAYMENT',
  /** Renewal payment. */
  RenewalPayment: 'RENEWAL_PAYMENT'
} as const;

export type EntTransaction_NextScheduledPaymentType = typeof EntTransaction_NextScheduledPaymentType[keyof typeof EntTransaction_NextScheduledPaymentType];
/** Enumeration for order states. */
export const EntTransaction_OrderState = {
  /** Order is aborted. */
  Aborted: 'ABORTED',
  /** Order is completed. */
  Completed: 'COMPLETED',
  /** Order is open. */
  Open: 'OPEN'
} as const;

export type EntTransaction_OrderState = typeof EntTransaction_OrderState[keyof typeof EntTransaction_OrderState];
/** Organization size options. */
export const EntTransaction_OrgSize = {
  /** 1 to 500 employees. */
  Size_1_500: 'SIZE_1_500',
  /** 501 to 1000 employees. */
  Size_501_1000: 'SIZE_501_1000',
  /** 1001 to 5000 employees. */
  Size_1001_5000: 'SIZE_1001_5000',
  /** 5001 to 15000 employees. */
  Size_5001_15000: 'SIZE_5001_15000',
  /** More than 15000 employees. */
  SizeMoreThan_15000: 'SIZE_MORE_THAN_15000'
} as const;

export type EntTransaction_OrgSize = typeof EntTransaction_OrgSize[keyof typeof EntTransaction_OrgSize];
/** Organization type options. */
export const EntTransaction_OrgType = {
  /** Business organization. */
  Business: 'BUSINESS',
  /** Campus/Educational institution. */
  Campus: 'CAMPUS',
  /** Government organization. */
  Government: 'GOVERNMENT'
} as const;

export type EntTransaction_OrgType = typeof EntTransaction_OrgType[keyof typeof EntTransaction_OrgType];
/** Payment processor types supported for enterprise transactions. */
export const EntTransaction_PaymentProcessorType = {
  /** Apple In-App Purchase Production. */
  AppleInapp: 'APPLE_INAPP',
  /** Apple In-App Purchase Sandbox. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree Production. */
  Braintree: 'BRAINTREE',
  /** Braintree Sandbox. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Internal payment processor for manual refunds. */
  CourseraManual: 'COURSERA_MANUAL',
  /** dLocal Production. */
  Dlocal: 'DLOCAL',
  /** dLocal Sandbox. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx Production. Deprecated. */
  Ebanx: 'EBANX',
  /** Ebanx Sandbox. Deprecated. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent Production. Deprecated. */
  Emergent: 'EMERGENT',
  /** Emergent Sandbox. Deprecated. */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid by Coursera. Deprecated. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play Billing Production. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Google Play Billing Sandbox. */
  GooglePlaySandbox: 'GOOGLE_PLAY_SANDBOX',
  /** Mock payment processor for testing. */
  Mock: 'MOCK',
  /** Paypal Production. */
  Paypal: 'PAYPAL',
  /** Paypal Sandbox. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay Production. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will Production. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will Sandbox. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay Sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe Enterprise Production (WES account). */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer Production (BV account). */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer Sandbox (BV account). */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer Production (US account). */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer Sandbox (US account). */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe Enterprise Sandbox (WES account). */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** Stripe Third Party Production (for subscriptions on third party processors). */
  StripeThirdParty: 'STRIPE_THIRD_PARTY',
  /** Stripe Third Party Sandbox (for subscriptions on third party processors). */
  StripeThirdPartySandbox: 'STRIPE_THIRD_PARTY_SANDBOX',
  /** ID used for checkouts with no charge. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type EntTransaction_PaymentProcessorType = typeof EntTransaction_PaymentProcessorType[keyof typeof EntTransaction_PaymentProcessorType];
/** Enumeration for purchase order states. */
export const EntTransaction_PurchaseOrderState = {
  /** Order is created. */
  Created: 'CREATED',
  /** Order is fulfilled. */
  Fulfilled: 'FULFILLED',
  /** Order is submitted. */
  Submitted: 'SUBMITTED'
} as const;

export type EntTransaction_PurchaseOrderState = typeof EntTransaction_PurchaseOrderState[keyof typeof EntTransaction_PurchaseOrderState];
/** Input for sales owner information. */
export type EntTransaction_SalesOwnerInput = {
  /** Sales owner name. */
  name: Scalars['String'];
  /** Sales owner user ID (internal). */
  userId: Scalars['ID'];
};

/** Input for tax ID data. */
export type EntTransaction_TaxIdDataInput = {
  /** Tax ID value. */
  taxId: Scalars['ID'];
  /** Tax ID type. */
  taxIdType: Scalars['String'];
};

/** Input for terminating a free trial. */
export type EntTransaction_TerminateFreeTrialInput = {
  /** The enterprise contract ID associated with the free trial to terminate. */
  enterpriseContractId: Scalars['ID'];
};

/** Input for testing options. */
export type EntTransaction_TestingOptionsInput = {
  /** Whether to create a fake organization. */
  createFakeOrg?: InputMaybe<Scalars['Boolean']>;
  /** Whether to use sandbox payments. */
  sandbox?: InputMaybe<Scalars['Boolean']>;
  /** Test lambda alias. */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix. */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
};

/** Input for third-party organization address. */
export type EntTransaction_ThirdPartyOrganizationAddressInput = {
  /** City. */
  city: Scalars['String'];
  /** Country ISO code. */
  countryIsoCode: Scalars['String'];
  /** Address line 1. */
  line1: Scalars['String'];
  /** Address line 2 (optional). */
  line2?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State or province. */
  state: Scalars['String'];
};

/** Enumeration for unit price discountType */
export const EntTransaction_UnitPriceDiscountType = {
  /** VOLUME_DISCOUNT */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EntTransaction_UnitPriceDiscountType = typeof EntTransaction_UnitPriceDiscountType[keyof typeof EntTransaction_UnitPriceDiscountType];
/** Input for updating contract and term ID. */
export type EntTransaction_UpdateContractAndTermIdInput = {
  /** The contract ID to associate. */
  contractId: Scalars['ID'];
  /** The order ID to update. */
  orderId: Scalars['ID'];
  /** The term ID to associate. */
  termId?: InputMaybe<Scalars['ID']>;
};

/** Input for updating order state. */
export type EntTransaction_UpdateOrderStateInput = {
  /** The new state for the order. */
  newState: EntTransaction_OrderState;
  /** The order ID to update. */
  orderId: Scalars['ID'];
};

/**
 * Input for validating free trial eligibility.
 * Only requires minimal information needed for validation checks.
 */
export type EntTransaction_ValidateFreeTrialEligibilityInput = {
  /** ISO 3166-1 alpha-2 country code (e.g., "US", "IN"). */
  countryIsoCode: Scalars['String'];
  /** Email address to validate. */
  email: Scalars['String'];
};

/** Type of the action taken by the admin */
export const EnterpriseAdminHomePage_ActionTakenType = {
  /** Assign content to learners */
  AssignContent: 'ASSIGN_CONTENT',
  /** Encourage ongoing learning */
  EncourageOngoingLearning: 'ENCOURAGE_ONGOING_LEARNING',
  /** Invite learners to the program */
  InviteLearners: 'INVITE_LEARNERS',
  /** Message enrolled learners */
  MessageEnrolledLearners: 'MESSAGE_ENROLLED_LEARNERS',
  /** Message inactive learners */
  MessageInactiveLearners: 'MESSAGE_INACTIVE_LEARNERS',
  /** Promote popular course */
  PromotePopularCourse: 'PROMOTE_POPULAR_COURSE',
  /** Reinforce learning for career growth */
  ReinforceLearningForCareerGrowth: 'REINFORCE_LEARNING_FOR_CAREER_GROWTH',
  /** Reminder to complete course */
  ReminderToCompleteCourse: 'REMINDER_TO_COMPLETE_COURSE',
  /** Remind benefits of upskilling */
  RemindBenefitsOfUpskilling: 'REMIND_BENEFITS_OF_UPSKILLING',
  /** Remind to join the program */
  RemindToJoin: 'REMIND_TO_JOIN',
  /** Send accolades */
  SendAccolades: 'SEND_ACCOLADES'
} as const;

export type EnterpriseAdminHomePage_ActionTakenType = typeof EnterpriseAdminHomePage_ActionTakenType[keyof typeof EnterpriseAdminHomePage_ActionTakenType];
/** Input type for marking a recommended action as completed */
export type EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedInput = {
  /** Type of action taken by the admin */
  actionTakenType: EnterpriseAdminHomePage_ActionTakenType;
  /** Enterprise organization ID */
  enterpriseOrganizationId: Scalars['ID'];
  /** Product ID related to the recommended action (if exists) */
  productId?: InputMaybe<Scalars['ID']>;
};

/** Page context for which recommended actions are requested */
export const EnterpriseAdminHomePage_PageContext = {
  /** Messaging page */
  Messaging: 'MESSAGING'
} as const;

export type EnterpriseAdminHomePage_PageContext = typeof EnterpriseAdminHomePage_PageContext[keyof typeof EnterpriseAdminHomePage_PageContext];
/** Status of the recommended action */
export const EnterpriseAdminHomePage_RecommendedActionStatus = {
  /** Completed status */
  Completed: 'COMPLETED',
  /** Pending status */
  Pending: 'PENDING'
} as const;

export type EnterpriseAdminHomePage_RecommendedActionStatus = typeof EnterpriseAdminHomePage_RecommendedActionStatus[keyof typeof EnterpriseAdminHomePage_RecommendedActionStatus];
/** Type of the recommended action */
export const EnterpriseAdminHomePage_RecommendedActionType = {
  /** Assign content high engagement */
  AssignContentHighEngagement: 'ASSIGN_CONTENT_HIGH_ENGAGEMENT',
  /** Assign content least growth skill */
  AssignContentLeastGrowthSkill: 'ASSIGN_CONTENT_LEAST_GROWTH_SKILL',
  /** Assign content low engagement */
  AssignContentLowEngagement: 'ASSIGN_CONTENT_LOW_ENGAGEMENT',
  /** Encourage ongoing learning */
  EncourageOngoingLearning: 'ENCOURAGE_ONGOING_LEARNING',
  /** Invite learners enrollment based */
  InviteLearnersEnrollmentBased: 'INVITE_LEARNERS_ENROLLMENT_BASED',
  /** Invite learners license based */
  InviteLearnersLicenseBased: 'INVITE_LEARNERS_LICENSE_BASED',
  /** Message enrolled learners */
  MessageEnrolledLearners: 'MESSAGE_ENROLLED_LEARNERS',
  /** Message inactive learners */
  MessageInactiveLearners: 'MESSAGE_INACTIVE_LEARNERS',
  /** Promote popular course */
  PromotePopularCourse: 'PROMOTE_POPULAR_COURSE',
  /** Reinforce learning for career growth */
  ReinforceLearningForCareerGrowth: 'REINFORCE_LEARNING_FOR_CAREER_GROWTH',
  /** Reminder to complete course */
  ReminderToCompleteCourse: 'REMINDER_TO_COMPLETE_COURSE',
  /** Remind benefits of upskilling */
  RemindBenefitsOfUpskilling: 'REMIND_BENEFITS_OF_UPSKILLING',
  /** Remind to join the program */
  RemindToJoin: 'REMIND_TO_JOIN',
  /** Send accolades */
  SendAccolades: 'SEND_ACCOLADES'
} as const;

export type EnterpriseAdminHomePage_RecommendedActionType = typeof EnterpriseAdminHomePage_RecommendedActionType[keyof typeof EnterpriseAdminHomePage_RecommendedActionType];
/** Input for requesting more licenses */
export type EnterpriseAdminHomePage_RequestMoreLicensesInput = {
  /** List of Contract IDs */
  contractIds: Array<Scalars['ID']>;
  /** Enterprise organization ID */
  enterpriseOrganizationId: Scalars['ID'];
};

/** Time period for fetching enterprise admin homepage metrics */
export const EnterpriseAdminHomePage_TimePeriod = {
  /** Complete contract duration */
  AllTime: 'ALL_TIME',
  /** Last 90 days */
  NinetyDays: 'NINETY_DAYS',
  /** Last 30 days */
  ThirtyDays: 'THIRTY_DAYS'
} as const;

export type EnterpriseAdminHomePage_TimePeriod = typeof EnterpriseAdminHomePage_TimePeriod[keyof typeof EnterpriseAdminHomePage_TimePeriod];
/** Possible states for an EnterpriseAdmin invitation. */
export const EnterpriseAdminInvitation_State = {
  /** The invitation has been accepted. */
  Accepted: 'ACCEPTED',
  /** The invitation is active and can be accepted. */
  Active: 'ACTIVE',
  /** The invitation has been deleted. */
  Deleted: 'DELETED'
} as const;

export type EnterpriseAdminInvitation_State = typeof EnterpriseAdminInvitation_State[keyof typeof EnterpriseAdminInvitation_State];
/** Assignment failure reasons */
export const EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason = {
  /** User's email is not verified */
  EmailIsNotVerified: 'EMAIL_IS_NOT_VERIFIED',
  /** The email on the invitation is not associated with the current user */
  EmailNotAssociatedWithUser: 'EMAIL_NOT_ASSOCIATED_WITH_USER',
  /** Invitation not found or not active */
  NoActiveEnterpriseAdminInvitationFound: 'NO_ACTIVE_ENTERPRISE_ADMIN_INVITATION_FOUND'
} as const;

export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason = typeof EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason[keyof typeof EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason];
/** Enterprise admin invitation accept all invitations for email and organization from invitation input */
export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationInput = {
  /** The invitation id to be accepted */
  invitationId: Scalars['ID'];
};

/** Enterprise admin invitation input */
export type EnterpriseAdmin_CreateInvitationsOrRolesInput = {
  /** The emails of the invited users. */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs. Empty program IDs means adding the role at the org level. */
  programIds: Array<Scalars['ID']>;
  /** Template IDs of the roles to be created */
  roleTemplateId: Scalars['ID'];
  /** If we should send or skip the email notification */
  skipEmailNotification: Scalars['Boolean'];
};

/** Enterprise admin invitation delete all admin invitations input */
export type EnterpriseAdmin_DeleteAllAdminInvitationsInput = {
  /** User's email */
  email: Scalars['String'];
  /** The organization id */
  organizationId: Scalars['ID'];
};

/** Enterprise admin invitation delete input */
export type EnterpriseAdmin_DeleteInvitationsOrRolesInput = {
  /** The invitation id to be deleted */
  invitationId: Scalars['ID'];
};

/** Reason that an admin role or invitation cannot be created */
export const EnterpriseAdmin_InvalidAdminCreateReason = {
  /** There proposed role conflicts with another role or invitation */
  ConflictingRole: 'CONFLICTING_ROLE',
  /** The proposed role already exists */
  DuplicateRole: 'DUPLICATE_ROLE'
} as const;

export type EnterpriseAdmin_InvalidAdminCreateReason = typeof EnterpriseAdmin_InvalidAdminCreateReason[keyof typeof EnterpriseAdmin_InvalidAdminCreateReason];
/** Enterprise admin invitation role */
export const EnterpriseAdmin_InvitationRole = {
  /** The role is for a organization admin */
  OrganizationFull: 'ORGANIZATION_FULL',
  /** The role is for a program admin */
  ProgramFull: 'PROGRAM_FULL'
} as const;

export type EnterpriseAdmin_InvitationRole = typeof EnterpriseAdmin_InvitationRole[keyof typeof EnterpriseAdmin_InvitationRole];
/** Enterprise admin managed scope level input */
export type EnterpriseAdmin_ManagedLevelScopeInput = {
  /** ID of the organization. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** ID of the program. */
  programId?: InputMaybe<Scalars['ID']>;
};

/** input to EnterpriseAdmin_ValidateInvitationsOrRoles */
export type EnterpriseAdmin_ValidateInvitationsOrRolesInput = {
  /** The emails of the invited users. */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs. Empty program IDs means adding the role at the org level. */
  programIds: Array<Scalars['ID']>;
  /** Template IDs of the roles to be created */
  roleTemplateId: Scalars['ID'];
};

/** Badge configuration object */
export type EnterpriseBadge_BadgeConfigurationInput = {
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Url for the badge image */
  imageUrl: Scalars['URL'];
};

/** Input for badge creation */
export type EnterpriseBadge_CreateInput = {
  /** Name of the badge */
  badgeName: Scalars['String'];
  /** Source of the badge, should default to Credly unless specified as Coursera */
  badgeSource?: Badge_Source;
  /** List of products that require completion to attain the badge */
  criteria: Array<EnterpriseBadge_CriteriaItemInput>;
  /** Description of the badge */
  description: Scalars['String'];
  /** Url for the badge logo image */
  imageUrl: Scalars['URL'];
  /** Set of learning objectives for the badge */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the Learning Path */
  learningPathName: Scalars['String'];
  /** Program ID */
  programId: Scalars['ID'];
  /** Add optional ReferenceCollectionConfiguration for LP so it can copy from LP library */
  referenceCollectionConfiguration?: InputMaybe<EnterpriseBadge_ReferenceCollectionConfiguration>;
  /** List of skills that required by Credly */
  skills: Array<Scalars['ID']>;
};

/** Criteria options for badge creation */
export type EnterpriseBadge_CriteriaItemInput = {
  /** Only course as criteria are allowed currently */
  courseId?: InputMaybe<Scalars['ID']>;
};

/** Input for badge DeleteLearningPath */
export type EnterpriseBadge_DeleteLearningPathInput = {
  /** ID of the badge template to delete */
  badgeTemplateId: Scalars['ID'];
  /** Program ID that the the badge belongs to */
  programId: Scalars['ID'];
};

/** Input for duplicating Learning Path */
export type EnterpriseBadge_DuplicateLearningPathInput = {
  /** ID of the badge template to duplicate */
  badgeTemplateId: Scalars['ID'];
  /** Program Id contains the badge template to duplicate */
  originProgramId: Scalars['ID'];
  /** Program ID that new badge belongs to */
  programId: Scalars['ID'];
};

/** Input for EnterpriseBadge_GenerateLearningObjectives */
export type EnterpriseBadge_GenerateLearningObjectivesInput = {
  /** List of products that will exist in the learning path */
  criteria: Array<EnterpriseBadge_CriteriaItemInput>;
  /** Optional language to generate the learning objectives in, otherwise defaults to the language of the course name/descriptions */
  language?: InputMaybe<Scalars['String']>;
  /** Program ID that the the badge belongs to */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Configuration for the reference collection. Null if the collection does not reference other collections. */
export type EnterpriseBadge_ReferenceCollectionConfiguration = {
  /** Whether the curriculum collection should be synced to match the reference collection */
  enableSync?: Scalars['Boolean'];
  /** reference collection id */
  referenceCollectionId: Scalars['ID'];
  /** reference collection type */
  referenceCollectionType: EnterpriseBadge_ReferenceCollectionType;
};

/** Enum for badge reference collection type */
export const EnterpriseBadge_ReferenceCollectionType = {
  /** An organization collection */
  Organization: 'ORGANIZATION',
  /** A preset collection */
  Preset: 'PRESET'
} as const;

export type EnterpriseBadge_ReferenceCollectionType = typeof EnterpriseBadge_ReferenceCollectionType[keyof typeof EnterpriseBadge_ReferenceCollectionType];
/** Input for badge UpdateBadgeConfigurations */
export type EnterpriseBadge_UpdateBadgeConfigurationsInput = {
  /** List of badge configurations to update */
  badgeConfigurations: Array<EnterpriseBadge_BadgeConfigurationInput>;
  /** Program ID that the the badges belong to, can not be changed */
  programId: Scalars['ID'];
};

/** Input for badge UpdateLearningPathActivities */
export type EnterpriseBadge_UpdateLearningPathActivitiesInput = {
  /** List of products that require completion to attain the badge */
  activities: Array<EnterpriseBadge_CriteriaItemInput>;
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Program ID that the the badge belongs to, can not be changed */
  programId: Scalars['ID'];
};

/** Input for badge UpdateLearningPathMetadata */
export type EnterpriseBadge_UpdateLearningPathMetadataInput = {
  /** Name of the badge */
  badgeName: Scalars['String'];
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Description of the badge */
  description: Scalars['String'];
  /** Url for the badge logo image */
  imageUrl: Scalars['URL'];
  /** Set of learning objectives for the badge (min 2, max 4) */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the Learning Path */
  learningPathName: Scalars['String'];
  /** List of skills that required by Credly */
  skills: Array<Scalars['ID']>;
};

/** Enum that defines the type of products supported */
export const EnterpriseBadge_ProductType = {
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type EnterpriseBadge_ProductType = typeof EnterpriseBadge_ProductType[keyof typeof EnterpriseBadge_ProductType];
/** Enum that defines all possible user states for a badge */
export const EnterpriseBadge_UserState = {
  /** TODO: Complete this description */
  Enrolled: 'ENROLLED',
  /** TODO: Complete this description */
  Issued: 'ISSUED',
  /** TODO: Complete this description */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** TODO: Complete this description */
  Unenrolled: 'UNENROLLED'
} as const;

export type EnterpriseBadge_UserState = typeof EnterpriseBadge_UserState[keyof typeof EnterpriseBadge_UserState];
/** Assignment failure reasons */
export const EnterpriseContentAssignment_AssignmentFailureReason = {
  /** Content is not enroll-able for user */
  ContentNotEnrollableForUser: 'CONTENT_NOT_ENROLLABLE_FOR_USER',
  /** Content is not available in the program */
  ContentNotInProgram: 'CONTENT_NOT_IN_PROGRAM',
  /** Content already assigned to the email address */
  EmailAlreadyAssigned: 'EMAIL_ALREADY_ASSIGNED',
  /** Email doesn't have program invitation and inviteNonMembers flag is false. */
  EmailDoesntHaveProgramInvitation: 'EMAIL_DOESNT_HAVE_PROGRAM_INVITATION',
  /**
   * NOTE: THIS ERROR WONT BE RETURNED ANYMORE. Since email could be not registered on coursera but still have program
   * invitation so we assign content to their email. Or, if invitation is not present and inviteNonMembers is false,
   * we return EMAIL_DOESNT_HAVE_PROGRAM_INVITATION error instead.
   */
  EmailNotRegistered: 'EMAIL_NOT_REGISTERED',
  /** User is already assigned to the content in the program */
  UserAlreadyAssigned: 'USER_ALREADY_ASSIGNED',
  /** User is not a member of the program */
  UserNotInProgram: 'USER_NOT_IN_PROGRAM'
} as const;

export type EnterpriseContentAssignment_AssignmentFailureReason = typeof EnterpriseContentAssignment_AssignmentFailureReason[keyof typeof EnterpriseContentAssignment_AssignmentFailureReason];
/** Assignable content types */
export const EnterpriseContentAssignment_ContentType = {
  /** Course */
  Course: 'COURSE',
  /** Learning Path */
  LearningPath: 'LEARNING_PATH',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseContentAssignment_ContentType = typeof EnterpriseContentAssignment_ContentType[keyof typeof EnterpriseContentAssignment_ContentType];
/** Union input type representing different ways to select users. */
export type EnterpriseContentAssignment_CreateAssignmentUserSelectionInput = {
  /** CSV file location in S3, which contains a column of email addresses. */
  csvFile?: InputMaybe<EnterpriseContentAssignment_S3FileInput>;
  /** Filter ID referencing the saved filter that can be used to retrieve a list of users. */
  savedFilterId?: InputMaybe<Scalars['ID']>;
  /** Selected user IDs. For assigning content to program members. */
  userSelections?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for EnterpriseContentAssignment_CreateAssignmentsForPrograms */
export type EnterpriseContentAssignment_CreateAssignmentsForProgramsInput = {
  /** Display name of the assigner */
  assignedByDisplayName: Scalars['String'];
  /** Content ID for the assignment */
  contentId: Scalars['ID'];
  /** Content type for the assignment */
  contentType: EnterpriseContentAssignment_ContentType;
  /** Email message to be sent to assigned learners */
  emailMessage?: InputMaybe<Scalars['String']>;
  /** Program IDs to assign content across */
  programIds: Array<Scalars['ID']>;
};

/** Input for EnterpriseContentAssignment_CreateAssignments */
export type EnterpriseContentAssignment_CreateAssignmentsInput = {
  /** Display name of the assigner */
  assignedByDisplayName: Scalars['String'];
  /** Content ID for the assignment */
  contentId: Scalars['ID'];
  /** Content type for the assignment */
  contentType: EnterpriseContentAssignment_ContentType;
  /** Email message to be sent to assigned learners */
  emailMessage?: InputMaybe<Scalars['String']>;
  /**
   * If true, invite non-members to program and assign content to their email, else throw error
   * EMAIL_DOESNT_HAVE_PROGRAM_INVITATION so can't assign content to non-invited learners.
   */
  inviteNonMembers?: Scalars['Boolean'];
  /** For assigning content to invited and non-invited learners and sending program invitations to non-invited learners. */
  invitees?: InputMaybe<Array<EnterpriseContentAssignment_ProgramInvitee>>;
  /** Boolean indicating whether the assignments will really be created, vs. just running through validations. */
  isPreview?: InputMaybe<Scalars['Boolean']>;
  /** Program ID for the assignment */
  programId: Scalars['ID'];
  /** roster_id to be used when inviting learners to a program with multiple contracts. */
  rosterId?: InputMaybe<Scalars['ID']>;
  /** Union input type representing different ways to select users. */
  userSelectionInput?: InputMaybe<EnterpriseContentAssignment_CreateAssignmentUserSelectionInput>;
  /**
   * Users to be assigned. Deprecated in favor of a new input type representing the different ways to select users.
   * @deprecated Use userSelectionInput instead
   */
  userSelections?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for EnterpriseContentAssignment_DeleteAssignments */
export type EnterpriseContentAssignment_DeleteAssignmentsInput = {
  /** Content ID for the delete */
  contentId: Scalars['ID'];
  /** Content type for the delete */
  contentType: EnterpriseContentAssignment_ContentType;
  /** If true, delete all assignments for the content in program. This is cross-validated with `userSelections`. */
  deleteAll?: Scalars['Boolean'];
  /** Email-based Assignments to be deleted, */
  nonMemberEmails?: Array<Scalars['String']>;
  /** Program ID */
  programId: Scalars['ID'];
  /** Users to be deleted, empty array means all assigned users. This is cross-validated with `deleteAll`. */
  userSelections?: Array<Scalars['ID']>;
};

/** Input for EnterpriseContentAssignment_GenerateCsvUploadLocation */
export type EnterpriseContentAssignment_GenerateCsvUploadLocationInput = {
  /** Program ID related to the bulk assignment. */
  programId: Scalars['ID'];
};

/** Pre-processing failure reasons. */
export const EnterpriseContentAssignment_PreProcessingFailure = {
  /** Content not in program. This is validated before we process the users. */
  ContentNotInProgram: 'CONTENT_NOT_IN_PROGRAM',
  /** Unable to read CSV file (not in appropriate CSV format). */
  CsvIncorrectFormat: 'CSV_INCORRECT_FORMAT'
} as const;

export type EnterpriseContentAssignment_PreProcessingFailure = typeof EnterpriseContentAssignment_PreProcessingFailure[keyof typeof EnterpriseContentAssignment_PreProcessingFailure];
/** Program Invitee model */
export type EnterpriseContentAssignment_ProgramInvitee = {
  /** Invitee Email */
  email: Scalars['String'];
  /** Invitee External ID */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Invitee Name */
  name: Scalars['String'];
};

/** Program Invitee Failure Reasons */
export const EnterpriseContentAssignment_ProgramInviteeFailureReason = {
  /** Invitation already exists for email */
  ExistingInvitationForEmail: 'EXISTING_INVITATION_FOR_EMAIL',
  /** Invitation already exists for external ID */
  ExistingInvitationForExternalId: 'EXISTING_INVITATION_FOR_EXTERNAL_ID',
  /** Membership already exists for email */
  ExistingMembershipForEmail: 'EXISTING_MEMBERSHIP_FOR_EMAIL',
  /** Membership already exists for external ID */
  ExistingMembershipForExternalId: 'EXISTING_MEMBERSHIP_FOR_EXTERNAL_ID',
  /** Invalid email */
  InvalidEmail: 'INVALID_EMAIL',
  /** Invalid external ID */
  InvalidExternalId: 'INVALID_EXTERNAL_ID',
  /** Invalid full name */
  InvalidFullName: 'INVALID_FULL_NAME',
  /** Roster Without an active Contract */
  RosterWithoutActiveContract: 'ROSTER_WITHOUT_ACTIVE_CONTRACT',
  /** Unhandled error */
  UnhandledError: 'UNHANDLED_ERROR'
} as const;

export type EnterpriseContentAssignment_ProgramInviteeFailureReason = typeof EnterpriseContentAssignment_ProgramInviteeFailureReason[keyof typeof EnterpriseContentAssignment_ProgramInviteeFailureReason];
/** S3 file location as an input */
export type EnterpriseContentAssignment_S3FileInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
};

/** Input for deleting a scheduled billing. */
export type EnterpriseContractBillingSchedule_DeleteBillingInput = {
  /** Identifier of the scheduled billing to delete. */
  billingId: Scalars['ID'];
};

/** Input for scheduling a billing run for an enterprise contract installment. */
export type EnterpriseContractBillingSchedule_ScheduleBillingInput = {
  /** The enterprise contract to schedule billing for. */
  enterpriseContractId: Scalars['ID'];
  /** The installment number within the term to schedule billing for. */
  installmentNo: Scalars['Int'];
  /** Timestamp of the previous retry attempt. Null for the initial scheduling attempt. */
  lastRetryAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The retry attempt number of the previous billing schedule. Defaults to 0 for the
   * initial scheduling attempt.
   */
  lastRetryNo?: Scalars['Int'];
  /** The contract term number the installment belongs to. */
  termNo: Scalars['Int'];
};

/** Input for creating a deferred license change. */
export type EnterpriseContractDeferredLicenseChange_CreateInput = {
  /** Number of licenses to change to. Null when this is a cancellation request. */
  changeNumLicensesTo?: InputMaybe<Scalars['Int']>;
  /** Enterprise Contract ID. */
  enterpriseContractId: Scalars['ID'];
  /** Type of the license change request. */
  requestType: EnterpriseContractDeferredLicenseChange_RequestType;
};

/** Input for getEffectiveDeferredLicenseChange query. */
export type EnterpriseContractDeferredLicenseChange_GetEffectiveDeferredLicenseInput = {
  /** Enterprise Contract ID. */
  enterpriseContractId: Scalars['ID'];
};

/** Enumeration of possible license change request types. */
export const EnterpriseContractDeferredLicenseChange_RequestType = {
  /** Request license cancellation. */
  Cancellation: 'CANCELLATION',
  /** Request a new license change. */
  Request: 'REQUEST'
} as const;

export type EnterpriseContractDeferredLicenseChange_RequestType = typeof EnterpriseContractDeferredLicenseChange_RequestType[keyof typeof EnterpriseContractDeferredLicenseChange_RequestType];
/** Invoice creation billing address input */
export type EnterpriseContractInvoice_BillingAddressInput = {
  /** City */
  city: Scalars['String'];
  /** Country */
  country: Scalars['String'];
  /** Address line 1 */
  line1: Scalars['String'];
  /** Address line 2 */
  line2?: InputMaybe<Scalars['String']>;
  /** Postal code */
  postalCode: Scalars['String'];
  /** State */
  state: Scalars['String'];
};

/** Billing system type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_BillingSystemType = {
  /** Contract payments handled by the Enterprise Invoicing service */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Contract billed by recurring automated transaction payment */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Contract not integrated with any billing system (usually for test contracts) */
  NonBillable: 'NON_BILLABLE',
  /** Contract payments handled off-platform by internal finance team */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContractInvoice_BillingSystemType = typeof EnterpriseContractInvoice_BillingSystemType[keyof typeof EnterpriseContractInvoice_BillingSystemType];
/** Input for creating an invoice order */
export type EnterpriseContractInvoice_CreateInvoiceOrderInput = {
  /** Admin billing email */
  adminBillingEmail: Scalars['String'];
  /** Admin title */
  adminTitle: Scalars['String'];
  /** Billing country code */
  billingCountryCode: Scalars['String'];
  /** Custom total amount for testing */
  customTotalAmount?: InputMaybe<Scalars['String']>;
  /** Number of licenses */
  numberOfLicenses: Scalars['Int'];
  /** Organization billing address */
  organizationBillingAddress: EnterpriseContractInvoice_BillingAddressInput;
  /** Existing organization ID */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** Organization name */
  organizationName: Scalars['String'];
  /** Organization type */
  organizationType?: InputMaybe<EnterpriseContractInvoice_OrganizationType>;
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Sales owner */
  salesOwner?: InputMaybe<EnterpriseContractInvoice_SalesOwner>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Tax ID data */
  taxIdData?: InputMaybe<EnterpriseContractInvoice_TaxIdDataInput>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag */
  useSandbox: Scalars['Boolean'];
};

/** Input for creating an invoice renewal order for an existing enterprise contract. */
export type EnterpriseContractInvoice_CreateInvoiceRenewalOrderInput = {
  /** Existing enterprise contract ID to renew */
  contractId: Scalars['ID'];
  /** Creator user ID. If omitted, it is resolved from the authenticated request context. */
  creatorId?: InputMaybe<Scalars['ID']>;
  /** Optional override for the renewal invoice due date (test/sandbox usage). */
  customDueAt?: InputMaybe<Scalars['DateTime']>;
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag. Defaults to false to match the other invoice order mutations. */
  useSandbox?: Scalars['Boolean'];
};

/** Input for creating an invoice upgrade (upsell) order */
export type EnterpriseContractInvoice_CreateInvoiceUpgradeOrderInput = {
  /** Existing enterprise contract ID to upgrade */
  contractId: Scalars['ID'];
  /** Admin billing emails to notify for the upsell invoice */
  emails: Array<Scalars['String']>;
  /** Optional enterprise promotion id. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /** Number of additional licenses to add */
  numberOfLicenses: Scalars['Int'];
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag. Defaults to false to match the legacy Scala resource behavior. */
  useSandbox?: Scalars['Boolean'];
};

/** Invoice type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_InvoiceType = {
  /** Initial invoice for a new contract */
  Initial: 'INITIAL',
  /** Renewal invoice for extending an existing contract */
  Renewal: 'RENEWAL',
  /** Upgrade invoice for adding licenses to an existing contract */
  Upgrade: 'UPGRADE'
} as const;

export type EnterpriseContractInvoice_InvoiceType = typeof EnterpriseContractInvoice_InvoiceType[keyof typeof EnterpriseContractInvoice_InvoiceType];
/** Key-value pair input for representing map entries */
export type EnterpriseContractInvoice_KeyValuePairInput = {
  /** Key */
  key: Scalars['String'];
  /** Value */
  value: Scalars['String'];
};

/** Organization type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_OrganizationType = {
  /** Business organization type */
  Business: 'BUSINESS',
  /** Campus organization type */
  Campus: 'CAMPUS',
  /** Government organization type */
  Government: 'GOVERNMENT'
} as const;

export type EnterpriseContractInvoice_OrganizationType = typeof EnterpriseContractInvoice_OrganizationType[keyof typeof EnterpriseContractInvoice_OrganizationType];
/** Enterprise sales owner enum */
export const EnterpriseContractInvoice_SalesOwner = {
  /** Coursera sales team */
  CourseraSales: 'COURSERA_SALES',
  /** Marketstar sales team */
  Marketstar: 'MARKETSTAR',
  /** Scaled success team */
  Scaledsuccess: 'SCALEDSUCCESS'
} as const;

export type EnterpriseContractInvoice_SalesOwner = typeof EnterpriseContractInvoice_SalesOwner[keyof typeof EnterpriseContractInvoice_SalesOwner];
/** Invoice creation tax ID data input */
export type EnterpriseContractInvoice_TaxIdDataInput = {
  /** Tax ID type */
  taxIdType: Scalars['String'];
  /** Tax ID value */
  taxIdValue: Scalars['String'];
};

/** Specifies all the different types of policies that can be associated with an enterprise contract. Intended to be used in tandem with one of the EnterpriseContractPolicyMetadata types, where the policy metadata specifies auxiliary values used to enforce the policy */
export const EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType = {
  ContractEnded: 'CONTRACT_ENDED',
  ContractFullyUtilized: 'CONTRACT_FULLY_UTILIZED'
} as const;

export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType = typeof EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType[keyof typeof EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType];
/** Represents the type of contract policy. */
export const EnterpriseContractPolicy_ContractPolicyType = {
  /** Policy for when a contract has ended. */
  ContractEnded: 'CONTRACT_ENDED',
  /** Policy for when a contract has been fully utilized. */
  ContractFullyUtilized: 'CONTRACT_FULLY_UTILIZED'
} as const;

export type EnterpriseContractPolicy_ContractPolicyType = typeof EnterpriseContractPolicy_ContractPolicyType[keyof typeof EnterpriseContractPolicy_ContractPolicyType];
/** Input for creating a contract ended policy. */
export type EnterpriseContractPolicy_CreateContractEndedPolicyInput = {
  /** The date when the contract becomes active, if applicable. */
  activationDate?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the contract to create the policy for. */
  contractId: Scalars['ID'];
  /** The ID of the contract migration, if applicable. */
  contractMigrationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the renewal contract. */
  renewalContractId: Scalars['ID'];
};

/** Input for creating a contract fully utilized policy. */
export type EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyInput = {
  /** The ID of the contract to create the policy for. */
  contractId: Scalars['ID'];
  /** The ID of the fallback contract to use when the current contract is fully utilized. */
  fallbackContractId: Scalars['ID'];
};

/** Input for deleting a contract policy. */
export type EnterpriseContractPolicy_DeleteContractPolicyInput = {
  /** The ID of the contract to delete the policy for. */
  contractId: Scalars['ID'];
  /** The type of contract policy to delete. */
  policyType: EnterpriseContractPolicy_ContractPolicyType;
};

/**
 * Contract billing type enumeration.
 * Corresponds to EnterpriseContractBillingType in Scala.
 */
export const EnterpriseContractPrice_BillingType = {
  /** Invoice billing type. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time billing type. */
  OneTime: 'ONE_TIME',
  /** Quarterly billing type. */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContractPrice_BillingType = typeof EnterpriseContractPrice_BillingType[keyof typeof EnterpriseContractPrice_BillingType];
/** Input for creating a new pricing rule. */
export type EnterpriseContractPrice_CreatePricingDiscountRuleInput = {
  /** The discount percentage to apply (e.g. "5.00" for 5%). */
  discountPercentage: Scalars['String'];
  /** What the lower/upper limits refer to. */
  limitType: EnterpriseContractPrice_PricingRuleLimitType;
  /** Minimum seat count for this tier (inclusive). */
  lowerLimit: Scalars['Int'];
  /** The type of discount. */
  type: EnterpriseContractPrice_PricingDiscountType;
  /** Maximum seat count for this tier (inclusive). */
  upperLimit: Scalars['Int'];
};

/** Discount type enumeration for applied or rejected discounts. */
export const EnterpriseContractPrice_DiscountType = {
  /** Promotion-based discount (e.g. enterprise promotion). */
  Promotion: 'PROMOTION',
  /** Volume-based discount from pricing rules. */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EnterpriseContractPrice_DiscountType = typeof EnterpriseContractPrice_DiscountType[keyof typeof EnterpriseContractPrice_DiscountType];
/**
 * Input for updating enterprise contract limit values.
 * Based on EnterpriseContractLimitValuesUpdate class in Scala.
 */
export type EnterpriseContractPrice_LimitValuesUpdateInput = {
  /** Number of courses per user to add. */
  coursesPerUsersAdded?: Scalars['Int'];
  /** Total number of courses to add to the contract. */
  coursesTotalAdded?: Scalars['Int'];
  /** Number of users to add to the contract. */
  usersAdded: Scalars['Int'];
};

/** Discount type for a pricing rule. */
export const EnterpriseContractPrice_PricingDiscountType = {
  /** Volume-based discount applied by seat count. */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EnterpriseContractPrice_PricingDiscountType = typeof EnterpriseContractPrice_PricingDiscountType[keyof typeof EnterpriseContractPrice_PricingDiscountType];
/**
 * Pricing model enumeration for enterprise contracts.
 * Determines whether differential pricing is applied based on billing frequency.
 */
export const EnterpriseContractPrice_PricingModel = {
  /** Differential pricing model with quarterly premium where quarterly billing has a 10% premium over annual billing. */
  DifferentialQuarterlyPremium: 'DIFFERENTIAL_QUARTERLY_PREMIUM',
  /** Standard pricing model where annual and quarterly billing have the same effective annual rate. */
  Standard: 'STANDARD'
} as const;

export type EnterpriseContractPrice_PricingModel = typeof EnterpriseContractPrice_PricingModel[keyof typeof EnterpriseContractPrice_PricingModel];
/** What the lower/upper limits of a pricing discount rule refer to. */
export const EnterpriseContractPrice_PricingRuleLimitType = {
  /** Limits are based on seat count. */
  Seats: 'SEATS'
} as const;

export type EnterpriseContractPrice_PricingRuleLimitType = typeof EnterpriseContractPrice_PricingRuleLimitType[keyof typeof EnterpriseContractPrice_PricingRuleLimitType];
/**
 * Input for enterprise self-serve contract product price ID.
 * Based on EnterpriseSelfServeContractProductPriceId class.
 */
export type EnterpriseContractPrice_ProductPriceIdInput = {
  /** Billing type for the contract. */
  billingType: EnterpriseContractPrice_BillingType;
  /** Number of user licenses for the contract. */
  userLimit: Scalars['Int'];
};

/** Why an estimate email was not sent. Only meaningful when `emailSent` is false. */
export const EnterpriseContractPrice_SendEstimateEmailErrorReason = {
  /** The downstream email service failed after validation and pricing succeeded. */
  EmailSendFailed: 'EMAIL_SEND_FAILED',
  /** The recipient address did not pass business email validation. */
  InvalidBusinessEmail: 'INVALID_BUSINESS_EMAIL',
  /** Validation requires the recipient to complete OTP before an estimate can be emailed. */
  OtpRequired: 'OTP_REQUIRED',
  /** The recipient reached the maximum number of estimate emails allowed in the configured time window. */
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type EnterpriseContractPrice_SendEstimateEmailErrorReason = typeof EnterpriseContractPrice_SendEstimateEmailErrorReason[keyof typeof EnterpriseContractPrice_SendEstimateEmailErrorReason];
/**
 * Input for sending a self-serve contract product price estimate via email.
 * Mirrors the parameters of `getEnterpriseSelfServeContractProductPrice` plus an
 * additional `email` field (and optional recipient personalization).
 */
export type EnterpriseContractPrice_SendEstimateEmailInput = {
  /**
   * Optional country ISO code for localized pricing. Falls back to the request's IP-derived
   * country when absent.
   */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Optional currency code for price conversion. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Recipient business email address. */
  email: Scalars['String'];
  /** Optional enterprise promotion ID to apply to the price. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /** Optional FX rate ID for specific currency conversion. */
  fxRateId?: InputMaybe<Scalars['ID']>;
  /**
   * Pricing model to apply for the contract. Defaults to STANDARD pricing where annual and
   * quarterly have the same effective annual rate.
   */
  pricingModel?: InputMaybe<EnterpriseContractPrice_PricingModel>;
  /** Promo Code to apply to the price. */
  promoCode?: InputMaybe<Scalars['String']>;
  /** Number of billing installments per term (1 for one-time, 4 for quarterly). */
  termInstallmentsTotal: Scalars['Int'];
  /** Optional user ID for user-specific pricing. */
  userId?: InputMaybe<Scalars['ID']>;
  /** Number of user licenses. */
  userLimit: Scalars['Int'];
};

/** Input for updating the active status of a pricing rule. */
export type EnterpriseContractPrice_UpdatePricingDiscountRuleStatusInput = {
  /** Whether the rule should be active. */
  active: Scalars['Boolean'];
  /** The pricing rule ID. */
  id: Scalars['ID'];
};

/**
 * Auto-renewal authorization action enumeration.
 * Corresponds to AutoRenewAuthorizationAction in Scala.
 */
export const EnterpriseContractRenewal_AutoRenewAuthorizationAction = {
  /**
   * Disable auto-renewal for the contract.
   * Maps to opt-out for legacy cases.
   */
  Disable: 'DISABLE',
  /**
   * Enable auto-renewal for the contract.
   * Maps to opt-in for legacy cases.
   */
  Enable: 'ENABLE'
} as const;

export type EnterpriseContractRenewal_AutoRenewAuthorizationAction = typeof EnterpriseContractRenewal_AutoRenewAuthorizationAction[keyof typeof EnterpriseContractRenewal_AutoRenewAuthorizationAction];
/**
 * Input for changing the auto-renewal authorization for an enterprise contract.
 * Based on AutoRenewAuthorizationChange class.
 */
export type EnterpriseContractRenewal_ChangeAutoRenewAuthorizationInput = {
  /**
   * The action to take for auto-renewal authorization (ENABLE or DISABLE).
   * Maps to opt-in and opt-out respectively for legacy cases.
   */
  action: EnterpriseContractRenewal_AutoRenewAuthorizationAction;
  /** The ID of the enterprise contract to modify. */
  contractId: Scalars['ID'];
  /**
   * The ID of the user who is authorizing the change.
   * Primarily used in legacy opt-in/opt-out flows.
   */
  userId: Scalars['ID'];
};

/** The Input of the Enterprise Contract Tag to be added */
export type EnterpriseContractTag_AddTagInput = {
  /** The delist restricted products boolean value */
  delistRestrictedProducts: Scalars['Boolean'];
  /** The ID of the contract tag to add */
  id: EnterpriseContractTag_ContractTagId;
};

/** Represents the unique identifier of an EnterpriseContractTag. */
export type EnterpriseContractTag_ContractTagId = {
  /** The contract ID associated with the tag. */
  contractId: Scalars['ID'];
  /** The name of the contract tag. */
  contractTagName: Scalars['String'];
};

/** The Enterprise Contract Tag Input to be deleted */
export type EnterpriseContractTag_DeleteTagInput = {
  /** The ID of the contract tag to delete */
  id: EnterpriseContractTag_ContractTagId;
};

/** Represents the source of an EnterpriseContractTag. */
export const EnterpriseContractTag_EnterpriseContractTagSource = {
  /** Represents a contract tag added ad-hoc, not during any specific process. */
  Adhoc: 'ADHOC',
  /** Represents a contract tag added manually during the contract creation process. */
  ContractCreationManual: 'CONTRACT_CREATION_MANUAL',
  /** Represents a contract tag added via Salesforce during the contract creation process. */
  ContractCreationSfdc: 'CONTRACT_CREATION_SFDC',
  /** Represents a contract tag added during the contract renewal process. */
  ContractRenewal: 'CONTRACT_RENEWAL',
  /** Represents an invalid source value. */
  Invalid: 'INVALID'
} as const;

export type EnterpriseContractTag_EnterpriseContractTagSource = typeof EnterpriseContractTag_EnterpriseContractTagSource[keyof typeof EnterpriseContractTag_EnterpriseContractTagSource];
export const EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource = {
  Adhoc: 'ADHOC',
  ContractCreationManual: 'CONTRACT_CREATION_MANUAL',
  ContractCreationSfdc: 'CONTRACT_CREATION_SFDC',
  ContractRenewal: 'CONTRACT_RENEWAL'
} as const;

export type EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource = typeof EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource[keyof typeof EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource];
export const EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
/** Contract limit types */
export const EnterpriseContractUtilizations_ContractLimitType = {
  /** Limit set by enrollment cap */
  EnterpriseContractLimitTypeEnrollmentCap: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_ENROLLMENT_CAP',
  /** Limit type is invalid */
  EnterpriseContractLimitTypeInvalid: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_INVALID',
  /** No limit set */
  EnterpriseContractLimitTypeNoLimit: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_NO_LIMIT',
  /** Limit set by user licenses */
  EnterpriseContractLimitTypeUserLicense: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_USER_LICENSE',
  /** Limit set by user licenses and enrollment cap */
  EnterpriseContractLimitTypeUserLicenseWithEnrollmentCap: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractUtilizations_ContractLimitType = typeof EnterpriseContractUtilizations_ContractLimitType[keyof typeof EnterpriseContractUtilizations_ContractLimitType];
/** Input parameters for EnterpriseContract_ActivateContract mutation. */
export type EnterpriseContract_ActivateContractInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** Option to specify email notification preferences for the activation */
  emailRequest?: InputMaybe<EnterpriseContract_EmailRequestInput>;
  /** Notes with more details */
  notes?: InputMaybe<Scalars['String']>;
};

/** Enterprise Contract Billing Type */
export const EnterpriseContract_BillingType = {
  /** Invoice */
  Invoice: 'INVOICE',
  /** None */
  None: 'NONE',
  /** One time */
  OneTime: 'ONE_TIME',
  /** Quarterly */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContract_BillingType = typeof EnterpriseContract_BillingType[keyof typeof EnterpriseContract_BillingType];
/** Enterprise contract account group */
export const EnterpriseContract_ContractAccountGroup = {
  /** Org Type C4B */
  C4B: 'C4B',
  /** Org Type C4C */
  C4C: 'C4C',
  /** Org Type C4G */
  C4G: 'C4G',
  /** Org Type GOOGLE */
  Google: 'GOOGLE',
  /** Org Type IP */
  Ip: 'IP',
  /** Org Type SOCIAL_IMPACT */
  SocialImpact: 'SOCIAL_IMPACT'
} as const;

export type EnterpriseContract_ContractAccountGroup = typeof EnterpriseContract_ContractAccountGroup[keyof typeof EnterpriseContract_ContractAccountGroup];
/**
 * EnterpriseContract's can be paid for in a variety of different ways.
 * The EnterpriseContractBillingSystemType is a finite list of the billing methods available
 * for both direct sales and WES contracts.
 */
export const EnterpriseContract_ContractBillingSystemType = {
  /**
   * This contract's payments are being handled by the Enterprise Invoicing service.
   * Transactions are initiated by interaction between the customer and payment processor,
   * notifying Coursera backend via asynchronous webhooks.
   */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /**
   * This contract is being billed by the recurring enterpriseselfservebilling Iguazu job.
   * Transactions are initiated by the payment service's cart system.
   * Usually used by WES contracts not handled by the Enterprise Invoicing service
   */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** This contract is not integrated with any billing system. This is usually used by test (not-real) contracts. */
  NonBillable: 'NON_BILLABLE',
  /**
   * This contract's payments are being handled off-platform by Coursera's internal finance team,
   * The team manually sends the customer invoices and collects payment.
   * Usually used by direct sales contracts.
   */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContract_ContractBillingSystemType = typeof EnterpriseContract_ContractBillingSystemType[keyof typeof EnterpriseContract_ContractBillingSystemType];
/**
 * Enterprise contract deal type.
 * Currently, all listed deal types are specific to C4G contracts.
 * Future expansion may include deal types for other contract types.
 */
export const EnterpriseContract_ContractDealType = {
  /** C4G deal for Government Employees */
  GovernmentEmployees: 'GOVERNMENT_EMPLOYEES',
  /** C4G deal for Ministries of Education */
  MinistriesOfEducation: 'MINISTRIES_OF_EDUCATION',
  /** C4G deal for Workforce Development */
  WorkforceDevelopment: 'WORKFORCE_DEVELOPMENT'
} as const;

export type EnterpriseContract_ContractDealType = typeof EnterpriseContract_ContractDealType[keyof typeof EnterpriseContract_ContractDealType];
/** Enterprise Contract Limit Type */
export const EnterpriseContract_ContractLimitType = {
  /** Number of enrollments the contract can have */
  EnrollmentCap: 'ENROLLMENT_CAP',
  /** No limit */
  NoLimit: 'NO_LIMIT',
  /** Number of members in the contract */
  UserLicense: 'USER_LICENSE',
  /** Number of members and enrollment the contract can have */
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContract_ContractLimitType = typeof EnterpriseContract_ContractLimitType[keyof typeof EnterpriseContract_ContractLimitType];
/** Enterprise Contract Limits */
export type EnterpriseContract_ContractLimitsInput = {
  /** Number of courses that can be enrolled by each member */
  coursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /** Number of enrollments the contract can have */
  enrollmentCapLimit?: InputMaybe<Scalars['Int']>;
  /** Number of members that can be assigned to the contract */
  userLimit?: InputMaybe<Scalars['Int']>;
};

/** Enterprise contract purpose */
export const EnterpriseContract_ContractPurpose = {
  /** Demo contract */
  Demo: 'DEMO',
  /** Trial contract intended for prospects */
  Trial: 'TRIAL'
} as const;

export type EnterpriseContract_ContractPurpose = typeof EnterpriseContract_ContractPurpose[keyof typeof EnterpriseContract_ContractPurpose];
/** Enterprise Contract State */
export const EnterpriseContract_ContractState = {
  /** ACTIVE: Active and consumable state for a contract. It moves into this stage after gets activated */
  Active: 'ACTIVE',
  /** CREATED: The state that the contract will be in when it just gets created. */
  Created: 'CREATED',
  /**
   * EXPIRED: The endsAt data has passed but contract has not been terminated yet. The contract
   * basically is treated as paused in this state
   */
  Expired: 'EXPIRED',
  /** PAUSED: The contract is paused and can't be consumed at this state. */
  Paused: 'PAUSED',
  /** TERMINATED: The contract is in this state after gets terminated and cannot be consumed or edited */
  Terminated: 'TERMINATED'
} as const;

export type EnterpriseContract_ContractState = typeof EnterpriseContract_ContractState[keyof typeof EnterpriseContract_ContractState];
/** An enum for tagging terms with extra context */
export const EnterpriseContract_ContractTermTag = {
  /** Free trial allowing access to Coursera for Teams. */
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EnterpriseContract_ContractTermTag = typeof EnterpriseContract_ContractTermTag[keyof typeof EnterpriseContract_ContractTermTag];
/** Enterprise Contract Type */
export const EnterpriseContract_ContractType = {
  /** WES */
  SelfServe: 'SELF_SERVE',
  /** Standard */
  Standard: 'STANDARD'
} as const;

export type EnterpriseContract_ContractType = typeof EnterpriseContract_ContractType[keyof typeof EnterpriseContract_ContractType];
/** Input parameters for EnterpriseContract_CreateContract mutation. */
export type EnterpriseContract_CreateContractInput = {
  /** Account Group of the Salesforce case, one of C4B, C4C & C4G. */
  accountGroup?: InputMaybe<EnterpriseContract_ContractAccountGroup>;
  /** The billing type for the contract to be created */
  billingType: EnterpriseContract_BillingType;
  /**
   * Optional cart ID
   * - For STANDARD contract type, NOT required
   * - For SELF_SERVE contract type, optional only if planId is provided
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  cartId?: InputMaybe<Scalars['ID']>;
  /** The contract type for the contract to be created */
  contractLimitType: EnterpriseContract_ContractLimitType;
  /** The contract limits specifications */
  contractLimits: EnterpriseContract_ContractLimitsInput;
  /** A tag that should be associated with the contract. Currently limited to Direct Sales contracts */
  contractTag?: InputMaybe<Scalars['String']>;
  /** The contract type for the contract to be created */
  contractType: EnterpriseContract_ContractType;
  /** Country ISO code */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /**
   * The ID of user creating the contract
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  createdBy?: InputMaybe<Scalars['ID']>;
  /** The associated Currency Code */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * For a C4G accounts, there can be multiple types of deals. Null is allowed for C4B and C4C,
   * test and WES contracts.
   */
  dealType?: InputMaybe<EnterpriseContract_ContractDealType>;
  /** Duration of the contract in months */
  durationInMonths?: InputMaybe<Scalars['Float']>;
  /** Time when the contract ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Flag used to distinguish between real customer contracts and test contracts */
  isReal?: Scalars['Boolean'];
  /** A custom percentage recycling allowed in the contract. */
  licenseRecycleLimitPercent?: InputMaybe<Scalars['String']>;
  /**
   * Whether the customer has agreed to license recycle terms & conditions while signing the contract.
   * Null is allowed for the test and WES contracts
   */
  licenseRecycleTncEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Name of the contract */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optional payment wallet ID: Used for recurring payments
   * - Sent as String ID, since Long is not supported in GraphQL
   */
  paymentWalletId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional Plan ID
   * - For STANDARD contract type, always required
   * - For SELF_SERVE contract type, optional only if cartId is provided
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  planId?: InputMaybe<Scalars['ID']>;
  /** The purpose of the contract. NULL means "regular" contract that does not fall into any predefined categories. */
  purpose?: InputMaybe<EnterpriseContract_ContractPurpose>;
  /** Case number of the contract in salesforce */
  salesforceCaseNumber?: InputMaybe<Scalars['String']>;
  /** Scheduled activation timestamp for the contract. Must be in the future. */
  scheduledActivationAt?: InputMaybe<Scalars['DateTime']>;
  /** Time when the contract starts */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** Organization ID - must be non-blank */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Input for deactivating an enterprise contract without refund. */
export type EnterpriseContract_DeactivateWithoutRefundInput = {
  /** The enterprise contract ID to deactivate. */
  enterpriseContractId: Scalars['ID'];
};

/** Input parameters for EnterpriseContract_DowngradeContract mutation. */
export type EnterpriseContract_DowngradeContractInput = {
  /** Id of the active contract to be downgraded */
  contractId: Scalars['ID'];
  /** Flag to determine whether membership deletion notifications should be sent */
  sendMembershipDeletionNotification?: InputMaybe<Scalars['Boolean']>;
};

/** Input parameters for EnterpriseContract_EmailOptionsInput mutation. */
export type EnterpriseContract_EmailRequestInput = {
  /** Flag to specify whether orgAdmins should also receive notifications about the activation */
  includeOrgAdmins: Scalars['Boolean'];
  /** List of emails to be notified about the activation */
  recipientEmailAddresses: Array<Scalars['String']>;
};

/** Enrollment Migration Configuration specifying how enrollments should be migrated */
export const EnterpriseContract_EnrollmentMigrationConfiguration = {
  /** Migrate only active program enrollments (determined by traffic light API) to the new contract */
  Active: 'ACTIVE',
  /** Migrate only enrollments starting after a date specified by enrollmentCutoffDate */
  AfterCutoffDate: 'AFTER_CUTOFF_DATE',
  /** Migrate all program enrollments to the new contract */
  All: 'ALL',
  /** Do not migrate any program enrollments to the new contract */
  None: 'NONE',
  /** Migrate enrollments that do not consume any credits (free consumption policy) */
  OnlyFreeEnrollments: 'ONLY_FREE_ENROLLMENTS',
  /** Only migrate enrollments defined in the range of ContractEnrollmentMigrationRange.min */
  Overage: 'OVERAGE',
  /** Migrate only enrollments specified in selectedUserCourseEnrollments */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_EnrollmentMigrationConfiguration = typeof EnterpriseContract_EnrollmentMigrationConfiguration[keyof typeof EnterpriseContract_EnrollmentMigrationConfiguration];
/** Represents the options for enrollment restoration configuration. */
export const EnterpriseContract_EnrollmentRestorationConfiguration = {
  /** Represents restore all program enrollments to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program enrollments. */
  None: 'NONE'
} as const;

export type EnterpriseContract_EnrollmentRestorationConfiguration = typeof EnterpriseContract_EnrollmentRestorationConfiguration[keyof typeof EnterpriseContract_EnrollmentRestorationConfiguration];
/**
 * The housekeeping action to perform. Exactly one field must be set; supplying zero or more
 * than one is rejected.
 */
export type EnterpriseContract_HousekeepingAction = {
  /** Update the next scheduled payment date for a contract payment. */
  updateNextPaymentAt?: InputMaybe<EnterpriseContract_UpdateNextPaymentAtParams>;
  /** Update the end date of the contract's current term. */
  updateTermEndsAt?: InputMaybe<EnterpriseContract_UpdateTermEndsAtParams>;
};

/** Input for the `EnterpriseContract_Housekeeping` mutation. */
export type EnterpriseContract_HousekeepingInput = {
  /** The single housekeeping action to perform. Exactly one variant must be provided. */
  action: EnterpriseContract_HousekeepingAction;
  /** The enterprise contract ID the housekeeping action applies to. */
  contractId: Scalars['ID'];
};

/** Invitation Migration Configuration specifying how invitations should be migrated */
export const EnterpriseContract_InvitationMigrationConfiguration = {
  /** Migrate all program invitations to the new contract */
  All: 'ALL',
  /** Do not migrate any program invitations to the new contract */
  None: 'NONE'
} as const;

export type EnterpriseContract_InvitationMigrationConfiguration = typeof EnterpriseContract_InvitationMigrationConfiguration[keyof typeof EnterpriseContract_InvitationMigrationConfiguration];
/** Represents the options for invitation restoration. */
export const EnterpriseContract_InvitationRestorationConfiguration = {
  /** Represents restore all program invitation to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program invitation the a new contract */
  None: 'NONE'
} as const;

export type EnterpriseContract_InvitationRestorationConfiguration = typeof EnterpriseContract_InvitationRestorationConfiguration[keyof typeof EnterpriseContract_InvitationRestorationConfiguration];
/** Membership Migration Configuration specifying how memberships should be migrated */
export const EnterpriseContract_MembershipMigrationConfiguration = {
  /** Migrate all members that have at least one active enrollment or completed enrollment */
  Active: 'ACTIVE',
  /** Migrate all program members to the new contract */
  All: 'ALL',
  /** Do not migrate any program members to the new contract */
  None: 'NONE',
  /** Only migrate users specified in selectedUserCourseEnrollments */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_MembershipMigrationConfiguration = typeof EnterpriseContract_MembershipMigrationConfiguration[keyof typeof EnterpriseContract_MembershipMigrationConfiguration];
/** Represents the options for membership restoration. */
export const EnterpriseContract_MembershipRestorationConfiguration = {
  /** Represents only restore active program memberships to the a new contract. */
  Active: 'ACTIVE',
  /** Represents restore all program memberships to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program memberships the a new contract */
  None: 'NONE',
  /** Represents only restore users specified program memberships to the a new contract. */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_MembershipRestorationConfiguration = typeof EnterpriseContract_MembershipRestorationConfiguration[keyof typeof EnterpriseContract_MembershipRestorationConfiguration];
/** Input parameters for EnterpriseContract_PauseContract mutation. */
export type EnterpriseContract_PauseContractInput = {
  /** Id of the contract to be paused */
  contractId: Scalars['ID'];
  /** Flag to determine whether the operation should be a hard-pause or not */
  hardPause?: Scalars['Boolean'];
  /** Notes about the pause */
  notes?: InputMaybe<Scalars['String']>;
};

/** Payment item type */
export const EnterpriseContract_PaymentItemType = {
  /** Additional payment item */
  Additional: 'ADDITIONAL',
  /** Original payment item */
  Original: 'ORIGINAL'
} as const;

export type EnterpriseContract_PaymentItemType = typeof EnterpriseContract_PaymentItemType[keyof typeof EnterpriseContract_PaymentItemType];
/**
 * Names that identify price mappings for self-serve contracts, where a price mapping defines the
 * per-user cost of a contract based on the contract's courses per user limit.
 */
export const EnterpriseContract_PriceMappingNameType = {
  /**
   * The name of the price mappings introduced in December 2017 to increase the one course per user
   * price from $100 to $110.
   */
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  /**
   * The name of the price mappings used for the launch of web enabled sales, which was late
   * extended to include unlimited courses per user.
   */
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EnterpriseContract_PriceMappingNameType = typeof EnterpriseContract_PriceMappingNameType[keyof typeof EnterpriseContract_PriceMappingNameType];
/** Program Migration Configuration specifying how a program should be migrated to the new contract */
export type EnterpriseContract_ProgramMigrationConfiguration = {
  /** Enrollment cutoff date (required if enrollmentMigrationConfiguration is AFTER_CUTOFF_DATE) */
  enrollmentCutoffDate?: InputMaybe<Scalars['DateTime']>;
  /** Configuration for migrating program enrollments */
  enrollmentMigrationConfiguration: EnterpriseContract_EnrollmentMigrationConfiguration;
  /** Configuration for migrating program invitations */
  invitationMigrationConfiguration: EnterpriseContract_InvitationMigrationConfiguration;
  /** Configuration for migrating program memberships */
  membershipMigrationConfiguration: EnterpriseContract_MembershipMigrationConfiguration;
  /** The ID of the program being migrated to a new contract */
  programId: Scalars['ID'];
  /** Selected user course enrollments (required if membershipMigrationConfiguration is SELECTED and enrollmentMigrationConfiguration is SELECTED) */
  selectedUserCourseEnrollments?: InputMaybe<Array<EnterpriseContract_UserCourseEnrollment>>;
  /** Flag to skip old roster cleanup */
  skipOldRosterCleanup?: Scalars['Boolean'];
};

/** Represents a program restoration configuration when restore contract. */
export type EnterpriseContract_ProgramRestorationConfigurations = {
  /** Enrollment Restoration Configuration. */
  enrollmentRestorationConfiguration: EnterpriseContract_EnrollmentRestorationConfiguration;
  /** Invitation Restoration Configuration. */
  invitationRestorationConfiguration: EnterpriseContract_InvitationRestorationConfiguration;
  /** Membership Restoration Configuration. */
  membershipRestorationConfiguration: EnterpriseContract_MembershipRestorationConfiguration;
  /** Program ID to restore. */
  programId: Scalars['ID'];
  /** Required if membershipMigrationConfiguration = SELECTED and enrollmentMigrationConfiguration = Selected. */
  selectedUserCourseEnrollments?: InputMaybe<Array<EnterpriseContract_UserCourseEnrollment>>;
};

/** Input parameters for EnterpriseContract_ProvisioningContract mutation. */
export type EnterpriseContract_ProvisionRenewalContractInput = {
  /** Account Group of the Salesforce case, one of C4B, C4C & C4G. */
  accountGroup?: InputMaybe<EnterpriseContract_ContractAccountGroup>;
  /** Flag to determine if the original contract should be archived */
  archiveContract?: Scalars['Boolean'];
  /** The billing type for the renewed contract */
  billingType: EnterpriseContract_BillingType;
  /** The contract limits for the renewed contract */
  contractLimits: EnterpriseContract_ContractLimitsInput;
  /**
   * For a C4G accounts, there can be multiple types of deals. Null is allowed for C4B and C4C,
   * test and WES contracts.
   */
  dealType?: InputMaybe<EnterpriseContract_ContractDealType>;
  /** The duration of the renewed contract in months (optional) */
  durationInMonths?: InputMaybe<Scalars['Int']>;
  /** Flag to determine if this is a real contract or a test contract */
  isReal?: Scalars['Boolean'];
  /** A custom percentage recycling allowed in the contract. */
  licenseRecycleLimitPercent?: InputMaybe<Scalars['String']>;
  /**
   * Whether the customer has agreed to license recycle terms & conditions while signing the contract.
   * Null is allowed for the test and WES contracts
   */
  licenseRecycleTncEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The limit type for the renewed contract */
  limitType: EnterpriseContract_ContractLimitType;
  /** The name of the renewed contract (optional) */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the original contract being renewed */
  originalContractId: Scalars['ID'];
  /** Program migration configurations (optional) */
  programMigrationConfigurations?: InputMaybe<Array<EnterpriseContract_ProgramMigrationConfiguration>>;
  /** The activation date for the renewed contract (optional) */
  renewalContractActivationDate?: InputMaybe<Scalars['DateTime']>;
  /** The Salesforce case number (optional) */
  salesforceCaseNumber?: InputMaybe<Scalars['String']>;
  /** Flag to determine if membership deletion notifications should be sent */
  sendMembershipDeletionNotification?: Scalars['Boolean'];
  /** The tag for the renewed contract (optional) */
  tag?: InputMaybe<Scalars['String']>;
  /** The ID of the third-party organization */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enum representing possible errors during contract provisioning */
export const EnterpriseContract_ProvisioningError = {
  /** Renewal contract activation date cannot be in the past */
  ActivationDateInPast: 'ACTIVATION_DATE_IN_PAST',
  /** Renewal contract activation date cannot be after the original contract end date */
  ActivationDateTooFarInFuture: 'ACTIVATION_DATE_TOO_FAR_IN_FUTURE',
  /** Failed to create contract migration */
  ContractMigrationCreationFailed: 'CONTRACT_MIGRATION_CREATION_FAILED',
  /** Original contract not found */
  ContractNotFound: 'CONTRACT_NOT_FOUND',
  /** Internal error */
  InternalError: 'INTERNAL_ERROR',
  /** Renewal contract coursesPerUserLimit must be strictly greater than or equal to the original contract coursesPerUserLimit */
  InvalidCoursesPerUserLimit: 'INVALID_COURSES_PER_USER_LIMIT',
  /** Renewal contract enrollment cap limit must be strictly greater than or equal to the original enrollment cap limit */
  InvalidEnrollmentCapLimit: 'INVALID_ENROLLMENT_CAP_LIMIT',
  /** Renewal contract user limit must be strictly greater than or equal to the original contract user limit */
  InvalidUserLimit: 'INVALID_USER_LIMIT',
  /** Failed to provision the new contract */
  NewContractProvisioningFailed: 'NEW_CONTRACT_PROVISIONING_FAILED'
} as const;

export type EnterpriseContract_ProvisioningError = typeof EnterpriseContract_ProvisioningError[keyof typeof EnterpriseContract_ProvisioningError];
/**
 * Input for processing an enterprise contract refund.
 * Based on EnterpriseContractRefundRequest class in Scala.
 */
export type EnterpriseContract_RefundContractInput = {
  /**
   * Field for skipping validation in the checkout flow which includes checks like
   * determining if a refund is within the 14 day window.
   * Validations should only be bypassed for exceptional cases.
   */
  bypassValidation?: Scalars['Boolean'];
  /** The enterprise contract ID to refund. */
  enterpriseContractId: Scalars['ID'];
};

/** Represents the options for enterprise contract terminated reason type. */
export const EnterpriseContract_TerminatedReasonType = {
  /**
   * WES Contracts only.
   * Terminate the contract since it has reached its end date. Applies to legacy contracts that were
   * created with an endsAt and auto-renewable contracts that disable auto-renew and are therefore
   * updated to have an endsAt.
   */
  ContractEndDate: 'CONTRACT_END_DATE',
  /** Terminate the contract since it is manually downgraded. */
  Downgraded: 'DOWNGRADED',
  /** WES free trial contracts that have been terminated due to first payment failure at the end of the trial period. */
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  /** WES free trial contracts that have been terminated due to disabling auto-renew and reaching its end date. */
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  /** Used for terminating the contract as a side-effect if the initial invoice was voided. */
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  /** For WES contracts that fail first payment checkout. */
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  /**
   * Direct Sales Contracts only.
   * Terminate the contract since its state was migrated to a new contract.
   */
  Migrated: 'MIGRATED',
  /**
   * WES Contracts with QUARTERLY billing type only.
   * Terminate the contract after it is past the grace period for installment payment.
   */
  MissingPayment: 'MISSING_PAYMENT',
  /**
   * WES Contracts only.
   * Terminate the contract since it was refunded
   */
  Refunded: 'REFUNDED',
  /**
   * WES Contracts only.
   * Terminate the contract after it is past the grace period for renewal payment.
   */
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EnterpriseContract_TerminatedReasonType = typeof EnterpriseContract_TerminatedReasonType[keyof typeof EnterpriseContract_TerminatedReasonType];
/** Input paramaters for RestoreContractJob. */
export type EnterpriseContract_TriggerRestoreJobInput = {
  /**
   * If true, contract tag validation will not be performed during roster creation.
   * This serves the use case where IMs want to verify migration results before archiving
   * the old contract.
   */
  bypassContractTagValidation: Scalars['Boolean'];
  /** Dry Run Mode */
  isDryRun: Scalars['Boolean'];
  /** Id of the new active contract which we restore into. */
  newContractId: Scalars['ID'];
  /** Id of the old terminated contract which we restore from. */
  oldContractId: Scalars['ID'];
  /** Program Restoration Configurations */
  programRestorationConfigurations: Array<InputMaybe<EnterpriseContract_ProgramRestorationConfigurations>>;
};

/** Input parameters for EnterpriseContract_UpdateContractBillingType Mutation. */
export type EnterpriseContract_UpdateContractBillingTypeInput = {
  /** The billing type for this particular contract to be updated to */
  billingType: EnterpriseContract_BillingType;
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
};

/** Input parameters for EnterpriseContract_UpdateContractEndsAt mutation. */
export type EnterpriseContract_UpdateContractEndsAtInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract termination date/time */
  endsAt: Scalars['DateTime'];
};

/** Input parameters for EnterpriseContract_UpdateContractLimits mutation. */
export type EnterpriseContract_UpdateContractLimitsInput = {
  /**
   * A boolean flag where true implies the user's intent to change the contract limit type.
   * When false, the API will reject the request if the provided limitType does not match the
   * current contract's limit type
   */
  changeLimitType?: Scalars['Boolean'];
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract limit type for the contract to be updated to */
  contractLimitType: EnterpriseContract_ContractLimitType;
  /** Optional enterprise promotion id for upsell flows. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /**
   * Set to a positive value to set new courses per user limit. If omitted, limit will be unchanged.
   * - No value expected (omit field) for NO_LIMIT contract type
   * - To enable unlimited courses per user, Set to 0
   */
  newCoursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /**
   * The desired enrollment limit value to configure,
   * - no value expected (omit field) for NO_LIMIT, and USER_LICENSE contract types
   */
  newEnrollmentLimitValue?: InputMaybe<Scalars['Int']>;
  /**
   * The desired license limit value to configure,
   * - No value expected (omit field) for NO_LIMIT, and ENROLLMENT_CAP contract types
   */
  newUserLicenseLimitValue?: InputMaybe<Scalars['Int']>;
  /**
   * Used to update limits for WES contracts,
   * - No value expected (omit field) for direct sales contracts
   */
  updateCost?: InputMaybe<EnterpriseContract_UpdateCostInput>;
};

/** Input parameters for EnterpriseContract_UpdateContractName mutation. */
export type EnterpriseContract_UpdateContractNameInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract name for the contract to be updated to */
  name: Scalars['String'];
};

/** Input for EnterpriseContract_UpdateContractPurpose */
export type EnterpriseContract_UpdateContractPurposeInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The updated contract purpose, can be set to NULL to remove the existing value. */
  purpose?: InputMaybe<EnterpriseContract_ContractPurpose>;
};

/** Input parameters for EnterpriseContract_UpdateContractLimits mutation. */
export type EnterpriseContract_UpdateCostInput = {
  /**
   * Amount that will be paid over the remaining installments, generally calculated as: (# users added) * (# of installments remaining) * (cost / installment for course limit)
   * - Decimal number represented as String e.g "126.75"
   */
  amountDueOverInstallment: Scalars['String'];
  /**
   * Amount due immediately at time of update, calculated based off time left in the current period and the annual cost for the course limit
   * - Decimal number represented as String e.g "126.75"
   */
  amountDueToday: Scalars['String'];
  /**
   * Amount due over installment
   * - Decimal number represented as String e.g "126.75"
   */
  rawAmountDueOverInstallment?: InputMaybe<Scalars['String']>;
  /**
   * Amount due today
   * - Decimal number represented as String e.g "126.75"
   */
  rawAmountDueToday?: InputMaybe<Scalars['String']>;
};

/** Parameters for the `updateNextPaymentAt` action. */
export type EnterpriseContract_UpdateNextPaymentAtParams = {
  /** The new next-payment date to set on the payment. */
  nextPaymentAt: Scalars['DateTime'];
  /** The ID of the enterprise contract payment whose next payment date is being updated. */
  paymentId: Scalars['ID'];
};

/** Input parameters for EnterpriseContract_UpdateScheduledActivation mutation. */
export type EnterpriseContract_UpdateScheduledActivationInput = {
  /** Id of the contract to update scheduled activation */
  contractId: Scalars['ID'];
  /** Scheduled activation timestamp. Set to null to cancel scheduled activation. */
  scheduledActivationAt?: InputMaybe<Scalars['DateTime']>;
};

/** Parameters for the `updateTermEndsAt` action. */
export type EnterpriseContract_UpdateTermEndsAtParams = {
  /**
   * Number of days to add to the term's current end date.
   * The resulting end date is computed server-side as currentTermEndsAt + numberOfDays.
   * Must be positive.
   */
  numberOfDays: Scalars['Int'];
  /** ID of the term to be updated. When omitted, the contract's latest term (by start date) is used. */
  termId?: InputMaybe<Scalars['ID']>;
};

/** Represents a user course pair to identify enrollment. */
export type EnterpriseContract_UserCourseEnrollment = {
  /** When migrating ALL or NONE enrollments, the courseSlug should be empty. */
  courseSlug?: InputMaybe<Scalars['String']>;
  /** The user email for enrollment selection */
  userEmail: Scalars['String'];
};

export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Expired: 'EXPIRED',
  Paused: 'PAUSED',
  Terminated: 'TERMINATED'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = {
  ContractEndDate: 'CONTRACT_END_DATE',
  Downgraded: 'DOWNGRADED',
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  Migrated: 'MIGRATED',
  MissingPayment: 'MISSING_PAYMENT',
  Refunded: 'REFUNDED',
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = {
  SelfServe: 'SELF_SERVE',
  Standard: 'STANDARD'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType];
/** EnterpriseContract's can be paid for in a variety of different ways. The EnterpriseContractBillingSystemType is a finite list of the billing methods available for both direct sales and WES contracts. */
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = {
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  NonBillable: 'NON_BILLABLE',
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
/** Names that identify price mappings for self-serve contracts, where a price mapping defines the per-user cost of a contract based on the contract's courses per user limit. */
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = {
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = {
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag];
/** Input parameters for EnterpriseCoupon_createForRenewal mutation. */
export type EnterpriseCoupon_CreateForRenewalInput = {
  /** The ID of the enterprise contract. */
  enterpriseContractId: Scalars['ID'];
  /** The ID of the enterprise promotion. */
  enterprisePromotionId: Scalars['ID'];
};

/** One key/value pair in additionalContext. */
export type EnterpriseEmailContentGeneration_ContextEntry = {
  /** Map key */
  key: Scalars['String'];
  /** Map value */
  value: Scalars['String'];
};

/** Input for email content generation. */
export type EnterpriseEmailContentGeneration_Input = {
  /** Optional arbitrary string context as map entries (GraphQL has no native map type). */
  additionalContext?: InputMaybe<Array<EnterpriseEmailContentGeneration_ContextEntry>>;
  /** Primary admin prompt for email generation. */
  prompt: Scalars['String'];
};

/** Input for the getBestProgramToEnroll query. */
export type EnterpriseEnrollment_GetBestProgramToEnrollInput = {
  /** The third-party organization ID that scopes the program selection to a specific organization. */
  organizationId: Scalars['ID'];
  /** The ID of the product (course or specialization) the user is trying to enroll in. */
  productId: Scalars['ID'];
  /** The type of product the user is trying to enroll in. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/** Input for the getOrgAutoEnrolledCourses query. */
export type EnterpriseEnrollment_GetOrgAutoEnrolledCoursesInput = {
  /**
   * When true, only returns courses the logged-in user is actually enrolled in.
   * Defaults to false, which returns all configured auto-enrollment courses.
   */
  includeEnrolledCoursesOnly?: Scalars['Boolean'];
  /** The organization slug used to resolve all programs in the org. */
  orgSlug: Scalars['String'];
};

/** Error codes for the orgSaveProduct mutation. */
export const EnterpriseEnrollment_OrgSaveProductError = {
  /** The product is already saved (duplicate). */
  AlreadySaved: 'ALREADY_SAVED',
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** No consumable contract found for the user in this organization. */
  NoConsumableContract: 'NO_CONSUMABLE_CONTRACT',
  /** No programs found for the given organization slug. */
  ProgramNotFound: 'PROGRAM_NOT_FOUND'
} as const;

export type EnterpriseEnrollment_OrgSaveProductError = typeof EnterpriseEnrollment_OrgSaveProductError[keyof typeof EnterpriseEnrollment_OrgSaveProductError];
/** Input for saving (bookmarking) a product. */
export type EnterpriseEnrollment_OrgSaveProductInput = {
  /** Organization slug. Server resolves programId, contractId, termId, and orgId from this. */
  orgSlug: Scalars['String'];
  /** The ID of the product (course or specialization) to save. */
  productId: Scalars['ID'];
  /** The type of product to save. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/** Error codes for the orgSavedProducts query. */
export const EnterpriseEnrollment_OrgSavedProductsError = {
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** No programs found for the given organization slug. */
  ProgramNotFound: 'PROGRAM_NOT_FOUND'
} as const;

export type EnterpriseEnrollment_OrgSavedProductsError = typeof EnterpriseEnrollment_OrgSavedProductsError[keyof typeof EnterpriseEnrollment_OrgSavedProductsError];
/** Input for fetching org-scoped saved products. */
export type EnterpriseEnrollment_OrgSavedProductsInput = {
  /** Cursor for pagination. Omit for the first page. */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of results per page. Default 8. */
  limit?: Scalars['Int'];
  /** Organization slug to scope the saved products query. */
  orgSlug: Scalars['String'];
};

/** Error codes for the orgUnsaveProduct mutation. */
export const EnterpriseEnrollment_OrgUnsaveProductError = {
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The product is not currently saved. */
  NotSaved: 'NOT_SAVED'
} as const;

export type EnterpriseEnrollment_OrgUnsaveProductError = typeof EnterpriseEnrollment_OrgUnsaveProductError[keyof typeof EnterpriseEnrollment_OrgUnsaveProductError];
/** Input for removing a saved (bookmarked) product. */
export type EnterpriseEnrollment_OrgUnsaveProductInput = {
  /** Organization slug. */
  orgSlug: Scalars['String'];
  /** The ID of the product (course or specialization) to unsave. */
  productId: Scalars['ID'];
  /** The type of product to unsave. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/** Error codes for program selection failures. */
export const EnterpriseEnrollment_ProgramSelectionError = {
  /** An unexpected internal error occurred during program selection. */
  InternalError: 'INTERNAL_ERROR',
  /** The user has no program memberships. */
  NoProgramMemberships: 'NO_PROGRAM_MEMBERSHIPS',
  /** None of the user's programs offer the requested product. */
  NoProgramOffersProduct: 'NO_PROGRAM_OFFERS_PRODUCT',
  /** The caller is not authorized to perform this operation. */
  Unauthorized: 'UNAUTHORIZED'
} as const;

export type EnterpriseEnrollment_ProgramSelectionError = typeof EnterpriseEnrollment_ProgramSelectionError[keyof typeof EnterpriseEnrollment_ProgramSelectionError];
/** Product types supported by the program selection enrollment flow. */
export const EnterpriseEnrollment_ProgramSelectionProductType = {
  /** A single course product. */
  Course: 'COURSE',
  /** A specialization (s12n) product. */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseEnrollment_ProgramSelectionProductType = typeof EnterpriseEnrollment_ProgramSelectionProductType[keyof typeof EnterpriseEnrollment_ProgramSelectionProductType];
/** Reason why a particular program was selected as the best program to enroll in. */
export const EnterpriseEnrollment_ProgramSelectionReason = {
  /**
   * A program was selected based on academic integrity feature priority
   * (GradedItemLocking > Proctoring > LockingBrowser > PeerReviewAiGradingDisabled).
   */
  AcademicIntegrityPriority: 'ACADEMIC_INTEGRITY_PRIORITY',
  /** A program was selected based on course schedule priority (earliest session start date). */
  CourseSchedulePriority: 'COURSE_SCHEDULE_PRIORITY',
  /** A program was selected because it has the latest contract expiry date among candidates. */
  LatestContractExpiry: 'LATEST_CONTRACT_EXPIRY',
  /** The user is a member of exactly one program. */
  OnlyOneProgramMember: 'ONLY_ONE_PROGRAM_MEMBER',
  /** Exactly one of the user's programs offers the requested product. */
  OnlyOneProgramOffersProduct: 'ONLY_ONE_PROGRAM_OFFERS_PRODUCT'
} as const;

export type EnterpriseEnrollment_ProgramSelectionReason = typeof EnterpriseEnrollment_ProgramSelectionReason[keyof typeof EnterpriseEnrollment_ProgramSelectionReason];
/** filterOptionEntityType model */
export const EnterpriseFilterOptions_EntityType = {
  /** Contract filter option entity type */
  FilterOptionEntityTypeContract: 'FILTER_OPTION_ENTITY_TYPE_CONTRACT',
  /** Verified certificate filter option entity type */
  FilterOptionEntityTypeCourse: 'FILTER_OPTION_ENTITY_TYPE_COURSE',
  /** Invalid filter option entity type */
  FilterOptionEntityTypeInvalid: 'FILTER_OPTION_ENTITY_TYPE_INVALID',
  /** Program filter option entity type */
  FilterOptionEntityTypeProgram: 'FILTER_OPTION_ENTITY_TYPE_PROGRAM',
  /** Specialization: specialization filter option entity type */
  FilterOptionEntityTypeSpecialization: 'FILTER_OPTION_ENTITY_TYPE_SPECIALIZATION'
} as const;

export type EnterpriseFilterOptions_EntityType = typeof EnterpriseFilterOptions_EntityType[keyof typeof EnterpriseFilterOptions_EntityType];
/** enterpriseFilterOptionType model */
export const EnterpriseFilterOptions_FilterType = {
  /** Query type based on the search API on available content. */
  EnterpriseFilterOptionTypeContent: 'ENTERPRISE_FILTER_OPTION_TYPE_CONTENT',
  /** Query type based on the keyword among contractIds. */
  EnterpriseFilterOptionTypeContract: 'ENTERPRISE_FILTER_OPTION_TYPE_CONTRACT',
  /** Invalid query type. */
  EnterpriseFilterOptionTypeInvalid: 'ENTERPRISE_FILTER_OPTION_TYPE_INVALID',
  /** Query type based on the keyword among programIds. */
  EnterpriseFilterOptionTypeProgram: 'ENTERPRISE_FILTER_OPTION_TYPE_PROGRAM'
} as const;

export type EnterpriseFilterOptions_FilterType = typeof EnterpriseFilterOptions_FilterType[keyof typeof EnterpriseFilterOptions_FilterType];
/** Filter for which attempts to include in export */
export const EnterpriseGradebooks_AttemptFilter = {
  /** All attempt at the course */
  AllAttempts: 'ALL_ATTEMPTS',
  /** Only first attempt at the course */
  OnlyFirstAttempt: 'ONLY_FIRST_ATTEMPT',
  /** Only latest attempt at the course */
  OnlyLatestAttempt: 'ONLY_LATEST_ATTEMPT'
} as const;

export type EnterpriseGradebooks_AttemptFilter = typeof EnterpriseGradebooks_AttemptFilter[keyof typeof EnterpriseGradebooks_AttemptFilter];
/** Filter for completion status */
export const EnterpriseGradebooks_CompletionStatusFilter = {
  /** Include all courses */
  IncludeAll: 'INCLUDE_ALL',
  /** Include only completed courses */
  IncludeOnlyCompletedCourses: 'INCLUDE_ONLY_COMPLETED_COURSES',
  /** Include only incomplete courses */
  IncludeOnlyIncompleteCourses: 'INCLUDE_ONLY_INCOMPLETE_COURSES'
} as const;

export type EnterpriseGradebooks_CompletionStatusFilter = typeof EnterpriseGradebooks_CompletionStatusFilter[keyof typeof EnterpriseGradebooks_CompletionStatusFilter];
/** Curriculum Collection Id */
export type EnterpriseGradebooks_CurriculumCollectionId = {
  /** Program Id */
  programId: Scalars['ID'];
  /** Track Id */
  trackId: Scalars['ID'];
};

/** Input for start and end date */
export type EnterpriseGradebooks_DateRangeInput = {
  /** End Date range for export job */
  endDate: Scalars['String'];
  /** Start Date range for export job */
  startDate: Scalars['String'];
};

/** Scope for enterprise collection */
export type EnterpriseGradebooks_EnterpriseCollectionScope = {
  /** Curriculum Collection Id */
  collectionId: EnterpriseGradebooks_CurriculumCollectionId;
};

/** Input for Gradebook Export job */
export type EnterpriseGradebooks_EnterpriseItemAttemptsGradebooksInput = {
  /** Gradebook Attempt Filter */
  attemptFilter?: InputMaybe<EnterpriseGradebooks_AttemptFilter>;
  /** Course id to generate an export for a specific course */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Date range for gradebook report */
  dateRange?: InputMaybe<EnterpriseGradebooks_DateRangeInput>;
  /** Flag to include completed courses only */
  includeCompletedCoursesOnly?: InputMaybe<EnterpriseGradebooks_CompletionStatusFilter>;
  /** Flag to include deleted members */
  includeDeletedMembers?: InputMaybe<Scalars['Boolean']>;
  /** Flag to indicate if it is a plagiarism report */
  isPlagiarismReport?: InputMaybe<Scalars['Boolean']>;
  /** Flag to specify csv formatting */
  oneCsvPerProgram?: InputMaybe<Scalars['Boolean']>;
  /** Scope for export job */
  scope: EnterpriseGradebooks_Scope;
};

/** Scope for enterprise organization */
export type EnterpriseGradebooks_EnterpriseOrganizationScope = {
  /** Third PartyOrganization Id */
  organizationId: Scalars['ID'];
};

/** Scope for enterprise programs */
export type EnterpriseGradebooks_EnterpriseProgramsScope = {
  /** Array of ProgramId */
  programIds: Array<Scalars['ID']>;
};

/** Scopes for enterprise gradebook export job */
export type EnterpriseGradebooks_Scope = {
  /** Scope: Enterprise Collection */
  enterpriseCollectionGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseCollectionScope>;
  /**
   * Scope: Enterprise Organization
   * @deprecated org level export is no longer supported
   */
  enterpriseOrganizationGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseOrganizationScope>;
  /** Scope: Enterprise Program */
  enterpriseProgramsGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseProgramsScope>;
};

/** Enterprise Group Create Input */
export type EnterpriseGroup_CreateInput = {
  /** The group name */
  name: Scalars['String'];
  /** The organization the group will be created in */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enterprise Group Delete Input */
export type EnterpriseGroup_DeleteInput = {
  /** IDs of groups to delete */
  groupIds: Array<Scalars['ID']>;
  /** How to handle learners in the deleted groups */
  learnerDeletionMode: EnterpriseGroup_LearnerDeletionMode;
  /** The organization the groups belong to (used for cross-org validation) */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Learner deletion mode for group deletion */
export const EnterpriseGroup_LearnerDeletionMode = {
  /** Learners lose access to deleted groups but retain org and other group memberships */
  RemoveFromGroup: 'REMOVE_FROM_GROUP',
  /** Full org removal including All Learners with learner notification */
  RemoveFromOrg: 'REMOVE_FROM_ORG'
} as const;

export type EnterpriseGroup_LearnerDeletionMode = typeof EnterpriseGroup_LearnerDeletionMode[keyof typeof EnterpriseGroup_LearnerDeletionMode];
/** Billing schedule type enum. */
export const EnterpriseInvoice_BillingScheduleType = {
  /** Enum for enterprise invoice billing schedule type ONE_TIME for annual payments. */
  OneTime: 'ONE_TIME',
  /** Enum for enterprise invoice billing schedule type QUARTERLY for quarterly payments. */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseInvoice_BillingScheduleType = typeof EnterpriseInvoice_BillingScheduleType[keyof typeof EnterpriseInvoice_BillingScheduleType];
/** Input parameters for EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrl mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlInput = {
  /** The customer's billing address details. */
  customerAddress: EnterpriseInvoice_CustomerAddressInput;
  /** The customer's tax ID information. */
  customerTaxIdData?: InputMaybe<EnterpriseInvoice_CustomerTaxIdInput>;
  /** Optional purchase order number for the invoice. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Self Serve Invoice Payload */
  selfServeInvoiceDetails: EnterpriseInvoice_CreateSelfServeInvoiceInput;
};

/** Input parameters for EnterpriseInvoice_CreateSelfServeInvoice mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceInput = {
  /** The billing currency code. */
  billingCurrency: Scalars['String'];
  /** The billing schedule type. */
  billingScheduleType: EnterpriseInvoice_BillingScheduleType;
  /** The contact email for the invoice. */
  contactEmail: Scalars['String'];
  /** The country ISO code. */
  countryIsoCode: Scalars['String'];
  /** The existing organization ID. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** The number of licenses to purchase. */
  numberOfLicenses: Scalars['Int'];
  /** The offer code to apply. */
  offerCode?: InputMaybe<Scalars['String']>;
  /** The name of the organization. */
  organizationName?: InputMaybe<Scalars['String']>;
  /** The type of organization. */
  organizationType?: InputMaybe<EnterpriseInvoice_OrganizationType>;
  /** The user ID of the user who is purchasing the licenses. */
  purchaseUserId?: InputMaybe<Scalars['ID']>;
  /** Testing options for the invoice. */
  testingOptions?: InputMaybe<EnterpriseInvoice_TestingOptionsInput>;
};

/** Customer address information for invoicing. */
export type EnterpriseInvoice_CustomerAddressInput = {
  /** The customer's city. */
  city: Scalars['String'];
  /** The customer's country (ISO country code). */
  country: Scalars['String'];
  /** First line of the customer's address. */
  line1: Scalars['String'];
  /** Optional second line of the customer's address. */
  line2?: InputMaybe<Scalars['String']>;
  /** The customer's postal code. */
  postalCode: Scalars['String'];
  /** The customer's state or province. */
  state: Scalars['String'];
};

/** Customer tax ID information for invoicing. */
export type EnterpriseInvoice_CustomerTaxIdInput = {
  /** The customer's tax ID number. */
  taxId: Scalars['ID'];
  /** The type of tax ID. */
  taxIdType: Scalars['String'];
};

/** Organization type enum. */
export const EnterpriseInvoice_OrganizationType = {
  /** Enum for enterprise organization BUSINESS type. */
  Business: 'BUSINESS',
  /** Enum for enterprise organization GOVERNMENT type. */
  Government: 'GOVERNMENT',
  /** Enum for enterprise organization NON_PROFIT type. */
  NonProfit: 'NON_PROFIT',
  /** Enum for enterprise organization OTHER type. */
  Other: 'OTHER',
  /** Enum for enterprise organization UNIVERSITY type. */
  University: 'UNIVERSITY'
} as const;

export type EnterpriseInvoice_OrganizationType = typeof EnterpriseInvoice_OrganizationType[keyof typeof EnterpriseInvoice_OrganizationType];
/** Testing options for the invoice. */
export type EnterpriseInvoice_TestingOptionsInput = {
  /** Whether to create a fake organization. */
  createFakeOrg?: InputMaybe<Scalars['Boolean']>;
  /** Whether to use sandbox mode. */
  sandbox?: InputMaybe<Scalars['Boolean']>;
};

/** Input parameters for EnterpriseLead_CreateLead mutation. */
export type EnterpriseLead_CreateLeadInput = {
  /** The enterprise lead details. */
  enterpriseLead: EnterpriseLead_DetailsInput;
  /** Flag to skip storing the lead. */
  skipStore?: Scalars['Boolean'];
  /** Flag to skip Zapier integration. */
  skipZapier?: Scalars['Boolean'];
};

/** Input type for EnterpriseLead. */
export type EnterpriseLead_DetailsInput = {
  /** Billing address for the enterprise lead. */
  billingAddress?: InputMaybe<EnterpriseLead_EnterpriseLeadBillingAddressInput>;
  /** Contact information for the enterprise lead. */
  contact: EnterpriseLead_EnterpriseLeadContactInput;
  /** created at time */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Type of enterprise contract. */
  leadType: EnterpriseLead_EnterpriseLeadType;
  /** Organization details for the enterprise lead. */
  organization: EnterpriseLead_EnterpriseLeadOrganizationInput;
  /** Additional properties for the enterprise lead. */
  properties?: InputMaybe<EnterpriseLead_EnterpriseLeadPropertiesInput>;
  /** Source of the enterprise lead. */
  source: EnterpriseLead_EnterpriseLeadSource;
  /** Transaction type of the enterprise lead. */
  transactionType: EnterpriseLead_EnterpriseLeadTransactionType;
};

/** Enum for enterprise contract billing types. */
export const EnterpriseLead_EnterpriseContractBillingType = {
  /** Enum for enterprise lead contract billing type INVOICE */
  Invoice: 'INVOICE',
  /** Enum for enterprise lead contract billing type NONE */
  None: 'NONE',
  /** Enum for enterprise lead contract billing type ONE_TIME */
  OneTime: 'ONE_TIME',
  /** Enum for enterprise lead contract billing type QUARTERLY */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseLead_EnterpriseContractBillingType = typeof EnterpriseLead_EnterpriseContractBillingType[keyof typeof EnterpriseLead_EnterpriseContractBillingType];
/** Input type for EnterpriseContractLimits. */
export type EnterpriseLead_EnterpriseContractLimitsInput = {
  /** Courses per user limit for the contract. */
  coursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /** Enrollment cap limit for the contract. */
  enrollmentCapLimit?: InputMaybe<Scalars['Int']>;
  /** User limit for the contract. */
  userLimit?: InputMaybe<Scalars['Int']>;
};

/** type for EnterpriseLeadBillingAddress. */
export type EnterpriseLead_EnterpriseLeadBillingAddressInput = {
  /** Country of the billing address. */
  country?: InputMaybe<Scalars['String']>;
  /** Postal code of the billing address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State of the billing address. */
  state?: InputMaybe<Scalars['String']>;
};

/** Input type for EnterpriseLeadContact. */
export type EnterpriseLead_EnterpriseLeadContactInput = {
  /** Department of the contact. */
  department?: InputMaybe<Scalars['String']>;
  /** Email address of the contact. */
  email?: InputMaybe<Scalars['String']>;
  /** Hashed email of the contact. */
  emailHash?: InputMaybe<Scalars['String']>;
  /** Full name of the contact. */
  fullName?: InputMaybe<Scalars['String']>;
  /** IP address of the contact. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Job title of the contact. */
  title?: InputMaybe<Scalars['String']>;
  /** User ID of the contact. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Input type for EnterpriseLeadContractPrice. */
export type EnterpriseLead_EnterpriseLeadContractPriceInput = {
  /** Annual contract value. */
  annualContractValue?: InputMaybe<Scalars['String']>;
  /** Currency code for the contract price. */
  currencyCode: Scalars['String'];
  /** Total payment amount for the contract. */
  paymentTotal: Scalars['String'];
};

/** Input type for EnterpriseLeadOrganization. */
export type EnterpriseLead_EnterpriseLeadOrganizationInput = {
  /** Name of the organization. */
  name: Scalars['String'];
  /** Size category of the organization. */
  sizeCategory?: InputMaybe<EnterpriseLead_EnterpriseLeadOrganizationSizeCategory>;
  /** Type of the organization. */
  type?: InputMaybe<EnterpriseLead_EnterpriseLeadOrganizationType>;
};

/** Enum for enterprise lead organization size categories. */
export const EnterpriseLead_EnterpriseLeadOrganizationSizeCategory = {
  /** Enum for enterprise lead organization size type 1_500. */
  Size_1_500: 'SIZE_1_500',
  /** Enum for enterprise lead organization size type 501_1000. */
  Size_501_1000: 'SIZE_501_1000',
  /** Enum for enterprise lead organization size type 1001_5000 */
  Size_1001_5000: 'SIZE_1001_5000',
  /** Enum for enterprise lead organization size type 5001_15000 */
  Size_5001_15000: 'SIZE_5001_15000',
  /** Enum for enterprise lead organization size type 15000_PLUS */
  Size_15000Plus: 'SIZE_15000_PLUS'
} as const;

export type EnterpriseLead_EnterpriseLeadOrganizationSizeCategory = typeof EnterpriseLead_EnterpriseLeadOrganizationSizeCategory[keyof typeof EnterpriseLead_EnterpriseLeadOrganizationSizeCategory];
/** Enum for enterprise lead organization types. */
export const EnterpriseLead_EnterpriseLeadOrganizationType = {
  /** Enum for enterprise lead organization BUSINESS type. */
  Business: 'BUSINESS',
  /** Enum for enterprise lead organization GOVERNMENT type. */
  Government: 'GOVERNMENT',
  /** Enum for enterprise lead organization NON_PROFIT type. */
  NonProfit: 'NON_PROFIT',
  /** Enum for enterprise lead organization OTHER type. */
  Other: 'OTHER',
  /** Enum for enterprise lead organization UNIVERSITY type. */
  University: 'UNIVERSITY'
} as const;

export type EnterpriseLead_EnterpriseLeadOrganizationType = typeof EnterpriseLead_EnterpriseLeadOrganizationType[keyof typeof EnterpriseLead_EnterpriseLeadOrganizationType];
/** input for EnterpriseLeadProperties. */
export type EnterpriseLead_EnterpriseLeadPropertiesInput = {
  /** Self-serve properties for the enterprise lead. */
  selfServeProperties?: InputMaybe<EnterpriseLead_EnterpriseLeadSelfServePropertiesInput>;
};

/** Input type for EnterpriseLeadSelfServeProperties. */
export type EnterpriseLead_EnterpriseLeadSelfServePropertiesInput = {
  /** Billing type for self-serve properties. */
  billingType?: InputMaybe<EnterpriseLead_EnterpriseContractBillingType>;
  /** Contract ID for self-serve properties. */
  contractId?: InputMaybe<Scalars['ID']>;
  /** Contract limits for self-serve properties. */
  contractLimits?: InputMaybe<EnterpriseLead_EnterpriseContractLimitsInput>;
  /** Contract price for self-serve properties. */
  contractPrice?: InputMaybe<EnterpriseLead_EnterpriseLeadContractPriceInput>;
};

/** Enum for enterprise lead sources. */
export const EnterpriseLead_EnterpriseLeadSource = {
  /** Enterprise lead source type ENTERPRISE_INTEREST_FORM */
  EnterpriseInterestForm: 'ENTERPRISE_INTEREST_FORM',
  /** Enterprise lead source type WEB_ENABLED_SALES */
  WebEnabledSales: 'WEB_ENABLED_SALES',
  /** Enterprise lead source type WEB_ENABLED_SALES_ACCOUNT_DETAILS */
  WebEnabledSalesAccountDetails: 'WEB_ENABLED_SALES_ACCOUNT_DETAILS',
  /** Enterprise lead source type WEB_ENABLED_SALES_BILLING_INFO */
  WebEnabledSalesBillingInfo: 'WEB_ENABLED_SALES_BILLING_INFO',
  /** Enterprise lead source type WEB_ENABLED_SALES_PLAN_DETAILS */
  WebEnabledSalesPlanDetails: 'WEB_ENABLED_SALES_PLAN_DETAILS'
} as const;

export type EnterpriseLead_EnterpriseLeadSource = typeof EnterpriseLead_EnterpriseLeadSource[keyof typeof EnterpriseLead_EnterpriseLeadSource];
/** Enum for enterprise lead transaction types. */
export const EnterpriseLead_EnterpriseLeadTransactionType = {
  /** Enterprise lead transaction type for an active free trial. */
  FreeTrialActive: 'FREE_TRIAL_ACTIVE',
  /** Enterprise lead transaction type for a free trial checkout that has started. */
  FreeTrialCheckoutStarted: 'FREE_TRIAL_CHECKOUT_STARTED',
  /** Enterprise lead transaction type for a free trial that converted to paid. */
  FreeTrialConvertedToPaid: 'FREE_TRIAL_CONVERTED_TO_PAID',
  /** Enterprise lead transaction type for a terminated free trial. */
  FreeTrialTerminated: 'FREE_TRIAL_TERMINATED',
  /** Enterprise lead transaction type for a paid transaction. */
  Paid: 'PAID',
  /** Enterprise lead transaction type for a standard checkout that has started. */
  StandardCheckoutStarted: 'STANDARD_CHECKOUT_STARTED'
} as const;

export type EnterpriseLead_EnterpriseLeadTransactionType = typeof EnterpriseLead_EnterpriseLeadTransactionType[keyof typeof EnterpriseLead_EnterpriseLeadTransactionType];
/** Enum for enterprise lead types. */
export const EnterpriseLead_EnterpriseLeadType = {
  /** Enterprise lead type for a self serve checkout */
  SelfServe: 'SELF_SERVE',
  /** Enterprise lead type for a standard checkout */
  Standard: 'STANDARD'
} as const;

export type EnterpriseLead_EnterpriseLeadType = typeof EnterpriseLead_EnterpriseLeadType[keyof typeof EnterpriseLead_EnterpriseLeadType];
/**
 * Authentication context for a cohort request. Mirrors EnterpriseLearnerCohortAuthContext
 * in the gRPC API.
 */
export type EnterpriseLearnerCohort_AuthContextInput = {
  /** Enterprise organization ID the cohort is scoped to. */
  orgId: Scalars['ID'];
};

/**
 * Input for creating and immediately fetching an enterprise learner cohort.
 * Structurally identical to EnterpriseLearnerCohort_CreateInput; named separately to satisfy
 * the schema input-name convention (each mutation's input must match the mutation name).
 */
export type EnterpriseLearnerCohort_CreateAndFetchInput = {
  /** Authentication context identifying the enterprise organization. */
  authContext: EnterpriseLearnerCohort_AuthContextInput;
  /** Natural-language description of the cohort. */
  nlq: Scalars['String'];
  /** Optional program scope. When omitted, the caller's RBAC-allowed programs are applied. */
  sessionFilters?: InputMaybe<EnterpriseLearnerCohort_SessionFiltersInput>;
};

/** Input for creating an enterprise learner cohort. */
export type EnterpriseLearnerCohort_CreateInput = {
  /** Authentication context identifying the enterprise organization. */
  authContext: EnterpriseLearnerCohort_AuthContextInput;
  /**
   * Natural-language description of the cohort, e.g. "inactive learners in the past 30
   * days" or "learners who completed a course in Q1".
   */
  nlq: Scalars['String'];
  /** Optional program scope. When omitted, the caller's RBAC-allowed programs are applied. */
  sessionFilters?: InputMaybe<EnterpriseLearnerCohort_SessionFiltersInput>;
};

/**
 * Optional program scope for a cohort. When sessionFilters is omitted or programIds is
 * empty, the caller's RBAC-allowed programs are applied (org-wide for org admins). Mirrors
 * EnterpriseLearnerCohortSessionFilters in the gRPC API.
 */
export type EnterpriseLearnerCohort_SessionFiltersInput = {
  /** Restrict the cohort to these programs. Empty or omitted means org-wide scope. */
  programIds?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Status of a cohort creation request. Mirrors EnterpriseLearnerCohortStatus in the
 * Analytics Control Plane gRPC API.
 */
export const EnterpriseLearnerCohort_Status = {
  /**
   * The natural-language query was ambiguous; refine it and try again. No cohort was
   * persisted.
   */
  DisambiguationNeeded: 'DISAMBIGUATION_NEEDED',
  /** The request failed; see error for the structured cause. */
  Error: 'ERROR',
  /** The cohort was created successfully; learners are available via fetchEnterpriseLearnerCohorts. */
  Success: 'SUCCESS'
} as const;

export type EnterpriseLearnerCohort_Status = typeof EnterpriseLearnerCohort_Status[keyof typeof EnterpriseLearnerCohort_Status];
/** Input for deleting all enterprise learner profiles in an organization. */
export type EnterpriseLearnerProfile_DeleteAllByOrganizationInput = {
  /** Organization ID */
  organizationId: Scalars['ID'];
};

/** Input for deleting enterprise learner profiles by organization and emails. */
export type EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsInput = {
  /** List of emails */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
};

export const EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState = {
  DeletedMember: 'DELETED_MEMBER',
  Invited: 'INVITED',
  InvitedEmailNotVerified: 'INVITED_EMAIL_NOT_VERIFIED',
  Member: 'MEMBER',
  NotMember: 'NOT_MEMBER',
  SoftDeletedMember: 'SOFT_DELETED_MEMBER',
  Whitelisted: 'WHITELISTED'
} as const;

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState = typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState[keyof typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState];
export const EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole = {
  DerivedProgramAdmin: 'DERIVED_PROGRAM_ADMIN',
  Member: 'MEMBER',
  ProgramAdmin: 'PROGRAM_ADMIN'
} as const;

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole = typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole[keyof typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole];
export const EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Inactive: 'INACTIVE'
} as const;

export type EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus = typeof EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus[keyof typeof EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus];
/** The ID of the call to action in an enterprise learner communication. */
export const EnterpriseMessages_CallToActionType = {
  /** Call to action is Continue Learning */
  ContinueLearning: 'CONTINUE_LEARNING',
  /** Call to action is Do Not Include */
  DoNotInclude: 'DO_NOT_INCLUDE',
  /** Call to action is Find a Course */
  FindACourse: 'FIND_A_COURSE',
  /** Call to action is Join Program */
  JoinProgram: 'JOIN_PROGRAM'
} as const;

export type EnterpriseMessages_CallToActionType = typeof EnterpriseMessages_CallToActionType[keyof typeof EnterpriseMessages_CallToActionType];
/** Input for EnterpriseMessages_GenerateUploadLocForManualList. */
export type EnterpriseMessages_GenerateUploadLocForManualListInput = {
  /** Enterprise organization ID for the upload context. */
  organizationId: Scalars['ID'];
};

/** The set of possible statuses for a sent triggered message. */
export const EnterpriseMessages_SentTriggeredMessageStatus = {
  /** Indicates message is in progress */
  InProgress: 'IN_PROGRESS',
  /** Indicates message has been sent */
  MessageSent: 'MESSAGE_SENT'
} as const;

export type EnterpriseMessages_SentTriggeredMessageStatus = typeof EnterpriseMessages_SentTriggeredMessageStatus[keyof typeof EnterpriseMessages_SentTriggeredMessageStatus];
/** Input to delete the roles for a specific user for an org */
export type EnterprisePermission_DeleteAdminInput = {
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Parameter for the domain slug */
export type EnterprisePermission_DomainSlugInput = {
  /** Query organization-domain permissions for an organization */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Query program-domain permissions for a program */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Feature type permissions */
export type EnterprisePermission_FeatureTypePermissionInput = {
  /** Feature domain */
  domain: EnterprisePermission_PermissionDomain;
  /** Optional subdomain */
  subdomain?: InputMaybe<Scalars['String']>;
  /** Feature verb */
  verb: Scalars['String'];
};

/** Possible domains of a feature type permission */
export const EnterprisePermission_PermissionDomain = {
  /** Organization domain */
  PermissionDomainOrganization: 'PERMISSION_DOMAIN_ORGANIZATION',
  /** Program domain */
  PermissionDomainProgram: 'PERMISSION_DOMAIN_PROGRAM'
} as const;

export type EnterprisePermission_PermissionDomain = typeof EnterprisePermission_PermissionDomain[keyof typeof EnterprisePermission_PermissionDomain];
/** Role domain */
export type EnterprisePermission_RoleDomainInput = {
  /** The ID of the domain type that the role is being applied for */
  id: Scalars['ID'];
  /** The domain that the above ID relates to */
  roleDomainType: EnterprisePermission_PermissionDomain;
};

/** Universal role enum, the graphql equivalent of coursera.proto.enterprisepermissions.shared.v1beta1.UniversalRole */
export const EnterprisePermission_UniversalRole = {
  /** Mentor */
  UniversalRoleMentor: 'UNIVERSAL_ROLE_MENTOR',
  /** Organization admin */
  UniversalRoleOrganizationAdmin: 'UNIVERSAL_ROLE_ORGANIZATION_ADMIN',
  /** Program admin */
  UniversalRoleProgramAdmin: 'UNIVERSAL_ROLE_PROGRAM_ADMIN',
  /** Recruiter */
  UniversalRoleRecruiter: 'UNIVERSAL_ROLE_RECRUITER',
  /** Restricted admin A.K.A Staff admin */
  UniversalRoleRestrictedAdmin: 'UNIVERSAL_ROLE_RESTRICTED_ADMIN'
} as const;

export type EnterprisePermission_UniversalRole = typeof EnterprisePermission_UniversalRole[keyof typeof EnterprisePermission_UniversalRole];
/** Input to update the roles associated with an user */
export type EnterprisePermission_UpdateUserRolesInput = {
  /** Domain */
  domains: Array<EnterprisePermission_RoleDomainInput>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Role template id */
  templateId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Search preset for plagiarism report list */
export const EnterprisePlagiarismReport_PlagiarismReportUsersPreset = {
  /** Appeal denied */
  AppealDenied: 'APPEAL_DENIED',
  /** Appeal granted */
  AppealGranted: 'APPEAL_GRANTED',
  /** Appeal submitted */
  AppealSubmitted: 'APPEAL_SUBMITTED',
  /** Plagiarized */
  Plagiarized: 'PLAGIARIZED'
} as const;

export type EnterprisePlagiarismReport_PlagiarismReportUsersPreset = typeof EnterprisePlagiarismReport_PlagiarismReportUsersPreset[keyof typeof EnterprisePlagiarismReport_PlagiarismReportUsersPreset];
/** Input for AddToProgram mutation */
export type EnterprisePrivateCourses_AddToProgramInput = {
  /**
   * ID of the collection in the program if the user is adding the course to a specific collection.
   * Otherwise it will create a new default collection if none is specified.
   */
  collectionId?: InputMaybe<Scalars['ID']>;
  /** ID of the course being added. */
  courseId: Scalars['ID'];
  /** ID of the program that the course is intended to be added to. */
  programId: Scalars['ID'];
};

export const EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus = {
  Failed: 'FAILED',
  Processing: 'PROCESSING'
} as const;

export type EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus = typeof EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus[keyof typeof EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus];
export const EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus = {
  ContentAndMembers: 'CONTENT_AND_MEMBERS',
  ContentOnly: 'CONTENT_ONLY',
  MembersOnly: 'MEMBERS_ONLY',
  NoContentOrMembers: 'NO_CONTENT_OR_MEMBERS'
} as const;

export type EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus = typeof EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus[keyof typeof EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus];
/** Program membership states */
export const EnterpriseProgramMemberships_ProgramMembershipState = {
  /** TODO: Complete this description */
  ProgramMembershipStateAllowlisted: 'PROGRAM_MEMBERSHIP_STATE_ALLOWLISTED',
  /** TODO: Complete this description */
  ProgramMembershipStateDeletedMember: 'PROGRAM_MEMBERSHIP_STATE_DELETED_MEMBER',
  /** TODO: Complete this description */
  ProgramMembershipStateInvalid: 'PROGRAM_MEMBERSHIP_STATE_INVALID',
  /** TODO: Complete this description */
  ProgramMembershipStateInvited: 'PROGRAM_MEMBERSHIP_STATE_INVITED',
  /** TODO: Complete this description */
  ProgramMembershipStateMember: 'PROGRAM_MEMBERSHIP_STATE_MEMBER',
  /** TODO: Complete this description */
  ProgramMembershipStateSoftDeletedMember: 'PROGRAM_MEMBERSHIP_STATE_SOFT_DELETED_MEMBER'
} as const;

export type EnterpriseProgramMemberships_ProgramMembershipState = typeof EnterpriseProgramMemberships_ProgramMembershipState[keyof typeof EnterpriseProgramMemberships_ProgramMembershipState];
/** Enterprise Program Archive input */
export type EnterpriseProgram_ArchiveInput = {
  /** Flag to set whether to run programArchiveCleanup job */
  includeCleanup: Scalars['Boolean'];
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** Flag to set sendMembershipDeletionNotificationflag param in programArchiveCleanup job */
  sendMembershipDeletionNotification: Scalars['Boolean'];
};

/** Reason why content access validation failed. */
export const EnterpriseProgram_ContentAccessFailureReason = {
  /** Programs have different content access restrictions and cannot be used together. */
  CrossGroupMismatch: 'CROSS_GROUP_MISMATCH',
  /** No failure — all programs share the same content access. */
  None: 'NONE'
} as const;

export type EnterpriseProgram_ContentAccessFailureReason = typeof EnterpriseProgram_ContentAccessFailureReason[keyof typeof EnterpriseProgram_ContentAccessFailureReason];
/** Enterprise Program Create Input */
export type EnterpriseProgram_CreateInput = {
  /** The program contract ID */
  contractId?: InputMaybe<Scalars['ID']>;
  /** The program curriculum ID */
  curriculumId?: InputMaybe<Scalars['ID']>;
  /** The program default to empty tracks curriculum flag */
  defaultToEmptyTracksCurriculum?: Scalars['Boolean'];
  /** The program landing page banner */
  landingPageBanner?: InputMaybe<Scalars['String']>;
  /** The program logo */
  logo?: InputMaybe<Scalars['URL']>;
  /** The program maximum courses per user */
  maxCoursesPerUser?: InputMaybe<Scalars['Int']>;
  /** The program name */
  name: Scalars['String'];
  /** The program slug */
  slug?: InputMaybe<Scalars['String']>;
  /** The program tagline */
  tagline?: InputMaybe<Scalars['String']>;
  /** The organization the program will be linked to */
  thirdPartyOrganizationId: Scalars['ID'];
  /** The program tutorial video asset id */
  tutorialVideoAssetId?: InputMaybe<Scalars['ID']>;
};

/** Curation item type for the curation */
export const EnterpriseProgram_CurationItemType = {
  /** Course */
  Course: 'COURSE',
  /** Guided Project */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional Certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project */
  Project: 'PROJECT',
  /** Specialization */
  Specialization: 'SPECIALIZATION',
  /** Video */
  Video: 'VIDEO'
} as const;

export type EnterpriseProgram_CurationItemType = typeof EnterpriseProgram_CurationItemType[keyof typeof EnterpriseProgram_CurationItemType];
/** Curation options for the program */
export const EnterpriseProgram_CurationOrganization = {
  /** Roles */
  Roles: 'ROLES',
  /** Skills */
  Skills: 'SKILLS'
} as const;

export type EnterpriseProgram_CurationOrganization = typeof EnterpriseProgram_CurationOrganization[keyof typeof EnterpriseProgram_CurationOrganization];
/** List of roles or skills selected by the admin for the program */
export type EnterpriseProgram_CurationSelection = {
  /** List of roles the admin selected to be relevant to the program */
  roles?: InputMaybe<Array<Scalars['String']>>;
  /** List of skills the admin selected to be relevant to the program */
  skills?: InputMaybe<Array<Scalars['String']>>;
};

/** Curation type for the program */
export const EnterpriseProgram_CurationType = {
  /** Collections */
  Collections: 'COLLECTIONS',
  /** Learning Paths */
  LearningPaths: 'LEARNING_PATHS'
} as const;

export type EnterpriseProgram_CurationType = typeof EnterpriseProgram_CurationType[keyof typeof EnterpriseProgram_CurationType];
/** Errors for the  EnterpriseProgram_GenerateProgramFileUploadLocation */
export const EnterpriseProgram_FileLocationErrors = {
  /** Invalid file type */
  InvalidFileType: 'INVALID_FILE_TYPE',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_FileLocationErrors = typeof EnterpriseProgram_FileLocationErrors[keyof typeof EnterpriseProgram_FileLocationErrors];
/** Enterprise Program Generate Outline Generate Request Input */
export type EnterpriseProgram_GenerateProgramContext = {
  /** The S3 object of the files uploaded by the user */
  files?: InputMaybe<Array<EnterpriseProgram_GenerateProgramS3FileInput>>;
  /** The optional prompt used to generate the outline */
  prompt?: InputMaybe<Scalars['String']>;
};

/** Input for EnterpriseProgram_GenerateProgramFileUploadLocation */
export type EnterpriseProgram_GenerateProgramFileUploadLocationInput = {
  /** File name */
  fileName: Scalars['String'];
  /** The existing ID of the program if just adding to a program */
  programId?: InputMaybe<Scalars['ID']>;
  /** Org ID related to program generation. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enterprise Program Generate Outline Input */
export type EnterpriseProgram_GenerateProgramOutlineInput = {
  /** Information needed to generate the program outline given by the user, either a prompt or files */
  context?: InputMaybe<EnterpriseProgram_GenerateProgramContext>;
  /** The 2 letter code of the language of the program ex. "EN" or "ES" */
  language?: InputMaybe<Scalars['String']>;
  /** The existing ID of the program if just adding to a program */
  programId?: InputMaybe<Scalars['ID']>;
  /** The organization the program will be linked to, used for auth */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** S3 file location as an input */
export type EnterpriseProgram_GenerateProgramS3FileInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
};

/** Enterprise Program Generate Suggestions Input */
export type EnterpriseProgram_GenerateProgramSuggestionsInput = {
  /** Updated information needed to generate the program outline given by the user, either a prompt or files */
  context?: InputMaybe<EnterpriseProgram_GenerateProgramContext>;
  /** The curation item types for the Collection or Learning Path */
  curationItemTypes?: InputMaybe<Array<EnterpriseProgram_CurationItemType>>;
  /** The curation options for the program Skills or Roles */
  curationOrganization: EnterpriseProgram_CurationOrganization;
  /** List of roles or skills selected by the admin for the program */
  curationSelections: EnterpriseProgram_CurationSelection;
  /** The curation type for the program Collections or Learning Paths */
  curationType: EnterpriseProgram_CurationType;
  /** Generated description of the program */
  description: Scalars['String'];
  /** The 2 letter code of the language of the program ex. "EN" or "ES" */
  language?: InputMaybe<Scalars['String']>;
  /** The desired length of the learning path in number of hours */
  learningPathLengthInHours?: InputMaybe<Scalars['Int']>;
  /** Generated name of the program */
  name: Scalars['String'];
  /** The program id to get the Generation Request */
  programId: Scalars['ID'];
};

/** Errors enum for  Generate Suggestions */
export const EnterpriseProgram_GenerateSuggestionsErrors = {
  /** Job trigger failed */
  JobFailedToTrigger: 'JOB_FAILED_TO_TRIGGER',
  /** Distributed lock is locked */
  RequestAlreadyInProgress: 'REQUEST_ALREADY_IN_PROGRESS',
  /** Request not found */
  RequestNotFound: 'REQUEST_NOT_FOUND',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_GenerateSuggestionsErrors = typeof EnterpriseProgram_GenerateSuggestionsErrors[keyof typeof EnterpriseProgram_GenerateSuggestionsErrors];
/** Generation Errors for the program generation */
export const EnterpriseProgram_GenerationErrors = {
  /** Generation failed */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_GenerationErrors = typeof EnterpriseProgram_GenerationErrors[keyof typeof EnterpriseProgram_GenerationErrors];
/** Generation Status for the program generation */
export const EnterpriseProgram_GenerationStatus = {
  /** Suggestions generated */
  Completed: 'COMPLETED',
  /** Generation failed */
  Failed: 'FAILED',
  /** Outline generated */
  GeneratedOutline: 'GENERATED_OUTLINE',
  /** Generating the outline */
  GeneratingOutline: 'GENERATING_OUTLINE',
  /** Generating suggestions */
  GeneratingSuggestions: 'GENERATING_SUGGESTIONS'
} as const;

export type EnterpriseProgram_GenerationStatus = typeof EnterpriseProgram_GenerationStatus[keyof typeof EnterpriseProgram_GenerationStatus];
/** Errors for the  EnterpriseProgram_LinkProgramWithGenerationRequests */
export const EnterpriseProgram_LinkProgramWithGenerationErrors = {
  /** Request not found */
  RequestNotFound: 'REQUEST_NOT_FOUND',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_LinkProgramWithGenerationErrors = typeof EnterpriseProgram_LinkProgramWithGenerationErrors[keyof typeof EnterpriseProgram_LinkProgramWithGenerationErrors];
/** Enterprise Program Link Program with request Input */
export type EnterpriseProgram_LinkProgramWithGenerationRequestsInput = {
  /** Id of the request to link to the initial request */
  programCreateRequestId: Scalars['ID'];
  /** The program id to get the Generation Request */
  programId: Scalars['ID'];
};

/** Type of content item in a skill profile collection. */
export const EnterpriseProgram_SkillProfileItemType = {
  /** A course content item. */
  Course: 'COURSE',
  /** A specialization content item. */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseProgram_SkillProfileItemType = typeof EnterpriseProgram_SkillProfileItemType[keyof typeof EnterpriseProgram_SkillProfileItemType];
/** Enum for skillset availability type associated with the program */
export const EnterpriseProgram_SkillsetAvailabilityType = {
  /** Program has all skillsets linked */
  SkillSetAvailabilityTypeAllSkillsets: 'SKILL_SET_AVAILABILITY_TYPE_ALL_SKILLSETS',
  /** Invalid */
  SkillSetAvailabilityTypeInvalid: 'SKILL_SET_AVAILABILITY_TYPE_INVALID',
  /** Program has specific skillsets linked to them */
  SkillSetAvailabilityTypeLinkedSkillsetsOnly: 'SKILL_SET_AVAILABILITY_TYPE_LINKED_SKILLSETS_ONLY'
} as const;

export type EnterpriseProgram_SkillsetAvailabilityType = typeof EnterpriseProgram_SkillsetAvailabilityType[keyof typeof EnterpriseProgram_SkillsetAvailabilityType];
/** Enum for skillset update mode */
export const EnterpriseProgram_SkillsetUpdateMode = {
  /** Append mode */
  SkillsetsUpdateModeAppend: 'SKILLSETS_UPDATE_MODE_APPEND',
  /** Invalid */
  SkillsetsUpdateModeInvalid: 'SKILLSETS_UPDATE_MODE_INVALID',
  /** Remove mode */
  SkillsetsUpdateModeRemove: 'SKILLSETS_UPDATE_MODE_REMOVE',
  /** Reorder mode */
  SkillsetsUpdateModeReorder: 'SKILLSETS_UPDATE_MODE_REORDER'
} as const;

export type EnterpriseProgram_SkillsetUpdateMode = typeof EnterpriseProgram_SkillsetUpdateMode[keyof typeof EnterpriseProgram_SkillsetUpdateMode];
/** Enterprise Program Update input */
export type EnterpriseProgram_UpdateInput = {
  /** Contract Id associated with the program. */
  contractId?: InputMaybe<Scalars['ID']>;
  /** The curriculum tied to the program. */
  curriculumId: Scalars['ID'];
  /** The program description */
  description?: InputMaybe<Scalars['String']>;
  /** The time at which the program ended */
  endedAt?: InputMaybe<Scalars['DateTime']>;
  /** The url for the landing page banner image */
  landingPageBanner?: InputMaybe<Scalars['String']>;
  /** The time at which the program is launched */
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  /** Academic Discipline ID linked to the program */
  linkedAcademicDisciplineIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Skillset IDs linked to the program */
  linkedTargetSkillProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The logo for the program. */
  logo?: InputMaybe<Scalars['URL']>;
  /** The maximum number of courses an individual learner can enroll in */
  maxCoursesPerUser?: InputMaybe<Scalars['Int']>;
  /** The program slug */
  name: Scalars['String'];
  /** Primary color for the program */
  primaryColor?: InputMaybe<Scalars['String']>;
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** Rectangular logo for the program */
  rectangularLogo?: InputMaybe<Scalars['URL']>;
  /** Skillset availability type for the program */
  skillsetAvailabilityType?: InputMaybe<EnterpriseProgram_SkillsetAvailabilityType>;
  /** Flag to skip validations */
  skipValidations?: Scalars['Boolean'];
  /** The program slug */
  slug: Scalars['String'];
  /** Square logo for the program */
  squareLogo?: InputMaybe<Scalars['URL']>;
  /** The program tagline */
  tagline?: InputMaybe<Scalars['String']>;
  /** Third Party Organization Id. */
  thirdPartyOrganizationId?: InputMaybe<Scalars['ID']>;
  /** The id for the tutorial video relation for the program */
  tutorialVideoAssetId?: InputMaybe<Scalars['ID']>;
  /** The tutorial video URL for the program. */
  tutorialVideoUrl?: InputMaybe<Scalars['URL']>;
};

/** Enterprise Program UpdateSkillsets input */
export type EnterpriseProgram_UpdateSkillsetsInput = {
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** List of skillset IDs */
  skillsetIds: Array<Scalars['ID']>;
  /** Skillset update mode */
  skillsetUpdateMode: EnterpriseProgram_SkillsetUpdateMode;
};

/** Different configurations for SkillSets available to a learning program. Currently it is just ALL skillsets, no skillsets, or selected skillsets, but in the future, there may be configurations for all academies. */
export const EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType = {
  AllSkillsets: 'ALL_SKILLSETS',
  LinkedSkillsetsOnly: 'LINKED_SKILLSETS_ONLY'
} as const;

export type EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType = typeof EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType[keyof typeof EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType];
/** Input parameters for EnterprisePromotion_Create mutation. */
export type EnterprisePromotion_CreateInput = {
  /** Coupon hard expiry date. Must be greater than or equal to endsAt when both are set. */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** Discount percentage. Must be in the range 1-100. */
  discountPercent: Scalars['Int'];
  /** Promotion validity window end. Null means evergreen. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Whether the promotion auto-applies on all checkout / pricing pages without a promo code.
   * Only valid for CHECKOUT stage promotions.
   */
  isSiteWide?: Scalars['Boolean'];
  /** Maximum redemptions per contract. */
  limitPerContract?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per organization. */
  limitPerOrganization?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per individual user. */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Maximum total redemptions across all users. Null means unlimited. */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /** The description of the promotion. */
  promotionDescription: Scalars['String'];
  /** The user-facing name of the promotion. */
  promotionName: Scalars['String'];
  /**
   * Stage in the customer journey at which this promotion applies. The server derives
   * enterprisePromotionType from this: CHECKOUT maps to BEFORE_TERM; UPSELL,
   * RENEWAL_OPT_IN and RENEWAL_CANCEL_DEFLECTION map to DURING_TERM.
   */
  promotionStage?: EnterprisePromotion_PromotionStage;
  /** Promotion validity window start. */
  startsAt: Scalars['DateTime'];
  /** List of enterprise contract ids targeted by this promotion. Null or empty means open-to-all. */
  targetedContractIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Trigger conditions for activation. When provided, the promotion only applies when all
   * conditions are satisfied. Null means always active within the validity window.
   */
  triggerConditions?: InputMaybe<Array<EnterprisePromotion_TriggerConditionInput>>;
};

/** Input parameters for EnterprisePromotion_Delete mutation. */
export type EnterprisePromotion_DeleteInput = {
  /** Enterprise promotion id to delete. */
  enterprisePromotionId: Scalars['ID'];
};

/** Filter and pagination input for EnterprisePromotionQueries.list. */
export type EnterprisePromotion_ListInput = {
  /** Filter promotions targeting any of these contract ids. */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by enterprise promotion ids. Null or empty means no id-level filter. */
  enterprisePromotionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by active status (currently within startsAt and endsAt window). */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Filter by underlying B2C promotion ids. Null or empty means no id-level filter. */
  promotionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by promotion name (partial match against the denormalized promotion name). */
  promotionName?: InputMaybe<Scalars['String']>;
  /** Filter by promotion stage. */
  stage?: InputMaybe<EnterprisePromotion_PromotionStage>;
};

/**
 * Stage in the customer journey at which an enterprise promotion applies. Drives both
 * eligibility resolution at apply-time and overlap validation at create / update time.
 */
export const EnterprisePromotion_PromotionStage = {
  /** Applied at new-customer checkout / acquisition. */
  EnterprisePromotionStageCheckout: 'ENTERPRISE_PROMOTION_STAGE_CHECKOUT',
  /** Applied as a deflection offer when a customer initiates cancellation. */
  EnterprisePromotionStageRenewalCancelDeflection: 'ENTERPRISE_PROMOTION_STAGE_RENEWAL_CANCEL_DEFLECTION',
  /** Applied at renewal opt-in time for contracts approaching expiry. */
  EnterprisePromotionStageRenewalOptIn: 'ENTERPRISE_PROMOTION_STAGE_RENEWAL_OPT_IN',
  /** Applied when an existing customer adds more seats / upgrades. */
  EnterprisePromotionStageUpsell: 'ENTERPRISE_PROMOTION_STAGE_UPSELL'
} as const;

export type EnterprisePromotion_PromotionStage = typeof EnterprisePromotion_PromotionStage[keyof typeof EnterprisePromotion_PromotionStage];
/** Enumeration of possible possible promotion types. */
export const EnterprisePromotion_PromotionType = {
  /** Promotion that can be applied before term. */
  EnterprisePromotionTypeBeforeTerm: 'ENTERPRISE_PROMOTION_TYPE_BEFORE_TERM',
  /** Promotion that can be applied during term. */
  EnterprisePromotionTypeDuringTerm: 'ENTERPRISE_PROMOTION_TYPE_DURING_TERM'
} as const;

export type EnterprisePromotion_PromotionType = typeof EnterprisePromotion_PromotionType[keyof typeof EnterprisePromotion_PromotionType];
/** Input for a single trigger condition. */
export type EnterprisePromotion_TriggerConditionInput = {
  /** The type of condition being evaluated. */
  conditionType: EnterprisePromotion_TriggerConditionType;
  /** The threshold value. For LICENSE_UTILIZATION: minimum utilization percentage (1-100). */
  thresholdValue: Scalars['Int'];
};

/** Types of trigger conditions supported for enterprise promotions. */
export const EnterprisePromotion_TriggerConditionType = {
  /**
   * Promotion triggers when license utilization percentage meets or exceeds thresholdValue.
   * Evaluated per-contract at eligibility check time.
   */
  LicenseUtilization: 'LICENSE_UTILIZATION'
} as const;

export type EnterprisePromotion_TriggerConditionType = typeof EnterprisePromotion_TriggerConditionType[keyof typeof EnterprisePromotion_TriggerConditionType];
/**
 * Input parameters for EnterprisePromotion_Update mutation. Only fields that are non-null
 * are mutated; all other fields are left unchanged.
 */
export type EnterprisePromotion_UpdateInput = {
  /** Coupon hard expiry date. */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** Discount percentage. Must be in the range 1-100. */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** Promotion validity window end. Set to current time to deactivate the promotion. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Enterprise promotion id. */
  enterprisePromotionId: Scalars['ID'];
  /** Whether the promotion auto-applies on all checkout / pricing pages without a promo code. */
  isSiteWide?: InputMaybe<Scalars['Boolean']>;
  /** Maximum redemptions per contract. */
  limitPerContract?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per organization. */
  limitPerOrganization?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per individual user. */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Maximum total redemptions across all users. */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /** The description of the promotion. */
  promotionDescription?: InputMaybe<Scalars['String']>;
  /** The user-facing name of the promotion. */
  promotionName?: InputMaybe<Scalars['String']>;
  /** Stage in the customer journey at which this promotion applies. */
  promotionStage?: InputMaybe<EnterprisePromotion_PromotionStage>;
  /** Promotion validity window start. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** List of enterprise contract ids targeted by this promotion. Null or empty means open-to-all. */
  targetedContractIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Trigger conditions for activation. Replaces existing conditions when non-null.
   * Pass an empty list to remove all conditions.
   */
  triggerConditions?: InputMaybe<Array<EnterprisePromotion_TriggerConditionInput>>;
};

export const EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType = {
  BeforeTerm: 'BEFORE_TERM',
  DuringTerm: 'DURING_TERM'
} as const;

export type EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType = typeof EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType[keyof typeof EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType];
/**
 * Input parameters related to the date range for report filtering
 * startDate and endDate are optional and only used when type is CUSTOM
 * startDate is populated for scheduled custom dates
 * both startDate and endDate are populated for export custom dates
 */
export type EnterpriseReports_DateRange = {
  /** End date to filter on, used for CUSTOM date type */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The type of date range to filter data on */
  type: EnterpriseReports_DateRangeType;
};

/** The type of date range filters available */
export const EnterpriseReports_DateRangeType = {
  /** ALL_TIME */
  AllTime: 'ALL_TIME',
  /** CUSTOM */
  Custom: 'CUSTOM',
  /** LAST_30_DAYS */
  Last_30Days: 'LAST_30_DAYS',
  /** LAST_60_DAYS */
  Last_60Days: 'LAST_60_DAYS',
  /** LAST_90_DAYS */
  Last_90Days: 'LAST_90_DAYS',
  /** SINCE_CONTRACT_STARTED */
  SinceContractStarted: 'SINCE_CONTRACT_STARTED',
  /** YEAR_TO_DATE */
  YearToDate: 'YEAR_TO_DATE'
} as const;

export type EnterpriseReports_DateRangeType = typeof EnterpriseReports_DateRangeType[keyof typeof EnterpriseReports_DateRangeType];
/** Enterprise delete schedule input */
export type EnterpriseReports_DeleteScheduleInput = {
  /** Report type of the scheduled report */
  reportType: EnterpriseReports_ReportType;
  /** Org id of the scheduled report */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enterprise export curriculum report input */
export type EnterpriseReports_ExportCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export enrollment report input */
export type EnterpriseReports_ExportEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Export file format for downloadable reports */
export const EnterpriseReports_ExportFormat = {
  /** Comma-separated values format */
  Csv: 'CSV',
  /** Excel spreadsheet format */
  Xlsx: 'XLSX'
} as const;

export type EnterpriseReports_ExportFormat = typeof EnterpriseReports_ExportFormat[keyof typeof EnterpriseReports_ExportFormat];
/** Enterprise export learner engagement report input */
export type EnterpriseReports_ExportLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export learner performance report input */
export type EnterpriseReports_ExportLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export learner skills report input */
export type EnterpriseReports_ExportLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise export membership report input */
export type EnterpriseReports_ExportMembershipReportInput = {
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export report input */
export type EnterpriseReports_ExportReportInput = {
  /** Curriculum report input */
  curriculum?: InputMaybe<EnterpriseReports_ExportCurriculumReportInput>;
  /** Enrollment report input */
  enrollment?: InputMaybe<EnterpriseReports_ExportEnrollmentReportInput>;
  /** Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseReports_ExportLearnerEngagementReportInput>;
  /** Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseReports_ExportLearnerPerformanceReportInput>;
  /** Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseReports_ExportLearnerSkillsReportInput>;
  /** Membership report input */
  membership?: InputMaybe<EnterpriseReports_ExportMembershipReportInput>;
  /** Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseReports_ExportVerifiedSkillPathProgressReportInput>;
};

/** Enterprise export Verified Skill Path Progress report input */
export type EnterpriseReports_ExportVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/**
 * Common report filters and configuration options
 * Reusable across multiple report types for consistency
 */
export type EnterpriseReports_ReportFilters = {
  /** List of contract IDs */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat?: EnterpriseReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** List of pathway IDs for VSP filtering */
  pathwayIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of skill IDs */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Names of individual report artifacts (CSV files or Excel sheets) */
export const EnterpriseReports_ReportName = {
  /** Activity by Business Unit pivot (Learner Engagement) */
  ActivityByBusinessUnit: 'ACTIVITY_BY_BUSINESS_UNIT',
  /** Activity by City pivot (Learner Engagement) */
  ActivityByCity: 'ACTIVITY_BY_CITY',
  /** Activity by Country pivot (Learner Engagement) */
  ActivityByCountry: 'ACTIVITY_BY_COUNTRY',
  /** Course Activity (Learner Engagement) */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Curated Curriculum (Curriculum) */
  CuratedCurriculum: 'CURATED_CURRICULUM',
  /** Full Catalog (Curriculum) */
  FullCatalog: 'FULL_CATALOG',
  /** Gradebook Report (Learner Performance) */
  GradebookReport: 'GRADEBOOK_REPORT',
  /** Learning Path Activity (Learner Engagement) */
  LearningPathActivity: 'LEARNING_PATH_ACTIVITY',
  /** Plagiarism Report (Learner Performance) */
  PlagiarismReport: 'PLAGIARISM_REPORT',
  /** Program Activity (Learner Engagement) */
  ProgramActivity: 'PROGRAM_ACTIVITY',
  /** Skills Verified (Verified Skills Path) */
  SkillsVerified: 'SKILLS_VERIFIED',
  /** Skill Benchmarking (Learner Skills) */
  SkillBenchmarking: 'SKILL_BENCHMARKING',
  /** Skill Leaderboard (Learner Skills) */
  SkillLeaderboard: 'SKILL_LEADERBOARD',
  /** Skill Proficiency (Learner Skills) */
  SkillProficiency: 'SKILL_PROFICIENCY',
  /** Specialization Activity (Learner Engagement) */
  SpecializationActivity: 'SPECIALIZATION_ACTIVITY',
  /** Verified Skills Path Activity (Verified Skills Path) */
  VerifiedSkillsPathActivity: 'VERIFIED_SKILLS_PATH_ACTIVITY',
  /** Video Clip Activity (Learner Engagement) */
  VideoClipActivity: 'VIDEO_CLIP_ACTIVITY'
} as const;

export type EnterpriseReports_ReportName = typeof EnterpriseReports_ReportName[keyof typeof EnterpriseReports_ReportName];
/** The type of reports that can be scheduled */
export const EnterpriseReports_ReportType = {
  /** CURRICULUM */
  Curriculum: 'CURRICULUM',
  /** ENROLLMENT */
  Enrollment: 'ENROLLMENT',
  /** LEARNER_ENGAGEMENT */
  LearnerEngagement: 'LEARNER_ENGAGEMENT',
  /** LEARNER_PERFORMANCE */
  LearnerPerformance: 'LEARNER_PERFORMANCE',
  /** LEARNER_SKILLS */
  LearnerSkills: 'LEARNER_SKILLS',
  /** MEMBERSHIP */
  Membership: 'MEMBERSHIP',
  /** MONTHLY_DIGEST_EMAIL */
  MonthlyDigestEmail: 'MONTHLY_DIGEST_EMAIL',
  /** VERIFIED_SKILL_PATH_PROGRESS */
  VerifiedSkillPathProgress: 'VERIFIED_SKILL_PATH_PROGRESS'
} as const;

export type EnterpriseReports_ReportType = typeof EnterpriseReports_ReportType[keyof typeof EnterpriseReports_ReportType];
/** Enterprise save schedule input */
export type EnterpriseReports_SaveScheduleInput = {
  /** Schedule Curriculum report input */
  curriculum?: InputMaybe<EnterpriseReports_ScheduleCurriculumReportInput>;
  /** Schedule Enrollment report input */
  enrollment?: InputMaybe<EnterpriseReports_ScheduleEnrollmentReportInput>;
  /** Schedule Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseReports_ScheduleLearnerEngagementReportInput>;
  /** Schedule Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseReports_ScheduleLearnerPerformanceReportInput>;
  /** Schedule Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseReports_ScheduleLearnerSkillsReportInput>;
  /** Schedule Membership report input */
  membership?: InputMaybe<EnterpriseReports_ScheduleMembershipReportInput>;
  /** Schedule Monthly Digest Email input */
  monthlyDigestEmail?: InputMaybe<EnterpriseReports_ScheduleMonthlyDigestEmailInput>;
  /** Schedule Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseReports_ScheduleVerifiedSkillPathProgressReportInput>;
};

/** What day of the week the report is scheduled to send on, sends weekly */
export const EnterpriseReports_Schedule = {
  /** FRIDAY */
  Friday: 'FRIDAY',
  /** MONDAY */
  Monday: 'MONDAY',
  /** SATURDAY */
  Saturday: 'SATURDAY',
  /** SUNDAY */
  Sunday: 'SUNDAY',
  /** THURSDAY */
  Thursday: 'THURSDAY',
  /** TUESDAY */
  Tuesday: 'TUESDAY',
  /** WEDNESDAY */
  Wednesday: 'WEDNESDAY'
} as const;

export type EnterpriseReports_Schedule = typeof EnterpriseReports_Schedule[keyof typeof EnterpriseReports_Schedule];
/** Enterprise schedule curriculum report input */
export type EnterpriseReports_ScheduleCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseReports_ScheduleEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Should report include data about removed members */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner engagement report input */
export type EnterpriseReports_ScheduleLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner performance report input */
export type EnterpriseReports_ScheduleLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner skills report input */
export type EnterpriseReports_ScheduleLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseReports_ScheduleMembershipReportInput = {
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule monthly digest email input */
export type EnterpriseReports_ScheduleMonthlyDigestEmailInput = {
  /** Org and programId context for report (programIds should be empty for monthly digest) */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule Verified Skill Path Progress report input */
export type EnterpriseReports_ScheduleVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** What context the report should be limited to */
export type EnterpriseReports_Scope = {
  /** Program ids to filter on */
  programIds: Array<Scalars['ID']>;
  /** Org id to filter on */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** AttributeName: all attribute names */
export const EnterpriseSavedFilter_AttributeName = {
  /** Business unit */
  BusinessUnit: 'BUSINESS_UNIT',
  /** Contract id */
  Contract: 'CONTRACT',
  /** Job title */
  JobTitle: 'JOB_TITLE',
  /** Job type */
  JobType: 'JOB_TYPE',
  /** Location */
  Location: 'LOCATION',
  /** Manager */
  Manager: 'MANAGER'
} as const;

export type EnterpriseSavedFilter_AttributeName = typeof EnterpriseSavedFilter_AttributeName[keyof typeof EnterpriseSavedFilter_AttributeName];
/** SortableColumn: all sortable columns */
export const EnterpriseSavedFilter_ColumnName = {
  /** Business unit column */
  BusinessUnit: 'BUSINESS_UNIT',
  /** Deleted at column */
  DeletedAt: 'DELETED_AT',
  /** Invited at column */
  InvitedAt: 'INVITED_AT',
  /** Is soft deleted column */
  IsSoftDeleted: 'IS_SOFT_DELETED',
  /** Joined at column */
  JoinedAt: 'JOINED_AT',
  /** Latest activity at column */
  LatestActivityAt: 'LATEST_ACTIVITY_AT',
  /** Manager name column */
  ManagerName: 'MANAGER_NAME',
  /** Name column */
  Name: 'NAME',
  /** Number of completions column */
  NumCompletions: 'NUM_COMPLETIONS',
  /** Number of enrollments column */
  NumEnrollments: 'NUM_ENROLLMENTS'
} as const;

export type EnterpriseSavedFilter_ColumnName = typeof EnterpriseSavedFilter_ColumnName[keyof typeof EnterpriseSavedFilter_ColumnName];
/** Enum that represents the filter purpose. */
export const EnterpriseSavedFilter_FilterPurpose = {
  /** The filter is intended for assigning content. */
  AssignContent: 'ASSIGN_CONTENT',
  /** The filter is flagged for deletion. */
  Delete: 'DELETE',
  /** The filter is intended for downloads. */
  Download: 'DOWNLOAD',
  /** The filter is intended for sending messages. */
  Message: 'MESSAGE',
  /** The filter is intended for reuse. */
  Reuse: 'REUSE'
} as const;

export type EnterpriseSavedFilter_FilterPurpose = typeof EnterpriseSavedFilter_FilterPurpose[keyof typeof EnterpriseSavedFilter_FilterPurpose];
/** Enum that represents the saved filter type. */
export const EnterpriseSavedFilter_FilterType = {
  /** The version 1 of the User filter type. */
  UserV1: 'USER_V1'
} as const;

export type EnterpriseSavedFilter_FilterType = typeof EnterpriseSavedFilter_FilterType[keyof typeof EnterpriseSavedFilter_FilterType];
/** SortDirection: sort direction */
export const EnterpriseSavedFilter_SortDirection = {
  /** Ascending sort direction */
  Ascending: 'ASCENDING',
  /** Descending sort direction */
  Descending: 'DESCENDING'
} as const;

export type EnterpriseSavedFilter_SortDirection = typeof EnterpriseSavedFilter_SortDirection[keyof typeof EnterpriseSavedFilter_SortDirection];
/** User Program Membership status */
export const EnterpriseSavedFilter_UserProgramMembershipStatus = {
  /** invited status */
  Invited: 'INVITED',
  /** joined status */
  Joined: 'JOINED',
  /** removed status */
  Removed: 'REMOVED'
} as const;

export type EnterpriseSavedFilter_UserProgramMembershipStatus = typeof EnterpriseSavedFilter_UserProgramMembershipStatus[keyof typeof EnterpriseSavedFilter_UserProgramMembershipStatus];
/** Input for checking users SCIM managed status */
export type EnterpriseScim_AreUsersScimManagedInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** List of user emails to check */
  userEmails: Array<Scalars['String']>;
};

/** Input for configuring SCIM */
export type EnterpriseScim_ConfigureScimInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
};

/** Input for generating a new SCIM token */
export type EnterpriseScim_GenerateTokenInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
};

/**
 * Processing status for group program mapping operations.
 * Tracks the async processing state after a mapping update is requested.
 */
export const EnterpriseScim_ProcessingStatus = {
  /** Mapping update completed successfully */
  Completed: 'COMPLETED',
  /** Mapping update failed after all retry attempts */
  Failed: 'FAILED',
  /** Mapping update has been requested but not yet started processing */
  Pending: 'PENDING',
  /** Mapping update is currently being processed */
  Processing: 'PROCESSING'
} as const;

export type EnterpriseScim_ProcessingStatus = typeof EnterpriseScim_ProcessingStatus[keyof typeof EnterpriseScim_ProcessingStatus];
/** Input for revoking a SCIM token */
export type EnterpriseScim_RevokeTokenInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** The token ID to revoke */
  tokenId: Scalars['ID'];
};

/** Input for updating group program mappings */
export type EnterpriseScim_UpdateGroupProgramMappingsInput = {
  /** The group ID */
  groupId: Scalars['ID'];
  /** The organization ID */
  orgId: Scalars['ID'];
  /** Program IDs to add to the group */
  programsAdded?: InputMaybe<Array<Scalars['ID']>>;
  /** Program IDs to remove from the group */
  programsRemoved?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for updating SCIM status */
export type EnterpriseScim_UpdateScimStatusInput = {
  /** Whether to enable or disable SCIM */
  enable: Scalars['Boolean'];
  /** The organization ID */
  orgId: Scalars['ID'];
};

/** Input for updating should send invite mail flag */
export type EnterpriseScim_UpdateShouldSendInviteMailInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** Whether to send invite mail */
  shouldSendInviteMail: Scalars['Boolean'];
};

export const EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
/** Message preset */
export const EnterpriseSentMessages_Preset = {
  /** Preset to congratulate a user on an achievement */
  CongratulateAchievement: 'CONGRATULATE_ACHIEVEMENT',
  /** Custom preset */
  Custom: 'CUSTOM',
  /** Deleted preset */
  Deleted: 'DELETED',
  /** Preset to remind assigned learners */
  RemindAssignedLearners: 'REMIND_ASSIGNED_LEARNERS',
  /** Preset to remind a user to be active past 30 days */
  RemindBeActivePast_30Days: 'REMIND_BE_ACTIVE_PAST_30_DAYS',
  /** Preset to remind a user to be active past 90 days */
  RemindBeActivePast_90Days: 'REMIND_BE_ACTIVE_PAST_90_DAYS',
  /** Preset to remind a user to complete content */
  RemindComplete: 'REMIND_COMPLETE',
  /** Preset to remind a user to enroll */
  RemindEnroll: 'REMIND_ENROLL',
  /** Preset to remind a user to join */
  RemindJoin: 'REMIND_JOIN'
} as const;

export type EnterpriseSentMessages_Preset = typeof EnterpriseSentMessages_Preset[keyof typeof EnterpriseSentMessages_Preset];
/** ID of the setting to update */
export type EnterpriseSetting_Id = {
  /** Setting key to update */
  enterpriseSettingKey: EnterpriseSetting_Key;
  /** Scope to update */
  managedLevelScope: EnterpriseSetting_ManagedLevelScopeInput;
};

/**
 * The various setting keys available, this should be kept in sync with the proto defined list
 * coursera/proto/enterprisesetting/v1beta1/enterprise_setting.proto
 */
export const EnterpriseSetting_Key = {
  /** Permission for sharing anonymized ELP data (stored per org) with Coursera. */
  EnterpriseSettingKeyAllowElpDataShare: 'ENTERPRISE_SETTING_KEY_ALLOW_ELP_DATA_SHARE',
  /** Deprecated ENTERPRISE_SETTING_KEY_ANONYMOUS_PEER_REVIEW */
  EnterpriseSettingKeyAnonymousPeerReview: 'ENTERPRISE_SETTING_KEY_ANONYMOUS_PEER_REVIEW',
  /**
   * Indicate whether a C4CB survey has been submitted.
   * Product spec: https://docs.google.com/document/d/1n2AiqI-ammSKXLcHsW7PkhcJJNESv7otEacZoNaGnZ0/edit
   */
  EnterpriseSettingKeyC4CbSurveySubmitted: 'ENTERPRISE_SETTING_KEY_C4CB_SURVEY_SUBMITTED',
  /** Indicates whether role selections for a career academy program have been customized or not. */
  EnterpriseSettingKeyCareerAcademyRoleSelectionCustomized: 'ENTERPRISE_SETTING_KEY_CAREER_ACADEMY_ROLE_SELECTION_CUSTOMIZED',
  /** Indicates which variant of Career Academy is enabled for this program (if any). */
  EnterpriseSettingKeyCareerAcademyVariant: 'ENTERPRISE_SETTING_KEY_CAREER_ACADEMY_VARIANT',
  /** This setting allows custom messaging for filled programs instead of displaying the default. */
  EnterpriseSettingKeyCustomFilledProgramMessage: 'ENTERPRISE_SETTING_KEY_CUSTOM_FILLED_PROGRAM_MESSAGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_CUSTOM_INVITATION_LINK */
  EnterpriseSettingKeyCustomInvitationLink: 'ENTERPRISE_SETTING_KEY_CUSTOM_INVITATION_LINK',
  /**
   * By default if this setting is not set for a Career Academy program, the learner's default tab
   * will be the Career Academy page. This setting set to true will remove the career academy
   * page from the learners' default tab.
   */
  EnterpriseSettingKeyDisableCaLearnerDefaultTab: 'ENTERPRISE_SETTING_KEY_DISABLE_CA_LEARNER_DEFAULT_TAB',
  /** Deprecated ENTERPRISE_SETTING_KEY_DISABLE_PROGRAM_DELETION_EMAIL */
  EnterpriseSettingKeyDisableProgramDeletionEmail: 'ENTERPRISE_SETTING_KEY_DISABLE_PROGRAM_DELETION_EMAIL',
  /** Deprecated ENTERPRISE_SETTING_KEY_DISALLOW_PEER_REVIEW_URL_SHARING */
  EnterpriseSettingKeyDisallowPeerReviewUrlSharing: 'ENTERPRISE_SETTING_KEY_DISALLOW_PEER_REVIEW_URL_SHARING',
  /** Deprecated ENTERPRISE_SETTING_KEY_FIRST_UNENROLLMENT_TRIGGER_ENABLED */
  EnterpriseSettingKeyFirstUnenrollmentTriggerEnabled: 'ENTERPRISE_SETTING_KEY_FIRST_UNENROLLMENT_TRIGGER_ENABLED',
  /**
   * The GDPR Mode setting for 3PO scope.
   * See https://coursera.atlassian.net/wiki/spaces/PROD/pages/560300101/SSO+Login+and+Account+Creation+Usability+and+GDPR+Compliance+across+SSO+and+Non-SSO+Orgs#Acceptance-Criteria
   */
  EnterpriseSettingKeyGdprMode: 'ENTERPRISE_SETTING_KEY_GDPR_MODE',
  /** ENTERPRISE_SETTING_KEY_GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED */
  EnterpriseSettingKeyGradebookPlagiarismColumnsEnabled: 'ENTERPRISE_SETTING_KEY_GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED',
  /** Indicates whether or not to include billable contracts in the key insights for an organization */
  EnterpriseSettingKeyInsightsIncludeBillableContracts: 'ENTERPRISE_SETTING_KEY_INSIGHTS_INCLUDE_BILLABLE_CONTRACTS',
  /** Indicates whether or not to include non-billable contracts in the key insights for an organization */
  EnterpriseSettingKeyInsightsIncludeNonBillableContracts: 'ENTERPRISE_SETTING_KEY_INSIGHTS_INCLUDE_NON_BILLABLE_CONTRACTS',
  /** Indicates whether auto enrollment is enabled for LMS/LXP learners by admin */
  EnterpriseSettingKeyLmsLxpAutoEnrollmentEnabled: 'ENTERPRISE_SETTING_KEY_LMS_LXP_AUTO_ENROLLMENT_ENABLED',
  /** Used for checking email address updates. */
  EnterpriseSettingKeyOrgLevelVerifiedEmailDomains: 'ENTERPRISE_SETTING_KEY_ORG_LEVEL_VERIFIED_EMAIL_DOMAINS',
  /** Controls whether personalized content reordering is disabled for the organization */
  EnterpriseSettingKeyPersonalizedContentReorderingDisabled: 'ENTERPRISE_SETTING_KEY_PERSONALIZED_CONTENT_REORDERING_DISABLED',
  /** ENTERPRISE_SETTING_KEY_PLAGIARISM_DETECTION_ENABLED */
  EnterpriseSettingKeyPlagiarismDetectionEnabled: 'ENTERPRISE_SETTING_KEY_PLAGIARISM_DETECTION_ENABLED',
  /** ENTERPRISE_SETTING_KEY_PLAGIARISM_EMAIL_RECIPIENTS */
  EnterpriseSettingKeyPlagiarismEmailRecipients: 'ENTERPRISE_SETTING_KEY_PLAGIARISM_EMAIL_RECIPIENTS',
  /** ENTERPRISE_SETTING_KEY_PREFERRED_LANGUAGE_CODE */
  EnterpriseSettingKeyPreferredLanguageCode: 'ENTERPRISE_SETTING_KEY_PREFERRED_LANGUAGE_CODE',
  /** Indicates whether the employee (removed from program/s) anonymization feature is enabled for the enterprise. */
  EnterpriseSettingKeyRemovedMemberAnonymizationEnabled: 'ENTERPRISE_SETTING_KEY_REMOVED_MEMBER_ANONYMIZATION_ENABLED',
  /** Deprecated ENTERPRISE_SETTING_KEY_SECOND_UNENROLLMENT_TRIGGER_ENABLED */
  EnterpriseSettingKeySecondUnenrollmentTriggerEnabled: 'ENTERPRISE_SETTING_KEY_SECOND_UNENROLLMENT_TRIGGER_ENABLED',
  /** Boolean flag indicating whether SSO locked out state is enabled */
  EnterpriseSettingKeySsoLockedOutStateEnabled: 'ENTERPRISE_SETTING_KEY_SSO_LOCKED_OUT_STATE_ENABLED',
  /** ENTERPRISE_SETTING_KEY_SUPPRESS_ACCLAIM_BADGE */
  EnterpriseSettingKeySuppressAcclaimBadge: 'ENTERPRISE_SETTING_KEY_SUPPRESS_ACCLAIM_BADGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE */
  EnterpriseSettingKeyUnenrollmentProgressThresholdPercentage: 'ENTERPRISE_SETTING_KEY_UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_UNLIMITED_INVITATIONS */
  EnterpriseSettingKeyUnlimitedInvitations: 'ENTERPRISE_SETTING_KEY_UNLIMITED_INVITATIONS',
  /** Deprecated ENTERPRISE_SETTING_KEY_WHITELIST_EMAIL_DOMAINS */
  EnterpriseSettingKeyWhitelistEmailDomains: 'ENTERPRISE_SETTING_KEY_WHITELIST_EMAIL_DOMAINS'
} as const;

export type EnterpriseSetting_Key = typeof EnterpriseSetting_Key[keyof typeof EnterpriseSetting_Key];
/** Scope based on type and value */
export type EnterpriseSetting_ManagedLevelScopeInput = {
  /** Enum of org or program */
  scope: EnterpriseSetting_ManagedLevelScopeType;
  /** The ID of the entity set in the scope, program or org */
  value: Scalars['String'];
};

/** The level of the setting, org or program */
export const EnterpriseSetting_ManagedLevelScopeType = {
  /** For program level settings */
  Program: 'PROGRAM',
  /** For org level settings */
  ThirdPartyOrganization: 'THIRD_PARTY_ORGANIZATION'
} as const;

export type EnterpriseSetting_ManagedLevelScopeType = typeof EnterpriseSetting_ManagedLevelScopeType[keyof typeof EnterpriseSetting_ManagedLevelScopeType];
/** Key value pair to mimic a map */
export type EnterpriseSetting_StringMapTypeValue = {
  /** key */
  key: Scalars['String'];
  /** value */
  value: Scalars['String'];
};

/** One of input based on the type to set */
export type EnterpriseSetting_Type = {
  /** bool setting */
  booleanEnterpriseSetting?: InputMaybe<Scalars['Boolean']>;
  /** int setting */
  integerEnterpriseSetting?: InputMaybe<Scalars['Int']>;
  /** Array of strings */
  stringArrayEnterpriseSetting?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** string setting */
  stringEnterpriseSetting?: InputMaybe<Scalars['String']>;
  /** Map<String, String> setting */
  stringMapEnterpriseSetting?: InputMaybe<Array<InputMaybe<EnterpriseSetting_StringMapTypeValue>>>;
};

/** TODO: Complete this description */
export type EnterpriseSetting_UpdateInput = {
  /** setting type to set */
  enterpriseSettingType: EnterpriseSetting_Type;
  /** org id */
  organizationId: Scalars['ID'];
  /** setting id */
  settingId: EnterpriseSetting_Id;
};

export const EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey = {
  AllowElpDataShare: 'ALLOW_ELP_DATA_SHARE',
  AnonymousPeerReview: 'ANONYMOUS_PEER_REVIEW',
  C4CbSurveySubmitted: 'C4CB_SURVEY_SUBMITTED',
  CareerAcademyRoleSelectionCustomized: 'CAREER_ACADEMY_ROLE_SELECTION_CUSTOMIZED',
  CareerAcademyVariant: 'CAREER_ACADEMY_VARIANT',
  CustomFilledProgramMessage: 'CUSTOM_FILLED_PROGRAM_MESSAGE',
  CustomInvitationLink: 'CUSTOM_INVITATION_LINK',
  DisableCaLearnerDefaultTab: 'DISABLE_CA_LEARNER_DEFAULT_TAB',
  DisableProgramDeletionEmail: 'DISABLE_PROGRAM_DELETION_EMAIL',
  DisallowPeerReviewUrlSharing: 'DISALLOW_PEER_REVIEW_URL_SHARING',
  FirstUnenrollmentTriggerEnabled: 'FIRST_UNENROLLMENT_TRIGGER_ENABLED',
  GdprMode: 'GDPR_MODE',
  GradebookPlagiarismColumnsEnabled: 'GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED',
  KeyInsightsIncludeBillableContracts: 'KEY_INSIGHTS_INCLUDE_BILLABLE_CONTRACTS',
  KeyInsightsIncludeNonBillableContracts: 'KEY_INSIGHTS_INCLUDE_NON_BILLABLE_CONTRACTS',
  OrgLevelVerifiedEmailDomains: 'ORG_LEVEL_VERIFIED_EMAIL_DOMAINS',
  PlagiarismDetectionEnabled: 'PLAGIARISM_DETECTION_ENABLED',
  PlagiarismEmailRecipients: 'PLAGIARISM_EMAIL_RECIPIENTS',
  PreferredLanguageCode: 'PREFERRED_LANGUAGE_CODE',
  RemovedMemberAnonymizationEnabled: 'REMOVED_MEMBER_ANONYMIZATION_ENABLED',
  SecondUnenrollmentTriggerEnabled: 'SECOND_UNENROLLMENT_TRIGGER_ENABLED',
  SuppressAcclaimBadge: 'SUPPRESS_ACCLAIM_BADGE',
  UnenrollmentProgressThresholdPercentage: 'UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE',
  UnlimitedInvitations: 'UNLIMITED_INVITATIONS',
  WhitelistEmailDomains: 'WHITELIST_EMAIL_DOMAINS'
} as const;

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey = typeof EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey[keyof typeof EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey];
/** Last number of days to gather insight from */
export const EnterpriseSkillsInsights_MetricTimeFrame = {
  /** Metrics from the last 90 days */
  NinetyDays: 'NINETY_DAYS',
  /** Metrics from the last 60 days */
  SixtyDays: 'SIXTY_DAYS',
  /** Metrics from the last 30 days */
  ThirtyDays: 'THIRTY_DAYS'
} as const;

export type EnterpriseSkillsInsights_MetricTimeFrame = typeof EnterpriseSkillsInsights_MetricTimeFrame[keyof typeof EnterpriseSkillsInsights_MetricTimeFrame];
/** A way to categorize Skillsets based on the intended learner journey goal of the Skillset. */
export const EnterpriseSkills_GoalType = {
  /** Invalid goal type */
  Invalid: 'INVALID',
  /** To gain basic literacy in a skill */
  Literacy: 'LITERACY',
  /** Reskill from another career */
  Reskill: 'RESKILL',
  /** Upskill from some existing knowledge */
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseSkills_GoalType = typeof EnterpriseSkills_GoalType[keyof typeof EnterpriseSkills_GoalType];
/** The scope type of the skillset */
export const EnterpriseSkills_ScopeType = {
  /** Customized skillsets */
  EnterpriseOrganization: 'ENTERPRISE_ORGANIZATION',
  /** Template or global skillsets */
  Global: 'GLOBAL'
} as const;

export type EnterpriseSkills_ScopeType = typeof EnterpriseSkills_ScopeType[keyof typeof EnterpriseSkills_ScopeType];
/** Filterable parameters for Skillset data */
export type EnterpriseSkills_SkillsetFilterParameters = {
  /** Academy IDs to filter by */
  academyIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Functions to filter by */
  functionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Goal types to filter by */
  goalTypes?: InputMaybe<Array<EnterpriseSkills_GoalType>>;
  /** Roles to filter by */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Sortable parameters for Skillset data */
export type EnterpriseSkills_SkillsetOrderByInput = {
  /** Sort on createdAt field */
  createdAt?: InputMaybe<EnterpriseSkills_Sort>;
  /** Sort on name field */
  name?: InputMaybe<EnterpriseSkills_Sort>;
};

/** Sort direction */
export const EnterpriseSkills_Sort = {
  /** Sort ascending order */
  Asc: 'ASC',
  /** Sort descending order */
  Desc: 'DESC'
} as const;

export type EnterpriseSkills_Sort = typeof EnterpriseSkills_Sort[keyof typeof EnterpriseSkills_Sort];
/** The state of a user's relationship with a TargetSkillProfile goal. */
export const EnterpriseSkills_TargetSkillProfileUserGoalState = {
  /** TargetSkillProfile has been deleted from the user's organization. */
  Deleted: 'DELETED',
  /** TargetSkillProfile goal recommendation has been dismissed by the user. */
  Dismissed: 'DISMISSED',
  /** TargetSkillProfile has been saved as a goal for the user. */
  Saved: 'SAVED',
  /** TargetSkillProfile has been unsaved/removed as a goal for the user. */
  Unsaved: 'UNSAVED'
} as const;

export type EnterpriseSkills_TargetSkillProfileUserGoalState = typeof EnterpriseSkills_TargetSkillProfileUserGoalState[keyof typeof EnterpriseSkills_TargetSkillProfileUserGoalState];
/**
 * Input parameters related to the date range for report filtering
 * startDate and endDate are optional and only used when type is CUSTOM
 * startDate is populated for scheduled custom dates
 * both startDate and endDate are populated for export custom dates
 */
export type EnterpriseSummaryReports_DateRange = {
  /** End date to filter on, used for CUSTOM date type */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The type of date range to filter data on */
  type: EnterpriseSummaryReports_DateRangeType;
};

/** The type of date range filters available */
export const EnterpriseSummaryReports_DateRangeType = {
  /** ALL_TIME */
  AllTime: 'ALL_TIME',
  /** CUSTOM */
  Custom: 'CUSTOM',
  /** LAST_30_DAYS */
  Last_30Days: 'LAST_30_DAYS',
  /** LAST_60_DAYS */
  Last_60Days: 'LAST_60_DAYS',
  /** LAST_90_DAYS */
  Last_90Days: 'LAST_90_DAYS',
  /** SINCE_CONTRACT_STARTED */
  SinceContractStarted: 'SINCE_CONTRACT_STARTED',
  /** YEAR_TO_DATE */
  YearToDate: 'YEAR_TO_DATE'
} as const;

export type EnterpriseSummaryReports_DateRangeType = typeof EnterpriseSummaryReports_DateRangeType[keyof typeof EnterpriseSummaryReports_DateRangeType];
/** Enterprise delete schedule input */
export type EnterpriseSummaryReports_DeleteScheduleInput = {
  /** Report type of the scheduled report */
  reportType: EnterpriseSummaryReports_ReportType;
  /** Org id of the scheduled report */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enterprise export curriculum report input */
export type EnterpriseSummaryReports_ExportCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export enrollment report input */
export type EnterpriseSummaryReports_ExportEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Export file format for downloadable reports */
export const EnterpriseSummaryReports_ExportFormat = {
  /** Comma-separated values format */
  Csv: 'CSV',
  /** Excel spreadsheet format */
  Xlsx: 'XLSX'
} as const;

export type EnterpriseSummaryReports_ExportFormat = typeof EnterpriseSummaryReports_ExportFormat[keyof typeof EnterpriseSummaryReports_ExportFormat];
/** Enterprise export learner engagement report input */
export type EnterpriseSummaryReports_ExportLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export learner performance report input */
export type EnterpriseSummaryReports_ExportLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export learner skills report input */
export type EnterpriseSummaryReports_ExportLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise export membership report input */
export type EnterpriseSummaryReports_ExportMembershipReportInput = {
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export report input */
export type EnterpriseSummaryReports_ExportReportInput = {
  /** Curriculum report input */
  curriculum?: InputMaybe<EnterpriseSummaryReports_ExportCurriculumReportInput>;
  /** Enrollment report input */
  enrollment?: InputMaybe<EnterpriseSummaryReports_ExportEnrollmentReportInput>;
  /** Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseSummaryReports_ExportLearnerEngagementReportInput>;
  /** Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseSummaryReports_ExportLearnerPerformanceReportInput>;
  /** Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseSummaryReports_ExportLearnerSkillsReportInput>;
  /** Membership report input */
  membership?: InputMaybe<EnterpriseSummaryReports_ExportMembershipReportInput>;
  /** Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseSummaryReports_ExportVerifiedSkillPathProgressReportInput>;
};

/** Enterprise export Verified Skill Path Progress report input */
export type EnterpriseSummaryReports_ExportVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/**
 * Common report filters and configuration options
 * Reusable across multiple report types for consistency
 */
export type EnterpriseSummaryReports_ReportFilters = {
  /** List of contract IDs */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat?: EnterpriseSummaryReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** List of pathway IDs for VSP filtering */
  pathwayIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of skill IDs */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Names of individual report artifacts (CSV files or Excel sheets) */
export const EnterpriseSummaryReports_ReportName = {
  /** Activity by Business Unit pivot (Learner Engagement) */
  ActivityByBusinessUnit: 'ACTIVITY_BY_BUSINESS_UNIT',
  /** Activity by City pivot (Learner Engagement) */
  ActivityByCity: 'ACTIVITY_BY_CITY',
  /** Activity by Country pivot (Learner Engagement) */
  ActivityByCountry: 'ACTIVITY_BY_COUNTRY',
  /** Course Activity (Learner Engagement) */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Curated Curriculum (Curriculum) */
  CuratedCurriculum: 'CURATED_CURRICULUM',
  /** Full Catalog (Curriculum) */
  FullCatalog: 'FULL_CATALOG',
  /** Gradebook Report (Learner Performance) */
  GradebookReport: 'GRADEBOOK_REPORT',
  /** Learning Path Activity (Learner Engagement) */
  LearningPathActivity: 'LEARNING_PATH_ACTIVITY',
  /** Plagiarism Report (Learner Performance) */
  PlagiarismReport: 'PLAGIARISM_REPORT',
  /** Program Activity (Learner Engagement) */
  ProgramActivity: 'PROGRAM_ACTIVITY',
  /** Skills Verified (Verified Skills Path) */
  SkillsVerified: 'SKILLS_VERIFIED',
  /** Skill Benchmarking (Learner Skills) */
  SkillBenchmarking: 'SKILL_BENCHMARKING',
  /** Skill Leaderboard (Learner Skills) */
  SkillLeaderboard: 'SKILL_LEADERBOARD',
  /** Skill Proficiency (Learner Skills) */
  SkillProficiency: 'SKILL_PROFICIENCY',
  /** Specialization Activity (Learner Engagement) */
  SpecializationActivity: 'SPECIALIZATION_ACTIVITY',
  /** Verified Skills Path Activity (Verified Skills Path) */
  VerifiedSkillsPathActivity: 'VERIFIED_SKILLS_PATH_ACTIVITY',
  /** Video Clip Activity (Learner Engagement) */
  VideoClipActivity: 'VIDEO_CLIP_ACTIVITY'
} as const;

export type EnterpriseSummaryReports_ReportName = typeof EnterpriseSummaryReports_ReportName[keyof typeof EnterpriseSummaryReports_ReportName];
/** The type of reports that can be scheduled */
export const EnterpriseSummaryReports_ReportType = {
  /** CURRICULUM */
  Curriculum: 'CURRICULUM',
  /** ENROLLMENT */
  Enrollment: 'ENROLLMENT',
  /** LEARNER_ENGAGEMENT */
  LearnerEngagement: 'LEARNER_ENGAGEMENT',
  /** LEARNER_PERFORMANCE */
  LearnerPerformance: 'LEARNER_PERFORMANCE',
  /** LEARNER_SKILLS */
  LearnerSkills: 'LEARNER_SKILLS',
  /** MEMBERSHIP */
  Membership: 'MEMBERSHIP',
  /** MONTHLY_DIGEST_EMAIL */
  MonthlyDigestEmail: 'MONTHLY_DIGEST_EMAIL',
  /** VERIFIED_SKILL_PATH_PROGRESS */
  VerifiedSkillPathProgress: 'VERIFIED_SKILL_PATH_PROGRESS'
} as const;

export type EnterpriseSummaryReports_ReportType = typeof EnterpriseSummaryReports_ReportType[keyof typeof EnterpriseSummaryReports_ReportType];
/** Enterprise save schedule input */
export type EnterpriseSummaryReports_SaveScheduleInput = {
  /** Schedule Curriculum report input */
  curriculum?: InputMaybe<EnterpriseSummaryReports_ScheduleCurriculumReportInput>;
  /** Schedule Enrollment report input */
  enrollment?: InputMaybe<EnterpriseSummaryReports_ScheduleEnrollmentReportInput>;
  /** Schedule Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerEngagementReportInput>;
  /** Schedule Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerPerformanceReportInput>;
  /** Schedule Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerSkillsReportInput>;
  /** Schedule Membership report input */
  membership?: InputMaybe<EnterpriseSummaryReports_ScheduleMembershipReportInput>;
  /** Schedule Monthly Digest Email input */
  monthlyDigestEmail?: InputMaybe<EnterpriseSummaryReports_ScheduleMonthlyDigestEmailInput>;
  /** Schedule Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseSummaryReports_ScheduleVerifiedSkillPathProgressReportInput>;
};

/** What day of the week the report is scheduled to send on, sends weekly */
export const EnterpriseSummaryReports_Schedule = {
  /** FRIDAY */
  Friday: 'FRIDAY',
  /** MONDAY */
  Monday: 'MONDAY',
  /** SATURDAY */
  Saturday: 'SATURDAY',
  /** SUNDAY */
  Sunday: 'SUNDAY',
  /** THURSDAY */
  Thursday: 'THURSDAY',
  /** TUESDAY */
  Tuesday: 'TUESDAY',
  /** WEDNESDAY */
  Wednesday: 'WEDNESDAY'
} as const;

export type EnterpriseSummaryReports_Schedule = typeof EnterpriseSummaryReports_Schedule[keyof typeof EnterpriseSummaryReports_Schedule];
/** Enterprise schedule curriculum report input */
export type EnterpriseSummaryReports_ScheduleCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseSummaryReports_ScheduleEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Should report include data about removed members */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner engagement report input */
export type EnterpriseSummaryReports_ScheduleLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner performance report input */
export type EnterpriseSummaryReports_ScheduleLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner skills report input */
export type EnterpriseSummaryReports_ScheduleLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseSummaryReports_ScheduleMembershipReportInput = {
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule monthly digest email input */
export type EnterpriseSummaryReports_ScheduleMonthlyDigestEmailInput = {
  /** Org and programId context for report (programIds should be empty for monthly digest) */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule Verified Skill Path Progress report input */
export type EnterpriseSummaryReports_ScheduleVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** What context the report should be limited to */
export type EnterpriseSummaryReports_Scope = {
  /** Program ids to filter on */
  programIds: Array<Scalars['ID']>;
  /** Org id to filter on */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** High-level goal for the skillset which will be used for grouping, filtering, reporting, and clarity */
export const EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType = {
  Literacy: 'LITERACY',
  Reskill: 'RESKILL',
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType = typeof EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType[keyof typeof EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType];
/** High-level goal for the skillset which will be used for grouping, filtering, reporting, and clarity */
export const EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType = {
  Literacy: 'LITERACY',
  Reskill: 'RESKILL',
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType = typeof EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType[keyof typeof EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType];
/** ActivityFilterInput: all ActivityFilterInput variants */
export type EnterpriseUserAdminView_ActivityFilterInput = {
  /** assigned content */
  assignedContent?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_AssignedContentInput>;
  /** completed */
  completed?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_CompletedInput>;
  /** enrolled */
  enrolled?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_EnrolledInput>;
  /** enrolled but inactive */
  enrolledButInactive?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_EnrolledButInactiveInput>;
  /** general inactivity */
  generalInactivity?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_GeneralInactivityInput>;
  /** no enrollments */
  noEnrollments?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_NoEnrollmentsInput>;
  /** either not enrolled in the course or not completed the course */
  notEnrolledOrNotCompleted?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_NotEnrolledOrNotCompletedInput>;
};

/** activity filter for assigned content */
export type EnterpriseUserAdminView_ActivityFilter_AssignedContentInput = {
  /** selected product ids */
  contentSelection: EnterpriseUserAdminView_ContentSelectionInput;
  /** flag signifying completion or non-enrollment */
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  /** flag signifying enrollment or non-enrollment */
  isEnrolled?: InputMaybe<Scalars['Boolean']>;
};

/** activity filter for completed */
export type EnterpriseUserAdminView_ActivityFilter_CompletedInput = {
  /** date of completion */
  completionDate: EnterpriseUserAdminView_DateComparisonInput;
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for enrolled but inactive */
export type EnterpriseUserAdminView_ActivityFilter_EnrolledButInactiveInput = {
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** date of last activity */
  lastActivityDate: EnterpriseUserAdminView_DateComparisonInput;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for enrolled */
export type EnterpriseUserAdminView_ActivityFilter_EnrolledInput = {
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for general inactivity */
export type EnterpriseUserAdminView_ActivityFilter_GeneralInactivityInput = {
  /** date of last activity */
  lastActivityDate: EnterpriseUserAdminView_DateComparisonInput;
};

/** activity filter for no enrollments */
export type EnterpriseUserAdminView_ActivityFilter_NoEnrollmentsInput = {
  /** noop field - used to emulate an empty object since graphql-java does not support empty objects */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** activity filter for either not enrolled in the course or not completed the course */
export type EnterpriseUserAdminView_ActivityFilter_NotEnrolledOrNotCompletedInput = {
  /** selected product ids for the filter */
  productIdSelection: EnterpriseUserAdminView_ProductIdSelectionInput;
};

/** additional attribute selection */
export type EnterpriseUserAdminView_AdditionalAttributeSelectionInput = {
  /** attribute name */
  attributeName: EnterpriseUserAdminView_AttributeName;
  /** values in the list */
  values: Array<Scalars['ID']>;
};

/** AttributeName: all attribute names */
export const EnterpriseUserAdminView_AttributeName = {
  /** business unit */
  BusinessUnit: 'BUSINESS_UNIT',
  /** contract id */
  Contract: 'CONTRACT',
  /** job title */
  JobTitle: 'JOB_TITLE',
  /** job type */
  JobType: 'JOB_TYPE',
  /** location */
  Location: 'LOCATION',
  /** manager */
  Manager: 'MANAGER'
} as const;

export type EnterpriseUserAdminView_AttributeName = typeof EnterpriseUserAdminView_AttributeName[keyof typeof EnterpriseUserAdminView_AttributeName];
/** SortableColumn: all sortable columns */
export const EnterpriseUserAdminView_ColumnName = {
  /** business unit column */
  BusinessUnit: 'BUSINESS_UNIT',
  /** deleted at column */
  DeletedAt: 'DELETED_AT',
  /** invited at column */
  InvitedAt: 'INVITED_AT',
  /** is soft deleted column */
  IsSoftDeleted: 'IS_SOFT_DELETED',
  /** joined at column */
  JoinedAt: 'JOINED_AT',
  /** latest activity at column */
  LatestActivityAt: 'LATEST_ACTIVITY_AT',
  /** manager name column */
  ManagerName: 'MANAGER_NAME',
  /** name column */
  Name: 'NAME',
  /** number of enrollments column */
  NumCompletions: 'NUM_COMPLETIONS',
  /** number of enrollments column */
  NumEnrollments: 'NUM_ENROLLMENTS'
} as const;

export type EnterpriseUserAdminView_ColumnName = typeof EnterpriseUserAdminView_ColumnName[keyof typeof EnterpriseUserAdminView_ColumnName];
/** selected content */
export type EnterpriseUserAdminView_ContentInput = {
  /** content id */
  contentId: Scalars['ID'];
  /** content type */
  contentType: EnterpriseUserAdminView_ContentType;
};

/** selected content */
export type EnterpriseUserAdminView_ContentSelectionInput = {
  /** selected content */
  values: Array<EnterpriseUserAdminView_ContentInput>;
};

/** ContentType: all content types */
export const EnterpriseUserAdminView_ContentType = {
  /** course type */
  Course: 'COURSE',
  /** learning path type */
  LearningPath: 'LEARNING_PATH',
  /** specialization type */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseUserAdminView_ContentType = typeof EnterpriseUserAdminView_ContentType[keyof typeof EnterpriseUserAdminView_ContentType];
/** DateComparisonInput: all DateComparisonInput variants */
export type EnterpriseUserAdminView_DateComparisonInput = {
  /** absolute */
  absolute?: InputMaybe<EnterpriseUserAdminView_DateComparison_AbsoluteInput>;
  /** relative */
  relative?: InputMaybe<EnterpriseUserAdminView_DateComparison_RelativeInput>;
};

/** absolute date comparison type */
export type EnterpriseUserAdminView_DateComparison_AbsoluteInput = {
  /** time after */
  after?: InputMaybe<Scalars['DateTime']>;
  /** time before */
  before?: InputMaybe<Scalars['DateTime']>;
};

/** relative date comparison type */
export type EnterpriseUserAdminView_DateComparison_RelativeInput = {
  /** days after */
  nDaysAgoAfter?: InputMaybe<Scalars['Int']>;
  /** days before */
  nDaysAgoBefore?: InputMaybe<Scalars['Int']>;
};

/** user identifiers selected in the filters */
export type EnterpriseUserAdminView_FilterResultUserSelectionInput = {
  /** optional user identifiers: list of userIds and/or emails */
  userIdentifiers: Array<EnterpriseUserAdminView_UserIdentifierInput>;
};

/** PrimaryFilterInput: all PrimaryFilterInput variants */
export type EnterpriseUserAdminView_PrimaryFilterInput = {
  /** invited */
  invited?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_InvitedInput>;
  /** member */
  member?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_MemberInput>;
  /** multi primaryFilterType */
  multiFilter?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_MultiFilterInput>;
  /** removed member */
  removedMember?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_RemovedMemberInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_InvitedInput = {
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_MemberInput = {
  /** activity filter */
  activityFilter?: InputMaybe<EnterpriseUserAdminView_ActivityFilterInput>;
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
  /** program join date */
  programJoinDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_MultiFilterInput = {
  /** activity filter */
  activityFilter?: InputMaybe<EnterpriseUserAdminView_ActivityFilterInput>;
  /** List of membership states to query */
  membershipStates: Array<EnterpriseUserAdminView_UserProgramMembershipStatus>;
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
  /** program join date */
  programJoinDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** ScimState to query */
  scimManagedFilter?: InputMaybe<Scalars['Boolean']>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_RemovedMemberInput = {
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
};

/** An Enterprise Product Id object */
export type EnterpriseUserAdminView_ProductIdInput = {
  /** product item id */
  productItemId: Scalars['ID'];
  /** product type */
  productType: EnterpriseUserAdminView_ProductType;
};

/** selected product ids */
export type EnterpriseUserAdminView_ProductIdSelectionInput = {
  /** selected product ids */
  values: Array<EnterpriseUserAdminView_ProductIdInput>;
};

/** product type */
export const EnterpriseUserAdminView_ProductType = {
  /** specialization type */
  Specialization: 'SPECIALIZATION',
  /** course type */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type EnterpriseUserAdminView_ProductType = typeof EnterpriseUserAdminView_ProductType[keyof typeof EnterpriseUserAdminView_ProductType];
/** SortDirection: sort direction */
export const EnterpriseUserAdminView_SortDirection = {
  /** ascending sort direction */
  Ascending: 'ASCENDING',
  /** descending sort direction */
  Descending: 'DESCENDING'
} as const;

export type EnterpriseUserAdminView_SortDirection = typeof EnterpriseUserAdminView_SortDirection[keyof typeof EnterpriseUserAdminView_SortDirection];
/** SortRequest: a sort request */
export type EnterpriseUserAdminView_SortableColumnInput = {
  /** Column to sort by */
  columnName: EnterpriseUserAdminView_ColumnName;
  /** Direction to sort by */
  sortDirection?: EnterpriseUserAdminView_SortDirection;
};

/** primary filter */
export type EnterpriseUserAdminView_StringSelectionInput = {
  /** primary filter programId selections */
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** UserFilterInput: all filter parameters input relating to UserFilterV1 */
export type EnterpriseUserAdminView_UserFilterInput = {
  /** optional additional filters: list of additional filters */
  additionalAttributeSelections?: InputMaybe<Array<EnterpriseUserAdminView_AdditionalAttributeSelectionInput>>;
  /** optional selected filter user identifier selections */
  filterResultUserSelection?: InputMaybe<EnterpriseUserAdminView_FilterResultUserSelectionInput>;
  /** primary filter: membership state */
  primaryFilter: EnterpriseUserAdminView_PrimaryFilterInput;
  /** optional search name or emails: list of emails or names to search for */
  searchNameOrEmails?: InputMaybe<Array<Scalars['String']>>;
  /** optional sort by: list of sort requests */
  sortBy?: InputMaybe<Array<EnterpriseUserAdminView_SortableColumnInput>>;
};

/** UserIdentifierInput: all user identifiers (input) */
export type EnterpriseUserAdminView_UserIdentifierInput = {
  /** email */
  email?: InputMaybe<Scalars['ID']>;
  /** user id */
  userId?: InputMaybe<Scalars['ID']>;
};

/** User Program Membership status */
export const EnterpriseUserAdminView_UserProgramMembershipStatus = {
  /** invited status */
  Invited: 'INVITED',
  /** joined status */
  Joined: 'JOINED',
  /** removed status */
  Removed: 'REMOVED'
} as const;

export type EnterpriseUserAdminView_UserProgramMembershipStatus = typeof EnterpriseUserAdminView_UserProgramMembershipStatus[keyof typeof EnterpriseUserAdminView_UserProgramMembershipStatus];
/** Input argument for updating by email or user Id. */
export type EnterpriseUsers_EmailOrUserId = {
  /** Email: email associated with the user */
  email?: InputMaybe<Scalars['String']>;
  /** UserId: user's userId */
  userId?: InputMaybe<Scalars['Int']>;
};

/** Input data model for enterprise learner profile standard fields. */
export type EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput = {
  /** Business Unit */
  businessUnit?: InputMaybe<Scalars['String']>;
  /** Business Unit 2 */
  businessUnit2?: InputMaybe<Scalars['String']>;
  /** Job Title */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** job Type */
  jobType?: InputMaybe<Scalars['String']>;
  /** Location City */
  locationCity?: InputMaybe<Scalars['String']>;
  /** Location Country */
  locationCountry?: InputMaybe<Scalars['String']>;
  /** Location Region */
  locationRegion?: InputMaybe<Scalars['String']>;
  /** Manager Email */
  managerEmail?: InputMaybe<Scalars['String']>;
  /** Manager Name */
  managerName?: InputMaybe<Scalars['String']>;
};

/** Input argument for updating all fields of user data. */
export type EnterpriseUsers_FullUpdateUserDataInput = {
  /** Update by email or userId */
  emailOrUserId: EnterpriseUsers_EmailOrUserId;
  /** External Id to be updated */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Full name to be updated */
  fullName: Scalars['String'];
  /** Update by organization Id */
  orgId: Scalars['ID'];
  /** Standard fields to be updated */
  standardFields: EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput;
};

/** Input for resending the verification email for a user within an organization. */
export type EnterpriseUsers_ResendVerificationEmailInput = {
  /** Email address to verify; must be owned by the authenticated user */
  email: Scalars['String'];
  /** Org slug identifying the organization the user is acting within */
  orgSlug: Scalars['String'];
};

/** EnterpriseUsers_ResendVerificationEmail mutation error. */
export const EnterpriseUsers_ResendVerificationEmailResultError = {
  /** The email is not owned by the user or is already verified */
  NotEligibleForVerification: 'NOT_ELIGIBLE_FOR_VERIFICATION'
} as const;

export type EnterpriseUsers_ResendVerificationEmailResultError = typeof EnterpriseUsers_ResendVerificationEmailResultError[keyof typeof EnterpriseUsers_ResendVerificationEmailResultError];
/**
 * Billing type for an enterprise contract. Matches the values in the
 * enterprise_contract_billing_type column on the contracts dim table and
 * aligns with the existing EnterpriseContract_BillingType enum from the
 * legacy enterprise contract schema.
 */
export const Enterprise_ContractBillingType = {
  /** Billed via invoice (off-platform or automated). */
  Invoice: 'INVOICE',
  /**
   * Non-billable — typically test contracts or contracts not integrated
   * with any billing system.
   */
  None: 'NONE',
  /** One-time payment contract. */
  OneTime: 'ONE_TIME',
  /** Quarterly recurring billing. */
  Quarterly: 'QUARTERLY'
} as const;

export type Enterprise_ContractBillingType = typeof Enterprise_ContractBillingType[keyof typeof Enterprise_ContractBillingType];
/**
 * WES contract lifecycle state. Only applicable to SELF_SERVE contracts.
 * Sourced from enterprise_wes_contract_state on the contracts dim table.
 */
export const Enterprise_ContractState = {
  /** Contract is currently active and in use. */
  Active: 'ACTIVE',
  /** Contract has been created but not yet activated. */
  Created: 'CREATED',
  /** Contract has passed its end date. */
  Expired: 'EXPIRED',
  /** Contract is temporarily paused. */
  Paused: 'PAUSED',
  /** Contract has been terminated before its natural end date. */
  Terminated: 'TERMINATED',
  /** Contract state could not be determined. */
  Unknown: 'UNKNOWN'
} as const;

export type Enterprise_ContractState = typeof Enterprise_ContractState[keyof typeof Enterprise_ContractState];
/** TODO: Complete this description */
export const Entitlement_ProductType = {
  /** TODO: Complete this description */
  CatalogSubscription: 'CATALOG_SUBSCRIPTION',
  /** TODO: Complete this description */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** TODO: Complete this description */
  CredentialTrack: 'CREDENTIAL_TRACK',
  /** TODO: Complete this description */
  CredentialTrackCourse: 'CREDENTIAL_TRACK_COURSE',
  /** TODO: Complete this description */
  CredentialTrackCourseV2: 'CREDENTIAL_TRACK_COURSE_V2',
  /** TODO: Complete this description */
  CredentialTrackSubscription: 'CREDENTIAL_TRACK_SUBSCRIPTION',
  /** TODO: Complete this description */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** TODO: Complete this description */
  EnterpriseContract: 'ENTERPRISE_CONTRACT',
  /** TODO: Complete this description */
  FacilitatedLearning: 'FACILITATED_LEARNING',
  /** TODO: Complete this description */
  ProductTypeInvalid: 'PRODUCT_TYPE_INVALID',
  /** TODO: Complete this description */
  Specialization: 'SPECIALIZATION',
  /** TODO: Complete this description */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** TODO: Complete this description */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type Entitlement_ProductType = typeof Entitlement_ProductType[keyof typeof Entitlement_ProductType];
/** Real-time targeting options */
export type Eoi_RealTimeTargetingOptionsInput = {
  /** The URL parameters to match against */
  matchingUrlParameters?: InputMaybe<Array<Eoi_UrlParameterInput>>;
  /** Total time user spent on the page */
  totalTimeOnPageInMiliseconds?: InputMaybe<Scalars['Int']>;
};

/** An object that represents a URL key and value */
export type Eoi_UrlParameterInput = {
  /** The URL parameter key */
  key: Scalars['String'];
  /** The URL parameter value */
  value: Scalars['String'];
};

/** Determines how an experiment is allocated. */
export const Epic_AllocationType = {
  /** Experiment uses the visitor's email. This allocation type is used for logged out email tests. */
  ByEmail: 'BY_EMAIL',
  /** Experiment uses the visitor's web browser session cookie for allocation. This allocation type is the only way to run an experiment on logged-out visitors, but it also is unable to guarantee a consistent experience for a given user. */
  BySessionCookie: 'BY_SESSION_COOKIE',
  /** Experiment uses the URL at impression time for allocation. This allocation type is used for SEO tests. */
  ByUrl: 'BY_URL',
  /** Experiment uses the visitor's user id for allocation. This allocation type guarantees a consistent experience for a given user, but cannot be used to reach logged-out visitors. */
  ByUser: 'BY_USER',
  /** The allocation type could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_AllocationType = typeof Epic_AllocationType[keyof typeof Epic_AllocationType];
/** Represents how a client should be targeted. */
export type Epic_ClientTargetingInput = {
  /** The tags that should be targeted */
  byTag?: InputMaybe<Epic_TagTargetInput>;
};

/** Represents how a country should be targeted for an experiment. */
export type Epic_CountryTargetInput = {
  /** This can contain both ISO 3166-1 country codes and ISO 3166-2 subdivision codes. */
  countryCodes: Array<Scalars['String']>;
  /** Target type of the target */
  targetType: Epic_ListTargetType;
};

/** Input used to create an experiment. */
export type Epic_CreateExperimentInput = {
  /**
   * The email of the experiments creator
   * @deprecated FE should not dictate the creator of the experiment.
   */
  creatorEmail?: InputMaybe<Scalars['String']>;
  /** The new values of the experiment. */
  experiment: Epic_ExperimentInput;
};

/**
 * Represents the reason an experiment has ended.
 * This enum is deprecated and should not be used.
 */
export const Epic_ExperimentEndReason = {
  /** The experiment end reason could not be determined */
  Invalid: 'INVALID',
  /** Experiment was manually ended */
  Manual: 'MANUAL',
  /** Experiment ended because no clear winning variant could be found */
  NoClearWinner: 'NO_CLEAR_WINNER',
  /** Experiment ended because a winning variant was found */
  WinnerFound: 'WINNER_FOUND'
} as const;

export type Epic_ExperimentEndReason = typeof Epic_ExperimentEndReason[keyof typeof Epic_ExperimentEndReason];
/** Model shared by Epic_UpdateExperimentInput and Epic_CreateExperimentInput */
export type Epic_ExperimentInput = {
  /** The allocation type of the Experiment */
  allocationType: Epic_AllocationType;
  /** Date when cleanup was ended - only exists if code has been cleaned (Bool isCodeCleaned set by author in FE). */
  cleanupEndedAt?: InputMaybe<TimestampInput>;
  /**
   * The clientTargeting object is sent to the front end to support client side targeting
   * (i.e., when the information for targeting is not directly sent to EPIC, but the client
   * is able to access it). For example: course_id, partner_id
   */
  clientTargeting?: InputMaybe<Epic_ClientTargetingInput>;
  /** The experiments conclusion */
  conclusion?: InputMaybe<Scalars['String']>;
  /** Id of the default metric shown on Results page after experiment is complete */
  defaultMetricGroup: Scalars['String'];
  /** The description of the experiment */
  description: Scalars['String'];
  /** The display name of the Experiment */
  displayName: Scalars['String'];
  /** When the experiment ended */
  endedAt?: InputMaybe<TimestampInput>;
  /** The date the experiment is estimated to end */
  estimatedEndDate?: InputMaybe<TimestampInput>;
  /** The type of the Experiment */
  experimentType: Epic_ExperimentType;
  /**
   * The hash seed used to determine user allocation to the experiment.
   * This defaults to the experimentId but can be manually overridden. Cannot be required since the experiment ID is not known to the reads function.
   */
  hashSeed?: InputMaybe<Scalars['String']>;
  /** If specified, indicates that the experiment should exclude users associated with this holdout */
  holdoutName?: InputMaybe<Scalars['String']>;
  /**
   * Indicates the experiment is actually meant to act as a long term configuration
   * instead of an experiment.
   */
  isLongTermConfiguration?: InputMaybe<Scalars['Boolean']>;
  /** The override variants of the experiment */
  overrideVariants: Array<Epic_OverrideVariantInput>;
  /**
   * Array of teams that own the experiment.
   * The head of the Array is the primary owner of the experiment
   */
  owningTeams: Array<Scalars['String']>;
  /** The id of the primary metric */
  primaryMetricId?: InputMaybe<Scalars['String']>;
  /** The significance threshold of the primary metric */
  primaryMetricSignificanceThreshold?: InputMaybe<Scalars['Float']>;
  /**
   * The reason the experiment has ended
   * @deprecated This is a legacy field that is no longer used.
   */
  reasonEnded?: InputMaybe<Epic_ExperimentEndReason>;
  /** The percentage of targets who will participate in the rollout of the experiment. */
  rolloutFraction: Scalars['Float'];
  /** The serverTargeting object is used for server side targeting (e.g. ip address, GeoIP targeting) */
  serverTargeting?: InputMaybe<Epic_ServerTargetingInput>;
  /** When the experiment started */
  startedAt?: InputMaybe<TimestampInput>;
  /** The status of the experiment */
  status: Epic_ExperimentStatus;
  /** Coursera emails subscribed to the Experiment */
  subscriberEmails: Array<Scalars['String']>;
  /** If true, generate V3 Impression events based on V2 epic.experiment.show events */
  trackImpressions: Scalars['Boolean'];
  /**
   * The userTargeting object is used to target specifically on user data, including
   * user demography, behavior that are available in EDW as well as realtime user eventing data.
   */
  userTargeting?: InputMaybe<Scalars['String']>;
  /** The variants of the experiment */
  variants: Array<Epic_VariantInput>;
};

/** The column to sort on. */
export const Epic_ExperimentSortColumn = {
  /** Sort the cleanupEndedAt field of Epic_Experiment. */
  CleanupEndedAt: 'CLEANUP_ENDED_AT',
  /** Sort the createdAt field of Epic_Experiment. */
  CreatedAt: 'CREATED_AT',
  /** Sort on the creator field of Epic_Experiment */
  Creator: 'CREATOR',
  /** Sort on the displayName field of Epic_Experiment */
  DisplayName: 'DISPLAY_NAME',
  /** Sort the createdAt field of Epic_Experiment. */
  EndedAt: 'ENDED_AT',
  /** Sort the estimatedEndDate field of Epic_Experiment. */
  EstimatedEndDate: 'ESTIMATED_END_DATE',
  /** Sort on the owningTeams field of Epic_Experiment */
  OwningTeams: 'OWNING_TEAMS',
  /** Sort on the rolloutFraction field of Epic_Experiment */
  RolloutFraction: 'ROLLOUT_FRACTION',
  /** Sort the startedAt field of Epic_Experiment. */
  StartedAt: 'STARTED_AT',
  /** Sort on the status field of Epic_Experiment */
  Status: 'STATUS',
  /** Sort on the type field of Epic_Experiment */
  Type: 'TYPE'
} as const;

export type Epic_ExperimentSortColumn = typeof Epic_ExperimentSortColumn[keyof typeof Epic_ExperimentSortColumn];
/** Represents the status of an experiment. */
export const Epic_ExperimentStatus = {
  /** An ended experiment. The description field can be changed. No parameters will be served. */
  Ended: 'ENDED',
  /** The status could not be determined */
  Invalid: 'INVALID',
  /** A new experiment. All fields are open for editing. */
  New: 'NEW',
  /**
   * This means that the experiment has effectively ended but epic still needs to provide the
   * override parameters for the winning variant.
   */
  OnlyWinnerRunning: 'ONLY_WINNER_RUNNING',
  /** A running experiment. The description and rollout fraction fields can be changed. THe value field can also be changed if this is a ROLLOUT. The experiment is serving traffic in production. Variants will be served according to the rollout fraction. */
  Running: 'RUNNING',
  /** A testing experiment. All fields are open for editing. The rollout fraction is set to 0 and the default variant is served. */
  Testing: 'TESTING'
} as const;

export type Epic_ExperimentStatus = typeof Epic_ExperimentStatus[keyof typeof Epic_ExperimentStatus];
/** How an experiment is distributed */
export const Epic_ExperimentType = {
  /** Experiment is designed to support regular AB tests. At least two variants must be defined. When the experiment is running, variants cannot be changed. */
  Ab: 'AB',
  /** The experiment type could not be determined */
  Invalid: 'INVALID',
  /** Experiment is designed to support new feature rollout or configuration changes without deployment. Exactly one variant must be defined. When the experiment is running, the value of the variant can be changed. */
  Rollout: 'ROLLOUT'
} as const;

export type Epic_ExperimentType = typeof Epic_ExperimentType[keyof typeof Epic_ExperimentType];
/** Represents how headers should be aggregated for targeting. */
export const Epic_HeaderAggregationType = {
  /** Indicates all headers must match to be considered a valid target */
  All: 'ALL',
  /** Indicates any header can match to be considered a valid target */
  Any: 'ANY',
  /** Header aggregation type could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_HeaderAggregationType = typeof Epic_HeaderAggregationType[keyof typeof Epic_HeaderAggregationType];
/** Represents a single rule for matching the value of the specified header. */
export type Epic_HeaderRuleInput = {
  /** The header to examine. */
  header: Scalars['String'];
  /** Whether to match the value exactly or to simply check that the given value is contained in the header. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents the targeting rules for the experiment based on headers. */
export type Epic_HeaderTargetInput = {
  /** Whether to count any rule match or all rule matches as satisfying the targeting rules as a whole. */
  aggregationType: Epic_HeaderAggregationType;
  /** One or more rules to match. */
  headerRules: Array<Epic_HeaderRuleInput>;
  /** Whether to treat satisfying the targeting rules as a whitelist (include in experiment) or a blacklist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Represents the valid target types. */
export const Epic_ListTargetType = {
  /** Indicates the target should be excluded */
  Blacklist: 'BLACKLIST',
  /** list target type could not be determined */
  Invalid: 'INVALID',
  /** Indicates the target should be included */
  Whitelist: 'WHITELIST'
} as const;

export type Epic_ListTargetType = typeof Epic_ListTargetType[keyof typeof Epic_ListTargetType];
/** Used to indicate which id should be included/excluded from a variant. */
export type Epic_OverrideVariantInput = {
  /** The id used for allocation, usually is a userId or a sessionId. */
  id: Scalars['String'];
  /** A comment about this override variant */
  note: Scalars['String'];
  /**
   * Variant name should match one of the variants of the experiment. A missing
   * variantName indicates that the id should be excluded (opted out) from the experiment
   * entirely.
   */
  variantName?: InputMaybe<Scalars['String']>;
};

/** A parameter defined by a user. */
export type Epic_ParameterInfoInput = {
  /** The parameter namespace */
  namespace: Scalars['String'];
  /** The parameter */
  parameter: Scalars['String'];
  /** The value of the variant, This can be any JSON object. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** The attribute to sort on. */
export const Epic_PlatformStatusMetricSortBy = {
  /** Sort on the number of NEW experiments */
  CountOfNewExperiments: 'COUNT_OF_NEW_EXPERIMENTS',
  /** Sort on the number of RUNNING experiments */
  CountOfRunningExperiments: 'COUNT_OF_RUNNING_EXPERIMENTS',
  /** Sort on the number of TESTING experiments */
  CountOfTestingExperiments: 'COUNT_OF_TESTING_EXPERIMENTS',
  /** Sort on the total sum of NEW, TESTING, and RUNNING experiments. */
  CountOfUnEndedExperiments: 'COUNT_OF_UN_ENDED_EXPERIMENTS'
} as const;

export type Epic_PlatformStatusMetricSortBy = typeof Epic_PlatformStatusMetricSortBy[keyof typeof Epic_PlatformStatusMetricSortBy];
/** Represents how a predicate should be matched. */
export const Epic_PredicateType = {
  /** Indicates predicate should contain target. */
  Contains: 'CONTAINS',
  /** Inndicates predicate should end with target */
  EndsWith: 'ENDS_WITH',
  /** Indicates predicate should exactly match target */
  Exactly: 'EXACTLY',
  /** Predicate type could not be determined */
  Invalid: 'INVALID',
  /** Indicates predicate should start with target */
  StartsWith: 'STARTS_WITH'
} as const;

export type Epic_PredicateType = typeof Epic_PredicateType[keyof typeof Epic_PredicateType];
/** Represents how an experiment is targeted on the server. */
export type Epic_ServerTargetingInput = {
  /**
   * Rules for countries that should be included/excluded when targeting. This must be one of the following:
   * - ISO 3166-1 alpha-2 code for targeting countries
   * - ISO 3166-2 code for targeting subdivisions of countries
   */
  byCountry?: InputMaybe<Epic_CountryTargetInput>;
  /** Rules for headers that should be included/excluded when targeting. */
  byHeader?: InputMaybe<Epic_HeaderTargetInput>;
  /** Rules for user agents that should be included/excluded when targeting. */
  byUserAgent?: InputMaybe<Epic_UserAgentTargetInput>;
  /** Flag to exclude Course admins from targeting. */
  excludeCourseAdminsOption?: InputMaybe<Scalars['Boolean']>;
  /** Flag to exclude degree learners from targeting. */
  excludeDegreeLearnersOption?: InputMaybe<Scalars['Boolean']>;
  /** Flag to exclude enterprise learners from targeting */
  excludeEnterpriseLearnersOption?: InputMaybe<Scalars['Boolean']>;
};

/** The direction in which to sort the sort column of a query. */
export const Epic_SortDirection = {
  /** Sort the column in ascending order (oldest to newest). */
  Ascending: 'ASCENDING',
  /** Sort the column in descending order (newest to oldest). */
  Descending: 'DESCENDING'
} as const;

export type Epic_SortDirection = typeof Epic_SortDirection[keyof typeof Epic_SortDirection];
/** Represents a tag target. */
export type Epic_TagTargetInput = {
  /** The name of the tag */
  tagName: Scalars['String'];
  /** A list of tag values to target */
  tagValues: Array<Scalars['String']>;
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Input used to update an Experiment. */
export type Epic_UpdateExperimentInput = {
  /** The new values of the experiment. */
  experiment: Epic_ExperimentInput;
  /** The versioned id of the experiment to update. */
  id: Scalars['ID'];
};

/** Represents a single rule for matching the value of the UserAgent. */
export type Epic_UserAgentRuleInput = {
  /** Whether to match the value exactly or to simply check that the given value is contained in the value. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents the targeting rules for the experiment based on UserAgent. */
export type Epic_UserAgentTargetInput = {
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
  /** One or more rules to match. */
  userAgentRules: Array<Epic_UserAgentRuleInput>;
};

/** The experiment variant input. */
export type Epic_VariantInput = {
  /** The id of the variant. If id is null, it is assumed that this is a new variant. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the variant. */
  name: Scalars['String'];
  /** The variants parameters. */
  parameters: Array<Epic_ParameterInfoInput>;
  /** The status of the variant */
  status: Epic_VariantStatus;
  /** The weight of the variant. All variant weights must sum to 1. */
  weight: Scalars['Float'];
};

/** The status of a variant. */
export const Epic_VariantStatus = {
  /** The variant is active */
  Active: 'ACTIVE',
  /** The variant is not active */
  Inactive: 'INACTIVE',
  /** The variant status could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_VariantStatus = typeof Epic_VariantStatus[keyof typeof Epic_VariantStatus];
export const ErrorDetail = {
  /**
   * The deadline expired before the operation could complete.
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded: 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm: 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound: 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument: 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor: 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource: 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError: 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure: 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency: 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu: 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented: 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown: 'UNKNOWN'
} as const;

export type ErrorDetail = typeof ErrorDetail[keyof typeof ErrorDetail];
export const ErrorType = {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest: 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition: 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal: 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   * HTTP Mapping: 404 Not Found
   */
  NotFound: 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied: 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated: 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable: 'UNAVAILABLE',
  /**
   * Unknown error.
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown: 'UNKNOWN'
} as const;

export type ErrorType = typeof ErrorType[keyof typeof ErrorType];
/** TODO: Complete this description */
export const EvidenceType = {
  /** TODO: Complete this description */
  OutsourcingAgentRubricResponse: 'OUTSOURCING_AGENT_RUBRIC_RESPONSE',
  /** TODO: Complete this description */
  PreviousUserSubmission: 'PREVIOUS_USER_SUBMISSION',
  /** TODO: Complete this description */
  SubmissionFlaggedBySimilarityCheckSystem: 'SUBMISSION_FLAGGED_BY_SIMILARITY_CHECK_SYSTEM',
  /** TODO: Complete this description */
  SubmissionFlaggedByUser: 'SUBMISSION_FLAGGED_BY_USER',
  /** TODO: Complete this description */
  SubmissionRuledByStaff: 'SUBMISSION_RULED_BY_STAFF',
  /** TODO: Complete this description */
  SubmissionSimilarToOtherSubmission: 'SUBMISSION_SIMILAR_TO_OTHER_SUBMISSION',
  /** TODO: Complete this description */
  TestDetails: 'TEST_DETAILS',
  /** TODO: Complete this description */
  UserViewedOtherSubmission: 'USER_VIEWED_OTHER_SUBMISSION'
} as const;

export type EvidenceType = typeof EvidenceType[keyof typeof EvidenceType];
/** Assessment types */
export const ExamMonitor_AssessmentType = {
  /** Assignment item type */
  Assignment: 'ASSIGNMENT'
} as const;

export type ExamMonitor_AssessmentType = typeof ExamMonitor_AssessmentType[keyof typeof ExamMonitor_AssessmentType];
/** Input to end a recording. */
export type ExamRecording_EndRecordingInput = {
  /** ID of the recording that should be ended. */
  recordingId: Scalars['ID'];
};

/** Input to initialize a chunk and generate an upload URL. */
export type ExamRecording_InitializeChunkInput = {
  /** The chunk index starting from 0. */
  chunkIndex: Scalars['Int'];
  /** The recording for which the chunk is initialized. */
  recordingId: Scalars['ID'];
};

/** Input to initialize a segment and generate an upload URL. */
export type ExamRecording_InitializeSegmentInput = {
  /** The recording for which the segment is initialized. */
  recordingId: Scalars['ID'];
  /** The segment index starting from 0. */
  segmentIndex: Scalars['Int'];
};

/**
 * Input to reprocess recordings that previously failed processing.
 * INTERNAL USE ONLY: For manual intervention by engineers when processing failures need to be fixed.
 */
export type ExamRecording_ReprocessRecordingsInput = {
  /** The IDs of the recordings to reprocess. */
  recordingIds: Array<Scalars['ID']>;
};

/** The status of a recording. */
export const ExamRecording_Status = {
  /** The recording has been ended. */
  Ended: 'ENDED',
  /** The recording has failed processing. */
  ProcessingFailed: 'PROCESSING_FAILED',
  /** The recording has been processed successfully. */
  ProcessingSucceeded: 'PROCESSING_SUCCEEDED',
  /** The recording has been started. */
  Started: 'STARTED'
} as const;

export type ExamRecording_Status = typeof ExamRecording_Status[keyof typeof ExamRecording_Status];
/** Enum representing the different states for the export item feedback job. */
export const ExportItemFeedback_JobStatus = {
  /** Job has completed. */
  Completed: 'COMPLETED',
  /** Job is in the failed state. */
  Failed: 'FAILED',
  /** Job is in progress. */
  InProgress: 'IN_PROGRESS',
  /** Job has started. */
  Started: 'STARTED'
} as const;

export type ExportItemFeedback_JobStatus = typeof ExportItemFeedback_JobStatus[keyof typeof ExportItemFeedback_JobStatus];
/** Start export item feedback job input. */
export type ExportItemFeedback_StartExportItemFeedbackJobInput = {
  /** Course branch id for where the item to export feedback for exists. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /**
   * Course id for where the item to export feedback for exists.
   * @deprecated Use courseBranchId instead
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Item id of item to export feedback for. */
  itemId?: InputMaybe<Scalars['ID']>;
};

/** Input for authentication configuration. */
export type ExternalIntegration_AuthenticationConfigurationInput = {
  /** Authentication URL for the integration. */
  authUrl: Scalars['URL'];
  /** Client ID for authentication. */
  clientId: Scalars['ID'];
  /** Client secret for authentication. */
  clientSecret: Scalars['String'];
};

/** Input for content configuration. */
export type ExternalIntegration_ContentConfigurationInput = {
  /** Content URL for the integration. */
  contentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether skill content is enabled. */
  enableSkill?: InputMaybe<Scalars['Boolean']>;
  /** Whether video content is enabled. */
  enableVideo?: InputMaybe<Scalars['Boolean']>;
};

/** Input to create an external integration platform configuration. */
export type ExternalIntegration_CreateIntegrationConfigurationInput = {
  /** The external integration platform configuration to create. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Input to delete an external integration platform configuration. */
export type ExternalIntegration_DeleteIntegrationConfigurationInput = {
  /** The integration ID to delete. */
  integrationId: Scalars['ID'];
};

/** Input to get all external integration platform configurations. */
export type ExternalIntegration_GetAllIntegrationConfigurationsInput = {
  /** Optional filter to only return active configurations. */
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter by platform type. */
  platformType?: InputMaybe<ExternalIntegration_PlatformType>;
};

/** Input to get an external integration platform configuration by integration ID. */
export type ExternalIntegration_GetIntegrationConfigurationInput = {
  /** The integration ID to retrieve. */
  integrationId: Scalars['ID'];
};

/** Input to get external integration platform configurations by organization ID. */
export type ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdInput = {
  /** Optional filter to only return active configurations. */
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  /** The organization ID to filter by. */
  organizationId: Scalars['ID'];
  /** Optional filter by platform type. */
  platformType?: InputMaybe<ExternalIntegration_PlatformType>;
};

/** Input for external integration platform configuration. */
export type ExternalIntegration_IntegrationConfigurationInput = {
  /** Whether the integration is active. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<ExternalIntegration_XapiActorIdentificationType>;
  /** Authentication configuration for the integration. */
  authConfig: ExternalIntegration_AuthenticationConfigurationInput;
  /** Content configuration for the integration. */
  contentConfig?: InputMaybe<ExternalIntegration_ContentConfigurationInput>;
  /** Timestamp when the configuration was created. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who created the configuration. */
  createdBy?: InputMaybe<Scalars['ID']>;
  /** Unique identifier for the integration. */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** Whether the xapi integration is active. */
  isXapiEnabled?: Scalars['Boolean'];
  /** Organization ID associated with this integration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: ExternalIntegration_PlatformType;
  /** Tracking configuration for the integration. */
  trackingConfig?: InputMaybe<ExternalIntegration_TrackingConfigurationInput>;
  /** Timestamp when the configuration was last updated. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who last updated the configuration. */
  updatedBy?: InputMaybe<Scalars['ID']>;
};

/** Platform types for external integrations. */
export const ExternalIntegration_PlatformType = {
  /** Degreed platform. */
  PlatformTypeDegreed: 'PLATFORM_TYPE_DEGREED',
  /** Edcast platform. */
  PlatformTypeEdcast: 'PLATFORM_TYPE_EDCAST',
  /** Invalid platform type. */
  PlatformTypeInvalid: 'PLATFORM_TYPE_INVALID',
  /** Standard platform. */
  PlatformTypeStandard: 'PLATFORM_TYPE_STANDARD',
  /** Walmart platform. */
  PlatformTypeWalmart: 'PLATFORM_TYPE_WALMART',
  /** Workday platform. */
  PlatformTypeWorkday: 'PLATFORM_TYPE_WORKDAY'
} as const;

export type ExternalIntegration_PlatformType = typeof ExternalIntegration_PlatformType[keyof typeof ExternalIntegration_PlatformType];
/** Status of a sync operation. */
export const ExternalIntegration_SyncStatus = {
  /** Sync failed. */
  Failure: 'FAILURE',
  /** Sync is currently in progress. */
  Processing: 'PROCESSING',
  /** Sync completed successfully. */
  Success: 'SUCCESS'
} as const;

export type ExternalIntegration_SyncStatus = typeof ExternalIntegration_SyncStatus[keyof typeof ExternalIntegration_SyncStatus];
/** Input for tracking configuration. */
export type ExternalIntegration_TrackingConfigurationInput = {
  /** Whether to send item updates. */
  sendItemUpdates?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send non-graded items. */
  sendNonGradedItems?: InputMaybe<Scalars['Boolean']>;
  /** Tracking URL for the integration. */
  trackingUrl?: InputMaybe<Scalars['URL']>;
};

/** Input to update an external integration platform configuration. */
export type ExternalIntegration_UpdateIntegrationConfigurationInput = {
  /** The external integration platform configuration to update. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Input to validate an external integration platform configuration. */
export type ExternalIntegration_ValidateIntegrationConfigurationInput = {
  /** The external integration platform configuration to validate. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Types of validation errors. */
export const ExternalIntegration_ValidationErrorType = {
  /** Authentication failed. */
  ValidationErrorTypeAuthenticationFailed: 'VALIDATION_ERROR_TYPE_AUTHENTICATION_FAILED',
  /** Connection failed. */
  ValidationErrorTypeConnectionFailed: 'VALIDATION_ERROR_TYPE_CONNECTION_FAILED',
  /** Invalid validation error type. */
  ValidationErrorTypeInvalid: 'VALIDATION_ERROR_TYPE_INVALID',
  /** Invalid format. */
  ValidationErrorTypeInvalidFormat: 'VALIDATION_ERROR_TYPE_INVALID_FORMAT',
  /** Invalid URL. */
  ValidationErrorTypeInvalidUrl: 'VALIDATION_ERROR_TYPE_INVALID_URL',
  /** Required field is missing. */
  ValidationErrorTypeRequiredFieldMissing: 'VALIDATION_ERROR_TYPE_REQUIRED_FIELD_MISSING'
} as const;

export type ExternalIntegration_ValidationErrorType = typeof ExternalIntegration_ValidationErrorType[keyof typeof ExternalIntegration_ValidationErrorType];
/** Enumeration type representing which method to use to identify xAPI actors */
export const ExternalIntegration_XapiActorIdentificationType = {
  /** Method of composing xAPI actor using an enterprise user's configured external id. */
  XapiActorIdentificationTypeAccount: 'XAPI_ACTOR_IDENTIFICATION_TYPE_ACCOUNT',
  /** Invalid value. */
  XapiActorIdentificationTypeInvalid: 'XAPI_ACTOR_IDENTIFICATION_TYPE_INVALID',
  /** Method of composing xAPI actor using email address in a mailto: format. */
  XapiActorIdentificationTypeMbox: 'XAPI_ACTOR_IDENTIFICATION_TYPE_MBOX'
} as const;

export type ExternalIntegration_XapiActorIdentificationType = typeof ExternalIntegration_XapiActorIdentificationType[keyof typeof ExternalIntegration_XapiActorIdentificationType];
/** Input for retrieving default FAQs. */
export type Faq_DefaultFaqsInput = {
  /** Product ID to get the default fAQs For */
  productId: Scalars['ID'];
  /** The type of product to retrieve FAQs for (COURSE or SPECIALIZATION). */
  productType: Faq_ProductType;
};

/** Type discriminator for default FAQs based on product type. */
export const Faq_ProductType = {
  /** FAQs for courses. */
  Course: 'COURSE',
  /** FAQs for specializations. */
  Specialization: 'SPECIALIZATION'
} as const;

export type Faq_ProductType = typeof Faq_ProductType[keyof typeof Faq_ProductType];
/** Approve application request payload */
export type FinancialAidApplication_ApproveInput = {
  /** Application UUID */
  id: Scalars['ID'];
};

/** Career related questions */
export type FinancialAidApplication_CareerProgressionQuestionnaireInput = {
  /** How this course will contribute to the applicants career */
  howContributeToCareer?: InputMaybe<Scalars['String']>;
  /** How this course will contribute to the applicants community */
  howContributeToCommunity?: InputMaybe<Scalars['String']>;
  /** Why this applicant is applying */
  whyApplying?: InputMaybe<Scalars['String']>;
  /** Why this applicant wants to take this course */
  whyTakingCourse?: InputMaybe<Scalars['String']>;
};

/** Create application request payload */
export type FinancialAidApplication_CreateInput = {
  /** Career progression questionnaire */
  careerProgressionQuestionnaire?: InputMaybe<FinancialAidApplication_CareerProgressionQuestionnaireInput>;
  /** The Cart Id associated with this application */
  cartId: Scalars['ID'];
  /** The country code of the applicant */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Education background */
  educationalBackground?: InputMaybe<FinancialAidApplication_EducationalBackgroundInput>;
  /** External financial assistance questionnaire */
  externalFinancialAssistanceQuestionnaire?: InputMaybe<FinancialAidApplication_ExternalFinancialAssistanceQuestionnaireInput>;
  /** Financial background */
  financialBackground?: InputMaybe<FinancialAidApplication_FinancialBackgroundInput>;
  /** The ID of the user associated with the application */
  userId: Scalars['ID'];
};

/** Education related questions */
export type FinancialAidApplication_EducationalBackgroundInput = {
  /** The educational background of the applicant eg: HIGH_SCHOOL */
  educationalBackground?: InputMaybe<Scalars['String']>;
};

/** External financial information */
export type FinancialAidApplication_ExternalFinancialAssistanceQuestionnaireInput = {
  /** Why the applicant is not willing to take out a loan for this course */
  whyNotWillingToTakeOutLoan?: InputMaybe<Scalars['String']>;
  /** Is the applicant willing to take out a loan for this course? */
  willingToTakeOutLoan?: InputMaybe<Scalars['Boolean']>;
};

/** Financial Background */
export type FinancialAidApplication_FinancialBackgroundInput = {
  /** How much the applicant can pay to take this course */
  affordToPay: Scalars['Float'];
  /** The currency code for the applicant */
  affordToPayCurrencyCode: CurrencyCode;
  /** The annual income of the applicant */
  annualIncome: Scalars['Float'];
  /** The type of currency referred to for annualIncome */
  annualIncomeCurrencyCode: Scalars['String'];
  /** The current employment status of the applicant */
  employmentStatus?: InputMaybe<Scalars['String']>;
  /** How often does the applicant get paid */
  payPeriod?: InputMaybe<Scalars['String']>;
};

/** Product Id input for encapsulating both the ProductType and ProductItemId together in one object. */
export type FinancialAidApplication_ProductIdInput = {
  /** Product item ID identifying the corresponding product. */
  productItemId: Scalars['ID'];
  /** Product types supported by the Financial Aid endpoints. */
  productType: FinancialAidApplication_ProductType;
};

/** The supported product types for Financial Aid */
export const FinancialAidApplication_ProductType = {
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type FinancialAidApplication_ProductType = typeof FinancialAidApplication_ProductType[keyof typeof FinancialAidApplication_ProductType];
/** An enumerate the state of the application */
export const FinancialAidApplication_State = {
  /** The application is APPROVED */
  Approved: 'APPROVED',
  /** PAYMENT_PENDING to APPROVED_PAID. State change after successful payment of discounted price */
  ApprovedPaid: 'APPROVED_PAID',
  /**
   * PAYMENT_PENDING to PAYMENT_EXPIRED if payment is not made within N days.
   * ( N is the # of days since application was created )
   */
  PaymentExpired: 'PAYMENT_EXPIRED',
  /**
   * PENDING to PAYMENT_PENDING for <100% discounted applications.
   * Requires learner to make payment of the discounted price
   */
  PaymentPending: 'PAYMENT_PENDING',
  /** The application is PENDING */
  Pending: 'PENDING',
  /** The application is REJECTED */
  Rejected: 'REJECTED',
  /** The applicant has chosen to withdraw this application */
  Withdrawn: 'WITHDRAWN'
} as const;

export type FinancialAidApplication_State = typeof FinancialAidApplication_State[keyof typeof FinancialAidApplication_State];
export const FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState = {
  Approved: 'APPROVED',
  ApprovedPaid: 'APPROVED_PAID',
  ApprovedPaymentSuccessful: 'APPROVED_PAYMENT_SUCCESSFUL',
  PaymentExpired: 'PAYMENT_EXPIRED',
  PaymentPending: 'PAYMENT_PENDING',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Withdrawn: 'WITHDRAWN'
} as const;

export type FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState = typeof FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState[keyof typeof FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState];
/** Flashcards_ItemIdFilterMode enumeration */
export const Flashcards_ItemIdFilterMode = {
  /** Return only flashcards for that item */
  Exact: 'EXACT',
  /** Return flashcards up to the item */
  UpTo: 'UP_TO'
} as const;

export type Flashcards_ItemIdFilterMode = typeof Flashcards_ItemIdFilterMode[keyof typeof Flashcards_ItemIdFilterMode];
/** Flashcards_ItemType enumeration */
export const Flashcards_ItemType = {
  /** Lecture item type */
  Lecture: 'LECTURE',
  /** Reading item type */
  Reading: 'READING'
} as const;

export type Flashcards_ItemType = typeof Flashcards_ItemType[keyof typeof Flashcards_ItemType];
/** ThirdPartyOrganization GDPR Modes define the expected account creation and existence of third party accounts where organizations have various restrictions on how and when they want users to be able to create recover accounts, etc. See https://coursera.atlassian.net/wiki/spaces/PROD/pages/560300101/SSO+Login+and+Account+Creation+Usability+and+GDPR+Compliance+across+SSO+and+Non-SSO+Orgs#Acceptance-Criteria */
export const GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode = {
  GdprModeDefault: 'GDPR_MODE_DEFAULT',
  GdprModeLight: 'GDPR_MODE_LIGHT',
  GdprModeRestrictive: 'GDPR_MODE_RESTRICTIVE',
  GdprModeStrict: 'GDPR_MODE_STRICT'
} as const;

export type GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode = typeof GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode[keyof typeof GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode];
/** Gibberish check status */
export const GibberishStatus = {
  /** Gibberish is skipped for a given prompt since it's not part of the allowlist */
  GibberishSkipped: 'GIBBERISH_SKIPPED',
  /** Gibberish is detected for a given prompt */
  IsGibberish: 'IS_GIBBERISH',
  /** Gibberish is not detected for a given prompt */
  NotGibberish: 'NOT_GIBBERISH'
} as const;

export type GibberishStatus = typeof GibberishStatus[keyof typeof GibberishStatus];
/** Parameters required to query a single Graded Item Locking enablement */
export type GradedItemLocking_EnablementInput = {
  /** Course whose enablement status to lookup */
  courseId: Scalars['ID'];
  /** Institution the program should be in for enablement lookup */
  institutionId: Scalars['ID'];
  /** Program the course should be in for enablement lookup */
  programId: Scalars['ID'];
};

/** The enablement to update and the enablement status */
export type GradedItemLocking_UpdateEnablementInput = {
  /** The course to update Graded Item Locking enablement status for */
  courseId: Scalars['ID'];
  /** The new enablement status to be set */
  enableGradedItemLocking: Scalars['Boolean'];
  /** The institution in which the course enablement should get updated */
  institutionId: Scalars['ID'];
  /** The program in which the course enablement should get updated */
  programId: Scalars['ID'];
};

/** Set learner plugin grade input */
export type GradedPlugin_SetLearnerPluginGradeInput = {
  /** Course branch id */
  courseBranchId: Scalars['ID'];
  /** Course id */
  courseId: Scalars['ID'];
  /** It's a normalized grade (between 0 and 1) */
  grade: Scalars['Float'];
  /** Item id */
  itemId: Scalars['ID'];
  /** Passing fraction (between 0 and 1) */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Widget session id */
  widgetSessionId: Scalars['ID'];
};

/** Values representing column names of the grader performance dashboard */
export const GraderPerformance_DashboardColumn = {
  /** assignmentsContributedCount column */
  AssignmentsContributedCount: 'ASSIGNMENTS_CONTRIBUTED_COUNT',
  /** averageCommentLengthPerRubric column */
  AverageCommentLengthPerRubric: 'AVERAGE_COMMENT_LENGTH_PER_RUBRIC',
  /** averageGradePerRubric column */
  AverageGradePerRubric: 'AVERAGE_GRADE_PER_RUBRIC',
  /** averageTimePerRubric column */
  AverageTimePerRubric: 'AVERAGE_TIME_PER_RUBRIC',
  /** overwrittenRubricsCount column */
  OverwrittenRubricsCount: 'OVERWRITTEN_RUBRICS_COUNT',
  /** rubricsContributedCount column */
  RubricsContributedCount: 'RUBRICS_CONTRIBUTED_COUNT'
} as const;

export type GraderPerformance_DashboardColumn = typeof GraderPerformance_DashboardColumn[keyof typeof GraderPerformance_DashboardColumn];
/** Input for GraderPerformance_RefreshGroupMetrics mutation. */
export type GraderPerformance_RefreshGroupMetricsInput = {
  /** The groupId */
  groupId: Scalars['ID'];
};

/** Enum for explaining why the refresh of the group grader performance was not triggered */
export const GraderPerformance_RefreshGroupMetricsNotTriggeredReason = {
  /**
   * We don't trigger the refresh for group grader performance metrics if there is already an
   * ongoing refresh
   */
  ExistingRefershInProgress: 'EXISTING_REFERSH_IN_PROGRESS'
} as const;

export type GraderPerformance_RefreshGroupMetricsNotTriggeredReason = typeof GraderPerformance_RefreshGroupMetricsNotTriggeredReason[keyof typeof GraderPerformance_RefreshGroupMetricsNotTriggeredReason];
/**
 * Input for GraderPerformance_SaveDashboardSessionSettings mutation.
 * It is expected to provide all the fields of the settings every time you call the mutation
 */
export type GraderPerformance_SaveDashboardSessionSettingsInput = {
  /**
   * List of graders' userIds that are bookmarked, the caller is expected to provide all fields of
   * the settings even if they only want to change a single value
   */
  bookmarkedGraderIds: Array<Scalars['ID']>;
  /** The groupId */
  groupId: Scalars['ID'];
  /**
   * Columns to hide on the grader dashboard, the caller is expected to provide all fields of
   * the settings even if they only want to change a single value
   */
  hiddenColumns: Array<GraderPerformance_DashboardColumn>;
};

/** Input parameters for GradesDisclaimerQueries */
export type GradesDisclaimer_QueryByUserAndCourseInput = {
  /** The ID of the course for which the grades disclaimer is being fetched. */
  courseId: Scalars['ID'];
};

/** Comment filter for the GraphQL queries */
export type GradingComments_CommentFilter = {
  /** [Required] filters results to assignment id */
  assignmentId: Scalars['ID'];
  /**
   * [Deprecated] [Optional] filter results based on provided search text
   * @deprecated use partialCommentContent instead
   */
  partialComment?: InputMaybe<Scalars['String']>;
  /** [Optional] filter results based on provided partial CmlContent */
  partialCommentContent?: InputMaybe<CmlContentInput>;
  /** [Required] filters results to review part id */
  reviewPartId: Scalars['ID'];
};

/** Input of the GradingComments_CreateComment mutation */
export type GradingComments_CreateCommentInput = {
  /** [required] comment's assignment id */
  assignmentId: Scalars['ID'];
  /** [required] comment's assignment version */
  assignmentVersion: Scalars['Int'];
  /** [required] see CmlContentInput */
  commentContentInput: CmlContentInput;
  /** [required] comment's review part id */
  reviewPartId: Scalars['ID'];
};

/** Input of GradingComments_CreateCommentUsage mutation */
export type GradingComments_CreateCommentUsageInput = {
  /** [required] assignment id */
  assignmentId: Scalars['ID'];
  /** [required] assignment version */
  assignmentVersion: Scalars['Int'];
  /** [required] comment id */
  commentId: Scalars['ID'];
  /** [required] review part id */
  reviewPartId: Scalars['ID'];
};

/** Input of the GradingComments_DeleteComment mutation */
export type GradingComments_DeleteCommentInput = {
  /** [required] comment id */
  commentId: Scalars['ID'];
};

/** Input of the GradingComments_DeleteCommentUsages mutation */
export type GradingComments_DeleteCommentUsagesInput = {
  /** [required] comment's assignment id */
  assignmentId: Scalars['ID'];
  /** [required] comment id */
  commentId: Scalars['ID'];
  /** [required] comment's review part id */
  reviewPartId: Scalars['ID'];
};

/** Input of the GradingComments_UpdateComment mutation */
export type GradingComments_UpdateCommentInput = {
  /** [required] see CmlContentInput */
  commentContentInput: CmlContentInput;
  /** [required] comment id */
  commentId: Scalars['ID'];
};

/** Overall grading status */
export const Grading_Status = {
  /** All grading activities are finished */
  Graded: 'GRADED',
  /** Human/AI Grading has started but it incomplete */
  Grading: 'GRADING',
  /** Grading has not started yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Grading_Status = typeof Grading_Status[keyof typeof Grading_Status];
/** Input for GroupGrading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideInput = {
  /** Comment to be surfaced to learners for the grade override. */
  explanation?: InputMaybe<Scalars['String']>;
  /** Grade of the override. */
  grade: Scalars['Float'];
  /** Comment to be surfaced to partners for the grade override. */
  partnerExplanation?: InputMaybe<Scalars['String']>;
  /**
   * Parameters for locating the submitter's assignment to apply a grade override: {groupId, itemId,
   * submitterId} (can be single user or team)
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Input for Grading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideV2Input = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** Comment to be surfaced to learners for the grade override. */
  explanation?: InputMaybe<Scalars['String']>;
  /**
   * Grade of the override.
   * The value is in range 0-1 for grades 0%-100%. The grade may be higher if extra credit is applied.
   */
  grade: Scalars['Float'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** Comment to be surfaced to partners for the grade override. */
  partnerExplanation?: InputMaybe<Scalars['String']>;
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** Input for GroupGrading_BatchUpdateGradeVisibility mutation. */
export type GroupGrading_BatchUpdateGradeVisibilityInput = {
  /**
   * How to handle existing grade override and grade visibility drafts, will default to publishing
   * existing drafts like legacy behaviour in grading list view.
   */
  draftAction?: InputMaybe<GroupGrading_GradeVisibilityAndOverrideDraftAction>;
  /** groupId of top-level group for the private session. */
  groupId: Scalars['ID'];
  /** Whether to hide the grade or not. */
  isHidden: Scalars['Boolean'];
  /** itemId */
  itemId: Scalars['ID'];
  /** List of submitterId (can be user~[userId] or team~[teamId]). */
  submitterIds: Array<Scalars['ID']>;
};

/** [DEPRECATED] Input for GroupGrading_BatchUpdateReviewPartResponse mutation. */
export type GroupGrading_BatchUpdateReviewPartResponseInput = {
  /** List of choices updates for review part response. */
  choicesUpdates: Array<GroupGrading_ReviewPartResponseChoicesUpdate>;
  /** List of comment updates for review part response. */
  commentUpdates: Array<GroupGrading_ReviewPartResponseCommentUpdate>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** List of score updates for review part response. */
  scoreUpdates: Array<GroupGrading_ReviewPartResponseScoreUpdate>;
};

/**
 * Used to bach update all of the rubric part responses at the same time. Note that this is organized
 * by rubric part response type instead of by rubric part form field. It also includes some additional
 * data that allows us to save an extra request to the "assignment" service in the BE.
 */
export type GroupGrading_BatchUpdateReviewPartResponsesInput = {
  /** Actions currently allowed by the BE in relation to current submission / grading state */
  allowedGradingActions: Array<GroupGrading_GradingStepActionType>;
  /** Collection of "inline feedback" review part responses */
  boxResponses: Array<GroupGrading_BoxReviewPartResponseInput>;
  /**
   * [Optional]. Conflict metadata previously fetched from sgaSubmission. The "correct" value may be
   * null
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Used to identify current grading task for submission */
  gradingTaskIdHash: Scalars['String'];
  /**
   * FE will compute if all rubric parts are complete.
   * If true, BE may combine step actions (i.e. update and submit) for performance boost.
   * If absent, it will be assumed to be false.
   */
  isRubricComplete?: InputMaybe<Scalars['Boolean']>;
  /** Collection of "multiLine" review part responses, question- and assignment-level */
  multiLineResponses: Array<GroupGrading_MultiLineInputReviewPartResponseInput>;
  /** Collection of "options" review part responses, question- and assignment-level */
  optionsResponses: Array<GroupGrading_OptionsReviewPartResponseInput>;
  /** Parameters for locating latest submission: {groupId, itemId, submitterId} */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Input type for "inline feedback" rubric part responses */
export type GroupGrading_BoxReviewPartResponseInput = {
  /** indicates whether they are "done" with adding inline feedback or not. */
  annotationComplete: Scalars['Boolean'];
  /** to add comment */
  fileId: Scalars['String'];
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
};

/** Input for GroupGrading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideInput = {
  /**
   * Parameters for locating the submitter's assignment to delete a grade override: {groupId, itemId,
   * submitterId}
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Input for Grading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideV2Input = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** Possible actions for grade override and grade visibility drafts. */
export const GroupGrading_GradeVisibilityAndOverrideDraftAction = {
  /** Discard any existing drafts for grade overrides and grade visibility. */
  DiscardExistingDrafts: 'DISCARD_EXISTING_DRAFTS',
  /**
   * Publish any existing drafts for grade overrides and grade visibility, like legacy behaviour in
   * grading list view's batch hide/unhide grades.
   */
  PublishExistingDrafts: 'PUBLISH_EXISTING_DRAFTS'
} as const;

export type GroupGrading_GradeVisibilityAndOverrideDraftAction = typeof GroupGrading_GradeVisibilityAndOverrideDraftAction[keyof typeof GroupGrading_GradeVisibilityAndOverrideDraftAction];
/** Subset of org.coursera.assignment.StepActionType used in grading flow */
export const GroupGrading_GradingStepActionType = {
  /** Allows someone to start grading (and send initial responses) */
  StartDraft: 'START_DRAFT',
  /** Allows someone to start and submit responses to gradebook */
  StartUpdateAndSubmitDraft: 'START_UPDATE_AND_SUBMIT_DRAFT',
  /** Allows someone to submit previously saved responses to gradebook */
  SubmitLatestDraft: 'SUBMIT_LATEST_DRAFT',
  /** Allows someone to save new responses and submit to gradebook */
  UpdateAndSubmitDraft: 'UPDATE_AND_SUBMIT_DRAFT',
  /** Allows someone to save new responses */
  UpdateDraft: 'UPDATE_DRAFT'
} as const;

export type GroupGrading_GradingStepActionType = typeof GroupGrading_GradingStepActionType[keyof typeof GroupGrading_GradingStepActionType];
/** TODO: Complete this description */
export type GroupGrading_GradingTaskFilter = {
  /** task must be for one of these submitters */
  submitterIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** TODO: Complete this description */
export type GroupGrading_ItemFilter = {
  /** If provided, filters results to item ids. */
  itemIds?: InputMaybe<Array<Scalars['ID']>>;
  /** If provided, filters results to itemTypes. */
  itemTypes?: InputMaybe<Array<GroupGrading_ItemType>>;
};

/**
 * Possible types of an item, corresponding to the type names in
 * org.coursera.ondemand.coursematerial.stored.StoredContent, but not comprehensive, only containing
 * types that are relevant in the context of group grading.
 */
export const GroupGrading_ItemType = {
  /** TODO: Complete this description */
  StaffGradedAssignment: 'STAFF_GRADED_ASSIGNMENT',
  /** TODO: Complete this description */
  Unknown: 'UNKNOWN'
} as const;

export type GroupGrading_ItemType = typeof GroupGrading_ItemType[keyof typeof GroupGrading_ItemType];
/** Input type for "multiLine" rubric part responses */
export type GroupGrading_MultiLineInputReviewPartResponseInput = {
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: InputMaybe<Scalars['ID']>;
  /** Text representing grader comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Type of grader for this review response */
  graderType?: AssignmentPresentations_GraderType;
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
  /**
   * Rich text representing grader comment.
   * This field is replacing plain text comment field.
   */
  richTextComment?: InputMaybe<CmlContentInput>;
  /** Score provided by grader. */
  score?: InputMaybe<Scalars['Float']>;
};

/** Input type for "options" rubric part responses */
export type GroupGrading_OptionsReviewPartResponseInput = {
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: InputMaybe<Scalars['ID']>;
  /** Represents selected choices. May be empty if none chosen. */
  choices: Array<Scalars['String']>;
  /** Type of grader for this review response */
  graderType?: AssignmentPresentations_GraderType;
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
  /** [optional] rich text input */
  richTextInput?: InputMaybe<CmlContentInput>;
};

/** [DEPRECATED] Input for GroupGrading_PublishGradesToGradeBook mutation. */
export type GroupGrading_PublishGradesToGradeBookInput = {
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   *
   * responses and reviewConflictMetadata must be re-fetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Choices update for review part response. */
export type GroupGrading_ReviewPartResponseChoicesUpdate = {
  /**
   * The list may be empty if no choices are selected. Or if multiple choices are
   * selected, they all need to be present in this list.
   */
  choices: Array<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Comment update for review part response. */
export type GroupGrading_ReviewPartResponseCommentUpdate = {
  /** [optional] plain text comment. sending no value will unset the comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Score update for review part response. */
export type GroupGrading_ReviewPartResponseScoreUpdate = {
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** [optional] integer or decimal values >= 0. sending no value will unset the score. */
  score?: InputMaybe<Scalars['Float']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** TODO: Complete this description */
export type GroupGrading_SgaSubmissionHeaderFilter = {
  /** submission must match one of the following ids */
  submissionIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** possible statuses of item submission, equivalent to org.coursera.ondemand.staffgraded.submission.SubmissionStatus */
export const GroupGrading_SgaSubmissionStatus = {
  /** TODO: Complete this description */
  AwaitingPeerReview: 'AWAITING_PEER_REVIEW',
  /** TODO: Complete this description */
  Deleted: 'DELETED',
  /** TODO: Complete this description */
  GradeReleased: 'GRADE_RELEASED',
  /** TODO: Complete this description */
  GradingFinished: 'GRADING_FINISHED',
  /** TODO: Complete this description */
  GradingStarted: 'GRADING_STARTED',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED',
  /** TODO: Complete this description */
  NotYetSubmitted: 'NOT_YET_SUBMITTED',
  /** TODO: Complete this description */
  ReadyForGrading: 'READY_FOR_GRADING'
} as const;

export type GroupGrading_SgaSubmissionStatus = typeof GroupGrading_SgaSubmissionStatus[keyof typeof GroupGrading_SgaSubmissionStatus];
/**
 * These are a set of ids (groupId, itemId, and submitterId) that allow us to locate the latest
 * individual assignment submission for a learner. It would be ideal if we could use a single
 * submission id or attempt id, but the assignment system doesn't present that option (a consequence
 * of "off-platform" only submissions). The original API used (userId, courseId, itemId) for these
 * query parameters.  I decided to change to (groupId, itemId, and submitterId) as this is more
 * aligned with our group and submitter-oriented graphql query design.
 */
export type GroupGrading_SubmissionReference = {
  /** groupId of top-level group for the private session. */
  groupId: Scalars['ID'];
  /** itemId */
  itemId: Scalars['ID'];
  /** submitterId (either user~[userId] or team~[teamId]). */
  submitterId: Scalars['ID'];
};

/** Input for GroupGrading_SubmitGradesToGradeBook mutation. */
export type GroupGrading_SubmitGradesToGradeBookInput = {
  /**
   * [Optional]. Conflict metadata previously fetched from sgaSubmission. The "correct" value may be
   * null
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Used to identify current grading task for submission */
  gradingTaskIdHash: Scalars['String'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Input for GroupGrading_UpdateGradeVisibility mutation. */
export type GroupGrading_UpdateGradeVisibilityInput = {
  /** Whether to hide the grade or not. */
  isHidden: Scalars['Boolean'];
  /**
   * Parameters for locating the submitter's assignment to update grade visibility: {groupId, itemId,
   * submitterId} (can be single user or team)
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseChoices mutation. */
export type GroupGrading_UpdateReviewPartResponseChoicesInput = {
  /**
   * The list may be empty if no choices are selected. Or if multiple choices are
   * selected, they all need to be present in this list.
   */
  choices: Array<Scalars['String']>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseComment mutation. */
export type GroupGrading_UpdateReviewPartResponseCommentInput = {
  /** [optional] plain text comment. sending no value will unset the comment. */
  comment?: InputMaybe<Scalars['String']>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST:ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseScore mutation. */
export type GroupGrading_UpdateReviewPartResponseScoreInput = {
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** [optional] integer or decimal values >= 0. sending no value will unset the score. */
  score?: InputMaybe<Scalars['Float']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature = typeof GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature];
export const GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource = {
  Coursera: 'COURSERA',
  Credly: 'CREDLY',
  Invalid: 'INVALID'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource = typeof GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
/** Reason for the resulting course material next step. */
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = {
  Default: 'DEFAULT',
  ExamFailedTryAgain: 'EXAM_FAILED_TRY_AGAIN',
  ExamFailedTryLater: 'EXAM_FAILED_TRY_LATER',
  ExamOntrack: 'EXAM_ONTRACK',
  ExamOverdue: 'EXAM_OVERDUE',
  ExamVerify: 'EXAM_VERIFY',
  GradedAssignmentFailedTryAgain: 'GRADED_ASSIGNMENT_FAILED_TRY_AGAIN',
  GradedAssignmentFailedTryLater: 'GRADED_ASSIGNMENT_FAILED_TRY_LATER',
  GradedAssignmentOntrack: 'GRADED_ASSIGNMENT_ONTRACK',
  GradedAssignmentOverdue: 'GRADED_ASSIGNMENT_OVERDUE',
  GradedAssignmentVerify: 'GRADED_ASSIGNMENT_VERIFY',
  GradedPeerFailed: 'GRADED_PEER_FAILED',
  GradedPeerOntrack: 'GRADED_PEER_ONTRACK',
  GradedPeerOverdue: 'GRADED_PEER_OVERDUE',
  GradedPeerReviewOntrack: 'GRADED_PEER_REVIEW_ONTRACK',
  GradedPeerReviewOverdue: 'GRADED_PEER_REVIEW_OVERDUE',
  GradedPeerUnsubmittedOntrack: 'GRADED_PEER_UNSUBMITTED_ONTRACK',
  GradedPeerUnsubmittedOverdue: 'GRADED_PEER_UNSUBMITTED_OVERDUE',
  GradedPeerVerify: 'GRADED_PEER_VERIFY',
  PracticeAssignmentOntrack: 'PRACTICE_ASSIGNMENT_ONTRACK',
  PracticeAssignmentOverdue: 'PRACTICE_ASSIGNMENT_OVERDUE',
  QuizOntrack: 'QUIZ_ONTRACK',
  QuizOverdue: 'QUIZ_OVERDUE',
  StudyMaterialOntrack: 'STUDY_MATERIAL_ONTRACK',
  StudyMaterialOverdue: 'STUDY_MATERIAL_OVERDUE',
  TmrFailed: 'TMR_FAILED',
  TmrUnsubmittedOntrack: 'TMR_UNSUBMITTED_ONTRACK',
  TmrUnsubmittedOverdue: 'TMR_UNSUBMITTED_OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
export const HttpMethod = {
  Connect: 'CONNECT',
  Delete: 'DELETE',
  Get: 'GET',
  Head: 'HEAD',
  Options: 'OPTIONS',
  Patch: 'PATCH',
  Post: 'POST',
  Put: 'PUT',
  Trace: 'TRACE'
} as const;

export type HttpMethod = typeof HttpMethod[keyof typeof HttpMethod];
/** An unique identifier to check honorlock enablement */
export type HonorlockEnablement_Input = {
  /** Assignment id */
  assignmentId: Scalars['ID'];
  /** Assignment type */
  assignmentType: Honorlock_AssignmentType;
  /** Session id */
  sessionId: Scalars['ID'];
};

/** The status of enablement */
export const HonorlockEnablement_Status = {
  /** Disable Honorlock */
  Disable: 'DISABLE',
  /** Enable Honorlock */
  Enable: 'ENABLE'
} as const;

export type HonorlockEnablement_Status = typeof HonorlockEnablement_Status[keyof typeof HonorlockEnablement_Status];
/** Assignment type that enables honorlock */
export const Honorlock_AssignmentType = {
  /**
   * For now we only support honorlock enablement for staff graded assignment,
   * possibly extend this feature to other assignment types(ex. coding assignment)
   */
  StaffGraded: 'STAFF_GRADED'
} as const;

export type Honorlock_AssignmentType = typeof Honorlock_AssignmentType[keyof typeof Honorlock_AssignmentType];
/** Input to generate the test link on iMocha */
export type IMochaAssessment_GenerateTestLinkInput = {
  /** Unique test identifier. Since GraphQL does not support Int64, use ID instead. */
  testId: Scalars['ID'];
};

/** Different the current completion status of an iMocha test attempt */
export const IMochaAssessment_TestCompletionStatus = {
  /** The test invitation is still pending as user hasn't started the test yet */
  InvitationPending: 'INVITATION_PENDING',
  /** The test is completed */
  TestCompleted: 'TEST_COMPLETED',
  /** The user is currently taking the test */
  TestInProgress: 'TEST_IN_PROGRESS',
  /** The test is abandoned after the user already started the test */
  TestLeft: 'TEST_LEFT'
} as const;

export type IMochaAssessment_TestCompletionStatus = typeof IMochaAssessment_TestCompletionStatus[keyof typeof IMochaAssessment_TestCompletionStatus];
export const IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource = {
  Admin: 'ADMIN',
  Jumio: 'JUMIO',
  NameAttest: 'NAME_ATTEST',
  None: 'NONE',
  Persona: 'PERSONA',
  Sigtrack: 'SIGTRACK',
  SsoSignin: 'SSO_SIGNIN'
} as const;

export type IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource = typeof IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource[keyof typeof IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource];
/** Input to mark an in-lab instruction as complete */
export type InLabInstructions_MarkInstructionAsCompleteInput = {
  /** The course ID */
  courseId: Scalars['ID'];
  /** The instruction ID */
  instructionId: Scalars['ID'];
  /** The item ID */
  itemId: Scalars['ID'];
};

/** Input schema for InjectableActivities_DirectlyTriggerInjectionConfiguration mutation */
export type InjectableActivities_DirectlyTriggerInjectionConfigurationInput = {
  /** An optional description for the trigger event. */
  description?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the injection configuration to be triggered. */
  injectionConfigurationId: Scalars['ID'];
};

/** Represents the progress state of an injectable activity. */
export const InjectableActivities_ProgressState = {
  /** Represents that the injectable activity has been completed. */
  Completed: 'COMPLETED',
  /** Represents that the injectable activity has not been started. */
  NotStarted: 'NOT_STARTED',
  /** Represents that the injectable activity is in progress. */
  Started: 'STARTED'
} as const;

export type InjectableActivities_ProgressState = typeof InjectableActivities_ProgressState[keyof typeof InjectableActivities_ProgressState];
/** Input schema for InjectableActivities_ProvisionProactiveAiExperiment mutation */
export type InjectableActivities_ProvisionProactiveAiExperimentInput = {
  /** The unique identifier for the course branch to provision the proactive AI experiment for. */
  courseBranchId: Scalars['ID'];
};

/** Possible positions for an adjacent item placement. */
export const InjectableActivities_RelativePosition = {
  /** Place the activity after the adjacent item. */
  After: 'AFTER',
  /** Place the activity before the adjacent item. */
  Before: 'BEFORE'
} as const;

export type InjectableActivities_RelativePosition = typeof InjectableActivities_RelativePosition[keyof typeof InjectableActivities_RelativePosition];
/** Input schema for InjectableActivities_UpdateInjectableActivityProgress mutation */
export type InjectableActivities_UpdateInjectableActivityProgressInput = {
  /** The unique identifier for the injectable activity. */
  injectableActivityId: Scalars['ID'];
  /** The new progress state for the injectable activity. */
  progressState: InjectableActivities_ProgressState;
};

/** Input for updating invitation role assignments */
export type InstitutionStaffInvitation_AcceptInvitationInput = {
  /**
   * invitation id associated with the invitation url that was used to land on coursera from an
   * invitation email
   */
  invitationId: Scalars['ID'];
  /** email address that the invitee registered with on coursera after landing via an invitation url. */
  inviteeRegisteredEmail: Scalars['ID'];
};

/** Describes what action was taken for each invitation in a batch invite request. */
export const InstitutionStaffInvitation_InvitationAction = {
  /** Invitee has existing Coursera account, directly added as staff */
  AddedAsStaff: 'ADDED_AS_STAFF',
  /** Invitation created for a new invitee, email sent */
  Created: 'CREATED',
  /** Previously CANCELLED invitation reactivated to INVITED, email sent */
  Reactivated: 'REACTIVATED',
  /** Invitee already has an INVITED invitation, no action taken */
  SkippedAlreadyInvited: 'SKIPPED_ALREADY_INVITED',
  /** Invitee already JOINED as staff, no action taken */
  SkippedAlreadyJoined: 'SKIPPED_ALREADY_JOINED',
  /** Existing INVITED invitation had roles updated, email resent */
  Updated: 'UPDATED'
} as const;

export type InstitutionStaffInvitation_InvitationAction = typeof InstitutionStaffInvitation_InvitationAction[keyof typeof InstitutionStaffInvitation_InvitationAction];
/** Invitation request input */
export type InstitutionStaffInvitation_InvitationInput = {
  /** email address of individual who is being invited */
  inviteeEmail: Scalars['String'];
  /** Ids of the roles that should be assigned to the invited individual */
  roleTemplateIds: Array<Scalars['ID']>;
  /** Staff Invitation scope */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Invitation request input */
export type InstitutionStaffInvitation_InvitationQueryFilter = {
  /** Optional filter results invitation status */
  invitationStatuses?: InputMaybe<Array<InstitutionStaffInvitation_InvitationStatus>>;
  /**
   * Staff-membership scope for an invitation
   * For now, only PARTNER scopeType is supported
   * If this API receives an unsupported scopeType it would return an appropriate message
   * detailing the unavailable support
   */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Invitation status enum */
export const InstitutionStaffInvitation_InvitationStatus = {
  /** Status when a user's staff membership invitation has been revoked */
  Cancelled: 'CANCELLED',
  /** Initial status when a user is invited */
  Invited: 'INVITED',
  /** Status when a user has been added as a staff member of the institution */
  Joined: 'JOINED'
} as const;

export type InstitutionStaffInvitation_InvitationStatus = typeof InstitutionStaffInvitation_InvitationStatus[keyof typeof InstitutionStaffInvitation_InvitationStatus];
/** Staff Invitation input */
export type InstitutionStaffInvitation_InviteStaffByEmailsInput = {
  /** set of invitation inputs */
  invitations: Array<InstitutionStaffInvitation_InvitationInput>;
  /** Staff-membership scope for the invitations */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Staff Invitation scope input */
export type InstitutionStaffInvitation_MembershipScopeInput = {
  /** scopeId for the associated scopeType */
  scopeId: Scalars['ID'];
  /** Membership scope type for the invitation */
  scopeType: InstitutionStaffInvitation_ScopeType;
};

/** Input for revoking invitation */
export type InstitutionStaffInvitation_RevokeInvitationsInput = {
  /** invitation ids to be revoked */
  invitationIds: Array<Scalars['ID']>;
  /** Staff-membership scope for the invitations being revoked */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/**
 * Membership scope type for an invitation
 * Known admin staff-membership scope types are [PARTNER, COURSE, GROUP, DEGREE]
 * Only PARTNER admin scope is supported for now, but this enum is to provide flexibility to
 * support the other scopes when required. They can be added here when support is to be implemented.
 */
export const InstitutionStaffInvitation_ScopeType = {
  /** Type name for partner scope */
  Partner: 'PARTNER'
} as const;

export type InstitutionStaffInvitation_ScopeType = typeof InstitutionStaffInvitation_ScopeType[keyof typeof InstitutionStaffInvitation_ScopeType];
/** The type of assessment for which the integrity check is being run. */
export const IntegrityCheck_AssessmentType = {
  /** The assessment is an assignment */
  Assignment: 'ASSIGNMENT',
  /** The assessment is a peer review */
  PeerReview: 'PEER_REVIEW'
} as const;

export type IntegrityCheck_AssessmentType = typeof IntegrityCheck_AssessmentType[keyof typeof IntegrityCheck_AssessmentType];
/** The type of check to be applied */
export const IntegrityCheck_CheckType = {
  /** Detects gibberish and returns a boolean. */
  Gibberish: 'GIBBERISH',
  /** Uses simtext to compute a similarity score from 0 to 100. */
  Textsimilarity: 'TEXTSIMILARITY'
} as const;

export type IntegrityCheck_CheckType = typeof IntegrityCheck_CheckType[keyof typeof IntegrityCheck_CheckType];
/** The actual content for a given prompt. */
export type IntegrityCheck_ContentInput = {
  /** The URL of the submitted file */
  fileUrl?: InputMaybe<Scalars['String']>;
  /** The text content for prompts with type TEXT */
  textContent?: InputMaybe<Scalars['String']>;
  /**
   * Tagged union. Depending on the value, the server expects the corresponding
   * field to be present and non null.
   * typeTag == TEXT => textContent is present.
   * typeTag == FILE => fileUrl is present.
   */
  typeTag: IntegrityCheck_ContentInputType;
};

/**
 * The content type of a given submission prompt.
 * Currently, text and files are supported.
 * Possibly support urls in the future.
 */
export const IntegrityCheck_ContentInputType = {
  /** The FILE type is used for file uploads. */
  File: 'FILE',
  /** The TEXT type is used for raw text, cml, and html. */
  Text: 'TEXT'
} as const;

export type IntegrityCheck_ContentInputType = typeof IntegrityCheck_ContentInputType[keyof typeof IntegrityCheck_ContentInputType];
/** The types of deterrence that we can indicate. */
export const IntegrityCheck_DeterrenceType = {
  /** This prompt should be actively deterred from submission */
  IntegrityCheckActive: 'INTEGRITY_CHECK_ACTIVE',
  /** No deterrence is necessary for this prompt */
  IntegrityCheckNone: 'INTEGRITY_CHECK_NONE',
  /** This prompt should be passively deterred from submission */
  IntegrityCheckPassive: 'INTEGRITY_CHECK_PASSIVE'
} as const;

export type IntegrityCheck_DeterrenceType = typeof IntegrityCheck_DeterrenceType[keyof typeof IntegrityCheck_DeterrenceType];
/** The configuration for a stage in the check pipeline */
export type IntegrityCheck_StageDefinitionInput = {
  /** The type of check to be executed at this stage */
  checkType: IntegrityCheck_CheckType;
  /**
   * This flag is used for indicating whether or not "failing" submission
   * prompts should be filtered out before executing the next stage.
   */
  withFiltering: Scalars['Boolean'];
};

/** The submission to be checked */
export type IntegrityCheck_SubmissionInput = {
  /** The type of assessment */
  assessmentType?: InputMaybe<IntegrityCheck_AssessmentType>;
  /** The assignment id */
  assignmentId: Scalars['ID'];
  /** The assignment version */
  assignmentVersion?: InputMaybe<Scalars['Int']>;
  /** The individual submission prompts to be checked */
  prompts: Array<IntegrityCheck_SubmissionPromptInput>;
  /** The submitter id */
  submitterId: Scalars['ID'];
  /** The submission version */
  version: Scalars['Int'];
};

/** A single prompt from a submission */
export type IntegrityCheck_SubmissionPromptInput = {
  /**
   * The enablement configuration to be used for this prompt
   * @deprecated The configurationId field is deprecated and will be removed in the future. Use the prompt's enablement data instead.
   */
  configurationId?: InputMaybe<Scalars['ID']>;
  /** Content of the prompt which should be checked */
  content: IntegrityCheck_ContentInput;
  /** Prompt id */
  promptId: Scalars['ID'];
};

/** An identifier of integrity settings */
export type Integrity_SettingsIdentifier = {
  /** The id of the assessment */
  assessmentId: Scalars['ID'];
  /** The type of the assessment */
  assessmentType: ExamMonitor_AssessmentType;
  /** The version of the assessment */
  assessmentVersion: Scalars['Int'];
  /** The id of the course */
  courseId: Scalars['ID'];
  /** The id of the course session */
  sessionId: Scalars['ID'];
};

/** IntlCompliance_PreEnrollmentIdInput */
export type IntlCompliance_PreEnrollmentIdInput = {
  /** The ID of the pre-enrollment for which the user is consenting to recurring charges. */
  id: Scalars['ID'];
};

/** Recurring charge consent request payload. */
export type IntlCompliance_RecurringChargeConsentInput = {
  /** IntlCompliance_PreEnrollmentIdInput */
  preEnrollmentId?: InputMaybe<IntlCompliance_PreEnrollmentIdInput>;
  /** IntlCompliance_SubscriptionCartIdInput */
  subscriptionCartId?: InputMaybe<IntlCompliance_SubscriptionCartIdInput>;
};

/** IntlCompliance_SubscriptionCartIdInput */
export type IntlCompliance_SubscriptionCartIdInput = {
  /** The ID of the subscription cart for which the user is consenting to recurring charges. */
  id: Scalars['ID'];
};

/** Indicates the status of a branch and its association with sessions */
export const ItemAuthoring_BranchStatus = {
  /**
   * Branch is not associated with a currently running session or future sessions, but was
   * associated with a past session
   */
  Archived: 'ARCHIVED',
  /** Branch is in the process of being created and cannot be accessed or modified yet */
  Creating: 'CREATING',
  /**
   * Branch is either associated with a currently running session OR
   * has a past session along with a future scheduled session OR
   * has a past session and is the branch that would be associated with new future sessions
   */
  Live: 'LIVE',
  /** Branch isn't associated with any sessions */
  New: 'NEW',
  /** Branch has been submitted for approval but has not yet been approved for use in sessions */
  Pending: 'PENDING',
  /** Branch is about to go live in a future session for the first time */
  Upcoming: 'UPCOMING'
} as const;

export type ItemAuthoring_BranchStatus = typeof ItemAuthoring_BranchStatus[keyof typeof ItemAuthoring_BranchStatus];
/** Input for the ItemAuthoring_DiscardItemDraft mutation */
export type ItemAuthoring_DiscardItemDraftInput = {
  /** Id of the atom whose draft is to be discarded */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
};

/** Input for creating an item personalization record */
export type ItemPersonalization_CreateItemPersonalizationInput = {
  /** The branch ID */
  branchId: Scalars['ID'];
  /** The course ID */
  courseId: Scalars['ID'];
  /** The item ID to personalize */
  itemId: Scalars['ID'];
  /** The personalization action to apply (e.g., SKIP or FOCUS) */
  personalizationAction: ItemPersonalization_PersonalizationAction;
  /** The source of the personalization (e.g., VERIFIED_SKILLS_DIAGNOSTIC) */
  personalizationSource: ItemPersonalization_PersonalizationSource;
};

/** The personalization action to be applied to an item for a learner */
export const ItemPersonalization_PersonalizationAction = {
  /** Focus on the item */
  Focus: 'FOCUS',
  /** Skip the item */
  Skip: 'SKIP'
} as const;

export type ItemPersonalization_PersonalizationAction = typeof ItemPersonalization_PersonalizationAction[keyof typeof ItemPersonalization_PersonalizationAction];
/** The personalization source */
export const ItemPersonalization_PersonalizationSource = {
  /** Verified Skills Assessment */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** Diagnostics Assessment */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC'
} as const;

export type ItemPersonalization_PersonalizationSource = typeof ItemPersonalization_PersonalizationSource[keyof typeof ItemPersonalization_PersonalizationSource];
/**
 * Denotes whether a created atom was manually created by a user, or generated with AI assistance. Needed for Guided Review
 * to identify AI-generated items.
 */
export const ItemPlatform_AtomGenerationSource = {
  /** Indicates that the atom was generated with AI assistance */
  Ai: 'AI',
  /** Indicates that the atom was manually created by a user */
  User: 'USER'
} as const;

export type ItemPlatform_AtomGenerationSource = typeof ItemPlatform_AtomGenerationSource[keyof typeof ItemPlatform_AtomGenerationSource];
/**
 * List of supported item types.
 * See https://coursera.atlassian.net/wiki/spaces/CP/pages/2743533707/Item+Types+a+complete+list for documentation about
 * each item type.
 */
export const ItemPlatform_ItemType = {
  /**
   * Assignment item. Previously known as staff-graded assignments or SGAs, the Unified Assignment project has expanded
   * their role to encompass use cases previously handled by QUIZ items. Can be either graded or ungraded.
   */
  Assignment: 'ASSIGNMENT',
  /** Coach Item. Either a Socratic Dialogue or a Role Play */
  Coach: 'COACH',
  /** Discussion prompt item. Can be either graded or ungraded. */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture item used for lecture videos. */
  Lecture: 'LECTURE',
  /**
   * LTI (Learning Tools Interoperability) item. Referred to as "App Items" in UI. Can be either graded or ungraded.
   * This item type still isn't handled by the Item Platform, but it will be, so this schema is used.
   */
  Lti: 'LTI',
  /** Peer review item. Can be either ungraded (Standard/Practice) or graded (Phased). */
  PeerReview: 'PEER_REVIEW',
  /** Placeholder item representing deprecated item types while preserving learner grades/progress. */
  Placeholder: 'PLACEHOLDER',
  /**
   * Programming assignment. Can be either graded or ungraded, though we don't currently allow instructors to create
   * graded programming assignments directly. Instead, they must first create an ungraded programming assignment and
   * then convert it to graded from within the item detail view.
   */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /**
   * Quiz item. Can be either graded or ungraded.
   * Deprecated in favour of assignments, and can no longer be created as of Q1 2024
   */
  Quiz: 'QUIZ',
  /** Reading, also known as a 'supplement' in older code. */
  Reading: 'READING',
  /** Teammate review item. Graded. */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab item. */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget item. Referred to as "Plugins" in UI. At present, only new ungraded plugins can be created. */
  Widget: 'WIDGET',
  /** WISEflow item. Graded. Unlaunched as of Q1 2021. */
  Wiseflow: 'WISEFLOW'
} as const;

export type ItemPlatform_ItemType = typeof ItemPlatform_ItemType[keyof typeof ItemPlatform_ItemType];
/** Used to "fix" item progress state by resending it to the core progress tracking systems. */
export type ItemProgress_ItemStateRefreshByBranchInput = {
  /** Branch Id */
  branchId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/**
 * Used to "fix" item progress state by resending it to the core progress tracking systems. The correct branch id is
 * inferred from the user's enrollment in the course.
 */
export type ItemProgress_ItemStateRefreshByCourseInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Delete ItemPublishComment input. */
export type ItemPublishComments_DeleteItemPublishCommentInput = {
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Atom version. For a draft the version is empty (optional). */
  version?: InputMaybe<Scalars['Int']>;
};

/** Save ItemPublishComment input. */
export type ItemPublishComments_SaveItemPublishCommentInput = {
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Comment string. */
  commentString: Scalars['String'];
  /** Is this atom version a draft. */
  isDraft: Scalars['Boolean'];
  /** Atom version. For a draft the version is empty (optional). */
  version?: InputMaybe<Scalars['Int']>;
};

/** Status of an atom version for a branch */
export const ItemPublishHistory_BranchAtomVersionStatus = {
  /** Atom contains a draft. */
  Draft: 'DRAFT',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** Similar to the PUBLISHED status, but the version has been updated and replaced by a newer version. */
  PreviouslyPublished: 'PREVIOUSLY_PUBLISHED',
  /** Similar to the READY status, but the version has been updated and replaced by a newer version. */
  PreviouslyReady: 'PREVIOUSLY_READY',
  /**
   *  Atom version does not contain any drafts, and the branch has been launched, the content
   * is visible to learners.
   */
  Published: 'PUBLISHED',
  /**
   *  Atom version does not contain any drafts, but since the branch has not been launched, the content
   * is not visible to learners yet.
   */
  Ready: 'READY'
} as const;

export type ItemPublishHistory_BranchAtomVersionStatus = typeof ItemPublishHistory_BranchAtomVersionStatus[keyof typeof ItemPublishHistory_BranchAtomVersionStatus];
/** Status of a branch. */
export const ItemPublishHistory_BranchStatus = {
  /**
   *  Branch is currently not running in any ongoing session and is not
   * scheduled to run in a future session but ran in an already ended session
   */
  Archived: 'ARCHIVED',
  /** Branch is in the process of being created and cannot be accessed or modified yet. */
  Creating: 'CREATING',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /**
   *  Branch is either currently running in a session OR
   * has a past session along with a future scheduled session OR
   * has a past session and would be the branch associated with any future sessions.
   */
  Live: 'LIVE',
  /** Branch isn’t associated with any sessions. */
  New: 'NEW',
  /** Branch has been submitted for approval but has not been approved for use in sessions. */
  Pending: 'PENDING',
  /** Branch is about to go live in a future session for the first time. */
  Upcoming: 'UPCOMING'
} as const;

export type ItemPublishHistory_BranchStatus = typeof ItemPublishHistory_BranchStatus[keyof typeof ItemPublishHistory_BranchStatus];
/** Note: These are verification statuses that are useful from Coursera's perspective, and are defined by Coursera. They are NOT the original callback parameter verificationStatus states defined by Jumio. For original verificationStatus states defined by Jumio, see:   org.coursera.userverification.jumioidverification.callback.JumioCallbackVerificationStatus */
export const JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus = {
  Approved: 'APPROVED',
  DeniedAge: 'DENIED_AGE',
  DeniedByJumio: 'DENIED_BY_JUMIO',
  DeniedByPersona: 'DENIED_BY_PERSONA',
  DeniedExpiredId: 'DENIED_EXPIRED_ID',
  DeniedRestrictedCountry: 'DENIED_RESTRICTED_COUNTRY',
  ErrorNotJumioSupportedCountry: 'ERROR_NOT_JUMIO_SUPPORTED_COUNTRY',
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  NoIdUploaded: 'NO_ID_UPLOADED',
  Pending: 'PENDING'
} as const;

export type JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus = typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus[keyof typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus];
/** This is the original verificationStatus parameter sent by Jumio in their callback. These statuses are defined by Jumio:   https://github.com/Jumio/implementation-guides/blob/master/netverify/callback.md#parameters */
export const JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus = {
  ApprovedVerified: 'APPROVED_VERIFIED',
  DeniedFraud: 'DENIED_FRAUD',
  DeniedNameMismatch: 'DENIED_NAME_MISMATCH',
  DeniedUnsupportedIdCountry: 'DENIED_UNSUPPORTED_ID_COUNTRY',
  DeniedUnsupportedIdType: 'DENIED_UNSUPPORTED_ID_TYPE',
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  NoIdUploaded: 'NO_ID_UPLOADED'
} as const;

export type JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus = typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus[keyof typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus];
/** Input for creating a JWT login */
export type JwtLogins_CreateJwtLoginInput = {
  /** The organization name to be slugified */
  organization: Scalars['String'];
  /** The web token to be parsed and validated */
  webToken: Scalars['String'];
};

/** Enum representing JWT login methods */
export const JwtLogins_LoginMethod = {
  /** Standard JWT login method */
  Jwt: 'JWT',
  /** JWT invite login method */
  JwtInvite: 'JWT_INVITE'
} as const;

export type JwtLogins_LoginMethod = typeof JwtLogins_LoginMethod[keyof typeof JwtLogins_LoginMethod];
/** Input for creating a JWT login with invitation token */
export type JwtLogins_LoginWithInvitationTokenInput = {
  /** The invitation token to be parsed and validated */
  invitationToken: Scalars['String'];
  /** The organization slug */
  organizationSlug: Scalars['String'];
};

/** ImageBuildStatus */
export const LabImageAuthoringData_ImageBuildStatus = {
  /** Build failed */
  Failed: 'FAILED',
  /** Build fault */
  Fault: 'FAULT',
  /** Build in progress */
  InProgress: 'IN_PROGRESS',
  /** Build stopped */
  Stopped: 'STOPPED',
  /** Build succeeded */
  Succeeded: 'SUCCEEDED',
  /** Build timed out */
  TimedOut: 'TIMED_OUT'
} as const;

export type LabImageAuthoringData_ImageBuildStatus = typeof LabImageAuthoringData_ImageBuildStatus[keyof typeof LabImageAuthoringData_ImageBuildStatus];
/** ImagePublishStatus */
export const LabImageAuthoringData_ImagePublishStatus = {
  /** Published */
  Published: 'PUBLISHED',
  /** Unpublished */
  Unpublished: 'UNPUBLISHED',
  /** Has unpublished changes */
  UnpublishedChanges: 'UNPUBLISHED_CHANGES'
} as const;

export type LabImageAuthoringData_ImagePublishStatus = typeof LabImageAuthoringData_ImagePublishStatus[keyof typeof LabImageAuthoringData_ImagePublishStatus];
/** Lab Grader Type */
export const LabImageAuthoringData_LabGraderType = {
  /** NBGrader */
  NbGrader: 'NB_GRADER',
  /** VSCode custom grader */
  VscodeCustomGrader: 'VSCODE_CUSTOM_GRADER',
  /** VSCode preconfigured java */
  VscodePreconfiguredJava: 'VSCODE_PRECONFIGURED_JAVA'
} as const;

export type LabImageAuthoringData_LabGraderType = typeof LabImageAuthoringData_LabGraderType[keyof typeof LabImageAuthoringData_LabGraderType];
/** Indicates the type of the base image */
export const LabImageAuthoringData_WorkspaceImageApplicationType = {
  /** AWS Cloud */
  AwsCloud: 'AWS_CLOUD',
  /** Custom image */
  Custom: 'CUSTOM',
  /** Gen AI Sandbox */
  GenAiSandbox: 'GEN_AI_SANDBOX',
  /** Jupyter notebook */
  JupyterNotebook: 'JUPYTER_NOTEBOOK',
  /** Linux Desktop */
  Linux: 'LINUX',
  /** RStudio */
  Rstudio: 'RSTUDIO',
  /** Virtual web browser */
  VirtualBrowser: 'VIRTUAL_BROWSER',
  /** VSCode */
  Vscode: 'VSCODE'
} as const;

export type LabImageAuthoringData_WorkspaceImageApplicationType = typeof LabImageAuthoringData_WorkspaceImageApplicationType[keyof typeof LabImageAuthoringData_WorkspaceImageApplicationType];
/** Input to clean up a lab recording */
export type LabRecording_CleanupInput = {
  /** The course ID */
  courseId: Scalars['ID'];
  /** External session ID (e.g. attempt ID) */
  externalSessionId: Scalars['ID'];
  /** The item ID */
  itemId: Scalars['ID'];
};

/** Input to continue lab recording */
export type LabRecording_ContinueInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Input to export a lab recording to video */
export type LabRecording_ExportInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Input to pause a lab recording */
export type LabRecording_PauseInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Input to start a lab recording */
export type LabRecording_StartInput = {
  /** External session ID (e.g. attempt ID) */
  externalSessionId: Scalars['ID'];
  /** The lab ID */
  labId: Scalars['ID'];
  /** Heartbeat interval in seconds. Defaults to 10. */
  recordingDurationSeconds?: Scalars['Int'];
};

/** The lifecycle status of a lab recording */
export const LabRecording_Status = {
  /** Capture is active */
  Active: 'ACTIVE',
  /** Recording has been deleted */
  Deleted: 'DELETED',
  /** Recording is scheduled for deletion */
  Deleting: 'DELETING',
  /** Video has been exported */
  Exported: 'EXPORTED',
  /** Video export is in progress */
  Exporting: 'EXPORTING',
  /** Lab type does not support recording */
  NotSupported: 'NOT_SUPPORTED',
  /** Recording is paused */
  Paused: 'PAUSED',
  /** Recording created, waiting for capture to begin */
  Pending: 'PENDING'
} as const;

export type LabRecording_Status = typeof LabRecording_Status[keyof typeof LabRecording_Status];
/** Publish type */
export const LabTemplate_PublishType = {
  /** PUBLISHER CHOICE */
  PublisherChoice: 'PUBLISHER_CHOICE',
  /** RO ONLY */
  RoOnly: 'RO_ONLY'
} as const;

export type LabTemplate_PublishType = typeof LabTemplate_PublishType[keyof typeof LabTemplate_PublishType];
/** List the LaunchContextMacro which can be resolved and set as environment variables when launching a lab */
export const LabTemplates_LaunchContextMacro = {
  /** AWS Cloud Lab Start URL */
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  /** Course Branch Id */
  CourseBranchId: 'COURSE_BRANCH_ID',
  /** A hashed value of user id */
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  /** Course Id */
  CourseId: 'COURSE_ID',
  /** Course Name */
  CourseName: 'COURSE_NAME',
  /** Course Session Duration */
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  /** Course Slug */
  CourseSlug: 'COURSE_SLUG',
  /** EVG1 Code */
  Evg1Code: 'EVG1_CODE',
  /** GCP Key */
  GcloudKey: 'GCLOUD_KEY',
  /** Gen AI Models */
  GenAiModels: 'GEN_AI_MODELS',
  /** Image Application Type */
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  /** Instructor Name */
  InstructorName: 'INSTRUCTOR_NAME',
  /** In lab browser start URL */
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  /** Item Deadline */
  ItemDeadline: 'ITEM_DEADLINE',
  /** All item deadlines */
  ItemDeadlines: 'ITEM_DEADLINES',
  /** Item Id */
  ItemId: 'ITEM_ID',
  /** OPENAI API Key */
  OpenaiApiKey: 'OPENAI_API_KEY',
  /** Partner Id */
  PartnerId: 'PARTNER_ID',
  /** Session Start Time */
  SessionStartTime: 'SESSION_START_TIME',
  /** Submission Token */
  SubmissionToken: 'SUBMISSION_TOKEN',
  /** University Student Id */
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type LabTemplates_LaunchContextMacro = typeof LabTemplates_LaunchContextMacro[keyof typeof LabTemplates_LaunchContextMacro];
/** 2-letter ISO language codes. */
export const LanguageCode = {
  /** Afar */
  Aa: 'aa',
  /** Abkhazian */
  Ab: 'ab',
  /** Afrikaans */
  Af: 'af',
  /** Amharic */
  Am: 'am',
  /** Arabic */
  Ar: 'ar',
  /** Assamese */
  As: 'as',
  /** Aymara */
  Ay: 'ay',
  /** Azerbaijani */
  Az: 'az',
  /** Bashkir */
  Ba: 'ba',
  /** Byelorussian */
  Be: 'be',
  /** Bulgarian */
  Bg: 'bg',
  /** Bihari */
  Bh: 'bh',
  /** Bislama */
  Bi: 'bi',
  /** Bengali; Bangla */
  Bn: 'bn',
  /** Tibetan */
  Bo: 'bo',
  /** Breton */
  Br: 'br',
  /** Catalan */
  Ca: 'ca',
  /** Corsican */
  Co: 'co',
  /** Czech */
  Cs: 'cs',
  /** Welsh */
  Cy: 'cy',
  /** Danish */
  Da: 'da',
  /** German */
  De: 'de',
  /** Bhutani */
  Dz: 'dz',
  /** Greek */
  El: 'el',
  /** English */
  En: 'en',
  /** Esperanto */
  Eo: 'eo',
  /** Spanish */
  Es: 'es',
  /** Estonian */
  Et: 'et',
  /** Basque */
  Eu: 'eu',
  /** Persian */
  Fa: 'fa',
  /** Finnish */
  Fi: 'fi',
  /** Fiji */
  Fj: 'fj',
  /** Faeroese */
  Fo: 'fo',
  /** French */
  Fr: 'fr',
  /** Frisian */
  Fy: 'fy',
  /** Irish */
  Ga: 'ga',
  /** Scots, Gaelic */
  Gd: 'gd',
  /** Galician */
  Gl: 'gl',
  /**
   * Global language code is the default language that should fall back to for a given country (for default language code should be used for english in the US).
   * This enables falling back to the country default language if a combination of country / language that is not supported is provided.
   */
  Global: 'global',
  /** Guarani */
  Gn: 'gn',
  /** Gujarati */
  Gu: 'gu',
  /** Hausa */
  Ha: 'ha',
  /** Hebrew */
  He: 'he',
  /** Hindi */
  Hi: 'hi',
  /** Croatian */
  Hr: 'hr',
  /** Hungarian */
  Hu: 'hu',
  /** Armenian */
  Hy: 'hy',
  /** Interlingua */
  Ia: 'ia',
  /** Indonesian */
  Id: 'id',
  /** Interlingue */
  Ie: 'ie',
  /** Inupiak */
  Ik: 'ik',
  /** Indonesian */
  In: 'in',
  /** Icelandic */
  Is: 'is',
  /** Italian */
  It: 'it',
  /** Inuktitut */
  Iu: 'iu',
  /** Hebrew (obsolete) */
  Iw: 'iw',
  /** Japanese */
  Ja: 'ja',
  /** Yiddish (obsolete) */
  Ji: 'ji',
  /** Javanese */
  Jw: 'jw',
  /** Georgian */
  Ka: 'ka',
  /** Kazakh */
  Kk: 'kk',
  /** Greenlandic */
  Kl: 'kl',
  /** Cambodian */
  Km: 'km',
  /** Kannada */
  Kn: 'kn',
  /** Korean */
  Ko: 'ko',
  /** Kashmiri */
  Ks: 'ks',
  /** Kurdish */
  Ku: 'ku',
  /** Kirghiz */
  Ky: 'ky',
  /** Latin */
  La: 'la',
  /** Lingala */
  Ln: 'ln',
  /** Laothian */
  Lo: 'lo',
  /** Lithuanian */
  Lt: 'lt',
  /** Latvian, Lettish */
  Lv: 'lv',
  /** Malagasy */
  Mg: 'mg',
  /** Maori */
  Mi: 'mi',
  /** Macedonian */
  Mk: 'mk',
  /** Malayalam */
  Ml: 'ml',
  /** Mongolian */
  Mn: 'mn',
  /** Moldavian */
  Mo: 'mo',
  /** Marathi */
  Mr: 'mr',
  /** Malay */
  Ms: 'ms',
  /** Maltese */
  Mt: 'mt',
  /** Burmese */
  My: 'my',
  /** Nauru */
  Na: 'na',
  /** Nepali */
  Ne: 'ne',
  /** Dutch */
  Nl: 'nl',
  /** Norwegian */
  No: 'no',
  /** Occitan */
  Oc: 'oc',
  /** (Afan), Oromo */
  Om: 'om',
  /** Oriya */
  Or: 'or',
  /** Punjabi */
  Pa: 'pa',
  /** Polish */
  Pl: 'pl',
  /** Pashto, Pushto */
  Ps: 'ps',
  /** Portuguese */
  Pt: 'pt',
  /** Quechua */
  Qu: 'qu',
  /** Rhaeto-Romance */
  Rm: 'rm',
  /** Kirundi */
  Rn: 'rn',
  /** Romanian */
  Ro: 'ro',
  /** Russian */
  Ru: 'ru',
  /** Kinyarwanda */
  Rw: 'rw',
  /** Sanskrit */
  Sa: 'sa',
  /** Sindhi */
  Sd: 'sd',
  /** Sangro */
  Sg: 'sg',
  /** Serbo-Croatian */
  Sh: 'sh',
  /** Singhalese */
  Si: 'si',
  /** Slovak */
  Sk: 'sk',
  /** Slovenian */
  Sl: 'sl',
  /** Samoan */
  Sm: 'sm',
  /** Shona */
  Sn: 'sn',
  /** Somali */
  So: 'so',
  /** Albanian */
  Sq: 'sq',
  /** Serbian */
  Sr: 'sr',
  /** Siswati */
  Ss: 'ss',
  /** Sesotho */
  St: 'st',
  /** Sundanese */
  Su: 'su',
  /** Swedish */
  Sv: 'sv',
  /** Swahili */
  Sw: 'sw',
  /** Tamil */
  Ta: 'ta',
  /** Tegulu */
  Te: 'te',
  /** Tajik */
  Tg: 'tg',
  /** Thai */
  Th: 'th',
  /** Tigrinya */
  Ti: 'ti',
  /** Turkmen */
  Tk: 'tk',
  /** Tagalog */
  Tl: 'tl',
  /** Setswana */
  Tn: 'tn',
  /** Tonga */
  To: 'to',
  /** Turkish */
  Tr: 'tr',
  /** Tsonga */
  Ts: 'ts',
  /** Tatar */
  Tt: 'tt',
  /** Twi */
  Tw: 'tw',
  /** Uigur */
  Ug: 'ug',
  /** Ukrainian */
  Uk: 'uk',
  /** Urdu */
  Ur: 'ur',
  /** Uzbek */
  Uz: 'uz',
  /** Vietnamese */
  Vi: 'vi',
  /** Volapuk */
  Vo: 'vo',
  /** Wolof */
  Wo: 'wo',
  /** Xhosa */
  Xh: 'xh',
  /** Yiddish */
  Y: 'y',
  /** Yoruba */
  Yo: 'yo',
  /** Zuang */
  Za: 'za',
  /** Chinese */
  Zh: 'zh',
  /** Zulu */
  Zu: 'zu'
} as const;

export type LanguageCode = typeof LanguageCode[keyof typeof LanguageCode];
/** Query by course input: course Id */
export type LanguagesForProduct_QueryByCourseInput = {
  /** Course ID */
  courseId: Scalars['ID'];
};

/** Translation type for a language */
export const LanguagesForProduct_TranslationType = {
  /** Human translation */
  Human: 'HUMAN',
  /** Machine translation */
  Machine: 'MACHINE'
} as const;

export type LanguagesForProduct_TranslationType = typeof LanguagesForProduct_TranslationType[keyof typeof LanguagesForProduct_TranslationType];
/** The state of a lab container. */
export const LaunchLab_ContainerState = {
  /** The container is healthy and ready to use */
  ContainerHealthy: 'CONTAINER_HEALTHY',
  /** The container is being removed */
  ContainerRemoved: 'CONTAINER_REMOVED',
  /** The container is being started, not ready yet */
  ContainerStarted: 'CONTAINER_STARTED',
  /** The container is unhealthy */
  ContainerUnhealthy: 'CONTAINER_UNHEALTHY',
  /** The status is unknown */
  Unknown: 'UNKNOWN'
} as const;

export type LaunchLab_ContainerState = typeof LaunchLab_ContainerState[keyof typeof LaunchLab_ContainerState];
/** Prepare lab for launch input. */
export type LaunchLab_PrepareInput = {
  /** The id of the course. */
  courseId: Scalars['ID'];
  /** Should we force a refresh for this lab? */
  forceRefresh?: Scalars['Boolean'];
  /** The id of the item. */
  itemId: Scalars['ID'];
  /** The id of the learner. */
  learnerId: Scalars['ID'];
  /** Wait for the preparation to complete (Sync), or kick off preparation, and execute async? */
  wait?: Scalars['Boolean'];
};

/** The state of a lab volume. */
export const LaunchLab_VolumeState = {
  /** The status is unknown */
  Unknown: 'UNKNOWN',
  /** Writing failed.  Fix and try again. */
  VolumeArchiveFailed: 'VOLUME_ARCHIVE_FAILED',
  /** Archiving then deleting volumes. DO NOT TOUCH */
  VolumeArchiveInProgress: 'VOLUME_ARCHIVE_IN_PROGRESS',
  /** The volumes are archived and deleted. Must prepare before use. */
  VolumeArchiveSucceeded: 'VOLUME_ARCHIVE_SUCCEEDED',
  /** Volumes could not be completely built.  Fix and try again. */
  VolumePreparationFailed: 'VOLUME_PREPARATION_FAILED',
  /** Volumes are being built *\/ */
  VolumePreparationInProgress: 'VOLUME_PREPARATION_IN_PROGRESS',
  /** Volumes are built */
  VolumePreparationSucceeded: 'VOLUME_PREPARATION_SUCCEEDED'
} as const;

export type LaunchLab_VolumeState = typeof LaunchLab_VolumeState[keyof typeof LaunchLab_VolumeState];
/** Input to create new calendar settings for a user. */
export type LearnerCalendars_CreateLearnerCalendarInput = {
  /** Workaround for Android. If enabled, then the calendar feed has content, else the feed will be blank. */
  shouldDisplayContent: Scalars['Boolean'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Input to Toggle the "shouldDisplayContent" setting for a user. */
export type LearnerCalendars_ToggleShouldDisplayContentInput = {
  /** Workaround for Android. If enabled, then the calendar feed has content, else the feed will be blank. */
  shouldDisplayContent: Scalars['Boolean'];
  /** User ID */
  userId: Scalars['ID'];
};

export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export const LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Paused: 'PAUSED'
} as const;

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus = typeof LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus[keyof typeof LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus];
/** Upcoming item status. */
export const LearnerCourseTimeline_UpcomingItemStatus = {
  /** On track item status. Item due date is before the current time. */
  OnTrack: 'ON_TRACK',
  /** Overdue item status. Item due date is after the current time. */
  Overdue: 'OVERDUE'
} as const;

export type LearnerCourseTimeline_UpcomingItemStatus = typeof LearnerCourseTimeline_UpcomingItemStatus[keyof typeof LearnerCourseTimeline_UpcomingItemStatus];
/** Overall goal progress status of a daily goal. */
export const LearnerGoals_DailyGoalProgressStatus = {
  /** A learner has completed the daily goal. */
  Completed: 'COMPLETED',
  /** A learner is making progress to complete the daily goal. */
  InProgress: 'IN_PROGRESS',
  /** A learner has not started making progress on the daily goal. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LearnerGoals_DailyGoalProgressStatus = typeof LearnerGoals_DailyGoalProgressStatus[keyof typeof LearnerGoals_DailyGoalProgressStatus];
/** Day in a week */
export const LearnerGoals_DayInAWeek = {
  /** Friday */
  Friday: 'FRIDAY',
  /** Monday */
  Monday: 'MONDAY',
  /** Saturday */
  Saturday: 'SATURDAY',
  /** Sunday */
  Sunday: 'SUNDAY',
  /** Thursday */
  Thursday: 'THURSDAY',
  /** Tuesday */
  Tuesday: 'TUESDAY',
  /** Wednesday */
  Wednesday: 'WEDNESDAY'
} as const;

export type LearnerGoals_DayInAWeek = typeof LearnerGoals_DayInAWeek[keyof typeof LearnerGoals_DayInAWeek];
/** Learn on day X of a week */
export type LearnerGoals_DayToLearnInAWeek = {
  /** Specify which day to learn in a week */
  day: LearnerGoals_DayInAWeek;
};

/** Edit weekly goal to learn X days in a week. */
export type LearnerGoals_EditWeeklyGoalDaysOfLearningInput = {
  /** Edit the days to learn in a week. */
  daysToLearn: Array<LearnerGoals_DayToLearnInAWeek>;
};

/** Edit weekly goal input. */
export type LearnerGoals_EditWeeklyGoalInput = {
  /** Edit weekly goal to learn X days in a week. */
  daysOfLearning?: InputMaybe<LearnerGoals_EditWeeklyGoalDaysOfLearningInput>;
};

/** Source of the macro goal. */
export const LearnerGoals_MacroGoalSource = {
  /** The macro goal was auto-generated by the system. */
  AutoGenerated: 'AUTO_GENERATED',
  /** The macro goal was customized by the user. */
  UserCustomized: 'USER_CUSTOMIZED'
} as const;

export type LearnerGoals_MacroGoalSource = typeof LearnerGoals_MacroGoalSource[keyof typeof LearnerGoals_MacroGoalSource];
/** Overall goal progress status of a weekly goal. */
export const LearnerGoals_OverallGoalProgressStatus = {
  /** A learner has completed the weekly goal. */
  Completed: 'COMPLETED',
  /** A learner made more progress than the weekly goal. */
  Exceeding: 'EXCEEDING',
  /** A learner has not started making progress on the weekly goal. */
  NotStarted: 'NOT_STARTED',
  /** A learner is on track to complete the weekly goal. */
  OnTrack: 'ON_TRACK'
} as const;

export type LearnerGoals_OverallGoalProgressStatus = typeof LearnerGoals_OverallGoalProgressStatus[keyof typeof LearnerGoals_OverallGoalProgressStatus];
/** Pacing state for a macro goal. */
export const LearnerGoals_PacingState = {
  /** Learner is ahead of schedule. */
  Ahead: 'AHEAD',
  /** Learner is behind schedule. */
  Behind: 'BEHIND',
  /** Learner is on track to meet the target date. */
  OnTrack: 'ON_TRACK'
} as const;

export type LearnerGoals_PacingState = typeof LearnerGoals_PacingState[keyof typeof LearnerGoals_PacingState];
/** Input for querying macro goal options for a target credential. */
export type LearnerGoals_QueryMacroGoalOptionsInput = {
  /** ID of the target credential. */
  targetCredentialId: Scalars['ID'];
  /** Type of target credential. */
  targetCredentialType: LearnerGoals_TargetCredentialType;
};

/** Input for setting or updating a macro goal. */
export type LearnerGoals_SetMacroGoalInput = {
  /** Number of days per week the learner plans to study. */
  daysPerWeek: Scalars['Int'];
  /** Number of items the learner aims to complete per learning day. Negotiated by the learner in the goal-setting dialog. */
  itemsPerDay: Scalars['Int'];
  /** Target date for completion. */
  targetCompletionDate: Scalars['Date'];
  /** ID of the target credential. */
  targetCredentialId: Scalars['ID'];
  /** Type of target credential. */
  targetCredentialType: LearnerGoals_TargetCredentialType;
};

/** Set weekly goal to learn X days in a week. */
export type LearnerGoals_SetWeeklyGoalDaysOfLearningInput = {
  /** Set the days to learn in a week. */
  daysToLearn: Array<LearnerGoals_DayToLearnInAWeek>;
};

/** Set weekly goal input. */
export type LearnerGoals_SetWeeklyGoalInput = {
  /** Set weekly goal to learn X days in a week. */
  daysOfLearning?: InputMaybe<LearnerGoals_SetWeeklyGoalDaysOfLearningInput>;
};

/**
 * Type of target credential for a macro goal. Used on inputs where a caller identifies
 * a target credential by (type, id) pair.
 */
export const LearnerGoals_TargetCredentialType = {
  /** A single course. */
  Course: 'COURSE',
  /** A specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type LearnerGoals_TargetCredentialType = typeof LearnerGoals_TargetCredentialType[keyof typeof LearnerGoals_TargetCredentialType];
/**
 * Label for a target date option, representing its pace relative to the other options.
 * The frontend maps these to display strings (e.g. "Fast pace", "Recommended", "Relaxed")
 * and can localize as needed.
 */
export const LearnerGoals_TargetDatePaceLabel = {
  /** Middle option. Derived from the default completion time for the target credential. */
  Default: 'DEFAULT',
  /** Faster than DEFAULT. */
  Fast: 'FAST',
  /** Slower than DEFAULT. */
  Slow: 'SLOW',
  /** Fastest option. Derived from the veryFast tier of the target credential's completion time config. */
  VeryFast: 'VERY_FAST',
  /** Slowest option. Derived from the verySlow tier of the target credential's completion time config. */
  VerySlow: 'VERY_SLOW'
} as const;

export type LearnerGoals_TargetDatePaceLabel = typeof LearnerGoals_TargetDatePaceLabel[keyof typeof LearnerGoals_TargetDatePaceLabel];
/** All supported products for recording learner's interest towards */
export type LearnerInterest_Product = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: LearnerInterest_ProductType;
};

/** The enum indicating the type of the product */
export const LearnerInterest_ProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type LearnerInterest_ProductType = typeof LearnerInterest_ProductType[keyof typeof LearnerInterest_ProductType];
/** Input of setting learner interest */
export type LearnerInterest_SetLearnerInterestInput = {
  /**
   * Input flag indicating learner interest state.
   * - true: record that learner is no longer interested in this product
   * - false: clears a previous 'no longer interested' state if present (no-op otherwise)
   */
  noLongerInterested: Scalars['Boolean'];
  /** a learning product, such as a course */
  product: LearnerInterest_Product;
};

/** Input type for current occupation. */
export type LearnerObject_CurrentOccupationInput = {
  /** The occupation name or identifier. */
  occupation?: InputMaybe<Scalars['String']>;
  /** Whether the occupation was from a defined taxonomy or user-generated. */
  occupationInputType?: InputMaybe<LearnerObject_OccupationInputType>;
};

/** Standardized list of options for education levels. */
export const LearnerObject_EducationLevel = {
  /** Associate degree. */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree. */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Some college but no degree. */
  CollegeNoDegree: 'COLLEGE_NO_DEGREE',
  /** Doctorate degree (Ph.D.). */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High school diploma or equivalent. */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Less than high school diploma. */
  LessThanHighSchoolDiploma: 'LESS_THAN_HIGH_SCHOOL_DIPLOMA',
  /** Master's degree. */
  MastersDegree: 'MASTERS_DEGREE',
  /** Professional degree (e.g., JD, MD). */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type LearnerObject_EducationLevel = typeof LearnerObject_EducationLevel[keyof typeof LearnerObject_EducationLevel];
/** Input type for education profile. */
export type LearnerObject_EducationProfileInput = {
  /** Learner's education level. */
  educationLevel?: InputMaybe<LearnerObject_EducationLevel>;
};

/** Enum for tracking the method used to infer an attribute. */
export const LearnerObject_InferenceMethod = {
  /** Inferred via Coach Memory system. */
  CoachMemory: 'COACH_MEMORY'
} as const;

export type LearnerObject_InferenceMethod = typeof LearnerObject_InferenceMethod[keyof typeof LearnerObject_InferenceMethod];
/** Input type for interested careers. */
export type LearnerObject_InterestedCareersInput = {
  /** Occupations selected from predefined list. */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** User-generated occupations entered as free-form text. */
  userGeneratedOccupations?: InputMaybe<Array<Scalars['String']>>;
};

/** Standardized list of options for learning goals. */
export const LearnerObject_LearningGoal = {
  /** Goal is to change career. */
  ChangeCareer: 'CHANGE_CAREER',
  /** Goal is to improve existing skills. */
  ImproveSkills: 'IMPROVE_SKILLS',
  /** Goal is to land a new job. */
  LandNewJob: 'LAND_NEW_JOB',
  /** Goal is personal interest/hobby. */
  PersonalInterest: 'PERSONAL_INTEREST'
} as const;

export type LearnerObject_LearningGoal = typeof LearnerObject_LearningGoal[keyof typeof LearnerObject_LearningGoal];
/** Input type for most recent course completion. */
export type LearnerObject_MostRecentCourseCompletionInput = {
  /** Time at which the course was completed (ISO 8601 format). */
  completedAt: Scalars['DateTime'];
  /** ID of the most recently completed course. */
  courseId: Scalars['ID'];
};

/** List covering whether the user's occupation was from defined taxonomy or user generated. */
export const LearnerObject_OccupationInputType = {
  /** Occupation selected from predefined taxonomy. */
  Defined: 'DEFINED',
  /** Occupation entered as free-form text by user. */
  UserGenerated: 'USER_GENERATED'
} as const;

export type LearnerObject_OccupationInputType = typeof LearnerObject_OccupationInputType[keyof typeof LearnerObject_OccupationInputType];
/** Input type for skills wanted. */
export type LearnerObject_SkillsWantedV2Input = {
  /** User-generated skills entered as free-form text. */
  userGeneratedSkills?: InputMaybe<Array<Scalars['String']>>;
  /** Skills selected from predefined list of skill IDs. */
  userInterestSkillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for updating current occupation. */
export type LearnerObject_UpdateCurrentOccupationInput = {
  /** The new current occupation value. */
  currentOccupation: LearnerObject_CurrentOccupationInput;
};

/** Input for updating education profile. */
export type LearnerObject_UpdateEducationProfileInput = {
  /** The new education profile value. */
  educationProfile: LearnerObject_EducationProfileInput;
};

/** Input for updating interested careers. */
export type LearnerObject_UpdateInterestedCareersInput = {
  /** The new interested careers value. */
  interestedCareers: LearnerObject_InterestedCareersInput;
};

/** Input for updating last indicated unsure roles timestamp. */
export type LearnerObject_UpdateLastIndicatedUnsureRolesAtInput = {
  /** The timestamp when the user indicated they were unsure about their roles (ISO 8601 format). */
  lastIndicatedUnsureRolesAt: Scalars['DateTime'];
};

/** Input for updating last indicated unsure skills timestamp. */
export type LearnerObject_UpdateLastIndicatedUnsureSkillsAtInput = {
  /** The timestamp when the user indicated they were unsure about their skills (ISO 8601 format). */
  lastIndicatedUnsureSkillsAt: Scalars['DateTime'];
};

/** Input for updating learning goal. */
export type LearnerObject_UpdateLearningGoalInput = {
  /** The new learning goal value. */
  learningGoal: LearnerObject_LearningGoal;
};

/** Input for updating most recent course completion. */
export type LearnerObject_UpdateMostRecentCourseCompletionInput = {
  /** The most recent completed course details. */
  mostRecentCourseCompletion: LearnerObject_MostRecentCourseCompletionInput;
};

/** Input for updating skills wanted. */
export type LearnerObject_UpdateSkillsWantedV2Input = {
  /** The new skills wanted value. */
  skillsWantedV2: LearnerObject_SkillsWantedV2Input;
};

/** Add a new skill that the learner is interest in to the learner onboarding response */
export type LearnerOnboarding_AddSkillInput = {
  /** Id of the skill to save in the onboarding response of the learner. */
  skillId: Scalars['ID'];
  /** Name of the skill. */
  skillName: Scalars['String'];
  /** User ID of the learner. */
  userId: Scalars['ID'];
};

/** Goals of enterprise learner onboarding */
export const LearnerOnboarding_Goal = {
  /** Indicates learner wants to get new credentials or degree. */
  Credentials: 'CREDENTIALS',
  /** Indicates learner wants to explore. */
  Explore: 'EXPLORE',
  /** Indicates learner wants to grow in a role. */
  Grow: 'GROW',
  /** Indicates learner wants to land a job. */
  Land: 'LAND',
  /** Indicates learner wants to become a leader. */
  Leader: 'LEADER',
  /** Indicates learner wants to switch in to a new role. */
  Switch: 'SWITCH'
} as const;

export type LearnerOnboarding_Goal = typeof LearnerOnboarding_Goal[keyof typeof LearnerOnboarding_Goal];
/** Level in enterprise learner onboarding */
export const LearnerOnboarding_Level = {
  /** Indicates learner has an advanced knowledge of the selected role. */
  Advanced: 'ADVANCED',
  /** Indicates learner has a beginner knowledge of the selected role. */
  Beginner: 'BEGINNER',
  /** Indicates learner has an expert knowledge of the selected role. */
  Expert: 'EXPERT',
  /** Indicates learner has an intermediate knowledge of the selected role. */
  Intermediate: 'INTERMEDIATE',
  /** Indicates learner has an mixed knowledge or is not sure of his level of the selected role. */
  Unsure: 'UNSURE'
} as const;

export type LearnerOnboarding_Level = typeof LearnerOnboarding_Level[keyof typeof LearnerOnboarding_Level];
/** Enum that defines all supported frontend entrypoints for modular onboarding. */
export const LearnerOnboarding_ModularOnboardingEntryPoint = {
  /** Entry point from the logged-in-home-page home tab. */
  LihpHome: 'LIHP_HOME',
  /** Entry point from the Role Description Page. */
  Rdp: 'RDP',
  /** Entry point from the search results page. */
  Search: 'SEARCH'
} as const;

export type LearnerOnboarding_ModularOnboardingEntryPoint = typeof LearnerOnboarding_ModularOnboardingEntryPoint[keyof typeof LearnerOnboarding_ModularOnboardingEntryPoint];
/** Enum that defines modular onboarding actions we want to store */
export const LearnerOnboarding_ModularOnboardingInteractionType = {
  /** Indicates user dismisses the onboarding module */
  Dismissal: 'DISMISSAL',
  /** Indicates user confirms inferred role */
  RoleConfirmation: 'ROLE_CONFIRMATION'
} as const;

export type LearnerOnboarding_ModularOnboardingInteractionType = typeof LearnerOnboarding_ModularOnboardingInteractionType[keyof typeof LearnerOnboarding_ModularOnboardingInteractionType];
/** Enum that defines all supported question types for modular onboarding. */
export const LearnerOnboarding_ModularOnboardingQuestionType = {
  /** Question about the user's learning goals and objectives. */
  LearningGoal: 'LEARNING_GOAL',
  /** Question about the user's desired roles. */
  Role: 'ROLE',
  /** Question about the user's desired skills. */
  Skill: 'SKILL'
} as const;

export type LearnerOnboarding_ModularOnboardingQuestionType = typeof LearnerOnboarding_ModularOnboardingQuestionType[keyof typeof LearnerOnboarding_ModularOnboardingQuestionType];
/** Input needed to fetch modular onboarding config */
export type LearnerOnboarding_OnboardingModuleConfigInput = {
  /** The frontend entrypoint from which the onboarding module config is requested */
  entrypoint: LearnerOnboarding_ModularOnboardingEntryPoint;
  /** The career role id from the caller for cases where the client wants to provide an inferred role (e.g RDP) */
  inferredRoleId?: InputMaybe<Scalars['ID']>;
};

/** Removes a learner response from onboarding responses table identified by userId */
export type LearnerOnboarding_RemoveResponseInput = {
  /** User ID of the learner. */
  userId: Scalars['ID'];
};

/** Set interaction result for the onboarding module */
export type LearnerOnboarding_SetModularOnboardingInteractionInput = {
  /** Modular onboarding actions, either dismiss onboarding or confirm inferred role */
  type: LearnerOnboarding_ModularOnboardingInteractionType;
};

/** Input for setting onboarding seen */
export type LearnerOnboarding_SetOnboardingSeenInput = {
  /** The onboarding version that was last seen */
  onboardingVersion: Scalars['String'];
};

/** Set interested skill for a learner in onboarding responses table. */
export type LearnerOnboarding_UpdateInterestedSkillsInput = {
  /** Ids of the skill that learner is interested in. */
  ids: Array<Scalars['ID']>;
};

/** Update the time to remind learner by in the learner onboarding response. */
export type LearnerOnboarding_UpdateRemindMeByTimeInput = {
  /**
   * Time to remind the learner to fill out the onboarding flow. This will be empty when either learner hasn't visited a
   * program home page or if the learner has completed the flow. Once flow is completed this field is ignored.
   */
  remindMeByTime: Scalars['DateTime'];
  /**
   * User ID of the learner.
   * @deprecated Having userId as input for logged in request is not recommended.
   */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Update the role for a learner in onboarding responses table. */
export type LearnerOnboarding_UpdateRoleInput = {
  /** Occupation id of the role to be set. */
  occupationId: Scalars['ID'];
};

/** Input for adding a term for plan */
export type LearnerPlan_AddTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** List of Segment CourseIds the learner planned for a term */
  plannedSegmentCourses?: InputMaybe<Array<Scalars['ID']>>;
  /** Specifies if the learner explicitly planned to skip the term */
  skipped: Scalars['Boolean'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** Input for creating learner plan */
export type LearnerPlan_CreatePlanInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
};

/** Input for deleting learner plan */
export type LearnerPlan_DeletePlanInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
};

/** Detail input for moving courses from one term to another */
export type LearnerPlan_MoveCourseInput = {
  /** IDs of the courses to be moved */
  courseId: Scalars['ID'];
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** ID of the destination term to where the courses are to be moved */
  destinationTermId: Scalars['ID'];
  /** ID of the source term from where the courses are to be moved */
  sourceTermId: Scalars['ID'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** Input for removing term from the plan" */
export type LearnerPlan_RemoveTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** version of the plan to trigger remove on */
  version: Scalars['Int'];
};

/** Input for updating a term for plan */
export type LearnerPlan_UpdateTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** List of Segment CourseIds the learner planned for a term */
  plannedSegmentCourses?: InputMaybe<Array<Scalars['ID']>>;
  /** Specifies if the learner explicitly planned to skip the term */
  skipped: Scalars['Boolean'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** One of 'remove' (removes boolean) or 'boolean' to patch to new value */
export type LearnerProfile_BooleanOrRemoveInput = {
  /** Set if boolean field should be patched to new value */
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  /** Set if boolean field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Input for user's work eligibilities, keyed by country code. */
export type LearnerProfile_CountryWorkEligibilitiesInput = {
  /** US work eligibility */
  US?: InputMaybe<LearnerProfile_UsWorkEligibilityInput>;
};

/** One of 'remove' (removes countryWorkEligibilities) or countryWorkEligibilities to patch to new value */
export type LearnerProfile_CountryWorkEligibilitiesOrRemoveInput = {
  /** Set if countryWorkEligibilities should be patched to new value */
  countryWorkEligibilities?: InputMaybe<LearnerProfile_CountryWorkEligibilitiesInput>;
  /** Set if countryWorkEligibilities should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Input of the LearnerProfile_DeleteResume mutation */
export type LearnerProfile_DeleteResumeInput = {
  /** The resumeUrl to be deleted, ex: https://coursera-profile-resumes.s3.amazonaws.com/cv.pdf */
  resumeUrl: Scalars['URL'];
};

/** One of 'remove' (removes desiredSkills) or 'desiredSkills' to patch to new value */
export type LearnerProfile_DesiredSkillsOrRemoveInput = {
  /** Set if 'desiredSkills' should be patched to new 'desiredSkills' value. A maximum of 50 skills is allowed. */
  desiredSkills?: InputMaybe<Array<LearnerProfile_SkillInput>>;
  /** Set if 'desiredSkills' should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Input for LearnerProfile_Domain. Accepts either a domain ID or an enum value for the other domain. */
export type LearnerProfile_DomainInput = {
  /** The id of the domain */
  id?: InputMaybe<Scalars['ID']>;
  /** The enum value of the other domain */
  otherDomain?: InputMaybe<LearnerProfile_OtherDomainEnum>;
};

/** Enum for degree type options for an education history item */
export const LearnerProfile_EducationHistoryDegreeType = {
  /** Associate's degree */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Doctorate degree */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High school diploma */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** No degree level qualification */
  NoDegree: 'NO_DEGREE',
  /** A professional school degree */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type LearnerProfile_EducationHistoryDegreeType = typeof LearnerProfile_EducationHistoryDegreeType[keyof typeof LearnerProfile_EducationHistoryDegreeType];
/** LearnerProfile Education History Input */
export type LearnerProfile_EducationHistoryInput = {
  /** Area of concentration for the education */
  areaOfConcentration?: InputMaybe<Scalars['String']>;
  /** Degree type for the course the user is studying */
  degreeType?: InputMaybe<LearnerProfile_EducationHistoryDegreeType>;
  /**
   * The user's grade at this institution.
   * This can be a GPA e.g., 3.0 or 3.0/4.0 or some free text e.g., "Summa Cum Laude"
   */
  grade?: InputMaybe<Scalars['String']>;
  /** Graduation date of the education */
  graduationDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
  /** Name of the institution */
  institutionName?: InputMaybe<Scalars['String']>;
  /** Set to true if learner is currently a student of the education history, false otherwise. */
  isCurrentlyAStudent?: InputMaybe<Scalars['Boolean']>;
  /** The field of study the learner is reading */
  major?: InputMaybe<LearnerProfile_EducationHistoryMajor>;
  /** Start date of the education */
  startDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** Enum for major of education */
export const LearnerProfile_EducationHistoryMajor = {
  /** Arts or humanities major */
  ArtsAndHumanities: 'ARTS_AND_HUMANITIES',
  /** Biology major */
  BiologicalSciences: 'BIOLOGICAL_SCIENCES',
  /** Business major */
  Business: 'BUSINESS',
  /** Computer Science major */
  ComputerScience: 'COMPUTER_SCIENCE',
  /** Education-related major */
  Education: 'EDUCATION',
  /** Engineering major of any type */
  Engineering: 'ENGINEERING',
  /** Any kind of doctor or health-related major */
  HealthProfessions: 'HEALTH_PROFESSIONS',
  /** Any kind of law or legal major */
  LegalProfessions: 'LEGAL_PROFESSIONS',
  /** Math and/or statistics major */
  MathematicsAndStatistics: 'MATHEMATICS_AND_STATISTICS',
  /** Not Applicable for some reason */
  Na: 'NA',
  /** Anything else that is not listed */
  Other: 'OTHER',
  /** Physics major */
  PhysicalSciences: 'PHYSICAL_SCIENCES',
  /** Any kind of social or behavioral sciences major */
  SocialSciences: 'SOCIAL_SCIENCES'
} as const;

export type LearnerProfile_EducationHistoryMajor = typeof LearnerProfile_EducationHistoryMajor[keyof typeof LearnerProfile_EducationHistoryMajor];
/** One of 'remove' (removes education history) or 'educationHistory' to patch to new value */
export type LearnerProfile_EducationHistoryOrRemoveInput = {
  /** Set if educationHistory should be patched to new educationHistory value */
  educationHistory?: InputMaybe<Array<LearnerProfile_EducationHistoryInput>>;
  /** Set if educationHistory should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** One of 'remove' (removes ethnicities) or ethnicities to patch to new value */
export type LearnerProfile_EthnicitiesOrRemoveInput = {
  /** Set if ethnicities should be patched to new value */
  ethnicities?: InputMaybe<Array<LearnerProfile_Ethnicity>>;
  /** Set if ethnicities should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/**
 * Options for a Learner's Ethnicity/Ethnicities.
 * Used by the recruiting platform for DEI metrics.
 */
export const LearnerProfile_Ethnicity = {
  /** African American */
  AfricanAmerican: 'AFRICAN_AMERICAN',
  /** American Indian or Alaskan Native */
  AmericanIndian: 'AMERICAN_INDIAN',
  /** Asian */
  Asian: 'ASIAN',
  /** Hispanic or LatinX */
  Hispanic: 'HISPANIC',
  /** Native Hawaiian or Pacific Islander */
  NativeHawaiian: 'NATIVE_HAWAIIAN',
  /** Prefer not to answer */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** White */
  White: 'WHITE'
} as const;

export type LearnerProfile_Ethnicity = typeof LearnerProfile_Ethnicity[keyof typeof LearnerProfile_Ethnicity];
/** The LearnerProfile external links to patch */
export type LearnerProfile_ExternalLinksInput = {
  /**
   * Sets new default url if default url is not null.
   * If null, default url remains unchanged
   * If RemoveInput, removes default url
   */
  defaultLink?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new facebook url if facebook url is not null.
   * If null, facebook url remains unchanged
   * If RemoveInput, removes facebook url
   */
  facebook?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new github url if github url is not null.
   * If null, github url remains unchanged
   * If RemoveInput, removes github url
   */
  github?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new linkedin url if linkedin url is not null.
   * If null, linkedin url remains unchanged
   * If RemoveInput, removes linkedin url
   */
  linkedin?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new twitter url if twitter url is not null.
   * If null, twitter url remains unchanged
   * If RemoveInput, removes twitter url
   */
  twitter?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
};

/** One of 'remove' (removes float) or 'float' to patch to new value */
export type LearnerProfile_FloatOrRemoveInput = {
  /** Set if float field should be patched to new value */
  float?: InputMaybe<Scalars['Float']>;
  /** Set if float field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Enum for gender options available in the profile */
export const LearnerProfile_Gender = {
  /** Agender */
  Agender: 'AGENDER',
  /** Not listed */
  GenderNotListed: 'GENDER_NOT_LISTED',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Prefer not to say */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Transgender */
  Transgender: 'TRANSGENDER',
  /** Two sprit */
  TwoSpirit: 'TWO_SPIRIT',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type LearnerProfile_Gender = typeof LearnerProfile_Gender[keyof typeof LearnerProfile_Gender];
/** Enum for gender options available in the learner profile */
export const LearnerProfile_GenderEnum = {
  /** Agender */
  Agender: 'AGENDER',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Prefer not to say */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Transgender man */
  TransgenderMan: 'TRANSGENDER_MAN',
  /** Transgender woman */
  TransgenderWoman: 'TRANSGENDER_WOMAN',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type LearnerProfile_GenderEnum = typeof LearnerProfile_GenderEnum[keyof typeof LearnerProfile_GenderEnum];
/** Learner Profile Industry Input */
export type LearnerProfile_IndustryInput = {
  /** The id of the industry */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the industry */
  name?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes int) or 'int' to patch to new value */
export type LearnerProfile_IntOrRemoveInput = {
  /** Set if int field should be patched to new value */
  int?: InputMaybe<Scalars['Int']>;
  /** Set if int field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** One of 'remove' (removes desiredDomain) or 'desiredDomains' to patch to new value */
export type LearnerProfile_InterestedDomainsOrRemoveInput = {
  /** Set if 'desiredDomains' should be patched to new 'desiredDomains' value. A maximum of 11 domains are allowed. This matches the number of domains that exist today (7/23/2025). */
  desiredDomains?: InputMaybe<Array<LearnerProfile_DomainInput>>;
  /** Set if 'desiredDomains' should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Learner Profile Gender Input */
export type LearnerProfile_LearnerProfileGenderInput = {
  /** The selected gender enum */
  selectedEnum?: InputMaybe<LearnerProfile_GenderEnum>;
  /** The custom self declared gender of the user */
  userGenderInput?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes learnerProfileGender) or 'learnerProfileGender' to patch to new value */
export type LearnerProfile_LearnerProfileGenderOrRemoveInput = {
  /** Set if learnerProfileGender should be patched to new value */
  learnerProfileGender?: InputMaybe<LearnerProfile_LearnerProfileGenderInput>;
  /** Set if learnerProfileGender should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Options for a User's Learning Goal */
export const LearnerProfile_LearningGoal = {
  /** Change career */
  ChangeCareer: 'CHANGE_CAREER',
  /** Improve skills */
  ImproveSkills: 'IMPROVE_SKILLS',
  /** Land a new job */
  LandNewJob: 'LAND_NEW_JOB',
  /** Personal interest */
  PersonalInterest: 'PERSONAL_INTEREST'
} as const;

export type LearnerProfile_LearningGoal = typeof LearnerProfile_LearningGoal[keyof typeof LearnerProfile_LearningGoal];
/** Learner Profile Occupation Input */
export type LearnerProfile_OccupationInput = {
  /** The id of the occupation. The id must be lower-kebab-case, and must be at most 100 characters long. */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the occupation. The name cannot be empty, cannot have special characters, and must be at most 100 characters long. */
  name?: InputMaybe<Scalars['String']>;
};

/** Enum for the levels of experience the learner is looking for in their preferred role */
export const LearnerProfile_OccupationPreferenceLevel = {
  /** Senior manager level of occupation */
  Director: 'DIRECTOR',
  /** Executive level of occupation */
  ExecutiveManagement: 'EXECUTIVE_MANAGEMENT',
  /** Intern level of occupation */
  Intern: 'INTERN',
  /** Entry or Junior level of occupation */
  JuniorIndividualContributor: 'JUNIOR_INDIVIDUAL_CONTRIBUTOR',
  /** Lead level of occupation */
  ManagerialLeadershipRole: 'MANAGERIAL_LEADERSHIP_ROLE',
  /** Not applicable for the role they are looking for */
  NotApplicable: 'NOT_APPLICABLE',
  /** Senior Contributor level of occupation */
  SeniorIndividualContributor: 'SENIOR_INDIVIDUAL_CONTRIBUTOR'
} as const;

export type LearnerProfile_OccupationPreferenceLevel = typeof LearnerProfile_OccupationPreferenceLevel[keyof typeof LearnerProfile_OccupationPreferenceLevel];
/** Learner Profile Occupation Preferences Input */
export type LearnerProfile_OccupationPreferencesInput = {
  /** Preferred industry */
  industry?: InputMaybe<LearnerProfile_IndustryInput>;
  /** Preferred level of the occupation */
  level?: InputMaybe<LearnerProfile_OccupationPreferenceLevel>;
  /** Preferred occupation */
  occupation?: InputMaybe<LearnerProfile_OccupationInput>;
};

/** One of 'remove' (removes occupation preferences) or 'occupationPreferences' to patch to new value */
export type LearnerProfile_OccupationPreferencesOrRemoveInput = {
  /**
   * Set if occupationPreferences should be patched to new occupationPreferences value
   * A maximum of 8 occupation preferences is allowed.
   */
  occupationPreferences?: InputMaybe<Array<LearnerProfile_OccupationPreferencesInput>>;
  /** Set if occupationPreferences should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Common domain categories available on Coursera */
export const LearnerProfile_OtherDomainEnum = {
  /** Other domain */
  Other: 'OTHER'
} as const;

export type LearnerProfile_OtherDomainEnum = typeof LearnerProfile_OtherDomainEnum[keyof typeof LearnerProfile_OtherDomainEnum];
/** Input of the LearnerProfile_PatchAdditionalInfo mutation */
export type LearnerProfile_PatchAdditionalInfoInput = {
  /**
   * If about type is LearnerProfile_RemoveInput, sets about to null
   * If about field is null don’t change value of about
   * If about is not null set about to new value
   */
  about?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If externalLinks field is null, field is undefined and don’t change value of externalLinks
   * If externalLinks is not null, set externalLinks to new value
   */
  externalLinks?: InputMaybe<LearnerProfile_ExternalLinksInput>;
  /**
   * If resumeUrl type is LearnerProfile_RemoveInput, sets resumeUrl to null
   * If resumeUrl field is null, field is undefined and don’t change value of resumeUrl
   * If resumeUrl is not null, set resumeUrl to new value
   */
  resumeUrl?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchDomains mutation. */
export type LearnerProfile_PatchDomainsInput = {
  /**
   * If interestedDomains type is LearnerProfile_RemoveInput, sets interestedDomains to null
   * If interestedDomains field is null don't change value of interestedDomains
   * If interestedDomains is not null set interestedDomains to new value
   */
  interestedDomains?: InputMaybe<LearnerProfile_InterestedDomainsOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchEducation mutation */
export type LearnerProfile_PatchEducationInput = {
  /**
   * If educationHistory type is LearnerProfile_RemoveInput, sets educationHistory to null
   * If educationHistory field is null don’t change value of educationHistory
   * If educationHistory is not null set educationHistory to new value
   */
  educationHistory?: InputMaybe<LearnerProfile_EducationHistoryOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchPersonalInformation mutation */
export type LearnerProfile_PatchPersonalInformationInput = {
  /**
   * If countryWorkEligibilities type is LearnerProfile_RemoveInput, sets countryWorkEligibilities to null
   * If countryWorkEligibilities field is null don’t change value of countryWorkEligibilities
   * If countryWorkEligibilities is not null set countryWorkEligibilities to new value
   */
  countryWorkEligibilities?: InputMaybe<LearnerProfile_CountryWorkEligibilitiesOrRemoveInput>;
  /**
   * If ethnicities field is null don’t change value of ethnicities
   * If ethnicities is not null set ethnicities to new value
   */
  ethnicities?: InputMaybe<LearnerProfile_EthnicitiesOrRemoveInput>;
  /**
   * If fullName type is LearnerProfile_RemoveInput, sets fullName to null
   * If fullName field is null or string field is null, field is undefined and don’t change value of fullName
   * If fullName is string and string field has value, set fullName to new value
   */
  fullName?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If learnerProfileGender type is LearnerProfile_RemoveInput, sets learnerProfileGender to null
   * If learnerProfileGender field is null don’t change value of learnerProfileGender
   * If learnerProfileGender is not null set learnerProfileGender to new value
   */
  learnerProfileGender?: InputMaybe<LearnerProfile_LearnerProfileGenderOrRemoveInput>;
  /**
   * If location type is LearnerProfile_RemoveInput, sets location to null
   * If location field is null don’t change value of location
   * If location is not null set location to new value
   */
  location?: InputMaybe<LearnerProfile_UserLocationOrRemoveInput>;
  /**
   * If profilePhoto type is LearnerProfile_RemoveInput, sets profilePhoto to null
   * If profilePhoto field is null don’t change value of profilePhoto
   * If profilePhoto is not null set profilePhoto to new value
   */
  profilePhoto?: InputMaybe<LearnerProfile_ProfilePhotoOrRemoveInput>;
  /**
   * If pronoun type is LearnerProfile_RemoveInput, sets pronoun to null
   * If pronoun field is null don’t change value of pronoun
   * If pronoun is not null set pronoun to new value
   */
  pronoun?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If veteranStatus type is LearnerProfile_RemoveInput, sets veteranStatus to null
   * If veteranStatus field is null don’t change value of veteranStatus
   * If veteranStatus is not null set veteranStatus to the new value
   */
  veteranStatus?: InputMaybe<LearnerProfile_VeteranStatusOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchPrivacySettings mutation */
export type LearnerProfile_PatchPrivacySettingsInput = {
  /**
   * If includedInTalentPipeline type is LearnerProfile_RemoveInput, sets includedInTalentPipeline to null
   * If includedInTalentPipeline field is null don’t change value of includedInTalentPipeline
   * If includedInTalentPipeline is not null set includedInTalentPipeline to new value
   */
  includedInTalentPipeline?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If showToPublic type is LearnerProfile_RemoveInput, sets showToPublic to null
   * If showToPublic field is null don’t change value of showToPublic
   * If showToPublic is not null set showToPublic to new value
   */
  showToPublic?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchProfileSlug mutation */
export type LearnerProfile_PatchProfileSlugInput = {
  /** the user-provided custom slug for use in the profile url, ex: https://coursera.org/profile/my-slug */
  profileSlug: Scalars['String'];
};

/**
 * Input of the LearnerProfile_PatchSkills mutation.
 *
 * Note: We are adding the 'ratedSkills' field to this input. Both 'existingField' and 'ratedSkills' will be available, and the client will specify which field to update.
 */
export type LearnerProfile_PatchSkillsInput = {
  /**
   * If desiredSkills type is LearnerProfile_RemoveInput, sets desiredSkills to null
   * If desiredSkills field is null don't change value of desiredSkills
   * If desiredSkills is not null set desiredSkills to new value
   */
  desiredSkills?: InputMaybe<LearnerProfile_DesiredSkillsOrRemoveInput>;
  /**
   * The learner may indicate that they're unsure of what skills they're
   * interested in developing
   */
  isUnsureOfSkills?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchWorkExperience mutation */
export type LearnerProfile_PatchWorkExperienceInput = {
  /**
   * If workHistory type is LearnerProfile_RemoveInput, sets workHistory to null
   * If workHistory field is null don’t change value of workHistory
   * If workHistory is not null set workHistory to new value
   */
  workHistory?: InputMaybe<LearnerProfile_WorkHistoryOrRemoveInput>;
};

/** Input of the LearnerProfile_PatchWorkPreferences mutation */
export type LearnerProfile_PatchWorkPreferencesInput = {
  /**
   * The learner indicated that they’re unsure of which role they’re interested
   * in pursuing
   */
  isUnsureOfRoles?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If occupationPreferences type is LearnerProfile_RemoveInput, sets occupationPreferences to null
   * If occupationPreferences field is null don’t change value of occupationPreferences
   * If occupationPreferences is not null set occupationPreferences to new value
   * A maximum of 8 occupation preferences is allowed.
   */
  occupationPreferences?: InputMaybe<LearnerProfile_OccupationPreferencesOrRemoveInput>;
  /**
   * If openToRemoteWork type is LearnerProfile_RemoveInput, sets openToRemoteWork to null
   * If openToRemoteWork field is null, field is undefined and don’t change value of openToRemoteWork
   * If openToRemoteWork is boolean, set openToRemoteWork to new value
   */
  openToRemoteWork?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If willingToRelocate type is LearnerProfile_RemoveInput, sets willingToRelocate to null
   * If willingToRelocate field is null, field is undefined and don’t change value of willingToRelocate
   * If willingToRelocate is boolean, set willingToRelocate to new value
   */
  willingToRelocate?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** Learner Profile Photo input */
export type LearnerProfile_ProfilePhotoInput = {
  /**
   * Sets new defaultSize if defaultSize is not null.
   * If null, defaultSize sets to null.
   */
  defaultSize?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size24 if size24 is not null.
   * If null, size24 sets to null
   */
  size24?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size60 if size60 is not null.
   * If null, size60 sets to null
   */
  size60?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size120 if size120 is not null.
   * If null, size120 sets to null
   */
  size120?: InputMaybe<Scalars['URL']>;
};

/** One of 'remove' (removes profilePhoto) or 'profilePhoto' to patch to new value */
export type LearnerProfile_ProfilePhotoOrRemoveInput = {
  /** Set if profilePhoto should be patched to new value */
  profilePhoto?: InputMaybe<LearnerProfile_ProfilePhotoInput>;
  /** Set if profilePhoto should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Project type enum. */
export const LearnerProfile_ProjectType = {
  /** Capstone project type. */
  Capstone: 'CAPSTONE',
  /** Portfolio project type. */
  Demonstration: 'DEMONSTRATION'
} as const;

export type LearnerProfile_ProjectType = typeof LearnerProfile_ProjectType[keyof typeof LearnerProfile_ProjectType];
/** Input used to remove LearnerProfile inputs */
export type LearnerProfile_RemoveInput = {
  /** Dummy field whose value is unused. GraphQL requires input to have at least one field. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Proficiency level of the user in a given skill assessment */
export const LearnerProfile_SkillAssessmentProficiency = {
  /** Beginner level of proficiency */
  Beginner: 'BEGINNER',
  /** Experienced level of proficiency */
  Experienced: 'EXPERIENCED',
  /** Intermediate level of proficiency */
  Intermediate: 'INTERMEDIATE',
  /** Proficient level of proficiency */
  Proficient: 'PROFICIENT'
} as const;

export type LearnerProfile_SkillAssessmentProficiency = typeof LearnerProfile_SkillAssessmentProficiency[keyof typeof LearnerProfile_SkillAssessmentProficiency];
/** Input for LearnerProfile_Skill */
export type LearnerProfile_SkillInput = {
  /** The id of the skill */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the skill */
  name?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes string) or 'string' to patch to new value */
export type LearnerProfile_StringOrRemoveInput = {
  /** Set if string field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if string field should be patched to new value */
  string?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes url) or 'url' to patch to new value */
export type LearnerProfile_UrlOrRemoveInput = {
  /** Set if url should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if url should be patched to new URL value */
  url?: InputMaybe<Scalars['URL']>;
};

/** US work eligibility input */
export type LearnerProfile_UsWorkEligibilityInput = {
  /** True if the user is authorized to work in the US, false otherwise. */
  hasWorkAuthorization?: InputMaybe<Scalars['Boolean']>;
  /** True if the user requires visa sponsorship to work in the US, false otherwise. */
  requiresVisaSponsorship?: InputMaybe<Scalars['Boolean']>;
};

/** User Location Input */
export type LearnerProfile_UserLocationInput = {
  /**
   * Sets new cityName if cityName is not null.
   * If null, cityName sets to null
   */
  cityName?: InputMaybe<Scalars['String']>;
  /**
   * Sets new countryCode if countryCode is not null.
   * If null, countryCode sets to null
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Sets new latitude if latitude is not null.
   * If null, latitude sets to null
   */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Sets new longitude if longitude is not null.
   * If null, longitude sets to null
   */
  longitude?: InputMaybe<Scalars['Float']>;
  /**
   * Sets new stateName if stateName is not null.
   * If null, stateName sets to null
   */
  stateName?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes location) or 'location' to patch to new value */
export type LearnerProfile_UserLocationOrRemoveInput = {
  /** Set if location should be patched to new value */
  location?: InputMaybe<LearnerProfile_UserLocationInput>;
  /** Set if location should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/**
 * Options for a Learner's Veteran Status.
 * Used by the recruiting platform in the United States for DEI metrics.
 */
export const LearnerProfile_VeteranStatus = {
  /** Not a Protected Veteran */
  NotProtectedVeteran: 'NOT_PROTECTED_VETERAN',
  /** Prefer not to answer */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Protected Veteran (specifically in the US) */
  ProtectedVeteran: 'PROTECTED_VETERAN'
} as const;

export type LearnerProfile_VeteranStatus = typeof LearnerProfile_VeteranStatus[keyof typeof LearnerProfile_VeteranStatus];
/** One of 'remove' (removes veteranStatus) or veteranStatus to patch to new value */
export type LearnerProfile_VeteranStatusOrRemoveInput = {
  /** Set if veteranStatus should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if veteranStatus should be patched to new value */
  veteranStatus?: InputMaybe<LearnerProfile_VeteranStatus>;
};

/** LearnerProfile Work History Input */
export type LearnerProfile_WorkHistoryInput = {
  /** Description of the work history */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the employer */
  employerName?: InputMaybe<Scalars['String']>;
  /** End date of the work history */
  endDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
  /** Set to true if the learner is currently employed in the work history, false otherwise */
  isCurrentlyEmployed?: InputMaybe<Scalars['Boolean']>;
  /** Job title of the work history */
  jobTitle?: InputMaybe<LearnerProfile_OccupationInput>;
  /** Start date of the work history */
  startDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** One of 'remove' (removes work history) or 'workHistory' to patch to new value */
export type LearnerProfile_WorkHistoryOrRemoveInput = {
  /** Set if workHistory should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if workHistory should be patched to new workHistory value */
  workHistory?: InputMaybe<Array<LearnerProfile_WorkHistoryInput>>;
};

/** YearMonthDate Input */
export type LearnerProfile_YearMonthDateInput = {
  /** The month associated with the date, if null, don't change. Change month if not null. */
  month?: InputMaybe<Scalars['Int']>;
  /** The year associated with the date, if null, don't change. Change year if not null. */
  year?: InputMaybe<Scalars['Int']>;
};

/** One of 'remove' (removes yearMonthDate) or 'yearMonthDate' to patch to new value */
export type LearnerProfile_YearMonthDateOrRemoveInput = {
  /** Set if yearMonthDate should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if yearMonthDate should be patched to new yearMonthDate value */
  yearMonthDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** Platform this event was sent from. */
export const LearningHours_EventPlatform = {
  /** Mobile device such as android or iOS */
  Mobile: 'MOBILE',
  /** Web */
  Web: 'WEB'
} as const;

export type LearningHours_EventPlatform = typeof LearningHours_EventPlatform[keyof typeof LearningHours_EventPlatform];
/**
 * Data sent every "durationSeconds" from the FE that contains
 * data on what course the user was learning on and potential item details.
 * UserId is taken from request context.
 */
export type LearningHours_Heartbeat = {
  /**
   * ISO Date Formatted String with Millisecond precision.
   * In cases where local storage may be used (Eg. Mobile) to batch events, it could be possible for
   * clientTimestamp and serverTimestamp to differ by a large amount
   */
  clientDateTime: Scalars['DateTime'];
  /** Optional course branch ID the learner is viewing. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** courseId */
  courseId: Scalars['ID'];
  /**
   * Optional field if available.
   * Used to uniquely identify the device incase a learner has coursera open
   * on multiple browsers or is sharing accounts
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Length of the heart beat interval in milliseconds. Eg. 30000 for 30 secs */
  durationMilliSeconds: Scalars['Int'];
  /**
   * event os:
   * Eg. Mac OS X, Windows 10, Android, iOS, etc
   * There are too many past and potential future values to enumerate here so leaving this as a String
   */
  eventOs: Scalars['String'];
  /** event platform */
  eventPlatform: LearningHours_EventPlatform;
  /** Optional itemDetails */
  itemDetails?: InputMaybe<LearningHours_HeartbeatItemDetails>;
  /** User Action Type */
  userActionType: LearningHours_UserActionType;
};

/** Details about the item the learner may have been viewing when the heartbeat was sent */
export type LearningHours_HeartbeatItemDetails = {
  /** ItemId if user was on an item page when heartbeat was sent */
  itemId: Scalars['ID'];
  /** Optional details about the item the learner was on. */
  learnerActivityType?: InputMaybe<LearningHours_LearnerActivityType>;
};

/**
 * Types are defined on the FE:
 * https://github.com/webedx-spark/web/blob/main/static/bundles/course-v2/utils/LearningHoursSignalsUtil.ts#L5
 */
export const LearningHours_LearnerActivityType = {
  /** Learner was on a discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Learner was on a video page */
  Lecture: 'LECTURE',
  /** Learner was on a peer review */
  PeerReview: 'PEER_REVIEW',
  /** Learner was on a programming item */
  Programming: 'PROGRAMMING',
  /** Learner was on a quiz item */
  Quiz: 'QUIZ',
  /** Learner was on a reading item */
  Reading: 'READING',
  /** Learner was on a staff graded item */
  StaffGraded: 'STAFF_GRADED',
  /** Learner was on a teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Learner was on an ungraded lab item */
  UngradedLab: 'UNGRADED_LAB'
} as const;

export type LearningHours_LearnerActivityType = typeof LearningHours_LearnerActivityType[keyof typeof LearningHours_LearnerActivityType];
/** LearningHours_SendEventInput */
export type LearningHours_SendEventInput = {
  /** LearningHours_Heartbeat */
  heartbeat: LearningHours_Heartbeat;
};

/** Action that triggered the event */
export const LearningHours_UserActionType = {
  /** Mouse click or keyboard press */
  KeyPress: 'KEY_PRESS',
  /** Mouse movement */
  MouseMovement: 'MOUSE_MOVEMENT',
  /** Page scroll */
  PageScroll: 'PAGE_SCROLL',
  /** Learner is on video page and video is playing */
  VideoIsPlaying: 'VIDEO_IS_PLAYING'
} as const;

export type LearningHours_UserActionType = typeof LearningHours_UserActionType[keyof typeof LearningHours_UserActionType];
/** Various formats for audio */
export const LectureAuthoring_AudioFormat = {
  /** Audio format mp3 */
  Mp3: 'MP3'
} as const;

export type LectureAuthoring_AudioFormat = typeof LectureAuthoring_AudioFormat[keyof typeof LectureAuthoring_AudioFormat];
/** Input for the LectureAuthoring_AutoPublishLectureDraft mutation */
export type LectureAuthoring_AutoPublishLectureDraftInput = {
  /** Id of the atom to publish */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /**
   * Optional limit on which branches to publish to. If specified, only branches mapping to the
   * supplied branch ids will be published to and all other instances of the atom will be frozen.
   */
  publishBranchIdsIncluded?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for the LectureAuthoring_UpdateLectureDraft mutation */
export type LectureAuthoring_DeleteLectureDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Whether to also delete subtitles */
  deleteSubtitleDrafts: Scalars['Boolean'];
};

/** Lecture draft content, represented as an input type */
export type LectureAuthoring_DraftContentInput = {
  /** List of VersionedOpenCourseAssetIds */
  attachedAssets?: InputMaybe<Array<Scalars['ID']>>;
  /** List of deleted subtitle language codes */
  deletedSubtitleLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** In-video assessment id for adding in video assessments to lectures */
  inVideoAssessmentId?: InputMaybe<Scalars['ID']>;
  /** Updated item name */
  name: Scalars['String'];
  /** Subtitle AssetIds of the staged subtitle drafts for this lecture */
  stagedSubtitleDrafts?: InputMaybe<Array<Scalars['ID']>>;
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
  /** List of subtitles that will replace the existing subtitles */
  updatedSubtitles?: InputMaybe<Array<LectureAuthoring_SubtitleInput>>;
  /** Updated video asset Id */
  videoAssetId?: InputMaybe<Scalars['ID']>;
};

/** Subtitle update parameters */
export type LectureAuthoring_SubtitleInput = {
  /** AssetId to update to */
  assetId: Scalars['ID'];
  /** Language code of subtitle to update */
  languageCode: Scalars['String'];
};

/** Various states a subtitle transcription job can be in */
export const LectureAuthoring_SubtitleJobState = {
  /** Transcription job was aborted by the vendor */
  Aborted: 'ABORTED',
  /** Media context has been uploaded, so the transcription job is ready to be authorized */
  AuthorizeTranscription: 'AUTHORIZE_TRANSCRIPTION',
  /** Primary-language subtitle asset is present. Attempt to upload for translation here */
  CreateTranslation: 'CREATE_TRANSLATION',
  /** Something went horribly wrong (eg. vendor lost data) */
  Failed: 'FAILED',
  /** Initial state. Attempt to create a new transcription job here */
  NotStarted: 'NOT_STARTED',
  /** Transcription has been completed, so we attempt to download and create subtitle assets here */
  TranscriptionReady: 'TRANSCRIPTION_READY',
  /** Transcription job has been authorized. Poll transcription vendors for progress updates here */
  TranscriptionStarted: 'TRANSCRIPTION_STARTED',
  /** Subtitles uploaded to Smartling. Poll for completed translations here */
  Translating: 'TRANSLATING',
  /** Transcription job has been created, but needs media to be uploaded */
  UploadMedia: 'UPLOAD_MEDIA'
} as const;

export type LectureAuthoring_SubtitleJobState = typeof LectureAuthoring_SubtitleJobState[keyof typeof LectureAuthoring_SubtitleJobState];
/** States that a video transcoding job can be in */
export const LectureAuthoring_TranscodingStatus = {
  /** Transcoding has been completed */
  Completed: 'COMPLETED',
  /** Transcoding has failed */
  Failed: 'FAILED',
  /** Transcoding is still in progress */
  InProgress: 'IN_PROGRESS',
  /** Transcoding not started */
  NotStarted: 'NOT_STARTED'
} as const;

export type LectureAuthoring_TranscodingStatus = typeof LectureAuthoring_TranscodingStatus[keyof typeof LectureAuthoring_TranscodingStatus];
/** Input for the LectureAuthoring_UpdateLectureDraft mutation */
export type LectureAuthoring_UpdateLectureDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: LectureAuthoring_DraftContentInput;
};

/** Various resolutions for videos */
export const LectureAuthoring_VideoResolution = {
  /** Lowest resolution we transcode, only used on mobile */
  Resolution_234P: 'RESOLUTION_234P',
  /** Lowest resolution used on web */
  Resolution_240P: 'RESOLUTION_240P',
  /** 270p only used for mobile */
  Resolution_270P: 'RESOLUTION_270P',
  /** 360p resolution */
  Resolution_360P: 'RESOLUTION_360P',
  /** 540p resolution */
  Resolution_540P: 'RESOLUTION_540P',
  /** 720p resolution */
  Resolution_720P: 'RESOLUTION_720P',
  /** 1080p resolution */
  Resolution_1080P: 'RESOLUTION_1080P'
} as const;

export type LectureAuthoring_VideoResolution = typeof LectureAuthoring_VideoResolution[keyof typeof LectureAuthoring_VideoResolution];
/** Learner LevelSet ID. */
export type LevelSetAttempts_LearnerLevelSetId = {
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
  /** Unique ID of the User. */
  userId: Scalars['Int'];
};

/** Input of the LevelSetAttempts_ResetAttempts mutation. */
export type LevelSetAttempts_ResetAttemptsInput = {
  /** Learner LevelSet ID. */
  learnerLevelSetId: LevelSetAttempts_LearnerLevelSetId;
};

/** Versioned Skill ID. */
export type LevelSetContent_VersionedSkillId = {
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
  /** The version of the skill. */
  version: Scalars['Int'];
};

/** Mastery level of a skill. */
export const LevelSet_MasteryLevel = {
  /** Mastery level 1. */
  MasteryLevel_1: 'MASTERY_LEVEL_1',
  /** Mastery level 2. */
  MasteryLevel_2: 'MASTERY_LEVEL_2',
  /** Mastery level 3. */
  MasteryLevel_3: 'MASTERY_LEVEL_3',
  /** Mastery level 4. */
  MasteryLevel_4: 'MASTERY_LEVEL_4'
} as const;

export type LevelSet_MasteryLevel = typeof LevelSet_MasteryLevel[keyof typeof LevelSet_MasteryLevel];
/** The response object for questions per questionType */
export type LevelSet_QuestionResponse = {
  /** The ID of the question being answered. */
  questionId: Scalars['ID'];
  /** The type of question being responded to. */
  questionType: LevelSet_QuestionType;
  /** The version of the question being answered. */
  questionVersion: Scalars['Int'];
  /** The response object for questions per questionType */
  response?: InputMaybe<Scalars['JSON']>;
};

/** The enum of question types. */
export const LevelSet_QuestionType = {
  /** A checkbox question. */
  Checkbox: 'CHECKBOX',
  /** A multiple choice question. */
  MultipleChoice: 'MULTIPLE_CHOICE'
} as const;

export type LevelSet_QuestionType = typeof LevelSet_QuestionType[keyof typeof LevelSet_QuestionType];
/** Input type for starting a new LevelSet attempt. */
export type LevelSet_StartAttemptInput = {
  /** The ID of the program in which the assessment is conducted. */
  programId?: InputMaybe<Scalars['ID']>;
  /** The ID of the skill being assessed. */
  skillId: Scalars['ID'];
};

/** Input type for ending an existing LevelSet attempt. */
export type LevelSet_SubmitAttemptInput = {
  /** The ID of the attempt being ended. */
  attemptId: Scalars['ID'];
  /** Json strings of serialized question responses. */
  questions: Array<LevelSet_QuestionResponse>;
  /** The ID of the skill being assessed. */
  skillId: Scalars['ID'];
};

/** User progress status of a LevelSet */
export const LevelSet_UserProgressStatus = {
  /** A user has completed a LevelSet. */
  Completed: 'COMPLETED',
  /** A user is working on a LevelSet and hasn't submitted it yet. */
  InProgress: 'IN_PROGRESS',
  /** A user hasn't started on a LevelSet. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LevelSet_UserProgressStatus = typeof LevelSet_UserProgressStatus[keyof typeof LevelSet_UserProgressStatus];
/** The input for the LexExperimentEvents_CreateEvent mutation */
export type LexExperimentEvents_CreateEventInput = {
  /** Course ID of the the event type. Empty if the event is course-agnostic. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The type of the event to create */
  eventType: LexExperimentEvents_EventType;
  /** Specialization ID of the event type. If provided, the event will be associated with a specialization instead of a course. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** The input for the LexExperimentEvents_DeleteEvent mutation */
export type LexExperimentEvents_DeleteEventInput = {
  /** Course ID of the the event type. Empty if the event is course-agnostic. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The type of the event to delete */
  eventType: LexExperimentEvents_EventType;
  /** The user id for whom the event will be deleted */
  userId: Scalars['ID'];
};

/** Enum for event type options */
export const LexExperimentEvents_EventType = {
  /** The event for when the weekly streaks backfilled dialog on the logged-in homepage is seen. */
  BackfilledWeeklyStreakModalSeen: 'BACKFILLED_WEEKLY_STREAK_MODAL_SEEN',
  /** The event for when the learner sees the day one onboarding modal. */
  DayOneOnboardingModalSeen: 'DAY_ONE_ONBOARDING_MODAL_SEEN',
  /** The event for when the learner sees the macro goals education modal. */
  MacroGoalsEducationModalSeen: 'MACRO_GOALS_EDUCATION_MODAL_SEEN',
  /** The event for when the learner interacted with the personalized coach welcome experience. */
  PersonalizedCoachWelcomeInteracted: 'PERSONALIZED_COACH_WELCOME_INTERACTED',
  /** The event for when the learner returns to Coursera for the first time. */
  ReturnToCourseraSeen: 'RETURN_TO_COURSERA_SEEN',
  /** The event for when the learner shares their certificate, primarily used for goal generation purposes */
  ShareCertificateButtonClicked: 'SHARE_CERTIFICATE_BUTTON_CLICKED',
  /** The event for when the learner sees the skills intro modal for the first time after completing an item. */
  SkillPointsIntroSeen: 'SKILL_POINTS_INTRO_SEEN',
  /** The event for when the learner visits a course that is tagged with skill XP. */
  SkillXpTaggedCourseVisited: 'SKILL_XP_TAGGED_COURSE_VISITED',
  /** The event for when the learner starts their first course. */
  StartsCourseSeen: 'STARTS_COURSE_SEEN',
  /** The event for when the learner unlocks their daily goal trends. */
  TrackDailyGoalsTrendsSeen: 'TRACK_DAILY_GOALS_TRENDS_SEEN'
} as const;

export type LexExperimentEvents_EventType = typeof LexExperimentEvents_EventType[keyof typeof LexExperimentEvents_EventType];
/** Request input for creating experiment configuration. */
export type Localization_CreateExperimentConfigurationInput = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** Configuration fields and values that will be used by the localization-application self-serve A/B system to find the correct EPIC exp parameter to use. */
  experimentConfiguration: Localization_ExperimentConfiguration;
};

/**
 * Request input for creating a Statsig experiment. The BE supplies the rest (Statsig team, ID
 * type, display name, auto-generated hypothesis with the localization-system marker).
 */
export type Localization_CreateStatsigExperimentInput = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** Configuration fields and values used to derive the Statsig layer name. Same fields as `Localization_CreateExperimentConfiguration`, but encoded as the layer name (lowercased, `_`-delimited per Statsig's `[a-z0-9_-]` rule). */
  experimentConfiguration: Localization_ExperimentConfiguration;
  /** Ordered list of variant names. Group sizes auto-balance to 100 / N. Each variant becomes a Statsig group whose `parameterValues.variant` equals the variant name. */
  variants: Array<Scalars['String']>;
};

/** Experiment configuration variables. */
export type Localization_ExperimentConfiguration = {
  /** List of configuration entries. */
  variables: Array<Localization_ExperimentConfigurationInputEntry>;
};

/** Experiment configuration entry. */
export type Localization_ExperimentConfigurationInputEntry = {
  /** configuration field key. */
  key: Scalars['String'];
  /** configuration field value. */
  value: Scalars['String'];
};

/** Read-side lifecycle status of a Statsig experiment, mirroring the Statsig Console API's status vocabulary. Distinct from `Localization_StatsigExperimentStatus`, which lists only the transitions `Localization_UpdateStatsigExperiment` accepts. */
export const Localization_StatsigExperimentLifecycleStatus = {
  /** Stopped without a decision. */
  Abandoned: 'ABANDONED',
  /** Live: traffic is being allocated to the experiment's variants. */
  Active: 'ACTIVE',
  /** Archived in the Statsig console. */
  Archived: 'ARCHIVED',
  /** Group assignment was stopped. */
  AssignmentStopped: 'ASSIGNMENT_STOPPED',
  /** Stopped with a decision recorded. */
  DecisionMade: 'DECISION_MADE',
  /** The experiment was stopped. */
  ExperimentStopped: 'EXPERIMENT_STOPPED',
  /** Created but not yet started; no traffic is being allocated. */
  Setup: 'SETUP',
  /** Fallback for status values Statsig adds that this schema does not know yet. Clients should render these neutrally rather than failing. */
  Unknown: 'UNKNOWN'
} as const;

export type Localization_StatsigExperimentLifecycleStatus = typeof Localization_StatsigExperimentLifecycleStatus[keyof typeof Localization_StatsigExperimentLifecycleStatus];
/** Lifecycle status of a Statsig experiment. */
export const Localization_StatsigExperimentStatus = {
  /** Stopped with a decision recorded. */
  DecisionMade: 'DECISION_MADE',
  /** Live: traffic is being allocated to the experiment's variants. */
  Running: 'RUNNING',
  /** Created but not yet started; no traffic is being allocated. */
  Setup: 'SETUP'
} as const;

export type Localization_StatsigExperimentStatus = typeof Localization_StatsigExperimentStatus[keyof typeof Localization_StatsigExperimentStatus];
/** Request input for updating a Statsig experiment. */
export type Localization_UpdateStatsigExperimentInput = {
  /** Statsig experiment ID to update. */
  experimentId: Scalars['ID'];
  /** Optional status transition. Omit to leave unchanged. */
  status?: InputMaybe<Localization_StatsigExperimentStatus>;
  /** Optional replacement variant list. Omit to leave the existing groups unchanged. When provided, group sizes auto-balance to 100 / N. */
  variants?: InputMaybe<Array<Scalars['String']>>;
};

/** Type of identifier used to identify the learner */
export const LockingBrowser_ExclusionIdentifierType = {
  /** The learner's primary email */
  Email: 'EMAIL',
  /** The external id of a user */
  ExternalId: 'EXTERNAL_ID'
} as const;

export type LockingBrowser_ExclusionIdentifierType = typeof LockingBrowser_ExclusionIdentifierType[keyof typeof LockingBrowser_ExclusionIdentifierType];
/** Operation to apply to the exclusion */
export const LockingBrowser_ExclusionOperation = {
  /** Add the learner to the exclusion list */
  Add: 'ADD',
  /** Remove the learner from the exclusion list */
  Remove: 'REMOVE'
} as const;

export type LockingBrowser_ExclusionOperation = typeof LockingBrowser_ExclusionOperation[keyof typeof LockingBrowser_ExclusionOperation];
/** Exclusion update to apply to an assessment's locking browser requirement */
export type LockingBrowser_ExclusionUpdate = {
  /** The identifier of the learner for whom we're updating the exclusion */
  learnerIdentifier: Scalars['String'];
  /** The type of identifier used to identify the learner */
  learnerIdentifierType: LockingBrowser_ExclusionIdentifierType;
  /** The operation to apply to the exclusion */
  operation: LockingBrowser_ExclusionOperation;
};

/** Session data which will be used to determine if this is a private or public session */
export type LockingBrowser_SessionInput = {
  /** Is this a private or public session? */
  isPrivate: Scalars['Boolean'];
  /** The session for this assessment */
  sessionId: Scalars['ID'];
};

/** Exclusion updates to apply to an assessment's locking browser requirement */
export type LockingBrowser_UpdateExclusionsInput = {
  /** The assessment ID without the version */
  assessmentId: Scalars['ID'];
  /**
   * The course for this session and assessment
   * Optional for backwards compatibility, but required for public sessions
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The updates to be applied to the assessment's exclusions */
  exclusionUpdates: Array<LockingBrowser_ExclusionUpdate>;
  /**
   * The session for this assessment
   * Optional for backwards compatibility
   */
  session?: InputMaybe<LockingBrowser_SessionInput>;
  /**
   * The session for this assessment
   * @deprecated Use session instead
   */
  sessionId?: InputMaybe<Scalars['ID']>;
};

/** Settings to update for the given assessment/session */
export type LockingBrowser_UpdateSettingsInput = {
  /** The assessment ID without the version */
  assessmentId: Scalars['ID'];
  /**
   * The course for this session and assessment
   * Optional for backwards compatibility, but required for public sessions
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Whether or not the Locking browser should be enabled */
  enabled: Scalars['Boolean'];
  /**
   * The session for this assessment
   * Optional for backwards compatibility
   */
  session?: InputMaybe<LockingBrowser_SessionInput>;
  /**
   * The session for this assessment
   * @deprecated Use session instead
   */
  sessionId?: InputMaybe<Scalars['ID']>;
};

/** Upsell relation types */
export const LoggedInHomePageStackability_UpsellRelationType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type LoggedInHomePageStackability_UpsellRelationType = typeof LoggedInHomePageStackability_UpsellRelationType[keyof typeof LoggedInHomePageStackability_UpsellRelationType];
export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = {
  GoToCourse: 'GO_TO_COURSE',
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  NoButton: 'NO_BUTTON',
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  ResetDeadlines: 'RESET_DEADLINES',
  StartCourse: 'START_COURSE',
  SwitchSessions: 'SWITCH_SESSIONS',
  VerifyId: 'VERIFY_ID',
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType];
export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType = {
  Subscribed: 'SUBSCRIBED'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType];
export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType = {
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType];
export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType = {
  ResetDeadlines: 'RESET_DEADLINES',
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType];
export const LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature = typeof LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature];
/** States are mutually exclusive. IN_PROGRESS: last activity in course is > 14d ago COMPLETED: self explanatory. OVERDUE: meets resetDeadline criteria where one deadline on the course is overdue by 14 days or multiple deadlines are overdue. */
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState = {
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS',
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = {
  GoToCourse: 'GO_TO_COURSE',
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  NoButton: 'NO_BUTTON',
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  ResetDeadlines: 'RESET_DEADLINES',
  StartCourse: 'START_COURSE',
  SwitchSessions: 'SWITCH_SESSIONS',
  VerifyId: 'VERIFY_ID',
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType = {
  RateCourse: 'RATE_COURSE',
  ResetDeadlines: 'RESET_DEADLINES',
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType = {
  Project: 'PROJECT',
  RhymeProject: 'RHYME_PROJECT',
  ShortFormContent: 'SHORT_FORM_CONTENT',
  StandardCourse: 'STANDARD_COURSE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState = {
  NoUpsell: 'NO_UPSELL',
  UpsellForCertificate: 'UPSELL_FOR_CERTIFICATE',
  UpsellFromAudit: 'UPSELL_FROM_AUDIT'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage = {
  InactiveUserNotificationMessage: 'INACTIVE_USER_NOTIFICATION_MESSAGE',
  NewUserNotificationMessage: 'NEW_USER_NOTIFICATION_MESSAGE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab = {
  Completed: 'COMPLETED',
  Home: 'HOME',
  InProgress: 'IN_PROGRESS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
/** Reason for the resulting course material next step. */
export const LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = {
  Default: 'DEFAULT',
  ExamFailedTryAgain: 'EXAM_FAILED_TRY_AGAIN',
  ExamFailedTryLater: 'EXAM_FAILED_TRY_LATER',
  ExamOntrack: 'EXAM_ONTRACK',
  ExamOverdue: 'EXAM_OVERDUE',
  ExamVerify: 'EXAM_VERIFY',
  GradedAssignmentFailedTryAgain: 'GRADED_ASSIGNMENT_FAILED_TRY_AGAIN',
  GradedAssignmentFailedTryLater: 'GRADED_ASSIGNMENT_FAILED_TRY_LATER',
  GradedAssignmentOntrack: 'GRADED_ASSIGNMENT_ONTRACK',
  GradedAssignmentOverdue: 'GRADED_ASSIGNMENT_OVERDUE',
  GradedAssignmentVerify: 'GRADED_ASSIGNMENT_VERIFY',
  GradedPeerFailed: 'GRADED_PEER_FAILED',
  GradedPeerOntrack: 'GRADED_PEER_ONTRACK',
  GradedPeerOverdue: 'GRADED_PEER_OVERDUE',
  GradedPeerReviewOntrack: 'GRADED_PEER_REVIEW_ONTRACK',
  GradedPeerReviewOverdue: 'GRADED_PEER_REVIEW_OVERDUE',
  GradedPeerUnsubmittedOntrack: 'GRADED_PEER_UNSUBMITTED_ONTRACK',
  GradedPeerUnsubmittedOverdue: 'GRADED_PEER_UNSUBMITTED_OVERDUE',
  GradedPeerVerify: 'GRADED_PEER_VERIFY',
  PracticeAssignmentOntrack: 'PRACTICE_ASSIGNMENT_ONTRACK',
  PracticeAssignmentOverdue: 'PRACTICE_ASSIGNMENT_OVERDUE',
  QuizOntrack: 'QUIZ_ONTRACK',
  QuizOverdue: 'QUIZ_OVERDUE',
  StudyMaterialOntrack: 'STUDY_MATERIAL_ONTRACK',
  StudyMaterialOverdue: 'STUDY_MATERIAL_OVERDUE',
  TmrFailed: 'TMR_FAILED',
  TmrUnsubmittedOntrack: 'TMR_UNSUBMITTED_ONTRACK',
  TmrUnsubmittedOverdue: 'TMR_UNSUBMITTED_OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
/** An enum for Activity State */
export const LoggedInHome_ActivityState = {
  /** COMPLETED */
  Completed: 'COMPLETED',
  /** IN PROGRESS */
  InProgress: 'IN_PROGRESS',
  /** OVERDUE */
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHome_ActivityState = typeof LoggedInHome_ActivityState[keyof typeof LoggedInHome_ActivityState];
/** An enum for all the possible types of the Course Card button CTA */
export const LoggedInHome_CourseCardButtonCta = {
  /** CTA for Go to Course */
  GoToCourse: 'GO_TO_COURSE',
  /** CTA for Go to Next Item */
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  /** CTA for Go to Next s12n Course */
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  /** No button CTA */
  NoButton: 'NO_BUTTON',
  /** CTA for Purchase Certificate */
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  /** CTA for Reset Deadline */
  ResetDeadlines: 'RESET_DEADLINES',
  /** CTA for Start Course */
  StartCourse: 'START_COURSE',
  /** CTA for Switch Sessions */
  SwitchSessions: 'SWITCH_SESSIONS',
  /** CTA for Verify ID */
  VerifyId: 'VERIFY_ID',
  /** CTA for View Certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHome_CourseCardButtonCta = typeof LoggedInHome_CourseCardButtonCta[keyof typeof LoggedInHome_CourseCardButtonCta];
/** An enum for all the possible types of the Course Card Secondary CTA */
export const LoggedInHome_CourseCardSecondaryCta = {
  /** no CTA */
  NoSecondaryCta: 'NO_SECONDARY_CTA',
  /** CTA for Rate the Course */
  RateCourse: 'RATE_COURSE',
  /** CTA for Reset Deadlines */
  ResetDeadlines: 'RESET_DEADLINES',
  /** CTA for Switch Sessions */
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHome_CourseCardSecondaryCta = typeof LoggedInHome_CourseCardSecondaryCta[keyof typeof LoggedInHome_CourseCardSecondaryCta];
/** An enum for if the course is eligible for upgrade from Freemium. */
export const LoggedInHome_CourseCardUpgradeCta = {
  /** No course upgrade CTA */
  NoCta: 'NO_CTA',
  /** CTA for upgrading the course */
  Upgrade: 'UPGRADE'
} as const;

export type LoggedInHome_CourseCardUpgradeCta = typeof LoggedInHome_CourseCardUpgradeCta[keyof typeof LoggedInHome_CourseCardUpgradeCta];
/** An enum for course Next steps */
export const LoggedInHome_CourseNextStepEnum = {
  /** Course Completed next step */
  CourseCompletedNextStep: 'COURSE_COMPLETED_NEXT_STEP',
  /** Course Material next step */
  CourseMaterialNextStep: 'COURSE_MATERIAL_NEXT_STEP',
  /** course schedule adjustment */
  CourseScheduleAdjustmentNextStep: 'COURSE_SCHEDULE_ADJUSTMENT_NEXT_STEP',
  /** multiple deadlines */
  MultipleDeadlinesNextStep: 'MULTIPLE_DEADLINES_NEXT_STEP',
  /** Not enough peer review */
  NotEnoughPeerReviewsNextStep: 'NOT_ENOUGH_PEER_REVIEWS_NEXT_STEP',
  /** No active session */
  NoActiveSessionNextStep: 'NO_ACTIVE_SESSION_NEXT_STEP',
  /** no available next step */
  NoAvailableNextStep: 'NO_AVAILABLE_NEXT_STEP',
  /** no available next step from error */
  NoAvailableNextStepFromError: 'NO_AVAILABLE_NEXT_STEP_FROM_ERROR',
  /** no enrollable sessions */
  NoEnrollableSessionsNextStep: 'NO_ENROLLABLE_SESSIONS_NEXT_STEP',
  /** Session ended */
  SessionEndedNextStep: 'SESSION_ENDED_NEXT_STEP'
} as const;

export type LoggedInHome_CourseNextStepEnum = typeof LoggedInHome_CourseNextStepEnum[keyof typeof LoggedInHome_CourseNextStepEnum];
/** An enum for the learner's learning progress state towards a course (has learner membership with) */
export const LoggedInHome_CourseProgressStateEnum = {
  /** Completed */
  Completed: 'COMPLETED',
  /** Not Started */
  NotStarted: 'NOT_STARTED',
  /** Started */
  Started: 'STARTED'
} as const;

export type LoggedInHome_CourseProgressStateEnum = typeof LoggedInHome_CourseProgressStateEnum[keyof typeof LoggedInHome_CourseProgressStateEnum];
/** An enum for interest CTA */
export const LoggedInHome_LearnerInterestCta = {
  /** no CTA */
  NoCta: 'NO_CTA',
  /** CTA for learner to click to show that they are no longer interested in a product */
  NoLongerInterested: 'NO_LONGER_INTERESTED'
} as const;

export type LoggedInHome_LearnerInterestCta = typeof LoggedInHome_LearnerInterestCta[keyof typeof LoggedInHome_LearnerInterestCta];
/** An enum for s12n modal buttonCta */
export const LoggedInHome_S12nModalButtonCta = {
  /** no button */
  NoButton: 'NO_BUTTON',
  /** view certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHome_S12nModalButtonCta = typeof LoggedInHome_S12nModalButtonCta[keyof typeof LoggedInHome_S12nModalButtonCta];
/**
 * An enum for the secondary CTA in an mini course card in an s12n modal.
 * This is different from the secondary CTA type in a regular course card that has RATE_COURSE
 */
export const LoggedInHome_S12nModalMiniCourseCardSecondaryCta = {
  /** no CTA */
  NoSecondaryCta: 'NO_SECONDARY_CTA',
  /** RESET DEADLINES */
  ResetDeadlines: 'RESET_DEADLINES',
  /** SWITCH SESSIONS */
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHome_S12nModalMiniCourseCardSecondaryCta = typeof LoggedInHome_S12nModalMiniCourseCardSecondaryCta[keyof typeof LoggedInHome_S12nModalMiniCourseCardSecondaryCta];
/** An enum representing the tabs of the Logged In Home Page (LIHP) */
export const LoggedInHome_Tab = {
  /** The Completed tab of the Logged In Home Page (LIHP) */
  Completed: 'COMPLETED',
  /** The Home tab of the Logged In Home Page (LIHP) */
  Home: 'HOME',
  /** The In-Progress tab of the Logged In Home Page (LIHP) */
  InProgress: 'IN_PROGRESS'
} as const;

export type LoggedInHome_Tab = typeof LoggedInHome_Tab[keyof typeof LoggedInHome_Tab];
/** An enum for upsell state */
export const LoggedInHome_UpsellState = {
  /** no upsell */
  NoUpsell: 'NO_UPSELL',
  /** upsell for certificate */
  UpsellForCertificate: 'UPSELL_FOR_CERTIFICATE',
  /** upsell from audit */
  UpsellFromAudit: 'UPSELL_FROM_AUDIT'
} as const;

export type LoggedInHome_UpsellState = typeof LoggedInHome_UpsellState[keyof typeof LoggedInHome_UpsellState];
/** AI generated practice type */
export const LowStakesLearningTools_AiGeneratedPracticeType = {
  /** Codeblock Select correct Output Multiple Choice Question */
  CodeblockOutputMcq: 'CODEBLOCK_OUTPUT_MCQ',
  /** Code Expression Question */
  CodeExpressionQuestion: 'CODE_EXPRESSION_QUESTION',
  /** Experimental Find the Bug */
  ExperimentalFindTheBug: 'EXPERIMENTAL_FIND_THE_BUG',
  /** Fill in the Blank */
  FillInTheBlank: 'FILL_IN_THE_BLANK',
  /** Flashcard */
  Flashcard: 'FLASHCARD',
  /** Matching Game */
  MatchingGame: 'MATCHING_GAME',
  /** True/False Question */
  TrueFalseQuestion: 'TRUE_FALSE_QUESTION'
} as const;

export type LowStakesLearningTools_AiGeneratedPracticeType = typeof LowStakesLearningTools_AiGeneratedPracticeType[keyof typeof LowStakesLearningTools_AiGeneratedPracticeType];
/** Input for archiving an AI generated practice */
export type LowStakesLearningTools_ArchivePracticeInput = {
  /** The ID of the AI generated practice to archive */
  aiGeneratedPracticeId: Scalars['ID'];
};

/** Filter mode for itemId when querying flashcards */
export const LowStakesLearningTools_ItemIdFilterMode = {
  /** Return only flashcards for the exact specified item */
  Exact: 'EXACT',
  /** Return flashcards up to and including the specified item */
  UpTo: 'UP_TO'
} as const;

export type LowStakesLearningTools_ItemIdFilterMode = typeof LowStakesLearningTools_ItemIdFilterMode[keyof typeof LowStakesLearningTools_ItemIdFilterMode];
/** Item type enumeration for flashcard items */
export const LowStakesLearningTools_ItemType = {
  /** Lecture item type */
  Lecture: 'LECTURE',
  /** Reading item type */
  Reading: 'READING'
} as const;

export type LowStakesLearningTools_ItemType = typeof LowStakesLearningTools_ItemType[keyof typeof LowStakesLearningTools_ItemType];
/** Input for completing flashcards. */
export type LowStakesLearning_CompleteFlashcardsInput = {
  /** Course ID the learner completed the flashcards for. */
  courseId: Scalars['ID'];
};

/** Deprecated. Use LtiPlatform_ValidationErrorStatus instead. */
export const LtiItemAuthoring_ValidationErrorStatus = {
  /** BAD_REFERENCE validation status. */
  BadReference: 'BAD_REFERENCE',
  /** DUPLICATE validation status. */
  Duplicate: 'DUPLICATE',
  /** EMPTY validation status. */
  Empty: 'EMPTY',
  /** ENUM validation status. */
  Enum: 'ENUM',
  /** FORMAT validation status. */
  Format: 'FORMAT',
  /** LOCKED validation status. */
  Locked: 'LOCKED',
  /** NON_EMPTY validation status. */
  NonEmpty: 'NON_EMPTY',
  /** OTHER validation status. */
  Other: 'OTHER',
  /** OVERLAP validation status. */
  Overlap: 'OVERLAP',
  /** TOO_LARGE validation status. */
  TooLarge: 'TOO_LARGE',
  /** TOO_LONG validation status. */
  TooLong: 'TOO_LONG',
  /** TOO_SHORT validation status. */
  TooShort: 'TOO_SHORT',
  /** TOO_SMALL validation status. */
  TooSmall: 'TOO_SMALL'
} as const;

export type LtiItemAuthoring_ValidationErrorStatus = typeof LtiItemAuthoring_ValidationErrorStatus[keyof typeof LtiItemAuthoring_ValidationErrorStatus];
/** App availability scope configured for the External App Deployment */
export const LtiPlatform_AppAvailabilityScope = {
  /**
   * Identifies if the External App Deployment will be available in All Sessions under the
   * partner/course scope. This includes Private sessions, Public sessions (and Org only sessions for Enterprise partners)
   */
  AllSessions: 'ALL_SESSIONS',
  /** Identifies if the External App Deployment should be made available specifically in Guided Projects */
  GuidedProjects: 'GUIDED_PROJECTS',
  /**
   * Identifies if the External App Deployment will be available in Private Sessions under the
   * partner/course scope
   */
  PrivateSessions: 'PRIVATE_SESSIONS'
} as const;

export type LtiPlatform_AppAvailabilityScope = typeof LtiPlatform_AppAvailabilityScope[keyof typeof LtiPlatform_AppAvailabilityScope];
/** Input Object for creating a new External App Registration V13 for a Curated App */
export type LtiPlatform_CreateCuratedAppExternalAppRegistrationV13Input = {
  /** OIDC Authorization Request URL configured for the External App */
  authRequestUrl: Scalars['String'];
  /** Curated App Key */
  curatedAppKey: LtiPlatform_CuratedAppKey;
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Redirect URLs configured for the External App */
  redirectUrls: Array<Scalars['String']>;
  /** Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** Create External app Deployment for a Partner Input object for Curated apps */
export type LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerInput = {
  /** Input Object for creating a new LTI v1.1 and LTI v1.3 Deployment for Curated App */
  curatedExternalAppDeploymentInput?: InputMaybe<LtiPlatform_CuratedExternalAppDeploymentInput>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Create External app Deployment Input for a course object for LTI 1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForCourseInput = {
  /** Course identifier */
  courseId: Scalars['ID'];
  /** Input Object for creating a new LTI v1.1 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV11Input;
};

/** Create External app Deployment for a Partner Input object for LTI v1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForPartnerInput = {
  /** Input Object for creating a new LTI v1.1 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV11Input;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Create External app Deployment Input for a course object for LTI 1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for creating a new LTI v1.3 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV13Input;
};

/** Create External app Deployment Input for a Partner object for LTI 1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForPartnerInput = {
  /** Input Object for creating a new LTI v1.3 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV13Input;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Curated App List */
export const LtiPlatform_CuratedAppKey = {
  /** Gradescope LTI tool */
  Gradescope: 'GRADESCOPE',
  /** Honorlock LTI tool */
  Honorlock: 'HONORLOCK',
  /** Turnitin LTI tool */
  Turnitin: 'TURNITIN'
} as const;

export type LtiPlatform_CuratedAppKey = typeof LtiPlatform_CuratedAppKey[keyof typeof LtiPlatform_CuratedAppKey];
/** Create External app Deployment Input object for Curated apps */
export type LtiPlatform_CuratedExternalAppDeploymentInput = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Curated External App identifier */
  curatedAppKey: LtiPlatform_CuratedAppKey;
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/** Custom type for Key-value pair */
export type LtiPlatform_CustomParamInput = {
  /** Custom Param Key */
  key: Scalars['String'];
  /** Custom Param Value */
  value?: InputMaybe<Scalars['String']>;
};

/** Lti draft content, represented as an input type */
export type LtiPlatform_DraftContentInput = {
  /** Custom parameter map for this LTI item. */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Learner-facing LTI item description in CML format. */
  description: CmlContentInput;
  /**
   * External app reference. Used for LTI V2 items.
   * This field MUST be populated for LTI v2 items, otherwise the lti will revert to lti v1. If there is no linked external app, the follow default value should be used.
   * https://github.com/webedx-spark/web/blob/387c64c9bac086b6131b4273b38d7efde4aed84f/static/bundles/item-authoring/lti/utils/convertLtiDraftContentToMutationInput.ts#L12
   */
  externalAppReference?: InputMaybe<LtiPlatform_LtiExternalAppReferenceInput>;
  /**
   * Deprecated. Use launchUrlString instead.
   * @deprecated Use launchUrlString instead.
   */
  launchUrl?: InputMaybe<Scalars['URL']>;
  /**
   * Endpoint for a non-external-app LTI tool to display, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this URL can be used as an override.
   *
   * Note: In case of LTI v1.1, this field is called "Launch URL", and in case of LTI v1.3 it's called
   * "Target Link URI".
   */
  launchUrlString?: InputMaybe<Scalars['String']>;
  /**
   * Privacy level for a non-external-app LTI tool, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this privacy level can be used as an override.
   */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
  /** User authored name of the LTI item. */
  name: Scalars['String'];
  /**
   * A passing threshold between 0 and 1; eg. 0.8 means 80% passing threshold.
   *
   * Note: Internal models have three values that interact: `ltiType` (`ungraded` or `graded`),
   * `hasGradeCallback` (boolean), and `passingFraction` which only exists if `hasGradeCallback` is
   * set to `true`. Additionally, a callback can be missing only if the `ltiType` is `ungraded`. In
   * this schema, these three fields are collapsed into just the `passingFraction` in external models
   * in the following way:
   * a) If `passingFraction` is missing or zero: LTI is ungraded and the callback isn't present
   * b) If `passingFraction` is >0: LTI is graded and the callback is present.
   */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** How long a given item is expected to take to complete. */
  timeCommitment: Scalars['Duration'];
  /**
   * Determines the LTI protocol version of LTI items not referencing an external app: v1.1 or v1.3.
   * If an external app is referenced, this field should be ignored.
   *
   * This field is introduced because we don't want to "forget" version configuration parameters of
   * the version which currently isn't configured for the item. E.g. if version v1.1 is selected and
   * the authoring user switches to version v1.3, we want to keep all v1.1 configuration parameters in
   * case the user made the edit by mistake and wants to revert it.
   */
  version: LtiPlatform_Version;
  /**
   * LTI protocol version v1.1 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_1?: InputMaybe<LtiPlatform_LtiVersionConfigV11Input>;
  /**
   * LTI protocol version v1.3 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_3?: InputMaybe<LtiPlatform_LtiVersionConfigV13Input>;
};

/** Create External app Deployment Input object for LTI v1.1 */
export type LtiPlatform_ExternalAppDeploymentV11Input = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** External App Registration configured for the deployment */
  externalAppRegistration: LtiPlatform_ExternalAppRegistrationV11Input;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/** Create External app Deployment Input object for LTI 1.3 */
export type LtiPlatform_ExternalAppDeploymentV13Input = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** External App Registration configured for the deployment */
  externalAppRegistration: LtiPlatform_ExternalAppRegistrationV13Input;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/** Create External app Registration Input object for LTI v1.1 */
export type LtiPlatform_ExternalAppRegistrationV11Input = {
  /** External App client secret from the external app configuration */
  clientSecret: Scalars['String'];
  /** External App consumer Key from the external app configuration */
  consumerKey: Scalars['String'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
};

/** Create External app Registration Input object for LTI v1.3 */
export type LtiPlatform_ExternalAppRegistrationV13Input = {
  /** OIDC Authorization Request URL configured for the External App */
  authRequestUrl: Scalars['String'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Redirect URLs configured for the External App */
  redirectUrls: Array<Scalars['String']>;
  /** Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** Whether the latest or the highest submitted grade should be kept for this LTI item. */
export const LtiPlatform_GradePreference = {
  /**
   * When the score is submitted, keep the highest score submitted thus far, even if more submissions
   * has been made since.
   */
  Highest: 'HIGHEST',
  /** When the score is submitted, keep the latest score submitted. */
  Latest: 'LATEST'
} as const;

export type LtiPlatform_GradePreference = typeof LtiPlatform_GradePreference[keyof typeof LtiPlatform_GradePreference];
/** Identifies whether JSON Web Key Sets is fetched from Jwks URL or an RSA_KEY */
export const LtiPlatform_JwksKeyType = {
  /** Identifies if the LTI v1.3 registration uses a KeySet URL for authentication */
  KeysetUrl: 'KEYSET_URL',
  /** Identifies if the LTI v1.3 registration uses an RSA key for authentication */
  RsaKey: 'RSA_KEY'
} as const;

export type LtiPlatform_JwksKeyType = typeof LtiPlatform_JwksKeyType[keyof typeof LtiPlatform_JwksKeyType];
/**
 * Learner Privacy configured for the LTI item; it's also used in External Apps here:
 * coursera/graphql/ltiplatform/schema/common.graphqls - it's defined here to avoid dragging in an LTI
 * specific dependency into the shared service definition.
 */
export const LtiPlatform_LearnerPrivacy = {
  /** Anonymous Learner Privacy scope; don't share any information when the launch is made */
  Nothing: 'NOTHING',
  /** Learner Privacy scope allowing for the opaque Learner Id to be shared */
  ShareLearnerId: 'SHARE_LEARNER_ID',
  /** Learner Privacy scope allowing for Learner Id and Learner Full name to be shared */
  ShareLearnerIdFullName: 'SHARE_LEARNER_ID_FULL_NAME',
  /**
   * Learner Privacy scope allowing for Learner Id, Learner Full name and Learner Email address to be
   * shared
   */
  ShareLearnerIdFullNameEmailAddress: 'SHARE_LEARNER_ID_FULL_NAME_EMAIL_ADDRESS'
} as const;

export type LtiPlatform_LearnerPrivacy = typeof LtiPlatform_LearnerPrivacy[keyof typeof LtiPlatform_LearnerPrivacy];
/** Integration level for the External App */
export const LtiPlatform_LtiDeploymentScope = {
  /** Identifies if External App is deployed at Course scope */
  Course: 'COURSE',
  /** Identifies if External App is deployed at Partner scope */
  Partner: 'PARTNER'
} as const;

export type LtiPlatform_LtiDeploymentScope = typeof LtiPlatform_LtiDeploymentScope[keyof typeof LtiPlatform_LtiDeploymentScope];
/** LTI external app deployment input. */
export type LtiPlatform_LtiExternalAppDeploymentInput = {
  /** Deployment id. */
  id: Scalars['ID'];
  /** Revision used to determine if a deployment has been changed. */
  revision: Scalars['Int'];
};

/**
 * LTI external app reference.
 * Fields specific to LTI items which use registered external apps.
 */
export type LtiPlatform_LtiExternalAppReferenceInput = {
  /** Deployment input. Used only for v1.3 items, since there is no separate deployment step for v1.1 items. */
  deployment?: InputMaybe<LtiPlatform_LtiExternalAppDeploymentInput>;
  /** Registration input. */
  registration: LtiPlatform_LtiExternalAppRegistrationInput;
};

/** LTI external app registration input. */
export type LtiPlatform_LtiExternalAppRegistrationInput = {
  /** Registration id. */
  id: Scalars['ID'];
  /** Registration revision used to determine if a registration has been changed. */
  revision: Scalars['Int'];
};

/**
 * LTI protocol version v1.1 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable.
 */
export type LtiPlatform_LtiVersionConfigV11Input = {
  /** Client secret from the external app configuration */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Consumer Key from the external app configuration */
  consumerKey?: InputMaybe<Scalars['String']>;
};

/**
 * LTI protocol version v1.3 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable.
 */
export type LtiPlatform_LtiVersionConfigV13Input = {
  /**
   * Deprecated. Use authRequestUrlString instead.
   * @deprecated Use authRequestUrlString instead.
   */
  authRequestUrl?: InputMaybe<Scalars['URL']>;
  /** OIDC Authorization Request URL configured for the LTI item. */
  authRequestUrlString?: InputMaybe<Scalars['String']>;
  /** Whether the latest or the highest submitted grade should be kept for this LTI item. */
  gradePreference?: InputMaybe<LtiPlatform_GradePreference>;
  /** Redirect URLs configured for the LTI item. */
  redirectUrlStrings?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Deprecated. Use redirectUrlStrings instead.
   * @deprecated Use redirectUrlStrings instead.
   */
  redirectUrls?: InputMaybe<Array<Scalars['URL']>>;
  /**
   * Key in PEM-format that will be used to interact with the platform services and send messages back
   * to the platform.
   */
  toolPublicKey?: InputMaybe<Scalars['String']>;
};

/** Wrapper object for Update input for deployment availability scope */
export type LtiPlatform_SetExternalAppAppAvailabilityScope = {
  /** Update input for deployment availability scope */
  appAvailabilityScope: LtiPlatform_AppAvailabilityScope;
};

/** Wrapper object for Update input for External app Registration Auth request url */
export type LtiPlatform_SetExternalAppAuthRequestUrl = {
  /** Update input for External app Registration OIDC Auth request url */
  authRequestUrl: Scalars['String'];
};

/** Wrapper object for Update input for Client Secret */
export type LtiPlatform_SetExternalAppClientSecret = {
  /** Update input for Client Secret */
  clientSecret: Scalars['String'];
};

/** Wrapper object for Update input for Consumer Key */
export type LtiPlatform_SetExternalAppConsumerKey = {
  /** Update input for Consumer Key */
  consumerKey: Scalars['String'];
};

/** Wrapper object for Update input for deployment custom parameters */
export type LtiPlatform_SetExternalAppCustomParams = {
  /** Update input for deployment custom parameters */
  customParams: Array<InputMaybe<LtiPlatform_CustomParamInput>>;
};

/** Wrapper object for Update input for External app Registration launch url */
export type LtiPlatform_SetExternalAppLaunchUrl = {
  /** Update input for External app Registration launch url */
  launchUrl: Scalars['String'];
};

/** Wrapper object for Update input for Learner Privacy */
export type LtiPlatform_SetExternalAppLearnerPrivacy = {
  /** Update input for Learner Privacy */
  learnerPrivacy: LtiPlatform_LearnerPrivacy;
};

/** Wrapper object for Update input for app name */
export type LtiPlatform_SetExternalAppName = {
  /** Update input for app name */
  appName: Scalars['String'];
};

/** Wrapper object for Update input for External app Registration redirect url */
export type LtiPlatform_SetExternalAppRedirectUrls = {
  /** Update input for External app Registration redirect url */
  redirectUrl: Array<Scalars['String']>;
};

/** Wrapper object for Update input for External app Registration Id for External App deployment */
export type LtiPlatform_SetExternalAppRegistrationId = {
  /** Update input for External app Registration Id for External App deployment */
  registrationId: Scalars['ID'];
};

/** Wrapper object for Update input for External app Registration JWKS Key type */
export type LtiPlatform_SetExternalAppToolKeySet = {
  /** Update input Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** External App Key set with Jwks/Public key type and value */
export type LtiPlatform_ToolKeySetInput = {
  /** Keyset key type configured for the External App */
  keyType: LtiPlatform_JwksKeyType;
  /** Key value configured for the External App */
  keyValue: Scalars['String'];
};

/** Update External app Deployment for a Course Input object */
export type LtiPlatform_UpdateExternalAppDeploymentForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for update a new LTI Deployment for External App */
  externalAppDeploymentInput: LtiPlatform_UpdateExternalAppDeploymentInput;
};

/** Update External app Deployment for a Partner Input object */
export type LtiPlatform_UpdateExternalAppDeploymentForPartnerInput = {
  /** Input Object for update a new LTI Deployment for External App (Curated or Custom) */
  externalAppDeploymentInput: LtiPlatform_UpdateExternalAppDeploymentInput;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Update External app Deployment for a Partner Input object */
export type LtiPlatform_UpdateExternalAppDeploymentInput = {
  /** External app Deployment Input object identifier */
  id: Scalars['ID'];
  /** External app Deployment Input Availability scope */
  setAppAvailabilityScope?: InputMaybe<LtiPlatform_SetExternalAppAppAvailabilityScope>;
  /** External app Deployment Input App name */
  setAppName?: InputMaybe<LtiPlatform_SetExternalAppName>;
  /** External app Deployment Input Custom Parameters */
  setCustomParams?: InputMaybe<LtiPlatform_SetExternalAppCustomParams>;
  /** External app Deployment Input Learner Privacy */
  setLearnerPrivacy?: InputMaybe<LtiPlatform_SetExternalAppLearnerPrivacy>;
  /** External app Deployment Input Registration id for the referred registration object */
  setRegistrationId?: InputMaybe<LtiPlatform_SetExternalAppRegistrationId>;
};

/** Update External app Registration for a Partner Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForCourseInput = {
  /** Course identifier */
  courseId: Scalars['ID'];
  /** Input Object for updating a LTI v1.1 Registration for App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV11Input>;
};

/** Update External app Registration for a Partner Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerInput = {
  /** Input Object for updating a LTI v1.1 Registration for Custom App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV11Input>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Update External app Registration Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11Input = {
  /** External app Registration Input object identifier */
  id: Scalars['ID'];
  /** External app Registration Input client secret */
  setClientSecret?: InputMaybe<LtiPlatform_SetExternalAppClientSecret>;
  /** External app Registration Input consumer key */
  setConsumerKey?: InputMaybe<LtiPlatform_SetExternalAppConsumerKey>;
  /** External app Registration Input launch Url */
  setLaunchUrl?: InputMaybe<LtiPlatform_SetExternalAppLaunchUrl>;
};

/** Update External app Registration for a Course Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for updating a LTI v1.3 Registration for   App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV13Input>;
};

/** Update External app Registration for a Partner Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerInput = {
  /** Input Object for updating a LTI v1.3 Registration for Curated App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV13Input>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Update External app Registration Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13Input = {
  /** External app Registration Input object identifier */
  id: Scalars['ID'];
  /** External app Registration Input OIDC Auth request Url */
  setAuthRequestUrl?: InputMaybe<LtiPlatform_SetExternalAppAuthRequestUrl>;
  /** External app Registration Input launch Url */
  setLaunchUrl?: InputMaybe<LtiPlatform_SetExternalAppLaunchUrl>;
  /** External app Registration Input Redirect Urls */
  setRedirectUrls?: InputMaybe<LtiPlatform_SetExternalAppRedirectUrls>;
  /** External app Registration Input Key set with Jwks/Public key type and value */
  setToolKeySet?: InputMaybe<LtiPlatform_SetExternalAppToolKeySet>;
};

/** Input for the LtiPlatform_UpdateLtiDraft mutation. */
export type LtiPlatform_UpdateLtiDraftInput = {
  /** Id of the underlying LTI atom to update. */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made. */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: LtiPlatform_DraftContentInput;
};

/** All possible validation statuses. */
export const LtiPlatform_ValidationErrorStatus = {
  /** BAD_REFERENCE validation status. */
  BadReference: 'BAD_REFERENCE',
  /** DUPLICATE validation status. */
  Duplicate: 'DUPLICATE',
  /** EMPTY validation status. */
  Empty: 'EMPTY',
  /** ENUM validation status. */
  Enum: 'ENUM',
  /** FORMAT validation status. */
  Format: 'FORMAT',
  /** LOCKED validation status. */
  Locked: 'LOCKED',
  /** NON_EMPTY validation status. */
  NonEmpty: 'NON_EMPTY',
  /** OTHER validation status. */
  Other: 'OTHER',
  /** OVERLAP validation status. */
  Overlap: 'OVERLAP',
  /** TOO_LARGE validation status. */
  TooLarge: 'TOO_LARGE',
  /** TOO_LONG validation status. */
  TooLong: 'TOO_LONG',
  /** TOO_SHORT validation status. */
  TooShort: 'TOO_SHORT',
  /** TOO_SMALL validation status. */
  TooSmall: 'TOO_SMALL'
} as const;

export type LtiPlatform_ValidationErrorStatus = typeof LtiPlatform_ValidationErrorStatus[keyof typeof LtiPlatform_ValidationErrorStatus];
/** Determines the LTI protocol version of LTI items not referencing an external app: v1.1 or v1.3. */
export const LtiPlatform_Version = {
  /** This LTI item uses the LTI protocol version 1.1 */
  V1_1: 'V1_1',
  /** This LTI item uses the LTI protocol version 1.3 */
  V1_3: 'V1_3'
} as const;

export type LtiPlatform_Version = typeof LtiPlatform_Version[keyof typeof LtiPlatform_Version];
/** Input type for adding a new LTI platform configuration. */
export type LtiTool_AddPlatformConfigInput = {
  /** Authorization endpoint URL */
  authEndpoint: Scalars['URL'];
  /** Client ID */
  clientId: Scalars['ID'];
  /** Deployment ID */
  deploymentId: Scalars['ID'];
  /** Environment (e.g., "production", "test") */
  environment: LtiTool_Environment;
  /** Issuer URL */
  issuer: Scalars['URL'];
  /** JWKS URL */
  jwksUrl: Scalars['URL'];
  /** LMS type selected from the dropdown */
  lmsName?: InputMaybe<LtiTool_LmsName>;
  /** Name of the platform */
  name: Scalars['String'];
  /** organization ID */
  organizationId: Scalars['ID'];
  /** Custom LMS name when lmsName is OTHERS */
  otherLmsName?: InputMaybe<Scalars['String']>;
  /** Token endpoint URL. Optional for LCMS-only registrations (e.g. Talentsoft LCMS). */
  tokenEndpoint?: InputMaybe<Scalars['URL']>;
};

/** Input type for adding or updating LTI tool metadata. */
export type LtiTool_AddToolMetadataInput = {
  /** Deep linking URL of the tool */
  deepLinkingUrl: Scalars['URL'];
  /** The initiate login url of the tool */
  initiateLoginUrl: Scalars['URL'];
  /** The URL to the tool's JWKS endpoint */
  jwksUrl: Scalars['URL'];
  /** The launch url of the tool */
  launchUrl: Scalars['URL'];
  /** Redirect URL of the tool */
  redirectUrls: Array<Scalars['URL']>;
};

/**
 * Input for fetching the full org program catalog for the admin Program Access
 * Control selection dialog.
 */
export type LtiTool_AdminProgramsInput = {
  /** Third party organization ID */
  organizationId: Scalars['ID'];
};

/** Input type for backfilling LMS names in platform configurations. */
export type LtiTool_BackfillLmsNamesInput = {
  /** Default LMS name for issuers not in the mapping. Defaults to "OTHERS" if not provided. */
  defaultLmsName?: InputMaybe<Scalars['String']>;
  /** If true, only returns what would be updated without persisting changes */
  dryRun: Scalars['Boolean'];
  /** List of issuer URL to LMS name mappings */
  issuerToLmsNameMappings: Array<LtiTool_IssuerLmsNameMapping>;
};

/** Status of a backfill operation */
export const LtiTool_BackfillStatus = {
  /** Failed to update */
  Failed: 'FAILED',
  /** Skipped because value already matches or issuer is null */
  Skipped: 'SKIPPED',
  /** Successfully updated (or would be updated in dry-run) */
  Updated: 'UPDATED'
} as const;

export type LtiTool_BackfillStatus = typeof LtiTool_BackfillStatus[keyof typeof LtiTool_BackfillStatus];
/**
 * Whether (and how) the picker should surface the "Coursera Activity Tracker" Banner CTA
 * for an LMS course shell. See LtiTool_DeepLinkingInstructorContext.courseActivityTrackerState.
 */
export const LtiTool_CourseActivityTrackerState = {
  /** Non-Tracker content exists and no Tracker is placed yet; offer creation. */
  Creatable: 'CREATABLE',
  /** No prior non-Tracker content placed in the shell; the Tracker CTA is hidden. */
  None: 'NONE',
  /** A Tracker already exists in the shell; offer re-creation. */
  Recreatable: 'RECREATABLE'
} as const;

export type LtiTool_CourseActivityTrackerState = typeof LtiTool_CourseActivityTrackerState[keyof typeof LtiTool_CourseActivityTrackerState];
/** Grading Preference for the content enum */
export const LtiTool_DeepLinkingContentGradingType = {
  /** Grade will be final for single/multi assignment projects */
  Final: 'FINAL',
  /** Grade will be assigned on individual item level */
  ItemLevel: 'ITEM_LEVEL'
} as const;

export type LtiTool_DeepLinkingContentGradingType = typeof LtiTool_DeepLinkingContentGradingType[keyof typeof LtiTool_DeepLinkingContentGradingType];
/** Content item to be linked in the LMS */
export type LtiTool_DeepLinkingContentItemInput = {
  /**
   * Coursera course ID. Required for content-bound link types (COURSE, MODULE, ITEM, VIDEO).
   * Null for COURSE_ACTIVITY (single-placement hub link with no course binding).
   * Enforced at the manager layer per link type.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Description of the content item */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the content item is gradable */
  gradable: Scalars['Boolean'];
  /** Optional due date for grade sync (UTC). Grade sync stops after this date. */
  gradeSyncDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Grading Preference for the content */
  gradingPreference?: InputMaybe<LtiTool_DeepLinkingContentGradingType>;
  /** Optional specific item ID within the course */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Deep linking type */
  linkType: LtiTool_DeepLinkingContentItemLinkType;
  /** Maximum score for gradable items */
  maxScore?: InputMaybe<Scalars['Float']>;
  /** Module ID within the course for Module level linking */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Module index within the course for Module level linking */
  moduleIndex?: InputMaybe<Scalars['Int']>;
  /**
   * Coursera program ID. Required for content-bound link types (COURSE, MODULE, ITEM, VIDEO).
   * Null for COURSE_ACTIVITY (single-placement hub link with no program binding).
   * Enforced at the manager layer per link type.
   */
  programId?: InputMaybe<Scalars['ID']>;
  /** Coursera specialization/professional_certificate Id */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** Title of the content item */
  title: Scalars['String'];
};

/** Deep linking content item link types */
export const LtiTool_DeepLinkingContentItemLinkType = {
  /** Coursera Course level linking */
  Course: 'COURSE',
  /**
   * Single-placement Coursera Activity Tracker link for cert / progress / due-date hub.
   * Carries no programId or courseId in the deep-linking content item input.
   */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Coursera guided project linking */
  GuidedProject: 'GUIDED_PROJECT',
  /** Coursera Item level linking */
  Item: 'ITEM',
  /** Coursera Module level linking */
  Module: 'MODULE',
  /** Coursera professional certificate level linking */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Coursera standalone project linking */
  Project: 'PROJECT',
  /** Coursera specialization level linking */
  Specialization: 'SPECIALIZATION',
  /** Coursera Video level linking */
  Video: 'VIDEO'
} as const;

export type LtiTool_DeepLinkingContentItemLinkType = typeof LtiTool_DeepLinkingContentItemLinkType[keyof typeof LtiTool_DeepLinkingContentItemLinkType];
/** Input for submitting deep linking content items */
export type LtiTool_DeepLinkingSubmitInput = {
  /** List of content items to be linked */
  items: Array<LtiTool_DeepLinkingContentItemInput>;
};

/**
 * Input for soft-deleting a deep-linked course shell item.
 *
 * sessionId targets the DeepLinkLaunch row directly (hash-key lookup —
 * no contextId GSI scan). The matching entry inside itemsSelected is located
 * by (courseId, moduleId, itemId).
 */
export type LtiTool_DeleteCourseShellItemInput = {
  /**
   * LMS context ID (course shell identifier). Must match the contextId bound to the
   * LTI_LOGIN_SESSION cookie; mismatch fails with CONTEXT_MISMATCH.
   */
  contextId: Scalars['ID'];
  /** Coursera course ID for the linked content. */
  courseId: Scalars['ID'];
  /** Optional item ID for item-level deep links. */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Optional module ID for module-level deep links. */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** DeepLinkLaunch sessionId (DynamoDB hash key). */
  sessionId: Scalars['ID'];
};

/** Input type for deleting an LTI platform configuration. */
export type LtiTool_DeletePlatformConfigInput = {
  /** The platform configuration ID to delete */
  id: Scalars['ID'];
  /** The third party organization ID */
  organizationId: Scalars['ID'];
};

/** Environment types for the platform configuration */
export const LtiTool_Environment = {
  /** For prod configurations */
  Production: 'PRODUCTION',
  /** For test configurations */
  Test: 'TEST'
} as const;

export type LtiTool_Environment = typeof LtiTool_Environment[keyof typeof LtiTool_Environment];
/** input for dynamicRegistrationUrl */
export type LtiTool_GenerateDynamicRegistrationUrlInput = {
  /** name of LMS to register */
  lmsName: LtiTool_LmsName;
  /** LTI tool shown on the LMS */
  ltiIdentifier: Scalars['String'];
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /** Name of the platform */
  platformName: Scalars['String'];
};

/** Input for grade sync settings */
export type LtiTool_GradeSyncSettingsInput = {
  /**
   * Whether grade sync is enabled for learners who access
   * Coursera without launching from the LMS (without LTI authentication).
   * When enabled and NRPS (roster sync) is set up, grades sync
   * for all learners in the class regardless of how they access Coursera.
   */
  gradeSyncWithoutLtiAuth?: InputMaybe<Scalars['Boolean']>;
  /**
   * Number of days for the look-back period (0-120).
   * Enables syncing of grades earned within the past N days.
   * Set to 0 to disable syncing of past grades.
   * Maximum allowed value is 120.
   */
  lookbackPeriodDays?: InputMaybe<Scalars['Int']>;
};

/**
 * Role classification for an LMS-native hub launch. Computed at LtiLoginSession
 * creation time by matching the LTI launch token's roles claim against the
 * instructor-role allowlist.
 */
export const LtiTool_HubRole = {
  /** Launching user has an instructor-equivalent role in the LMS course. */
  Instructor: 'INSTRUCTOR',
  /** Launching user is a learner in the LMS course (default when not instructor). */
  Learner: 'LEARNER'
} as const;

export type LtiTool_HubRole = typeof LtiTool_HubRole[keyof typeof LtiTool_HubRole];
/** Mapping of issuer URL to LMS name */
export type LtiTool_IssuerLmsNameMapping = {
  /** The issuer URL to match */
  issuer: Scalars['URL'];
  /** The LMS name to assign */
  lmsName: Scalars['String'];
};

/**
 * Filter and search options for the learner progress table. No sort option —
 * results are returned in learner-name order (the read index's natural order);
 * v1 has no user-selectable sort.
 */
export type LtiTool_LearnerProgressFilterInput = {
  /**
   * Case-insensitive prefix match against learner name. Empty / null means no
   * search filter.
   */
  nameSearch?: InputMaybe<Scalars['String']>;
  /**
   * Restrict results to learners with one of these statuses. Empty / null means
   * all statuses.
   */
  statuses?: InputMaybe<Array<LtiTool_LearnerProgressStatus>>;
};

/**
 * 3-state monotonic learner-progress status. Status cannot regress
 * (NOT_STARTED → IN_PROGRESS → COMPLETED).
 */
export const LtiTool_LearnerProgressStatus = {
  /** Content completed. */
  Completed: 'COMPLETED',
  /** Activity recorded but the content is not yet completed. */
  InProgress: 'IN_PROGRESS',
  /** No activity recorded for this content yet. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LtiTool_LearnerProgressStatus = typeof LtiTool_LearnerProgressStatus[keyof typeof LtiTool_LearnerProgressStatus];
/** Learning Management System (LMS) names for platform configuration */
export const LtiTool_LmsName = {
  /** Blackboard LMS */
  Blackboard: 'BLACKBOARD',
  /** Canvas LMS */
  Canvas: 'CANVAS',
  /** D2L Brightspace LMS */
  D2L: 'D2L',
  /** Google Classroom */
  GoogleClassroom: 'GOOGLE_CLASSROOM',
  /** Moodle LMS */
  Moodle: 'MOODLE',
  /** Other LMS platforms not listed */
  Others: 'OTHERS',
  /** Cegid Talentsoft (both LMS delivery and LCMS deep-link authoring registrations) */
  Talentsoft: 'TALENTSOFT'
} as const;

export type LtiTool_LmsName = typeof LtiTool_LmsName[keyof typeof LtiTool_LmsName];
/** Difficulty levels for products */
export const LtiTool_ProductDifficultyLevel = {
  /** Advanced level */
  Advanced: 'ADVANCED',
  /** Beginner level */
  Beginner: 'BEGINNER',
  /** Intermediate level */
  Intermediate: 'INTERMEDIATE',
  /** Mixed level */
  Mixed: 'MIXED'
} as const;

export type LtiTool_ProductDifficultyLevel = typeof LtiTool_ProductDifficultyLevel[keyof typeof LtiTool_ProductDifficultyLevel];
/** Types of products in a program */
export const LtiTool_ProductType = {
  /** Product is a course */
  Course: 'COURSE',
  /** Product is a guided project */
  GuidedProject: 'GUIDED_PROJECT',
  /** For other product types not listed */
  Other: 'OTHER',
  /** Product is a professional certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Product is a project */
  Project: 'PROJECT',
  /** Product is a specialization */
  Specialization: 'SPECIALIZATION',
  /** Product is a video */
  Video: 'VIDEO'
} as const;

export type LtiTool_ProductType = typeof LtiTool_ProductType[keyof typeof LtiTool_ProductType];
/**
 * Input for updating program access control settings.
 * When enabling, selectedProgramIds must contain at least one active program.
 */
export type LtiTool_ProgramAccessControlInput = {
  /** Whether to enable program access control. */
  enabled: Scalars['Boolean'];
  /**
   * IDs of programs to make visible in LTI deep linking.
   * Required and must be non-empty when enabled is true.
   * Ignored when enabled is false (existing selection preserved in storage).
   */
  selectedProgramIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** How the platform registration was created */
export const LtiTool_RegistrationSource = {
  /** Automatic via LTI Dynamic Registration */
  Dynamic: 'DYNAMIC',
  /** Manual configuration by admin */
  Static: 'STATIC'
} as const;

export type LtiTool_RegistrationSource = typeof LtiTool_RegistrationSource[keyof typeof LtiTool_RegistrationSource];
/** Input type for searching product */
export type LtiTool_SearchProductInput = {
  /**
   * Optional list of product type to apply. Valid values: COURSE, PROJECT, GUIDED_PROJECT,
   * SHORT_FORM_CONTENT_VIDEO, PROFESSIONAL_CERTIFICATE, SPECIALIZATION, VIDEO, OTHER.
   * If not provided, default productTypes (COURSE, SHORT_FORM_CONTENT_VIDEO, PROJECT, GUIDED_PROJECT) will be used.
   */
  productTypes?: InputMaybe<Array<Scalars['String']>>;
  /** Optional program IDs to search within */
  programIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Text query to search for */
  query?: InputMaybe<Scalars['String']>;
};

/** Input for updating the grade-sync due date of a deep-linked course shell item. */
export type LtiTool_UpdateCourseShellDueDateInput = {
  /**
   * LMS context ID (course shell identifier). Must match the contextId bound to the
   * LTI_LOGIN_SESSION cookie; mismatch fails with CONTEXT_MISMATCH.
   */
  contextId: Scalars['ID'];
  /** Coursera course ID for the linked content */
  courseId: Scalars['ID'];
  /**
   * New grade-sync due date (UTC). Null clears the existing due date.
   * Past dates are rejected.
   */
  gradeSyncDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional item ID for item-level deep links */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Optional module ID for module-level deep links */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/** Input for updating organization configuration */
export type LtiTool_UpdateOrgConfigInput = {
  /** Updated grade sync settings for an org */
  gradeSyncSettings?: InputMaybe<LtiTool_GradeSyncSettingsInput>;
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /** Program access control settings. When provided, updates the program visibility controls. */
  programAccessControl?: InputMaybe<LtiTool_ProgramAccessControlInput>;
};

/** Status of the grading of the submission */
export const Manual_Grading_Status = {
  /** Grading finished */
  Graded: 'GRADED',
  /** Grading started */
  Grading: 'GRADING',
  /** Grading is not required */
  NotRequired: 'NOT_REQUIRED',
  /** Grading didn't start yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Manual_Grading_Status = typeof Manual_Grading_Status[keyof typeof Manual_Grading_Status];
/** Input for creating an MCP app. */
export type McpApps_CreateMcpAppInput = {
  /** The name of Application. */
  appName?: InputMaybe<Scalars['String']>;
  /** The type of MCP application. */
  mcpAppType: McpApps_McpAppType;
  /**
   * Redirect URIs for OAuth2.
   * Accepts custom schemes (e.g., cursor://) and localhost URLs; validated in business logic.
   */
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Input for deleting an MCP app. */
export type McpApps_DeleteMcpAppInput = {
  /** The OAuth client ID to delete. */
  clientId: Scalars['ID'];
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Input for editing an MCP app. At least one of appName or redirectUris must be provided. */
export type McpApps_EditMcpAppInput = {
  /** The new application name. If omitted, the name is unchanged. */
  appName?: InputMaybe<Scalars['String']>;
  /** The OAuth client ID of the app to edit. */
  clientId: Scalars['ID'];
  /** Accepts custom schemes (e.g., cursor://) and localhost URLs; validated in business logic. */
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Enum representing the type of MCP application. */
export const McpApps_McpAppType = {
  /** ChatGPT MCP integration. */
  Chatgpt: 'CHATGPT',
  /** Claude MCP integration. */
  Claude: 'CLAUDE',
  /** Copilot MCP integration. */
  Copilot: 'COPILOT',
  /** Other MCP integration type. */
  Other: 'OTHER'
} as const;

export type McpApps_McpAppType = typeof McpApps_McpAppType[keyof typeof McpApps_McpAppType];
/** User's status in a course based on score and verification */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = {
  NotPassable: 'NOT_PASSABLE',
  NotPassed: 'NOT_PASSED',
  Passed: 'PASSED',
  VerifiedPassed: 'VERIFIED_PASSED'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord];
/** Distinction achieved by a learner getting a grade for a course */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** A user's relationship to a course. This is strongly related to [[org.coursera.opencourse.model.CourseRole]] */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole = {
  Browser: 'BROWSER',
  CourseAssistant: 'COURSE_ASSISTANT',
  DataCoordinator: 'DATA_COORDINATOR',
  Instructor: 'INSTRUCTOR',
  Learner: 'LEARNER',
  Mentor: 'MENTOR',
  NotEnrolled: 'NOT_ENROLLED',
  PartnerAdmin: 'PARTNER_ADMIN',
  PreEnrolledLearner: 'PRE_ENROLLED_LEARNER',
  SuperUser: 'SUPER_USER',
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole];
/** GetMerchandisingUpsell Input */
export type MerchandisingUpsellModule_GetUpsellInput = {
  /** The location of the upsell */
  location: MerchandisingUpsellModule_Location;
};

/** Surfaces of the merchandising upsell */
export const MerchandisingUpsellModule_Location = {
  /** Upsell on the career academy page */
  CareerAcademy: 'CAREER_ACADEMY',
  /** Upsell on the logged-in home page */
  Lihp: 'LIHP',
  /** Upsell on the role description page */
  Rdp: 'RDP'
} as const;

export type MerchandisingUpsellModule_Location = typeof MerchandisingUpsellModule_Location[keyof typeof MerchandisingUpsellModule_Location];
/** MerchandisingUpsellModule priority level */
export const MerchandisingUpsellModule_Priority = {
  /** High priority */
  High: 'HIGH',
  /** Low priority */
  Low: 'LOW'
} as const;

export type MerchandisingUpsellModule_Priority = typeof MerchandisingUpsellModule_Priority[keyof typeof MerchandisingUpsellModule_Priority];
/** MerchandisingUpsellModule type */
export const MerchandisingUpsellModule_Type = {
  /** Upsell for Coursera Plus */
  CourseraPlus: 'COURSERA_PLUS'
} as const;

export type MerchandisingUpsellModule_Type = typeof MerchandisingUpsellModule_Type[keyof typeof MerchandisingUpsellModule_Type];
/** Wrapper type for experiment parameter namespace and parameter name */
export type Mobile_Experiment_Id = {
  /** Experiment namespace */
  namespace: Scalars['String'];
  /** Parameter name */
  parameterName: Scalars['String'];
};

/** Wrapper type for flashcards parameters */
export type Mobile_GetFlashcardsInput = {
  /** Course slug */
  courseSlug: Scalars['String'];
  /**
   * Optional module id. If module id is missing, cards will be fetched for the
   * active module, based on learner progress
   */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/** Wrapper type for experiment parameters */
export type Mobile_GetParametersInput = {
  /** List of experiment namespace and parameter name pairs */
  ids: Array<Mobile_Experiment_Id>;
};

/** TODO: Complete this description */
export type MonetaryAmountInput = {
  /** TODO: Complete this description */
  currencyCode: CurrencyCode;
  /** using String to avoid potential Float precision issues */
  value: Scalars['String'];
};

/** Categories of per-component resolution errors surfaced to the FE. */
export const NativeAnalytics_ErrorCode = {
  /**
   * The data source for this component is temporarily unavailable
   * (e.g. ClickHouse upstream down, table not yet built).
   */
  DataUnavailable: 'DATA_UNAVAILABLE',
  /** Unspecified server-side failure; details available in logs. */
  InternalError: 'INTERNAL_ERROR',
  /**
   * The component references a Semantic Layer metric that does not
   * exist or has been removed.
   */
  InvalidMetric: 'INVALID_METRIC',
  /**
   * The caller is not allowed to view the data backing this component
   * (sub-component scope check; the dashboard-level @authorization
   * already passed).
   */
  PermissionDenied: 'PERMISSION_DENIED',
  /** The underlying analytics query exceeded its time budget. */
  QueryTimeout: 'QUERY_TIMEOUT'
} as const;

export type NativeAnalytics_ErrorCode = typeof NativeAnalytics_ErrorCode[keyof typeof NativeAnalytics_ErrorCode];
/**
 * A single filter selection for a dashboard component data request. The
 * shape of `value` varies per filter type, defined by the dashboard
 * spec's filter[].type field (e.g., multi_select → array of strings,
 * date_range → string or {start, end} object). Validated app-side
 * against the filter's declared type at request time.
 */
export type NativeAnalytics_FilterValueInput = {
  /** ID of the filter in the dashboard spec being filtered on. */
  filterId: Scalars['ID'];
  /**
   * Opaque value whose shape is dictated by the filter's declared type
   * in the dashboard spec.
   */
  value: Scalars['JSON'];
};

/** Input for getting data from a Nostos table. */
export type Nostos_GetDataInput = {
  /** Columns to return. If empty, returns all data columns. */
  columns?: InputMaybe<Array<Scalars['String']>>;
  /** Primary key values to look up. Maximum 1000 keys per request. */
  keys: Array<Scalars['String']>;
  /** Opaque table identifier from the table registry (e.g., "12345", "67890"). */
  tableId: Scalars['ID'];
};

/** Input parameters for OTP_SendOTP mutation. */
export type Otp_SendOtpInput = {
  /** The email address to send the OTP to. */
  email: Scalars['String'];
  /** The username associated with the email address. */
  username: Scalars['String'];
};

/** Status enum for OTP send operations. */
export const Otp_SendOtpStatus = {
  /**
   * Email is currently blocked due to OTP send attempts being exhausted.
   * User cannot send new OTP until the block expires.
   */
  Blocked: 'BLOCKED',
  /** Maximum resend attempts exceeded within the time window. */
  MaxResendExceeded: 'MAX_RESEND_EXCEEDED',
  /** OTP was successfully sent or reused from cache. */
  Success: 'SUCCESS'
} as const;

export type Otp_SendOtpStatus = typeof Otp_SendOtpStatus[keyof typeof Otp_SendOtpStatus];
/** Status enum for OTP validation operations. */
export const Otp_ValidateOtpStatus = {
  /**
   * Email is currently blocked due to OTP validation attempts being exhausted.
   * User cannot attempt OTP validation until the block expires.
   */
  Blocked: 'BLOCKED',
  /** OTP has expired or doesn't exist in cache. */
  Expired: 'EXPIRED',
  /** Provided OTP code is incorrect. */
  InvalidOtp: 'INVALID_OTP',
  /** OTP validation was successful. */
  Success: 'SUCCESS'
} as const;

export type Otp_ValidateOtpStatus = typeof Otp_ValidateOtpStatus[keyof typeof Otp_ValidateOtpStatus];
export const OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType = {
  Highlighted: 'HIGHLIGHTED',
  InstructorCreated: 'INSTRUCTOR_CREATED',
  InstructorResponded: 'INSTRUCTOR_RESPONDED',
  MentorCreated: 'MENTOR_CREATED',
  MentorResponded: 'MENTOR_RESPONDED',
  StaffCreated: 'STAFF_CREATED',
  StaffResponded: 'STAFF_RESPONDED'
} as const;

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType = typeof OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType[keyof typeof OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType];
export const OnDemandCoursesV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Course_CourseStatus = typeof OnDemandCoursesV1_Org_Coursera_Course_CourseStatus[keyof typeof OnDemandCoursesV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant = typeof OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant];
export const OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
export const OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position = {
  End: 'end',
  Start: 'start'
} as const;

export type OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position = typeof OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position[keyof typeof OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
/** One of these next steps will be recommended when the learner has verified and passed a course. */
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep = {
  BuyCourse: 'BuyCourse',
  CompleteVerificationProfile: 'CompleteVerificationProfile',
  EligibleButNoCertificate: 'EligibleButNoCertificate',
  NoVcCourseCompleted: 'NoVcCourseCompleted',
  ViewCertificate: 'ViewCertificate'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus = {
  MultipleDeadlinesOverdue: 'MultipleDeadlinesOverdue',
  OnTrack: 'OnTrack',
  SingleDeadlineOverdue: 'SingleDeadlineOverdue'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason = {
  MultipleDeadlinesOverdue: 'MultipleDeadlinesOverdue',
  NotEnoughPeerReviews: 'NotEnoughPeerReviews',
  SessionEnded: 'SessionEnded'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason];
export const OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus = {
  Ineligible: 'INELIGIBLE',
  NotStarted: 'NOT_STARTED',
  Started: 'STARTED',
  Submitted: 'SUBMITTED'
} as const;

export type OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus = typeof OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus[keyof typeof OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus];
export const OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus = {
  Completed: 'COMPLETED',
  NotStarted: 'NOT_STARTED',
  Released: 'RELEASED',
  Started: 'STARTED'
} as const;

export type OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus = typeof OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus[keyof typeof OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus];
/** TODO: Complete this description */
export const OnDemandSpecializationMembershipRole = {
  /** TODO: Complete this description */
  Instructor: 'INSTRUCTOR',
  /** TODO: Complete this description */
  Learner: 'LEARNER',
  /** TODO: Complete this description */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** TODO: Complete this description */
  NotEnrolled: 'NOT_ENROLLED',
  /** TODO: Complete this description */
  UniversityAdmin: 'UNIVERSITY_ADMIN'
} as const;

export type OnDemandSpecializationMembershipRole = typeof OnDemandSpecializationMembershipRole[keyof typeof OnDemandSpecializationMembershipRole];
/** Creates a membership for the logged-in user. */
export type OnDemandSpecializationMembership_CreateInput = {
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
  /** Boolean to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/** Deletes a membership for the logged-in user. */
export type OnDemandSpecializationMembership_DeleteInput = {
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** Input required to create a S12n Membership */
export type OnDemandSpecializationMembership_EnrollInOwnedS12nInput = {
  /** The optional course ID */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** The source of the upgrade eligibility. */
export const OnDemandSpecializationUpgrade_OwnershipSource = {
  /** When ownership is through Consumer segment, like CPLUS, CLite, S12nSubscription, BulkPay, etc. */
  Consumer: 'CONSUMER',
  /** When ownership is through an Enterprise program. */
  Enterprise: 'ENTERPRISE'
} as const;

export type OnDemandSpecializationUpgrade_OwnershipSource = typeof OnDemandSpecializationUpgrade_OwnershipSource[keyof typeof OnDemandSpecializationUpgrade_OwnershipSource];
/** Different product variants that are currently supported. */
export const OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant = typeof OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant];
export const OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
export const OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType = typeof OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType[keyof typeof OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType];
/** Asset based input. */
export type OpenCourseAsset_AssetBasedAssetInput = {
  /** AssetService assetId (different from open course asset id). */
  assetId: Scalars['ID'];
  /** Name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Create open course asset input. */
export type OpenCourseAsset_CreateOpenCourseAssetInput = {
  /** Open course asset input. */
  openCourseAssetInput: OpenCourseAsset_OpenCourseAssetInput;
};

/** Get latest open course asset input */
export type OpenCourseAsset_GetLatestOpenCourseAssetInput = {
  /** Open course asset id. */
  openCourseAssetId: Scalars['ID'];
};

/** Get open course asset input */
export type OpenCourseAsset_GetOpenCourseAssetInput = {
  /** Versioned open course asset id. */
  versionedOpenCourseAssetId: OpenCourseAsset_VersionedOpenCourseAssetIdInput;
};

/** Html text asset input. */
export type OpenCourseAsset_HtmlTextAssetInput = {
  /** This is a HTML string. */
  content: Scalars['String'];
};

/** Multi-get latest open course asset input. */
export type OpenCourseAsset_MultiGetLatestOpenCourseAssetInput = {
  /** Open course asset Ids. */
  openCourseAssetIds: Array<Scalars['ID']>;
};

/** Multi-get open course asset input. */
export type OpenCourseAsset_MultiGetOpenCourseAssetInput = {
  /** Versioned open course asset Ids input. */
  versionedOpenCourseAssetIdsInput: OpenCourseAsset_VersionedOpenCourseAssetIdsInput;
};

/** Open course asset input. */
export type OpenCourseAsset_OpenCourseAssetInput = {
  /** assetBasedAssetInput. */
  assetBasedAssetInput?: InputMaybe<OpenCourseAsset_AssetBasedAssetInput>;
  /** Cml content input. */
  cmlContentInput?: InputMaybe<CmlContentInput>;
  /** htmlTextAssetInput. */
  htmlTextAssetInput?: InputMaybe<OpenCourseAsset_HtmlTextAssetInput>;
  /** urlAssetInput. */
  urlAssetInput?: InputMaybe<OpenCourseAsset_UrlAssetInput>;
};

/** Update open course asset input. */
export type OpenCourseAsset_UpdateOpenCourseAssetInput = {
  /** The atomId which this open course asset belongs to. This is to enable authoization check. */
  atomId: Scalars['ID'];
  /** Open course asset input. */
  openCourseAssetInput: OpenCourseAsset_OpenCourseAssetInput;
  /** Unversioned open course asset id. */
  unversionedOpenCourseAssetId: Scalars['ID'];
};

/** Url asset input. */
export type OpenCourseAsset_UrlAssetInput = {
  /** Name. */
  name: Scalars['String'];
  /** Url. */
  url: Scalars['URL'];
};

/** VersionedOpenCourseAssetId input */
export type OpenCourseAsset_VersionedOpenCourseAssetIdInput = {
  /** Open course asset Id. */
  id: Scalars['ID'];
  /** Version. */
  version: Scalars['Int'];
};

/** Versioned open course asset Ids input */
export type OpenCourseAsset_VersionedOpenCourseAssetIdsInput = {
  /** Versioned open course asset Ids. */
  versionedOpenCourseAssetIds: Array<OpenCourseAsset_VersionedOpenCourseAssetIdInput>;
};

/** Optimization status */
export const OptimizationBranch_ApprovalState = {
  /** Approved */
  Approved: 'APPROVED',
  /** Pending */
  Pending: 'PENDING',
  /** Rejected */
  Rejected: 'REJECTED'
} as const;

export type OptimizationBranch_ApprovalState = typeof OptimizationBranch_ApprovalState[keyof typeof OptimizationBranch_ApprovalState];
/**
 * Item type
 * Note: we only need to specify ungraded/graded for assignments, otherwise types are generic
 */
export const OptimizationBranch_ItemType = {
  /**
   * Dialogue [new, coach type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue from a role play (which are both marked as "coach" item type)
   */
  CoachItemDialogue: 'COACH_ITEM_DIALOGUE',
  /**
   * Role play [new, coach type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue from a role play (which are both marked as "coach" item type)
   */
  CoachItemRolePlay: 'COACH_ITEM_ROLE_PLAY',
  /**
   * Dialogue [old, plugin type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue (which is by default marked previously as an ungradedWidget)
   */
  Dialogue: 'DIALOGUE',
  /** Discussion Prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Graded assignment */
  GradedAssignment: 'GRADED_ASSIGNMENT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** LTI or App Item */
  Lti: 'LTI',
  /** Peer Review Assignment */
  PeerReview: 'PEER_REVIEW',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming Assignment */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /**
   * Role play [old, plugin type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a role play (which is by default marked previously as an ungradedWidget)
   */
  RolePlay: 'ROLE_PLAY',
  /** Teammate Review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded assignment */
  UngradedAssignment: 'UNGRADED_ASSIGNMENT',
  /** UNGRADED_LAB */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget (aka Plugin) */
  Widget: 'WIDGET'
} as const;

export type OptimizationBranch_ItemType = typeof OptimizationBranch_ItemType[keyof typeof OptimizationBranch_ItemType];
/** Error codes for API key creation failures. */
export const OrgApiKey_CreateError = {
  /** The organization has reached the maximum number of active API keys. */
  KeyLimitExceeded: 'KEY_LIMIT_EXCEEDED'
} as const;

export type OrgApiKey_CreateError = typeof OrgApiKey_CreateError[keyof typeof OrgApiKey_CreateError];
/** Input for creating a new API key. */
export type OrgApiKey_CreateInput = {
  /** Human-readable label for the new API key. */
  name: Scalars['String'];
  /** The third party organization ID to create the key for. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Error codes for API key revocation failures. */
export const OrgApiKey_RevokeError = {
  /** The specified API key was not found or is already revoked. */
  KeyNotFound: 'KEY_NOT_FOUND'
} as const;

export type OrgApiKey_RevokeError = typeof OrgApiKey_RevokeError[keyof typeof OrgApiKey_RevokeError];
/** Input for revoking an existing API key. */
export type OrgApiKey_RevokeInput = {
  /** The ID of the API key to revoke. */
  keyId: Scalars['ID'];
  /** The third party organization ID that owns the key. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Identifies a video clip item by its parent course and the specific item ID within that course. */
export type OrgCollection_ClipItemInput = {
  /** The ID of the course containing the clip. */
  courseId: Scalars['ID'];
  /** The ID of the specific item (clip) within the course. */
  itemId: Scalars['ID'];
};

/** The source workflow or system that originally created a collection. */
export const OrgCollection_CollectionCreateSource = {
  /** Collection created for an academic discipline. */
  AcademicDiscipline: 'ACADEMIC_DISCIPLINE',
  /** Collection created as part of Career Academy. */
  CareerAcademy: 'CAREER_ACADEMY',
  /** Collection created via the content curation workflow. */
  ContentCuration: 'CONTENT_CURATION',
  /** Collection created as a curated collection. */
  CuratedCollection: 'CURATED_COLLECTION',
  /** Collection created via an internal tool. */
  InternalTool: 'INTERNAL_TOOL',
  /** Collection created as part of a learning path. */
  LearningPath: 'LEARNING_PATH',
  /** Collection created via the WES content curation workflow. */
  WesContentCuration: 'WES_CONTENT_CURATION'
} as const;

export type OrgCollection_CollectionCreateSource = typeof OrgCollection_CollectionCreateSource[keyof typeof OrgCollection_CollectionCreateSource];
/**
 * Identifies a collection by its owning organization and unordered set of content items.
 * Used to determine whether a collection with an equivalent identity already exists before creating a new one.
 */
export type OrgCollection_CollectionIdentityInput = {
  /** The type of the collection (e.g. standard collection or learning path). */
  collectionType?: InputMaybe<OrgCollection_CollectionType>;
  /**
   * The content items that make up the collection. Item order is not significant —
   * duplicate detection compares items as an unordered set.
   */
  items: Array<OrgCollection_CollectionItemInput>;
  /** The ID of the third-party organization that owns (or would own) the collection. */
  thirdPartyOrganisationId: Scalars['ID'];
};

/**
 * Represents a single curriculum content item within a collection.
 * Exactly one of the type-specific fields must be set, corresponding to the type of content being referenced.
 */
export type OrgCollection_CollectionItemInput = {
  /** Set to specify this item as a video clip within a course. */
  clipId?: InputMaybe<OrgCollection_ClipItemInput>;
  /** Set to specify this item as a course, using the course ID. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a domain, using the domain ID. */
  domainId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a Specialization (s12n), using the s12n ID. */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a subdomain, using the subdomain ID. */
  subdomainId?: InputMaybe<Scalars['ID']>;
};

/** The type of an admin-curated collection. */
export const OrgCollection_CollectionType = {
  /** A standard curated collection of content. */
  Collection: 'COLLECTION',
  /** A structured learning path through a curated set of content. */
  LearningPath: 'LEARNING_PATH'
} as const;

export type OrgCollection_CollectionType = typeof OrgCollection_CollectionType[keyof typeof OrgCollection_CollectionType];
/** The lifecycle status of an org collection. */
export const OrgCollection_Status = {
  /** The collection has been archived and is no longer in active use. */
  Archived: 'ARCHIVED',
  /** The collection is in draft and not yet published. */
  Draft: 'DRAFT',
  /** The collection is published and available for use. */
  Published: 'PUBLISHED'
} as const;

export type OrgCollection_Status = typeof OrgCollection_Status[keyof typeof OrgCollection_Status];
/** Errors that can occur when creating an OrgVerifiedDomain. */
export const OrgVerifiedDomain_CreateError = {
  /** This domain already exists for the organization. */
  DomainAlreadyExists: 'DOMAIN_ALREADY_EXISTS',
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT'
} as const;

export type OrgVerifiedDomain_CreateError = typeof OrgVerifiedDomain_CreateError[keyof typeof OrgVerifiedDomain_CreateError];
/** Input for creating a new OrgVerifiedDomain. */
export type OrgVerifiedDomain_CreateInput = {
  /**
   * The email domain to add (e.g., "example.com").
   * Must be a valid FQDN.
   */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that will own this domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Errors that can occur when deleting an OrgVerifiedDomain. */
export const OrgVerifiedDomain_DeleteError = {
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT',
  /** The domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_DeleteError = typeof OrgVerifiedDomain_DeleteError[keyof typeof OrgVerifiedDomain_DeleteError];
/** Input for deleting an OrgVerifiedDomain. */
export type OrgVerifiedDomain_DeleteInput = {
  /** The email domain to delete (e.g., "example.com"). */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that owns the domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Errors that can occur when fetching OrgVerifiedDomain. */
export const OrgVerifiedDomain_GetResponseError = {
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The requested domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_GetResponseError = typeof OrgVerifiedDomain_GetResponseError[keyof typeof OrgVerifiedDomain_GetResponseError];
/** Method used to verify domain ownership. */
export const OrgVerifiedDomain_VerificationMethod = {
  /** Self-serve DNS TXT record verification. Admin adds a TXT record to their domain's DNS. */
  DnsTxt: 'DNS_TXT',
  /** Manual verification by platform admin (SA). Used for legacy or high-risk customers. */
  Manual: 'MANUAL'
} as const;

export type OrgVerifiedDomain_VerificationMethod = typeof OrgVerifiedDomain_VerificationMethod[keyof typeof OrgVerifiedDomain_VerificationMethod];
/** Verification status of an organization domain for SSO authentication. */
export const OrgVerifiedDomain_VerificationStatus = {
  /** Domain has been added but not yet verified. */
  Unverified: 'UNVERIFIED',
  /** Domain has been successfully verified. */
  Verified: 'VERIFIED'
} as const;

export type OrgVerifiedDomain_VerificationStatus = typeof OrgVerifiedDomain_VerificationStatus[keyof typeof OrgVerifiedDomain_VerificationStatus];
/** Errors that can occur when verifying an OrgVerifiedDomain. */
export const OrgVerifiedDomain_VerifyError = {
  /** DNS resolution failed. Please try again later. */
  DnsResolutionFailed: 'DNS_RESOLUTION_FAILED',
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT',
  /** The domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_VerifyError = typeof OrgVerifiedDomain_VerifyError[keyof typeof OrgVerifiedDomain_VerifyError];
/** Input for verifying an OrgVerifiedDomain. */
export type OrgVerifiedDomain_VerifyInput = {
  /** The email domain to verify (e.g., "example.com"). */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that owns the domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** GraphQL representation of BillingCycle.courier */
export const OwnableProduct_BillingCycle = {
  /** Annual Billing Cycle */
  BillingCycleAnnual: 'BILLING_CYCLE_ANNUAL',
  /** Biannual Billing Cycle */
  BillingCycleBiannual: 'BILLING_CYCLE_BIANNUAL',
  /** Invalid Billing Cycle */
  BillingCycleInvalid: 'BILLING_CYCLE_INVALID',
  /** Monthly Billing Cycle */
  BillingCycleMonthly: 'BILLING_CYCLE_MONTHLY'
} as const;

export type OwnableProduct_BillingCycle = typeof OwnableProduct_BillingCycle[keyof typeof OwnableProduct_BillingCycle];
/** A Partner and revshare split pair. */
export type OwnableProduct_PartnerRevshareSplitInput = {
  /** The ID of the partner that corresponds to this revshare split */
  partnerId: Scalars['ID'];
  /**
   * The numerator of the overall fraction of revenue that the partner earns.
   * For example, if a given partner has a revshare count of 3 out of a revshare total
   * of 5, then the partner would earn 3/5 (i.e. 60%) of the revenue for that ownable product.
   */
  revshareCount: Scalars['Int'];
  /** The denominator of the overall fraction of revenue that the partner earns. */
  revshareTotal: Scalars['Int'];
};

/**
 * GraphQL enum containing supported product partners for authoring purposes.
 * This information is critical for when associating to the new pricing engine.
 */
export const OwnableProduct_PriceConfiguration_HighValuePartner = {
  /** GOOGLE partner */
  Google: 'GOOGLE',
  /** IBM partner */
  Ibm: 'IBM',
  /** META partner */
  Meta: 'META'
} as const;

export type OwnableProduct_PriceConfiguration_HighValuePartner = typeof OwnableProduct_PriceConfiguration_HighValuePartner[keyof typeof OwnableProduct_PriceConfiguration_HighValuePartner];
/** GraphQL enum containing supported price configuration product types */
export const OwnableProduct_PriceConfiguration_SupportedProductType = {
  /** Specialization product type */
  Specialization: 'SPECIALIZATION',
  /** Course product type */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type OwnableProduct_PriceConfiguration_SupportedProductType = typeof OwnableProduct_PriceConfiguration_SupportedProductType[keyof typeof OwnableProduct_PriceConfiguration_SupportedProductType];
/** GraphQL representation of coursera.proto.sharedentitlement.v1beta1.ProductId */
export type OwnableProduct_ProductId_Input = {
  /** ID for the product */
  productItemId: Scalars['ID'];
  /** Product Type for the Product */
  productType: OwnableProduct_ProductType;
};

/** Product Types defined in ProductType.scala */
export const OwnableProduct_ProductType = {
  /** CourseraPlus */
  ProductTypeCourseraPlus: 'PRODUCT_TYPE_COURSERA_PLUS',
  /** CourseraPlusSubscription */
  ProductTypeCourseraPlusSubscription: 'PRODUCT_TYPE_COURSERA_PLUS_SUBSCRIPTION',
  /** CourseraTierLite */
  ProductTypeCourseraTierLite: 'PRODUCT_TYPE_COURSERA_TIER_LITE',
  /** CredentialTrack - Prepaid version of CredentialTrackSubscriptionV2 */
  ProductTypeCredentialTrack: 'PRODUCT_TYPE_CREDENTIAL_TRACK',
  /** CredentialTrackCourse */
  ProductTypeCredentialTrackCourse: 'PRODUCT_TYPE_CREDENTIAL_TRACK_COURSE',
  /** Legacy CredentialTrackCourseV2 */
  ProductTypeCredentialTrackCourseV2: 'PRODUCT_TYPE_CREDENTIAL_TRACK_COURSE_V2',
  /** Legacy CredentialTrackSubscription */
  ProductTypeCredentialTrackSubscription: 'PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION',
  /** CredentialTrackSubscriptionV2 */
  ProductTypeCredentialTrackSubscriptionV2: 'PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** ENTERPRISE_CONTRACT */
  ProductTypeEnterpriseContract: 'PRODUCT_TYPE_ENTERPRISE_CONTRACT',
  /** Invalid product type */
  ProductTypeInvalid: 'PRODUCT_TYPE_INVALID',
  /** Specialization */
  ProductTypeSpecialization: 'PRODUCT_TYPE_SPECIALIZATION',
  /** SpecializationPrepaid */
  ProductTypeSpecializationPrepaid: 'PRODUCT_TYPE_SPECIALIZATION_PREPAID',
  /** SpecializationSubscription */
  ProductTypeSpecializationSubscription: 'PRODUCT_TYPE_SPECIALIZATION_SUBSCRIPTION',
  /** VerifiedCertificate */
  ProductTypeVerifiedCertificate: 'PRODUCT_TYPE_VERIFIED_CERTIFICATE'
} as const;

export type OwnableProduct_ProductType = typeof OwnableProduct_ProductType[keyof typeof OwnableProduct_ProductType];
/** Input parameters for querying promotional pricing on ownable products. */
export type OwnableProduct_PromotionPrice_Input = {
  /**
   * Unique identifier for the ownable product configuration.
   * Required to determine base pricing and apply promotion.
   */
  productId: OwnableProduct_ProductId_Input;
  /**
   * Promotion details specifying which discount to apply.
   * Must contain either a promotion code string or promotion ID.
   */
  promotion: OwnableProduct_Promotion_Input;
};

/**
 * Union input type for specifying a promotion using either a code string or unique ID.
 * Exactly one field must be provided due to @oneOf directive.
 */
export type OwnableProduct_Promotion_Input = {
  /**
   * Human-readable promotion code (e.g., "SUMMER2024", "WELCOME10").
   * Case-sensitive string that customers typically enter manually.
   */
  promoCode?: InputMaybe<Scalars['String']>;
  /**
   * Internal unique identifier for the promotion.
   * More reliable than codes as it doesn't change and avoids case sensitivity issues.
   */
  promotionId?: InputMaybe<Scalars['ID']>;
};

/** OwnableProduct_UpsertOwnableProductPartnerRevshareRecords request body */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsInput = {
  /** The ownable product ID by which to upsert ownable product partner revshare records */
  ownableProductId: Scalars['ID'];
  /** The list of partner revshare splits to upsert */
  partnerRevshareSplits: Array<OwnableProduct_PartnerRevshareSplitInput>;
};

/** Defines layout orientation for grouped components. */
export const PageConfig_OrientationType = {
  /** Components are arranged horizontally (side by side). */
  Horizontal: 'HORIZONTAL',
  /** Components are arranged vertically (stacked). */
  Vertical: 'VERTICAL'
} as const;

export type PageConfig_OrientationType = typeof PageConfig_OrientationType[keyof typeof PageConfig_OrientationType];
/** An enum holding the names of pages that use the "queryComponents" query. */
export const PageConfig_PageName = {
  /** Used on the base browse page */
  BrowseAll: 'BROWSE_ALL',
  /** Used on domain (topic) browse pages. */
  BrowseDomain: 'BROWSE_DOMAIN',
  /** (Deprecated) Used for EQP page for free queries. Retained for backward compatibility. */
  BrowseEqpFree: 'BROWSE_EQP_FREE',
  /** Used on skill browse pages. */
  BrowseSkill: 'BROWSE_SKILL',
  /** Used on the consumer logged-in home. */
  ConsumerLoggedInHome: 'CONSUMER_LOGGED_IN_HOME',
  /** Used for consumer search page. */
  ConsumerSearch: 'CONSUMER_SEARCH',
  /** Used for enterprise home. */
  EnterpriseHome: 'ENTERPRISE_HOME',
  /** Used on the enterprise org browse page */
  EnterpriseOrgBrowseAll: 'ENTERPRISE_ORG_BROWSE_ALL',
  /** Used on enterprise org domain (topic) browse pages. */
  EnterpriseOrgBrowseDomain: 'ENTERPRISE_ORG_BROWSE_DOMAIN',
  /** Used for enterprise org home. */
  EnterpriseOrgHome: 'ENTERPRISE_ORG_HOME',
  /** Used on enterprise org skill pages. */
  EnterpriseOrgSkill: 'ENTERPRISE_ORG_SKILL',
  /** Used for EQP page for free queries. */
  Eqp: 'EQP',
  /** Used on the mobile explore page. */
  MobileEnterpriseOrgExplore: 'MOBILE_ENTERPRISE_ORG_EXPLORE',
  /** Used on the mobile explore domain page. */
  MobileEnterpriseOrgExploreDomain: 'MOBILE_ENTERPRISE_ORG_EXPLORE_DOMAIN'
} as const;

export type PageConfig_PageName = typeof PageConfig_PageName[keyof typeof PageConfig_PageName];
/** Input for querying browse domain pages components. */
export type PageConfig_QueryBrowseDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
};

/** Input for querying browse skill pages components. */
export type PageConfig_QueryBrowseSkillComponentsInput = {
  /** Include skill id so we can retrieve information about the current skill. */
  skillId: Scalars['ID'];
};

/** The types of query classifications that can be matched. */
export const PageConfig_QueryClassificationType = {
  /** A subject domain or field of study (e.g., "machine learning", "data science") */
  Domain: 'DOMAIN',
  /** An educational or industry partner (e.g., "Google", "Stanford University") */
  Partner: 'PARTNER',
  /** A job role or career position (e.g., "data scientist", "software engineer") */
  Role: 'ROLE',
  /** A specific skill or competency (e.g., "Python programming", "project management") */
  Skill: 'SKILL'
} as const;

export type PageConfig_QueryClassificationType = typeof PageConfig_QueryClassificationType[keyof typeof PageConfig_QueryClassificationType];
/** The queryComponents input. */
export type PageConfig_QueryComponentsInput = {
  /** Additional input required for querying any collection entities under components. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * The page from which the query emanates. The BE will use the PageConfig_PageName enum to
   * determine which components to return and in what order.
   */
  pageName: PageConfig_PageName;
  /**
   * Required info when queries are made from enterprise pages.
   * Include program slug so we can retrieve information about the current program.
   */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Input for querying consumer search page components. */
export type PageConfig_QueryConsumerSearchComponentsInput = {
  /** Query term from the search page. */
  queryTerm: Scalars['String'];
};

/** Input for querying enterprise home page components. */
export type PageConfig_QueryEnterpriseHomeComponentsInput = {
  /**
   * Required info when queries are made from enterprise pages.
   * Include program slug so we can retrieve information about the current program.
   */
  programSlug: Scalars['String'];
};

/** Input for querying enterprise org browse all page components. */
export type PageConfig_QueryEnterpriseOrgBrowseAllComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org browse domain pages components. */
export type PageConfig_QueryEnterpriseOrgBrowseDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org home page components. */
export type PageConfig_QueryEnterpriseOrgHomeComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org skill pages components. */
export type PageConfig_QueryEnterpriseOrgSkillComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
  /** Include skill id so we can retrieve information about the current skill. */
  skillId: Scalars['ID'];
};

/** Input for querying mobile enterprise org explore page components. */
export type PageConfig_QueryMobileEnterpriseOrgExploreComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying mobile enterprise org explore domain page components. */
export type PageConfig_QueryMobileEnterpriseOrgExploreDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** The type of referral banner to display. */
export const PageConfig_ReferralBannerType = {
  /**
   * User is subscribed to Coursera Plus.
   * Referral will lead to discount for the referred only.
   */
  Altruistic: 'ALTRUISTIC',
  /**
   * User is not subscribed to Coursera Plus.
   * Referral will lead to discount for both the referrer and the referred.
   */
  NeverSubscribed: 'NEVER_SUBSCRIBED'
} as const;

export type PageConfig_ReferralBannerType = typeof PageConfig_ReferralBannerType[keyof typeof PageConfig_ReferralBannerType];
/** enum holding the types of Coursera Plus Subscriptions */
export const PageHeader_CourseraPlusSubscriptionCycle = {
  /** Monthly subscription. */
  Monthly: 'MONTHLY',
  /** Yearly subscription */
  Yearly: 'YEARLY'
} as const;

export type PageHeader_CourseraPlusSubscriptionCycle = typeof PageHeader_CourseraPlusSubscriptionCycle[keyof typeof PageHeader_CourseraPlusSubscriptionCycle];
/** Pagination parameters for a pageable request. */
export type PaginationRequest = {
  /** Page number of elements to be retrieved. */
  page?: InputMaybe<Scalars['Int']>;
  /** Number of elements to return. */
  size?: InputMaybe<Scalars['Int']>;
};

/** String-string map entry */
export type Param = {
  /** Key of entry */
  key: Scalars['String'];
  /** Value of entry */
  value: Scalars['String'];
};

/** Input to reject an entity change */
export type PartnerApproval_ApproveOrRejectAllChangesInput = {
  /** Action to take for remaining pending recommendations */
  action: PartnerApproval_ReviewAction;
  /** Authoring branch id (if present, search for branch-level review) */
  authoringBranchId?: InputMaybe<Scalars['ID']>;
  /**
   * Course id (always needed to determine course edit permission, if branch id is not present,
   * fetch course-level review)
   */
  courseId: Scalars['ID'];
};

/** Input to approve a single change */
export type PartnerApproval_ApproveOrRejectChangeInput = {
  /** Action */
  action: PartnerApproval_ReviewAction;
  /** Change review id */
  changeReviewId: Scalars['ID'];
  /** Course id (to determine course edit permission) */
  courseId: Scalars['ID'];
  /**
   * Skip authoring action:
   * If flag is set to true, on recommendation approval, skip publishing the item, and on
   * recommendation rejection, skip deleting the item
   */
  skipAuthoringAction?: Scalars['Boolean'];
};

/** Valid types of content that a recommendation may be associated with */
export const PartnerApproval_EntityType = {
  /** recommendation is for an item. */
  ItemId: 'ITEM_ID'
} as const;

export type PartnerApproval_EntityType = typeof PartnerApproval_EntityType[keyof typeof PartnerApproval_EntityType];
/** Enum for item generation type */
export const PartnerApproval_ItemGenerationType = {
  /** AI generated */
  AiGenerated: 'AI_GENERATED',
  /** Human generated */
  HumanGenerated: 'HUMAN_GENERATED'
} as const;

export type PartnerApproval_ItemGenerationType = typeof PartnerApproval_ItemGenerationType[keyof typeof PartnerApproval_ItemGenerationType];
/** Partner approval optimization status */
export const PartnerApproval_OptimizationStatus = {
  /** The optimization is completed */
  Completed: 'COMPLETED',
  /** The optimization is still pending */
  Pending: 'PENDING'
} as const;

export type PartnerApproval_OptimizationStatus = typeof PartnerApproval_OptimizationStatus[keyof typeof PartnerApproval_OptimizationStatus];
/** Partner approval recommendation state. */
export const PartnerApproval_RecommendationApprovalState = {
  /** The recommendation has been approved. Draft changes are published and available to learners. */
  Approved: 'APPROVED',
  /** The recommendation is pending.  Changes have been applied to the course but they are still in draft. */
  Pending: 'PENDING',
  /** The recommendation has been rejected. Draft changes have essentially been deleted. */
  Rejected: 'REJECTED'
} as const;

export type PartnerApproval_RecommendationApprovalState = typeof PartnerApproval_RecommendationApprovalState[keyof typeof PartnerApproval_RecommendationApprovalState];
/**
 * Enum that shows the current status of the item generation step, mainly to satisfy the loading step
 * This intentionally omits a partial success status per discussion with eng team
 */
export const PartnerApproval_RecommendationGenerationStatus = {
  /** recommendation is being applied (ie item generation has started) */
  Creating: 'CREATING',
  /** recommendation failed to be applied (ie item was not successfully created) */
  Failed: 'FAILED',
  /** No recommendations are pending creation */
  None: 'NONE',
  /** recommendation is ready for review (ie item is created) */
  Success: 'SUCCESS'
} as const;

export type PartnerApproval_RecommendationGenerationStatus = typeof PartnerApproval_RecommendationGenerationStatus[keyof typeof PartnerApproval_RecommendationGenerationStatus];
/** The reason this recommendation was generated */
export const PartnerApproval_RecommendationRationale = {
  /** this recommendation was generated to better prepare learners for upcoming assessments */
  AssessmentPreparation: 'ASSESSMENT_PREPARATION',
  /** this recommendation was generated in order to break up too many passive items in a row */
  BridgeDialogue: 'BRIDGE_DIALOGUE',
  /** this recommendation was implemented in order to engage learners earlier */
  EarlyEngagement: 'EARLY_ENGAGEMENT'
} as const;

export type PartnerApproval_RecommendationRationale = typeof PartnerApproval_RecommendationRationale[keyof typeof PartnerApproval_RecommendationRationale];
/** Action to take on review */
export const PartnerApproval_ReviewAction = {
  /** Approve */
  Approve: 'APPROVE',
  /** Reject */
  Reject: 'REJECT'
} as const;

export type PartnerApproval_ReviewAction = typeof PartnerApproval_ReviewAction[keyof typeof PartnerApproval_ReviewAction];
/**
 * Input to start implementing ai generated recommendations
 * I'm assuming this will apply ALL outstanding pedagogy recommendations for that course
 */
export type PartnerApproval_StartImplementingAiGeneratedRecommendationsInput = {
  /** branch id */
  authoringBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/** Input to submit course/branch (top level entity) for partner approval */
export type PartnerApproval_SubmitForApprovalInput = {
  /** Authoring branch id (nullable for course review) */
  authoringBranchId?: InputMaybe<Scalars['ID']>;
  /** Course id */
  courseId: Scalars['ID'];
};

export const PartnerMembershipsV1_Role = {
  CourseAssistant: 'COURSE_ASSISTANT',
  DataCoordinator: 'DATA_COORDINATOR',
  Instructor: 'INSTRUCTOR',
  PartnerAdmin: 'PARTNER_ADMIN',
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type PartnerMembershipsV1_Role = typeof PartnerMembershipsV1_Role[keyof typeof PartnerMembershipsV1_Role];
/** Partner type */
export const Partner_Type = {
  /** Industry partner */
  Industry: 'INDUSTRY',
  /**
   * Private authoring partner, typically enterprise partners that wish to author content but only
   * make it available to their own employees
   */
  PrivateAuthoring: 'PRIVATE_AUTHORING',
  /** University partner */
  University: 'UNIVERSITY'
} as const;

export type Partner_Type = typeof Partner_Type[keyof typeof Partner_Type];
/** Upsell types */
export const Pathways_StackingType = {
  /** Courses and specializations offering credit towards degree */
  OffersCredit: 'OFFERS_CREDIT',
  /** Courses and specializations offering progress transfer towards a degree */
  PartOf: 'PART_OF',
  /** Courses and specializations related to a degree */
  RelatedTo: 'RELATED_TO'
} as const;

export type Pathways_StackingType = typeof Pathways_StackingType[keyof typeof Pathways_StackingType];
/** Time unit for degree duration */
export const Pathways_TimeUnit = {
  /** Day */
  Day: 'DAY',
  /** Month */
  Month: 'MONTH',
  /** Week */
  Week: 'WEEK',
  /** Year */
  Year: 'YEAR'
} as const;

export type Pathways_TimeUnit = typeof Pathways_TimeUnit[keyof typeof Pathways_TimeUnit];
/** Input for CreatePaymentMethod request. */
export type PaymentProcessor_CreatePaymentMethodInput = {
  /** Optional billing info for processors that do not return billing address information (e.g. Braintree). */
  billingInfo?: InputMaybe<Payments_BillingInfoInput>;
  /** Optional nickname to give payment method. */
  nickname?: InputMaybe<Scalars['String']>;
  /** Id of payment processor. */
  paymentProcessorId: Payments_PaymentProcessorId;
  /** Id of payment method on payment processor. */
  paymentProcessorPaymentMethodId: Scalars['ID'];
};

/** Input object for DeletePaymentMethod request. */
export type PaymentProcessor_DeletePaymentMethodInput = {
  /** ID of payment method to delete. */
  id: Scalars['ID'];
};

/** Input object for PreCreatePaymentMethod request. */
export type PaymentProcessor_PreCreatePaymentMethodInput = {
  /** Payment Processor ID. */
  paymentProcessorId: Payments_PaymentProcessorId;
};

/** Input object for UpdatePaymentMethod request. */
export type PaymentProcessor_UpdatePaymentMethodInput = {
  /** Billing info object containing country, state, postal code. */
  billingInfo?: InputMaybe<Payments_BillingInfoInput>;
  /** Payment method id. */
  id: Scalars['ID'];
  /** New payment processor payment method id. */
  paymentProcessorPaymentMethodId?: InputMaybe<Scalars['ID']>;
};

/** Products that are subject to tax */
export const PaymentTaxes_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** The Coursera Lite product, which gives limited access to a subset of the Coursera catalog. */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /**
   * Used for not taxable, deprecated, or invalid product types.
   * Please note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID',
  /** The most modern version of one-time payment for s12ns. */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** A Subscription product that gives access to an s12n and its courses. */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** Standalone course purchase */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type PaymentTaxes_ProductType = typeof PaymentTaxes_ProductType[keyof typeof PaymentTaxes_ProductType];
/** Billing information in which to update a CheckoutIntent with. */
export type PaymentsCheckout_BillingInfoInput = {
  /** Country ISO code of the billing info (ISO 3166-1 alpha-2). */
  countryIsoCode: Scalars['String'];
  /** Postal code (ZIP code in the US) of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State code of the billing info (preferably the subdivision of ISO 3166-2, but this is not always possible). */
  state?: InputMaybe<Scalars['String']>;
};

/** Braintree subscription submit params. */
export type PaymentsCheckout_BraintreeSubscriptionSubmitParams = {
  /** Braintree nonce. */
  braintreeNonce: Scalars['String'];
};

/** Status of a Checkout Attempt. */
export const PaymentsCheckout_CheckoutAttemptStatus = {
  /** The checkout attempt was successful. */
  Accepted: 'ACCEPTED',
  /** The checkout attempt has failed. */
  Rejected: 'REJECTED'
} as const;

export type PaymentsCheckout_CheckoutAttemptStatus = typeof PaymentsCheckout_CheckoutAttemptStatus[keyof typeof PaymentsCheckout_CheckoutAttemptStatus];
/** Dlocal checkout params. */
export type PaymentsCheckout_DlocalCheckoutParams = {
  /** Callback URL. */
  callbackUrl: Scalars['URL'];
  /** Payer Document(CPF or CNPJ) required by some payment method for expatriation purposse. */
  payerDocument?: InputMaybe<Scalars['String']>;
  /** Payer email. */
  payerEmail: Scalars['String'];
  /** Payer name. */
  payerName: Scalars['String'];
  /** Payer Phone. */
  payerPhone?: InputMaybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod: PaymentsCheckout_DlocalPaymentMethodType;
};

/** Dlocal payment method type. */
export const PaymentsCheckout_DlocalPaymentMethodType = {
  /** GCash payment method - OTP (Philippines). */
  GcashOtp: 'GCASH_OTP',
  /** GCash Recurring (Philippines). */
  GcashRecurring: 'GCASH_RECURRING',
  /** Indonesia local wallet. (Dana or BRI Direct Debit) */
  IdLocalWallet: 'ID_LOCAL_WALLET',
  /** Mercado Pago payment method - OTP. */
  MercadoPagoOtp: 'MERCADO_PAGO_OTP',
  /** Mercado Pago payment method - Recurring. */
  MercadoPagoRecurring: 'MERCADO_PAGO_RECURRING',
  /** OVO wallet (Indonesia) - OTP. */
  OvoOtp: 'OVO_OTP',
  /** PIX Automático payment method. */
  PixAutomatico: 'PIX_AUTOMATICO'
} as const;

export type PaymentsCheckout_DlocalPaymentMethodType = typeof PaymentsCheckout_DlocalPaymentMethodType[keyof typeof PaymentsCheckout_DlocalPaymentMethodType];
/** Input for initializing a CheckoutIntent with a body. */
export type PaymentsCheckout_InitializeBodyInput = {
  /** Billing information to initialize the CheckoutIntent with. */
  billingInfo?: InputMaybe<PaymentsCheckout_BillingInfoInput>;
  /** Payment processor params used to initialize this CheckoutIntent. */
  paymentProcessorInitializeParams?: InputMaybe<PaymentsCheckout_PaymentProcessorInitializeParamsInput>;
  /** Whether to save the payment method associated with this CheckoutIntent. */
  savePaymentMethod?: Scalars['Boolean'];
};

/** Input for initializing a CheckoutIntent. */
export type PaymentsCheckout_InitializeCheckoutIntentInput = {
  /** Body for initializing a CheckoutIntent. */
  body?: InputMaybe<PaymentsCheckout_InitializeBodyInput>;
  /** Cart ID in which to initialize a CheckoutIntent for. */
  cartId: Scalars['ID'];
  /** What Payment Processor ID to use for this CheckoutIntent. */
  paymentProcessorId?: InputMaybe<PaymentsCheckout_PaymentProcessorId>;
  /** Privileged checkout options. */
  privilegedOptions?: InputMaybe<PaymentsCheckout_PrivilegedInitializeCheckoutOptions>;
  /** Whether to use sandbox for checkout. */
  sandbox?: Scalars['Boolean'];
};

/** Input for initializing a CheckoutIntent with a payment method. */
export type PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodInput = {
  /** Flag to indicate whether to wait for user input to submit checkout. */
  autoSubmit?: Scalars['Boolean'];
  /** Cart ID in which to initialize a CheckoutIntent for. */
  cartId: Scalars['ID'];
  /** ID for payment method being used to initialize CheckoutIntent. */
  paymentMethodId: Scalars['ID'];
  /** Privileged checkout options. */
  privilegedOptions?: InputMaybe<PaymentsCheckout_PrivilegedInitializeCheckoutOptions>;
};

/**
 * ID of the Payment Processor being used for a CheckoutIntent.
 *
 * TODO: Update to use Payments_PaymentProcessorId
 */
export const PaymentsCheckout_PaymentProcessorId = {
  /** Braintree Payment processor ID. */
  Braintree: 'BRAINTREE',
  /** DLOCAL Payment Processor ID. */
  Dlocal: 'DLOCAL',
  /** Razorpay Payment Processor ID. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge-at-will Payment Processor ID. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Stripe Bv consumer Payment processor ID. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe consumer Payment processor ID. */
  StripeConsumer: 'STRIPE_CONSUMER'
} as const;

export type PaymentsCheckout_PaymentProcessorId = typeof PaymentsCheckout_PaymentProcessorId[keyof typeof PaymentsCheckout_PaymentProcessorId];
/** Payment processor params used to initialize the checkout. */
export type PaymentsCheckout_PaymentProcessorInitializeParamsInput = {
  /** Input params for Razorpay charge-at-will flow. */
  razorpayChargeAtWillParams?: InputMaybe<PaymentsCheckout_RazorpayChargeAtWillInitializeParams>;
};

/** Payment processor params used to submit the checkout. */
export type PaymentsCheckout_PaymentProcessorSubmitParamsInput = {
  /** Braintree subscription checkout params. */
  braintreeSubscriptionSubmitParams?: InputMaybe<PaymentsCheckout_BraintreeSubscriptionSubmitParams>;
  /** Dlocal checkout params. */
  dlocalSubmitParams?: InputMaybe<PaymentsCheckout_DlocalCheckoutParams>;
  /** Razorpay subscription submit params. */
  razorpaySubscriptionSubmitParams?: InputMaybe<PaymentsCheckout_RazorpaySubscriptionSubmitParams>;
};

/** Privileged CheckoutIntent initialization options. Only allowed for Privileged users. */
export type PaymentsCheckout_PrivilegedInitializeCheckoutOptions = {
  /** Whether to bypass validations for a CheckoutIntent. */
  bypassValidations?: Scalars['Boolean'];
};

/** Razorpay Charge-at-will input params. */
export type PaymentsCheckout_RazorpayChargeAtWillInitializeParams = {
  /** Selected payment method used to initialize the Razorpay checkout. */
  paymentMethod: PaymentsCheckout_RazorpayChargeAtWillPaymentMethod;
};

/** Payment method used to make the authorisation Razorpay charge-at-will transaction. */
export const PaymentsCheckout_RazorpayChargeAtWillPaymentMethod = {
  /** Razorpay Cards. */
  Card: 'CARD',
  /** Razorpay UPI (Unified Payments Interface). */
  Upi: 'UPI'
} as const;

export type PaymentsCheckout_RazorpayChargeAtWillPaymentMethod = typeof PaymentsCheckout_RazorpayChargeAtWillPaymentMethod[keyof typeof PaymentsCheckout_RazorpayChargeAtWillPaymentMethod];
/** Razorpay subscription submit params. */
export type PaymentsCheckout_RazorpaySubscriptionSubmitParams = {
  /** Razorpay payment ID. */
  razorpayPaymentId: Scalars['ID'];
  /** Razorpay signature. */
  razorpaySignature: Scalars['String'];
  /** Razorpay subscription ID. */
  razorpaySubscriptionId: Scalars['ID'];
};

/** The state of a CheckoutIntent. */
export const PaymentsCheckout_State = {
  /**
   * The CheckoutIntent is awaiting for a result to be returned back asynchronously from the
   * Payment Processor to our backend.
   */
  AwaitingResult: 'AWAITING_RESULT',
  /** The CheckoutIntent is no longer valid and cannot be used for payment. */
  Expired: 'EXPIRED',
  /** The CheckoutIntent is complete, in that a payment has successfully been made. */
  Paid: 'PAID',
  /**
   * The CheckoutIntent requires further action from the learner in order to progress.
   * The action required can be found in the `nextAction` field of the CheckoutIntent.
   */
  RequiresAction: 'REQUIRES_ACTION'
} as const;

export type PaymentsCheckout_State = typeof PaymentsCheckout_State[keyof typeof PaymentsCheckout_State];
/** Input for submitting details for a S2S (server to server) checkout step. */
export type PaymentsCheckout_SubmitCheckoutIntentInput = {
  /** ID of the CheckoutIntent in which to submit. */
  checkoutIntentId: Scalars['ID'];
  /**
   * Payment Processor specific data necessary to submit a S2S checkout step in JSON format.
   * @deprecated Migrated to paymentProcessorSubmitParams
   */
  paymentDetails?: InputMaybe<Scalars['String']>;
  /** Payment Processor specific data necessary to submit a S2S checkout step. */
  paymentProcessorSubmitParams?: InputMaybe<PaymentsCheckout_PaymentProcessorSubmitParamsInput>;
};

/** Update body for a CheckoutIntent update request. */
export type PaymentsCheckout_UpdateBodyInput = {
  /** Billing information to update the CheckoutIntent with. */
  billingInfo?: InputMaybe<PaymentsCheckout_BillingInfoInput>;
  /** Whether to save the payment method associated with this CheckoutIntent. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating a CheckoutIntent. */
export type PaymentsCheckout_UpdateCheckoutIntentInput = {
  /** ID of the CheckoutIntent in which to update. */
  checkoutIntentId: Scalars['ID'];
  /** The details in which to update the CheckoutIntent with. */
  updateBody: PaymentsCheckout_UpdateBodyInput;
};

/**
 * paymentsreporting GraphQL Schema
 * Different targets where the payment reporting jobs can be run
 */
export const PaymentsReporting_TargetEnvironment = {
  /** To be used for test runs during development or debugging */
  Development: 'DEVELOPMENT',
  /** To be used for production runs to be delivered to finance */
  Production: 'PRODUCTION'
} as const;

export type PaymentsReporting_TargetEnvironment = typeof PaymentsReporting_TargetEnvironment[keyof typeof PaymentsReporting_TargetEnvironment];
/** Billing information in which to update a CheckoutIntent with. */
export type Payments_BillingInfoInput = {
  /** Country ISO code of the billing info (ISO 3166-1 alpha-3). */
  countryIsoCode: Scalars['String'];
  /** Postal code (ZIP code in the US) of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State code of the billing info (preferably the subdivision of ISO 3166-2, but this is not always possible). */
  state?: InputMaybe<Scalars['String']>;
};

/** Card Brand */
export const Payments_CardBrand = {
  /** American Express - Premium charge and credit cards known for high-end rewards and services */
  AmericanExpress: 'AMERICAN_EXPRESS',
  /** Cartes Bancaires - The French national debit card system, widely used in France */
  CartesBancaires: 'CARTES_BANCAIRES',
  /** Diners Club - International charge card and credit card company, one of the oldest card brands */
  DinersClub: 'DINERS_CLUB',
  /** Discover - American digital payment service and credit card company with cashback rewards */
  Discover: 'DISCOVER',
  /** EFTPOS Australia - Electronic funds transfer at point of sale system primarily used in Australia */
  EftposAustralia: 'EFTPOS_AUSTRALIA',
  /** Interac - Canadian debit card system and payment network widely used across Canada */
  Interac: 'INTERAC',
  /** JCB (Japan Credit Bureau) - Japanese credit card company and payment brand, widely accepted in Asia */
  Jcb: 'JCB',
  /** Mastercard - Global payment technology company and one of the world's largest payment card brands */
  Mastercard: 'MASTERCARD',
  /** Other card brand - Used when the brand cannot be determined */
  Other: 'OTHER',
  /** UnionPay - Chinese financial services corporation and payment card brand, dominant in China */
  UnionPay: 'UNION_PAY',
  /** Visa - American multinational financial services corporation and the world's largest payment card brand */
  Visa: 'VISA'
} as const;

export type Payments_CardBrand = typeof Payments_CardBrand[keyof typeof Payments_CardBrand];
/** Enum type for different payment methods. */
export const Payments_PaymentMethodType = {
  /** Card payment method type. */
  Card: 'CARD',
  /** Cashapp payment method type. */
  Cashapp: 'CASHAPP',
  /** GCash payment method type (DLocal, Philippines). */
  Gcash: 'GCASH',
  /** Indonesia local wallet payment method type. */
  IdLocalWallet: 'ID_LOCAL_WALLET',
  /** Klarna payment method type. */
  Klarna: 'KLARNA',
  /** Link payment method type. */
  Link: 'LINK',
  /** MercadoPago payment method type. */
  Mercadopago: 'MERCADOPAGO',
  /** Other payment method type. */
  Other: 'OTHER',
  /** OVO payment method type. */
  Ovo: 'OVO',
  /** PayPal payment method type. */
  Paypal: 'PAYPAL',
  /** Pix payment method type (Stripe). */
  Pix: 'PIX',
  /** PIX Automatic payment method type (DLocal). */
  PixAutomatic: 'PIX_AUTOMATIC',
  /** Unknown payment method type. */
  Unknown: 'UNKNOWN',
  /** UPI payment method type. */
  Upi: 'UPI'
} as const;

export type Payments_PaymentMethodType = typeof Payments_PaymentMethodType[keyof typeof Payments_PaymentMethodType];
/** Enum for payment processor id. */
export const Payments_PaymentProcessorId = {
  /** IAP Production. */
  AppleInapp: 'APPLE_INAPP',
  /** IAP Sandbox. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree Production. */
  Braintree: 'BRAINTREE',
  /** Braintree Sandbox. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** ID used for manual refunds */
  CourseraManual: 'COURSERA_MANUAL',
  /** dLocal Production. */
  Dlocal: 'DLOCAL',
  /** dLocal Sandbox. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx Production. Deprecated. */
  Ebanx: 'EBANX',
  /** Ebanx Sandbox. Deprecated. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent Production. Deprecated. */
  Emergent: 'EMERGENT',
  /** Emergent Sandbox. Deprecated. */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid by Coursera. Deprecated. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play Billing. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Paypal Production. */
  Paypal: 'PAYPAL',
  /** Paypal Sandbox. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay Production. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will Production. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will Sandbox. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay Sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe Enterprise Production. */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer Production. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer Sandbox. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer Production. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer Sandbox. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe Enterprise WES. Deprecated. */
  StripeEnterpriseWes: 'STRIPE_ENTERPRISE_WES',
  /** Stripe Enterprise WES Sandbox. Deprecated. */
  StripeEnterpriseWesSandbox: 'STRIPE_ENTERPRISE_WES_SANDBOX',
  /** Stripe Enterprise Sandbox. */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** ID used for checkouts with no charge. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type Payments_PaymentProcessorId = typeof Payments_PaymentProcessorId[keyof typeof Payments_PaymentProcessorId];
/** Product action of a transaction */
export const Payments_ProductAction = {
  /**
   * Buy product action is the primary product action used by the FE.
   * Additional product actions are used to support our internal tool for Learner Services.
   * For the CourseraTierLite rollout, we are skipping internal tool support for the MVP.
   * We will rely on direct API calls if we need to do admin-level refunds.
   */
  Buy: 'BUY'
} as const;

export type Payments_ProductAction = typeof Payments_ProductAction[keyof typeof Payments_ProductAction];
/**
 * Product types. Note that not all of our available product type may be listed here.
 * They may be added as required.
 */
export const Payments_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /**
   * Represents MasterTrack one-time payment. Specifically, this is a fairly low-value flow we built
   * as a hack for India EMI payments.
   */
  CredentialTrack: 'CREDENTIAL_TRACK',
  /**
   * CredentialTrackCourse is our abstraction for the individual courses contained in a MasterTrack.
   * When you create a cart for an installments-based MasterTrack checkout (CredentialTrackSubscription)
   * or India prepaid (CredentialTrack) we construct a cart item / fulfillment tree that contains CredentialTrackCourse
   * entities as the leaf nodes.
   */
  CredentialTrackCourse: 'CREDENTIAL_TRACK_COURSE',
  /** Master track subscription, for course work that could count towards a degree */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** Use for Invalid or deprecated product types */
  Invalid: 'INVALID',
  /**
   * Upon successful s12n subscription cart creation, the child cart items in the learner's validated
   * cart are populated with each of the courses that belong to the s12n, as well as the actual s12n
   * itself. This product type was added in strictly for this use case. Lastly, financial aid cart creation
   * is slightly different, as it will not be handled by checkout-gateway application. This enum value
   * will be cleaned up during phase 5+ of next gen product config.
   */
  Specialization: 'SPECIALIZATION',
  /** The most modern version of one-time payment for s12ns */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** A subscription product that gives access to a s12n and its courses */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** Standalone course purchase */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type Payments_ProductType = typeof Payments_ProductType[keyof typeof Payments_ProductType];
/** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
export const Payments_SubscriptionCartItemMetadataPaymentType = {
  /**
   * Used to trigger different side effects based off what type of payment a subscription checkout
   * Represents. Right now we only have the need to distinguish between INITIAL_CHECKOUT and
   * SUBSEQUENT_PAYMENT, but we may find a need for other actions like REFUND.
   */
  SubscriptionCartItemMetadataPaymentTypeInitialCheckout: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_INITIAL_CHECKOUT',
  /**
   * Any payment after the initial checkout payment. Deliberately chose not to call it
   * RECURRING_PAYMENT since that means both initial and subsequent payments in the context of our
   * store. Also didn't call it installment because generally we only use that to mean subsequent
   * payment for a terminal subscription.
   */
  SubscriptionCartItemMetadataPaymentTypeSubsequentPayment: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_SUBSEQUENT_PAYMENT'
} as const;

export type Payments_SubscriptionCartItemMetadataPaymentType = typeof Payments_SubscriptionCartItemMetadataPaymentType[keyof typeof Payments_SubscriptionCartItemMetadataPaymentType];
/** The behavior of the tax. */
export const Payments_TaxBehavior = {
  /** The tax is inclusive of the amount. */
  Exclusive: 'EXCLUSIVE',
  /** The tax is exclusive of the amount. */
  Inclusive: 'INCLUSIVE',
  /** No tax is charged. */
  NotCharged: 'NOT_CHARGED'
} as const;

export type Payments_TaxBehavior = typeof Payments_TaxBehavior[keyof typeof Payments_TaxBehavior];
/** Wallet Type */
export const Payments_WalletType = {
  /** APPLE_PAY */
  ApplePay: 'APPLE_PAY',
  /** GOOGLE_PAY */
  GooglePay: 'GOOGLE_PAY',
  /** LINK */
  Link: 'LINK'
} as const;

export type Payments_WalletType = typeof Payments_WalletType[keyof typeof Payments_WalletType];
/** Input to nullify the appliedAt field of the latest pedagogy recommendation of a branch */
export type PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationInput = {
  /** Authoring branch id */
  authoringBranchId: Scalars['ID'];
};

/** category of change recommended */
export const PedagogyRecommendation_RecommendedChangeType = {
  /** recommendation is for a dialog item generation to be added to the course */
  RecommendDialogItemGeneration: 'RECOMMEND_DIALOG_ITEM_GENERATION',
  /** recommendation is for a lab item generation to be added to the course */
  RecommendLabItemGeneration: 'RECOMMEND_LAB_ITEM_GENERATION',
  /** recommendation is for multiple item types generation to be added to the course */
  RecommendMultipleItemTypesGeneration: 'RECOMMEND_MULTIPLE_ITEM_TYPES_GENERATION'
} as const;

export type PedagogyRecommendation_RecommendedChangeType = typeof PedagogyRecommendation_RecommendedChangeType[keyof typeof PedagogyRecommendation_RecommendedChangeType];
/** Special features that an AI enabled peer assignment has to indicate special behavior */
export const PeerReviewAi_AiEnabledAssignmentFeature = {
  /** Indicates this assignment contains at least 1 file upload question */
  FileUpload: 'FILE_UPLOAD',
  /**
   * Indicates that this assignment will be rolled out to 100% of paid and enterprise learners,
   * instead of the default behavior
   */
  PaidEnterprise_100: 'PAID_ENTERPRISE_100',
  /**
   * Indicates this assignment will be rolled out to all learners except for those excluded on legal
   * reasons
   */
  RolloutAll: 'ROLLOUT_ALL'
} as const;

export type PeerReviewAi_AiEnabledAssignmentFeature = typeof PeerReviewAi_AiEnabledAssignmentFeature[keyof typeof PeerReviewAi_AiEnabledAssignmentFeature];
/** Input for PeerReviewAi_RequestGradingByPeer mutation */
export type PeerReviewAi_RequestGradingByPeerInput = {
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** Reason for switching the grading type */
  reason?: InputMaybe<Scalars['String']>;
  /** The Submission ID, requires successful peer review submission */
  submissionId: Scalars['ID'];
};

/** Determines the type of rollout for the peer review AI enabled assignment */
export const PeerReviewAi_RolloutType = {
  /** Indicates that this assignment will be rolled out to 100% of paid and enterprise learners */
  PaidEnterprise_100: 'PAID_ENTERPRISE_100',
  /**
   * Indicates this assignment will be rolled out to all learners except for those excluded on legal
   * reasons
   */
  RolloutAll: 'ROLLOUT_ALL'
} as const;

export type PeerReviewAi_RolloutType = typeof PeerReviewAi_RolloutType[keyof typeof PeerReviewAi_RolloutType];
/** Input for PeerReviewAi_SaveUserFeedback mutation */
export type PeerReviewAi_SaveUserFeedbackInput = {
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The logged in user's feedback choice for the specified AI grading review part of a specific review */
  feedbackChoice?: InputMaybe<PeerReviewAi_UserFeedbackChoice>;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Review ID for a peer review */
  reviewId: Scalars['ID'];
  /** The Review Part ID of the AI review */
  reviewPartId: Scalars['ID'];
  /** The Submission ID, requires successful peer review submission */
  submissionId: Scalars['ID'];
};

/** Enum representing the current status of an AI grading submission */
export const PeerReviewAi_Status = {
  /** AI review failed */
  Failed: 'FAILED',
  /** Submission is not AI Reviewed */
  None: 'NONE',
  /** AI review is under process */
  Pending: 'PENDING',
  /** AI review was successfully completed */
  Success: 'SUCCESS'
} as const;

export type PeerReviewAi_Status = typeof PeerReviewAi_Status[keyof typeof PeerReviewAi_Status];
/** Enum representing user feedback of AI grading */
export const PeerReviewAi_UserFeedbackChoice = {
  /** AI review part is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI review part is liked by the user */
  Like: 'LIKE'
} as const;

export type PeerReviewAi_UserFeedbackChoice = typeof PeerReviewAi_UserFeedbackChoice[keyof typeof PeerReviewAi_UserFeedbackChoice];
/** Input for convertPeerReviewToAiAssignment mutation */
export type PeerReviewMigration_ConvertPeerReviewToAiAssignmentInput = {
  /** Atom ID */
  atomId?: InputMaybe<Scalars['ID']>;
  /** Authoring branch ID of the course */
  authoringBranchId: Scalars['ID'];
  /** The course that the peer review is in */
  courseId: Scalars['ID'];
  /** Peer review assignment ID */
  peerAssignmentId: Scalars['ID'];
  /** Version */
  version: Scalars['Int'];
};

/** Input representing a versioned peer review assignment within a course and branch */
export type PeerReviewMigration_EligibilityInput = {
  /** The Assignment ID */
  assignmentId: Scalars['ID'];
  /** The Assignment Version */
  assignmentVersion: Scalars['Int'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
};

/** Additional migration eligibility context. Warnings highlight potential issues but do not necessarily prevent eligibility. */
export const PeerReviewMigration_EligibilityMessage = {
  /** Assignment mentions or allows invalid or unsupported file types. */
  ContainsInvalidFileTypesMention: 'CONTAINS_INVALID_FILE_TYPES_MENTION',
  /** Assignment includes questions that require URLs. */
  ContainsUrlQuestions: 'CONTAINS_URL_QUESTIONS',
  /** Assignment is part of or linked to a degree authoring branch. */
  IsPartOrLinkedToDegreeBranch: 'IS_PART_OR_LINKED_TO_DEGREE_BRANCH'
} as const;

export type PeerReviewMigration_EligibilityMessage = typeof PeerReviewMigration_EligibilityMessage[keyof typeof PeerReviewMigration_EligibilityMessage];
/** Specifies which grading type will be used for peer submission. */
export const PeerReview_PeerGradingType = {
  /** New grading type when submission is graded by AI. */
  Ai: 'AI',
  /** Original grading type when submission is graded by other learners. */
  Human: 'HUMAN'
} as const;

export type PeerReview_PeerGradingType = typeof PeerReview_PeerGradingType[keyof typeof PeerReview_PeerGradingType];
/** Degree application acceptance decision */
export const PersonalizedDdp_DegreeApplicationAcceptanceDecision = {
  /** The application with ACCEPTED decision */
  Accepted: 'ACCEPTED',
  /** The application with DECLINED decision */
  Declined: 'DECLINED',
  /** The application with DEFERRED decision */
  Deferred: 'DEFERRED',
  /** The application with WITHDRAWN decision */
  Withdrawn: 'WITHDRAWN'
} as const;

export type PersonalizedDdp_DegreeApplicationAcceptanceDecision = typeof PersonalizedDdp_DegreeApplicationAcceptanceDecision[keyof typeof PersonalizedDdp_DegreeApplicationAcceptanceDecision];
/**
 * Degree application status. (There are more in the database, for now we only record these types
 * and mark the others as OTHER)
 */
export const PersonalizedDdp_DegreeApplicationStatus = {
  /** The application was accepted */
  Accepted: 'ACCEPTED',
  /** The application that awaiting for payment */
  AwaitingPayment: 'AWAITING_PAYMENT',
  /** The application that user started but hasn't submitted */
  AwaitingSubmission: 'AWAITING_SUBMISSION',
  /** The application with other status */
  Other: 'OTHER',
  /** The application in pending */
  Pending: 'PENDING',
  /** The application with performance pathway admit */
  PerformancePathwayAdmit: 'PERFORMANCE_PATHWAY_ADMIT',
  /** The application was rejected */
  Rejected: 'REJECTED',
  /** The application in waiting list */
  Waitlisted: 'WAITLISTED',
  /** The application was withdrawn */
  Withdrawn: 'WITHDRAWN'
} as const;

export type PersonalizedDdp_DegreeApplicationStatus = typeof PersonalizedDdp_DegreeApplicationStatus[keyof typeof PersonalizedDdp_DegreeApplicationStatus];
/** Degree application types */
export const PersonalizedDdp_DegreeApplicationType = {
  /** degree seeking */
  DegreeSeeking: 'DEGREE_SEEKING',
  /** missing value */
  MissingValue: 'MISSING_VALUE',
  /** non degree seeking */
  NonDegreeSeeking: 'NON_DEGREE_SEEKING'
} as const;

export type PersonalizedDdp_DegreeApplicationType = typeof PersonalizedDdp_DegreeApplicationType[keyof typeof PersonalizedDdp_DegreeApplicationType];
/**
 * The source types of EOI responses. (There are around 30 different types in the database, for now we
 * only record the coursera sources and mark the others as OTHER)
 */
export const PersonalizedDdp_EoiResponseSource = {
  /** EOI from coursera article */
  CourseraArticle: 'COURSERA_ARTICLE',
  /** EOI from coursera blog */
  CourseraBlog: 'COURSERA_BLOG',
  /** EOI from DDP */
  CourseraDdp: 'COURSERA_DDP',
  /** EOI from degree hub */
  CourseraDegreeHub: 'COURSERA_DEGREE_HUB',
  /** EOI from coursera zoom webinars */
  CourseraZoomWebinars: 'COURSERA_ZOOM_WEBINARS',
  /** EOI from other source */
  Other: 'OTHER'
} as const;

export type PersonalizedDdp_EoiResponseSource = typeof PersonalizedDdp_EoiResponseSource[keyof typeof PersonalizedDdp_EoiResponseSource];
/** Upsell relation types */
export const PersonalizedDdp_UpsellRelationType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type PersonalizedDdp_UpsellRelationType = typeof PersonalizedDdp_UpsellRelationType[keyof typeof PersonalizedDdp_UpsellRelationType];
/** Input for adding a product to a milestone within a learning plan. */
export type PersonalizedPlans_AddProductInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /** The plan to modify. */
  planId: Scalars['ID'];
  /** The product to add. */
  product: PersonalizedPlans_ProductIdentifier;
};

/**
 * Input to generate a learning plan. This is exclusively used for the simulating personalized plans and thus is for internal use only.
 * The input does not need to be backwards compatible. Breaking changes for this API should be expected and allowed.
 */
export type PersonalizedPlans_LearningPlanInput = {
  /** Free-form learner goal (e.g. "become a data scientist in 6 months"). */
  goal: Scalars['String'];
  /** Free-form role name. The application does a best-effort to resolve this to a taxonomy role. Unmatched values are considered user-generated. */
  roleName?: InputMaybe<Scalars['String']>;
  /** Free-form skill names. The application does a best-effort to resolve these to taxonomy skills. Unmatched values are considered user-generated. */
  skillNames: Array<Scalars['String']>;
};

/** Status of a learning plan. */
export const PersonalizedPlans_LearningPlanStatus = {
  /** Learner has completed all milestones in the plan. */
  Completed: 'COMPLETED',
  /** Plan has been created but not yet started. */
  Created: 'CREATED',
  /**
   * Plan generation failed. The original generation input is retained on the plan so the
   * learner can retry generation without re-entering their goal, role, and skills.
   */
  Failed: 'FAILED',
  /** Learner has started working on the plan. */
  Started: 'STARTED'
} as const;

export type PersonalizedPlans_LearningPlanStatus = typeof PersonalizedPlans_LearningPlanStatus[keyof typeof PersonalizedPlans_LearningPlanStatus];
/** Per-learner enrollment state for a plan product or constituent course. */
export const PersonalizedPlans_PlanProductEnrollmentState = {
  /** The learner is actively enrolled (LEARNER role or equivalent). */
  Enrolled: 'ENROLLED',
  /** The learner has no enrolled-or-pre-enrolled course membership for this product. */
  NotEnrolled: 'NOT_ENROLLED',
  /** The learner is pre-enrolled — the course has not yet launched for them. */
  PreEnrolled: 'PRE_ENROLLED'
} as const;

export type PersonalizedPlans_PlanProductEnrollmentState = typeof PersonalizedPlans_PlanProductEnrollmentState[keyof typeof PersonalizedPlans_PlanProductEnrollmentState];
/** Identifies a specific learning product by its type and ID. */
export type PersonalizedPlans_ProductIdentifier = {
  /** The canonical product ID (e.g. a course slug or specialization ID). */
  productId: Scalars['ID'];
  /** The type of learning product. */
  productType: PersonalizedPlans_ProductType;
};

/** The type of learning product within a plan. */
export const PersonalizedPlans_ProductType = {
  /** A Coursera course. */
  Course: 'COURSE',
  /** A Coursera specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type PersonalizedPlans_ProductType = typeof PersonalizedPlans_ProductType[keyof typeof PersonalizedPlans_ProductType];
/** Input for removing a product from a milestone within a learning plan. */
export type PersonalizedPlans_RemoveProductInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /** The plan to modify. */
  planId: Scalars['ID'];
  /** The product to remove. */
  product: PersonalizedPlans_ProductIdentifier;
};

/** Input for reordering products within a milestone. */
export type PersonalizedPlans_ReorderProductsInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /**
   * Ordered list of products representing the desired order.
   * Must be a permutation of existing products in the milestone (no adds or removes).
   */
  orderedProducts: Array<PersonalizedPlans_ProductIdentifier>;
  /** The plan to modify. */
  planId: Scalars['ID'];
};

/** Why a retry-generation request could not produce a new plan. */
export const PersonalizedPlans_RetryGenerationErrorCode = {
  /** Generation was retried but failed again. The plan remains FAILED with an incremented retry count. */
  GenerationFailed: 'GENERATION_FAILED',
  /** The plan has already been retried the maximum number of times; the learner should start over. */
  MaxRetriesExceeded: 'MAX_RETRIES_EXCEEDED',
  /** The plan is not in a retryable state (only FAILED plans can be retried). */
  NotRetryable: 'NOT_RETRYABLE',
  /** No plan with the given ID exists for the requesting learner. */
  PlanNotFound: 'PLAN_NOT_FOUND'
} as const;

export type PersonalizedPlans_RetryGenerationErrorCode = typeof PersonalizedPlans_RetryGenerationErrorCode[keyof typeof PersonalizedPlans_RetryGenerationErrorCode];
/** Input for retrying generation of a FAILED plan. */
export type PersonalizedPlans_RetryGenerationInput = {
  /** The ID of the FAILED plan to retry. */
  planId: Scalars['ID'];
};

/** Input for deleting a Phrase course configuration. */
export type PhraseCourseConfig_RemoveByBatchNameInput = {
  /** The batch name of the configuration to remove. */
  batchName: Scalars['String'];
};

/** Input for validating and writing a Phrase course configuration. */
export type PhraseCourseConfig_ValidateAndSaveInput = {
  /** Unique batch name for this configuration. */
  batchName: Scalars['String'];
  /** Branch ID for content versioning. */
  branchId: Scalars['ID'];
  /** Coursera course ID. */
  courseId: Scalars['ID'];
  /** True if updating existing config, false for new config. */
  isUpdate?: Scalars['Boolean'];
  /** Phrase project template ID. */
  projectTemplateId: Scalars['ID'];
  /** Source language code (e.g., "en-US"). */
  sourceLang?: InputMaybe<Scalars['String']>;
  /** Target language codes (e.g., ["es-ES", "fr-FR"]). */
  targetLanguages: Array<Scalars['String']>;
  /** Version ID from previous read for optimistic locking. Null for new configs. */
  versionId?: InputMaybe<Scalars['ID']>;
};

/** Text similarity check status */
export const PlagiarismStatus = {
  /** Content has been completely plagiarized a given prompt */
  CompletePlagiarism: 'COMPLETE_PLAGIARISM',
  /** Plagiarism is not detected for a given prompt */
  NotPlagiarism: 'NOT_PLAGIARISM',
  /** Plagiarism is detected for a given prompt */
  PartialPlagiarism: 'PARTIAL_PLAGIARISM',
  /** Plagiarism is skipped for a given prompt since it's not part of the allowlist */
  PlagiarismSkipped: 'PLAGIARISM_SKIPPED'
} as const;

export type PlagiarismStatus = typeof PlagiarismStatus[keyof typeof PlagiarismStatus];
/** Enum of the "known" list of rpc interactions we support between the platform and the widget iframe contents.  This is used to identify actions that a widget is allowed to take. */
export const Plugins_WidgetRpcActionType = {
  /** Get scoped activity summary data for the user. */
  GetActivitySummaries: 'GET_ACTIVITY_SUMMARIES',
  /** Get authoriziation data for specific APIs that the widget needs to communicate with. */
  GetExternalApiAuthorizations: 'GET_EXTERNAL_API_AUTHORIZATIONS',
  /** Deprecated action type, unused in practice but serialized within * AuthoringWidgetApprovalPolicy.actions, so must be retained for backward compatibility. */
  GetGroupMemberships: 'GET_GROUP_MEMBERSHIPS',
  /** Load current session's configuration data */
  GetSessionConfiguration: 'GET_SESSION_CONFIGURATION',
  /** retrieve storedValues from our BE */
  GetStoredValues: 'GET_STORED_VALUES',
  /** Read specific, session-configured data keys from Nostos. See usage of * [[WidgetNostosReadRequest]] and [[WidgetNostosReadAuthorization]] for details. */
  ReadCustomQueryResults: 'READ_CUSTOM_QUERY_RESULTS',
  /** set the answer for a graded widget */
  SetAnswer: 'SET_ANSWER',
  /** Set the item as complete */
  SetComplete: 'SET_COMPLETE',
  /** Sets the item as complete with a specific grade */
  SetGradedComplete: 'SET_GRADED_COMPLETE',
  /** Set the height of the widget */
  SetHeight: 'SET_HEIGHT',
  /** Deprecated, use [[SET_COMPLETE]] instead. Retained here for backward compatibility of* prototype widgets. Please see note on SET_COMPLETE. */
  SetItemComplete: 'SET_ITEM_COMPLETE',
  /** save storedValues to our BE for persistence. */
  SetStoredValues: 'SET_STORED_VALUES',
  /** Deprecated feature, retained for backward compatibility with legacy data. */
  SubmitSurveyResponse: 'SUBMIT_SURVEY_RESPONSE'
} as const;

export type Plugins_WidgetRpcActionType = typeof Plugins_WidgetRpcActionType[keyof typeof Plugins_WidgetRpcActionType];
/** Fields for an artifact in the project from input */
export type PortfolioProject_ArtifactInput = {
  /** The assignment link of the artifact item */
  assignmentLink?: InputMaybe<Scalars['URL']>;
  /** The assignment title of the artifact item */
  assignmentTitle?: InputMaybe<Scalars['String']>;
  /** The item id of the artifact */
  itemId?: InputMaybe<Scalars['ID']>;
  /** The link of the artifact item */
  link?: InputMaybe<Scalars['URL']>;
  /** The type of the artifact item entered by learner (eg. Github URL) */
  type?: InputMaybe<Scalars['String']>;
};

/** Project type enum. */
export const PortfolioProject_ProjectType = {
  /** Capstone project type. */
  Capstone: 'CAPSTONE',
  /** Portfolio project type. */
  Demonstration: 'DEMONSTRATION'
} as const;

export type PortfolioProject_ProjectType = typeof PortfolioProject_ProjectType[keyof typeof PortfolioProject_ProjectType];
/** TODO: Complete this description */
export const PreEnrollmentType = {
  /**
   * This PreEnrollmentType will (attempt) to auto enroll the learner using their C+ or Enterprise
   * membership at the time of product launch.
   */
  AutoEnroll: 'AUTO_ENROLL',
  /**
   * This PreEnrollmentType will require an additional capturePaymentWalletId step to be completed.
   * When the product is launched, the Learner will automatically be charged and enrolled.
   */
  PaymentWalletCapture: 'PAYMENT_WALLET_CAPTURE'
} as const;

export type PreEnrollmentType = typeof PreEnrollmentType[keyof typeof PreEnrollmentType];
/** Representation of different states of pre-enrollment/enrollment a product can be in. */
export const PreEnrollment_PreEnrollmentProductState = {
  /** All pre-enrolled learners are now enrolled into the product. */
  CompletedEnrollments: 'COMPLETED_ENROLLMENTS',
  /** Product is open for pre-enrollment and learners can actively pre-enroll. */
  OpenForPreEnrollment: 'OPEN_FOR_PRE_ENROLLMENT',
  /** Product is now launched and pre-enrolled learners are ready to be enrolled. */
  ReadyToEnroll: 'READY_TO_ENROLL'
} as const;

export type PreEnrollment_PreEnrollmentProductState = typeof PreEnrollment_PreEnrollmentProductState[keyof typeof PreEnrollment_PreEnrollmentProductState];
/** Product types */
export const PreEnrollment_ProductType = {
  /** Subscription product */
  Specialization: 'SPECIALIZATION',
  /** Specialization sold as a subscription */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION'
} as const;

export type PreEnrollment_ProductType = typeof PreEnrollment_ProductType[keyof typeof PreEnrollment_ProductType];
/** Parameter for querying degree categories when premium learning products are required in the results. */
export type PremiumLearningProductSpecs = {
  /** Availability status of the premium products to be retrieved. */
  catalogAvailabilityStatuses?: InputMaybe<Array<Scalars['String']>>;
  /** Pagination parameters for premium product collection. */
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** TODO: Complete this description */
export type PremiumProductCollections_QueryCollectionInput = {
  /** Catalog availability status */
  catalogAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of degree category ids. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of browse domain ids. */
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of product variants. */
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** TODO: Complete this description */
export type Proctor_OverrideSubmitterProctorConfigInput = {
  /** TODO: Complete this description */
  assessmentId: Scalars['String'];
  /** TODO: Complete this description */
  attemptDuration?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  maxAttempts?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  maxSubmissionsPerAttempt?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  submitterId: Scalars['String'];
};

/** Enum of canonical types for product card. */
export const ProductCard_CanonicalType = {
  /** Clip canonical type. */
  Clip: 'CLIP',
  /** Course canonical type. */
  Course: 'COURSE',
  /** Degree canonical type. */
  Degree: 'DEGREE',
  /** Specialization canonical type. */
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductCard_CanonicalType = typeof ProductCard_CanonicalType[keyof typeof ProductCard_CanonicalType];
/** The unique identifier of a product card. We name it "key" instead of "id" to prevent confusion with the `id` field within this type. */
export type ProductCard_Key = {
  /** The canonical type of the product requested. */
  canonicalType: ProductCard_CanonicalType;
  /** The entity ID. Examples: "GdeNrll1EeSROyIACtiVvg", "base~7KkNm4CtRpifVWmOqPrNyA" */
  id: Scalars['ID'];
};

/**
 * Product types.
 * Defines specific types of product that are displayed to the user.
 * They may also be used as subcategories of products.
 * They differ from canonical types as they do not have a one-to-one mapping with them.
 */
export const ProductCard_ProductType = {
  /** Course product type. */
  Course: 'COURSE',
  /** Degree product type. */
  Degree: 'DEGREE',
  /** Graduate Certificate product type. */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Guided Project product type. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Lesson product type. */
  Lesson: 'LESSON',
  /** MasterTrack product type. */
  Mastertrack: 'MASTERTRACK',
  /** Postgraduate Diploma product type. */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Professional Certificate product type. */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type. */
  Project: 'PROJECT',
  /** Specialization product type. */
  Specialization: 'SPECIALIZATION',
  /** University Certificate product type. */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Video product type. */
  Video: 'VIDEO'
} as const;

export type ProductCard_ProductType = typeof ProductCard_ProductType[keyof typeof ProductCard_ProductType];
/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType = typeof ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType];
/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType = typeof ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType];
export const ProductSkusV1_Org_Coursera_Product_BillingCycle = {
  Annual: 'ANNUAL',
  Biannual: 'BIANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type ProductSkusV1_Org_Coursera_Product_BillingCycle = typeof ProductSkusV1_Org_Coursera_Product_BillingCycle[keyof typeof ProductSkusV1_Org_Coursera_Product_BillingCycle];
export const ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = typeof ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus[keyof typeof ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus];
/** Input to add profile consents */
export type ProfileConsents_AddProfileConsentsInput = {
  /** Boolean indicating the user consents to Coursera's Terms of Use and Privacy Policy. */
  consentToTermsOfUse: Scalars['Boolean'];
};

/** Enum for deman levels used to form an occupation tag */
export const ProfileOccupationChoices_DemandLevel = {
  /** High */
  High: 'HIGH',
  /** Low */
  Low: 'LOW',
  /** Not applicable */
  NotApplicable: 'NOT_APPLICABLE'
} as const;

export type ProfileOccupationChoices_DemandLevel = typeof ProfileOccupationChoices_DemandLevel[keyof typeof ProfileOccupationChoices_DemandLevel];
/** Enum for feature tags used to form an occupation tag */
export const ProfileOccupationChoices_FeatureTag = {
  /**
   * ACTIVELY_HIRING
   * Use this tag if there's an open rec for this role on our recruiting platform
   */
  ActivelyHiring: 'ACTIVELY_HIRING',
  /** BASELINE */
  Baseline: 'BASELINE',
  /**
   * BASELINE_V2
   * It is for profile autocompete with updated occupation taxonomy
   * that is exported by https://tools.coursera.org/mega/s3Export/YptlEMBxEeq0d_0D90PFFg~S3_EXPORT_JOB@1#jobEditor
   * This is supposed to replace the old occupation taxonomy tagged with `PLP_V1`
   * which were hardcoded and not being updated
   */
  BaselineV2: 'BASELINE_V2',
  /**
   * DEGREES_ONLY
   * Use this if user completed degrees onboarding (currently as part of the PLP onboarding UI)
   * with an existing degree, and did NOT fill out occupation/skills/domains preferences.
   */
  DegreesOnly: 'DEGREES_ONLY',
  /** PLP_V1 */
  PlpV1: 'PLP_V1'
} as const;

export type ProfileOccupationChoices_FeatureTag = typeof ProfileOccupationChoices_FeatureTag[keyof typeof ProfileOccupationChoices_FeatureTag];
/** Input type of filtering criteria to generate corresponding occupation choices. */
export type ProfileOccupationChoices_OccupationChoiceFilter = {
  /**
   * A list of occupation tags to filter for. The profileOccupationChoice.v1 has getAll and byTag.
   * By passing null here, it would return the results for getAll.
   */
  occupationTags?: InputMaybe<Array<ProfileOccupationChoices_OccupationTagInput>>;
};

/** The occupation tag input. */
export type ProfileOccupationChoices_OccupationTagInput = {
  /** The demand level part of the occupation tag input */
  demandLevel: ProfileOccupationChoices_DemandLevel;
  /** The feature tag part of the occupation tag input */
  featureTag: ProfileOccupationChoices_FeatureTag;
};

export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction = {
  Enroll: 'ENROLL',
  Manage: 'MANAGE',
  Preview: 'PREVIEW',
  Resume: 'RESUME',
  Select: 'SELECT',
  Unenroll: 'UNENROLL',
  Unselect: 'UNSELECT',
  Upgrade: 'UPGRADE',
  View: 'VIEW'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction];
export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState = {
  Available: 'AVAILABLE',
  Completed: 'COMPLETED',
  Enrolled: 'ENROLLED',
  Unavailable: 'UNAVAILABLE'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState];
export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = {
  UnavailableCourseNotLaunchedNorPreEnrollable: 'UNAVAILABLE_COURSE_NOT_LAUNCHED_NOR_PRE_ENROLLABLE',
  UnavailableCourseNoOpenSessions: 'UNAVAILABLE_COURSE_NO_OPEN_SESSIONS',
  UnavailableNotInProgram: 'UNAVAILABLE_NOT_IN_PROGRAM',
  UnavailableNotPermitted: 'UNAVAILABLE_NOT_PERMITTED',
  UnavailableNoCreditsRemaining: 'UNAVAILABLE_NO_CREDITS_REMAINING'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason];
/** An enum denotes the state for a learner and a given enrolled learning product. */
export const ProgramHome_EnrolledProductState = {
  /**
   * A non-enrolled state that is only used to describe the enrollment state of a child course
   * under an enrolled specialization: the course is available to enroll;
   */
  Available: 'AVAILABLE',
  /** The user has completed the learning product; */
  Completed: 'COMPLETED',
  /** The user has enrolled and started but not yet completed the learning product; */
  EnrolledInProgress: 'ENROLLED_IN_PROGRESS',
  /**
   * The learner has enrolled but the session has not yet started. This is only applicable when the
   * course instance is limited availability, i.e., fixed session experience. When in this state,
   * the learner can preview the course but can not access the full course materials.
   */
  EnrolledStartingLater: 'ENROLLED_STARTING_LATER',
  /**
   * A non-enrolled state that is only used to describe the enrollment state of a child course
   * under an enrolled specialization: the course is not available to enroll;
   */
  Unavailable: 'UNAVAILABLE'
} as const;

export type ProgramHome_EnrolledProductState = typeof ProgramHome_EnrolledProductState[keyof typeof ProgramHome_EnrolledProductState];
/** An enum denotes the input state for a learner and a given enrolled learning product. */
export const ProgramHome_EnrolledProductStateInput = {
  /** The user has completed the learning product; */
  Completed: 'COMPLETED',
  /** The user has enrolled and started but not yet completed the learning product; */
  EnrolledInProgress: 'ENROLLED_IN_PROGRESS',
  /**
   * The learner has enrolled but the session has not yet started. This is only applicable when the
   * course instance is limited availability, i.e., fixed session experience. When in this state,
   * the learner can preview the course but can not access the full course materials.
   */
  EnrolledStartingLater: 'ENROLLED_STARTING_LATER'
} as const;

export type ProgramHome_EnrolledProductStateInput = typeof ProgramHome_EnrolledProductStateInput[keyof typeof ProgramHome_EnrolledProductStateInput];
/** The queryEnrolledProducts input. */
export type ProgramHome_QueryEnrolledProductsInput = {
  /** enterprise program Id */
  programId: Scalars['ID'];
  /** the state of the enrolled product */
  state: ProgramHome_EnrolledProductStateInput;
};

/** ProgramInvitationsDomainAllowList_MultiDelete Input */
export type ProgramInvitationsDomainAllowList_MultiDeleteInput = {
  /** List of email domains that will be deleted from the allow list. */
  emailDomains: Array<Scalars['String']>;
  /** Id of the program whose allow list will be updated. */
  programId: Scalars['ID'];
};

/** ProgramInvitationsDomainAllowList_MultiUpdate Input */
export type ProgramInvitationsDomainAllowList_MultiUpdateInput = {
  /** List of email domains to be added or updated. */
  emailDomains: Array<Scalars['String']>;
  /** Determines whether updates for existing domains will skipped. */
  insertOnly: Scalars['Boolean'];
  /** Id of the program whose allow list will be updated. */
  programId: Scalars['ID'];
  /** RosterId to be associated with the email domains added or updated. */
  rosterId: Scalars['ID'];
};

/** Input argument for accepting an invitation */
export type ProgramInvitations_AcceptInvitationInput = {
  /** Program invitation ID */
  invitationId: Scalars['ID'];
};

/** Input argument for AddUsersToProgram (AddUsersToProgramRequest in gRPC). Caller identity is taken from the session when not overridden server-side. */
export type ProgramInvitations_AddUsersToProgramInput = {
  /** Invitees to add */
  invitees: Array<ProgramInvitations_AddUsersToProgramInviteeInput>;
  /** Enterprise program ID */
  programId: Scalars['ID'];
  /** Source of the invitation for learner profile update semantics (ProgramInvitationType in gRPC). */
  programInvitationType?: InputMaybe<ProgramInvitations_ProgramInvitationType>;
  /** Optional enterprise roster ID */
  rosterId?: InputMaybe<Scalars['ID']>;
};

/** Input for a single invitee when adding users to a program (ProgramInvitee in gRPC). */
export type ProgramInvitations_AddUsersToProgramInviteeInput = {
  /** Invitee email */
  email: Scalars['String'];
  /** Optional invitee external ID */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Invitee name */
  name: Scalars['String'];
  /** Optional enterprise learner profile standard fields */
  standardFields?: InputMaybe<EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput>;
};

/** Input argument for creating an invitation */
export type ProgramInvitations_CreateInvitationInput = {
  /** Invitee email */
  inviteeEmail: Scalars['String'];
  /** Optional invitee external ID */
  inviteeExternalId?: InputMaybe<Scalars['ID']>;
  /** Invitee name */
  inviteeName: Scalars['String'];
  /** Enterprise program ID */
  programId: Scalars['ID'];
  /** Optional enterprise roster ID */
  rosterId?: InputMaybe<Scalars['ID']>;
};

/** Enum for invitation state */
export const ProgramInvitations_InvitationState = {
  /** Invitation has been accepted */
  Accepted: 'ACCEPTED',
  /** Invitation is active */
  Active: 'ACTIVE',
  /** Invitation is deleted */
  Deleted: 'DELETED'
} as const;

export type ProgramInvitations_InvitationState = typeof ProgramInvitations_InvitationState[keyof typeof ProgramInvitations_InvitationState];
/** Input argument for bulk deleting invitations */
export type ProgramInvitations_MultiDeleteInvitationsInput = {
  /** List of invitation IDs to delete */
  invitationIds: Array<Scalars['ID']>;
};

/** Program invitation creation channel (non-INVALID values of ProgramInvitationType in gRPC). */
export const ProgramInvitations_ProgramInvitationType = {
  /** API flow */
  Api: 'API',
  /** CSV import flow */
  Csv: 'CSV',
  /** SAML-based flow */
  Saml: 'SAML'
} as const;

export type ProgramInvitations_ProgramInvitationType = typeof ProgramInvitations_ProgramInvitationType[keyof typeof ProgramInvitations_ProgramInvitationType];
/** Error codes for per-invitee failure cases in AddUsersToProgram (copy of ProgramInviteeError in gRPC). */
export const ProgramInvitations_ProgramInviteeError = {
  /** Program Invitation already exists for the invitee email */
  ProgramInviteeErrorExistingInvitationForEmail: 'PROGRAM_INVITEE_ERROR_EXISTING_INVITATION_FOR_EMAIL',
  /** Program Invitation already exists for the invitee external ID */
  ProgramInviteeErrorExistingInvitationForExternalId: 'PROGRAM_INVITEE_ERROR_EXISTING_INVITATION_FOR_EXTERNAL_ID',
  /** Program Membership already exists for the invitee email */
  ProgramInviteeErrorExistingMembershipForEmail: 'PROGRAM_INVITEE_ERROR_EXISTING_MEMBERSHIP_FOR_EMAIL',
  /** Program Membership already exists for the invitee external ID */
  ProgramInviteeErrorExistingMembershipForExternalId: 'PROGRAM_INVITEE_ERROR_EXISTING_MEMBERSHIP_FOR_EXTERNAL_ID',
  /** Invalid invitee */
  ProgramInviteeErrorInvalid: 'PROGRAM_INVITEE_ERROR_INVALID',
  /** Invalid invitee email */
  ProgramInviteeErrorInvalidEmail: 'PROGRAM_INVITEE_ERROR_INVALID_EMAIL',
  /** Invalid invitee external ID */
  ProgramInviteeErrorInvalidExternalId: 'PROGRAM_INVITEE_ERROR_INVALID_EXTERNAL_ID',
  /** Invalid invitee full name */
  ProgramInviteeErrorInvalidFullName: 'PROGRAM_INVITEE_ERROR_INVALID_FULL_NAME',
  /** User is managed by SCIM and cannot be invited to the program */
  ProgramInviteeErrorScimManaged: 'PROGRAM_INVITEE_ERROR_SCIM_MANAGED',
  /** Program Invitation unhandled error */
  ProgramInviteeErrorUnhandledError: 'PROGRAM_INVITEE_ERROR_UNHANDLED_ERROR'
} as const;

export type ProgramInvitations_ProgramInviteeError = typeof ProgramInvitations_ProgramInviteeError[keyof typeof ProgramInvitations_ProgramInviteeError];
/** Source of program membership creation */
export const ProgramMembership_CreationSource = {
  /** membership created from auto-acceptance */
  AutoAccepted: 'AUTO_ACCEPTED',
  /** membership created from learner-action */
  LearnerAction: 'LEARNER_ACTION'
} as const;

export type ProgramMembership_CreationSource = typeof ProgramMembership_CreationSource[keyof typeof ProgramMembership_CreationSource];
/** Input for accepting all pending program invitations within an organization. UserId will be picked from the context. */
export type ProgramMembership_JoinAllPendingForOrgInput = {
  /** Organization ID whose pending program invitations should be accepted */
  organizationId: Scalars['ID'];
};

/** Input for Joining the user into the program, UserId will be picked from the context */
export type ProgramMembership_JoinInput = {
  /** Optional Course ID, this will be sent when Program is enrolled when Joining the Course. And it will be used in sending the Notification. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Optional creation_source, this will store the source of program membership creation */
  creationSource?: InputMaybe<ProgramMembership_CreationSource>;
  /** Program ID */
  programId: Scalars['ID'];
};

/** ProgramMembership_Join mutation Error. */
export const ProgramMembership_JoinResultError = {
  /** User is already a member of program */
  AlreadyAMember: 'ALREADY_A_MEMBER',
  /** No active contract is found for the program */
  ContractNotActive: 'CONTRACT_NOT_ACTIVE',
  /** No contract is found for the program */
  ContractNotAvailable: 'CONTRACT_NOT_AVAILABLE',
  /** Error if no available seat is available for the user on the contract */
  CreateMembershipEnrollmentCapLimitError: 'CREATE_MEMBERSHIP_ENROLLMENT_CAP_LIMIT_ERROR',
  /** User limit exceed for the contract, counts unique number of users across all active rosters for the contract. */
  CreateMembershipUserLimitError: 'CREATE_MEMBERSHIP_USER_LIMIT_ERROR',
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** Program state is not a valid state to Join */
  InvalidStateToJoin: 'INVALID_STATE_TO_JOIN',
  /** Membership not found against the programId and userId */
  MembershipNotFound: 'MEMBERSHIP_NOT_FOUND'
} as const;

export type ProgramMembership_JoinResultError = typeof ProgramMembership_JoinResultError[keyof typeof ProgramMembership_JoinResultError];
/** Input for resending the verification email to the user */
export type ProgramMembership_ResendVerificationEmailInput = {
  /** Program membership ID */
  programMembershipId: ProgramMemberships_ProgramMembershipId;
  /** Optional redirectUrl to redirect the user after verification, should start with /program */
  redirectUrl?: InputMaybe<Scalars['String']>;
};

/** ProgramMembership_ResendVerificationEmail mutation Error. */
export const ProgramMembership_ResendVerificationEmailResultError = {
  /** The invitation and/or email is not eligible for verification */
  NotEligibleForVerification: 'NOT_ELIGIBLE_FOR_VERIFICATION'
} as const;

export type ProgramMembership_ResendVerificationEmailResultError = typeof ProgramMembership_ResendVerificationEmailResultError[keyof typeof ProgramMembership_ResendVerificationEmailResultError];
export const ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState = {
  DeletedMember: 'DELETED_MEMBER',
  Invited: 'INVITED',
  InvitedEmailNotVerified: 'INVITED_EMAIL_NOT_VERIFIED',
  Member: 'MEMBER',
  NotMember: 'NOT_MEMBER',
  SoftDeletedMember: 'SOFT_DELETED_MEMBER',
  Whitelisted: 'WHITELISTED'
} as const;

export type ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState = typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState[keyof typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState];
export const ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole = {
  DerivedProgramAdmin: 'DERIVED_PROGRAM_ADMIN',
  Member: 'MEMBER',
  ProgramAdmin: 'PROGRAM_ADMIN'
} as const;

export type ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole = typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole[keyof typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole];
/** Program membership Id is constructed by UserId and ProgramId */
export type ProgramMemberships_ProgramMembershipId = {
  /** TODO: Complete this description */
  programId: Scalars['String'];
  /** TODO: Complete this description */
  userId: Scalars['Int'];
};

export const ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType = {
  Coursera: 'COURSERA',
  Degree: 'DEGREE',
  NotSelected: 'NOT_SELECTED',
  Program: 'PROGRAM'
} as const;

export type ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType = typeof ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType[keyof typeof ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType];
/** coursesRemainingReason model */
export const ProgramUserCredits_CoursesRemainingReason = {
  /** Limit on the number of courses per user specified in the contract */
  ProgramUserCreditsContractCoursesPerUserLimit: 'PROGRAM_USER_CREDITS_CONTRACT_COURSES_PER_USER_LIMIT',
  /** Limit on the number of enrollments */
  ProgramUserCreditsEnrollmentCapLimit: 'PROGRAM_USER_CREDITS_ENROLLMENT_CAP_LIMIT',
  /** Is invalid */
  ProgramUserCreditsInvalid: 'PROGRAM_USER_CREDITS_INVALID',
  /** Limit on the number of courses per user specified by a program */
  ProgramUserCreditsProgramCoursesPerUserLimit: 'PROGRAM_USER_CREDITS_PROGRAM_COURSES_PER_USER_LIMIT'
} as const;

export type ProgramUserCredits_CoursesRemainingReason = typeof ProgramUserCredits_CoursesRemainingReason[keyof typeof ProgramUserCredits_CoursesRemainingReason];
/** Input type to Get and MultiGet queries */
export type ProgramUserCredits_ProgramEnrollmentId = {
  /** Id of program */
  programId: Scalars['String'];
  /** Id of user enrolled in given program */
  userId: Scalars['Int'];
};

/** Programming_CreateAttemptOverride mutation input */
export type Programming_CreateAttemptOverrideInput = {
  /** course id */
  courseId: Scalars['String'];
  /** item id */
  itemId: Scalars['String'];
  /** new max submission limit of the attempt */
  maxSubmissions?: InputMaybe<Scalars['Int']>;
  /** whether to start the attempt immediately */
  startAttemptNow?: InputMaybe<Scalars['Boolean']>;
  /** new time limit of the attempt, unit Second */
  timeLimitSeconds?: InputMaybe<Scalars['Int']>;
  /**
   * user Id, to be more accurate, it should be learner's id here
   * the override is initiated by instructor for one learner
   */
  userId: Scalars['String'];
};

/** Promotion creation */
export type Promotions_CreatePromotionInput = {
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: InputMaybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** The discount amounts */
  discountAmounts?: InputMaybe<Array<MonetaryAmountInput>>;
  /** The discount percent */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** True if this promotion was created for testing */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: InputMaybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: InputMaybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput>>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** List of promotion products */
  promotionProducts?: InputMaybe<Array<Promotions_PromotionProduct>>;
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Promotion user eligible rule creation */
export type Promotions_CreatePromotionUserEligibleRuleInput = {
  /** Determines if the promotion is available for every one. */
  availableForEveryone?: InputMaybe<Scalars['Boolean']>;
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Export code batch CSV input */
export type Promotions_ExportCodeBatchInput = {
  /** The ID of the batch */
  batchId: Scalars['ID'];
};

/** Generate code batch input */
export type Promotions_GenerateCodeBatchInput = {
  /** Optional name for this batch (e.g., "Win back for C+ learners") */
  batchName?: InputMaybe<Scalars['String']>;
  /** Optional prefix for generated codes (e.g., "WINBACK") */
  codePrefix?: InputMaybe<Scalars['String']>;
  /** Number of codes to generate (Max 50,000) */
  codeQuantity: Scalars['Int'];
  /** Optional expiration date (Must be before or equal to promotion.ends_at) */
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Payment Processor ID */
export const Promotions_PaymentProcessorId = {
  /** APPLE_INAPP */
  AppleInapp: 'APPLE_INAPP',
  /** APPLE_INAPP_SANDBOX */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** BRAINTREE */
  Braintree: 'BRAINTREE',
  /** BRAINTREE_SANDBOX */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** COURSERA_MANUAL */
  CourseraManual: 'COURSERA_MANUAL',
  /** EBANX */
  Ebanx: 'EBANX',
  /** EBANX_SANDBOX */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** EMERGENT */
  Emergent: 'EMERGENT',
  /** EMERGENT_SANDBOX */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** FINANCIAL_AID */
  FinancialAid: 'FINANCIAL_AID',
  /** GOOGLE_PLAY */
  GooglePlay: 'GOOGLE_PLAY',
  /** MOCK */
  Mock: 'MOCK',
  /** PAYPAL */
  Paypal: 'PAYPAL',
  /** PAYPAL_SANDBOX */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** RAZORPAY */
  Razorpay: 'RAZORPAY',
  /** RAZORPAY_SANDBOX */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** STRIPE */
  Stripe: 'STRIPE',
  /** STRIPE_BV_CONSUMER */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** STRIPE_BV_CONSUMER_SANDBOX */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** STRIPE_CONSUMER */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** STRIPE_CONSUMER_SANDBOX */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** STRIPE_SANDBOX */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** ZERO_DOLLAR */
  ZeroDollar: 'ZERO_DOLLAR'
} as const;

export type Promotions_PaymentProcessorId = typeof Promotions_PaymentProcessorId[keyof typeof Promotions_PaymentProcessorId];
/** Payment processor ID to payment processor promotion ID map */
export type Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput = {
  /** Payment processor ID */
  paymentProcessorId: Promotions_PaymentProcessorId;
  /** Payment processor promotion ID */
  paymentProcessorPromotionId: Scalars['ID'];
};

/** Product types supported by payment system. */
export const Promotions_ProductType = {
  /** CatalogSubscription */
  CatalogSubscription: 'CatalogSubscription',
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'CourseraPlus',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'CourseraPlusSubscription',
  /** CourseraTierLite */
  CourseraTierLite: 'CourseraTierLite',
  /** CredentialTrack */
  CredentialTrack: 'CredentialTrack',
  /** CredentialTrackCourse */
  CredentialTrackCourse: 'CredentialTrackCourse',
  /**
   * A new version of CredentialTrackCourse that has different revenue recognition and ownership
   * granting logic from the original version.
   */
  CredentialTrackCourseV2: 'CredentialTrackCourseV2',
  /** CredentialTrackSubscription */
  CredentialTrackSubscription: 'CredentialTrackSubscription',
  /**
   * A new version of CredentialTrackSubscription that has different revenue recognition and
   * ownership granting logic from the original version.
   */
  CredentialTrackSubscriptionV2: 'CredentialTrackSubscriptionV2',
  /** EnterpriseContract */
  EnterpriseContract: 'EnterpriseContract',
  /** FacilitatedLearning */
  FacilitatedLearning: 'FacilitatedLearning',
  /** InterestDeposit */
  InterestDeposit: 'InterestDeposit',
  /** SparkCourseShell */
  SparkCourseShell: 'SparkCourseShell',
  /** SparkSpecialization */
  SparkSpecialization: 'SparkSpecialization',
  /** SparkVerifiedCertificate */
  SparkVerifiedCertificate: 'SparkVerifiedCertificate',
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type Promotions_ProductType = typeof Promotions_ProductType[keyof typeof Promotions_ProductType];
/** Promotion product */
export type Promotions_PromotionProduct = {
  /** Product Item ID */
  productItemId?: InputMaybe<Scalars['ID']>;
  /** Product type */
  productType?: InputMaybe<Promotions_ProductType>;
};

/** Promotion types */
export const Promotions_PromotionType = {
  /** CANCELLATION_DEFLECTION */
  CancellationDeflection: 'CANCELLATION_DEFLECTION',
  /** CORPORATE_SPONSORSHIP_DISCOUNT */
  CorporateSponsorshipDiscount: 'CORPORATE_SPONSORSHIP_DISCOUNT',
  /** COURSERA_PLUS_VOUCHER */
  CourseraPlusVoucher: 'COURSERA_PLUS_VOUCHER',
  /** COURSE_MIGRATED */
  CourseMigrated: 'COURSE_MIGRATED',
  /** COURSE_WITH_FULL_DISCOUNT_VOUCHER */
  CourseWithFullDiscountVoucher: 'COURSE_WITH_FULL_DISCOUNT_VOUCHER',
  /** DEGREE_ENROLLMENT_VOUCHER */
  DegreeEnrollmentVoucher: 'DEGREE_ENROLLMENT_VOUCHER',
  /** ENTERPRISE_CONTRACT */
  EnterpriseContract: 'ENTERPRISE_CONTRACT',
  /** EXTERNAL_DISCOUNT */
  ExternalDiscount: 'EXTERNAL_DISCOUNT',
  /** FINANCIAL_AID_CEILING_DISCOUNT */
  FinancialAidCeilingDiscount: 'FINANCIAL_AID_CEILING_DISCOUNT',
  /** GROUPS_DISCOUNT */
  GroupsDiscount: 'GROUPS_DISCOUNT',
  /** INTERNAL_PROMOTIONAL_DISCOUNT */
  InternalPromotionalDiscount: 'INTERNAL_PROMOTIONAL_DISCOUNT',
  /** MANUAL_DISCOUNT */
  ManualDiscount: 'MANUAL_DISCOUNT',
  /** S12N_BULK_PAY_DISCOUNT */
  S12NBulkPayDiscount: 'S12N_BULK_PAY_DISCOUNT',
  /** SPARK_DISCOUNT_VOUCHER */
  SparkDiscountVoucher: 'SPARK_DISCOUNT_VOUCHER',
  /** SPARK_REFUND_VOUCHER */
  SparkRefundVoucher: 'SPARK_REFUND_VOUCHER',
  /** SPARK_S12N_BULK_PAY */
  SparkS12NBulkPay: 'SPARK_S12N_BULK_PAY',
  /** SUBSCRIPTION_CHECKOUT_DISCOUNT */
  SubscriptionCheckoutDiscount: 'SUBSCRIPTION_CHECKOUT_DISCOUNT'
} as const;

export type Promotions_PromotionType = typeof Promotions_PromotionType[keyof typeof Promotions_PromotionType];
/** Promotion Update */
export type Promotions_UpdatePromotionInput = {
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: InputMaybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** The discount amounts */
  discountAmounts?: InputMaybe<Array<MonetaryAmountInput>>;
  /** The discount percent */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** True if this promotion was created for testing */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: InputMaybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: InputMaybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput>>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Promotion user eligible rule update */
export type Promotions_UpdatePromotionUserEligibleRuleInput = {
  /** Determines if the promotion is available for every one. */
  availableForEveryone?: Scalars['Boolean'];
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Input for UpdateQualificationSurveyExperiment */
export type QualificationSurveyExperiment_DeleteQualificationSurveyExperimentInput = {
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input Model for a Qualification Survey Experiment. */
export type QualificationSurveyExperiment_QualificationSurveyExperimentInput = {
  /** The default value used in the experiment. */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** The namespace of an experiment variant. */
  epicNamespace?: InputMaybe<Scalars['String']>;
  /** The parameters used in the namespace. */
  epicParameter?: InputMaybe<Scalars['String']>;
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input for UpdateQualificationSurveyExperiment */
export type QualificationSurveyExperiment_UpdateQualificationSurveyExperimentInput = {
  /** qualificationSurveyExperiment to be update. */
  qualificationSurveyExperiment: QualificationSurveyExperiment_QualificationSurveyExperimentInput;
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input model for checkbox question response. */
export type QualificationSurveySectionResponse_CheckboxResponseInput = {
  /** ids */
  ids: Array<Scalars['ID']>;
  /** otherText */
  otherText?: InputMaybe<Scalars['String']>;
};

/** Input for QualificationSurveySectionResponse_CreateOrUpdate */
export type QualificationSurveySectionResponse_CreateOrUpdateInput = {
  /** The product id */
  productId: Scalars['ID'];
  /** qualification_survey_response_id field is optional for new survey responses. It needs to be provided if you want to update an existing survey response. */
  qualificationSurveyResponseId?: InputMaybe<Scalars['ID']>;
  /** QualificationSurveySectionResponse to be update. */
  sectionResponse: QualificationSurveySectionResponse_SectionResponseInput;
};

/** Input for QualificationSurveySectionResponse_DeleteByResponseIdsInput */
export type QualificationSurveySectionResponse_DeleteByResponseIdsInput = {
  /** surveyResponseIds */
  surveyResponseIds: Array<Scalars['ID']>;
};

/** Input model for dropdown question response. */
export type QualificationSurveySectionResponse_DropdownResponseInput = {
  /** Response id */
  id: Scalars['ID'];
};

/** Model for expression of interest context. */
export type QualificationSurveySectionResponse_ExpressionOfInterestContextInput = {
  /**
   * Identifies the campaign and/or other attributes of the click associated with the EOI
   * This field is optional.
   */
  clickId?: InputMaybe<Scalars['ID']>;
  /**
   * Identifies the country where the Expression Of Interest is being submitted.
   * This field is optional.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * word to identify the source location of the EOI.
   * e.g. 'LinkedIn' indicate EOIs collected from off-platform sources LinkedIn,
   * and 'DDP' or 'DLP' for on-platform EOIs.
   * This field is optional.
   */
  responseSource?: InputMaybe<Scalars['String']>;
  /** Full URL of the source DDP or DLP. */
  source: Scalars['URL'];
  /** utmParameters */
  utmParameters: QualificationSurveySectionResponse_UtmParameters;
};

/** Input model for multiple choice question response. */
export type QualificationSurveySectionResponse_MultipleChoiceResponseInput = {
  /** Multiple Choice Response ID */
  id: Scalars['ID'];
};

/** Input model for numeric question response. */
export type QualificationSurveySectionResponse_NumericResponseInput = {
  /** Numeric Response */
  response: Scalars['Float'];
};

/** Input for QualificationSurveySectionResponse_RetrieveCompletedQualificationSurveyInput */
export type QualificationSurveySectionResponse_RetrieveCompletedQualificationSurveyInput = {
  /** EOI context */
  eoiContext?: InputMaybe<QualificationSurveySectionResponse_ExpressionOfInterestContextInput>;
  /** The lookback period in months */
  lookBackPeriodInMonths?: Scalars['Int'];
  /** The product id */
  productId: Scalars['ID'];
};

/** Model for survey section response input. */
export type QualificationSurveySectionResponse_SectionResponseInput = {
  /** EOI context */
  eoiContext?: InputMaybe<QualificationSurveySectionResponse_ExpressionOfInterestContextInput>;
  /** question_response_map */
  responses: Array<QualificationSurveySectionResponse_SurveyQuestionResponseMapInput>;
  /** section_id for response */
  sectionId: Scalars['ID'];
  /**
   * Used to allow FE to include any additional data not related to the survey response.
   * For example: tracking, debugging, one-off partner requests for forwarding certain
   * fields (i.e. google analytic client IDs) etc.
   */
  trackingFields: Array<QualificationSurveySectionResponse_TrackingFieldsInput>;
};

/** Input model for short answer question response. */
export type QualificationSurveySectionResponse_ShortAnswerResponseInput = {
  /** Text Response */
  text: Scalars['String'];
};

/** Model for QualificationSurveySectionResponse_SurveyQuestionResponseMapInput. */
export type QualificationSurveySectionResponse_SurveyQuestionResponseMapInput = {
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map key. */
  surveyQuestionResponseKey: Scalars['String'];
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map value. */
  surveyQuestionResponseValue: QualificationSurveySectionResponse_SurveyQuestionResponseUnion;
};

/** Input models for survey question response. */
export type QualificationSurveySectionResponse_SurveyQuestionResponseUnion = {
  /** checkboxResponse */
  checkboxResponse?: InputMaybe<QualificationSurveySectionResponse_CheckboxResponseInput>;
  /** dropdownResponse */
  dropdownResponse?: InputMaybe<QualificationSurveySectionResponse_DropdownResponseInput>;
  /** multipleChoiceResponse */
  multipleChoiceResponse?: InputMaybe<QualificationSurveySectionResponse_MultipleChoiceResponseInput>;
  /** numericResponse */
  numericResponse?: InputMaybe<QualificationSurveySectionResponse_NumericResponseInput>;
  /** shortAnswerResponse */
  shortAnswerResponse?: InputMaybe<QualificationSurveySectionResponse_ShortAnswerResponseInput>;
  /** typeaheadResponse */
  typeaheadResponse?: InputMaybe<QualificationSurveySectionResponse_TypeaheadResponseInput>;
};

/** Input model for QualificationSurveySectionResponse_TrackingFieldsInput. */
export type QualificationSurveySectionResponse_TrackingFieldsInput = {
  /** QualificationSurveySectionResponse_TrackingFields Map key. */
  trackingFieldsKey: Scalars['String'];
  /** QualificationSurveySectionResponse_TrackingFields Map value. */
  trackingFieldsValue: Scalars['String'];
};

/** Input model for typeahead question response. */
export type QualificationSurveySectionResponse_TypeaheadResponseInput = {
  /** id */
  id?: InputMaybe<Scalars['ID']>;
  /** otherText */
  otherText?: InputMaybe<Scalars['String']>;
};

/** Model for UTM parameters. */
export type QualificationSurveySectionResponse_UtmParameters = {
  /**
   * Identifies a specific product promotion or strategic campaign. e.g utm_campaign=spring_sale.
   * This field is optional.
   */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /**
   * Identifies what specifically was clicked to bring the user to the site,
   * such as a banner ad or a text link. e.g utm_content=logolink or utm_content=textlink.
   * This field is optional.
   */
  utmContent?: InputMaybe<Scalars['String']>;
  /**
   * Identifies what type of link was used, such as cost per click or email. e.g utm_medium=cpc.
   * This field is optional.
   */
  utmMedium?: InputMaybe<Scalars['String']>;
  /**
   * Identifies which site sent the traffic, and is a required parameter. e.g utm_source=google.
   * This field is optional.
   */
  utmSource?: InputMaybe<Scalars['String']>;
  /**
   * Identifies search terms. e.g utm_term=running+shoes.
   * This field is optional.
   */
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** Model for AllConditionsValidTransition. */
export type QualificationSurvey_AllConditionsValidTransitionInput = {
  /** condition for AllConditionsValidTransition. */
  conditions: Array<QualificationSurvey_TransitionConditionInput>;
  /** destination for AllConditionsValidTransition. */
  destination: Scalars['String'];
};

/** Model for any TransitionConditions. */
export type QualificationSurvey_AnyConditionsValidTransitionInput = {
  /** condition for any TransitionConditions. */
  conditions: Array<QualificationSurvey_TransitionConditionInput>;
  /** destination for any TransitionConditions. */
  destination: Scalars['String'];
};

/** Model for QualificationSurvey_CheckboxContent. */
export type QualificationSurvey_CheckboxContentInput = {
  /** helpText for QualificationSurvey_CheckboxContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_CheckboxContent. */
  includeOther?: InputMaybe<Scalars['Boolean']>;
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_CheckboxContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** placeholderForOther for QualificationSurvey_CheckboxContent. */
  placeholderForOther?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_CheckboxContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_ChoiceAnswerOption. */
export type QualificationSurvey_ChoiceAnswerOptionInput = {
  /** id for QualificationSurvey_ChoiceAnswerOption. */
  id: Scalars['ID'];
  /** text for QualificationSurvey_ChoiceAnswerOption. */
  text: Scalars['String'];
};

/** Model to represent a course recommendation in the terminal section. */
export type QualificationSurvey_CourseRecommendationInput = {
  /** course ID of QualificationSurveyCourseRecommendation */
  courseId: Scalars['ID'];
};

/** Model for new qualificationSurvey to create. */
export type QualificationSurvey_CreateQualificationSurveyInput = {
  /** QualificationSurvey configuration excluding the associated Survey. */
  qualificationSurveyCommon: QualificationSurvey_QualificationSurveyCommonInput;
  /**
   * SectionId to section title map. Will be used to populate the title in Survey.sections
   * Used only if survey is of standard type i.e. phone or 1-click
   */
  sectionIdToSectionTitle?: InputMaybe<Array<QualificationSurvey_SectionIdTitleMapInput>>;
  /** Used only if survey is of non-standard type. */
  survey?: InputMaybe<QualificationSurvey_SurveyInput>;
  /**
   *  A way to categorize surveys, mostly for analytics purposes.
   *  For standard EOI's, the surveyFamilyOverride will be used to lookup a matching
   * [[QualificationSurveyTemplate]] which will be used to create a Survey.
   * For non-standard EOI's, the surveyFamilyOverride will be used to set the surveyFamily in the created Survey.
   */
  surveyFamilyOverride: Scalars['String'];
  /** Used only if survey is of standard type i.e. phone or 1-click. */
  surveyName?: InputMaybe<Scalars['String']>;
};

/** Model for a QualificationSurvey_DropdownContent. */
export type QualificationSurvey_DropdownContentInput = {
  /** helpText for a QualificationSurvey_DropdownContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** QualificationSurvey_ChoiceAnswerOption for a QualificationSurvey_DropdownContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** Text to display before the user has selected an option. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for a QualificationSurvey_DropdownContent. */
  prompt: Scalars['String'];
};

/** Model for DynamicQualificationSurvey_ChoiceAnswerOptions. */
export type QualificationSurvey_DynamicChoiceAnswerOptionsInput = {
  /** Human-readable name/description to help understand where the dynamic choices come from (e.g. comes from an API). */
  name: Scalars['String'];
};

/** Model for email address and recipient name. */
export type QualificationSurvey_EmailAddressInput = {
  /** Full email address. */
  address: Scalars['String'];
  /** Recipient  name of email address. */
  name: Scalars['String'];
};

/** QualificationSurvey EmailValidation */
export type QualificationSurvey_EmailValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Model for Leads Configuration.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_LeadsConfigurationInput = {
  /** configuration for zapier. */
  zapierConfiguration?: InputMaybe<QualificationSurvey_ZapierConfigurationInput>;
};

/** Model for sending email after survey submission. */
export type QualificationSurvey_MailSpinEmailActionInput = {
  /** Email address for who send confirmation email */
  from?: InputMaybe<QualificationSurvey_EmailAddressInput>;
  /** MailSpinTemplateId for survey submission */
  mailSpinTemplateId: Scalars['ID'];
  /** Email address for reply to the survey submission */
  replyTo?: InputMaybe<QualificationSurvey_EmailAddressInput>;
};

/** Model for QualificationSurvey_MultipleChoiceContent. */
export type QualificationSurvey_MultipleChoiceContentInput = {
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_MultipleChoiceContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** prompt for QualificationSurvey_MultipleChoiceContent. */
  prompt: Scalars['String'];
};

/** QualificationSurvey NameValidation */
export type QualificationSurvey_NameValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Model for QualificationSurvey_NumericAnswerOption. */
export type QualificationSurvey_NumericAnswerOptionInput = {
  /** AnswerOptionId id for QualificationSurvey_NumericAnswerOption. */
  id: Scalars['ID'];
  /** lowerBound for QualificationSurvey_NumericAnswerOption. */
  lowerBound?: InputMaybe<Scalars['Float']>;
  /** lowerBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  lowerBoundInclusive?: Scalars['Boolean'];
  /** upperBound for QualificationSurvey_NumericAnswerOption. */
  upperBound?: InputMaybe<Scalars['Float']>;
  /** upperBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  upperBoundInclusive?: Scalars['Boolean'];
};

/** Model for QualificationSurvey_NumericAnswerValidation. */
export type QualificationSurvey_NumericAnswerValidationInput = {
  /** numericRangeValidation. */
  numericRangeValidation?: InputMaybe<QualificationSurvey_NumericRangeValidationInput>;
};

/** Model for QualificationSurvey_NumericContent. */
export type QualificationSurvey_NumericContentInput = {
  /** QualificationSurvey_NumericAnswerOption list for QualificationSurvey_NumericContent. */
  options: Array<QualificationSurvey_NumericAnswerOptionInput>;
  /** Text to display when the user has not entered any input. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_NumericContent. */
  prompt: Scalars['String'];
  /** QualificationSurvey_NumericAnswerValidation list for QualificationSurvey_NumericContent. */
  validations?: InputMaybe<Array<QualificationSurvey_NumericAnswerValidationInput>>;
};

/** Model for NumericRangeValidation. */
export type QualificationSurvey_NumericRangeValidationInput = {
  /** lowerBound for NumericRangeValidation. */
  lowerBound?: InputMaybe<Scalars['Float']>;
  /** lowerBoundInclusive for NumericRangeValidation. */
  lowerBoundInclusive?: Scalars['Boolean'];
  /** upperBound for NumericRangeValidation. */
  upperBound?: InputMaybe<Scalars['Float']>;
  /** upperBoundInclusive for NumericRangeValidation. */
  upperBoundInclusive?: Scalars['Boolean'];
};

/** QualificationSurvey PhoneValidation */
export type QualificationSurvey_PhoneValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** QualificationSurvey configuration excluding the associated Survey. */
export type QualificationSurvey_QualificationSurveyCommonInput = {
  /** archived of qualification survey. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** consentMessage of qualification survey. */
  consentMessage?: InputMaybe<CmlContentInput>;
  /** leadsConfiguration of qualification survey. */
  leadsConfiguration?: InputMaybe<QualificationSurvey_LeadsConfigurationInput>;
  /** product Id of qualification survey. */
  productId: Scalars['ID'];
  /** TerminalActionListMapping of qualification survey. */
  terminalActions: Array<QualificationSurvey_TerminalActionListMappingInput>;
  /** TerminalSectionMapping of qualification survey. */
  terminalSections: Array<QualificationSurvey_TerminalSectionMappingInput>;
};

/** Model for a Qualification Survey Input. */
export type QualificationSurvey_QualificationSurveyObjectInput = {
  /** QualificationSurvey configuration excluding the associated Survey. */
  qualification_survey_common: QualificationSurvey_QualificationSurveyCommonInput;
  /** Associated Survey for qualificationSurvey. */
  survey: QualificationSurvey_SurveyInput;
};

/** Model for a QualificationSurvey_QuestionContent. */
export type QualificationSurvey_QuestionContentInput = {
  /** checkboxContent */
  checkboxContent?: InputMaybe<QualificationSurvey_CheckboxContentInput>;
  /** dropdownContent */
  dropdownContent?: InputMaybe<QualificationSurvey_DropdownContentInput>;
  /** multipleChoiceContent */
  multipleChoiceContent?: InputMaybe<QualificationSurvey_MultipleChoiceContentInput>;
  /** numericContent */
  numericContent?: InputMaybe<QualificationSurvey_NumericContentInput>;
  /** shortAnswerContent */
  shortAnswerContent?: InputMaybe<QualificationSurvey_ShortAnswerContentInput>;
  /** typeaheadContent */
  typeaheadContent?: InputMaybe<QualificationSurvey_TypeaheadContentInput>;
};

/** Model for a QuestionGroup. */
export type QualificationSurvey_QuestionGroupInput = {
  /** selectKQuestionGroup */
  selectKQuestionGroup?: InputMaybe<QualificationSurvey_SelectKQuestionGroupInput>;
  /** singleQuestionGroup */
  singleQuestionGroup?: InputMaybe<QualificationSurvey_SingleQuestionGroupInput>;
};

/** Model for QuestionSectionDefinition. */
export type QualificationSurvey_QuestionSectionDefinitionInput = {
  /** DefaultDestination for QuestionSectionDefinition. */
  defaultDestination: Scalars['String'];
  /** NextMessage for QuestionSectionDefinition. */
  nextMessage?: InputMaybe<Scalars['String']>;
  /** Question Groups for QuestionSectionDefinition. */
  questionGroups: Array<QualificationSurvey_QuestionGroupInput>;
  /** transitions for QuestionSectionDefinition. */
  transitions: Array<QualificationSurvey_TransitionInput>;
};

/** Model for a RandomTransition. */
export type QualificationSurvey_RandomTransitionInput = {
  /** List of possible Destinations for RandomTransition. */
  possibleDestinations: Array<Scalars['String']>;
};

/**
 * Model to represent a recommendation in the terminal section.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_RecommendationInput = {
  /** represent a s12n recommendation in the terminal section. */
  QualificationSurveyS12nRecommendation?: InputMaybe<QualificationSurvey_S12nRecommendationInput>;
  /** represent a course recommendation in the terminal section. */
  qualificationSurveyCourseRecommendation?: InputMaybe<QualificationSurvey_CourseRecommendationInput>;
};

/** Model to represent a s12n recommendation in the terminal section. */
export type QualificationSurvey_S12nRecommendationInput = {
  /** S12nId id of QualificationSurveyS12nRecommendation. */
  S12nId: Scalars['ID'];
};

/** type for SectionDefinition */
export type QualificationSurvey_SectionDefinitionInput = {
  /** questionSectionDefinition. */
  questionSectionDefinition?: InputMaybe<QualificationSurvey_QuestionSectionDefinitionInput>;
  /** terminal Definition. */
  terminalDefinition?: InputMaybe<QualificationSurvey_TerminalDefinitionInput>;
};

/** Model for QualificationSurvey_SectionIdTitleMapInput */
export type QualificationSurvey_SectionIdTitleMapInput = {
  /** SectionId of Survey section title */
  sectionId: Scalars['ID'];
  /** title used in Survey.sections if survey is of standard type i.e. phone or 1-click */
  value: Scalars['String'];
};

/** Model for selecting multiple QuestionGroups. */
export type QualificationSurvey_SelectKQuestionGroupInput = {
  /** numberOfQuestionsToShow for selecting multiple QuestionGroups. */
  numberOfQuestionsToShow: Scalars['Int'];
  /** QuestionId list for selecting multiple QuestionGroups. */
  questionIds: Array<Scalars['ID']>;
};

/** Model for QualificationSurvey_ShortAnswerAnswerOption. */
export type QualificationSurvey_ShortAnswerAnswerOptionInput = {
  /** Answer for QualificationSurvey_ShortAnswerAnswerOption. */
  answer: Scalars['String'];
  /** id for QualificationSurvey_ShortAnswerAnswerOption. */
  id: Scalars['ID'];
};

/** Model for ShotAnswerContent. */
export type QualificationSurvey_ShortAnswerContentInput = {
  /** Matching conditions for associating an option id with a response. */
  options: Array<QualificationSurvey_ShortAnswerAnswerOptionInput>;
  /** Text to display when the user has not entered any input. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for ShotAnswerContent. */
  prompt: Scalars['String'];
  /** validations need to be done for QualificationSurvey_ShortAnswerContent. */
  validations?: InputMaybe<Array<QualificationSurvey_ShortAnswerValidationInput>>;
};

/** Model for QualificationSurvey_ShortAnswerValidation. */
export type QualificationSurvey_ShortAnswerValidationInput = {
  /** emailValidation. */
  emailValidation?: InputMaybe<QualificationSurvey_EmailValidationInput>;
  /** nameValidation. */
  nameValidation?: InputMaybe<QualificationSurvey_NameValidationInput>;
  /** phoneValidation. */
  phoneValidation?: InputMaybe<QualificationSurvey_PhoneValidationInput>;
  /** textLengthValidation. */
  textLengthValidation?: InputMaybe<QualificationSurvey_TextLengthValidationInput>;
  /** urlValidation. */
  urlValidation?: InputMaybe<QualificationSurvey_UrlValidationInput>;
};

/** Model for a SingleQuestionGroup. */
export type QualificationSurvey_SingleQuestionGroupInput = {
  /** QuestionId for a SingleQuestionGroup. */
  questionId: Scalars['ID'];
};

/** Model for associate Survey for Qualification Survey. */
export type QualificationSurvey_SurveyInput = {
  /** all for Survey. */
  all?: Scalars['String'];
  /** allowSectionResponseEdits for Survey. */
  allowSectionResponseEdits?: Scalars['Boolean'];
  /** createdAt for Survey. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** maxResponses for Survey. */
  maxResponses?: InputMaybe<Scalars['Int']>;
  /** name for Survey. */
  name?: InputMaybe<Scalars['String']>;
  /** questions for Survey. */
  questions: Array<QualificationSurvey_SurveyQuestionInput>;
  /** restartFromSavedResponses for Survey. */
  restartFromSavedResponses?: Scalars['Boolean'];
  /** Section Maps for Survey. */
  sections: Array<QualificationSurvey_SurveySectionMappingInput>;
  /** Section id for Survey start. */
  startSection: Scalars['String'];
  /** surveyFamily for Survey. */
  surveyFamily?: InputMaybe<Scalars['String']>;
};

/** Model for QualificationSurvey_SurveyQuestion configurations. */
export type QualificationSurvey_SurveyQuestionConfigurationInput = {
  /** QualificationSurvey_SurveyQuestionConfiguration Map key. */
  surveyQuestionConfigurationKey?: InputMaybe<Scalars['String']>;
  /** QualificationSurvey_SurveyQuestionConfiguration Map value. */
  surveyQuestionConfigurationValue?: InputMaybe<Scalars['String']>;
};

/** Model for a QualificationSurvey_SurveyQuestion. */
export type QualificationSurvey_SurveyQuestionInput = {
  /** Map for question configuration. */
  configurations?: InputMaybe<Array<QualificationSurvey_SurveyQuestionConfigurationInput>>;
  /** Question Contents for survey question. */
  content: QualificationSurvey_QuestionContentInput;
  /** QuestionId for survey question. */
  id: Scalars['ID'];
  /** Set this question is required or not. */
  isRequired: Scalars['Boolean'];
};

/** Model for survey section. */
export type QualificationSurvey_SurveySectionInput = {
  /** section Definition. */
  definition: QualificationSurvey_SectionDefinitionInput;
  /** Section descriptions. */
  description?: InputMaybe<Scalars['String']>;
  /** section title. */
  title: Scalars['String'];
};

/** Model for survey Section Map. */
export type QualificationSurvey_SurveySectionMappingInput = {
  /** value for survey Section Map. */
  section: QualificationSurvey_SurveySectionInput;
  /** Key for for survey Section Map. */
  sectionKey: Scalars['String'];
};

/**
 * Actions after survey submission.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_TerminalActionInput = {
  /** mailSpinEmailAction for survey terminalAction. */
  mailSpinEmailAction?: InputMaybe<QualificationSurvey_MailSpinEmailActionInput>;
};

/** action lists after survey submission. */
export type QualificationSurvey_TerminalActionListInput = {
  /** List of actions for survey submission. */
  actions: Array<QualificationSurvey_TerminalActionInput>;
};

/** TerminalActionListMapping after survey submission. */
export type QualificationSurvey_TerminalActionListMappingInput = {
  /** value of TerminalActionListMapping after survey submission. */
  terminalActionList: QualificationSurvey_TerminalActionListInput;
  /** key of TerminalActionListMapping after survey submission. */
  terminalActionListKey: Scalars['String'];
};

/** Model for QualificationSurvey_TerminalDefinition. */
export type QualificationSurvey_TerminalDefinitionInput = {
  /** Dummy field whose value is unused. GraphQL requires input to have at least one field. */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Model to represent message at end of survey. */
export type QualificationSurvey_TerminalSectionInput = {
  /** applyLink of QualificationSurveyTerminalSection. */
  applyLink?: InputMaybe<Scalars['String']>;
  /** CmlContent body of QualificationSurvey_TerminalSection. */
  body: CmlContentInput;
  /** brochureLink of QualificationSurveyTerminalSection. */
  brochureLink?: InputMaybe<Scalars['String']>;
  /** inviteToGroup of QualificationSurveyTerminalSection. */
  inviteToGroup?: InputMaybe<Scalars['Boolean']>;
  /** QualificationSurveyRecommendation of QualificationSurveyTerminalSection. */
  recommendations?: InputMaybe<Array<QualificationSurvey_RecommendationInput>>;
  /** title of QualificationSurvey_TerminalSection. */
  title: Scalars['String'];
};

/** TerminalSectionMapping of qualification survey. */
export type QualificationSurvey_TerminalSectionMappingInput = {
  /** terminalSection of TerminalSectionMapping */
  terminalSection: QualificationSurvey_TerminalSectionInput;
  /** key of TerminalSectionMapping */
  terminalSectionKey: Scalars['String'];
};

/** For text length validation. */
export type QualificationSurvey_TextLengthValidationInput = {
  /** text length validation for lower-bound. */
  lowerBound?: InputMaybe<Scalars['Int']>;
  /** text length validation for upper bound. */
  upperBound?: InputMaybe<Scalars['Int']>;
};

/** Model for a TransitionCondition. */
export type QualificationSurvey_TransitionConditionInput = {
  /** answerOptionId for a TransitionCondition. */
  answerOptionId: Scalars['ID'];
  /** questionId for a TransitionCondition. */
  questionId: Scalars['ID'];
};

/** Model for QualificationSurvey Transition */
export type QualificationSurvey_TransitionInput = {
  /** allConditionsValidTransition */
  allConditionsValidTransition?: InputMaybe<QualificationSurvey_AllConditionsValidTransitionInput>;
  /** anyConditionsValidTransition */
  anyConditionsValidTransition?: InputMaybe<QualificationSurvey_AnyConditionsValidTransitionInput>;
  /** randomTransition */
  randomTransition?: InputMaybe<QualificationSurvey_RandomTransitionInput>;
};

/** Model for QualificationSurvey_TypeaheadContent. */
export type QualificationSurvey_TypeaheadContentInput = {
  /**
   * If this question content is configured with dynamic options, then options can be fetched
   * from some other source before being displayed to the user, instead of from the `options` field.
   * This field is optional.
   */
  dynamicOptions?: InputMaybe<QualificationSurvey_DynamicChoiceAnswerOptionsInput>;
  /** helpText for QualificationSurvey_TypeaheadContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_TypeaheadContent. */
  includeOther?: Scalars['Boolean'];
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_TypeaheadContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** Text to display before the user has selected an option. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_TypeaheadContent. */
  prompt: Scalars['String'];
};

/** new qualificationSurvey to update. */
export type QualificationSurvey_UpdateQualificationSurveyInput = {
  /** qualificationSurveyId of this updated survey. */
  qualificationSurveyId: Scalars['ID'];
  /** body of update qualification survey. */
  qualification_survey: QualificationSurvey_QualificationSurveyObjectInput;
};

/** QualificationSurvey UrlValidation */
export type QualificationSurvey_UrlValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Model for Zapier Configuration. */
export type QualificationSurvey_ZapierConfigurationInput = {
  /** webhookUrl for Zapier configuration */
  webhookUrl: Scalars['URL'];
};

/** An input reference to an atom. */
export type QualityCoach_AtomReferenceInput = {
  /** The atom ID. */
  atomId: Scalars['ID'];
  /** The atom type. */
  atomType: QualityCoach_AtomType;
  /**
   * Whether this entity is a draft or a published version. Drafts of atoms are not connected to a
   * version.
   */
  atomVersion: QualityCoach_AtomStatusOrVersionInput;
};

/** Placeholder to indicate that the atom is a draft */
export const QualityCoach_AtomStatus = {
  /** Get atom draft */
  Draft: 'DRAFT',
  /** Get latest published atom */
  LatestPublished: 'LATEST_PUBLISHED'
} as const;

export type QualityCoach_AtomStatus = typeof QualityCoach_AtomStatus[keyof typeof QualityCoach_AtomStatus];
/** Status of an atom, it should either have a version or be a draft (never both) */
export type QualityCoach_AtomStatusOrVersionInput = {
  /** Get the atom by status (draft or latest published) */
  status?: InputMaybe<QualityCoach_AtomStatus>;
  /** Indicates that the atom is published and provides the version of the published atom */
  version?: InputMaybe<Scalars['Int']>;
};

/** Types of atoms that can be reviewed for adherence to best practices by the quality coach system. */
export const QualityCoach_AtomType = {
  /** A reading item. */
  ReadingItem: 'READING_ITEM'
} as const;

export type QualityCoach_AtomType = typeof QualityCoach_AtomType[keyof typeof QualityCoach_AtomType];
/** A reference to a course branch that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseBranchReferenceInput = {
  /** The id of the branch. */
  authoringBranchId: Scalars['ID'];
};

/** A reference to a course that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseReferenceInput = {
  /** The id of the course. */
  courseId: Scalars['ID'];
};

/** Input to create a new quality rule. */
export type QualityCoach_CreateQualityRuleInput = {
  /** LLM configuration instructs the LLM system on how to evaluate the rule. */
  llmConfiguration?: InputMaybe<QualityCoach_RuleLlmConfigurationInput>;
  /** Rerun configuration instructs the orchestration system on when to rerun the rule. */
  rerunConfiguration: Array<QualityCoach_RuleRerunConfigurationType>;
  /** Descriptions of the rule in a human- and LLM-readable format. */
  ruleDescription: QualityCoach_RuleDescriptionInput;
  /** Filters define the conditions under which the rule is applicable. */
  ruleFilters: Array<QualityCoach_RuleFilterInput>;
  /** The weight of the rule in the overall score. */
  weight: Scalars['Float'];
};

/** Input to delete an existing quality rule. */
export type QualityCoach_DeleteQualityRuleInput = {
  /** The id of the rule. */
  id: Scalars['ID'];
};

/** Input to initiate a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntityInput = {
  /** If true, the quality review will be created even if there is an existing and still valid quality review. */
  forceNewQualityReview?: InputMaybe<Scalars['Boolean']>;
  /** The reviewable entity to review. */
  reviewableEntity: QualityCoach_ReviewableEntityReferenceInput;
};

/** Instruct the LLM on how to output the results of the rule, whether single result or issue list. */
export const QualityCoach_IssueOutputStyleType = {
  /** The LLM should output a review result with a list of issues for the rule. */
  IssueList: 'ISSUE_LIST',
  /** The LLM should output a single review result with an empty issue list for the rule. */
  SingleResult: 'SINGLE_RESULT'
} as const;

export type QualityCoach_IssueOutputStyleType = typeof QualityCoach_IssueOutputStyleType[keyof typeof QualityCoach_IssueOutputStyleType];
/** Instruct the LLM on how to output the results of the rule. */
export const QualityCoach_LlmOutputStyleType = {
  /** The LLM should output a plain text recommendation to address the rule violation. */
  PlainText: 'PLAIN_TEXT'
} as const;

export type QualityCoach_LlmOutputStyleType = typeof QualityCoach_LlmOutputStyleType[keyof typeof QualityCoach_LlmOutputStyleType];
/** How the quality review was initiated. */
export const QualityCoach_QualityReviewInitiationType = {
  /** The quality review was initiated manually. */
  Manual: 'MANUAL',
  /** The quality review was initiated on entity change. */
  OnEntityChange: 'ON_ENTITY_CHANGE'
} as const;

export type QualityCoach_QualityReviewInitiationType = typeof QualityCoach_QualityReviewInitiationType[keyof typeof QualityCoach_QualityReviewInitiationType];
/** Status of the quality review. */
export const QualityCoach_QualityReviewStatus = {
  /** The quality review is complete. */
  Complete: 'COMPLETE',
  /** The quality review completed in error */
  Failed: 'FAILED',
  /** The quality review is in progress. */
  InProgress: 'IN_PROGRESS'
} as const;

export type QualityCoach_QualityReviewStatus = typeof QualityCoach_QualityReviewStatus[keyof typeof QualityCoach_QualityReviewStatus];
/** Input to query quality reviews for an entity. */
export type QualityCoach_QueryQualityReviewsByEntityInput = {
  /** How to filter reviews by completion status. */
  completionFilter?: Array<QualityCoach_QualityReviewStatus>;
  /** Entity to look up quality reviews for. */
  entity: QualityCoach_ReviewableEntityReferenceInput;
  /** How to filter results by severity level. */
  severityFilter?: Array<QualityCoach_ScoreSeverity>;
};

/** Input for an entity that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_ReviewableEntityReferenceInput = {
  /**
   * The id of the entity that can be reviewed.
   * @deprecated Use the entityReference field instead
   */
  entityId?: InputMaybe<Scalars['ID']>;
  /** The typed entity reference. */
  entityReference?: InputMaybe<QualityCoach_TypedReviewableEntityReferenceInput>;
  /**
   * The type of the entity that can be reviewed.
   * @deprecated Use the entityReference field instead
   */
  entityType?: InputMaybe<QualityCoach_ReviewableEntityReferenceType>;
  /**
   * The version of the entity, for entities that support versioning.
   * @deprecated Use the entityReference field instead
   */
  entityVersion?: InputMaybe<Scalars['ID']>;
};

/** Types of entities that are supported for reviewing for adherence to best practices by the quality coach system. */
export const QualityCoach_ReviewableEntityReferenceType = {
  /** An atom entity. */
  ReviewableEntityAtom: 'REVIEWABLE_ENTITY_ATOM',
  /** A course entity. */
  ReviewableEntityCourse: 'REVIEWABLE_ENTITY_COURSE',
  /** A course branch entity. */
  ReviewableEntityCourseBranch: 'REVIEWABLE_ENTITY_COURSE_BRANCH',
  /** A reading item entity. */
  ReviewableEntityReadingItem: 'REVIEWABLE_ENTITY_READING_ITEM'
} as const;

export type QualityCoach_ReviewableEntityReferenceType = typeof QualityCoach_ReviewableEntityReferenceType[keyof typeof QualityCoach_ReviewableEntityReferenceType];
/** Descriptions of the rule in a human- and LLM-readable format. */
export type QualityCoach_RuleDescriptionInput = {
  /**
   * A human- and LLM-readable description of the rule. It should give the user enough information to understand
   * why a rule exists and how to address its issues.
   */
  ruleDescription: Scalars['String'];
  /** A short name for the rule suitable for display in a list. */
  ruleShortName: Scalars['String'];
};

/** A rule filter defines the conditions under which the rule is applicable. */
export type QualityCoach_RuleFilterInput = {
  /** The type of the filter defines which field on the entity to filter on. */
  filterType: QualityCoach_RuleFilterType;
  /** The acceptable entity values for the filter. Empty list implies all values are acceptable. */
  filterValue: Array<Scalars['ID']>;
};

/** The type of the rule filter defines which field on the entity to filter on. */
export const QualityCoach_RuleFilterType = {
  /** Filter on the reviewable entity type. */
  ReviewableEntityTypeFilter: 'REVIEWABLE_ENTITY_TYPE_FILTER'
} as const;

export type QualityCoach_RuleFilterType = typeof QualityCoach_RuleFilterType[keyof typeof QualityCoach_RuleFilterType];
/** LLM configuration instructs the LLM system on how to evaluate the rule. */
export type QualityCoach_RuleLlmConfigurationInput = {
  /** Whether the LLM should generate a single review result or a review result with a list of issues. */
  issueOutputStyle: QualityCoach_IssueOutputStyleType;
  /** The LLM instruction for the rule. */
  llmInstruction: Scalars['String'];
  /** How the LLM should output the results of the rule. */
  llmOutputStyle: QualityCoach_LlmOutputStyleType;
};

/** Rerun configuration instructs the orchestration system on when to re-evaluate the rule. */
export const QualityCoach_RuleRerunConfigurationType = {
  /** Rule can be manually triggered. */
  RuleRerunConfigurationManual: 'RULE_RERUN_CONFIGURATION_MANUAL',
  /** Rerun the rule on entity update. */
  RuleRerunConfigurationOnEntityUpdate: 'RULE_RERUN_CONFIGURATION_ON_ENTITY_UPDATE'
} as const;

export type QualityCoach_RuleRerunConfigurationType = typeof QualityCoach_RuleRerunConfigurationType[keyof typeof QualityCoach_RuleRerunConfigurationType];
/** Severity of the score */
export const QualityCoach_ScoreSeverity = {
  /** The score is an error (potentially launch-blocking). */
  Error: 'ERROR',
  /** The score is a pass. */
  Pass: 'PASS',
  /** The score is a suggestion. */
  Suggestion: 'SUGGESTION',
  /** The score is a warning. */
  Warning: 'WARNING'
} as const;

export type QualityCoach_ScoreSeverity = typeof QualityCoach_ScoreSeverity[keyof typeof QualityCoach_ScoreSeverity];
/** Input types for referencing reviewable entities. */
export type QualityCoach_TypedReviewableEntityReferenceInput = {
  /** A reference to an atom. */
  atom?: InputMaybe<QualityCoach_AtomReferenceInput>;
  /** A reference to a course. */
  course?: InputMaybe<QualityCoach_CourseReferenceInput>;
  /** A reference to a course branch. */
  courseBranch?: InputMaybe<QualityCoach_CourseBranchReferenceInput>;
};

/** Input to update an existing quality rule. */
export type QualityCoach_UpdateQualityRuleInput = {
  /** LLM configuration instructs the LLM system on how to evaluate the rule. */
  llmConfiguration?: InputMaybe<QualityCoach_RuleLlmConfigurationInput>;
  /** Rerun configuration instructs the orchestration system on when to rerun the rule. */
  rerunConfiguration: Array<QualityCoach_RuleRerunConfigurationType>;
  /** Descriptions of the rule in a human- and LLM-readable format. */
  ruleDescription: QualityCoach_RuleDescriptionInput;
  /** Filters define the conditions under which the rule is applicable. */
  ruleFilters: Array<QualityCoach_RuleFilterInput>;
  /** The id of the rule. */
  ruleId: Scalars['ID'];
  /** The weight of the rule in the overall score. */
  weight: Scalars['Float'];
};

/** AI Graded text rubric */
export type QuestionBank_AiGradedTextRubricInput = {
  /** ID */
  id: Scalars['ID'];
  /** How much this rubric is worth */
  points: Scalars['Float'];
  /** Instructions for this option for the grader */
  prompt: Scalars['String'];
};

/** Input for adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add categories to */
  questionBankId: Scalars['ID'];
  /** The question categories to add. Duplicate categories will be rejected. */
  questionCategories: Array<QuestionBank_QuestionCategoryInput>;
};

/** Input for adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add categories to */
  questionBankId: Scalars['ID'];
  /** The question categories to add. Duplicate categories will be rejected. */
  questionCategories: Array<QuestionBank_QuestionCategoryInput>;
};

/** Input for adding questions to a question bank draft */
export type QuestionBank_AddQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add questions to */
  questionBankId: Scalars['ID'];
  /** The questions to add */
  questions: Array<QuestionBank_MachineEvaluableQuestionInput>;
};

/** Input for adding questions to a question bank draft */
export type QuestionBank_AddQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add questions to */
  questionBankId: Scalars['ID'];
  /** The questions to add */
  questions: Array<QuestionBank_MachineEvaluableQuestionInputV2>;
};

/** AI Graded options rubric */
export type QuestionBank_AiGradedOptionsRubricInput = {
  /** ID */
  id: Scalars['ID'];
  /** Instructions for this option for the grader */
  options: Array<QuestionBank_AiGradedOptionsRubricOptionInput>;
  /** A description of the rubric to be provided to the AI */
  prompt: Scalars['String'];
};

/** AI Graded options rubric option */
export type QuestionBank_AiGradedOptionsRubricOptionInput = {
  /** Instructions for this option for the grader */
  description: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** How much this option is worth */
  points: Scalars['Float'];
};

/** AI Graded Rubrics for open ended questions */
export type QuestionBank_AiGradedRubricInput = {
  /** AI Graded options rubric */
  optionsRubric?: InputMaybe<QuestionBank_AiGradedOptionsRubricInput>;
  /** AI Graded text rubric */
  textRubric?: InputMaybe<QuestionBank_AiGradedTextRubricInput>;
};

/** Indicates which types of files are allowed to be uploaded for the file upload question */
export const QuestionBank_AllowedFileUploadType = {
  /** All file types are allowed */
  All: 'ALL',
  /** Audio files of certain extensions are allowed */
  Audio: 'AUDIO',
  /** Coding files of certain extensions are allowed */
  Coding: 'CODING',
  /** Image files of certain extensions are allowed */
  Image: 'IMAGE',
  /** Text files of certain extensions are allowed */
  Text: 'TEXT',
  /** Video files of certain extensions are allowed */
  Video: 'VIDEO'
} as const;

export type QuestionBank_AllowedFileUploadType = typeof QuestionBank_AllowedFileUploadType[keyof typeof QuestionBank_AllowedFileUploadType];
/** Authoring metadata of question bank */
export type QuestionBank_AuthoringQuestionBankMetadataInput = {
  /** Timestamp when the question bank was created */
  createdAt: Scalars['DateTime'];
  /** ID of the user who created the question bank */
  createdBy?: InputMaybe<Scalars['Int']>;
  /** Published versioned question bank ID */
  publishedId?: InputMaybe<QuestionBank_VersionedQuestionBankIdInput>;
  /** Timestamp when the question bank was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who last updated the question bank */
  updatedBy?: InputMaybe<Scalars['Int']>;
};

/** Reasons for unauthorized access to the question bank */
export const QuestionBank_AuthorizationReasonEnum = {
  /** Question bank is used by at least one assignment. This reason is just for 'delete a QB' case */
  ActivelyInUse: 'ACTIVELY_IN_USE',
  /** Authorized access */
  Authorized: 'AUTHORIZED',
  /** Question bank is embedded */
  Embedded: 'EMBEDDED',
  /** Insufficient access rights */
  InsufficientAccess: 'INSUFFICIENT_ACCESS'
} as const;

export type QuestionBank_AuthorizationReasonEnum = typeof QuestionBank_AuthorizationReasonEnum[keyof typeof QuestionBank_AuthorizationReasonEnum];
/** Input for creating a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionCreateInput = {
  /** The authoring metadata for the question bank being published. */
  authoringMetadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to be published. */
  questionBankId: Scalars['ID'];
};

/** Input for executing a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionExecuteInput = {
  /** The ID of the cascading publish transaction to execute. */
  transactionId: Scalars['ID'];
};

/** Input for proposing a question block update within a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateInput = {
  /** The ID of the question block to update. */
  questionBlockId: Scalars['ID'];
  /** The proposed question configuration for the question block. */
  questionConfiguration: QuestionBlock_QuestionConfigurationInput;
  /** The proposed selection criteria for the question block. */
  selectionCriteria: QuestionBlock_SelectionCriteriaInput;
  /** The ID of the cascading publish transaction to update. */
  transactionId: Scalars['ID'];
};

/** Status of a cascading publish transaction */
export const QuestionBank_CascadingPublishTransactionStatus = {
  /** The transaction has completed publishing the question bank and its questions. */
  Completed: 'COMPLETED',
  /** The transaction has failed to publish the question bank and its questions. */
  Failed: 'FAILED',
  /** The transaction is currently publishing the question bank and its questions. */
  Running: 'RUNNING',
  /** The transaction is validating the question bank and its questions before publishing. */
  Validating: 'VALIDATING'
} as const;

export type QuestionBank_CascadingPublishTransactionStatus = typeof QuestionBank_CascadingPublishTransactionStatus[keyof typeof QuestionBank_CascadingPublishTransactionStatus];
/** Input for a checkbox question definition */
export type QuestionBank_CheckboxQuestionDefinitionInput = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox question definition */
export type QuestionBank_CheckboxQuestionDefinitionInputV2 = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflection question definition */
export type QuestionBank_CheckboxReflectQuestionDefinitionInput = {
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflection question definition */
export type QuestionBank_CheckboxReflectQuestionDefinitionInputV2 = {
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a code expression question definition */
export type QuestionBank_CodeExpressionQuestionDefinitionInput = {
  /** The programming language for the code */
  codeLanguage: Scalars['String'];
  /** The identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** The optional identifier for the REPL evaluator */
  replEvaluatorId?: InputMaybe<Scalars['ID']>;
  /** The initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Input for a code expression question definition */
export type QuestionBank_CodeExpressionQuestionDefinitionInputV2 = {
  /** The programming language for the code */
  codeLanguage: Scalars['String'];
  /** The identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** The optional identifier for the REPL evaluator */
  replEvaluatorId?: InputMaybe<Scalars['ID']>;
  /** The initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Input for creating question bank draft */
export type QuestionBank_CreateDraftInput = {
  /** Name of the question bank */
  name: Scalars['String'];
  /** Scope of the question bank */
  scope: QuestionBank_Scope;
  /** Source of the question bank */
  source: QuestionBank_QuestionBankSource;
};

/** Input for a file upload question definition */
export type QuestionBank_FileUploadQuestionDefinitionInput = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Input for a file upload question definition */
export type QuestionBank_FileUploadQuestionDefinitionInputV2 = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Input for linking question bank to a scope */
export type QuestionBank_LinkInput = {
  /** Question bank id to link */
  questionBankId: Scalars['ID'];
  /** Scope to link the question bank to */
  scope: QuestionBank_Scope;
};

/** Input for a machine evaluable question (without an ID, used when creating new questions) */
export type QuestionBank_MachineEvaluableQuestionInput = {
  /** The question definition, specifying the question type and its content */
  definition: QuestionBank_QuestionDefinitionInput;
  /** Optional difficulty level of the question */
  difficultyLevel?: InputMaybe<QuestionBank_QuestionDifficultyLevel>;
  /** Optional mastery level of the question */
  masteryLevel?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** Optional ID of the question category assigned to this question */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
};

/** Input for a machine evaluable question (without an ID, used when creating new questions) */
export type QuestionBank_MachineEvaluableQuestionInputV2 = {
  /** The question definition, specifying the question type and its content */
  definition: QuestionBank_QuestionDefinitionInputV2;
  /** Optional difficulty level of the question */
  difficultyLevel?: InputMaybe<QuestionBank_QuestionDifficultyLevel>;
  /** Optional mastery level of the question */
  masteryLevel?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** Optional ID of the question category assigned to this question */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
};

/** Input for a math expression answer with its expression string and feedback */
export type QuestionBank_MathExpressionAnswerInputV2 = {
  /** The mathematical expression string (e.g. LaTeX) */
  answer: Scalars['String'];
  /** The feedback to show for this answer */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a math expression question definition */
export type QuestionBank_MathExpressionQuestionDefinitionInput = {
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_TextContentInput;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContentInput;
  /** Incorrect possible answers to display as distractors */
  incorrectPossibleAnswers: Array<QuestionBank_TextContentInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a math expression question definition */
export type QuestionBank_MathExpressionQuestionDefinitionInputV2 = {
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_MathExpressionAnswerInputV2;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_CmlInput;
  /** Incorrect possible answers to display as distractors */
  incorrectPossibleAnswers: Array<QuestionBank_MathExpressionAnswerInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Input for merging questions into a question bank draft. Questions with matching IDs are updated; questions without a matching ID are added as new. */
export type QuestionBank_MergeQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to merge questions into */
  questionBankId: Scalars['ID'];
  /** The questions to merge */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdInput>;
};

/** Input for merging questions into a question bank draft. Questions with matching IDs are updated; questions without a matching ID are added as new. */
export type QuestionBank_MergeQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to merge questions into */
  questionBankId: Scalars['ID'];
  /** The questions to merge */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdV2Input>;
};

/** Input for a fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlankInput = {
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** The unique identifier for this blank */
  id: Scalars['ID'];
  /** The options available for this blank */
  options: Array<QuestionBank_QuestionOptionInput>;
};

/** Input for a fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlankInputV2 = {
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** The unique identifier for this blank */
  id: Scalars['ID'];
  /** The options available for this blank */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
};

/** Input for a multiple choice question definition */
export type QuestionBank_MultipleChoiceQuestionDefinitionInput = {
  /** The ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContentInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice question definition */
export type QuestionBank_MultipleChoiceQuestionDefinitionInputV2 = {
  /** The ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback: Cml_CmlInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflection question definition */
export type QuestionBank_MultipleChoiceReflectQuestionDefinitionInput = {
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContentInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflection question definition */
export type QuestionBank_MultipleChoiceReflectQuestionDefinitionInputV2 = {
  /** Feedback to show when no option is chosen */
  noChosenFeedback: Cml_CmlInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple fillable blanks question definition */
export type QuestionBank_MultipleFillableBlanksQuestionDefinitionInput = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlankInput>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple fillable blanks question definition */
export type QuestionBank_MultipleFillableBlanksQuestionDefinitionInputV2 = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlankInputV2>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a possible numeric answer with feedback */
export type QuestionBank_NumericAnswerInput = {
  /** The numeric value or range considered correct */
  answer: QuestionBank_NumericAnswerValueInput;
  /** The feedback to show when this answer is matched */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a possible numeric answer with feedback */
export type QuestionBank_NumericAnswerInputV2 = {
  /** The numeric value or range considered correct */
  answer: QuestionBank_NumericAnswerValueInputV2;
  /** The feedback to show when this answer is matched */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a numeric answer value. Exactly one field must be provided. */
export type QuestionBank_NumericAnswerValueInput = {
  /** A range of acceptable numeric values */
  rangeValue?: InputMaybe<QuestionBank_RangeNumericAnswerValueInput>;
  /** A single exact numeric value */
  singleValue?: InputMaybe<QuestionBank_SingleNumericAnswerValueInput>;
};

/** Input for a numeric answer value. Exactly one field must be provided. */
export type QuestionBank_NumericAnswerValueInputV2 = {
  /** A range of acceptable numeric values */
  rangeValue?: InputMaybe<QuestionBank_RangeNumericAnswerValueInputV2>;
  /** A single exact numeric value */
  singleValue?: InputMaybe<QuestionBank_SingleNumericAnswerValueInputV2>;
};

/** Input for a numeric question definition */
export type QuestionBank_NumericQuestionDefinitionInput = {
  /** The possible numeric answers with their feedback */
  answer: Array<QuestionBank_NumericAnswerInput>;
  /** The IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a numeric question definition */
export type QuestionBank_NumericQuestionDefinitionInputV2 = {
  /** The possible numeric answers with their feedback */
  answer: Array<QuestionBank_NumericAnswerInputV2>;
  /** The IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Input for a question bank question with its ID (used when updating or merging existing questions) */
export type QuestionBank_QuestionBankQuestionWithIdInput = {
  /** The ID of the question to update */
  id: Scalars['ID'];
  /** The updated question definition */
  question: QuestionBank_MachineEvaluableQuestionInput;
};

/** Input for a question bank question with its ID (used when updating or merging existing questions with V2 question types) */
export type QuestionBank_QuestionBankQuestionWithIdV2Input = {
  /** The ID of the question to update */
  id: Scalars['ID'];
  /** The updated question definition */
  question: QuestionBank_MachineEvaluableQuestionInputV2;
};

/** Source of question bank */
export const QuestionBank_QuestionBankSource = {
  /** Question bank authored by a human (AUTHOR) */
  Author: 'AUTHOR',
  /** Question bank generated by AI (COPILOT) */
  Copilot: 'COPILOT'
} as const;

export type QuestionBank_QuestionBankSource = typeof QuestionBank_QuestionBankSource[keyof typeof QuestionBank_QuestionBankSource];
/** Input for a question category (without an ID, used when creating new categories) */
export type QuestionBank_QuestionCategoryInput = {
  /** The name of the question category */
  name: Scalars['String'];
};

/** Input for a question category with its ID (used when updating existing categories) */
export type QuestionBank_QuestionCategoryWithIdInput = {
  /** The ID of the question category to update */
  id: Scalars['ID'];
  /** The updated name of the question category */
  name: Scalars['String'];
};

/** Input for a question definition. Exactly one field must be provided. */
export type QuestionBank_QuestionDefinitionInput = {
  /** A checkbox question */
  checkbox?: InputMaybe<QuestionBank_CheckboxQuestionDefinitionInput>;
  /** A checkbox reflection question */
  checkboxReflect?: InputMaybe<QuestionBank_CheckboxReflectQuestionDefinitionInput>;
  /** A code expression question */
  codeExpression?: InputMaybe<QuestionBank_CodeExpressionQuestionDefinitionInput>;
  /** File Upload */
  fileUpload?: InputMaybe<QuestionBank_FileUploadQuestionDefinitionInput>;
  /** A math expression question */
  mathExpression?: InputMaybe<QuestionBank_MathExpressionQuestionDefinitionInput>;
  /** A multiple choice question */
  multipleChoice?: InputMaybe<QuestionBank_MultipleChoiceQuestionDefinitionInput>;
  /** A multiple choice reflection question */
  multipleChoiceReflect?: InputMaybe<QuestionBank_MultipleChoiceReflectQuestionDefinitionInput>;
  /** A multiple fillable blanks question */
  multipleFillableBlanks?: InputMaybe<QuestionBank_MultipleFillableBlanksQuestionDefinitionInput>;
  /** A numeric question */
  numeric?: InputMaybe<QuestionBank_NumericQuestionDefinitionInput>;
  /** A regex question */
  regex?: InputMaybe<QuestionBank_RegexQuestionDefinitionInput>;
  /** Rich Text Question */
  richText?: InputMaybe<QuestionBank_RichTextQuestionDefinitionInput>;
  /** A text exact match question */
  textExactMatch?: InputMaybe<QuestionBank_TextExactMatchQuestionDefinitionInput>;
  /** A text reflection question */
  textReflect?: InputMaybe<QuestionBank_TextReflectQuestionDefinitionInput>;
  /** A widget question */
  widget?: InputMaybe<QuestionBank_WidgetQuestionDefinitionInput>;
};

/** Input for a question definition. Exactly one field must be provided. */
export type QuestionBank_QuestionDefinitionInputV2 = {
  /** A checkbox question */
  checkbox?: InputMaybe<QuestionBank_CheckboxQuestionDefinitionInputV2>;
  /** A checkbox reflection question */
  checkboxReflect?: InputMaybe<QuestionBank_CheckboxReflectQuestionDefinitionInputV2>;
  /** A code expression question */
  codeExpression?: InputMaybe<QuestionBank_CodeExpressionQuestionDefinitionInputV2>;
  /** File Upload */
  fileUpload?: InputMaybe<QuestionBank_FileUploadQuestionDefinitionInputV2>;
  /** A math expression question */
  mathExpression?: InputMaybe<QuestionBank_MathExpressionQuestionDefinitionInputV2>;
  /** A multiple choice question */
  multipleChoice?: InputMaybe<QuestionBank_MultipleChoiceQuestionDefinitionInputV2>;
  /** A multiple choice reflection question */
  multipleChoiceReflect?: InputMaybe<QuestionBank_MultipleChoiceReflectQuestionDefinitionInputV2>;
  /** A multiple fillable blanks question */
  multipleFillableBlanks?: InputMaybe<QuestionBank_MultipleFillableBlanksQuestionDefinitionInputV2>;
  /** A numeric question */
  numeric?: InputMaybe<QuestionBank_NumericQuestionDefinitionInputV2>;
  /** A regex question */
  regex?: InputMaybe<QuestionBank_RegexQuestionDefinitionInputV2>;
  /** Rich Text Question */
  richText?: InputMaybe<QuestionBank_RichTextQuestionDefinitionInputV2>;
  /** A text exact match question */
  textExactMatch?: InputMaybe<QuestionBank_TextExactMatchQuestionDefinitionInputV2>;
  /** A text reflection question */
  textReflect?: InputMaybe<QuestionBank_TextReflectQuestionDefinitionInputV2>;
  /** A widget question */
  widget?: InputMaybe<QuestionBank_WidgetQuestionDefinitionInputV2>;
};

/** Difficulty levels for questions */
export const QuestionBank_QuestionDifficultyLevel = {
  /** Easy difficulty level */
  Easy: 'EASY',
  /** Hard difficulty level */
  Hard: 'HARD',
  /** Medium difficulty level */
  Medium: 'MEDIUM'
} as const;

export type QuestionBank_QuestionDifficultyLevel = typeof QuestionBank_QuestionDifficultyLevel[keyof typeof QuestionBank_QuestionDifficultyLevel];
/** Input for a question option with display text and feedback */
export type QuestionBank_QuestionDisplayOptionInputV2 = {
  /** The display text for this option */
  display: Cml_CmlInput;
  /** The feedback to show when this option is selected */
  feedback: Cml_CmlInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
};

/** Input for a question option with display text and feedback. Exactly one of stringContent or cml must be provided for each text field. */
export type QuestionBank_QuestionOptionInput = {
  /** The display text for this option */
  display: QuestionBank_TextContentInput;
  /** The feedback to show when this option is selected */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
};

/** Input for a range of acceptable numeric answer values */
export type QuestionBank_RangeNumericAnswerValueInput = {
  /** The lower bound of the acceptable range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound itself is included in the range */
  lowerBoundInclusive: Scalars['Boolean'];
  /** The upper bound of the acceptable range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound itself is included in the range */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Input for a range of acceptable numeric answer values */
export type QuestionBank_RangeNumericAnswerValueInputV2 = {
  /** The lower bound of the acceptable range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound itself is included in the range */
  lowerBoundInclusive: Scalars['Boolean'];
  /** The upper bound of the acceptable range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound itself is included in the range */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Flags that can be applied to regex patterns */
export const QuestionBank_RegexFlag = {
  /** Makes the pattern case-insensitive */
  CaseInsensitive: 'CASE_INSENSITIVE',
  /** Makes . match newlines as well */
  Dotall: 'DOTALL',
  /** Enables multi-line mode where ^ and $ match start/end of lines */
  Multiline: 'MULTILINE'
} as const;

export type QuestionBank_RegexFlag = typeof QuestionBank_RegexFlag[keyof typeof QuestionBank_RegexFlag];
/** Input for a regex option with a pattern and feedback */
export type QuestionBank_RegexOptionInput = {
  /** The feedback to show when this pattern is matched */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered a correct answer */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPatternInput;
};

/** Input for a regex option with a pattern and feedback */
export type QuestionBank_RegexOptionInputV2 = {
  /** The feedback to show when this pattern is matched */
  feedback: Cml_CmlInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered a correct answer */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPatternInputV2;
};

/** Input for a regex pattern with optional flags */
export type QuestionBank_RegexPatternInput = {
  /** Flags that modify how the pattern is applied */
  flags: Array<QuestionBank_RegexFlag>;
  /** The regex pattern string */
  value: Scalars['String'];
};

/** Input for a regex pattern with optional flags */
export type QuestionBank_RegexPatternInputV2 = {
  /** Flags that modify how the pattern is applied */
  flags: Array<QuestionBank_RegexFlag>;
  /** The regex pattern string */
  value: Scalars['String'];
};

/** Input for a regex question definition */
export type QuestionBank_RegexQuestionDefinitionInput = {
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContentInput;
  /** The possible regex pattern answers with their feedback */
  possibleAnswers: Array<QuestionBank_RegexOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a regex question definition */
export type QuestionBank_RegexQuestionDefinitionInputV2 = {
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_CmlInput;
  /** The possible regex pattern answers with their feedback */
  possibleAnswers: Array<QuestionBank_RegexOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Input for removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove all questions from */
  questionBankId: Scalars['ID'];
};

/** Input for removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove all questions from */
  questionBankId: Scalars['ID'];
};

/** Input for removing question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
export type QuestionBank_RemoveQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove categories from */
  questionBankId: Scalars['ID'];
  /** The IDs of the question categories to remove */
  questionCategoryIds: Array<Scalars['ID']>;
};

/** Input for removing question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
export type QuestionBank_RemoveQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove categories from */
  questionBankId: Scalars['ID'];
  /** The IDs of the question categories to remove */
  questionCategoryIds: Array<Scalars['ID']>;
};

/** Input for removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove questions from */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions to remove. All provided IDs must already exist in the draft. */
  questionIds: Array<Scalars['ID']>;
};

/** Input for removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove questions from */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions to remove. All provided IDs must already exist in the draft. */
  questionIds: Array<Scalars['ID']>;
};

/** Input for reverting a question bank */
export type QuestionBank_RevertDraftInput = {
  /** Metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** Question bank id to revert */
  questionBankId: Scalars['ID'];
};

/** Input for a rich text question definition */
export type QuestionBank_RichTextQuestionDefinitionInput = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Input for a rich text question definition */
export type QuestionBank_RichTextQuestionDefinitionInputV2 = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Source of the question bank */
export type QuestionBank_Scope = {
  /** Source is a course */
  course?: InputMaybe<Scalars['ID']>;
};

/** Input for a single exact numeric answer value */
export type QuestionBank_SingleNumericAnswerValueInput = {
  /** The exact numeric value that is correct */
  value: Scalars['Float'];
};

/** Input for a single exact numeric answer value */
export type QuestionBank_SingleNumericAnswerValueInputV2 = {
  /** The exact numeric value that is correct */
  value: Scalars['Float'];
};

/** Input for text content. Exactly one field must be provided. */
export type QuestionBank_TextContentInput = {
  /** Rich text content in CML format */
  cml?: InputMaybe<Cml_CmlInput>;
  /** Plain text content */
  stringContent?: InputMaybe<Scalars['String']>;
};

/** Input for a text exact match answer option with plain text display and CML feedback */
export type QuestionBank_TextExactMatchAnswerInputV2 = {
  /** The plain text string to match against */
  answer: Scalars['String'];
  /** The feedback to show when this option is selected */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a text exact match question definition */
export type QuestionBank_TextExactMatchQuestionDefinitionInput = {
  /** The possible text answers with their feedback */
  answers: Array<QuestionBank_QuestionOptionInput>;
  /** The IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a text exact match question definition */
export type QuestionBank_TextExactMatchQuestionDefinitionInputV2 = {
  /** The possible text answers with their feedback */
  answers: Array<QuestionBank_TextExactMatchAnswerInputV2>;
  /** The IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Input for a text reflection question definition */
export type QuestionBank_TextReflectQuestionDefinitionInput = {
  /** General feedback for the learner after answering */
  feedback: QuestionBank_TextContentInput;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a text reflection question definition */
export type QuestionBank_TextReflectQuestionDefinitionInputV2 = {
  /** General feedback for the learner after answering */
  feedback: Cml_CmlInput;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Input for unlinking question bank from a scope */
export type QuestionBank_UnlinkInput = {
  /** Question bank id to unlink */
  questionBankId: Scalars['ID'];
  /** Scope to unlink the question bank from */
  scope: QuestionBank_Scope;
};

/** Input for updating the name of a question bank */
export type QuestionBank_UpdateBankInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The new name of the question bank */
  name: Scalars['String'];
  /** The ID of the question bank to update */
  questionBankId: Scalars['ID'];
};

/** Input for updating the name of a question bank */
export type QuestionBank_UpdateBankV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The new name of the question bank */
  name: Scalars['String'];
  /** The ID of the question bank to update */
  questionBankId: Scalars['ID'];
};

/** Input for updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose categories are to be updated */
  questionBankId: Scalars['ID'];
  /** The question categories to update, identified by their IDs */
  questionCategories: Array<QuestionBank_QuestionCategoryWithIdInput>;
};

/** Input for updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose categories are to be updated */
  questionBankId: Scalars['ID'];
  /** The question categories to update, identified by their IDs */
  questionCategories: Array<QuestionBank_QuestionCategoryWithIdInput>;
};

/** Input for updating existing questions in a question bank draft */
export type QuestionBank_UpdateQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose questions are to be updated */
  questionBankId: Scalars['ID'];
  /** The questions to update, identified by their IDs. All provided IDs must already exist in the draft. */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdInput>;
};

/** Input for updating existing questions in a question bank draft */
export type QuestionBank_UpdateQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose questions are to be updated */
  questionBankId: Scalars['ID'];
  /** The questions to update, identified by their IDs. All provided IDs must already exist in the draft. */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdV2Input>;
};

/** Validation status */
export const QuestionBank_ValidationStatus = {
  /** The field has a bad reference */
  BadReference: 'BAD_REFERENCE',
  /** The field has a DTD error */
  Dtd: 'DTD',
  /** The field is a duplicate */
  Duplicate: 'DUPLICATE',
  /** The field is empty */
  Empty: 'EMPTY',
  /** The field has an ENUM error */
  Enum: 'ENUM',
  /** The field has a format error */
  Format: 'FORMAT',
  /** The field is locked */
  Locked: 'LOCKED',
  /** The field is not empty */
  NonEmpty: 'NON_EMPTY',
  /** The field has another unclassified type of error */
  Other: 'OTHER',
  /** The field has an overlap error */
  Overlap: 'OVERLAP',
  /** The field is too large */
  TooLarge: 'TOO_LARGE',
  /** The field is too long */
  TooLong: 'TOO_LONG',
  /** The field is too short */
  TooShort: 'TOO_SHORT',
  /** The field is too small */
  TooSmall: 'TOO_SMALL',
  /** The field is valid */
  Valid: 'VALID'
} as const;

export type QuestionBank_ValidationStatus = typeof QuestionBank_ValidationStatus[keyof typeof QuestionBank_ValidationStatus];
/** Versioned Question Bank ID */
export type QuestionBank_VersionedQuestionBankIdInput = {
  /** Question Bank ID */
  id: Scalars['ID'];
  /** Version of the question bank */
  version: Scalars['Int'];
};

/** Input for a widget question definition */
export type QuestionBank_WidgetQuestionDefinitionInput = {
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** The type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** The identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Input for a widget question definition */
export type QuestionBank_WidgetQuestionDefinitionInputV2 = {
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** The type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** The identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Response types for widget questions */
export const QuestionBank_WidgetResponseType = {
  /** Only a continue action is expected */
  ContinueOnly: 'CONTINUE_ONLY',
  /** No response expected */
  Empty: 'EMPTY',
  /** A submission is expected */
  Submission: 'SUBMISSION'
} as const;

export type QuestionBank_WidgetResponseType = typeof QuestionBank_WidgetResponseType[keyof typeof QuestionBank_WidgetResponseType];
/** Question difficulty levels used to select Questions */
export const QuestionBlock_DifficultyLevel = {
  /** Question difficulty - easy */
  Easy: 'EASY',
  /** Question difficulty - hard */
  Hard: 'HARD',
  /** Question difficulty - medium */
  Medium: 'MEDIUM'
} as const;

export type QuestionBlock_DifficultyLevel = typeof QuestionBlock_DifficultyLevel[keyof typeof QuestionBlock_DifficultyLevel];
/** Question mastery levels used to select Questions */
export const QuestionBlock_MasteryLevel = {
  /** Question mastery level 1 - Foundational understanding */
  Level_1: 'LEVEL_1',
  /** Question mastery level 2 - Practical application */
  Level_2: 'LEVEL_2',
  /** Question mastery level 3 - Reason analytically */
  Level_3: 'LEVEL_3',
  /** Question mastery level 4 - Synthesize and innovate */
  Level_4: 'LEVEL_4'
} as const;

export type QuestionBlock_MasteryLevel = typeof QuestionBlock_MasteryLevel[keyof typeof QuestionBlock_MasteryLevel];
/** Input for configuration of selected questions within Question Block */
export type QuestionBlock_QuestionConfigurationInput = {
  /** How many points per question should be awarded */
  points: Scalars['Int'];
};

/** Input for selection criteria for questions from Question Bank */
export type QuestionBlock_SelectionCriteriaInput = {
  /** What is the difficulty level of the selected questions */
  difficultyLevelFilter?: InputMaybe<QuestionBlock_DifficultyLevel>;
  /** What is the mastery level of the selected questions */
  masteryLevelFilter?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** How many questions are to be selected from the Question Bank */
  numberOfRequestedQuestions: Scalars['Int'];
  /** What category ID, if any, should be used in question selection */
  questionCategoryFilter?: InputMaybe<Scalars['ID']>;
};

/** Input for setting an experiment */
export type QuestionGenerator_CreateExperimentInput = {
  /** The name of the experiement */
  name: Scalars['String'];
  /** The new prompt template to use */
  promptTemplate: Scalars['String'];
};

/** Enum representing the types of feedback level */
export const QuestionGenerator_FeedbackType = {
  /** All relevant feedback provided */
  Full: 'FULL',
  /** Correct answer is not disclosed */
  Graded: 'GRADED',
  /** No feedback provided */
  None: 'NONE'
} as const;

export type QuestionGenerator_FeedbackType = typeof QuestionGenerator_FeedbackType[keyof typeof QuestionGenerator_FeedbackType];
/** Status of the generation request */
export const QuestionGenerator_GenerationStatus = {
  /** The user cancelled the generation request */
  Cancelled: 'CANCELLED',
  /** The generation request finished successfully */
  Complete: 'COMPLETE',
  /** The generation request didn't finish successfully */
  Failed: 'FAILED',
  /** The workers started picking up jobs */
  Inprogress: 'INPROGRESS',
  /** The generation request was queued but the workers didn't pick up jobs yet */
  Started: 'STARTED'
} as const;

export type QuestionGenerator_GenerationStatus = typeof QuestionGenerator_GenerationStatus[keyof typeof QuestionGenerator_GenerationStatus];
/** LearningObjective generation request */
export type QuestionGenerator_LearningObjectiveGenerationRequest = {
  /** LearningObjective ID */
  learningObjectiveId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Lesson generation request */
export type QuestionGenerator_LessonGenerationRequest = {
  /** Lesson ID */
  lessonId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Module generation request */
export type QuestionGenerator_ModuleGenerationRequest = {
  /** Module ID */
  moduleId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Enum representing the types of questions the AI can generate */
export const QuestionGenerator_QuestionType = {
  /** AI Graded */
  AiGraded: 'AiGraded',
  /** Checkboxes question */
  Checkbox: 'Checkbox',
  /** Code expression question */
  CodeExpression: 'CodeExpression',
  /** Multi-choice questions, or checkboxes */
  MultipleChoiceQuestion: 'MultipleChoiceQuestion',
  /** Number match questions */
  Number: 'Number',
  /** Text match questions */
  TextExactMatch: 'TextExactMatch'
} as const;

export type QuestionGenerator_QuestionType = typeof QuestionGenerator_QuestionType[keyof typeof QuestionGenerator_QuestionType];
/** Request to start a generation from learning objectives to question banks */
export type QuestionGenerator_StartGenerationFromLearningObjectivesToQuestionBanks = {
  /** Learning Objectives to generate from and how many questions */
  learningObjectives: Array<QuestionGenerator_LearningObjectiveGenerationRequest>;
};

/** Request to start a generation from lessons to question banks */
export type QuestionGenerator_StartGenerationFromLessonsToQuestionBanks = {
  /** Lessons to generate from and how many questions */
  lessons: Array<QuestionGenerator_LessonGenerationRequest>;
};

/** Request to start a generation from modules to question banks */
export type QuestionGenerator_StartGenerationFromModulesToQuestionBanks = {
  /** Modules to generate from and how many questions */
  modules: Array<QuestionGenerator_ModuleGenerationRequest>;
};

/** Input to start a question generation request */
export type QuestionGenerator_StartGenerationInput = {
  /** Authoring branch id with the content to use for generation */
  authoringBranchId: Scalars['ID'];
  /** Course ID in which to save the new question bank */
  courseId: Scalars['ID'];
  /** The type of feedback the AI should generate. Feedback is displayed to learners alongside their answer. */
  feedbackType?: InputMaybe<QuestionGenerator_FeedbackType>;
  /** The id of an existing question bank to append generated questions to */
  questionBankId?: InputMaybe<Scalars['ID']>;
  /** The name of the question bank to be created */
  questionBankName?: InputMaybe<Scalars['String']>;
  /** Question types to generate */
  questionTypes?: InputMaybe<Array<QuestionGenerator_QuestionType>>;
  /**
   * Whether to retry on low quality questions.
   * It makes the generation slower
   */
  retryLowQualityQuestions?: Scalars['Boolean'];
  /** Source to use to generate */
  sources: QuestionGenerator_StartGenerationSources;
};

/** Start generation sources from a course */
export type QuestionGenerator_StartGenerationSources = {
  /** Start a question generation to a question bank from learning objectives */
  fromLearningObjectivesToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromLearningObjectivesToQuestionBanks>;
  /** Start a question generation to a question bank from lessons */
  fromLessonsToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromLessonsToQuestionBanks>;
  /** Start a question generation to a question bank from modules */
  fromModulesToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromModulesToQuestionBanks>;
};

/** Input for the stop generation request */
export type QuestionGenerator_StopGenerationInput = {
  /** Course ID */
  courseId?: InputMaybe<Scalars['ID']>;
  /** ID of the generation request to stop */
  generationRequestId: Scalars['ID'];
};

/** Input for setting an experiment */
export type QuestionGenerator_UpdateExperimentInput = {
  /** The ID of the experiment to change */
  experimentId: Scalars['ID'];
  /** The new prompt to use */
  promptTemplate: Scalars['String'];
};

/** Rating strategy for the question rater */
export const QuestionRater_RatingStrategy = {
  /** Rate only unrated questions */
  ContinueRating: 'CONTINUE_RATING',
  /** Rate all questions */
  RateAll: 'RATE_ALL'
} as const;

export type QuestionRater_RatingStrategy = typeof QuestionRater_RatingStrategy[keyof typeof QuestionRater_RatingStrategy];
/** Input for the save question rating request */
export type QuestionRater_SaveHumanQuestionRatingInput = {
  /** Absence of clues score */
  absenceOfCluesScore: Scalars['Int'];
  /** Answer feedback clarity score */
  answerFeedbackClarityScore: Scalars['Int'];
  /** Answer precision score */
  answerPrecisionScore: Scalars['Int'];
  /** Avoid negative phrasing score */
  avoidNegativePhrasingScore: Scalars['Int'];
  /** Generation batch ID */
  batchId: Scalars['ID'];
  /** Difficulty level alignment score */
  difficultyLevelAlignmentScore: Scalars['Int'];
  /** Factual accuracy score */
  factualAccuracyScore: Scalars['Int'];
  /** Feedback answer score */
  feedbackAnswerScore: Scalars['Int'];
  /** Meaningfulness score */
  meaningfulnessScore: Scalars['Int'];
  /** Human rater notes */
  notes: Scalars['String'];
  /** Plausibility score */
  plausibilityScore: Scalars['Int'];
  /** Problem presentation score */
  problemPresentationScore: Scalars['Int'];
  /** Question bank ID */
  questionBankId: Scalars['ID'];
  /** Question clarity score */
  questionClarityScore: Scalars['Int'];
  /** Question grammar score */
  questionGrammarScore: Scalars['Int'];
  /** Question ID */
  questionId: Scalars['ID'];
};

/** Whether the rating was saved or not */
export const QuestionRater_SaveHumanQuestionRatingStatus = {
  /** Rating not saved */
  RatingNotSaved: 'RATING_NOT_SAVED',
  /** Rating saved */
  RatingSaved: 'RATING_SAVED'
} as const;

export type QuestionRater_SaveHumanQuestionRatingStatus = typeof QuestionRater_SaveHumanQuestionRatingStatus[keyof typeof QuestionRater_SaveHumanQuestionRatingStatus];
/** Input for the mutation to start a question rater */
export type QuestionRater_StartQuestionRatingInput = {
  /** Course id  to rate */
  courseId: Scalars['ID'];
  /** Rating Strategy */
  ratingStrategy: QuestionRater_RatingStrategy;
};

/** Reading draft content, represented as an input type */
export type ReadingAuthoring_DraftContentInput = {
  /** Updated reading content, in CML format */
  content: CmlContentInput;
  /** Updated item name */
  name: Scalars['String'];
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Input for the ReadingAuthoring_UpdateReadingDraft mutation */
export type ReadingAuthoring_UpdateReadingDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: ReadingAuthoring_DraftContentInput;
};

/** Input to add a recently viewed product */
export type RecentlyViewedProducts_AddRecentlyViewedProductInput = {
  /** Product id of the recently viewed product */
  productId: Scalars['ID'];
  /** Product type of the recently viewed product */
  productType: RecentlyViewedProducts_ProductType;
};

/** Product type for a recently viewed product */
export const RecentlyViewedProducts_ProductType = {
  /** Product is a course */
  Course: 'COURSE',
  /** Product is a specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type RecentlyViewedProducts_ProductType = typeof RecentlyViewedProducts_ProductType[keyof typeof RecentlyViewedProducts_ProductType];
/**
 * Input for querying recommendations from a specific recommender configuration (specified by name) while providing
 * all input required by that module and the request context (user ID and session ID).
 */
export type Recommendation_QueryByNameAndCustomInputAndContext = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * The recommender's name. Names must be in lower-kebab-case.
   *
   * The set of valid recommendation configuration names is defined by the file names (sans the .json extension) found
   * in this directory: https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1
   */
  name: Scalars['String'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
  /** The Session ID for which to retrieve recommendations. A null value indicates no session. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** The user ID for which to retrieve recommendations. A null value indicates a logged out user. */
  userId?: InputMaybe<Scalars['Int']>;
};

/**
 * Input for querying recommendations for a recommender configuration (provided) while providing
 * all input required by that module.
 */
export type Recommendation_QueryByRecommendationConfigurationAndCustomInput = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * A JSON object representing a recommender configuration. This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  configuration: Scalars['JSON'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
};

/**
 * Input for querying recommendations for a recommender configuration (provided) while providing
 * all input required by that module and the request context (user ID and session ID).
 */
export type Recommendation_QueryByRecommendationConfigurationAndCustomInputAndContext = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * A JSON object representing a recommender configuration. This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  configuration: Scalars['JSON'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
  /** The Session ID for which to retrieve recommendations. A null value indicates no session. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** The user ID for which to retrieve recommendations. A null value indicates a logged out user. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** Input parameters for Query byUserAndCourse */
export type RecommendedModuleDeadlines_QueryByUserAndCourseInput = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** User Id */
  userId: Scalars['ID'];
};

/** The level of education that a candidate has already or is in the process of achieving. */
export const RecruitingCandidate_EducationLevel = {
  /** Associate's degree */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Completed some college but no degree attained */
  CollegeNoDegree: 'COLLEGE_NO_DEGREE',
  /** Doctorate degree */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High School Diploma or GED */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Less than a High School Diploma */
  LessThanHighSchoolDiploma: 'LESS_THAN_HIGH_SCHOOL_DIPLOMA',
  /** Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** Some kind of professional degree */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type RecruitingCandidate_EducationLevel = typeof RecruitingCandidate_EducationLevel[keyof typeof RecruitingCandidate_EducationLevel];
/** Ethnicity options for candidates in the talent pipeline */
export const RecruitingCandidate_Ethnicity = {
  /** African American */
  AfricanAmerican: 'AFRICAN_AMERICAN',
  /** American Indian or Alaskan Native */
  AmericanIndian: 'AMERICAN_INDIAN',
  /** Asian */
  Asian: 'ASIAN',
  /** Hispanic or LatinX */
  Hispanic: 'HISPANIC',
  /** Native Hawaiian or Pacific Islander */
  NativeHawaiian: 'NATIVE_HAWAIIAN',
  /** White */
  White: 'WHITE'
} as const;

export type RecruitingCandidate_Ethnicity = typeof RecruitingCandidate_Ethnicity[keyof typeof RecruitingCandidate_Ethnicity];
/** A set of filters that can be used to limit the list of candidates on the recruiting dashboard. */
export type RecruitingCandidate_Filters = {
  /**
   * The maximum assessment score (from 0 to 100) that a candidate should have
   * achieved to be displayed.
   * Leave null if you do not wish to set a upper-bound on assessment score
   */
  assessmentMaximum?: InputMaybe<Scalars['Int']>;
  /**
   * The minimum assessment score (from 0 to 100) that a candidate should have
   * achieved to be displayed.
   * Leave null if you do not wish to set a lower-bound on assessment score
   */
  assessmentMinimum?: InputMaybe<Scalars['Int']>;
  /**
   * Filter candidates by whether or not they require sponsorship to work in the US.
   * A value of true will return only candidates who do not require sponsorship.
   * A value of false will return only candidates who require sponsorship.
   * Leave null if you do not wish to filter by sponsorship requirements.
   */
  canWorkInUsWithoutSponsorship?: InputMaybe<Scalars['Boolean']>;
  /**
   * One or more degree levels to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by degree level.
   */
  educationLevels?: InputMaybe<Array<RecruitingCandidate_EducationLevel>>;
  /**
   * One or more majors of study to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by major.
   * The complete list of eligible majors that candidates may select can be found here:
   * https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/userprofile/v1beta1/education_profile.proto#L56-L69
   */
  educationMajors?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Any race/ethnicity selections that should be used to filter candidates by.
   * Candidates will be included if they have selected any one of the ethnicities provided.
   * Leave null if you do not wish to filter by ethnicity.
   */
  ethnicities?: InputMaybe<Array<RecruitingCandidate_Ethnicity>>;
  /**
   * Any gender identity selections that should be used to filter candidates by.
   * Candidates will be included if they have selected any one of the gender identities provided.
   * Leave null if you do not wish to filter by gender identity.
   */
  genders?: InputMaybe<Array<RecruitingCandidate_Gender>>;
  /**
   * The maximum year that displayed candidates should have completed their most recent degree.
   * Leave null if you do not wish to set an upper-bound on graduation year
   */
  graduationYearMaximum?: InputMaybe<Scalars['Int']>;
  /**
   * The minimum year that displayed candidates should have completed their most recent degree.
   * Leave null if you do not wish to set a lower-bound on graduation year
   */
  graduationYearMinimum?: InputMaybe<Scalars['Int']>;
  /**
   * Filter candidates by whether or not they have been invited.
   * A value of true will return only candidates who have already been invited.
   * A value of false will return only candidates who have not been invited.
   * Leave null if you do not wish to filter by invitation status.
   */
  hasBeenInvited?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter candidates by whether or not they are eligible to work in the US.
   * A value of true will return only candidates who are eligible.
   * A value of false will return only candidates who are not eligible.
   * Leave null if you do not wish to filter by US work eligibility.
   */
  hasUsWorkAuthorization?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter candidates by whether or not they are protected veterans.
   * A value of true will return only candidates who have self-identifies as protected veterans.
   * A value of false will return only candidates who have self-identified as non-protected veterans.
   * Leave null if you do not wish to filter by veteran status.
   */
  isProtectedVeteran?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter the candidates by their current location.
   * Leave null if you do not wish to filter the candidates by location
   */
  locations?: InputMaybe<Array<RecruitingCandidate_LocationFilter>>;
  /**
   * Filter candidates by whether or not they are members in specific programs.
   * Candidates will be included if they are member of any one of the program IDs provided.
   * Leave null if you do not wish to filter by programs.
   */
  memberPrograms?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Any skills that the candidates should have achieved to be included in the result set.
   * The input should be the name of the skill, not the ID.
   * Candidates will be included if they have any one of the skills provided.
   * Leave null if you do not wish to filter by skill.
   */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Any Specializations that the candidates should have completed to be included in the result set.
   * Candidates will be included if they have completed any one of the specializations provided.
   * Leave null if you do not wish to filter by specialization.
   */
  specializationIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Set to true if you would like to filter to only "diverse" hires.
   * False or null will not filter the candidate result set.
   */
  underrepresentedTalentOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * One or more university names (in English) to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by attended university.
   */
  universities?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filters candidates by whether or not they are willing to relocate.
   * Leave null if you do not wish to filter candidates by their relocation preferences.
   */
  willingToRelocate?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filters candidates by whether or not they are willing to work remotely.
   * Leave null if you do not wish to filter candidates by their remote work preferences.
   */
  willingToWorkRemote?: InputMaybe<Scalars['Boolean']>;
};

/** Gender options for candidates in the talent pipeline */
export const RecruitingCandidate_Gender = {
  /** Agender */
  Agender: 'AGENDER',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Transgender man */
  TransgenderMan: 'TRANSGENDER_MAN',
  /** Transgender woman */
  TransgenderWoman: 'TRANSGENDER_WOMAN',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type RecruitingCandidate_Gender = typeof RecruitingCandidate_Gender[keyof typeof RecruitingCandidate_Gender];
/** Filters the candidates by their current lat/long location */
export type RecruitingCandidate_LocationFilter = {
  /** The latitude of the location */
  latitude: Scalars['Float'];
  /** The longitude of the location */
  longitude: Scalars['Float'];
  /**
   * The number of kilometers from the specified lat/long point that
   * we will allow candidates to be in.
   * Defaults to 60km
   */
  radiusKilometers?: Scalars['Int'];
};

/** Whether we should sort ascending or descending */
export const RecruitingCandidate_SortDirection = {
  /** Sort from low to high */
  Asc: 'ASC',
  /** Sort from high to low */
  Desc: 'DESC'
} as const;

export type RecruitingCandidate_SortDirection = typeof RecruitingCandidate_SortDirection[keyof typeof RecruitingCandidate_SortDirection];
/** The column or field that we want to sort by */
export const RecruitingCandidate_SortField = {
  /** Sorts candidates by the grade that they have achieved on the job-specific qualifying assessment */
  AssessmentScore: 'ASSESSMENT_SCORE',
  /**
   * Sorts candidates based on their usage of the coursera platform.
   * Namely this means sorting by number of specializations, then by number of programming assignments
   */
  CourseraCredentials: 'COURSERA_CREDENTIALS'
} as const;

export type RecruitingCandidate_SortField = typeof RecruitingCandidate_SortField[keyof typeof RecruitingCandidate_SortField];
/** The order in which the candidates should be returned within the candidates list. */
export type RecruitingCandidate_SortOption = {
  /** Whether we should sort ascending or descending */
  direction: RecruitingCandidate_SortDirection;
  /** The column or field that we want to sort by */
  field: RecruitingCandidate_SortField;
};

/** Input type for the email object */
export type RecruitingInvitation_Email = {
  /** The body (content) of the email. This will be CML generated by FE rich text editor. */
  body: CmlContentInput;
  /** The label of the call to action button in the email */
  ctaLabel: Scalars['String'];
  /** Display name on who is sending the email. */
  fromName: Scalars['String'];
  /** The ID of the position that the recruiter is sending an invite email */
  positionId: Scalars['ID'];
  /** The URL for the position page to go when call to action button is clicked */
  positionUrl: Scalars['URL'];
  /** The subject of the email */
  subject: Scalars['String'];
  /** The total number of candidates in the filter chosen when invitation is being sent */
  totalInFilter: Scalars['Int'];
};

/** Input type for sending invitation emails by filters */
export type RecruitingInvitation_InviteByFiltersInput = {
  /** The email to be sent to candidates */
  email: RecruitingInvitation_Email;
  /**
   * A set of optional filtering parameters that can be used to reduce the number
   * of candidates returned
   */
  optionalFilters?: InputMaybe<RecruitingCandidate_Filters>;
};

/** Input type for sending invitation emails by external IDs */
export type RecruitingInvitation_InviteByIdsInput = {
  /** The email to be sent to candidates */
  email: RecruitingInvitation_Email;
  /** List of External IDs of the candidates that will receive the invitations */
  externalIds: Array<Scalars['ID']>;
};

/** The country associated with this position */
export const RecruitingPosition_Country = {
  /** Andorra */
  Ad: 'AD',
  /** United Arab Emirates */
  Ae: 'AE',
  /** Afghanistan */
  Af: 'AF',
  /** Antigua and Barbuda */
  Ag: 'AG',
  /** Anguilla */
  Ai: 'AI',
  /** Albania */
  Al: 'AL',
  /** Armenia */
  Am: 'AM',
  /** Netherlands Antilles */
  An: 'AN',
  /** Angola */
  Ao: 'AO',
  /** Antarctica */
  Aq: 'AQ',
  /** Argentina */
  Ar: 'AR',
  /** American Samoa */
  As: 'AS',
  /** Austria */
  At: 'AT',
  /** Australia */
  Au: 'AU',
  /** Aruba */
  Aw: 'AW',
  /** Åland Islands */
  Ax: 'AX',
  /** Azerbaijan */
  Az: 'AZ',
  /** Bosnia and Herzegovina */
  Ba: 'BA',
  /** Barbados */
  Bb: 'BB',
  /** Bangladesh */
  Bd: 'BD',
  /** Belgium */
  Be: 'BE',
  /** Burkina Faso */
  Bf: 'BF',
  /** Bulgaria */
  Bg: 'BG',
  /** Bahrain */
  Bh: 'BH',
  /** Burundi */
  Bi: 'BI',
  /** Benin */
  Bj: 'BJ',
  /** Saint Barthélemy */
  Bl: 'BL',
  /** Bermuda */
  Bm: 'BM',
  /** Brunei Darussalam */
  Bn: 'BN',
  /** Bolivia */
  Bo: 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq: 'BQ',
  /** Brazil */
  Br: 'BR',
  /** Bahamas */
  Bs: 'BS',
  /** Bhutan */
  Bt: 'BT',
  /** Bouvet Island */
  Bv: 'BV',
  /** Botswana */
  Bw: 'BW',
  /** Belarus */
  By: 'BY',
  /** Belize */
  Bz: 'BZ',
  /** Canada */
  Ca: 'CA',
  /** Cocos (Keeling) Islands */
  Cc: 'CC',
  /** Congo, The Democratic Republic of the */
  Cd: 'CD',
  /** Central African Republic */
  Cf: 'CF',
  /** Congo */
  Cg: 'CG',
  /** Switzerland */
  Ch: 'CH',
  /** Cote D'Ivoire */
  Ci: 'CI',
  /** Cook Islands */
  Ck: 'CK',
  /** Chile */
  Cl: 'CL',
  /** Cameroon */
  Cm: 'CM',
  /** China */
  Cn: 'CN',
  /** Colombia */
  Co: 'CO',
  /** Costa Rica */
  Cr: 'CR',
  /** Cuba */
  Cu: 'CU',
  /** Cape Verde */
  Cv: 'CV',
  /** Curaçao */
  Cw: 'CW',
  /** Christmas Island */
  Cx: 'CX',
  /** Cyprus */
  Cy: 'CY',
  /** Czech Republic */
  Cz: 'CZ',
  /** Germany */
  De: 'DE',
  /** Djibouti */
  Dj: 'DJ',
  /** Denmark */
  Dk: 'DK',
  /** Dominica */
  Dm: 'DM',
  /** Dominican Republic */
  Do: 'DO',
  /** Algeria */
  Dz: 'DZ',
  /** Ecuador */
  Ec: 'EC',
  /** Estonia */
  Ee: 'EE',
  /** Egypt */
  Eg: 'EG',
  /** Western Sahara */
  Eh: 'EH',
  /** Eritrea */
  Er: 'ER',
  /** Spain */
  Es: 'ES',
  /** Ethiopia */
  Et: 'ET',
  /** Finland */
  Fi: 'FI',
  /** Fiji */
  Fj: 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk: 'FK',
  /** Micronesia, Federated States of */
  Fm: 'FM',
  /** Faroe Islands */
  Fo: 'FO',
  /** France */
  Fr: 'FR',
  /** Gabon */
  Ga: 'GA',
  /** United Kingdom */
  Gb: 'GB',
  /** Grenada */
  Gd: 'GD',
  /** Georgia */
  Ge: 'GE',
  /** French Guiana */
  Gf: 'GF',
  /** Guernsey */
  Gg: 'GG',
  /** Ghana */
  Gh: 'GH',
  /** Gibraltar */
  Gi: 'GI',
  /** Greenland */
  Gl: 'GL',
  /** Gambia */
  Gm: 'GM',
  /** Guinea */
  Gn: 'GN',
  /** Guadeloupe */
  Gp: 'GP',
  /** Equatorial Guinea */
  Gq: 'GQ',
  /** Greece */
  Gr: 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs: 'GS',
  /** Guatemala */
  Gt: 'GT',
  /** Guam */
  Gu: 'GU',
  /** Guinea-Bissau */
  Gw: 'GW',
  /** Guyana */
  Gy: 'GY',
  /** Hong Kong */
  Hk: 'HK',
  /** Heard Island and Mcdonald Islands */
  Hm: 'HM',
  /** Honduras */
  Hn: 'HN',
  /** Croatia */
  Hr: 'HR',
  /** Haiti */
  Ht: 'HT',
  /** Hungary */
  Hu: 'HU',
  /** Indonesia */
  Id: 'ID',
  /** Ireland */
  Ie: 'IE',
  /** Israel */
  Il: 'IL',
  /** Isle of Man */
  Im: 'IM',
  /** India */
  In: 'IN',
  /** British Indian Ocean Territory */
  Io: 'IO',
  /** Iraq */
  Iq: 'IQ',
  /** Iran, Islamic Republic of */
  Ir: 'IR',
  /** Iceland */
  Is: 'IS',
  /** Italy */
  It: 'IT',
  /** Jersey */
  Je: 'JE',
  /** Jamaica */
  Jm: 'JM',
  /** Jordan */
  Jo: 'JO',
  /** Japan */
  Jp: 'JP',
  /** Kenya */
  Ke: 'KE',
  /** Kyrgyzstan */
  Kg: 'KG',
  /** Cambodia */
  Kh: 'KH',
  /** Kiribati */
  Ki: 'KI',
  /** Comoros */
  Km: 'KM',
  /** Saint Kitts and Nevis */
  Kn: 'KN',
  /** Korea, Democratic People's Republic of */
  Kp: 'KP',
  /** Korea, Republic of */
  Kr: 'KR',
  /** Kuwait */
  Kw: 'KW',
  /** Cayman Islands */
  Ky: 'KY',
  /** Kazakhstan */
  Kz: 'KZ',
  /** Lao People's Democratic Republic */
  La: 'LA',
  /** Lebanon */
  Lb: 'LB',
  /** Saint Lucia */
  Lc: 'LC',
  /** Liechtenstein */
  Li: 'LI',
  /** Sri Lanka */
  Lk: 'LK',
  /** Liberia */
  Lr: 'LR',
  /** Lesotho */
  Ls: 'LS',
  /** Lithuania */
  Lt: 'LT',
  /** Luxembourg */
  Lu: 'LU',
  /** Latvia */
  Lv: 'LV',
  /** Libya */
  Ly: 'LY',
  /** Morocco */
  Ma: 'MA',
  /** Monaco */
  Mc: 'MC',
  /** Moldova, Republic of */
  Md: 'MD',
  /** Montenegro */
  Me: 'ME',
  /** Saint Martin */
  Mf: 'MF',
  /** Madagascar */
  Mg: 'MG',
  /** Marshall Islands */
  Mh: 'MH',
  /** Macedonia, The Former Yugoslav Republic of */
  Mk: 'MK',
  /** Mali */
  Ml: 'ML',
  /** Myanmar */
  Mm: 'MM',
  /** Mongolia */
  Mn: 'MN',
  /** Macao */
  Mo: 'MO',
  /** Northern Mariana Islands */
  Mp: 'MP',
  /** Martinique */
  Mq: 'MQ',
  /** Mauritania */
  Mr: 'MR',
  /** Montserrat */
  Ms: 'MS',
  /** Malta */
  Mt: 'MT',
  /** Mauritius */
  Mu: 'MU',
  /** Maldives */
  Mv: 'MV',
  /** Malawi */
  Mw: 'MW',
  /** Mexico */
  Mx: 'MX',
  /** Malaysia */
  My: 'MY',
  /** Mozambique */
  Mz: 'MZ',
  /** Namibia */
  Na: 'NA',
  /** New Caledonia */
  Nc: 'NC',
  /** Niger */
  Ne: 'NE',
  /** Norfolk Island */
  Nf: 'NF',
  /** Nigeria */
  Ng: 'NG',
  /** Nicaragua */
  Ni: 'NI',
  /** Netherlands */
  Nl: 'NL',
  /** Norway */
  No: 'NO',
  /** Nepal */
  Np: 'NP',
  /** Nauru */
  Nr: 'NR',
  /** Niue */
  Nu: 'NU',
  /** New Zealand */
  Nz: 'NZ',
  /** Oman */
  Om: 'OM',
  /** Panama */
  Pa: 'PA',
  /** Peru */
  Pe: 'PE',
  /** French Polynesia */
  Pf: 'PF',
  /** Papua New Guinea */
  Pg: 'PG',
  /** Philippines */
  Ph: 'PH',
  /** Pakistan */
  Pk: 'PK',
  /** Poland */
  Pl: 'PL',
  /** Saint Pierre and Miquelon */
  Pm: 'PM',
  /** Pitcairn */
  Pn: 'PN',
  /** Puerto Rico */
  Pr: 'PR',
  /** Palestinian Territory, Occupied */
  Ps: 'PS',
  /** Portugal */
  Pt: 'PT',
  /** Palau */
  Pw: 'PW',
  /** Paraguay */
  Py: 'PY',
  /** Qatar */
  Qa: 'QA',
  /** Akrotiri */
  Qz: 'QZ',
  /** Reunion */
  Re: 'RE',
  /** Romania */
  Ro: 'RO',
  /** Serbia */
  Rs: 'RS',
  /** Russian Federation */
  Ru: 'RU',
  /** Rwanda */
  Rw: 'RW',
  /** Saudi Arabia */
  Sa: 'SA',
  /** Solomon Islands */
  Sb: 'SB',
  /** Seychelles */
  Sc: 'SC',
  /** Sudan */
  Sd: 'SD',
  /** Sweden */
  Se: 'SE',
  /** Singapore */
  Sg: 'SG',
  /** Saint Helena */
  Sh: 'SH',
  /** Slovenia */
  Si: 'SI',
  /** Svalbard and Jan Mayen */
  Sj: 'SJ',
  /** Slovakia */
  Sk: 'SK',
  /** Sierra Leone */
  Sl: 'SL',
  /** San Marino */
  Sm: 'SM',
  /** Senegal */
  Sn: 'SN',
  /** Somalia */
  So: 'SO',
  /** Suriname */
  Sr: 'SR',
  /** South Sudan */
  Ss: 'SS',
  /** Sao Tome and Principe */
  St: 'ST',
  /** El Salvador */
  Sv: 'SV',
  /** Sint Maarten (Dutch part) */
  Sx: 'SX',
  /** Syrian Arab Republic */
  Sy: 'SY',
  /** Swaziland */
  Sz: 'SZ',
  /** Turks and Caicos Islands */
  Tc: 'TC',
  /** Chad */
  Td: 'TD',
  /** French Southern Territories */
  Tf: 'TF',
  /** Togo */
  Tg: 'TG',
  /** Thailand */
  Th: 'TH',
  /** Tajikistan */
  Tj: 'TJ',
  /** Tokelau */
  Tk: 'TK',
  /** Timor-Leste */
  Tl: 'TL',
  /** Turkmenistan */
  Tm: 'TM',
  /** Tunisia */
  Tn: 'TN',
  /** Tonga */
  To: 'TO',
  /** Turkey */
  Tr: 'TR',
  /** Trinidad and Tobago */
  Tt: 'TT',
  /** Tuvalu */
  Tv: 'TV',
  /** Taiwan */
  Tw: 'TW',
  /** Tanzania, United Republic of */
  Tz: 'TZ',
  /** Ukraine */
  Ua: 'UA',
  /** Uganda */
  Ug: 'UG',
  /** United States Minor Outlying Islands */
  Um: 'UM',
  /** United States */
  Us: 'US',
  /** Uruguay */
  Uy: 'UY',
  /** Uzbekistan */
  Uz: 'UZ',
  /** Holy See (Vatican City State) */
  Va: 'VA',
  /** Saint Vincent and the Grenadines */
  Vc: 'VC',
  /** Venezuela */
  Ve: 'VE',
  /** Virgin Islands, British */
  Vg: 'VG',
  /** Virgin Islands, U.S. */
  Vi: 'VI',
  /** Vietnam */
  Vn: 'VN',
  /** Vanuatu */
  Vu: 'VU',
  /** Wallis and Futuna */
  Wf: 'WF',
  /** Samoa */
  Ws: 'WS',
  /** Gaza Strip */
  Xg: 'XG',
  /** Kosovo */
  Xk: 'XK',
  /** Svalbard */
  Xr: 'XR',
  /** Spratly Islands */
  Xs: 'XS',
  /** West Bank */
  Xw: 'XW',
  /** Yemen */
  Ye: 'YE',
  /** Mayotte */
  Yt: 'YT',
  /** South Africa */
  Za: 'ZA',
  /** Zambia */
  Zm: 'ZM',
  /** Zimbabwe */
  Zw: 'ZW'
} as const;

export type RecruitingPosition_Country = typeof RecruitingPosition_Country[keyof typeof RecruitingPosition_Country];
/** Creates a new recruiting position */
export type RecruitingPosition_CreateInput = {
  /** The country in which eligible candidates should reside */
  hiringCountry: RecruitingPosition_Country;
  /** The name of the position to be displayed in the recruiting dashboard */
  name: Scalars['String'];
  /**
   * The type of occupation or industry that this position is for.
   * Null if this position is not associated with one specific occupation type.
   */
  occupationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the third party organization that this position is under */
  organizationId: Scalars['ID'];
  /** The slug of the position, which should be unique within a given organization */
  positionSlug: Scalars['String'];
};

/** Deletes an existing recruiting position */
export type RecruitingPosition_DeleteInput = {
  /** The ID of the position to be deleted */
  id: Scalars['ID'];
};

/** Input type for redeeming a course credit */
export type RedeemCourseCreditInput = {
  /** ID of the cart to apply the credit to */
  cartId: Scalars['String'];
  /** ID of the credit to redeem */
  creditId: Scalars['String'];
};

/** Input type for refunding a course credit */
export type RefundCourseCreditInput = {
  /** ID of the credit to refund */
  creditId: Scalars['String'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CommentFilter = {
  /** [Required] filters results to assignment id */
  assignmentId: Scalars['ID'];
  /** [Required] filters results to review part id */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CreateReusableCommentInput = {
  /** TODO: Complete this description */
  assignmentId: Scalars['ID'];
  /** TODO: Complete this description */
  assignmentVersion: Scalars['Int'];
  /** TODO: Complete this description */
  commentText: Scalars['String'];
  /** TODO: Complete this description */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CreateReusableCommentUsageInput = {
  /** TODO: Complete this description */
  assignmentId: Scalars['ID'];
  /** TODO: Complete this description */
  assignmentVersion: Scalars['Int'];
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
  /** TODO: Complete this description */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_DeleteReusableCommentInput = {
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_UpdateReusableCommentInput = {
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
  /** TODO: Complete this description */
  commentText: Scalars['String'];
};

/** Input argument for create new branch. */
export type RoleSkillMappingBranch_CreateNewBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for deactivate branch. */
export type RoleSkillMappingBranch_DeactivateBranchInput = {
  /** Flag to force deactivate freeze branch */
  includeFreezeBranch?: Scalars['Boolean'];
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for freeze branch. */
export type RoleSkillMappingBranch_FreezeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Input argument for merge branch. */
export type RoleSkillMappingBranch_MergeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Role Skills mapping branch status */
export const RoleSkillMappingBranch_Status = {
  /** branch active for editing */
  Active: 'ACTIVE',
  /** branch deactivated for all operation other than deletion */
  Deactivate: 'DEACTIVATE',
  /** branch freezed for labelling and A/B testing */
  Freeze: 'FREEZE',
  /** branch has been merged into main */
  Merged: 'MERGED'
} as const;

export type RoleSkillMappingBranch_Status = typeof RoleSkillMappingBranch_Status[keyof typeof RoleSkillMappingBranch_Status];
/** DDN type for role skill mapping */
export const RoleSkillMappingNode_Ddn = {
  /** DEFINING_SKILLS */
  DefiningSkills: 'DEFINING_SKILLS',
  /** Distinguishing skills */
  DistinguishingSkills: 'DISTINGUISHING_SKILLS',
  /** Necessary skills */
  NecessarySkills: 'NECESSARY_SKILLS'
} as const;

export type RoleSkillMappingNode_Ddn = typeof RoleSkillMappingNode_Ddn[keyof typeof RoleSkillMappingNode_Ddn];
/** Role skill mapping node for upsert */
export type RoleSkillMappingNode_MappingInput = {
  /** role description */
  desc: Scalars['String'];
  /** role id */
  id: Scalars['ID'];
  /** role name */
  name: Scalars['String'];
  /** mapped skills */
  skills: Array<RoleSkillMappingNode_SkillInput>;
};

/** Skill node for upsert */
export type RoleSkillMappingNode_SkillInput = {
  /** skill DDN type */
  ddn: RoleSkillMappingNode_Ddn;
  /** skill id */
  id: Scalars['ID'];
  /** manually set skill proficiency score. */
  proficiency?: InputMaybe<Scalars['Int']>;
};

/** Input argument for upsert & deletion nodes by branch. */
export type RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** role ids that to be deleted. */
  deletions: Array<Scalars['ID']>;
  /** role Skill mapping node to be upserted. */
  upserts: Array<RoleSkillMappingNode_MappingInput>;
};

/** Input for completing a SAML flow */
export type SamlFlows_CompleteFlowInput = {
  /** The ID of the SAML login to complete */
  samlLoginId: Scalars['ID'];
};

/** Type of SAML login flow */
export const SamlFlows_LoginType = {
  /** Identity provider initiated login */
  IdpInitiated: 'IDP_INITIATED',
  /** Service provider (Coursera) initiated login */
  SpInitiated: 'SP_INITIATED'
} as const;

export type SamlFlows_LoginType = typeof SamlFlows_LoginType[keyof typeof SamlFlows_LoginType];
/** Input for marking a SAML login as completed */
export type SamlFlows_MarkLoginCompletedInput = {
  /** The ID of the SAML login to mark as completed */
  samlLoginId: Scalars['ID'];
};

/** TODO: Complete this description */
export type SampleUser_AddUserInput = {
  /** The user's email address. */
  email: Scalars['String'];
  /** The user's name. */
  name: Scalars['String'];
};

/** TODO: Complete this description */
export type ScopedContentRule_Input = {
  /** TODO: Complete this description */
  productItemId: Scalars['String'];
  /** TODO: Complete this description */
  productType: ScopedContentRule_ProductType;
  /** TODO: Complete this description */
  scope: ScopedContentRule_ProductExperienceScopeType;
};

/** TODO: Complete this description */
export const ScopedContentRule_ProductExperienceScopeType = {
  /** TODO: Complete this description */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** TODO: Complete this description */
  CourseWithFullDiscount: 'COURSE_WITH_FULL_DISCOUNT'
} as const;

export type ScopedContentRule_ProductExperienceScopeType = typeof ScopedContentRule_ProductExperienceScopeType[keyof typeof ScopedContentRule_ProductExperienceScopeType];
/** TODO: Complete this description */
export const ScopedContentRule_ProductType = {
  /** TODO: Complete this description */
  Specialization: 'Specialization',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type ScopedContentRule_ProductType = typeof ScopedContentRule_ProductType[keyof typeof ScopedContentRule_ProductType];
/** TODO: Complete this description */
export const ScopedContentRule_ScopeRestrictionPolicy = {
  /** TODO: Complete this description */
  Allow: 'ALLOW',
  /** TODO: Complete this description */
  Block: 'BLOCK'
} as const;

export type ScopedContentRule_ScopeRestrictionPolicy = typeof ScopedContentRule_ScopeRestrictionPolicy[keyof typeof ScopedContentRule_ScopeRestrictionPolicy];
/** Input for requesting re-translation of a scope. */
export type ScopedTranslationConfig_RequestRetranslationInput = {
  /** The scope key identifying the translation scope, e.g. COURSE~courseId or SPECIALIZATION~s12nId. */
  scopeKey: Scalars['String'];
  /**
   * Coursera language codes to request re-translation for, e.g. ["fr", "es"].
   * Must not be empty.
   * See: https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  targetLanguageCodes: Array<Scalars['String']>;
};

/** Input for querying retranslation configs by scope key. */
export type ScopedTranslationConfig_RetranslationConfigsByScopeKeyInput = {
  /** The scope key identifying the translation scope, e.g. COURSE~courseId. */
  scopeKey: Scalars['String'];
};

/** Context for the search. */
export type Search_Context = {
  /** Search for public content catalog videos, i.e. non-private and non-enterprise catalog only content. */
  searchConsumerVideos?: InputMaybe<Search_SearchConsumerVideos>;
  /** Search for products available to add into an existing program or for program creation. */
  searchForCuration?: InputMaybe<Search_SearchForCuration>;
  /** Search for products that have enrollments in an enterprise org or enterprise programs. */
  searchInEnrolled?: InputMaybe<Search_SearchInEnrolled>;
  /** Search within products available in specific enterprise programs. */
  searchInPrograms?: InputMaybe<Search_SearchInPrograms>;
  /** Search the web-enabled sales (WES) catalog. */
  searchInWebEnabledSalesCatalog?: InputMaybe<Search_SearchInWebEnabledSalesCatalog>;
  /** Search context for product suggestions, used to suggest products in the autocomplete experience. */
  searchProductSuggestions?: InputMaybe<Search_SearchProductSuggestions>;
  /** Search context for suggested queries, used to route requests for suggested queries. */
  searchSuggestedQueries?: InputMaybe<Search_SearchSuggestedQueries>;
};

/** Types of entities available to search. */
export const Search_EntityType = {
  /** Search for articles. */
  Articles: 'ARTICLES',
  /** Search for products (courses, specializations, degrees, etc). */
  Products: 'PRODUCTS',
  /** Search for auto-complete suggestions. */
  Suggestions: 'SUGGESTIONS'
} as const;

export type Search_EntityType = typeof Search_EntityType[keyof typeof Search_EntityType];
/**
 * Input mirror of the `Search_Facet` output type, used to pass the facets
 * returned by a prior `search` call into `inferSearchRequest`. Display-only
 * fields (`nameDisplay`, `valueDisplay`) are omitted because the LLM only
 * reasons about the canonical names and counts.
 */
export type Search_FacetInput = {
  /** Attribute name (e.g., "skills", "topic"). Same semantics as `Search_Facet.name`. */
  name: Scalars['String'];
  /**
   * List of facet values and their counts. Same semantics as
   * `Search_Facet.valuesAndCounts`.
   */
  valuesAndCounts: Array<Search_FacetValueAndCountInput>;
};

/**
 * Input mirror of `Search_FacetValueAndCount`. Carries the canonical value
 * and its document count for use as LLM context.
 */
export type Search_FacetValueAndCountInput = {
  /** How many times the value occurred in the original search results. */
  count: Scalars['Int'];
  /**
   * The canonical facet value (e.g., "Machine Learning"). Same semantics as
   * `Search_FacetValueAndCount.value`.
   */
  value: Scalars['String'];
};

/**
 * Metadata about the top search results which are used as LLM input for the AI-generated summary.
 * This is just for the POC of AI-generated summaries where FE makes another API call,
 * but in the future we can consider creating a streaming API that returns search results first,
 * and then the summary and suggestions as they get loaded.
 */
export type Search_HitMetadataInputForSummary = {
  /** Average rating of the product from 0-5. */
  avgProductRating?: InputMaybe<Scalars['Float']>;
  /** The fully-translated languages for the search hit. */
  fullyTranslatedLanguages?: InputMaybe<Array<Scalars['String']>>;
  /** The ID of the search hit. */
  id: Scalars['ID'];
  /** Whether the content is new. */
  isNewContent?: InputMaybe<Scalars['Boolean']>;
  /** The name of the search hit. */
  name?: InputMaybe<Scalars['String']>;
  /** The partners associated with the search hit. */
  partners?: InputMaybe<Array<Scalars['String']>>;
  /** The difficulty level of the search hit. */
  productDifficultyLevel?: InputMaybe<Search_ProductDifficultyLevel>;
  /** Duration of the product. */
  productDuration?: InputMaybe<Search_ProductDuration>;
  /** The type of the search hit. */
  productType?: InputMaybe<Search_ProductType>;
  /** The skills associated with the search hit. */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /** The topics associated with the search hit. */
  topics?: InputMaybe<Array<Scalars['String']>>;
  /** URL of the product description page. */
  url?: InputMaybe<Scalars['URL']>;
};

/** Difficulty levels for products. */
export const Search_ProductDifficultyLevel = {
  /** Advanced difficulty level. */
  Advanced: 'ADVANCED',
  /** Beginner difficulty level. */
  Beginner: 'BEGINNER',
  /** Intermediate difficulty level. */
  Intermediate: 'INTERMEDIATE',
  /** Mixed difficulty level. */
  Mixed: 'MIXED'
} as const;

export type Search_ProductDifficultyLevel = typeof Search_ProductDifficultyLevel[keyof typeof Search_ProductDifficultyLevel];
/** Product durations. */
export const Search_ProductDuration = {
  /** Less than 2 hours. */
  LessThanTwoHours: 'LESS_THAN_TWO_HOURS',
  /** 1-4 weeks. */
  OneToFourWeeks: 'ONE_TO_FOUR_WEEKS',
  /** 1-4 years. */
  OneToFourYears: 'ONE_TO_FOUR_YEARS',
  /** 1-3 months. */
  OneToThreeMonths: 'ONE_TO_THREE_MONTHS',
  /** 6-12 months. */
  SixToTwelveMonths: 'SIX_TO_TWELVE_MONTHS',
  /** 3-6 months. */
  ThreeToSixMonths: 'THREE_TO_SIX_MONTHS',
  /** Under 60 minutes. */
  UnderSixtyMinutes: 'UNDER_SIXTY_MINUTES'
} as const;

export type Search_ProductDuration = typeof Search_ProductDuration[keyof typeof Search_ProductDuration];
/** Product types. */
export const Search_ProductType = {
  /** Course product type. */
  Course: 'COURSE',
  /** Degree product type. */
  Degree: 'DEGREE',
  /** Graduate Certificate product type. */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Guided Project product type. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Lesson product type. */
  Lesson: 'LESSON',
  /** MasterTrack product type. */
  Mastertrack: 'MASTERTRACK',
  /** Postgraduate Diploma product type. */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Professional Certificate product type. */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type. */
  Project: 'PROJECT',
  /** Specialization product type. */
  Specialization: 'SPECIALIZATION',
  /** University Certificate product type. */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Video product type. */
  Video: 'VIDEO'
} as const;

export type Search_ProductType = typeof Search_ProductType[keyof typeof Search_ProductType];
/** Input products and skills */
export type Search_ProductsAndSkills = {
  /** Product name. */
  productName: Scalars['String'];
  /** List of skill names. */
  skills: Array<Scalars['String']>;
};

/** Routes possible for executing prompt suggestions */
export const Search_QueryPromptRouteType = {
  /** Route to chat-only interface */
  ChatOnly: 'CHAT_ONLY',
  /** Route to search results page. */
  Serp: 'SERP'
} as const;

export type Search_QueryPromptRouteType = typeof Search_QueryPromptRouteType[keyof typeof Search_QueryPromptRouteType];
/** Search request type. */
export type Search_Request = {
  /**
   * Cursor to paginate through results - NOTE: the page number is used as the cursor, not the
   * element (hit) number or identifier.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Set to True to disable all recommenders. Disabling recommenders will improve search time.
   * Note: This is a `disable` instead of an `enable` because the server can only guarantee less work, and not more (for
   * performance reasons).
   */
  disableRecommender?: Scalars['Boolean'];
  /**
   * Set to True to enable auto-applied search filters using query understanding. The auto-applied filters will be returned
   * in the `autoAppliedFilters` field in the `Search_Result`.
   */
  enableAutoAppliedFilters?: Scalars['Boolean'];
  /** Type of entity to search. */
  entityType: Search_EntityType;
  /**
   * Set to True to get detailed explanation of how each search hit was ranked.
   * This parameter will be guarded by checks to see that the user is an internal Courserian.
   */
  explain?: Scalars['Boolean'];
  /**
   * Filter search hits by facet value. The given strings should be a comma separated key/value pair,
   * where the key is the attribute name and the value is the desired attribute value.
   *
   * Strings within the same array are interpreted as a disjunction (OR), while nested arrays are
   * interpreted as a conjunction (AND).
   *
   * For example, if the client only wants to show search results
   * where:
   *
   * (`allLanguages` attribute contains the "French" value) AND (`skills` attribute contains the
   * "Statistics" value OR `topic` attribute value is "Business")
   *
   * this would be set to:
   *
   * [["allLanguages:French"],["skills:Statistics","topic:Business"]]
   */
  facetFilters?: InputMaybe<Array<Array<Scalars['String']>>>;
  /**
   * Retrieve facets for the given attribute names (the list of distinct values and their counts),
   * which will be returned in the `facets` response field.
   *
   * For example, if the client wants to retrieve facets for the "skills" and "topic" attributes for
   * searches for the `PRODUCTS` entity type, this would be set to ["skills", "topic"].
   *
   * If a given attribute name is not facetable or does not exist for the entity type being
   * searched, it is silently ignored.
   *
   * See [hit.graphqls] for the list of valid, facetable attributes for each entity type.
   */
  facets?: InputMaybe<Array<Scalars['String']>>;
  /** Specify the maximum number of [Search_Hit]s to be returned in [Search_Result]. */
  limit: Scalars['Int'];
  /**
   * Maximum number of distinct values to return for each facet. The maximum value is 1000 for
   * performance reasons; any value higher will be interpreted as 1000.
   */
  maxValuesPerFacet?: Scalars['Int'];
  /** Text to search. */
  query: Scalars['String'];
  /**
   * Request origin of the search request. The goal for this is to eventually be an exhaustive set of enums
   * where different pages would pass in where the request is coming from, in order to inform logging and
   * determining eligibility for experiments that are orchestrated on BE.
   */
  requestOrigin?: InputMaybe<Search_RequestOrigin>;
  /** Optional context of the search. */
  searchContext?: InputMaybe<Search_Context>;
  /**
   * Sorting criteria to use for the search result hits.
   *
   * If this field is not set, a default sorting option will be chosen depending on the entity type.
   * May return a BAD_REQUEST if the entity type does not supporting the sorting option.
   *
   * See https://github.com/webedx-spark/search-application/blob/main/src/main/java/org/coursera/search/managers/EpicConfigurationHelper.java
   * for the supported sorting options and the default sort option for each entity type.
   */
  sortBy?: InputMaybe<Search_SortBy>;
};

/** Metadata for the request origin, used for logging and determining eligibility for experiments that are setup on the BE. */
export type Search_RequestOrigin = {
  /** FE page where the search request originated from, e.g. EQP, SERP */
  pageType: Search_RequestOriginPageType;
  /** Whether the page is part of the consumer or enterprise experience. */
  segmentType: Search_RequestOriginSegmentType;
};

/** FE page where the search request originated from, e.g. EQP, SERP. */
export const Search_RequestOriginPageType = {
  /** Entity Query Page, primarily used for linking users to browse topics from SEO and other site links. */
  Eqp: 'EQP',
  /** Search Entity Results Page, i.e. the page that renders after a user submits to the search bar. */
  Serp: 'SERP',
  /** Dropdown underneath the search bar when a user focuses and starts typing. */
  Suggestions: 'SUGGESTIONS'
} as const;

export type Search_RequestOriginPageType = typeof Search_RequestOriginPageType[keyof typeof Search_RequestOriginPageType];
/**
 * Whether the origin of the request is from a consumer or enterprise page,
 * e.g. enterprise SERP is separate from consumer SERP.
 */
export const Search_RequestOriginSegmentType = {
  /** Used for distinguishing pages in the consumer segment, e.g. consumer SERP. */
  Consumer: 'CONSUMER',
  /** Used for distinguishing pages in the enterprise segment, e.g. enterprise SERP. */
  Enterprise: 'ENTERPRISE'
} as const;

export type Search_RequestOriginSegmentType = typeof Search_RequestOriginSegmentType[keyof typeof Search_RequestOriginSegmentType];
/** Search for public content catalog videos, i.e. non-private and non-enterprise catalog only content. */
export type Search_SearchConsumerVideos = {
  /** Dummy field as this context supports no extra metadata. */
  _?: InputMaybe<Scalars['Boolean']>;
  /** Search for videos only belonging to these parent course slugs. */
  parentCourseSlugs?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Search for products available to add into an existing program or for program creation. If no program
 * is provided (e.g. for program creation), the contractId is used.
 */
export type Search_SearchForCuration = {
  /** Enterprise contract ID to search within. */
  contractId: Scalars['ID'];
  /** Enterprise program ID to search within. */
  programId?: InputMaybe<Scalars['ID']>;
};

/**
 * Search for products that have enrollments in an enterprise org or enterprise programs. If the
 * programsId list is empty, search within the entire organization.
 */
export type Search_SearchInEnrolled = {
  /**
   * Whether to include products that have downgraded enrollments. An enrollment may be downgraded
   * if, for example, an enterprise contract is archived. Existing enrollments within that
   * contract lose access to premium features in the products, such as labs and quizzes.
   */
  includeDowngraded?: Scalars['Boolean'];
  /** Organization ID to search within. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** List of program IDs to search within. */
  programIds: Array<Scalars['ID']>;
};

/** Search within products available in specific enterprise programs. */
export type Search_SearchInPrograms = {
  /** List of enterprise program IDs. */
  programIds: Array<Scalars['ID']>;
};

/** Search the web-enabled sales (WES) catalog. */
export type Search_SearchInWebEnabledSalesCatalog = {
  /**
   * Dummy field since searching the WES catalog takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Search context for product suggestions, used to suggest products in the autocomplete experience. */
export type Search_SearchProductSuggestions = {
  /**
   * Dummy field since this context takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Search context for suggested queries, used to route requests for suggested queries. */
export type Search_SearchSuggestedQueries = {
  /**
   * Dummy field since this context takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Available sorting criteria for the search result hits. */
export const Search_SortBy = {
  /**
   * Sort by best match. Ranking uses keyword matching and is also optimized for LTV (long-term value).
   * For more information on LTV, visit https://coursera.atlassian.net/wiki/spaces/UD/pages/179601459/Search#LTV-Optimized-Search.
   */
  BestMatch: 'BEST_MATCH',
  /**
   * Sort by newest launch date. Ranking by launch date descending. This is an A/B test on SERP. (More info:
   * https://coursera.atlassian.net/wiki/spaces/GROW/pages/3038740481/Sort+by+new+option+in+the+Consumer+and+Enterprise+Search+Experience)
   */
  New: 'NEW'
} as const;

export type Search_SortBy = typeof Search_SortBy[keyof typeof Search_SortBy];
/** The display size of an AI summary product card. */
export const Search_SummaryProductCardSize = {
  /** A condensed card size, used for the similar courses section of the summary. */
  Compact: 'COMPACT',
  /** The smallest card size, used for the primary result inline within the summary text. */
  Mini: 'MINI'
} as const;

export type Search_SummaryProductCardSize = typeof Search_SummaryProductCardSize[keyof typeof Search_SummaryProductCardSize];
/**
 * A single conversation message passed to `inferSearchRequest`. Intentionally
 * minimal — only the raw text is needed for LLM interpretation. If sender
 * distinction is needed later, add a senderType enum without breaking callers.
 */
export type Search_UserMessage = {
  /** The message text. Callers should send user messages only. */
  message: Scalars['String'];
};

/** SEO component link input */
export type Seo_ComponentLinkInput = {
  /** Url for this link */
  href: Scalars['URL'];
  /** Label for this link */
  label: Scalars['String'];
};

/** Header payload for domain skills suggestions */
export type Seo_DomainSkillsHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** Eqp content block input */
export type Seo_EqpContentBlockInput = {
  /** Content text */
  content: Scalars['String'];
  /** Label of content block */
  label: Scalars['String'];
};

/** Eqp bulk edit mutation */
export type Seo_EqpDataBulkEditV1MutationInput = {
  /** Collection of urls to delete */
  delete?: InputMaybe<Array<Scalars['String']>>;
  /** Write eqp data input */
  write?: InputMaybe<Array<Seo_EqpDataInput>>;
};

/** EQP Config result action */
export const Seo_EqpDataEditAction = {
  /**
   * EQP config was added
   * The eqp url was not present in the data store and a new record was written
   */
  Add: 'ADD',
  /**
   * EQP config was deleted
   * The url previously existed in the data store and was removed
   */
  Delete: 'DELETE',
  /**
   * Page data config was updated
   * The eqp url existed in the data store and the configuration fields for that path regex were overwritten
   */
  Update: 'UPDATE'
} as const;

export type Seo_EqpDataEditAction = typeof Seo_EqpDataEditAction[keyof typeof Seo_EqpDataEditAction];
/** Eqp data input */
export type Seo_EqpDataInput = {
  /** Bottom content block */
  bottomContentBlock?: InputMaybe<Seo_EqpContentBlockInput>;
  /** Description Tag */
  descriptionTag?: InputMaybe<Scalars['String']>;
  /** FAQ slug */
  faqSlug?: InputMaybe<Scalars['String']>;
  /** List of filter */
  filters: Array<Seo_EqpFilterInput>;
  /** Header */
  headers?: InputMaybe<Seo_EqpHeadersInput>;
  /**
   * Locale as defined by ISO 639-1 and ISO 3166-1 alpha-2 for language and country respectively.
   * E.g. "en-CA".
   * Not all locales are supported by EQP.
   */
  locale?: InputMaybe<Scalars['String']>;
  /** Title Tag */
  titleTag: Scalars['String'];
  /** Top content block */
  topContentBlock?: InputMaybe<Seo_EqpContentBlockInput>;
};

/** EQP filter input */
export type Seo_EqpFilterInput = {
  /** Filter field */
  field: Scalars['String'];
  /** Value of filter */
  value: Scalars['String'];
};

/** Customizable EQP headers input */
export type Seo_EqpHeadersInput = {
  /** Header payload for domain skills suggestions */
  domainSkillsHeader?: InputMaybe<Seo_DomainSkillsHeaderInput>;
  /** Header payload for related search suggestions */
  relatedSearchHeader?: InputMaybe<Seo_RelatedSearchHeaderInput>;
  /** Header payload for main search results */
  searchResultsHeader?: InputMaybe<Seo_SearchResultsHeaderInput>;
};

/** Eqp grouping mutation input */
export type Seo_EqpHreflangGroupingMutationInput = {
  /** List of hreflang links to group */
  hreflangLinks: Array<Seo_HreflangLinkInput>;
};

/** Eqp ungrouping mutation input */
export type Seo_EqpHreflangUngroupingMutationInput = {
  /** List of hreflang links to ungroup */
  hreflangLinks: Array<Seo_HreflangLinkInput>;
};

/** Footer category input */
export type Seo_FooterCategoryInput = {
  /** Header of category */
  header: Scalars['String'];
  /** Links in this category */
  links: Array<Seo_ComponentLinkInput>;
};

/** Header input */
export type Seo_HeaderInput = {
  /** Customizable EQP headers input */
  eqp?: InputMaybe<Seo_EqpHeadersInput>;
};

/** SEO Hreflang Link input */
export type Seo_HreflangLinkInput = {
  /** Hreflang link href attribute */
  href: Scalars['URL'];
  /** Hreflang Link hreflang attribute */
  hreflang: Scalars['String'];
};

/** Max Image Preview setting for robots meta tag */
export const Seo_MaxImagePreview = {
  /** Large image preview */
  Large: 'LARGE',
  /** No image preview */
  None: 'NONE',
  /** Standard image preview */
  Standard: 'STANDARD'
} as const;

export type Seo_MaxImagePreview = typeof Seo_MaxImagePreview[keyof typeof Seo_MaxImagePreview];
/** Mega menu input for specifying a top-level category */
export type Seo_MegaMenuCategoryInput = {
  /** Header label of the top-level category */
  header: Scalars['String'];
  /** Subcategory info */
  subcategories: Array<Seo_MegaMenuSubcategoryInput>;
};

/** Mega menu input for specifying category and links overrides */
export type Seo_MegaMenuInput = {
  /** Top level categories within the mega menu */
  categories: Array<Seo_MegaMenuCategoryInput>;
};

/** Subcategory info */
export type Seo_MegaMenuSubcategoryInput = {
  /** Header label of the subcategory */
  header: Scalars['String'];
  /** Links that will populate the menu subcategory contents */
  links: Array<Seo_ComponentLinkInput>;
};

/** Meta Tags input */
export type Seo_MetaTagsInput = {
  /** Canonical URL */
  canonicalURL?: InputMaybe<Scalars['URL']>;
  /** Description Tag */
  descriptionTag?: InputMaybe<Scalars['String']>;
  /**
   * Disable Crawler AI Flag
   * The default behavior is false, indicating that crawlers are allowed to use the content for AI on a given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from using content for AI training.
   */
  disableCrawlerAI?: InputMaybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Follow Flag
   * The default behavior is false, indicating that crawlers are allowed to follow links on the given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from following links.
   */
  disableCrawlerFollow?: InputMaybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Indexing Flag
   * The default behavior is false, indicating that crawlers are allowed to add the given page to their index.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given
   * page and that generated metatags should not block crawling.
   */
  disableCrawlerIndexing?: InputMaybe<Scalars['Boolean']>;
  /** Hreflang Links */
  hreflangLinks?: InputMaybe<Array<Seo_HreflangLinkInput>>;
  /**
   * Max Image Preview setting for robots meta tag
   * Controls the size of image preview shown in search results. A null value means no specific setting is applied.
   */
  maxImagePreview?: InputMaybe<Seo_MaxImagePreview>;
  /** Title Tag */
  titleTag?: InputMaybe<Scalars['String']>;
};

/** Page Data Config result action (add, update, delete) */
export const Seo_PageDataConfigResultActionV1 = {
  /**
   * Page data config was added
   * The pathRegex was not present in the data store and a new record was written
   */
  Add: 'ADD',
  /**
   * Page data config was deleted
   * The pathRegex previously existed in the data store and was removed
   */
  Delete: 'DELETE',
  /**
   * Page data config was updated
   * The pathRegex existed in the data store and the configuration fields for that path regex were overwritten
   */
  Update: 'UPDATE'
} as const;

export type Seo_PageDataConfigResultActionV1 = typeof Seo_PageDataConfigResultActionV1[keyof typeof Seo_PageDataConfigResultActionV1];
/** Full import input takes an array of every Page Data Config input in the pageData field */
export type Seo_PageDataFullImportV1MutationInput = {
  /** Array of all page data config inputs */
  pageData: Array<Seo_PageDataInputV1>;
};

/** Page Data Input */
export type Seo_PageDataInputV1 = {
  /** Global footer links */
  globalFooter?: InputMaybe<Array<Seo_FooterCategoryInput>>;
  /** Header text and links */
  headers?: InputMaybe<Seo_HeaderInput>;
  /** Mega menu categories and links */
  megaMenu?: InputMaybe<Seo_MegaMenuInput>;
  /** SEO Meta Tags */
  metaTags?: InputMaybe<Seo_MetaTagsInput>;
  /**
   * SEO page data path regex
   * This field defines a unique record
   */
  pathRegex: Scalars['String'];
  /**
   * SEO page data priority
   * Higher value has higher priority
   */
  priority: Scalars['Int'];
  /** Subfooter links */
  subfooter?: InputMaybe<Array<Seo_FooterCategoryInput>>;
};

/** Page data override input takes an array for overwrite, merge and delete */
export type Seo_PageDataOverrideV1MutationInput = {
  /** Path regexes to delete */
  delete?: InputMaybe<Array<Scalars['String']>>;
  /** Merge page data input */
  merge?: InputMaybe<Array<Seo_PageDataInputV1>>;
  /** Overwrite page data input */
  overwrite?: InputMaybe<Array<Seo_PageDataInputV1>>;
};

/** Header payload for related search suggestions */
export type Seo_RelatedSearchHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
  /** Custom links that will guide learners to related searches */
  links: Array<Seo_ComponentLinkInput>;
};

/** Input for robots.txt mutation */
export type Seo_RobotsTxtV1MutationInput = {
  /** Robots.txt content */
  content: Scalars['String'];
  /** Subdomain */
  subDomain: Scalars['String'];
};

/** Header payload for main search results */
export type Seo_SearchResultsHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** Item deadline to override */
export type SessionScheduleOverrides_DeadlineOverrideInput = {
  /**
   * The new deadline this item should have for the learner.
   * This can be null in order to delete the deadline override for this item.
   */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** The itemId to override the deadline for. */
  itemId: Scalars['ID'];
};

/** Item availability window to override */
export type SessionScheduleOverrides_ItemAvailbilityOverrideInput = {
  /** The itemId to override the availability window for */
  itemId: Scalars['ID'];
  /**
   * The availability window for the item.
   * This can be null in order to delete the availability override for this item.
   */
  timedItemLock?: InputMaybe<SessionScheduleOverrides_TimedItemLockInput>;
};

/** Field that indicates if an assessment itemId is accessible to read after the session ends. */
export type SessionScheduleOverrides_PatchSessionScheduleOverridesInput = {
  /**
   * Item deadlines to update
   * Optional, you do not have to set deadlineOverrides if not updating.
   */
  itemDeadlines?: InputMaybe<Array<SessionScheduleOverrides_DeadlineOverrideInput>>;
  /** The session ID */
  sessionId: Scalars['ID'];
  /**
   * Item availability windows to update.
   * Optional, you do not have to set timedItemLocks if not updating.
   */
  timedItemLocks?: InputMaybe<Array<SessionScheduleOverrides_ItemAvailbilityOverrideInput>>;
  /** The userId of the learner whose schedule should be overridden */
  userId: Scalars['ID'];
};

/** Indicates when an item will be available (unlocked) for a user */
export type SessionScheduleOverrides_TimedItemLockInput = {
  /** Duration of time from the start of the session to when the item will be relocked */
  relockTime: Scalars['Duration'];
  /** Duration of time from the start of the session to when the item will be unlocked */
  unlockTime: Scalars['Duration'];
};

/** Input for an delete item session mutation. */
export type Session_SessionSpecificItemOverrideDeleteInput = {
  /** The atom ID of the assessment to be deleted */
  assessmentAtomId: Scalars['ID'];
  /** The item ID of the assessment to be deleted */
  assessmentItemId: Scalars['ID'];
  /**
   * The optional dateTime of when post session read access to the item is closed. If empty, post
   * session read access is permanently on.
   */
  deleteReadAccessItemRelockTime?: InputMaybe<Scalars['Boolean']>;
};

/** Input for a session specific item override, can be update or delete */
export type Session_SessionSpecificItemOverrideInput = {
  /** Delete different assessments properties for specific session */
  delete?: InputMaybe<Session_SessionSpecificItemOverrideDeleteInput>;
  /** Update different assessments properties for specific session */
  update?: InputMaybe<Session_SessionSpecificItemOverrideUpdateInput>;
};

/** Field that indicates if an assessment itemId is accessible to read after the session ends. */
export type Session_SessionSpecificItemOverrideUpdateInput = {
  /** The atom ID of the assessment */
  assessmentAtomId: Scalars['ID'];
  /** The item ID of the assessment */
  assessmentItemId: Scalars['ID'];
  /**
   * The optional dateTime of when post session read access to the item is closed. If empty, post
   * session read access is permanently on.
   */
  readAccessItemRelockTime?: InputMaybe<Scalars['DateTime']>;
};

/** Input for an update item override in session mutation. */
export type Session_UpdateSessionSpecificItemOverridesInput = {
  /** The session ID for the session to be updated */
  sessionId: Scalars['ID'];
  /**
   * List of itemId -> dateTime to indicate if an assessment item can be accessible to read after
   * the session ends.
   */
  sessionSpecificItemOverrides?: InputMaybe<Array<Session_SessionSpecificItemOverrideInput>>;
};

export const SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = {
  CopiedFromLimitedAvailabilityBranch: 'COPIED_FROM_LIMITED_AVAILABILITY_BRANCH',
  CourseHasDegreeSession: 'COURSE_HAS_DEGREE_SESSION',
  CourseIsExempt: 'COURSE_IS_EXEMPT',
  IrregularCadence: 'IRREGULAR_CADENCE',
  PartnerIsExempt: 'PARTNER_IS_EXEMPT'
} as const;

export type SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = typeof SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason[keyof typeof SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason];
export const SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = {
  CopiedFromLimitedAvailabilityBranch: 'COPIED_FROM_LIMITED_AVAILABILITY_BRANCH',
  CourseHasDegreeSession: 'COURSE_HAS_DEGREE_SESSION',
  CourseIsExempt: 'COURSE_IS_EXEMPT',
  IrregularCadence: 'IRREGULAR_CADENCE',
  PartnerIsExempt: 'PARTNER_IS_EXEMPT'
} as const;

export type SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = typeof SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason[keyof typeof SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason];
/** GraphQL representation of BillingCycle.courier */
export const SharedOwnableProduct_BillingCycle = {
  /** Annual Billing Cycle */
  BillingCycleAnnual: 'BILLING_CYCLE_ANNUAL',
  /** Biannual Billing Cycle */
  BillingCycleBiannual: 'BILLING_CYCLE_BIANNUAL',
  /** Invalid Billing Cycle */
  BillingCycleInvalid: 'BILLING_CYCLE_INVALID',
  /** Monthly Billing Cycle */
  BillingCycleMonthly: 'BILLING_CYCLE_MONTHLY'
} as const;

export type SharedOwnableProduct_BillingCycle = typeof SharedOwnableProduct_BillingCycle[keyof typeof SharedOwnableProduct_BillingCycle];
/**
 * This enum represents all the ownable product types at Coursera.
 * This is different from ProductType because product type has both underlying and top-level product types
 * whereas OwnableProductType are only the underlying product types.s
 * For more information refer to `OwnableProduct::productType`.
 */
export const SharedOwnableProduct_OwnableProductType = {
  /** Catalog subscription. */
  OwnableProductTypeCatalogSubscription: 'OWNABLE_PRODUCT_TYPE_CATALOG_SUBSCRIPTION',
  /**
   * [2022 Q2] payment-experience is working on the Coursera Plus Prepaid (one-time payment scheme) product.
   *
   * We've been rethinking the product configuration system as a part of the Next Gen Product Configuration System
   * project (https://coursera.atlassian.net/wiki/spaces/B2C/pages/2090336410/Next+Gen+Product+Configuration+System).
   * Due to this rethinking, we've decided to deviate from past patterns for concurrently selling products under
   * one-time and subscription payment schemes (e.g. s12ns use 3 Specialization* ProductTypes).
   *
   * Our current plan for supporting Coursera Plus in general is:
   *   - Coursera Plus Prepaid: use ProductType.CourseraPlus for (using legacy terminology) both the product_item_id
   *     and the underlying_product_item_id
   *   - Coursera Plus Subscription: use ProductType.CourseraPlusSubscription for (using legacy terminology) both the
   *     product_item_id and the underlying_product_item_id
   *
   * Eventually we hope to deprecate ProductType.CourseraPlusSubscription entirely in favor of
   * ProductType.CourseraPlus and the SubscriptionPaymentScheme (https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/product/PaymentScheme.courier)/
   * This worked is captured by Phase 4 of Next Gen Product Configuration System.
   */
  OwnableProductTypeCourseraPlus: 'OWNABLE_PRODUCT_TYPE_COURSERA_PLUS',
  /** Internal representation of a site-wide subscription at Coursera. */
  OwnableProductTypeCourseraPlusSubscription: 'OWNABLE_PRODUCT_TYPE_COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  OwnableProductTypeCourseraTierLite: 'OWNABLE_PRODUCT_TYPE_COURSERA_TIER_LITE',
  /**
   * Internal representation of the Master track product line at Coursera which is a collection of
   * courses sold as an elevated degree content.
   */
  OwnableProductTypeCredentialTrackSubscription: 'OWNABLE_PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION',
  /**
   * The updated internal representation of the Master track product line at Coursera.
   *
   * A new version of CredentialTrackSubscription/CredentialTrackCourse that has different
   * revenue recognition and ownership granting logic from the original version.
   *
   * Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  OwnableProductTypeCredentialTrackSubscriptionV2: 'OWNABLE_PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /**
   * Represents an enterprise contract. This is not an ownable product type, but a purchasable
   * product type. This is used to represent the enterprise contract in the checkout flow.
   */
  OwnableProductTypeEnterpriseContract: 'OWNABLE_PRODUCT_TYPE_ENTERPRISE_CONTRACT',
  /** Facilitated learning. */
  OwnableProductTypeFacilitatedLearning: 'OWNABLE_PRODUCT_TYPE_FACILITATED_LEARNING',
  /** Interest deposit. */
  OwnableProductTypeInterestDeposit: 'OWNABLE_PRODUCT_TYPE_INTEREST_DEPOSIT',
  /** Invalid product type. This is used as a default value. */
  OwnableProductTypeInvalid: 'OWNABLE_PRODUCT_TYPE_INVALID',
  /** Spark course shell. */
  OwnableProductTypeSparkCourseShell: 'OWNABLE_PRODUCT_TYPE_SPARK_COURSE_SHELL',
  /** Spark specialization. */
  OwnableProductTypeSparkSpecialization: 'OWNABLE_PRODUCT_TYPE_SPARK_SPECIALIZATION',
  /** Spark verified certificate. */
  OwnableProductTypeSparkVerifiedCertificate: 'OWNABLE_PRODUCT_TYPE_SPARK_VERIFIED_CERTIFICATE',
  /**
   * Internal representation of the specialization product type. It represents a collection of
   * courses that are part of a specialization.
   */
  OwnableProductTypeSpecialization: 'OWNABLE_PRODUCT_TYPE_SPECIALIZATION',
  /**
   * Internal representation of the course product type. This represents all the courses at
   * Coursera including guided projects, course in specializations and course in degrees.
   */
  OwnableProductTypeVerifiedCertificate: 'OWNABLE_PRODUCT_TYPE_VERIFIED_CERTIFICATE'
} as const;

export type SharedOwnableProduct_OwnableProductType = typeof SharedOwnableProduct_OwnableProductType[keyof typeof SharedOwnableProduct_OwnableProductType];
/**
 * Container object for information required to enroll enterprise user in the course using an enterprise program.
 * User id will be picked up from logged-in context
 */
export type ShortFormContent_EnrollEnterpriseUserIntoCourseInput = {
  /** Course id enterprise user attempts to enroll into */
  courseId: Scalars['String'];
  /**
   * Video item id. This is needed so that mutation result can contain
   * video assets information that becomes available to user
   * on the successful enrollment
   */
  itemId: Scalars['String'];
  /** Enterprise programs to be used for course enrollment. */
  programId: Scalars['String'];
  /**
   * This flag is used to unsubscribe learner from all course notifications (including emails)
   * For SFC MVP launch it should be true by default. Later on, FE will be able to start supporting it via
   * checkbox, so this default value for this parameter can be removed
   */
  unsubscribeFromCourseNotifications?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context
 * NOTE: Specifying Enterprise context is no longer supported, this type shouldn't be used!
 */
export type ShortFormContent_QueryVideoDataForEnterpriseOrganizationContextInput = {
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /** Video item id */
  itemId: Scalars['String'];
  /**
   * Optional OrganizationId identifying the list of programs to be considered as enterprise SFC VLP
   * preview and enrollment context
   */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Optional Organization slug to be considered as enterprise SFC VLP preview and enrollment context */
  organizationSlug?: InputMaybe<Scalars['String']>;
};

/**
 * Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context
 * NOTE: Specifying Enterprise context is no longer supported, this type shouldn't be used!
 */
export type ShortFormContent_QueryVideoDataForEnterpriseProgramContextInput = {
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /** Video item id */
  itemId: Scalars['String'];
  /** Optional Program id to be considered as enterprise SFC VLP preview and enrollment context */
  programId?: InputMaybe<Scalars['String']>;
  /** Optional Program slug to be considered as enterprise SFC VLP preview and enrollment context */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context */
export type ShortFormContent_QueryVideoDataInput = {
  /** List of atom ids for the batch query */
  atomIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /**
   * Video item id
   * @deprecated Use itemIds instead
   */
  itemId?: InputMaybe<Scalars['String']>;
  /** List of item ids for batch query */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional Program slug to be considered as enterprise short-form-content (SFC) VLP preview and enrollment context.
   * The FE may specify a program slug to the SFC service, indicates which program video watch progress and enrollment occurs against.
   */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Container object for information required to track user video progress */
export type ShortFormContent_TrackVideoProgressInput = {
  /** Course id that contains the video being tracked */
  courseId: Scalars['String'];
  /**
   * This represents current video progress ms. It is a timestamp correposnding to the location at which user
   * is currently in the video
   */
  currentVideoProgressMs: Scalars['Int'];
  /** Video item id corresponding to the video being tracked */
  itemId: Scalars['String'];
  /** Optional OrganizationId. The FE may specify an organizationId to the SFC service, indicates which organization video watch progress and enrollment occurs against. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional programId. The FE may specify a programId to the SFC service, indicates which
   * program video watch progress and enrollment occurs against.
   */
  programId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional Program slug to be considered as enterprise short-form-content (SFC) VLP preview and enrollment context.
   * The FE may specify a program slug to the SFC service, indicates which program video watch progress and enrollment occurs against.
   */
  programSlug?: InputMaybe<Scalars['String']>;
  /**
   * Total video duration. This is needed because sometimes video metadata in the BE contains incorrect information
   * and only web player would know it reliably when it loaded the video
   */
  totalVideoDurationMs: Scalars['Int'];
};

/** TODO: Complete this description */
export const SimilarityCheckContextType = {
  /** TODO: Complete this description */
  Degree: 'DEGREE',
  /** TODO: Complete this description */
  Enterprise: 'ENTERPRISE'
} as const;

export type SimilarityCheckContextType = typeof SimilarityCheckContextType[keyof typeof SimilarityCheckContextType];
/**
 * The reason why the similarity check was failed. This contains both internal errors
 * that lead to us not even submitting the check to the external provider and vendor provided
 * errors when the check was submitted but failed for some reason.
 */
export const SimilarityCheck_ErrorCode = {
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because the content could not be extracted.
   */
  CannotExtractText: 'CANNOT_EXTRACT_TEXT',
  /** The submission was not submitted to the external provider for an unspecified reason. */
  DidNotSubmit: 'DID_NOT_SUBMIT',
  /** The submission was not submitted and a default record was created for the submission. */
  DidNotSubmitDefaultRecord: 'DID_NOT_SUBMIT_DEFAULT_RECORD',
  /** The submission was not submitted to the external provider because no content was found. */
  DidNotSubmitNoContent: 'DID_NOT_SUBMIT_NO_CONTENT',
  /** The submission was not submitted to the external provider because the file type is not supported. */
  DidNotSubmitUnsupportedFileType: 'DID_NOT_SUBMIT_UNSUPPORTED_FILE_TYPE',
  /** The submission was not submitted to the external provider because the upload failed. */
  DidNotSubmitUploadFailed: 'DID_NOT_SUBMIT_UPLOAD_FAILED',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because the file was locked.
   */
  FileLocked: 'FILE_LOCKED',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * for an unspecified reason. Likely indicates that an error code is not captured in this enum
   * and should be added.
   */
  Other: 'OTHER',
  /** The submission was submitted to the external provider, but the provider failed to process it. */
  ProcessingError: 'PROCESSING_ERROR',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there was not enough content.
   */
  TooLittleText: 'TOO_LITTLE_TEXT',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there were too many pages.
   */
  TooManyPages: 'TOO_MANY_PAGES',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there was too much content.
   */
  TooMuchText: 'TOO_MUCH_TEXT',
  /**
   * The submission was submited to the external provider, but the provider failed to process it due
   * to the file type.
   */
  UnsupportedFileType: 'UNSUPPORTED_FILE_TYPE'
} as const;

export type SimilarityCheck_ErrorCode = typeof SimilarityCheck_ErrorCode[keyof typeof SimilarityCheck_ErrorCode];
/** An individual submitter. This is a user who authored and submitted the assignment. */
export type SimilarityCheck_IndividualSubmitter = {
  /** The submitter of the assignment */
  submitterId: Scalars['ID'];
};

/**
 * Data necessary to identify a submission which has been previously submitted when we
 * do not have the similarity check id.
 */
export type SimilarityCheck_MetadataInput = {
  /**
   * This endpoint will, in general, submit the most recent submission for checking.
   * When this flag is set, draft submissions will be considered when finding the
   * most recent submission.
   */
  considerDrafts: Scalars['Boolean'];
  /** The course for the item to be checked */
  courseId: Scalars['ID'];
  /** The id of the item to be checked */
  itemId: Scalars['ID'];
  /** The response id of the item to be checked for the given author/submitter */
  responseId: Scalars['ID'];
  /** The submitter of the item to be checked */
  submitter: SimilarityCheck_Submitter;
};

/** Data necessary to identify a submission which should be checked for similarity. */
export type SimilarityCheck_SubmitInput = {
  /**
   * This endpoint will, in general, submit the most recent submission for checking.
   * When this flag is set, draft submissions will be considered when finding the
   * most recent submission.
   */
  considerDrafts: Scalars['Boolean'];
  /** The course for the item to be checked */
  courseId: Scalars['ID'];
  /** The id of the item to be checked */
  itemId: Scalars['ID'];
  /** The response id of the item to be checked for the given author/submitter */
  responseId: Scalars['ID'];
  /**
   * As of 2021-11-26, this field is used to create cheating cases for peer review submissions with
   * similarity scores over the threshold. It is ignored for SGA submissions. If this field is not
   * set, we will not create a cheating case regardless of score.
   */
  submissionKey?: InputMaybe<Scalars['String']>;
  /** The submitter of the item to be checked */
  submitter: SimilarityCheck_Submitter;
};

/** The submitter of the submission. This is either an individual or a team. */
export type SimilarityCheck_Submitter = {
  /** An individual author/submitter */
  individualSubmitter?: InputMaybe<SimilarityCheck_IndividualSubmitter>;
  /** A team submission and the submission author */
  teamSubmitter?: InputMaybe<SimilarityCheck_TeamSubmitter>;
};

/** A team submitter. This contains the author of the submission and the author's team. */
export type SimilarityCheck_TeamSubmitter = {
  /** The scoped team id that the author is a member of */
  scopedTeamId: Scalars['ID'];
  /** The submitter of the assignment */
  submitterId: Scalars['ID'];
};

/** Credit level for skill expression mastery */
export const SkillAttainmentProgress_AttainmentStatus = {
  /** Full credit - skill expression fully attained */
  FullAttainment: 'FULL_ATTAINMENT',
  /** No credit - skill expression not attained */
  NoAttainment: 'NO_ATTAINMENT'
} as const;

export type SkillAttainmentProgress_AttainmentStatus = typeof SkillAttainmentProgress_AttainmentStatus[keyof typeof SkillAttainmentProgress_AttainmentStatus];
/** Input type for the SkillAttainment_GenerateProgressReport mutation. */
export type SkillAttainment_GenerateProgressReportInput = {
  /** Career Band for the skill attainments to be returned in the report. */
  careerBand: VerifiedSkills_CareerBand;
  /** Occupation Group ID for the skill attainments to be returned in the report. */
  occupationGroupId: Scalars['ID'];
  /** List of program IDs whose enrolled users will be included in the generated progress report. */
  programIds: Array<Scalars['ID']>;
};

/**
 * Mastery level of a skill. More info on the differences between levels can be found here:
 * https://www.figma.com/board/1PGhhkVdMFqgm8NU1XGZFs/Degree-Data-For-Mastery-Verification?node-id=1-162&node-type=frame&t=krBlcqRPJeoGOlTW-0
 */
export const SkillMasteryLevels_MasteryLevel = {
  /** Mastery level 1. */
  MasteryLevel_1: 'MASTERY_LEVEL_1',
  /** Mastery level 2. */
  MasteryLevel_2: 'MASTERY_LEVEL_2',
  /** Mastery level 3. */
  MasteryLevel_3: 'MASTERY_LEVEL_3',
  /** Mastery level 4. */
  MasteryLevel_4: 'MASTERY_LEVEL_4'
} as const;

export type SkillMasteryLevels_MasteryLevel = typeof SkillMasteryLevels_MasteryLevel[keyof typeof SkillMasteryLevels_MasteryLevel];
/**
 * The highest Bloom's-taxonomy cognitive level the item requires of the
 * learner with respect to the skill expression.
 */
export const SkillMastery_BloomLevel = {
  /**
   * Break information into parts, compare alternatives, identify
   * relationships, diagnose causes, or distinguish patterns.
   */
  Analyze: 'ANALYZE',
  /**
   * Execute a known method in a familiar context (routine problems or
   * procedural tasks).
   */
  Apply: 'APPLY',
  /**
   * Produce original work by combining ideas into a new solution, design,
   * artifact, or plan.
   */
  Create: 'CREATE',
  /**
   * Judge quality or correctness against criteria; justify decisions,
   * critiques, or recommendations.
   */
  Evaluate: 'EVALUATE',
  /**
   * Recall facts, terms, definitions, or simple statements with no
   * interpretation required.
   */
  Remember: 'REMEMBER',
  /**
   * Explain, summarize, paraphrase, interpret, or recognize conceptual
   * meaning.
   */
  Understand: 'UNDERSTAND'
} as const;

export type SkillMastery_BloomLevel = typeof SkillMastery_BloomLevel[keyof typeof SkillMastery_BloomLevel];
/** What the item asks the learner to do, on the ICAP spectrum. */
export const SkillMastery_InteractionMode = {
  /**
   * Producing something: typing answers, writing code, recording video,
   * drawing, designing, building artifacts, or uploading work.
   */
  Constructive: 'CONSTRUCTIVE',
  /**
   * Reading, watching, listening, or clicking "Next" (e.g., lectures,
   * videos, readings, recaps).
   */
  Passive: 'PASSIVE',
  /**
   * Constrained-response interactions: multiple choice, drag-and-drop,
   * matching, selecting from options.
   */
  Selective: 'SELECTIVE'
} as const;

export type SkillMastery_InteractionMode = typeof SkillMastery_InteractionMode[keyof typeof SkillMastery_InteractionMode];
/**
 * Pedagogical relationship between a course item and a skill expression. The
 * three values ingested in v1 are listed in priority order (ASSESS >
 * PRACTICE_APPLY > TEACH_DEVELOP).
 */
export const SkillMastery_SkillContentCategory = {
  /**
   * Summative: the item asks the learner to demonstrate the skill for
   * evaluation, without scaffolding, hints, or immediate feedback.
   */
  Assess: 'ASSESS',
  /**
   * Formative: the item asks the learner to apply the skill with scaffolding,
   * hints, guidance, or immediate feedback.
   */
  PracticeApply: 'PRACTICE_APPLY',
  /**
   * Instructional: the item explicitly teaches how to perform the skill or
   * explains the deeper why behind it (e.g., demonstrations, worked examples,
   * step-by-step directions).
   */
  TeachDevelop: 'TEACH_DEVELOP'
} as const;

export type SkillMastery_SkillContentCategory = typeof SkillMastery_SkillContentCategory[keyof typeof SkillMastery_SkillContentCategory];
/**
 * Optional facet filters for Skill Mastery queries (ML data only). Within a
 * facet, values are OR-ed; across facets, conditions are AND-ed. Filters
 * match on individual (item, skill expression) tag rows, so multi-facet AND
 * preserves per-tag correlation. Ignored when curated VSP data is served.
 *
 * The server already enforces `effectivenessLevel >= 2` and a
 * `skillContentCategory` whitelist (ASSESS, PRACTICE_APPLY, TEACH_DEVELOP)
 * at ingestion.
 */
export type SkillMastery_TagFilters = {
  /** Restrict to these Bloom levels. Null/empty means any. */
  bloomLevels?: InputMaybe<Array<SkillMastery_BloomLevel>>;
  /** Restrict to these interaction modes. Null/empty means any. */
  interactionModes?: InputMaybe<Array<SkillMastery_InteractionMode>>;
  /**
   * Tightens the effectiveness floor above the server baseline of 2. Values
   * below the baseline are clamped up.
   */
  minimumEffectivenessLevel?: InputMaybe<Scalars['Int']>;
  /** Restrict to these skill-content categories. Null/empty means any. */
  skillContentCategories?: InputMaybe<Array<SkillMastery_SkillContentCategory>>;
};

/** input for associating skill-ids to/from a contract-tag. */
export type SkillRestrictedContractTag_AddContractTagSkillIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-ids to be associated/dissociated to/from a contract-tag */
  skillIds: Array<Scalars['ID']>;
};

/** input for associating a domain-id and subdomain-id to a contract-tag */
export type SkillRestrictedContractTag_DomainIdAndSubdomainIdsInput = {
  /** Domain ID */
  domainId: Scalars['ID'];
  /** Subdomain ID */
  subdomainIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** input for dissociating domain-ids and subdomain-ids from a contract-tag */
export type SkillRestrictedContractTag_RemoveContractTagDomainIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** domain-ids to be dissociated from a contract-tag. All subdomain-ids associated with the domain-id will be dissociated as well. */
  domainIds: Array<Scalars['ID']>;
};

/** input for dissociating skill-ids to/from a contract-tag */
export type SkillRestrictedContractTag_RemoveContractTagSkillIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-ids to be associated/dissociated to/from a contract-tag */
  skillIds: Array<Scalars['ID']>;
};

/** input for updating skill relevancy */
export type SkillRestrictedContractTag_UpdateSkillRelevancyInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-id associated with the contract-tag */
  skillId: Scalars['ID'];
  /** new skill relevancy value to update to */
  skillRelevancy: Scalars['Float'];
};

/** input for upserting domain-id and subdomain-ids to a contract-tag */
export type SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** domain-id and subdomain-ids to be associated/dissociated to/from a contract-tag */
  domainIdAndSubdomainIds: SkillRestrictedContractTag_DomainIdAndSubdomainIdsInput;
};

/** An enum representing a content type. */
export const SkillScores_ContentType = {
  /** Course type. */
  Course: 'COURSE'
} as const;

export type SkillScores_ContentType = typeof SkillScores_ContentType[keyof typeof SkillScores_ContentType];
/** An enum representing a skill level. */
export const SkillScores_SkillLevel = {
  /** Skill score from 351-500. */
  Advanced: 'ADVANCED',
  /** Skill score from 51-150. */
  Beginner: 'BEGINNER',
  /** Skill score from 0-50. */
  Conversant: 'CONVERSANT',
  /** Skill score from 151-350. */
  Intermediate: 'INTERMEDIATE'
} as const;

export type SkillScores_SkillLevel = typeof SkillScores_SkillLevel[keyof typeof SkillScores_SkillLevel];
/** Skill Score argument parameter. */
export type SkillScores_SkillScore = {
  /** The score for the skill. */
  score: Scalars['Int'];
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
};

/** Benchmark type for skill score percentile. */
export const SkillScores_SkillScorePercentileType = {
  /** Percentile data with respect to all users on Coursera. */
  CourseraBenchmark: 'COURSERA_BENCHMARK',
  /** Percentile data with respect to all users for an occupation. */
  OccupationBenchmark: 'OCCUPATION_BENCHMARK'
} as const;

export type SkillScores_SkillScorePercentileType = typeof SkillScores_SkillScorePercentileType[keyof typeof SkillScores_SkillScorePercentileType];
/** The goal type of a skill set */
export const SkillSetCardsComponentSkillSet_GoalType = {
  /** Signifies a LITERACY goalType */
  Literacy: 'LITERACY',
  /** Signifies a RESKILL goalType */
  Reskill: 'RESKILL',
  /** Signifies a UPSKILL goalType */
  Upskill: 'UPSKILL'
} as const;

export type SkillSetCardsComponentSkillSet_GoalType = typeof SkillSetCardsComponentSkillSet_GoalType[keyof typeof SkillSetCardsComponentSkillSet_GoalType];
/** Level of difficulty for a piece of content (e.g. course or specialization). */
export const SkillTags_DifficultyLevel = {
  /** ADVANCED skill level */
  DifficultyLevelAdvanced: 'DIFFICULTY_LEVEL_ADVANCED',
  /** BEGINNER skill level */
  DifficultyLevelBeginner: 'DIFFICULTY_LEVEL_BEGINNER',
  /** INTERMEDIATE skill level */
  DifficultyLevelIntermediate: 'DIFFICULTY_LEVEL_INTERMEDIATE',
  /** INVALID skill level */
  DifficultyLevelInvalid: 'DIFFICULTY_LEVEL_INVALID'
} as const;

export type SkillTags_DifficultyLevel = typeof SkillTags_DifficultyLevel[keyof typeof SkillTags_DifficultyLevel];
/** Query skills request. */
export type Skill_QuerySkillsRequest = {
  /**
   * Filter query by child skill IDs.
   * The query results will include skills with child skill IDs that match any child_skill_ids provided.
   */
  childSkillIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by domain IDs.
   * The query results will include skills with domain IDs that match domain_ids provided.
   */
  domainIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by granularities.
   * The query results will include skills with granularity match any granularities provided.
   */
  granularities?: InputMaybe<Array<Scalars['Int']>>;
  /** If set to true, only skills eligible for scoring will be returned. Defaults to true if is not set. */
  includeOnlyEligibleForScoring?: Scalars['Boolean'];
  /**
   * Filter query by minimum number of recommendations.
   * The query results will include skills with number of recs that's equal to or larger than provided minimum number.
   * Defaults to 0 if not set.
   * 0 means no filtering because number of recs is no less than 0.
   */
  minimumNumberOfRecs?: Scalars['Int'];
  /**
   * Filter query by occupation IDs.
   * The query results will include skills with occupation IDs that match occupation_ids provided.
   */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by parent skill IDs.
   * The query results will include skills with parent skill IDs that match any parent_skill_ids provided.
   */
  parentSkillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter query by the skill names. */
  skillNames?: InputMaybe<Array<Scalars['String']>>;
  /** How to sort the results. If empty or null, sorting by skill ids as default. */
  skillSorts?: InputMaybe<Array<Skill_Sort>>;
};

/** Acceptable ways to sort skills. */
export const Skill_Sort = {
  /** Sort by enrollment of tagged course in ascending order. */
  CourseEnrollmentAsc: 'COURSE_ENROLLMENT_ASC',
  /** Sort by enrollment of tagged course in descending order. */
  CourseEnrollmentDesc: 'COURSE_ENROLLMENT_DESC',
  /** Sort by number of tagged courses in ascending order. */
  CourseTagsAsc: 'COURSE_TAGS_ASC',
  /** Sort by number of tagged courses in descending order. */
  CourseTagsDesc: 'COURSE_TAGS_DESC',
  /** Sort by full text search score. */
  FullTextSearchScore: 'FULL_TEXT_SEARCH_SCORE',
  /** Sort by skill granularity in ascending order. */
  GranularityAsc: 'GRANULARITY_ASC',
  /** Sort by skill granularity in descending order. */
  GranularityDesc: 'GRANULARITY_DESC',
  /** Sort by skill name in ascending order. */
  LexicographicOrderAsc: 'LEXICOGRAPHIC_ORDER_ASC',
  /** Sort by skill name in descending order. */
  LexicographicOrderDesc: 'LEXICOGRAPHIC_ORDER_DESC'
} as const;

export type Skill_Sort = typeof Skill_Sort[keyof typeof Skill_Sort];
/** The skill progress' level set status */
export const SkillsFocusComponentSkillProgress_LevelSetProgressStatus = {
  /** Signifies a COMPLETED_ALL levelSet */
  CompletedAll: 'COMPLETED_ALL',
  /** Signifies a COMPLETED_ONCE levelSet */
  CompletedOnce: 'COMPLETED_ONCE',
  /** Signifies an IN_PROGRESS levelSet */
  InProgress: 'IN_PROGRESS',
  /** Signifies a NOT_STARTED levelSet */
  NotStarted: 'NOT_STARTED',
  /** Signifies a UNAVAILABLE levelSet */
  Unavailable: 'UNAVAILABLE'
} as const;

export type SkillsFocusComponentSkillProgress_LevelSetProgressStatus = typeof SkillsFocusComponentSkillProgress_LevelSetProgressStatus[keyof typeof SkillsFocusComponentSkillProgress_LevelSetProgressStatus];
/** LevelSet progress status for a particular skill */
export const SkillsProgress_LevelSetProgressStatus = {
  /** Signifies a COMPLETED levelSet */
  Completed: 'COMPLETED',
  /** Signifies an IN_PROGRESS levelSet */
  InProgress: 'IN_PROGRESS',
  /** Signifies a NOT_STARTED levelSet */
  NotStarted: 'NOT_STARTED'
} as const;

export type SkillsProgress_LevelSetProgressStatus = typeof SkillsProgress_LevelSetProgressStatus[keyof typeof SkillsProgress_LevelSetProgressStatus];
/** Level for a specified skill */
export const SkillsProgress_SkillLevel = {
  /** ADVANCED skill level */
  Advanced: 'ADVANCED',
  /** BEGINNER skill level */
  Beginner: 'BEGINNER',
  /** CONVERSANT skill level */
  Conversant: 'CONVERSANT',
  /** INTERMEDIATE skill level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type SkillsProgress_SkillLevel = typeof SkillsProgress_SkillLevel[keyof typeof SkillsProgress_SkillLevel];
/** Whether we should sort ascending or descending */
export const SkillsProgress_SortDirection = {
  /** Sort from low to high */
  Asc: 'ASC',
  /** Sort from high to low */
  Desc: 'DESC'
} as const;

export type SkillsProgress_SortDirection = typeof SkillsProgress_SortDirection[keyof typeof SkillsProgress_SortDirection];
/** The field that we want to sort by */
export const SkillsProgress_SortField = {
  /** Sorts skills based on relevancy from search query */
  Relevancy: 'RELEVANCY',
  /** Sorts skills by when the skill name */
  SkillName: 'SKILL_NAME',
  /** Sorts skills by learner's score */
  SkillScore: 'SKILL_SCORE',
  /** Sorts skills by when the skill score was last updated */
  UpdatedAt: 'UPDATED_AT'
} as const;

export type SkillsProgress_SortField = typeof SkillsProgress_SortField[keyof typeof SkillsProgress_SortField];
/** The order in which skill progress information should be returned. */
export type SkillsProgress_SortOption = {
  /** Whether we should sort ascending or descending */
  direction: SkillsProgress_SortDirection;
  /** The field that we want to sort by */
  field: SkillsProgress_SortField;
};

/** Content ID. */
export type SkillsTagsLabeling_ContentId = {
  /** Course ID. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Course and item ID. */
  courseItemId?: InputMaybe<SkillsTagsLabeling_CourseItemId>;
};

/** Course and Item ID. */
export type SkillsTagsLabeling_CourseItemId = {
  /** Course ID. */
  courseId: Scalars['ID'];
  /** Item ID. */
  itemId: Scalars['ID'];
};

/** Relevancy. */
export const SkillsTagsLabeling_Relevancy = {
  /** Skill is not relevant. */
  No: 'NO',
  /** It is unclear if skill is relevant. */
  Unsure: 'UNSURE',
  /** Skill is relevant. */
  Yes: 'YES'
} as const;

export type SkillsTagsLabeling_Relevancy = typeof SkillsTagsLabeling_Relevancy[keyof typeof SkillsTagsLabeling_Relevancy];
/** Relevancy of a specific skill. */
export type SkillsTagsLabeling_SkillRelevancyInput = {
  /** Relevance of skill. */
  relevancy: SkillsTagsLabeling_Relevancy;
  /** Skill ID. */
  skillId: Scalars['ID'];
};

/** Source for a skill. */
export const SkillsTagsLabeling_SkillSource = {
  /** Core skill. */
  Core: 'CORE',
  /** Lightcast skill. */
  Lightcast: 'LIGHTCAST'
} as const;

export type SkillsTagsLabeling_SkillSource = typeof SkillsTagsLabeling_SkillSource[keyof typeof SkillsTagsLabeling_SkillSource];
/** Input of the SkillsTagsLabeling_UpdateSkillsTagsLabeling mutation. */
export type SkillsTagsLabeling_UpdateSkillsTagsLabelingInput = {
  /** ID of content being tagged. */
  contentId: SkillsTagsLabeling_ContentId;
  /** List of skills and their relevance to the content. */
  skillsRelevancies: Array<SkillsTagsLabeling_SkillRelevancyInput>;
};

/** Sorting direction for the SkillTag based on the taggedAssessmentFraction */
export const SkillsTags_SortDirection = {
  /** ASCENDING sorting order */
  Ascending: 'ASCENDING',
  /** DESCENDING sorting order */
  Descending: 'DESCENDING'
} as const;

export type SkillsTags_SortDirection = typeof SkillsTags_SortDirection[keyof typeof SkillsTags_SortDirection];
/** Input argument of an organization id or program id. */
export type SkillsTracking_OrgOrProgramId = {
  /** Organization id. */
  orgId?: InputMaybe<Scalars['ID']>;
  /** Program id. */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Input used to update list of tracked skills. */
export type SkillsTracking_UpdateSkillsTrackingInput = {
  /** ID of org or program that is tracking skills. */
  orgOrProgramId: SkillsTracking_OrgOrProgramId;
  /** List of skills tracked. */
  skillIds: Array<Scalars['ID']>;
};

/** Input for creating a new social cohort. */
export type SocialCohort_CreateCohortInput = {
  /** Optional description of the cohort. */
  description?: InputMaybe<Scalars['String']>;
  /** Client-provided unique identifier for the cohort. */
  id: Scalars['String'];
  /**
   * How memberships should be modeled for this cohort. When omitted, defaults to
   * EXPLICIT_JOIN, meaning learners must explicitly join to become members. This
   * is immutable after creation and cannot be changed via UpdateCohort.
   */
  membershipModel?: SocialCohort_MembershipModel;
  /** Human-readable name of the cohort. */
  name: Scalars['String'];
  /** Optional parent cohort ID to create a child cohort. */
  parentCohortId?: InputMaybe<Scalars['ID']>;
  /** Optional type classification for the cohort. */
  type?: InputMaybe<Scalars['String']>;
};

/** Input for deleting a social cohort. */
export type SocialCohort_DeleteCohortInput = {
  /** ID of the cohort to delete. */
  cohortId: Scalars['ID'];
};

/**
 * Determines how memberships are modeled for a cohort. This is set at creation
 * time and is immutable thereafter.
 */
export const SocialCohort_MembershipModel = {
  /**
   * Learners must explicitly join the cohort (e.g. by clicking a join CTA) to
   * become a member. They are not members by default. This is the default when
   * no membership model is specified at creation time.
   */
  ExplicitJoin: 'EXPLICIT_JOIN',
  /**
   * Learners are members of the cohort by default without having to explicitly
   * join, unless they opt out. Because membership is implicit, the size of the
   * cohort (how many users have membership) is unknown, so cohortSize is null.
   */
  MemberByDefault: 'MEMBER_BY_DEFAULT'
} as const;

export type SocialCohort_MembershipModel = typeof SocialCohort_MembershipModel[keyof typeof SocialCohort_MembershipModel];
/** Role of a user within a social cohort. */
export const SocialCohort_MembershipRole = {
  /** Cohort administrator with management permissions. */
  Admin: 'ADMIN',
  /** Regular cohort member. */
  Member: 'MEMBER',
  /** Cohort owner with full control. */
  Owner: 'OWNER'
} as const;

export type SocialCohort_MembershipRole = typeof SocialCohort_MembershipRole[keyof typeof SocialCohort_MembershipRole];
/** Input for registering the authenticated user to a cohort. */
export type SocialCohort_RegisterMembershipInput = {
  /** ID of the cohort to join. */
  cohortId: Scalars['ID'];
  /** Role to assign to the user. */
  role: SocialCohort_MembershipRole;
};

/** Input for registering a specific user (by userId) to a cohort. This is an admin endpoint processed asynchronously via SQS. */
export type SocialCohort_RegisterUsersToCohortInput = {
  /** ID of the cohort. */
  cohortId: Scalars['ID'];
  /** Optional description for the registration. */
  description?: InputMaybe<Scalars['String']>;
  /** Role to assign to the user. */
  role: SocialCohort_MembershipRole;
  /** Optional type classification for the registration. */
  type?: InputMaybe<Scalars['String']>;
  /** IDs of the users to register. */
  userIds: Array<Scalars['ID']>;
};

/** Input for removing a cohort membership. */
export type SocialCohort_RemoveMembershipInput = {
  /** ID of the cohort. */
  cohortId: Scalars['ID'];
};

/** Input for updating a social cohort. */
export type SocialCohort_UpdateCohortInput = {
  /** ID of the cohort to update. */
  cohortId: Scalars['ID'];
  /** New description for the cohort. */
  description?: InputMaybe<Scalars['String']>;
  /** New name for the cohort. */
  name?: InputMaybe<Scalars['String']>;
  /** New parent cohort ID. Set to null to make it a root cohort. */
  parentCohortId?: InputMaybe<Scalars['ID']>;
  /** New type classification for the cohort. */
  type?: InputMaybe<Scalars['String']>;
};

/** Spark course types */
export const SparkCourse_CourseType = {
  /** Capstone course */
  V1Capstone: 'V1CAPSTONE',
  /** Normal course */
  V1Session: 'V1SESSION'
} as const;

export type SparkCourse_CourseType = typeof SparkCourse_CourseType[keyof typeof SparkCourse_CourseType];
/** Creates a membership for the logged-in user. */
export type SpecializationMembership_CreateMembershipInput = {
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization ID. */
  s12nId: Scalars['ID'];
  /** Optional boolean to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/** Input required to create a S12n Membership */
export type SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nInput = {
  /** The course to enroll in */
  courseToEnrollIn?: InputMaybe<Scalars['ID']>;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** Deletes a membership for the logged-in user. */
export type SpecializationMembership_DeleteMembershipInput = {
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** Represents the possible roles a user can have in relation to a specialization. */
export const SpecializationMembership_Role = {
  /** User is an instructor for the specialization. */
  Instructor: 'INSTRUCTOR',
  /** User is currently enrolled as a student in the specialization. */
  Learner: 'LEARNER',
  /** User has never been enrolled in the specialization. */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** User was previously enrolled but is no longer enrolled in the specialization. */
  NotEnrolled: 'NOT_ENROLLED',
  /** User has university administrator privileges for the specialization. */
  UniversityAdmin: 'UNIVERSITY_ADMIN'
} as const;

export type SpecializationMembership_Role = typeof SpecializationMembership_Role[keyof typeof SpecializationMembership_Role];
/** Input for decline upgrade. */
export type SpecializationUpgrade_DeclineUpgradeInput = {
  /** The unique identifier of the new specialization being declined. */
  newS12nId: Scalars['ID'];
  /** The unique identifier of the old specialization the user wants to retain. */
  oldS12nId: Scalars['ID'];
};

/** The source of the upgrade eligibility. */
export const SpecializationUpgrade_OwnershipSource = {
  /** When ownership is through Consumer segment, like CPLUS, CLite, S12nSubscription, BulkPay, etc. */
  Consumer: 'CONSUMER',
  /** When ownership is through an Enterprise program. */
  Enterprise: 'ENTERPRISE'
} as const;

export type SpecializationUpgrade_OwnershipSource = typeof SpecializationUpgrade_OwnershipSource[keyof typeof SpecializationUpgrade_OwnershipSource];
/** Input for s12n upgrade */
export type SpecializationUpgrade_UpgradeInput = {
  /** The unique identifier of the specialization to upgrade to. */
  s12nId: Scalars['ID'];
};

/** Specialization Difficulty Level. */
export const Specialization_DifficultyLevel = {
  /** Advanced Level */
  Advanced: 'ADVANCED',
  /** Beginner Level */
  Beginner: 'BEGINNER',
  /** Intermediate Level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type Specialization_DifficultyLevel = typeof Specialization_DifficultyLevel[keyof typeof Specialization_DifficultyLevel];
/** Determines what course content is behind a paywall and what is free */
export const Specialization_PremiumExperienceVariant = {
  /** Base variant: everything is free */
  BaseVariant: 'BASE_VARIANT',
  /** Premium (closed) Course variant: all course materials are behind a paywall. This course cannot be audited. */
  PremiumCourse: 'PREMIUM_COURSE',
  /**
   * Premium Grading variant: gradable assessments are behind a paywall, everything else (e.g. video lectures) are free.
   * This course is able to be audited.
   */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type Specialization_PremiumExperienceVariant = typeof Specialization_PremiumExperienceVariant[keyof typeof Specialization_PremiumExperienceVariant];
/** Product Variant. */
export const Specialization_ProductVariant = {
  /** External Certificate */
  ExternalCertificateS12N: 'EXTERNAL_CERTIFICATE_S12N',
  /** Google Certificate */
  GoogleCertificateS12N: 'GOOGLE_CERTIFICATE_S12N',
  /** Normal Specialization */
  NormalS12N: 'NORMAL_S12N',
  /** Professional Certificate */
  ProfessionalCertificateS12N: 'PROFESSIONAL_CERTIFICATE_S12N'
} as const;

export type Specialization_ProductVariant = typeof Specialization_ProductVariant[keyof typeof Specialization_ProductVariant];
/** Filter stackable contents by upsell type and product type. */
export type Stackability_ContentFilter = {
  /** Product type */
  productType: Stackability_ProductType;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** Filtering rules for stackable courses and specializations. */
export const Stackability_ContentFilteringRule = {
  /** Return the stackable contents that the user enrolled to. Only works for logged-in users. */
  UserEnrolled: 'USER_ENROLLED'
} as const;

export type Stackability_ContentFilteringRule = typeof Stackability_ContentFilteringRule[keyof typeof Stackability_ContentFilteringRule];
/** Sorting rules for stackable courses and specializations. */
export const Stackability_ContentSortingRule = {
  /** Sort stackable contents by the specific user's enrollment time. Only works for logged-in users. */
  ByEnrollmentTime: 'BY_ENROLLMENT_TIME',
  /** Sort stackable contents by number of enrollments. */
  ByNumOfEnrollments: 'BY_NUM_OF_ENROLLMENTS'
} as const;

export type Stackability_ContentSortingRule = typeof Stackability_ContentSortingRule[keyof typeof Stackability_ContentSortingRule];
/** Parameter for creating an upsell */
export type Stackability_CreateUpsellInput = {
  /** Additional parameters in JSON format */
  paramsJson?: InputMaybe<Scalars['JSON']>;
  /** The id of the product that upsells */
  sourceId: Scalars['ID'];
  /** The type of the product that upsells */
  sourceType: Stackability_ProductType;
  /** The id of the product to upsell to */
  targetId: Scalars['ID'];
  /** The type of the product to upsell to */
  targetType: Stackability_ProductType;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** Filter rules for target degrees */
export type Stackability_DegreeFilter = {
  /** If the user has enrolled to the target degree. Only works for logged-in users. */
  hasTargetDegreeMembership: Scalars['Boolean'];
  /** If the user has enrolled to any stackble contents of this degree. Only works for logged-in users. */
  stackableContentMembershipFilters?: InputMaybe<Array<Stackability_ContentFilter>>;
};

/** Sorting rules for pathway degrees. */
export const Stackability_DegreeSortingRule = {
  /** Sort degrees by DRE rankscores. Only works for logged-in users. */
  ByDre: 'BY_DRE'
} as const;

export type Stackability_DegreeSortingRule = typeof Stackability_DegreeSortingRule[keyof typeof Stackability_DegreeSortingRule];
/** Filtering rules for degrees with stackable courses and specializations. */
export const Stackability_DegreeWithContentsFilteringRule = {
  /** For stackable courses, only return standalone ones, i.e. not part of any other stackable content. */
  StandaloneCourses: 'STANDALONE_COURSES',
  /** Return the stackable contents that the user enrolled to. Only works for logged-in users. */
  UserEnrolled: 'USER_ENROLLED'
} as const;

export type Stackability_DegreeWithContentsFilteringRule = typeof Stackability_DegreeWithContentsFilteringRule[keyof typeof Stackability_DegreeWithContentsFilteringRule];
/** Input for delete property */
export type Stackability_DeletePropertyInput = {
  /** Property name */
  name: Scalars['String'];
  /** The id of the product that has the property */
  productId: Scalars['ID'];
  /** The type of the product */
  productType: Stackability_ProductType;
};

/** Input for delete upsell */
export type Stackability_DeleteUpsellInput = {
  /** The id of the upsell to delete */
  id: Scalars['ID'];
};

/** Upsell product type */
export const Stackability_ProductType = {
  /** Any product type. */
  Any: 'ANY',
  /** Course. */
  Course: 'COURSE',
  /** Degree */
  Degree: 'DEGREE',
  /** MasterTrack. */
  Mastertrack: 'MASTERTRACK',
  /** Specialization. */
  Specialization: 'SPECIALIZATION'
} as const;

export type Stackability_ProductType = typeof Stackability_ProductType[keyof typeof Stackability_ProductType];
/** Input for setting a property */
export type Stackability_SetPropertyInput = {
  /** Property name */
  name: Scalars['String'];
  /** The id of the product that has the property */
  productId: Scalars['ID'];
  /** The type of the product */
  productType: Stackability_ProductType;
  /** Property value */
  value: Scalars['String'];
};

/** Input for updating an upsell */
export type Stackability_UpdateUpsellInput = {
  /** Id of the record to update */
  id: Scalars['ID'];
  /**
   * Additional parameters in JSON format. For now, the following structure is supported for OFFERS_CREDIT upsells:
   * {
   *   credits: {
   *     maximumTransferableCredit: 5
   *   }
   * }
   */
  paramsJson?: InputMaybe<Scalars['JSON']>;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** Upsell relation types */
export const Stackability_UpsellType = {
  /** Any types of relations */
  Any: 'ANY',
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type Stackability_UpsellType = typeof Stackability_UpsellType[keyof typeof Stackability_UpsellType];
export const SubmissionDownload_EligibleSubmissionsErrors = {
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type SubmissionDownload_EligibleSubmissionsErrors = typeof SubmissionDownload_EligibleSubmissionsErrors[keyof typeof SubmissionDownload_EligibleSubmissionsErrors];
export const SubmissionDownload_EnqueueDownloadError = {
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type SubmissionDownload_EnqueueDownloadError = typeof SubmissionDownload_EnqueueDownloadError[keyof typeof SubmissionDownload_EnqueueDownloadError];
export type SubmissionDownload_EnqueueDownloadInput = {
  groupId: Scalars['ID'];
  /** Whether or not to include staff submitters and submissions in the bundle. */
  includeStaffSubmissions?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
  /**
   * The URL of the page where the download is initiated from.
   * When an error is encountered, this is used to redirect graders back to where they can retry
   * this operation.
   */
  sourcePageUrl: Scalars['URL'];
};

/** TODO: Complete this description */
export const Submission_AllowedAction = {
  /** TODO: Complete this description */
  ResumeDraft: 'RESUME_DRAFT',
  /** TODO: Complete this description */
  ReworkSubmission: 'REWORK_SUBMISSION',
  /** TODO: Complete this description */
  StartNewAttempt: 'START_NEW_ATTEMPT'
} as const;

export type Submission_AllowedAction = typeof Submission_AllowedAction[keyof typeof Submission_AllowedAction];
/** Indicates which types of files are allowed to be uploaded for the file upload question */
export const Submission_AllowedFileType = {
  /** All file types are allowed */
  All: 'ALL',
  /** Audio files of certain extensions are allowed */
  Audio: 'AUDIO',
  /** Coding files of certain extensions are allowed */
  Coding: 'CODING',
  /** Image files of certain extensions are allowed */
  Image: 'IMAGE',
  /** Text files of certain extensions are allowed */
  Text: 'TEXT',
  /** Video files of certain extensions are allowed */
  Video: 'VIDEO'
} as const;

export type Submission_AllowedFileType = typeof Submission_AllowedFileType[keyof typeof Submission_AllowedFileType];
/** Assignment features that may potentially be unsupported by certain mobile app versions. */
export const Submission_AssignmentFeature = {
  /** Populated when StaffGradedAssignment.submissionSchema has AI graded questions */
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts has AI graded rubrics */
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts is not empty */
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  /** Populated when ProctorConfig.attemptDuration is not empty */
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  /** Represent values from StaffGradedAssignmentConfiguration.showGradeOnGradeRelease. */
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  /**
   * Populated when StaffGradedAssignment
   * staffGradedAssignmentConfiguration.visibilityForSubmittingLearner.postsubmitPhase.ResponseVisibility
   * is set to RESPONSE_VISIBILITY_RESPONSE_HIDDEN
   */
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts has human graded rubrics */
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  /** Populated when ProctorConfig.maxAttempts is greater than zero */
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  /** Populated when ProctorConfig.maxSubmissionsPerAttempt is greater than zero */
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  /** Populated when StaffGradedAssignment.submissionSchema has human graded questions */
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  /** Populated when LearnerSubmission.parts includes at least one MultipleFillableBlanksQuestion */
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  /** Populated when ProctorConfig.maxSubmissionsPerAttempt is greater than 1 or is empty(unlimited) */
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  /** Populated when the assignment is proctored by an external service like Honorlock. */
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  /** Shows grade to learner after grade release */
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  /** Take the highest grade when reattempting */
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  /** Represent values from StaffGradedAssignmentConfiguration.gradeSelectionStrategy. */
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  /** Represents a value from StaffGradedAssignment.submissionEnabled */
  Teamwork: 'TEAMWORK',
  /**
   * This is a subtype of assignment parts (submission part, feedback part, etc) that is not
   * supported in all platforms yet
   */
  TextBlocks: 'TEXT_BLOCKS',
  /** This assignment is a verified skills assessment */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** This assignment is a verified skills diagnostic */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC',
  /** Populated when LearnerSubmission.parts includes at least one WidgetQuestion */
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Submission_AssignmentFeature = typeof Submission_AssignmentFeature[keyof typeof Submission_AssignmentFeature];
/** Determines whether the assignment is graded or ungraded */
export const Submission_AssignmentGradingType = {
  /** Indicates this is a graded assignment, as such it is included in the grading formula */
  Graded: 'GRADED',
  /** Indicates this is an ungraded (practice) assignment, as such it is not included in the grading formula */
  Ungraded: 'UNGRADED'
} as const;

export type Submission_AssignmentGradingType = typeof Submission_AssignmentGradingType[keyof typeof Submission_AssignmentGradingType];
/** What type of assignment this is */
export const Submission_AssignmentType = {
  /** A standard assignment. */
  Standard: 'STANDARD',
  /** This assessment is used for assessing verified skill attainment. */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** This assessment is used for diagnosing skills. */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC'
} as const;

export type Submission_AssignmentType = typeof Submission_AssignmentType[keyof typeof Submission_AssignmentType];
/**
 * Correctness of a question response. Currently a partially correctly answered question is marked as incorrectly
 * answered. In the future, we can improve the user experience by adding a "Partially Correct" status.
 */
export const Submission_AutoGradedQuestionCorrectness = {
  /** The question is correctly answered. A full score should be awarded. */
  Correct: 'CORRECT',
  /** The question is not correctly answered. A partial score or no score should be awarded. */
  Incorrect: 'INCORRECT'
} as const;

export type Submission_AutoGradedQuestionCorrectness = typeof Submission_AutoGradedQuestionCorrectness[keyof typeof Submission_AutoGradedQuestionCorrectness];
/** Response to a checkbox question */
export type Submission_CheckboxQuestionResponseInput = {
  /** Id of the chosen options, could be an empty list if the submitter didn't select any */
  chosen: Array<Scalars['ID']>;
};

/** Response to a code expression question */
export type Submission_CodeExpressionQuestionResponseInput = {
  /** Submitter's code submission */
  answer: Submission_CodeInput;
};

/** Code in a string format */
export type Submission_CodeInput = {
  /** Code string */
  code: Scalars['String'];
};

/** Input for creating a box session for viewing inline feedback responses */
export type Submission_CreateBoxSessionForViewInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /**
   * Review Response ID for the question feedback to be viewed
   * Ex: 'reviewResponseId~6f56744c-0788-4ade-867d-d09af89d7a67'
   */
  responseId: Scalars['ID'];
  /** Submission ID */
  submissionId: Scalars['ID'];
};

/** Creates a proctored session for an assignment with Honorlock. */
export type Submission_CreateHonorlockSessionInput = {
  /** The CourseId of the assignment being submitted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being submitted */
  itemId: Scalars['ID'];
};

/** Inputs for deleting the latest attempt of a learner */
export type Submission_DeleteAllAttemptsInput = {
  /** The CourseId */
  courseId: Scalars['ID'];
  /** The ItemId */
  itemId: Scalars['ID'];
  /** The UserId */
  userId: Scalars['Int'];
};

/** S3 file parameters for pre-signed URL */
export type Submission_FileUploadQuestionGenerateUploadUrlInput = {
  /** Optionally include the MD5 CheckSum of the file, which is used to ensure that file transfer occurred without a file corruption */
  contentMd5?: InputMaybe<Scalars['String']>;
  /** MIME string, eg. image/gif or text/plain */
  contentType: Scalars['String'];
  /** Upload file name */
  fileName: Scalars['String'];
};

/** Response to a file upload question */
export type Submission_FileUploadQuestionResponseInput = {
  /** Caption to describe the file */
  caption: Scalars['String'];
  /** Generated file URL after upload */
  fileUrl: Scalars['String'];
  /** Title to describe the file */
  title: Scalars['String'];
};

/** A wrapper to support different response types. Future fillable blank types can be added using @oneOf. */
export type Submission_FillableBlankResponseInput = {
  /** A multiple choice fillable blank response */
  multipleChoiceFillableBlankResponse?: InputMaybe<Submission_MultipleChoiceFillableBlankResponseInput>;
};

/** Determines which grade to use as a learner's final grade if multiple grading attempts have been made */
export const Submission_GradeSelectionStrategy = {
  /** Use the highest grade out of all of the learner's grading attempts */
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  /** Use the grade from the learner's most recent grading attempt */
  TakeLatestGrade: 'TAKE_LATEST_GRADE'
} as const;

export type Submission_GradeSelectionStrategy = typeof Submission_GradeSelectionStrategy[keyof typeof Submission_GradeSelectionStrategy];
/** How the rubric was graded. Whether it was by a human or AI. */
export const Submission_GraderTypes = {
  /** AI Graded */
  Ai: 'AI',
  /** Auto graded questions */
  Auto: 'AUTO',
  /** Human Graded */
  Human: 'HUMAN'
} as const;

export type Submission_GraderTypes = typeof Submission_GraderTypes[keyof typeof Submission_GraderTypes];
/** Contains html in a string format. */
export type Submission_HtmlContentInput = {
  /** Html in string */
  value: Scalars['String'];
};

/**
 * Learner feedback visibility
 * Information on the values: https://www.coursera.support/s/article/360024748191-Add-Staff-Graded-Assignments-and-Adjust-Assignment-Settings#feedback_type
 */
export const Submission_LearnerFeedbackVisibility = {
  /** Full visibility */
  Full: 'FULL',
  /** Limited visibility */
  Limited: 'LIMITED',
  /** Partial visibility */
  Partial: 'PARTIAL'
} as const;

export type Submission_LearnerFeedbackVisibility = typeof Submission_LearnerFeedbackVisibility[keyof typeof Submission_LearnerFeedbackVisibility];
/** Response to a math question */
export type Submission_MathQuestionResponseInput = {
  /** Math expression in a string */
  answer: Scalars['String'];
};

/** Response to a single multiple choice fillable blank */
export type Submission_MultipleChoiceFillableBlankResponseInput = {
  /** Id of the fillable blank */
  id: Scalars['ID'];
  /** Id of the chosen option */
  optionId: Scalars['ID'];
};

/** Response to a multiple choice question */
export type Submission_MultipleChoiceQuestionResponseInput = {
  /** Id of the chosen option, could be empty if the submitter didn't select any */
  chosen?: InputMaybe<Scalars['ID']>;
};

/** Response to a multiple fillable blanks question */
export type Submission_MultipleFillableBlanksQuestionResponseInput = {
  /** List of fillable blank responses, where each has the Id of the blank and the response */
  responses: Array<Submission_FillableBlankResponseInput>;
};

/** Response to a numeric question */
export type Submission_NumericQuestionResponseInput = {
  /** Numeric answer string */
  answer: Scalars['String'];
};

/**
 * Response to a plain text question. This question type has been deprecated and should only
 * exist in old assignments
 */
export type Submission_PlainTextQuestionResponseInput = {
  /** Plain text string */
  plainText: Scalars['String'];
};

/** Enabled status of plagiarism check feature */
export const Submission_QuestionPlagiarismCheckEnabledStatus = {
  /** Plagiarism check disabled. */
  Disabled: 'DISABLED',
  /** Plagiarism check enabled. */
  Enabled: 'ENABLED'
} as const;

export type Submission_QuestionPlagiarismCheckEnabledStatus = typeof Submission_QuestionPlagiarismCheckEnabledStatus[keyof typeof Submission_QuestionPlagiarismCheckEnabledStatus];
/**
 * The response to a single question.
 * Provide a single QuestionType and the corresponding data.
 * Unfortunately, neither Union nor Oneof are currently available to make this simpler to use.
 */
export type Submission_QuestionResponseInput = {
  /** The ID of the question being responded to */
  questionId: Scalars['ID'];
  /** response to the question */
  questionResponse: Submission_QuestionResponseInputUnion;
  /**
   * The type of question being responded to.
   * This should match the response data provided.
   */
  questionType: Submission_QuestionType;
};

/**
 * A union type that use our custom @oneOf annotation to enforce exactly one field is set:
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Conventions#@oneOf-Inputs-(Input-Unions)
 */
export type Submission_QuestionResponseInputUnion = {
  checkboxResponse?: InputMaybe<Submission_CheckboxQuestionResponseInput>;
  codeExpressionResponse?: InputMaybe<Submission_CodeExpressionQuestionResponseInput>;
  fileUploadResponse?: InputMaybe<Submission_FileUploadQuestionResponseInput>;
  mathResponse?: InputMaybe<Submission_MathQuestionResponseInput>;
  multipleChoiceResponse?: InputMaybe<Submission_MultipleChoiceQuestionResponseInput>;
  multipleFillableBlanksResponse?: InputMaybe<Submission_MultipleFillableBlanksQuestionResponseInput>;
  numericResponse?: InputMaybe<Submission_NumericQuestionResponseInput>;
  plainTextResponse?: InputMaybe<Submission_PlainTextQuestionResponseInput>;
  regexResponse?: InputMaybe<Submission_RegexQuestionResponseInput>;
  richTextResponse?: InputMaybe<Submission_RichTextQuestionResponseInput>;
  textExactMatchResponse?: InputMaybe<Submission_TextExactMatchQuestionResponseInput>;
  textReflectResponse?: InputMaybe<Submission_TextReflectQuestionResponseInput>;
  urlResponse?: InputMaybe<Submission_UrlQuestionResponseInput>;
  widgetResponse?: InputMaybe<Submission_WidgetQuestionResponseInput>;
};

/** A list of all question types. */
export const Submission_QuestionType = {
  Checkbox: 'CHECKBOX',
  CheckboxReflect: 'CHECKBOX_REFLECT',
  CodeExpression: 'CODE_EXPRESSION',
  FileUpload: 'FILE_UPLOAD',
  Math: 'MATH',
  MultipleChoice: 'MULTIPLE_CHOICE',
  MultipleChoiceReflect: 'MULTIPLE_CHOICE_REFLECT',
  MultipleFillableBlanks: 'MULTIPLE_FILLABLE_BLANKS',
  Numeric: 'NUMERIC',
  PlainText: 'PLAIN_TEXT',
  Regex: 'REGEX',
  RichText: 'RICH_TEXT',
  TextExactMatch: 'TEXT_EXACT_MATCH',
  TextReflect: 'TEXT_REFLECT',
  Url: 'URL',
  Widget: 'WIDGET'
} as const;

export type Submission_QuestionType = typeof Submission_QuestionType[keyof typeof Submission_QuestionType];
/** Response to a regex question */
export type Submission_RegexQuestionResponseInput = {
  /** A regex string */
  answer: Scalars['String'];
};

/** Assignment features that may potentially be unsupported by certain mobile app versions. */
export const Submission_RequiredMobileFeature = {
  /** The assignment has AI graded questions */
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  /** The assignment has AI-graded rubrics */
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  /** The assignment includes a learner-facing assignment rubric */
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  /** Attempts are limited to a maximum duration */
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  /** Grades are hidden from learners after release */
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  /** Past submissions are not visible to learners */
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  /** The assignment has human-graded rubrics, at either the assignment-level or question-level */
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  /** Learners are limited to a maximum number of allowed attempts */
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  /** Learners are limited to a maximum number of allowed submissions per attempt */
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  /** The assignment includes manually-graded questions */
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  /** The assignment includes multiple fillable blanks questions */
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  /** The assignment has more than one submission allowed per attempt */
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  /** The assignment uses a proctoring service like Honorlock or AutoProctor */
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  /** The assignment can be assigned to a team */
  Teamwork: 'TEAMWORK',
  /** The assignment contains text blocks */
  TextBlocks: 'TEXT_BLOCKS',
  /** The assignment includes widget questions */
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Submission_RequiredMobileFeature = typeof Submission_RequiredMobileFeature[keyof typeof Submission_RequiredMobileFeature];
/** Submits the latest draft */
export type Submission_ReworkSubmissionInput = {
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
};

/**
 * Rich text in Submission models can be encoded in Cml or Html.
 * Use either the HTML or CML node, but not both.
 */
export type Submission_RichTextInput = {
  /** CML Content */
  cml?: InputMaybe<CmlContentInput>;
  /** HTML string. */
  html?: InputMaybe<Submission_HtmlContentInput>;
};

/** Response to a rich text question */
export type Submission_RichTextQuestionResponseInput = {
  /**
   * Rich text encoded in either Cml or html. We prefer using Cml for new responses but there
   * is no strict guarantee that returned value is of Cml type due to legacy data
   */
  richText: Submission_RichTextInput;
};

/** Updates the current submission with new responses */
export type Submission_SaveResponsesInput = {
  /** AttemptId of the response to save */
  attemptId?: InputMaybe<Scalars['ID']>;
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
  /** The question responses */
  questionResponses: Array<InputMaybe<Submission_QuestionResponseInput>>;
};

/** Starts a new attempt */
export type Submission_StartAttemptInput = {
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
};

/** Submits the latest draft */
export type Submission_SubmitLatestDraftInput = {
  /** The CourseId of the assignment being submitted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being submitted */
  itemId: Scalars['ID'];
  /** ID of the Submission to submit */
  submissionId: Scalars['ID'];
};

/** Response to a text exact match question */
export type Submission_TextExactMatchQuestionResponseInput = {
  /** Answer is allowed to be optional per the original question definition */
  answer?: InputMaybe<Scalars['String']>;
};

/** Response to a text reflect question */
export type Submission_TextReflectQuestionResponseInput = {
  /** Answer is allowed to be optional per the original question definition */
  answer?: InputMaybe<Scalars['String']>;
};

/** Response to a URL submission question */
export type Submission_UrlQuestionResponseInput = {
  /** Caption to describe the resource that the URL links to */
  caption: Scalars['String'];
  /** Title to describe the resource that the URL links to */
  title: Scalars['String'];
  /** URL string inputted by submitter */
  url: Scalars['String'];
};

/** Informative warnings that we want let the learner be aware of */
export const Submission_Warning = {
  /** AI Grading is in progress */
  AiGradingInProgress: 'AI_GRADING_IN_PROGRESS',
  /** Assignment is outdated */
  AssignmentVersionOutdated: 'ASSIGNMENT_VERSION_OUTDATED',
  /** Human grading is in progress */
  GradingInProgress: 'GRADING_IN_PROGRESS'
} as const;

export type Submission_Warning = typeof Submission_Warning[keyof typeof Submission_Warning];
/** Response to a widget question */
export type Submission_WidgetQuestionResponseInput = {
  /** Widget question's answer could be in arbitrary shape. */
  answer: Scalars['JSON'];
};

export const SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  Expired: 'EXPIRED',
  FreeTrial: 'FREE_TRIAL',
  Inactive: 'INACTIVE',
  PastDue: 'PAST_DUE'
} as const;

export type SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus = typeof SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus[keyof typeof SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus];
/** Subscriptions_Cancel input. */
export type Subscriptions_CancelInput = {
  /** ID of the Subscription to cancel. */
  subscriptionId: Scalars['ID'];
};

/** Subscriptions_ConvertFreeTrialToActive input. */
export type Subscriptions_ConvertFreeTrialToActiveInput = {
  /** ID of the Subscription to convert from free trial to active. */
  subscriptionId: Scalars['ID'];
};

/** List of supported payment processors. */
export const Subscriptions_PaymentProcessor = {
  /** Apple In-App payment processor ID. */
  AppleInapp: 'APPLE_INAPP',
  /** Apple In-App sandbox payment processor ID. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree payment processor ID. */
  Braintree: 'BRAINTREE',
  /** Braintree sandbox payment processor ID. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Coursera Manual payment processor ID. */
  CourseraManual: 'COURSERA_MANUAL',
  /** DLocal payment processor ID. */
  Dlocal: 'DLOCAL',
  /** DLocal sandbox payment processor ID. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx payment processor ID. */
  Ebanx: 'EBANX',
  /** Ebanx sandbox payment processor ID. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent payment processor processor */
  Emergent: 'EMERGENT',
  /** Emergent sandbox payment processor */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid payment processor ID. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play payment processor ID. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Google Play sandbox payment processor ID. */
  GooglePlaySandbox: 'GOOGLE_PLAY_SANDBOX',
  /** Mock payment processor ID. */
  Mock: 'MOCK',
  /** PayPal payment processor ID. */
  Paypal: 'PAYPAL',
  /** PayPal sandbox payment processor ID. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay payment processor ID. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will payment processor ID. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will sandbox payment processor ID. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay sandbox payment processor ID. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe payment processor ID. */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer payment processor ID. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer sandbox payment processor ID. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer payment processor ID. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer sandbox payment processor ID. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe sandbox payment processor ID. */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** Stripe Third Party payment processor ID. */
  StripeThirdParty: 'STRIPE_THIRD_PARTY',
  /** Stripe Third Party sandbox payment processor ID. */
  StripeThirdPartySandbox: 'STRIPE_THIRD_PARTY_SANDBOX',
  /** Zero Dollar payment processor ID. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type Subscriptions_PaymentProcessor = typeof Subscriptions_PaymentProcessor[keyof typeof Subscriptions_PaymentProcessor];
/**
 * Represents all subscription supported product types.
 *
 * Should map 1:1 to https://github.com/webedx-spark/infra-services/blob/19fb06e23d7c0b14ba3dc4820d66e800b9f0384c/libs/models/src/main/scala/org/coursera/product/ProductType.scala#L88
 * except the product types which are deprecated.
 */
export const Subscriptions_ProductType = {
  /** The Coursera Plus product, which gives learners full access to a subset of the Coursera catalog. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** The Coursera Lite product, which gives limited access to a subset of the Coursera catalog. */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /** Represents the Master track product type. */
  CredentialTrackSubscription: 'CREDENTIAL_TRACK_SUBSCRIPTION',
  /**
   * A new version of CredentialTrackSubscription/CredentialTrackCourse that has different
   * revenue recognition and ownership granting logic from the original version.
   * Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   * *\/
   */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /**
   * Used for unexpected, deprecated, or invalid product types. In this context, an
   * "unexpected" product type falls out of the domain of subscriptions-application. Please
   * note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID',
  /** A Specialization product, which gives access to its collection of courses. */
  Specialization: 'SPECIALIZATION',
  /** A Subscription product that gives access to an s12n and its courses. */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION'
} as const;

export type Subscriptions_ProductType = typeof Subscriptions_ProductType[keyof typeof Subscriptions_ProductType];
/** Subscriptions_RestoreCanceledSubscriptionInput */
export type Subscriptions_RestoreCanceledSubscriptionInput = {
  /** ID of the canceled subscription to restore. */
  subscriptionId: Scalars['ID'];
};

/** Subscription status. */
export const Subscriptions_Status = {
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  Active: 'ACTIVE',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE. */
  Cancelled: 'CANCELLED',
  /**
   * Subscription has reached the specified number of billing cycles and has lapsed out of the
   * paid-through period.
   */
  Expired: 'EXPIRED',
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  FreeTrial: 'FREE_TRIAL',
  /** Learner does not have product ownership and there is no longer a recurring payment. */
  Inactive: 'INACTIVE',
  /** Learner maintains product ownership until the end of grace period after which status is INACTIVE. */
  PastDue: 'PAST_DUE'
} as const;

export type Subscriptions_Status = typeof Subscriptions_Status[keyof typeof Subscriptions_Status];
/**
 * The internal status of the Subscription. Not all of our possible Subscription statuses are
 * listed here. Additional statuses may be added as required.
 */
export const Subscriptions_SubscriptionStatus = {
  /**
   * The Subscription has been cancelled and no new payment will be made for this Subscription.
   * One the Subscription moves past its paid up until date, it will transition to INACTIVE.
   */
  Cancelled: 'CANCELLED',
  /**
   * The Subscription is currently in a free trial period and the first payment is expected on the
   * nextBillingAt, at which case it will transition to either ACTIVE or PAST_DUE depending on
   * whether the payment was successfully pulled or not.
   */
  FreeTrial: 'FREE_TRIAL',
  /** Learner does not have product ownership and there is no longer a recurring payment. */
  Inactive: 'INACTIVE',
  /**
   * Used for unexpected, deprecated, or invalid Subscription statuses. In this context, an
   * "unexpected" Subscription status falls out of the domain of subscriptions-application. Please
   * note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID'
} as const;

export type Subscriptions_SubscriptionStatus = typeof Subscriptions_SubscriptionStatus[keyof typeof Subscriptions_SubscriptionStatus];
/** Create transcription workflow input */
export type Subtitles_CreateTranscriptionWorkflowInput = {
  /** The ID of the atom that links to the video asset */
  atomId: Scalars['ID'];
  /** The ID of the video asset for which the transcription is generated */
  videoAssetId: Scalars['ID'];
};

/** Retry transcription workflow input */
export type Subtitles_RetryTranscriptionWorkflowInput = {
  /** The ID of the atom that links to the video asset in the workflow. */
  atomId: Scalars['ID'];
  /** Workflow ID. */
  id: Scalars['ID'];
};

export const TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState = {
  Deleted: 'DELETED',
  Dismissed: 'DISMISSED',
  Saved: 'SAVED',
  Unsaved: 'UNSAVED'
} as const;

export type TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState = typeof TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState[keyof typeof TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState];
export const TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior = {
  Exclusive: 'EXCLUSIVE',
  Inclusive: 'INCLUSIVE',
  NotCharged: 'NOT_CHARGED'
} as const;

export type TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior = typeof TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior[keyof typeof TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior];
export const TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = {
  Ai: 'AI',
  Auto: 'AUTO',
  Human: 'HUMAN'
} as const;

export type TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = typeof TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType[keyof typeof TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType];
/** An enum representing types of activity */
export const Teamwork_ActivityType = {
  /** Activity type for item discussions */
  ItemDiscussion: 'ITEM_DISCUSSION',
  /** Activity type for item submissions */
  ItemSubmission: 'ITEM_SUBMISSION',
  /** Activity type for practice assignments' items */
  PracticeItemSubmission: 'PRACTICE_ITEM_SUBMISSION',
  /** Activity type standalone discussions */
  StandaloneDiscussion: 'STANDALONE_DISCUSSION',
  /** Activity type for team mate review items */
  TeammateReview: 'TEAMMATE_REVIEW'
} as const;

export type Teamwork_ActivityType = typeof Teamwork_ActivityType[keyof typeof Teamwork_ActivityType];
/** Request to lock team activity */
export type Teamwork_LockTeamActivityInput = {
  /** Type of activity */
  activityType: Teamwork_ActivityType;
  /** Item for which activity should be locked */
  itemId: Scalars['ID'];
  /** Scoped identifier of the team */
  scopedTeamId: Teamwork_ScopedTeamIdInput;
};

/** Scoped identifier of a team */
export type Teamwork_ScopedTeamIdInput = {
  /** The scopeId */
  scopeId: Scalars['ID'];
  /** The teamId */
  teamId: Scalars['ID'];
};

/** Request to unlock team activity */
export type Teamwork_UnlockTeamActivityInput = {
  /** Type of activity */
  activityType: Teamwork_ActivityType;
  /** Item for which activity should be unlocked */
  itemId: Scalars['ID'];
  /** Scoped identifier of the team */
  scopedTeamId: Teamwork_ScopedTeamIdInput;
};

/** Input for creating ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_CreateInput = {
  /** ID of ThirdPartyOrganizationEmailDomainId. */
  id: Scalars['ID'];
  /** The thirdPartyOrganization Id. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** ThirdPartyOrganizationEmailDomain_Get* query Error. */
export const ThirdPartyOrganizationEmailDomain_CreateResultError = {
  /** ThirdPartyEmailDomain not found */
  DuplicateEntry: 'DUPLICATE_ENTRY',
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR'
} as const;

export type ThirdPartyOrganizationEmailDomain_CreateResultError = typeof ThirdPartyOrganizationEmailDomain_CreateResultError[keyof typeof ThirdPartyOrganizationEmailDomain_CreateResultError];
/** Input for Deleting ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_DeleteInput = {
  /** ID of ThirdPartyOrganizationEmailDomain */
  id: Scalars['ID'];
};

/** ThirdPartyOrganizationEmailDomain_Get query Error. */
export const ThirdPartyOrganizationEmailDomain_DeleteResultError = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** ThirdPartyEmailDomain not found */
  NotFound: 'NOT_FOUND'
} as const;

export type ThirdPartyOrganizationEmailDomain_DeleteResultError = typeof ThirdPartyOrganizationEmailDomain_DeleteResultError[keyof typeof ThirdPartyOrganizationEmailDomain_DeleteResultError];
/** ThirdPartyOrganizationEmailDomain_Get* query Error. */
export const ThirdPartyOrganizationEmailDomain_GetResponseError = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** ThirdPartyEmailDomain not found */
  NotFound: 'NOT_FOUND'
} as const;

export type ThirdPartyOrganizationEmailDomain_GetResponseError = typeof ThirdPartyOrganizationEmailDomain_GetResponseError[keyof typeof ThirdPartyOrganizationEmailDomain_GetResponseError];
/** Input for creating Multiple ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_MultiCreateInput = {
  /** IDs of ThirdPartyOrganizationEmailDomain */
  ids: Array<Scalars['ID']>;
  /** The thirdPartyOrganization Id. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Input Request for Creating ThirdPartyOrganizationServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateInput = {
  /** ClientId for Create ServiceAccount */
  clientId: Scalars['ID'];
  /** OrganizationId for Create ServiceAccount */
  thirdPartyOrganizationId: Scalars['ID'];
  /** UserId for Create ServiceAccount */
  userId: Scalars['ID'];
};

/** Input Request for Deleting ThirdPartyOrganizationServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteInput = {
  /** ServiceAccountId to be Deleted */
  serviceAccountId: Scalars['ID'];
};

/** Input Request for FindByOrganization ThirdPartyOrganizationServiceAccount API */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountFindByOrganizationInput = {
  /** OrganizationId to find ServiceAccount */
  organizationId: Scalars['String'];
};

/** Input Request for FindByUser ThirdPartyOrganizationServiceAccount API */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountFindByUserInput = {
  /** UserId to find ServiceAccount */
  userId: Scalars['String'];
};

/** Display mode for tracking progress legalese on the Terms & Conditions screen. */
export const ThirdPartyOrganization_LegaleseDisplayMode = {
  /**
   * Display organization-specific custom legalese text.
   * Requires customText field to be provided.
   */
  Custom: 'CUSTOM',
  /** Hide the tracking progress legalese block entirely. */
  Hidden: 'HIDDEN'
} as const;

export type ThirdPartyOrganization_LegaleseDisplayMode = typeof ThirdPartyOrganization_LegaleseDisplayMode[keyof typeof ThirdPartyOrganization_LegaleseDisplayMode];
/** Enum representing Organization Employee Range. */
export const ThirdPartyOrganization_OrganizationEmployeeRange = {
  /** Organization has 1-500 employees. */
  EmployeeRange_1_500: 'EMPLOYEE_RANGE_1_500',
  /** Organization has 501-1000 employees. */
  EmployeeRange_501_1000: 'EMPLOYEE_RANGE_501_1000',
  /** Organization has 1001-5000 employees. */
  EmployeeRange_1001_5000: 'EMPLOYEE_RANGE_1001_5000',
  /** Organization has 5001-15,000 employees. */
  EmployeeRange_5001_15000: 'EMPLOYEE_RANGE_5001_15000',
  /** Organization has more than 15,000 employees. */
  EmployeeRangeMoreThan_15000: 'EMPLOYEE_RANGE_MORE_THAN_15000'
} as const;

export type ThirdPartyOrganization_OrganizationEmployeeRange = typeof ThirdPartyOrganization_OrganizationEmployeeRange[keyof typeof ThirdPartyOrganization_OrganizationEmployeeRange];
/** Enum representing organization types. */
export const ThirdPartyOrganization_OrganizationType = {
  /** Business organization type. */
  Business: 'BUSINESS',
  /** Campus organization type. */
  Campus: 'CAMPUS',
  /** Government organization type. */
  Government: 'GOVERNMENT'
} as const;

export type ThirdPartyOrganization_OrganizationType = typeof ThirdPartyOrganization_OrganizationType[keyof typeof ThirdPartyOrganization_OrganizationType];
/** Enum representing the program visibility rule. */
export const ThirdPartyOrganization_ProgramVisibilityRule = {
  /** Visibility for accepted privacy notice. */
  AcceptedPrivacyNotice: 'ACCEPTED_PRIVACY_NOTICE',
  /** Visibility rule where everyone can see the program. */
  Everyone: 'EVERYONE'
} as const;

export type ThirdPartyOrganization_ProgramVisibilityRule = typeof ThirdPartyOrganization_ProgramVisibilityRule[keyof typeof ThirdPartyOrganization_ProgramVisibilityRule];
/** Enum representing validity of SAML Metadata. */
export const ThirdPartyOrganization_SamlMetadataExpiry = {
  /** SAML Metadata has been expired. */
  Expired: 'EXPIRED',
  /** SAML Metadata is about to expire. */
  ExpiryWarning: 'EXPIRY_WARNING',
  /** SAML Metadata is missing. */
  MissingMetadata: 'MISSING_METADATA',
  /** SAML Metadata needs to be refreshed. */
  NeedsRefresh: 'NEEDS_REFRESH',
  /** SAML Metadata is valid. */
  Valid: 'VALID'
} as const;

export type ThirdPartyOrganization_SamlMetadataExpiry = typeof ThirdPartyOrganization_SamlMetadataExpiry[keyof typeof ThirdPartyOrganization_SamlMetadataExpiry];
/** Enum representing SAML signing algorithm. */
export const ThirdPartyOrganization_SamlSigningAlgorithm = {
  /** SAML signing algorithm SHA1_RSA. */
  Sha1Rsa: 'SHA1_RSA',
  /** SAML signing algorithm SHA256_RSA. */
  Sha256Rsa: 'SHA256_RSA'
} as const;

export type ThirdPartyOrganization_SamlSigningAlgorithm = typeof ThirdPartyOrganization_SamlSigningAlgorithm[keyof typeof ThirdPartyOrganization_SamlSigningAlgorithm];
/** Input for setIsReal mutation */
export type ThirdPartyOrganization_SetIsRealInput = {
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The new value for the isReal field */
  isReal: Scalars['Boolean'];
};

/** Enum representing SSO login methods. */
export const ThirdPartyOrganization_SsoLoginMethod = {
  /** SSO login method JWT. */
  Jwt: 'JWT',
  /** SSO login method JWT_INVITE. */
  JwtInvite: 'JWT_INVITE',
  /** SSO login method SAML. */
  Saml: 'SAML'
} as const;

export type ThirdPartyOrganization_SsoLoginMethod = typeof ThirdPartyOrganization_SsoLoginMethod[keyof typeof ThirdPartyOrganization_SsoLoginMethod];
/** Input for updating entityId mutation */
export type ThirdPartyOrganization_UpdateEntityIdInput = {
  /** An optional boolean field to allow duplicate entityId (works with poweruser permission in backend) */
  allowDuplicateEntityIds?: InputMaybe<Scalars['Boolean']>;
  /** The new value for the entityId field */
  entityId: Scalars['ID'];
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
};

/** Input for updating ThirdPartyOrganization metadata mutation */
export type ThirdPartyOrganization_UpdateMetadataInput = {
  /** The allowsIdpInitiatedLogin of the ThirdPartyOrganization */
  allowsIdpInitiatedLogin?: InputMaybe<Scalars['Boolean']>;
  /** The emailAttribute of the ThirdPartyOrganization */
  emailAttribute: Scalars['String'];
  /** The externalIdAttribute of the ThirdPartyOrganization */
  externalIdAttribute?: InputMaybe<Scalars['String']>;
  /** The firstNameAttribute of the ThirdPartyOrganization */
  firstNameAttribute?: InputMaybe<Scalars['String']>;
  /** hasSamlMetadataFileUpdated for the organization */
  hasSamlMetadataFileUpdated?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The lastNameAttribute of the ThirdPartyOrganization */
  lastNameAttribute?: InputMaybe<Scalars['String']>;
  /** The nameAttribute of the ThirdPartyOrganization */
  nameAttribute?: InputMaybe<Scalars['String']>;
  /** The opaqueIdAttribute of the ThirdPartyOrganization */
  opaqueIdAttribute: Scalars['String'];
  /** The refreshUrl of the ThirdPartyOrganization */
  refreshUrl?: InputMaybe<Scalars['URL']>;
  /** The signSamlRequest flag of the ThirdPartyOrganization */
  signSamlRequest?: InputMaybe<Scalars['Boolean']>;
  /** The signingAlgorithm of the ThirdPartyOrganization */
  signingAlgorithm: ThirdPartyOrganization_SamlSigningAlgorithm;
  /** The signingCertificateFingerprint of the ThirdPartyOrganization */
  signingCertificateFingerprint?: InputMaybe<Scalars['String']>;
};

/** Input for updateSigningCertificate mutation */
export type ThirdPartyOrganization_UpdateSigningCertificateInput = {
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The new signing certificate fingerprint to set */
  signingCertificateFingerprint: Scalars['String'];
};

/**
 * GraphQL version of google.protobuf.Timestamp used for Input
 * A type representing a point in time independent of any time zone or local calendar, encoded as a count of
 * seconds and fractions of seconds at nanoseccond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the Gregorian calendar backwards to year one.
 */
export type TimestampInput = {
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999 inclusive.
   */
  nanos: Scalars['Int'];
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   * Note - since GraphQL does not support 64-bit Integers/Longs, defined with String type here.
   */
  seconds: Scalars['String'];
};

/** The current status of the workflow */
export const Transcription_WorkflowStatus = {
  /** The workflow completed successfully */
  Completed: 'COMPLETED',
  /** The workflow ran into an error while executing */
  Failed: 'FAILED',
  /** The workflow was created, but the associated Airflow jobs have not yet run */
  NotStarted: 'NOT_STARTED',
  /** The associated Airflow jobs is running to transcribe */
  Transcribing: 'TRANSCRIBING'
} as const;

export type Transcription_WorkflowStatus = typeof Transcription_WorkflowStatus[keyof typeof Transcription_WorkflowStatus];
/** Translate Language Settings */
export type TranslateContent_TranslateLanguageSettings = {
  /**
   * Language of the source content. Eg. en-US, zh-CN, es-US.
   * If not provided, will attempt to auto detect
   */
  sourceLanguage?: InputMaybe<Scalars['String']>;
  /**
   * Language to translate to. Eg. en-US, zh-CN, es-US.
   * If not provided, will translate to the language in users profile.
   */
  targetLanguage?: InputMaybe<Scalars['String']>;
};

/**
 * Details on why the Translation is poor such as
 * the portion of text that was wrong, and how to improve it.
 */
export type TranslationFeedback_Details = {
  /** The mistranslated text, or a description of where it is and possible improvement */
  feedback: Scalars['String'];
  /** An array of potential reasons that the user can select on why the translation is inaccurate */
  reasonsForFeedback: Array<TranslationFeedback_ReasonForFeedback>;
};

/** TranslationFeedback_ReasonForFeedback */
export const TranslationFeedback_ReasonForFeedback = {
  /** Translation is not clear */
  HardToUnderstand: 'HARD_TO_UNDERSTAND',
  /** Translation contains offensive or harmful words that are not appropriate */
  HarmfulOffensive: 'HARMFUL_OFFENSIVE',
  /** Any other reason that isn't listed above */
  Other: 'OTHER',
  /** Text is only partially translated */
  PartialTranslation: 'PARTIAL_TRANSLATION'
} as const;

export type TranslationFeedback_ReasonForFeedback = typeof TranslationFeedback_ReasonForFeedback[keyof typeof TranslationFeedback_ReasonForFeedback];
/** Feedback Input */
export type TranslationFeedback_ReportFeedbackInput = {
  /** The details of the feedback */
  details: TranslationFeedback_Details;
  /** Language the user viewed the translation in. Eg. en-US, zh-CN, es-US */
  languageCode: Scalars['String'];
  /**
   * May also be called refererKey in other areas.
   * This should be the URL the user is on when
   * the feedback is submitted.
   */
  refererURL: Scalars['URL'];
  /** Additional info to locate where the feedback was submitted */
  trackingInfo: TranslationFeedback_TrackingInfo;
  /** UserId that submitted feedback, None if logged out user */
  userId?: InputMaybe<Scalars['ID']>;
};

/** TranslationFeedback_TrackingInfo */
export type TranslationFeedback_TrackingInfo = {
  /** TrackingInfo for Enterprise Pages */
  enterpriseTrackingInfo?: InputMaybe<TranslationFeedback_TrackingInfo_Enterprise>;
  /** TrackingInfo for InCourse */
  inCourseTrackingInfo?: InputMaybe<TranslationFeedback_TrackingInfo_InCourse>;
};

/** Should be used for any feedback gathered under Enterprise /program */
export type TranslationFeedback_TrackingInfo_Enterprise = {
  /** Enterprise Org Id */
  enterpriseOrgId: Scalars['ID'];
  /** Program Slug */
  programSlug?: InputMaybe<Scalars['String']>;
  /** Name of possible Skill Set */
  skillSet?: InputMaybe<Scalars['String']>;
  /**
   * A comma delimited string of the skills.
   * Eg. java,computer science,business
   */
  skills?: InputMaybe<Scalars['String']>;
};

/** Should be used for any feedback gathered under /learn */
export type TranslationFeedback_TrackingInfo_InCourse = {
  /** CourseId */
  courseId: Scalars['ID'];
  /** CourseSlug */
  courseSlug: Scalars['String'];
  /** ItemId */
  itemId?: InputMaybe<Scalars['ID']>;
  /** ModuleId */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/** TODO: Complete this description */
export type TurnitinTenant_CreateEntryInput = {
  /** programType helps to distinguish between DEGREE and ENTERPRISE program */
  programType: SimilarityCheckContextType;
  /**
   * If it's a DEGREE type, the slug should be a program slug.
   * If it's an ENTERPRISE type, the slug should be an organization slug.
   */
  slug: Scalars['String'];
  /** turnitinAPIKey will be used in header when GET/POST. */
  turnitinAPIKey: Scalars['String'];
  /**
   * We need to store turnitinTenantUrl in the sim_check_api_metadata_main collection
   * to enable vericite to make requests to the right tenant.
   * The CoreAPI class uses this url to make HTTP requests to Turnitin.
   */
  turnitinTenantUrl: Scalars['String'];
};

/**
 * Content structure type
 * Used in: Ulba_UlbaSummary, Ulba_ExportEntityCount
 */
export const Ulba_ContentType = {
  /** Course level content */
  Course: 'COURSE',
  /** Item level content */
  Item: 'ITEM',
  /** Learning objective */
  LearningObjective: 'LEARNING_OBJECTIVE',
  /** Learning objective reference */
  LearningObjectiveReference: 'LEARNING_OBJECTIVE_REFERENCE',
  /** Lesson level content */
  Lesson: 'LESSON',
  /** Module level content */
  Module: 'MODULE',
  /** Question bank */
  QuestionBank: 'QUESTION_BANK',
  /** Sub-item content */
  SubItem: 'SUB_ITEM'
} as const;

export type Ulba_ContentType = typeof Ulba_ContentType[keyof typeof Ulba_ContentType];
/**
 * Input for creating a ULBA job
 * Used in: Ulba_CreateUlbaJob mutation
 */
export type Ulba_CreateUlbaJobInput = {
  /** Destination information */
  destination: Ulba_DestinationInput;
  /**
   * Ingestion strategy to determine parsing and loading flow.
   * If not specified, defaults to CLASSIC for backward compatibility.
   * - CLASSIC: Uses traditional parsing and loading via startLoading()
   * - SMART_INGESTION: Uses node-based parsing with immediate Course Builder handoff
   */
  ingestionStrategy?: Ulba_IngestionStrategy;
  /** Source information */
  source: Ulba_SourceInput;
};

/**
 * Describes where/the use case where the course materials are being processed for.
 * Used in: Ulba_CreateUlbaJobInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_DestinationInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID (optional) */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson ID (optional) */
  lessonId?: InputMaybe<Scalars['ID']>;
  /** Module ID (optional) */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Type of destination */
  typeName: Ulba_UlbaDestinationType;
};

/**
 * Input for exporting course structure
 * Used in: Ulba_ExportCourseStructure mutation
 */
export type Ulba_ExportCourseStructureInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/**
 * Input for getting all latest ULBA jobs
 * Used in: getAllLatestUlbaJobs query
 */
export type Ulba_GetAllLatestUlbaJobsInput = {
  /** Branch ID */
  branchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/**
 * Input for getting ULBA job loading progress
 * Used in: getUlbaJobLoadingProgress query
 */
export type Ulba_GetUlbaJobLoadingProgressInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Input for getting ULBA job status
 * Used in: getUlbaJobStatus query
 */
export type Ulba_GetUlbaJobStatusInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID (optional) */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson ID (optional) */
  lessonId?: InputMaybe<Scalars['ID']>;
  /** Module ID (optional) */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/**
 * Ingestion strategy for ULBA job processing
 * Used in: Ulba_CreateUlbaJobInput
 */
export const Ulba_IngestionStrategy = {
  /** Classic ingestion flow using traditional loading via startLoading() */
  Classic: 'CLASSIC',
  /** Smart Ingestion flow with node-based parsing and immediate Course Builder handoff */
  SmartIngestion: 'SMART_INGESTION'
} as const;

export type Ulba_IngestionStrategy = typeof Ulba_IngestionStrategy[keyof typeof Ulba_IngestionStrategy];
/**
 * Identifies the type of item (e.g., assignment, quiz, video, etc.)
 * Used in: Ulba_UlbaSummary
 */
export const Ulba_ItemType = {
  /** Discussion prompt item */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Graded discussion prompt item */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** LTI item */
  LtiItem: 'LTI_ITEM',
  /** Peer review item */
  PeerReview: 'PEER_REVIEW',
  /** Programming assignment item */
  Programming: 'PROGRAMMING',
  /** Quiz item */
  Quiz: 'QUIZ',
  /** Reading item */
  Reading: 'READING',
  /** Staff graded assignment item */
  StaffGradedAssignment: 'STAFF_GRADED_ASSIGNMENT',
  /** Teammate review item */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab item */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded plugin item */
  UngradedPlugin: 'UNGRADED_PLUGIN',
  /** Unresolved item type */
  Unresolved: 'UNRESOLVED',
  /** Unset item type */
  Unset: 'UNSET',
  /** Video item */
  Video: 'VIDEO'
} as const;

export type Ulba_ItemType = typeof Ulba_ItemType[keyof typeof Ulba_ItemType];
/**
 * S3 object input
 * Used in: Ulba_SourceInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_S3ObjectInput = {
  /** S3 bucket name */
  bucket: Scalars['String'];
  /** S3 object key */
  key: Scalars['String'];
};

/**
 * Describes where the ULBA file is coming from. The content to upload is defined in one of 3 ways:
 * 1. the S3 object location (sourceDefinition),
 * 2. the assembly info (transloaditFiles and transloaditData) or
 * 3. the text itself (textContent).
 *
 * Used in: Ulba_CreateUlbaJobInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_SourceInput = {
  /** Source filename */
  filename: Scalars['String'];
  /** S3 object location (optional) */
  sourceDefinition?: InputMaybe<Ulba_S3ObjectInput>;
  /** Text content (optional) */
  textContent?: InputMaybe<Scalars['String']>;
  /** Transloadit data (optional) */
  transloaditData?: InputMaybe<Scalars['String']>;
  /** Transloadit file information (optional) */
  transloaditFiles?: InputMaybe<Array<Ulba_TransloaditFileInfoInput>>;
  /** Type of source */
  typeName: Ulba_UlbaSourceType;
};

/**
 * Sub-type classification for items (types of child content within items)
 * Used in: Ulba_UlbaSummary
 */
export const Ulba_SubItemType = {
  /** AI-graded question */
  AiGradedQuestion: 'AI_GRADED_QUESTION',
  /** Auto graded question */
  AutoGradedQuestion: 'AUTO_GRADED_QUESTION',
  /** Manual graded question */
  ManualGradedQuestion: 'MANUAL_GRADED_QUESTION',
  /** Question block */
  QuestionBlock: 'QUESTION_BLOCK'
} as const;

export type Ulba_SubItemType = typeof Ulba_SubItemType[keyof typeof Ulba_SubItemType];
/**
 * Transloadit file information input; see https://transloadit.com/docs/api/metadata/ for more details
 * Used in: Ulba_SourceInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_TransloaditFileInfoInput = {
  /** The extension of the file. */
  fileExt: Scalars['String'];
  /** An abstract type describing the file, which can currently be "image", "video", "audio", or null. */
  fileType: Scalars['String'];
  /** The name of the file. Transloadit will change the extension used for this field if the file undergoes processing into a different format. */
  filename: Scalars['String'];
  /** The determined MIME type for this file. */
  mime: Scalars['String'];
  /** File size in bytes (Float is used to prevent an overflow with the 32-bit Int for files > 2GB) */
  size: Scalars['Float'];
  /** SSL file URL */
  sslUrl: Scalars['URL'];
  /** The URL at which this file can be accessed. This is either a URL in your S3 bucket, or a temporary URL on our servers. Since temporary URLs expire after a few hours, you should make sure to move your files elsewhere unless you are using a storage robot. */
  url: Scalars['URL'];
};

/**
 * Represents what kind of place a content structure representation is headed to.
 * Used in: Ulba_Destination, Ulba_DestinationInput
 */
export const Ulba_UlbaDestinationType = {
  /** Import into empty course, also a stand-in for the deprecated ULBA_DESTINATION_TYPE_COURSERA_CONTENT */
  Empty: 'EMPTY',
  /** Export operation */
  Export: 'EXPORT',
  /** Import into populated course */
  Populated: 'POPULATED'
} as const;

export type Ulba_UlbaDestinationType = typeof Ulba_UlbaDestinationType[keyof typeof Ulba_UlbaDestinationType];
/**
 * Type of report that can be dismissed
 * Used in: Ulba_UpdateUlbaJobDismissReportInput mutation
 */
export const Ulba_UlbaReportType = {
  /** Load report */
  Load: 'LOAD',
  /** Parse report */
  Parse: 'PARSE'
} as const;

export type Ulba_UlbaReportType = typeof Ulba_UlbaReportType[keyof typeof Ulba_UlbaReportType];
/**
 * Represents what kind of place a content structure representation is being loaded from.
 * Used in: Ulba_Source, Ulba_SourceInput
 */
export const Ulba_UlbaSourceType = {
  /** IMS Common Cartridge file */
  ImsccFile: 'IMSCC_FILE',
  /** Peer review DOCX template */
  PeerReviewDocxFile: 'PEER_REVIEW_DOCX_FILE',
  /** SCORM package file */
  ScormFile: 'SCORM_FILE',
  /** Staff graded assignment DOCX template */
  SgaDocxFile: 'SGA_DOCX_FILE',
  /** Staff graded assignment QTI file */
  SgaQtiFile: 'SGA_QTI_FILE',
  /** Staff graded assignment text input */
  SgaTextInput: 'SGA_TEXT_INPUT',
  /** Staff graded assignment YAML file */
  SgaYamlFile: 'SGA_YAML_FILE',
  /** Tar gzip compressed file, usually this means an edX course */
  TarGzipFile: 'TAR_GZIP_FILE',
  /** Excel spreadsheet file */
  XlsxFile: 'XLSX_FILE'
} as const;

export type Ulba_UlbaSourceType = typeof Ulba_UlbaSourceType[keyof typeof Ulba_UlbaSourceType];
/**
 * Represents the status of each import step, i.e. parse and load.
 * Used in: Ulba_UlbaParseResult, Ulba_UlbaLoadResult, Ulba_UlbaSummary
 */
export const Ulba_UlbaStatus = {
  /** Operation failed */
  Failure: 'FAILURE',
  /** Operation is currently in progress */
  InProgress: 'IN_PROGRESS',
  /** Operation completed with some failures */
  PartialSuccess: 'PARTIAL_SUCCESS',
  /** Operation is pending */
  Pending: 'PENDING',
  /** Operation completed successfully */
  Success: 'SUCCESS'
} as const;

export type Ulba_UlbaStatus = typeof Ulba_UlbaStatus[keyof typeof Ulba_UlbaStatus];
/**
 * Input for dismissing a ULBA job report
 * Used in: Ulba_UpdateUlbaJobDismissReport mutation
 */
export type Ulba_UpdateUlbaJobDismissReportInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
  /** Type of report to dismiss */
  reportType: Ulba_UlbaReportType;
};

/**
 * Input for starting ULBA job loading
 * Used in: Ulba_UpdateUlbaJobStartLoading mutation
 */
export type Ulba_UpdateUlbaJobStartLoadingInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Input for Smart Ingestion initiation from the ULBA job
 * Used in: Ulba_UpdateUlbaJobStartSmartIngestionSync mutation
 */
export type Ulba_UpdateUlbaJobStartSmartIngestionSyncInput = {
  /** ID of the course into which content will be ingested */
  courseId: Scalars['ID'];
  /** ID of the ULBA job to transfer to Course Builder via Smart Ingestion */
  jobId: Scalars['ID'];
};

/** The enum upgrade CTA for the freemium experience */
export const UnifiedHome_CourseCardUpgradeCta = {
  /** No course upgrade CTA */
  NoCta: 'NO_CTA',
  /** CTA for upgrading the course */
  Upgrade: 'UPGRADE'
} as const;

export type UnifiedHome_CourseCardUpgradeCta = typeof UnifiedHome_CourseCardUpgradeCta[keyof typeof UnifiedHome_CourseCardUpgradeCta];
/** Primary CTA type, determines button displayed in enrolled product card */
export const UnifiedHome_CoursePrimaryButtonCta = {
  /** go to course */
  GoToCourse: 'GO_TO_COURSE',
  /** no button displayed */
  NoButton: 'NO_BUTTON',
  /** CTA for Purchase Certificate for course completed after audit (not applicable to Enterprise) */
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  /** start course */
  StartCourse: 'START_COURSE',
  /** jumio ID verification */
  VerifyId: 'VERIFY_ID',
  /** view certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type UnifiedHome_CoursePrimaryButtonCta = typeof UnifiedHome_CoursePrimaryButtonCta[keyof typeof UnifiedHome_CoursePrimaryButtonCta];
/** An enum for the learner's learning progress state towards a course */
export const UnifiedHome_CourseProgressStateEnum = {
  /** Completed */
  Completed: 'COMPLETED',
  /** Not Started */
  NotStarted: 'NOT_STARTED',
  /** Started */
  Started: 'STARTED'
} as const;

export type UnifiedHome_CourseProgressStateEnum = typeof UnifiedHome_CourseProgressStateEnum[keyof typeof UnifiedHome_CourseProgressStateEnum];
/** User Progress state in a Learning Pathway or Verified Skill Pathway */
export const UnifiedHome_LearningPathwayUserState = {
  /** enrolled in LP */
  Enrolled: 'ENROLLED',
  /** badge issued (completed) */
  Issued: 'ISSUED',
  /** never enrolled */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** unenrolled */
  Unenrolled: 'UNENROLLED'
} as const;

export type UnifiedHome_LearningPathwayUserState = typeof UnifiedHome_LearningPathwayUserState[keyof typeof UnifiedHome_LearningPathwayUserState];
/** Input for query queryClips */
export type UnifiedHome_QueryClipsInput = {
  /**
   * optionally provide the category of clips, if null, return a general list of clips (aka "All"
   * category)
   */
  category?: InputMaybe<Scalars['String']>;
};

/** An enum representing the tabs of the Unified Logged In Home Page */
export const UnifiedHome_Tab = {
  /** The Completed tab */
  Completed: 'COMPLETED',
  /** Continue Learning (originally called HOME tab in Consumer LIHP) */
  ContinueLearning: 'CONTINUE_LEARNING',
  /** The In-Progress tab */
  InProgress: 'IN_PROGRESS'
} as const;

export type UnifiedHome_Tab = typeof UnifiedHome_Tab[keyof typeof UnifiedHome_Tab];
/**
 * Item status that is to show up in the UpcomingItem model. It could be on track, overdue or
 * failed.
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 */
export const UpcomingItems_ItemStatus = {
  /** Failed */
  Failed: 'FAILED',
  /** Invalid Status */
  Invalid: 'INVALID',
  /** Item on track */
  OnTrack: 'ON_TRACK',
  /** Item overdue */
  Overdue: 'OVERDUE'
} as const;

export type UpcomingItems_ItemStatus = typeof UpcomingItems_ItemStatus[keyof typeof UpcomingItems_ItemStatus];
/**
 * Item type
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 * Deprecate some item types based on https://docs.google.com/document/d/1xj9ffO56LgpH-QXUzLFWjUi966r7M_rteIW0e_d97GQ/edit#heading=h.hgy0mtjf8o5u
 */
export const UpcomingItems_ItemType = {
  /** Assessment open single page */
  AssesOpenSinglePage: 'ASSES_OPEN_SINGLE_PAGE',
  /** Closed peer */
  ClosedPeer: 'CLOSED_PEER',
  /** Discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Exam */
  Exam: 'EXAM',
  /** Graded discussion prompt */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** Graded LTI */
  GradedLti: 'GRADED_LTI',
  /** Graded peer */
  GradedPeer: 'GRADED_PEER',
  /** Graded programming */
  GradedProgramming: 'GRADED_PROGRAMMING',
  /** Graded widget */
  GradedWidget: 'GRADED_WIDGET',
  /** Invalid Type */
  Invalid: 'INVALID',
  /** Lecture */
  Lecture: 'LECTURE',
  /** Notebook */
  Notebook: 'NOTEBOOK',
  /** Peer */
  Peer: 'PEER',
  /** Phased peer */
  PhasedPeer: 'PHASED_PEER',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming */
  Programming: 'PROGRAMMING',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Single question submit */
  SingleQuestionSubmit: 'SINGLE_QUESTION_SUBMIT',
  /** Slideshow */
  Slideshow: 'SLIDESHOW',
  /** Staff graded */
  StaffGraded: 'STAFF_GRADED',
  /** Supplement */
  Supplement: 'SUPPLEMENT',
  /** Teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded LTI */
  UngradedLti: 'UNGRADED_LTI',
  /** Ungraded programming */
  UngradedProgramming: 'UNGRADED_PROGRAMMING',
  /** Ungraded widget */
  UngradedWidget: 'UNGRADED_WIDGET',
  /** Wise flow */
  WiseFlow: 'WISE_FLOW',
  /** Workspace launcher */
  WorkspaceLauncher: 'WORKSPACE_LAUNCHER'
} as const;

export type UpcomingItems_ItemType = typeof UpcomingItems_ItemType[keyof typeof UpcomingItems_ItemType];
/** Input parameters for Query byUserAndCourse */
export type UpcomingItems_QueryByUserAndCourseInput = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** User Id */
  userId: Scalars['ID'];
};

/** Update course offering request */
export type UpdateCourseOfferingRequest = {
  /** The course offering updates. */
  courseOffering: CourseOfferingInput;
  /** The course offering ID for the update. */
  courseOfferingId: Scalars['ID'];
};

/** Upsell Direction. */
export const UpsellQueries_DifficultyLevel = {
  /** Advanced Level. */
  Advanced: 'ADVANCED',
  /** Beginner Level. */
  Beginner: 'BEGINNER',
  /** Intermediate Level. */
  Intermediate: 'INTERMEDIATE',
  /** Undefined Level. */
  Undefined: 'UNDEFINED'
} as const;

export type UpsellQueries_DifficultyLevel = typeof UpsellQueries_DifficultyLevel[keyof typeof UpsellQueries_DifficultyLevel];
/** Product Type. */
export const UpsellQueries_ProductType = {
  /** Course. */
  Course: 'COURSE',
  /** Degree. */
  Degree: 'DEGREE',
  /** Mastertrack. */
  Mastertrack: 'MASTERTRACK',
  /** Specialization. */
  Specialization: 'SPECIALIZATION'
} as const;

export type UpsellQueries_ProductType = typeof UpsellQueries_ProductType[keyof typeof UpsellQueries_ProductType];
/** Upsell Direction. */
export const UpsellQueries_UpsellDirection = {
  /** Source, Upsell From. */
  Source: 'SOURCE',
  /** Target, Upsell To. */
  Target: 'TARGET'
} as const;

export type UpsellQueries_UpsellDirection = typeof UpsellQueries_UpsellDirection[keyof typeof UpsellQueries_UpsellDirection];
/** Input for the DeleteSecondaryUnverifiedEmailsForUser mutation */
export type UserEmails_DeleteUserEmailInput = {
  /** Email */
  email: Scalars['String'];
};

/** Input for selecting the consumer experience. */
export type UserExperienceContext_ConsumerSelectionInput = {
  /** Placeholder field required by @oneOf directive. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Input for selecting the degree experience. */
export type UserExperienceContext_DegreeSelectionInput = {
  /** The ID of the degree program for the degree experience. */
  degreeProgramId: Scalars['ID'];
};

/** Input for selecting the enterprise experience. */
export type UserExperienceContext_EnterpriseSelectionInput = {
  /** The ID of the organization for the enterprise experience. */
  organizationId: Scalars['ID'];
};

/** Input for updating user experience context. */
export type UserExperienceContext_UpdateUserExperienceContextInput = {
  /** The new experience context selection. */
  selection: UserExperienceContext_UserExperienceSelectionInput;
};

/** The user's experience context selection. Exactly one field must be provided. */
export type UserExperienceContext_UserExperienceSelectionInput = {
  /** Consumer experience selection. */
  consumer?: InputMaybe<UserExperienceContext_ConsumerSelectionInput>;
  /** Degree experience selection. */
  degree?: InputMaybe<UserExperienceContext_DegreeSelectionInput>;
  /** Enterprise experience selection. */
  enterprise?: InputMaybe<UserExperienceContext_EnterpriseSelectionInput>;
};

/** The fields required to hide a learner's portfolio project */
export type UserPortfolioProject_HideInput = {
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** The fields requires to publish a learner's portfolio project */
export type UserPortfolioProject_PublishInput = {
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** The fields requires to save user portfolio projects */
export type UserPortfolioProject_SaveInput = {
  /**
   * The user-generated description of the steps the user took to complete the project
   * The behavior if this is Null is that it will delete an existing value.
   */
  approach?: InputMaybe<CmlContentInput>;
  /**
   * A list of the artifacts for the project entered by learner.
   * The behavior if this is Null is that it will delete existing artifacts..
   */
  artifacts?: InputMaybe<Array<PortfolioProject_ArtifactInput>>;
  /**
   * The user-generated summary of their findings.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'approach' instead
   */
  findingsSummary?: InputMaybe<CmlContentInput>;
  /**
   * A URL that links to a location where the learner's work may be viewed.
   * The behavior if this is Null is that it will delete an existing value.
   */
  linkToWork?: InputMaybe<Scalars['URL']>;
  /**
   * The user-generated summary of the problem and the methods they used to solve it.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'solution' instead
   */
  problemSummary?: InputMaybe<CmlContentInput>;
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /**
   * The user-generated summary of the project.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'summary' instead
   */
  projectSummary?: InputMaybe<CmlContentInput>;
  /**
   * The user-generated explanation of how the solution achieved the project objectives
   * The behavior if this is Null is that it will delete an existing value.
   */
  solution?: InputMaybe<CmlContentInput>;
  /**
   * The user-generated summary of the project.
   * The behavior if this is Null is that it will delete an existing value.
   */
  summary?: InputMaybe<Scalars['String']>;
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** Admin selected partner user preference input */
export type UserPreference_AdminSelectedPartnerUserPreferenceInput = {
  /** partner id that the admin has selected */
  partnerId: Scalars['Int'];
};

/** Track when the user has skipped the honors modal for a course. */
export type UserPreference_CourseHonorsModalDisabledAtInput = {
  /** The course id of the honors model */
  courseId: Scalars['ID'];
  /** The time when the honors modal was disabled */
  disabledAt: Scalars['DateTime'];
};

/** Generic user preference input */
export type UserPreference_GenericUserPreferenceInput = {
  /** List of user activities */
  userActivities?: InputMaybe<Array<UserPreference_UserActivityInput>>;
};

/** Honors user preference input */
export type UserPreference_HonorsUserPreferenceInput = {
  /** List of the honors modals disabled time */
  honorsModalDisabledAt?: InputMaybe<Array<UserPreference_CourseHonorsModalDisabledAtInput>>;
};

/**
 * Answers to the Onboarding question "When do you want to start learning?" that users may self
 * select.
 */
export const UserPreference_LearningStartTimeRange = {
  /** Not sure when to start learning */
  NotSure: 'NOT_SURE',
  /** Start learning in one to two weeks */
  OneToTwoWeeks: 'ONE_TO_TWO_WEEKS',
  /** Start learning in six months */
  SixMonths: 'SIX_MONTHS',
  /** Start learning in three months */
  ThreeMonths: 'THREE_MONTHS',
  /** Start learning in three to four weeks */
  ThreeToFourWeeks: 'THREE_TO_FOUR_WEEKS',
  /** Start learning today */
  Today: 'TODAY'
} as const;

export type UserPreference_LearningStartTimeRange = typeof UserPreference_LearningStartTimeRange[keyof typeof UserPreference_LearningStartTimeRange];
/** Different possible paths the user can take in the Onboarding flow. */
export const UserPreference_OnboardingPath = {
  /** Not choosing a onboarding path */
  NotChosen: 'NOT_CHOSEN',
  /** Onboarding path for personal interest */
  PersonalInterest: 'PERSONAL_INTEREST',
  /** Onboarding path to reskill */
  Reskiller: 'RESKILLER',
  /** Onboarding path to upskill */
  Upskiller: 'UPSKILLER'
} as const;

export type UserPreference_OnboardingPath = typeof UserPreference_OnboardingPath[keyof typeof UserPreference_OnboardingPath];
/** Onboarding user preference input */
export type UserPreference_OnboardingUserPreferenceInput = {
  /** If the user has viewed survey or not */
  hasViewedSurvey?: InputMaybe<Scalars['Boolean']>;
  /** Onboarding flow */
  onboardingFlow?: InputMaybe<UserPreference_OnboardingPath>;
  /** Preferred domains */
  preferredDomains?: InputMaybe<Array<Scalars['String']>>;
  /** Preferred domains with type */
  preferredDomainsWithType?: InputMaybe<Array<UserPreference_PreferredDomainInput>>;
  /** Time to start learning */
  timeToStartLearning?: InputMaybe<UserPreference_TimeToStartLearningInput>;
};

/** Payment user preference input */
export type UserPreference_PaymentUserPreferenceInput = {
  /** If the user enables one click pay or not */
  enableOneClickPay?: InputMaybe<Scalars['Boolean']>;
  /** If the user wants to save credit card or not */
  saveCreditCard?: InputMaybe<Scalars['Boolean']>;
};

/** User preference types */
export const UserPreference_PreferenceType = {
  /** Admin selected partner preference */
  AdminSelectedPartner: 'ADMIN_SELECTED_PARTNER',
  /** Generic preference */
  Generic: 'GENERIC',
  /** Honors preference */
  Honors: 'HONORS',
  /** Onboarding preference */
  Onboarding: 'ONBOARDING',
  /** Payment preference */
  Payment: 'PAYMENT',
  /** Promotion landing page preference */
  PromotionLandingPage: 'PROMOTION_LANDING_PAGE',
  /** S12n upgrade preference */
  S12NUpgrade: 'S12N_UPGRADE'
} as const;

export type UserPreference_PreferenceType = typeof UserPreference_PreferenceType[keyof typeof UserPreference_PreferenceType];
/** Preferred domain input */
export type UserPreference_PreferredDomainInput = {
  /** Domain id of the preferred domain */
  domainId: Scalars['ID'];
  /** Type of the preferred domain */
  preferredDomainType?: InputMaybe<UserPreference_PreferredDomainType>;
};

/** Used to specify if a user's preferred domain is for their Career or Personal interest. */
export const UserPreference_PreferredDomainType = {
  /** Career interest for the preferred domain */
  Career: 'CAREER',
  /** Personal interest for the preferred domain */
  Personal: 'PERSONAL'
} as const;

export type UserPreference_PreferredDomainType = typeof UserPreference_PreferredDomainType[keyof typeof UserPreference_PreferredDomainType];
/** Promotion landing page user preference input */
export type UserPreference_PromotionLandingPageUserPreferenceInput = {
  /** List of promo codes */
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** S12n upgrade preference input for a s12n */
export type UserPreference_S12nUpgradeUserPreferenceEntryInput = {
  /** s12n upgrade dismissed time */
  dismissedTime?: InputMaybe<Scalars['DateTime']>;
  /** ID of the s12n */
  s12nId: Scalars['ID'];
  /** s12n upgrade stayed time */
  stayedTime?: InputMaybe<Scalars['DateTime']>;
  /** s12n upgrade time */
  upgradeTime?: InputMaybe<Scalars['DateTime']>;
};

/** S12n upgrade user preference input */
export type UserPreference_S12nUpgradeUserPreferenceInput = {
  /** List of s12n upgrade preferences */
  upgradePreferences?: InputMaybe<Array<UserPreference_S12nUpgradeUserPreferenceEntryInput>>;
};

/** Input to set user preference for different preference types */
export type UserPreference_SetUserPreferenceInput = {
  /** Admin selected parner user preference input */
  adminSelectedPartner?: InputMaybe<UserPreference_AdminSelectedPartnerUserPreferenceInput>;
  /** Generic user preference input */
  generic?: InputMaybe<UserPreference_GenericUserPreferenceInput>;
  /** Honors user preference input */
  honors?: InputMaybe<UserPreference_HonorsUserPreferenceInput>;
  /** Onboarding user preference input */
  onboarding?: InputMaybe<UserPreference_OnboardingUserPreferenceInput>;
  /** Payment user preference input */
  payment?: InputMaybe<UserPreference_PaymentUserPreferenceInput>;
  /** Promotion landing page user preference input */
  promotionLandingPage?: InputMaybe<UserPreference_PromotionLandingPageUserPreferenceInput>;
  /** S12n upgrade user preference input */
  s12nUpgrade?: InputMaybe<UserPreference_S12nUpgradeUserPreferenceInput>;
};

/** Time to start learning input */
export type UserPreference_TimeToStartLearningInput = {
  /** Time that last seen learning start time */
  lastSeenTimestamp: Scalars['DateTime'];
  /** Learning start time */
  learningStartTime: UserPreference_LearningStartTimeRange;
};

/** User activity input */
export type UserPreference_UserActivityInput = {
  /** User activity ID */
  activityId: Scalars['ID'];
  /** User activity timestamp */
  timestamp: Scalars['DateTime'];
};

export const UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState = {
  NeedsToAttestName: 'NEEDS_TO_ATTEST_NAME',
  NeedsToVerifyId: 'NEEDS_TO_VERIFY_ID',
  RequirementMet: 'REQUIREMENT_MET'
} as const;

export type UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState = typeof UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState[keyof typeof UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState];
/** Status of ID verification for a course. */
export const UserVerification_CourseIdVerificationStatus = {
  /** ID verification is disabled for this course. */
  Disabled: 'DISABLED',
  /** ID verification is enabled for this course. */
  Enabled: 'ENABLED'
} as const;

export type UserVerification_CourseIdVerificationStatus = typeof UserVerification_CourseIdVerificationStatus[keyof typeof UserVerification_CourseIdVerificationStatus];
/** Input for deleting an ID verification override for a course. */
export type UserVerification_DeleteIdVerificationCourseOverrideInput = {
  /** ID of the course that the override should be applied to. */
  courseId: Scalars['ID'];
};

/** Specifies whether an override is for enabling or disabling ID verification. */
export const UserVerification_IdVerificationOverrideType = {
  /** ID verification should be disabled. */
  Disable: 'DISABLE',
  /** ID verification should be enabled. */
  Enable: 'ENABLE'
} as const;

export type UserVerification_IdVerificationOverrideType = typeof UserVerification_IdVerificationOverrideType[keyof typeof UserVerification_IdVerificationOverrideType];
/** Input for setting an ID verification override for a course. */
export type UserVerification_SetIdVerificationCourseOverrideInput = {
  /** ID of the course that the override should be applied to. */
  courseId: Scalars['ID'];
  /** Note to provide context about the override. */
  note: Scalars['String'];
  /** Specifies an ID verification override action that should be applied to the course. */
  overrideType: UserVerification_IdVerificationOverrideType;
};

/** Input for the export user data release mutation */
export type User_ExportUserDataReleaseInput = {
  /** User ID for the data release request */
  userId: Scalars['Int'];
};

/** User's status in a course based on score and verification */
export const VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = {
  NotPassable: 'NOT_PASSABLE',
  NotPassed: 'NOT_PASSED',
  Passed: 'PASSED',
  VerifiedPassed: 'VERIFIED_PASSED'
} as const;

export type VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord[keyof typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord];
/** Distinction achieved by a learner getting a grade for a course */
export const VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** Determines what career band grouping a verified skills pathway is */
export const VerifiedSkills_CareerBand = {
  /** Early career CareerBand */
  EarlyCareerProfessional: 'EARLY_CAREER_PROFESSIONAL',
  /** Executive Careerband */
  ExecutiveProfessional: 'EXECUTIVE_PROFESSIONAL',
  /** Managerial CareerBnad */
  ManagerialProfessional: 'MANAGERIAL_PROFESSIONAL',
  /** Skilled Professional CareerBand */
  SkilledProfessional: 'SKILLED_PROFESSIONAL'
} as const;

export type VerifiedSkills_CareerBand = typeof VerifiedSkills_CareerBand[keyof typeof VerifiedSkills_CareerBand];
/** Input type for the VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappings mutation. */
export type VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsInput = {
  /** The assessment id, e.g. an assignment id */
  assessmentId: Scalars['ID'];
  /** The new skill expression mappings to assessment part for the assessment. */
  assessmentPartToSkillExpressionMappings: Array<VerifiedSkills_SkillExpressionAndAssessmentPartInput>;
  /** The assessment type, e.g. "assignment", "lab" */
  assessmentType: Scalars['String'];
};

/** Skill expression to assessment part mapping Input */
export type VerifiedSkills_SkillExpressionAndAssessmentPartInput = {
  /** The assessment part id, e.g. a question id or a rubric id. */
  assessmentPartId: Scalars['ID'];
  /** The assessment part type, e.g. "question", "rubric" */
  assessmentPartType: Scalars['String'];
  /** The skill expression Id. */
  skillExpressionId: Scalars['ID'];
  /** The weight of this assessment part of the skill expression. The overall weight of all parts of a skill expression should sum to 1.0. */
  weight?: InputMaybe<Scalars['Float']>;
};

/** supported assignment type for viva exam */
export const VivaExam_AssignmentType = {
  /** the assignment type current for staff graded assignments and new quizzes */
  Assignment: 'ASSIGNMENT',
  /** peer review assignments */
  PeerReview: 'PEER_REVIEW'
} as const;

export type VivaExam_AssignmentType = typeof VivaExam_AssignmentType[keyof typeof VivaExam_AssignmentType];
/** Enum representing viva exam configuration status */
export const VivaExam_ConfigurationStatus = {
  /** The viva exam is disabled */
  Disabled: 'DISABLED',
  /** The viva exam is enabled */
  Enabled: 'ENABLED',
  /** The viva exam is enabled with learner feedback turned on */
  EnabledWithFeedback: 'ENABLED_WITH_FEEDBACK'
} as const;

export type VivaExam_ConfigurationStatus = typeof VivaExam_ConfigurationStatus[keyof typeof VivaExam_ConfigurationStatus];
/** input to save user feedback to a viva exam session */
export type VivaExam_SaveUserFeedbackInput = {
  /** viva exam session Id */
  examSessionId: Scalars['ID'];
  /** Enum representing user's feedback choice for the viva exam session */
  feedbackChoice: VivaExam_UserFeedbackChoice;
  /** optional feedback comment for the viva exam session */
  feedbackComment?: InputMaybe<Scalars['String']>;
};

/** input parameters used to start a viva exam session */
export type VivaExam_StartExamInput = {
  /** assignment id */
  assignmentId: Scalars['ID'];
  /** supported assignment type */
  assignmentType: VivaExam_AssignmentType;
  /** course id */
  courseId: Scalars['ID'];
};

/** input to submit an answer to a viva exam question */
export type VivaExam_SubmitQuestionAnswerInput = {
  /** viva exam session Id */
  examSessionId: Scalars['ID'];
  /** learner response to be submitted to viva exam question */
  response: Scalars['String'];
};

/** Enum representing user feedback of a viva exam session */
export const VivaExam_UserFeedbackChoice = {
  /** The viva exam session is disliked by the user */
  Dislike: 'DISLIKE',
  /** The viva exam session is liked by the user */
  Like: 'LIKE'
} as const;

export type VivaExam_UserFeedbackChoice = typeof VivaExam_UserFeedbackChoice[keyof typeof VivaExam_UserFeedbackChoice];
/** Enum representing the flagging status of the exam */
export const VivaExam_VivaExamFlagStatus = {
  /** Viva exam session is incomplete */
  Incomplete: 'INCOMPLETE',
  /** Integrity issue was found via the viva exam */
  IntegrityIssueFound: 'INTEGRITY_ISSUE_FOUND',
  /** No integrity issue was found via the viva exam */
  NoIntegrityIssue: 'NO_INTEGRITY_ISSUE'
} as const;

export type VivaExam_VivaExamFlagStatus = typeof VivaExam_VivaExamFlagStatus[keyof typeof VivaExam_VivaExamFlagStatus];
/**
 * Enumeration of possible actions for the WesCheckout process. This indicates whether the user
 * should log in to an existing account or create a new account and proceed to checkout.
 */
export const WesCheckout_Action = {
  /** The action to create a new account and proceed to checkout. */
  CreateAccountAndCheckout: 'CREATE_ACCOUNT_AND_CHECKOUT',
  /** The action to log in to an existing account. */
  LogInToExistingAccount: 'LOG_IN_TO_EXISTING_ACCOUNT'
} as const;

export type WesCheckout_Action = typeof WesCheckout_Action[keyof typeof WesCheckout_Action];
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus = {
  Failed: 'FAILED',
  Fault: 'FAULT',
  InProgress: 'IN_PROGRESS',
  Stopped: 'STOPPED',
  Succeeded: 'SUCCEEDED',
  TimedOut: 'TIMED_OUT'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus];
/** Indicates the type of the image shared between workspace and grid platform. */
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType = {
  NbGrader: 'NB_GRADER',
  VscodeCustomGrader: 'VSCODE_CUSTOM_GRADER',
  VscodePreconfiguredJava: 'VSCODE_PRECONFIGURED_JAVA'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType];
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus = {
  Published: 'PUBLISHED',
  Unpublished: 'UNPUBLISHED',
  UnpublishedChanges: 'UNPUBLISHED_CHANGES'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus];
/** Indicates the type of the base image. */
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType = {
  AwsCloud: 'AWS_CLOUD',
  Custom: 'CUSTOM',
  GenAiSandbox: 'GEN_AI_SANDBOX',
  JupyterNotebook: 'JUPYTER_NOTEBOOK',
  Linux: 'LINUX',
  Rstudio: 'RSTUDIO',
  VirtualBrowser: 'VIRTUAL_BROWSER',
  Vscode: 'VSCODE'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType];
/** Container log type. If set to AWS then container logs are sent to AWS cloudwatch. STD_OUT should be used as a default. */
export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType = {
  Aws: 'AWS',
  StdOut: 'STD_OUT'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType];
export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = {
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  CourseBranchId: 'COURSE_BRANCH_ID',
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  CourseId: 'COURSE_ID',
  CourseName: 'COURSE_NAME',
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  CourseSlug: 'COURSE_SLUG',
  Evg1Code: 'EVG1_CODE',
  GcloudKey: 'GCLOUD_KEY',
  GenAiModels: 'GEN_AI_MODELS',
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  InstructorName: 'INSTRUCTOR_NAME',
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  ItemDeadline: 'ITEM_DEADLINE',
  ItemDeadlines: 'ITEM_DEADLINES',
  ItemId: 'ITEM_ID',
  OpenaiApiKey: 'OPENAI_API_KEY',
  PartnerId: 'PARTNER_ID',
  SessionStartTime: 'SESSION_START_TIME',
  SubmissionToken: 'SUBMISSION_TOKEN',
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro];
export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType = {
  PublisherChoice: 'PUBLISHER_CHOICE',
  RoOnly: 'RO_ONLY'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType];
/** Container log type. If set to AWS then container logs are sent to AWS cloudwatch. STD_OUT should be used as a default. */
export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType = {
  Aws: 'AWS',
  StdOut: 'STD_OUT'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType];
export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = {
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  CourseBranchId: 'COURSE_BRANCH_ID',
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  CourseId: 'COURSE_ID',
  CourseName: 'COURSE_NAME',
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  CourseSlug: 'COURSE_SLUG',
  Evg1Code: 'EVG1_CODE',
  GcloudKey: 'GCLOUD_KEY',
  GenAiModels: 'GEN_AI_MODELS',
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  InstructorName: 'INSTRUCTOR_NAME',
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  ItemDeadline: 'ITEM_DEADLINE',
  ItemDeadlines: 'ITEM_DEADLINES',
  ItemId: 'ITEM_ID',
  OpenaiApiKey: 'OPENAI_API_KEY',
  PartnerId: 'PARTNER_ID',
  SessionStartTime: 'SESSION_START_TIME',
  SubmissionToken: 'SUBMISSION_TOKEN',
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro];
export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType = {
  PublisherChoice: 'PUBLISHER_CHOICE',
  RoOnly: 'RO_ONLY'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType];
/** The type of content the xAPI statement describes. */
export const XapiIntegration_AuditContentScope = {
  /** Course-level content. */
  Course: 'COURSE',
  /** Item-level content. */
  Item: 'ITEM',
  /** Content scope could not be determined. */
  Unknown: 'UNKNOWN',
  /** Video-level content. */
  Video: 'VIDEO'
} as const;

export type XapiIntegration_AuditContentScope = typeof XapiIntegration_AuditContentScope[keyof typeof XapiIntegration_AuditContentScope];
/** The reason a non-DELIVERED outcome occurred. */
export const XapiIntegration_AuditFailureReason = {
  /** Authentication with the external platform failed. */
  AuthenticationFailed: 'AUTHENTICATION_FAILED',
  /** The request was rejected by the external platform (4xx). */
  BadRequest: 'BAD_REQUEST',
  /** Integration credentials were missing. */
  CredentialsMissing: 'CREDENTIALS_MISSING',
  /** Delivery to the external platform failed (non-4xx error). */
  DeliveryFailed: 'DELIVERY_FAILED',
  /** No failure — statement was delivered successfully. */
  None: 'NONE',
  /** The organization has been rate limited. */
  RateLimited: 'RATE_LIMITED',
  /** The external platform was unavailable. */
  ServiceDown: 'SERVICE_DOWN',
  /** An unexpected error occurred. */
  Unhandled: 'UNHANDLED'
} as const;

export type XapiIntegration_AuditFailureReason = typeof XapiIntegration_AuditFailureReason[keyof typeof XapiIntegration_AuditFailureReason];
/** Outcome of an xAPI statement delivery attempt. */
export const XapiIntegration_AuditOutcomeType = {
  /** Statement delivery was deferred for retry. */
  Deferred: 'DEFERRED',
  /** Statement was successfully delivered to the external platform. */
  Delivered: 'DELIVERED',
  /** Statement delivery failed permanently. */
  Failed: 'FAILED',
  /** Statement was skipped (e.g. rate limited). */
  Skipped: 'SKIPPED'
} as const;

export type XapiIntegration_AuditOutcomeType = typeof XapiIntegration_AuditOutcomeType[keyof typeof XapiIntegration_AuditOutcomeType];
/** The source that triggered the xAPI statement delivery. */
export const XapiIntegration_AuditSourceType = {
  /** Statement originated from a dead-letter queue redrive. */
  DlqRedrive: 'DLQ_REDRIVE',
  /** Statement originated from a historical sync job. */
  HistoricalSync: 'HISTORICAL_SYNC',
  /** Statement originated from the real-time event queue. */
  RealTime: 'REAL_TIME'
} as const;

export type XapiIntegration_AuditSourceType = typeof XapiIntegration_AuditSourceType[keyof typeof XapiIntegration_AuditSourceType];
/**
 * Filters for getAuditStats. organizationId is required.
 * Providing userId alone queries the GSI by user; providing both userId and courseId
 * narrows the GSI range key to that user+course combination.
 * courseId without userId is not supported.
 */
export type XapiIntegration_AuditStatsInput = {
  /** Coursera course id. Only meaningful when userId is also supplied. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Inclusive start of the stats window (ISO-8601). Defaults to 30 days before toCreatedAt. */
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The organization id to query. Required. */
  organizationId: Scalars['ID'];
  /** Inclusive end of the stats window (ISO-8601). Defaults to the current time. */
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Coursera user id. When provided, the GSI_ByUser index is used. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Input to create an xAPI integration. */
export type XapiIntegration_CreateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** String to specify external learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to create a xAPI integration. */
  organizationId: Scalars['ID'];
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Input to delete a xAPI integration. */
export type XapiIntegration_DeleteXapiIntegrationInput = {
  /** Id of an organization for which to delete xAPI integration. */
  organizationId: Scalars['ID'];
};

/** External learning platform using this integration. */
export const XapiIntegration_ExternalLearningPlatform = {
  /** Degreed. */
  ExternalLearningPlatformDegreed: 'EXTERNAL_LEARNING_PLATFORM_DEGREED',
  /** Docebo. */
  ExternalLearningPlatformDocebo: 'EXTERNAL_LEARNING_PLATFORM_DOCEBO',
  /** EdCast. */
  ExternalLearningPlatformEdcast: 'EXTERNAL_LEARNING_PLATFORM_EDCAST',
  /** Execute Apps. A middleware for other bespoke LMS/LXPs we integrate with. */
  ExternalLearningPlatformExecuteApps: 'EXTERNAL_LEARNING_PLATFORM_EXECUTE_APPS',
  /** Invalid external learning platform. */
  ExternalLearningPlatformInvalid: 'EXTERNAL_LEARNING_PLATFORM_INVALID',
  /** Percipio. */
  ExternalLearningPlatformPercipio: 'EXTERNAL_LEARNING_PLATFORM_PERCIPIO',
  /** Standard. */
  ExternalLearningPlatformStandard: 'EXTERNAL_LEARNING_PLATFORM_STANDARD',
  /** Walmart. */
  ExternalLearningPlatformWalmart: 'EXTERNAL_LEARNING_PLATFORM_WALMART',
  /** Workday Cloud Connect for Learning. */
  ExternalLearningPlatformWorkday: 'EXTERNAL_LEARNING_PLATFORM_WORKDAY'
} as const;

export type XapiIntegration_ExternalLearningPlatform = typeof XapiIntegration_ExternalLearningPlatform[keyof typeof XapiIntegration_ExternalLearningPlatform];
/**
 * Filters for getAuditRecordsFilter. organizationId is required.
 * Providing userId alone queries the GSI by user; providing both userId and courseId
 * narrows the GSI range key to that user+course combination.
 * courseId without userId is not supported.
 */
export type XapiIntegration_ListXapiStatementAuditInput = {
  /** Coursera course id. Only meaningful when userId is also supplied. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Inclusive start of the audit window (ISO-8601). Defaults to 30 days before toCreatedAt. */
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The organization id to query. Required. */
  organizationId: Scalars['ID'];
  /** Inclusive end of the audit window (ISO-8601). Defaults to the current time. */
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Coursera user id. When provided, the GSI_ByUser index is used. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Input to permanently remove a xAPI integration record. */
export type XapiIntegration_RemoveXapiIntegrationInput = {
  /** Id of an organization for which to permanently remove the xAPI integration record. */
  organizationId: Scalars['ID'];
  /** External learning platform for which to permanently remove the xAPI integration record. */
  platformType: XapiIntegration_ExternalLearningPlatform;
};

/** Input for triggering the xAPI Tracking Enrollment Sync job for a single organization. */
export type XapiIntegration_TriggerEnrollmentSyncJobInput = {
  /** When true, include deleted users in the sync. Defaults to false. */
  includeDeletedUsers?: InputMaybe<Scalars['Boolean']>;
  /** When true, run the sync without making external mutations. */
  isDryRun: Scalars['Boolean'];
  /** Organization id to process. */
  organizationId: Scalars['ID'];
  /**
   * Override end of the event time range. Must be supplied together with overrideEventStartTime,
   * or both omitted to fall back to the job's default range.
   */
  overrideEventEndTime?: InputMaybe<Scalars['DateTime']>;
  /**
   * Override start of the event time range. Must be supplied together with overrideEventEndTime,
   * or both omitted to fall back to the job's default range.
   */
  overrideEventStartTime?: InputMaybe<Scalars['DateTime']>;
};

/** Input to update an xAPI integration. */
export type XapiIntegration_UpdateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** External learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to update a xAPI integration. */
  organizationId: Scalars['ID'];
  /**
   * String to specify tenant (user/customer) alias/name.
   * @deprecated No need for tenant alias.
   */
  tenantAlias?: InputMaybe<Scalars['String']>;
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Input to validate an xAPI integration. */
export type XapiIntegration_ValidateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** Value to specify external learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to validate a xAPI integration. */
  organizationId: Scalars['ID'];
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Different status of validate xAPI Integration */
export const XapiIntegration_ValidationStatus = {
  /** Client Credentials are incorrect, validation failed */
  ValidationFailed: 'VALIDATION_FAILED',
  /** Client Credentials successfully validated */
  ValidationPassed: 'VALIDATION_PASSED'
} as const;

export type XapiIntegration_ValidationStatus = typeof XapiIntegration_ValidationStatus[keyof typeof XapiIntegration_ValidationStatus];
/** Enumeration type representing which method to use to identify xAPI actors */
export const XapiIntegration_XapiActorIdentificationType = {
  /** Method of composing xAPI actor using an enterprise user's configured external id. */
  XapiActorIdentificationTypeAccount: 'XAPI_ACTOR_IDENTIFICATION_TYPE_ACCOUNT',
  /** Invalid value. */
  XapiActorIdentificationTypeInvalid: 'XAPI_ACTOR_IDENTIFICATION_TYPE_INVALID',
  /** Method of composing xAPI actor using email address in a mailto: format. */
  XapiActorIdentificationTypeMbox: 'XAPI_ACTOR_IDENTIFICATION_TYPE_MBOX'
} as const;

export type XapiIntegration_XapiActorIdentificationType = typeof XapiIntegration_XapiActorIdentificationType[keyof typeof XapiIntegration_XapiActorIdentificationType];
/** Input to get a xAPI integration. */
export type XapiIntegration_GetXapiIntegration = {
  /** The id of an organization for which to get a xAPI integration. */
  organizationId: Scalars['ID'];
};

/** Current status of xAPI integration. */
export const XapiIntegration_XapiIntegrationStatus = {
  /** Disabled integration status. */
  XapiIntegrationStatusDisabled: 'XAPI_INTEGRATION_STATUS_DISABLED',
  /** Enabled integration status. */
  XapiIntegrationStatusEnabled: 'XAPI_INTEGRATION_STATUS_ENABLED',
  /** Invalid integration status. */
  XapiIntegrationStatusInvalid: 'XAPI_INTEGRATION_STATUS_INVALID'
} as const;

export type XapiIntegration_XapiIntegrationStatus = typeof XapiIntegration_XapiIntegrationStatus[keyof typeof XapiIntegration_XapiIntegrationStatus];
/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const XdpV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type XdpV1_Org_Coursera_Catalogp_Browse_ProductType = typeof XdpV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof XdpV1_Org_Coursera_Catalogp_Browse_ProductType];
/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
export const XdpV1_Org_Coursera_Course_CertificateType = {
  Ace: 'ACE',
  SoA: 'SoA',
  Specialization: 'Specialization',
  VerifiedCert: 'VerifiedCert'
} as const;

export type XdpV1_Org_Coursera_Course_CertificateType = typeof XdpV1_Org_Coursera_Course_CertificateType[keyof typeof XdpV1_Org_Coursera_Course_CertificateType];
export const XdpV1_Org_Coursera_Course_CourseMode = {
  Ondemand: 'ONDEMAND',
  Session: 'SESSION'
} as const;

export type XdpV1_Org_Coursera_Course_CourseMode = typeof XdpV1_Org_Coursera_Course_CourseMode[keyof typeof XdpV1_Org_Coursera_Course_CourseMode];
export const XdpV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type XdpV1_Org_Coursera_Course_CourseStatus = typeof XdpV1_Org_Coursera_Course_CourseStatus[keyof typeof XdpV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const XdpV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type XdpV1_Org_Coursera_Course_PremiumExperienceVariant = typeof XdpV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof XdpV1_Org_Coursera_Course_PremiumExperienceVariant];
/** Type of launch this degree was intended to launch as e.g. TEST or REAL. */
export const XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType = typeof XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType];
export const XdpV1_Org_Coursera_Degree_Stored_SlackPlanType = {
  Free: 'FREE',
  Plus: 'PLUS',
  Standard: 'STANDARD'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_SlackPlanType = typeof XdpV1_Org_Coursera_Degree_Stored_SlackPlanType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_SlackPlanType];
/** Type of upsell */
export const XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType = {
  OffersCredit: 'OFFERS_CREDIT',
  PartOf: 'PART_OF',
  RelatedTo: 'RELATED_TO',
  SuppressUpsell: 'SUPPRESS_UPSELL'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType = typeof XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType];
export const XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
/** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus = {
  Active: 'ACTIVE',
  NonActive: 'NON_ACTIVE',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus];
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType = {
  ExternalPartnerVoucher: 'EXTERNAL_PARTNER_VOUCHER'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType];
/** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType = {
  Adobe: 'ADOBE',
  Facebook: 'FACEBOOK',
  InternalPromotion: 'INTERNAL_PROMOTION',
  Stored: 'STORED'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType];
export const XdpV1_Org_Coursera_S12n_S12nInternalType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_S12n_S12nInternalType = typeof XdpV1_Org_Coursera_S12n_S12nInternalType[keyof typeof XdpV1_Org_Coursera_S12n_S12nInternalType];
export const XdpV1_Org_Coursera_Xdp_Common_XdpfaqType = {
  ClosedCourseAccess: 'ClosedCourseAccess',
  ClosedCourseEnroll: 'ClosedCourseEnroll',
  ClosedCourseNoAudit: 'ClosedCourseNoAudit',
  ClosedCoursePreview: 'ClosedCoursePreview',
  ClosedCourseReceiveCertificate: 'ClosedCourseReceiveCertificate',
  CourseAccess: 'CourseAccess',
  CourseFinancialAid: 'CourseFinancialAid',
  CourseFullyOnline: 'CourseFullyOnline',
  CourseUniversityCreditPromo: 'CourseUniversityCreditPromo',
  CourseValueProp: 'CourseValueProp',
  GenericRefund: 'GenericRefund',
  PaygCertificateRefund: 'PAYGCertificateRefund',
  ProfessionalCertCourseValueProp: 'ProfessionalCertCourseValueProp',
  ProfessionalCertEnrollInSingleCourse: 'ProfessionalCertEnrollInSingleCourse',
  S12nCourseValueProp: 'S12nCourseValueProp',
  S12nEnrollInSingleCourse: 'S12nEnrollInSingleCourse',
  S12nFinancialAid: 'S12nFinancialAid',
  S12nSubscriptionCourseCost: 'S12nSubscriptionCourseCost',
  S12nUniversityCredit: 'S12nUniversityCredit',
  S12nUniversityCreditPromo: 'S12nUniversityCreditPromo',
  StandAloneCourseRefund: 'StandAloneCourseRefund',
  SubscriptionTrialRefund: 'SubscriptionTrialRefund'
} as const;

export type XdpV1_Org_Coursera_Xdp_Common_XdpfaqType = typeof XdpV1_Org_Coursera_Xdp_Common_XdpfaqType[keyof typeof XdpV1_Org_Coursera_Xdp_Common_XdpfaqType];
export const Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Org_Coursera_Assignment_AssignmentFeature = typeof Org_Coursera_Assignment_AssignmentFeature[keyof typeof Org_Coursera_Assignment_AssignmentFeature];
export const Org_Coursera_Authentication_Thirdpartyauth_OrganizationType = {
  Business: 'BUSINESS',
  Campus: 'CAMPUS',
  Government: 'GOVERNMENT'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_OrganizationType = typeof Org_Coursera_Authentication_Thirdpartyauth_OrganizationType[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_OrganizationType];
export const Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule = {
  AcceptedPrivacyNotice: 'ACCEPTED_PRIVACY_NOTICE',
  Everyone: 'EVERYONE'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule = typeof Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule];
export const Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod = {
  Jwt: 'JWT',
  JwtInvite: 'JWT_INVITE',
  Lti: 'LTI',
  Saml: 'SAML'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod = typeof Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod];
/** SAML signing algorithm. Used for generating the SAML Request in SP-initiated logins. */
export const Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm = {
  Sha1Rsa: 'SHA1_RSA',
  Sha256Rsa: 'SHA256_RSA'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm = typeof Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm];
export const Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PaidItem: 'PAID_ITEM',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof Org_Coursera_Ondemand_Coursematerial_PeriodType];
export const Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState = {
  GradingStarted: 'GradingStarted',
  InProgress: 'InProgress'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState = {
  Failed: 'Failed',
  NotStarted: 'NotStarted',
  Started: 'Started',
  UnverifiedPassed: 'UnverifiedPassed',
  VerifiedPassed: 'VerifiedPassed'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState = {
  NotSubmitted: 'NotSubmitted',
  SubmittedNotReviewedOthers: 'SubmittedNotReviewedOthers',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState = {
  ReviewingOthers: 'ReviewingOthers',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState];
export const Org_Coursera_Payment_Transaction_PaymentTransactionActionType = {
  Chargeback: 'CHARGEBACK',
  PartialRefund: 'PARTIAL_REFUND',
  Payment: 'PAYMENT',
  Query: 'QUERY',
  Refund: 'REFUND',
  Void: 'VOID'
} as const;

export type Org_Coursera_Payment_Transaction_PaymentTransactionActionType = typeof Org_Coursera_Payment_Transaction_PaymentTransactionActionType[keyof typeof Org_Coursera_Payment_Transaction_PaymentTransactionActionType];
/** Different configurations for SkillSets available to a learning program. Currently it is just ALL skillsets, no skillsets, or selected skillsets, but in the future, there may be configurations for all academies. */
export const Org_Coursera_Program_SkillSetAvailabilityType = {
  AllSkillsets: 'ALL_SKILLSETS',
  LinkedSkillsetsOnly: 'LINKED_SKILLSETS_ONLY'
} as const;

export type Org_Coursera_Program_SkillSetAvailabilityType = typeof Org_Coursera_Program_SkillSetAvailabilityType[keyof typeof Org_Coursera_Program_SkillSetAvailabilityType];
export const Org_Coursera_Program_Enrollment_ProgramUserProductAction = {
  Enroll: 'ENROLL',
  Manage: 'MANAGE',
  Preview: 'PREVIEW',
  Resume: 'RESUME',
  Select: 'SELECT',
  Unenroll: 'UNENROLL',
  Unselect: 'UNSELECT',
  Upgrade: 'UPGRADE',
  View: 'VIEW'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductAction = typeof Org_Coursera_Program_Enrollment_ProgramUserProductAction[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductAction];
/** Represents the enrollment state of a user for a specific content item (course or specialization) within a program. AVAILABLE - The content is in the user's program curriculum but the user is not   currently enrolled. This is the default state and also the state after unenrollment. ENROLLED - The user is actively enrolled in the content. COMPLETED - The user has completed the content. A completed enrollment cannot be unenrolled. UNAVAILABLE - The content is not currently available to the user. Possible reasons include:   the course has no open sessions, the course is not yet launched or pre-enrollable,   the organization has no remaining credits/licenses, or the content is not part of   the user's program. */
export const Org_Coursera_Program_Enrollment_ProgramUserProductState = {
  Available: 'AVAILABLE',
  Completed: 'COMPLETED',
  Enrolled: 'ENROLLED',
  Unavailable: 'UNAVAILABLE'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductState = typeof Org_Coursera_Program_Enrollment_ProgramUserProductState[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductState];
export const Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = {
  UnavailableCourseNotLaunchedNorPreEnrollable: 'UNAVAILABLE_COURSE_NOT_LAUNCHED_NOR_PRE_ENROLLABLE',
  UnavailableCourseNoOpenSessions: 'UNAVAILABLE_COURSE_NO_OPEN_SESSIONS',
  UnavailableNotInProgram: 'UNAVAILABLE_NOT_IN_PROGRAM',
  UnavailableNotPermitted: 'UNAVAILABLE_NOT_PERMITTED',
  UnavailableNoCreditsRemaining: 'UNAVAILABLE_NO_CREDITS_REMAINING'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = typeof Org_Coursera_Program_Enrollment_ProgramUserProductStateReason[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductStateReason];